(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRegister("aSiaI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6ObR8"));

});
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
'use strict';

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRegister("exYeM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $86bee5c140ae1e47$export$3ba232387fd5d6dd; }, function (v) { return $86bee5c140ae1e47$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$3ba232387fd5d6dd;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
'use strict';
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
function $86bee5c140ae1e47$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$3ba232387fd5d6dd = $86bee5c140ae1e47$var$X;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = $86bee5c140ae1e47$var$X;
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
'use strict';

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$Lg(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$Lg(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$Sg(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Tg(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Ug = $c79bde28d689cb05$var$Og(!0), $c79bde28d689cb05$var$Vg = $c79bde28d689cb05$var$Og(!1), $c79bde28d689cb05$var$Wg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Xg = null, $c79bde28d689cb05$var$Yg = null, $c79bde28d689cb05$var$Zg = null;
function $c79bde28d689cb05$var$$g() {
    $c79bde28d689cb05$var$Zg = $c79bde28d689cb05$var$Yg = $c79bde28d689cb05$var$Xg = null;
}
function $c79bde28d689cb05$var$ah(a) {
    var b = $c79bde28d689cb05$var$Wg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$ch(a, b) {
    $c79bde28d689cb05$var$Xg = a;
    $c79bde28d689cb05$var$Zg = $c79bde28d689cb05$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$dh = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$eh(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Yg) {
            if (null === $c79bde28d689cb05$var$Xg) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Yg = a;
            $c79bde28d689cb05$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Yg = $c79bde28d689cb05$var$Yg.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$fh = null;
function $c79bde28d689cb05$var$gh(a) {
    null === $c79bde28d689cb05$var$fh ? $c79bde28d689cb05$var$fh = [
        a
    ] : $c79bde28d689cb05$var$fh.push(a);
}
function $c79bde28d689cb05$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$ih(a, d);
}
function $c79bde28d689cb05$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$jh = !1;
function $c79bde28d689cb05$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$ih(a, c);
}
function $c79bde28d689cb05$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$th = {}, $c79bde28d689cb05$var$uh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th), $c79bde28d689cb05$var$vh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th), $c79bde28d689cb05$var$wh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$th);
function $c79bde28d689cb05$var$xh(a) {
    if (a === $c79bde28d689cb05$var$th) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$yh(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$wh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$vh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, $c79bde28d689cb05$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, b);
}
function $c79bde28d689cb05$var$zh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$vh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$wh);
}
function $c79bde28d689cb05$var$Ah(a) {
    $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
    var b = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$vh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$uh, c));
}
function $c79bde28d689cb05$var$Bh(a) {
    $c79bde28d689cb05$var$vh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$uh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$vh));
}
var $c79bde28d689cb05$var$L = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Dh = [];
function $c79bde28d689cb05$var$Eh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Dh.length; a++)$c79bde28d689cb05$var$Dh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Dh.length = 0;
}
var $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Hh = 0, $c79bde28d689cb05$var$M = null, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$Ih = !1, $c79bde28d689cb05$var$Jh = !1, $c79bde28d689cb05$var$Kh = 0, $c79bde28d689cb05$var$Lh = 0;
function $c79bde28d689cb05$var$P() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Nh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Hh = f;
    $c79bde28d689cb05$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Fh.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Oh : $c79bde28d689cb05$var$Ph;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Jh) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Jh = !1;
            $c79bde28d689cb05$var$Kh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Qh;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Jh);
    }
    $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Rh;
    b = null !== $c79bde28d689cb05$var$N && null !== $c79bde28d689cb05$var$N.next;
    $c79bde28d689cb05$var$Hh = 0;
    $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = $c79bde28d689cb05$var$M = null;
    $c79bde28d689cb05$var$Ih = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$Sh() {
    var a = 0 !== $c79bde28d689cb05$var$Kh;
    $c79bde28d689cb05$var$Kh = 0;
    return a;
}
function $c79bde28d689cb05$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState = $c79bde28d689cb05$var$O = a : $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$O.next = a;
    return $c79bde28d689cb05$var$O;
}
function $c79bde28d689cb05$var$Uh() {
    if (null === $c79bde28d689cb05$var$N) {
        var a = $c79bde28d689cb05$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$N.next;
    var b = null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState : $c79bde28d689cb05$var$O.next;
    if (null !== b) $c79bde28d689cb05$var$O = b, $c79bde28d689cb05$var$N = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$N = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$N.memoizedState,
            baseState: $c79bde28d689cb05$var$N.baseState,
            baseQueue: $c79bde28d689cb05$var$N.baseQueue,
            queue: $c79bde28d689cb05$var$N.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$O ? $c79bde28d689cb05$var$M.memoizedState = $c79bde28d689cb05$var$O = a : $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$O.next = a;
    }
    return $c79bde28d689cb05$var$O;
}
function $c79bde28d689cb05$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$Wh(a) {
    var b = $c79bde28d689cb05$var$Uh(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$M.lanes |= m;
                $c79bde28d689cb05$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$M.lanes |= f, $c79bde28d689cb05$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$Xh(a) {
    var b = $c79bde28d689cb05$var$Uh(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$Yh() {}
function $c79bde28d689cb05$var$Zh(a, b) {
    var c = $c79bde28d689cb05$var$M, d = $c79bde28d689cb05$var$Uh(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$dh = !0);
    d = d.queue;
    $c79bde28d689cb05$var$$h($c79bde28d689cb05$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$O && $c79bde28d689cb05$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$bi(9, $c79bde28d689cb05$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$Q) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Hh & 30) || $c79bde28d689cb05$var$di(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$ei(b) && $c79bde28d689cb05$var$fi(a);
}
function $c79bde28d689cb05$var$ai(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$ei(b) && $c79bde28d689cb05$var$fi(a);
    });
}
function $c79bde28d689cb05$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$ih(a, 1);
    null !== b && $c79bde28d689cb05$var$gi(b, a, 1, -1);
}
function $c79bde28d689cb05$var$hi(a) {
    var b = $c79bde28d689cb05$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ii.bind(null, $c79bde28d689cb05$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$ji() {
    return $c79bde28d689cb05$var$Uh().memoizedState;
}
function $c79bde28d689cb05$var$ki(a, b, c, d) {
    var e = $c79bde28d689cb05$var$Th();
    $c79bde28d689cb05$var$M.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    var e = $c79bde28d689cb05$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$N) {
        var g = $c79bde28d689cb05$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Mh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$bi(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$M.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$bi(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$mi(a, b) {
    return $c79bde28d689cb05$var$ki(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$$h(a, b) {
    return $c79bde28d689cb05$var$li(2048, 8, a, b);
}
function $c79bde28d689cb05$var$ni(a, b) {
    return $c79bde28d689cb05$var$li(4, 2, a, b);
}
function $c79bde28d689cb05$var$oi(a, b) {
    return $c79bde28d689cb05$var$li(4, 4, a, b);
}
function $c79bde28d689cb05$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$li(4, 4, $c79bde28d689cb05$var$pi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$ri() {}
function $c79bde28d689cb05$var$si(a, b) {
    var c = $c79bde28d689cb05$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$ti(a, b) {
    var c = $c79bde28d689cb05$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$ui(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Hh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$dh = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$M.lanes |= c, $c79bde28d689cb05$var$rh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$vi(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Gh.transition;
    $c79bde28d689cb05$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Gh.transition = d;
    }
}
function $c79bde28d689cb05$var$wi() {
    return $c79bde28d689cb05$var$Uh().memoizedState;
}
function $c79bde28d689cb05$var$xi(a, b, c) {
    var d = $c79bde28d689cb05$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$zi(a)) $c79bde28d689cb05$var$Ai(b, c);
    else if (c = $c79bde28d689cb05$var$hh(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$R();
        $c79bde28d689cb05$var$gi(c, a, d, e);
        $c79bde28d689cb05$var$Bi(c, b, d);
    }
}
function $c79bde28d689cb05$var$ii(a, b, c) {
    var d = $c79bde28d689cb05$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$zi(a)) $c79bde28d689cb05$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$hh(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$R(), $c79bde28d689cb05$var$gi(c, a, d, e), $c79bde28d689cb05$var$Bi(c, b, d));
    }
}
function $c79bde28d689cb05$var$zi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$M || null !== b && b === $c79bde28d689cb05$var$M;
}
function $c79bde28d689cb05$var$Ai(a, b) {
    $c79bde28d689cb05$var$Jh = $c79bde28d689cb05$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$Rh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$P,
    useContext: $c79bde28d689cb05$var$P,
    useEffect: $c79bde28d689cb05$var$P,
    useImperativeHandle: $c79bde28d689cb05$var$P,
    useInsertionEffect: $c79bde28d689cb05$var$P,
    useLayoutEffect: $c79bde28d689cb05$var$P,
    useMemo: $c79bde28d689cb05$var$P,
    useReducer: $c79bde28d689cb05$var$P,
    useRef: $c79bde28d689cb05$var$P,
    useState: $c79bde28d689cb05$var$P,
    useDebugValue: $c79bde28d689cb05$var$P,
    useDeferredValue: $c79bde28d689cb05$var$P,
    useTransition: $c79bde28d689cb05$var$P,
    useMutableSource: $c79bde28d689cb05$var$P,
    useSyncExternalStore: $c79bde28d689cb05$var$P,
    useId: $c79bde28d689cb05$var$P,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Oh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ki(4194308, 4, $c79bde28d689cb05$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$xi.bind(null, $c79bde28d689cb05$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$hi,
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$hi(!1), b = a[0];
        a = $c79bde28d689cb05$var$vi.bind(null, a[1]);
        $c79bde28d689cb05$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$M, e = $c79bde28d689cb05$var$Th();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$Q) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Hh & 30) || $c79bde28d689cb05$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$mi($c79bde28d689cb05$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$bi(9, $c79bde28d689cb05$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$Th(), b = $c79bde28d689cb05$var$Q.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Ph = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$si,
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$$h,
    useImperativeHandle: $c79bde28d689cb05$var$qi,
    useInsertionEffect: $c79bde28d689cb05$var$ni,
    useLayoutEffect: $c79bde28d689cb05$var$oi,
    useMemo: $c79bde28d689cb05$var$ti,
    useReducer: $c79bde28d689cb05$var$Wh,
    useRef: $c79bde28d689cb05$var$ji,
    useState: function() {
        return $c79bde28d689cb05$var$Wh($c79bde28d689cb05$var$Vh);
    },
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$Uh();
        return $c79bde28d689cb05$var$ui(b, $c79bde28d689cb05$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$Wh($c79bde28d689cb05$var$Vh)[0], b = $c79bde28d689cb05$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$Yh,
    useSyncExternalStore: $c79bde28d689cb05$var$Zh,
    useId: $c79bde28d689cb05$var$wi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Qh = {
    readContext: $c79bde28d689cb05$var$eh,
    useCallback: $c79bde28d689cb05$var$si,
    useContext: $c79bde28d689cb05$var$eh,
    useEffect: $c79bde28d689cb05$var$$h,
    useImperativeHandle: $c79bde28d689cb05$var$qi,
    useInsertionEffect: $c79bde28d689cb05$var$ni,
    useLayoutEffect: $c79bde28d689cb05$var$oi,
    useMemo: $c79bde28d689cb05$var$ti,
    useReducer: $c79bde28d689cb05$var$Xh,
    useRef: $c79bde28d689cb05$var$ji,
    useState: function() {
        return $c79bde28d689cb05$var$Xh($c79bde28d689cb05$var$Vh);
    },
    useDebugValue: $c79bde28d689cb05$var$ri,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$Uh();
        return null === $c79bde28d689cb05$var$N ? b.memoizedState = a : $c79bde28d689cb05$var$ui(b, $c79bde28d689cb05$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$Xh($c79bde28d689cb05$var$Vh)[0], b = $c79bde28d689cb05$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$Yh,
    useSyncExternalStore: $c79bde28d689cb05$var$Zh,
    useId: $c79bde28d689cb05$var$wi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c79bde28d689cb05$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$R(), e = $c79bde28d689cb05$var$yi(a), f = $c79bde28d689cb05$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$nh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, e, d), $c79bde28d689cb05$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$R(), e = $c79bde28d689cb05$var$yi(a), f = $c79bde28d689cb05$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$nh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, e, d), $c79bde28d689cb05$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$R(), d = $c79bde28d689cb05$var$yi(a), e = $c79bde28d689cb05$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$nh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$gi(b, a, d, c), $c79bde28d689cb05$var$oh(b, a, d));
    }
};
function $c79bde28d689cb05$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$eh(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c79bde28d689cb05$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$eh(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$Ei.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Ni(a, b, c) {
    c = $c79bde28d689cb05$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Oi || ($c79bde28d689cb05$var$Oi = !0, $c79bde28d689cb05$var$Pi = d);
        $c79bde28d689cb05$var$Li(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Qi(a, b, c) {
    c = $c79bde28d689cb05$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Li(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Ri ? $c79bde28d689cb05$var$Ri = new Set([
            this
        ]) : $c79bde28d689cb05$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$mh(-1, 1), b.tag = 2, $c79bde28d689cb05$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Wi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$dh = !1;
function $c79bde28d689cb05$var$Xi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Vg(b, null, c, d) : $c79bde28d689cb05$var$Ug(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$ch(b, e);
    d = $c79bde28d689cb05$var$Nh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$Sh();
    if (null !== a && !$c79bde28d689cb05$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$Zi(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Xi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$bj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$dh = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$Zi(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$cj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj);
            $c79bde28d689cb05$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$ej, $c79bde28d689cb05$var$fj), $c79bde28d689cb05$var$fj |= d;
    $c79bde28d689cb05$var$Xi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$ch(b, e);
    c = $c79bde28d689cb05$var$Nh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$Sh();
    if (null !== a && !$c79bde28d689cb05$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$Zi(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Xi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$ch(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$ij(a, b), $c79bde28d689cb05$var$Gi(b, c, d), $c79bde28d689cb05$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$eh(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$Hi(b, g, d, l);
        $c79bde28d689cb05$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$jh ? ("function" === typeof m && ($c79bde28d689cb05$var$Di(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$jh || $c79bde28d689cb05$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$eh(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$Hi(b, g, d, k);
        $c79bde28d689cb05$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$jh ? ("function" === typeof y && ($c79bde28d689cb05$var$Di(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$jh || $c79bde28d689cb05$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$jj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$jj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$Zi(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Ug(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Ug(b, null, h, f)) : $c79bde28d689cb05$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$yh(a, b.containerInfo);
}
function $c79bde28d689cb05$var$lj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Xi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$oj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$pj(g, d, 0, null), a = $c79bde28d689cb05$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$nj(c), b.memoizedState = $c79bde28d689cb05$var$mj, a) : $c79bde28d689cb05$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$Pg(h, f) : (f = $c79bde28d689cb05$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$qj(a, b) {
    b = $c79bde28d689cb05$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$sj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Ug(b, a.child, null, c);
    a = $c79bde28d689cb05$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$nj(g);
        b.memoizedState = $c79bde28d689cb05$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Ki(f, d, void 0);
        return $c79bde28d689cb05$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$dh || h) {
        d = $c79bde28d689cb05$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$ih(a, e), $c79bde28d689cb05$var$gi(d, a, e, -1));
        }
        $c79bde28d689cb05$var$tj();
        d = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$bh(a.return, b, c);
}
function $c79bde28d689cb05$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Xi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$vj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$kj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Ah(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$oj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1);
                a = $c79bde28d689cb05$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$dj(a, b, c);
    }
    return $c79bde28d689cb05$var$Zi(a, b, c);
}
var $c79bde28d689cb05$var$zj, $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj;
$c79bde28d689cb05$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Aj = function() {};
$c79bde28d689cb05$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Dj(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$zh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Fj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Aj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Bh(b);
            var e = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$wh.current);
                $c79bde28d689cb05$var$xh($c79bde28d689cb05$var$uh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Fj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$L.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$zh(), $c79bde28d689cb05$var$Aj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$ah(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Dj(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, $c79bde28d689cb05$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Gj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$L.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$L, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$fj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Ij(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$zh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Bh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L), null;
        case 4:
            return $c79bde28d689cb05$var$zh(), null;
        case 10:
            return $c79bde28d689cb05$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Jj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Nj = !1;
function $c79bde28d689cb05$var$Oj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Nj;
    $c79bde28d689cb05$var$Nj = !1;
    return n;
}
function $c79bde28d689cb05$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Vj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Vj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Xj = !1;
function $c79bde28d689cb05$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$Zj(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$Zj(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Lj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Xj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Xj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Xj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Xj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Xj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Xj = !0;
            $c79bde28d689cb05$var$Yj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Mj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Yj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Yj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Yj(a, b, c);
    }
}
function $c79bde28d689cb05$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Kj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Xj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Xj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$Zj(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$dk(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Pj(3, a, a.return), $c79bde28d689cb05$var$Qj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Pj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Lj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            break;
        case 13:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$fk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$ck(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$ck(b, a);
            $c79bde28d689cb05$var$ek(a);
            d & 4 && $c79bde28d689cb05$var$ak(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$ck(b, a), $c79bde28d689cb05$var$ek(a);
    }
}
function $c79bde28d689cb05$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Uj(a);
                    $c79bde28d689cb05$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Uj(a);
                    $c79bde28d689cb05$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$hk(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$ik(a, b, c);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Jj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Jj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$jk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$jk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$ik(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Jj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$kk(a, b, c);
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Rj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$gk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$jk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Qj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$lk = Math.ceil, $c79bde28d689cb05$var$mk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$fj = 0, $c79bde28d689cb05$var$ej = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$pk = null, $c79bde28d689cb05$var$rh = 0, $c79bde28d689cb05$var$qk = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = null, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$fk = 0, $c79bde28d689cb05$var$Gj = Infinity, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Oi = !1, $c79bde28d689cb05$var$Pi = null, $c79bde28d689cb05$var$Ri = null, $c79bde28d689cb05$var$vk = !1, $c79bde28d689cb05$var$wk = null, $c79bde28d689cb05$var$xk = 0, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = null, $c79bde28d689cb05$var$Ak = -1, $c79bde28d689cb05$var$Bk = 0;
function $c79bde28d689cb05$var$R() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$Ak : $c79bde28d689cb05$var$Ak = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Bk && ($c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Bk;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$gi(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$yk) throw $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$Q) a === $c79bde28d689cb05$var$Q && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$qk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Ck(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Dk(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Dk(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$Q ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Ek.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Ek.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Fk(c, $c79bde28d689cb05$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Gk(a, b) {
    $c79bde28d689cb05$var$Ak = -1;
    $c79bde28d689cb05$var$Bk = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Hk() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$Q ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Ik(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Jk();
        if ($c79bde28d689cb05$var$Q !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Kk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Lk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Mk(a, h);
        }
        $c79bde28d689cb05$var$$g();
        $c79bde28d689cb05$var$mk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Nk(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, d), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Ok(e) && (b = $c79bde28d689cb05$var$Ik(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Nk(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, d), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$fk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Pk.bind(null, a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Pk.bind(null, a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Gk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    var c = $c79bde28d689cb05$var$sk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Kk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Ik(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$tk = c, null !== b && $c79bde28d689cb05$var$Fj(b));
    return a;
}
function $c79bde28d689cb05$var$Fj(a) {
    null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = a : $c79bde28d689cb05$var$tk.push.apply($c79bde28d689cb05$var$tk, a);
}
function $c79bde28d689cb05$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Ck(a, b) {
    b &= ~$c79bde28d689cb05$var$rk;
    b &= ~$c79bde28d689cb05$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Ek(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Hk();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Nk(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$pk, $c79bde28d689cb05$var$Kk(a, 0), $c79bde28d689cb05$var$Ck(a, b), $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Pk(a, $c79bde28d689cb05$var$tk, $c79bde28d689cb05$var$uk);
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Qk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Rk(a) {
    null !== $c79bde28d689cb05$var$wk && 0 === $c79bde28d689cb05$var$wk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Hk();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$ok.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$ok.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$ok.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Hj() {
    $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$ej.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$ej);
}
function $c79bde28d689cb05$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$zh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Eh();
                break;
            case 5:
                $c79bde28d689cb05$var$Bh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$zh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$L);
                break;
            case 10:
                $c79bde28d689cb05$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Hj();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$Q = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$Pg(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$fj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$pk = null;
    $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$qk = $c79bde28d689cb05$var$rh = 0;
    $c79bde28d689cb05$var$tk = $c79bde28d689cb05$var$sk = null;
    if (null !== $c79bde28d689cb05$var$fh) {
        for(b = 0; b < $c79bde28d689cb05$var$fh.length; b++)if (c = $c79bde28d689cb05$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$fh = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Mk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$$g();
            $c79bde28d689cb05$var$Fh.current = $c79bde28d689cb05$var$Rh;
            if ($c79bde28d689cb05$var$Ih) {
                for(var d = $c79bde28d689cb05$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Ih = !1;
            }
            $c79bde28d689cb05$var$Hh = 0;
            $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = $c79bde28d689cb05$var$M = null;
            $c79bde28d689cb05$var$Jh = !1;
            $c79bde28d689cb05$var$Kh = 0;
            $c79bde28d689cb05$var$nk.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$pk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Si(f, l, b);
                            $c79bde28d689cb05$var$tj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Vi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ji(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$sk ? $c79bde28d689cb05$var$sk = [
                    f
                ] : $c79bde28d689cb05$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Ni(f, k, b);
                            $c79bde28d689cb05$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Ri || !$c79bde28d689cb05$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Qi(f, h, b);
                                $c79bde28d689cb05$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Sk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Jk() {
    var a = $c79bde28d689cb05$var$mk.current;
    $c79bde28d689cb05$var$mk.current = $c79bde28d689cb05$var$Rh;
    return null === a ? $c79bde28d689cb05$var$Rh : a;
}
function $c79bde28d689cb05$var$tj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$Q || 0 === ($c79bde28d689cb05$var$rh & 268435455) && 0 === ($c79bde28d689cb05$var$qk & 268435455) || $c79bde28d689cb05$var$Ck($c79bde28d689cb05$var$Q, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Ik(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Jk();
    if ($c79bde28d689cb05$var$Q !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$Kk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Tk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Mk(a, e);
    }
    $c79bde28d689cb05$var$$g();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$mk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$Q = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Tk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Uk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Lk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Uk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Uk(a) {
    var b = $c79bde28d689cb05$var$Vk(a.alternate, a, $c79bde28d689cb05$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Sk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$nk.current = null;
}
function $c79bde28d689cb05$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Ej(c, b, $c79bde28d689cb05$var$fj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Pk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$ok.transition;
    try {
        $c79bde28d689cb05$var$ok.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Wk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$ok.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Wk(a, b, c, d) {
    do $c79bde28d689cb05$var$Hk();
    while (null !== $c79bde28d689cb05$var$wk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$Q && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$Q = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$vk || ($c79bde28d689cb05$var$vk = !0, $c79bde28d689cb05$var$Fk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$ok.transition;
        $c79bde28d689cb05$var$ok.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$nk.current = null;
        $c79bde28d689cb05$var$Oj(a, c);
        $c79bde28d689cb05$var$dk(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$hk(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$ok.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$vk && ($c79bde28d689cb05$var$vk = !1, $c79bde28d689cb05$var$wk = a, $c79bde28d689cb05$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Ri = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Oi) throw $c79bde28d689cb05$var$Oi = !1, a = $c79bde28d689cb05$var$Pi, $c79bde28d689cb05$var$Pi = null, a;
    0 !== ($c79bde28d689cb05$var$xk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$zk ? $c79bde28d689cb05$var$yk++ : ($c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = a) : $c79bde28d689cb05$var$yk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Hk() {
    if (null !== $c79bde28d689cb05$var$wk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$xk), b = $c79bde28d689cb05$var$ok.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$ok.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$wk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$wk;
                $c79bde28d689cb05$var$wk = null;
                $c79bde28d689cb05$var$xk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Sj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Qj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$ok.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Xk(a, b, c) {
    b = $c79bde28d689cb05$var$Ji(c, b);
    b = $c79bde28d689cb05$var$Ni(a, b, 1);
    a = $c79bde28d689cb05$var$nh(a, b, 1);
    b = $c79bde28d689cb05$var$R();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Dk(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Ri || !$c79bde28d689cb05$var$Ri.has(d))) {
                a = $c79bde28d689cb05$var$Ji(c, a);
                a = $c79bde28d689cb05$var$Qi(b, a, 1);
                b = $c79bde28d689cb05$var$nh(b, a, 1);
                a = $c79bde28d689cb05$var$R();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$Q === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$fk ? $c79bde28d689cb05$var$Kk(a, 0) : $c79bde28d689cb05$var$rk |= c);
    $c79bde28d689cb05$var$Dk(a, b);
}
function $c79bde28d689cb05$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$R();
    a = $c79bde28d689cb05$var$ih(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Dk(a, c));
}
function $c79bde28d689cb05$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Yk(a, c);
}
function $c79bde28d689cb05$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Yk(a, c);
}
var $c79bde28d689cb05$var$Vk;
$c79bde28d689cb05$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$dh = !1, $c79bde28d689cb05$var$yj(a, b, c);
            $c79bde28d689cb05$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$dh = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$ij(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$ch(b, c);
            e = $c79bde28d689cb05$var$Nh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$kh(b), e.updater = $c79bde28d689cb05$var$Ei, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$Ii(b, d, a, c), b = $c79bde28d689cb05$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$Zk(d);
                a = $c79bde28d689cb05$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$$i(null, b, d, $c79bde28d689cb05$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$kj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$lh(a, b);
                $c79bde28d689cb05$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ji(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ji(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$lj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$Zi(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Ah(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$gj(a, b), $c79bde28d689cb05$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$oj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Ug(b, null, d, c) : $c79bde28d689cb05$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$Yi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$ch(b, c), e = $c79bde28d689cb05$var$eh(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Ci(d, b.pendingProps), e = $c79bde28d689cb05$var$Ci(d.type, e), $c79bde28d689cb05$var$$i(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Ci(d, e), $c79bde28d689cb05$var$ij(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$ch(b, c), $c79bde28d689cb05$var$Gi(b, d, e), $c79bde28d689cb05$var$Ii(b, d, e, c), $c79bde28d689cb05$var$jj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$xj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$dj(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Fk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$$k(a, b, c, d);
}
function $c79bde28d689cb05$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$Zk(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Tg(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Tg(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$pj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$Qg(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$kh(f);
    return a;
}
function $c79bde28d689cb05$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$dl(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$el(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$dl(null);
    c = a.current;
    d = $c79bde28d689cb05$var$R();
    e = $c79bde28d689cb05$var$yi(c);
    f = $c79bde28d689cb05$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$nh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Dk(a, d);
    return a;
}
function $c79bde28d689cb05$var$fl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$R(), g = $c79bde28d689cb05$var$yi(e);
    c = $c79bde28d689cb05$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$nh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$gi(a, e, g, f), $c79bde28d689cb05$var$oh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    $c79bde28d689cb05$var$hl(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$hl(a, b);
}
function $c79bde28d689cb05$var$jl() {
    return null;
}
var $c79bde28d689cb05$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ll(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$ml.prototype.render = $c79bde28d689cb05$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$fl(a, b, null, null);
};
$c79bde28d689cb05$var$ml.prototype.unmount = $c79bde28d689cb05$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Rk(function() {
            $c79bde28d689cb05$var$fl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$pl() {}
function $c79bde28d689cb05$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$gl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$el(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$pl);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$gl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$bl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$pl);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Rk(function() {
        $c79bde28d689cb05$var$fl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$gl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$fl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$ql(c, b, a, e, d);
    return $c79bde28d689cb05$var$gl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Dk(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Gj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Rk(function() {
                var b = $c79bde28d689cb05$var$ih(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$R();
                    $c79bde28d689cb05$var$gi(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$il(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$ih(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$R();
            $c79bde28d689cb05$var$gi(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$il(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$yi(a), c = $c79bde28d689cb05$var$ih(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$R();
            $c79bde28d689cb05$var$gi(c, a, b, d);
        }
        $c79bde28d689cb05$var$il(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Qk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Rk;
var $c79bde28d689cb05$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Qk
    ]
}, $c79bde28d689cb05$var$tl = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$ul = {
    bundleType: $c79bde28d689cb05$var$tl.bundleType,
    version: $c79bde28d689cb05$var$tl.version,
    rendererPackageName: $c79bde28d689cb05$var$tl.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$tl.findFiberByHostInstance || $c79bde28d689cb05$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$vl.isDisabled && $c79bde28d689cb05$var$vl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$vl.inject($c79bde28d689cb05$var$ul), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$vl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$sl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$nl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$cl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$nl(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ll(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Rk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$rl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$nl(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$rl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Rk(function() {
        $c79bde28d689cb05$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Qk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$ol(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$rl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("ibqfJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
'use strict';
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRegister("kj6DU", function(module, exports) {

$parcel$export(module.exports, "getSemigroup", function () { return $ec8abc1e2151c9f2$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $ec8abc1e2151c9f2$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "identity", function () { return $ec8abc1e2151c9f2$export$f0954fd7d5368655; });
$parcel$export(module.exports, "unsafeCoerce", function () { return $ec8abc1e2151c9f2$export$401372c57776dc; });
$parcel$export(module.exports, "constant", function () { return $ec8abc1e2151c9f2$export$c983f826f44ff86; });
$parcel$export(module.exports, "constTrue", function () { return $ec8abc1e2151c9f2$export$a68382d9631f6c53; });
$parcel$export(module.exports, "constFalse", function () { return $ec8abc1e2151c9f2$export$7349232f2648ca80; });
$parcel$export(module.exports, "constNull", function () { return $ec8abc1e2151c9f2$export$243c2ee5e7d8b05c; });
$parcel$export(module.exports, "constUndefined", function () { return $ec8abc1e2151c9f2$export$3d16a43570087548; });
$parcel$export(module.exports, "flow", function () { return $ec8abc1e2151c9f2$export$ccc7b0636abaffc3; });
$parcel$export(module.exports, "tuple", function () { return $ec8abc1e2151c9f2$export$65e3907585753458; });
$parcel$export(module.exports, "pipe", function () { return $ec8abc1e2151c9f2$export$a4627e546088548d; });
$parcel$export(module.exports, "SK", function () { return $ec8abc1e2151c9f2$export$5f584391ee0d99b4; });
$parcel$export(module.exports, "dual", function () { return $ec8abc1e2151c9f2$export$d1699a1bbdf17835; });
var $ec8abc1e2151c9f2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ec8abc1e2151c9f2$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $ec8abc1e2151c9f2$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $ec8abc1e2151c9f2$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $ec8abc1e2151c9f2$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $ec8abc1e2151c9f2$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $ec8abc1e2151c9f2$export$575097c1c561f76f = function(R) {
    var S = $ec8abc1e2151c9f2$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $ec8abc1e2151c9f2$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $ec8abc1e2151c9f2$export$f0954fd7d5368655(a) {
    return a;
}
var $ec8abc1e2151c9f2$export$401372c57776dc = $ec8abc1e2151c9f2$export$f0954fd7d5368655;
function $ec8abc1e2151c9f2$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $ec8abc1e2151c9f2$export$a68382d9631f6c53 = /*#__PURE__*/ $ec8abc1e2151c9f2$export$c983f826f44ff86(true);
var $ec8abc1e2151c9f2$export$7349232f2648ca80 = /*#__PURE__*/ $ec8abc1e2151c9f2$export$c983f826f44ff86(false);
var $ec8abc1e2151c9f2$export$243c2ee5e7d8b05c = /*#__PURE__*/ $ec8abc1e2151c9f2$export$c983f826f44ff86(null);
var $ec8abc1e2151c9f2$export$3d16a43570087548 = /*#__PURE__*/ $ec8abc1e2151c9f2$export$c983f826f44ff86(undefined);
var $ec8abc1e2151c9f2$export$fe2a8306a887c223 = $ec8abc1e2151c9f2$export$3d16a43570087548;
function $ec8abc1e2151c9f2$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $ec8abc1e2151c9f2$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $ec8abc1e2151c9f2$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $ec8abc1e2151c9f2$export$a2647aa13413c947(n) {
    return n + 1;
}
function $ec8abc1e2151c9f2$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $ec8abc1e2151c9f2$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $ec8abc1e2151c9f2$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $ec8abc1e2151c9f2$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $ec8abc1e2151c9f2$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $ec8abc1e2151c9f2$export$5cc5fd8bb7edf254 = $ec8abc1e2151c9f2$export$f172309911142386;
var $ec8abc1e2151c9f2$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $ec8abc1e2151c9f2$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $ec8abc1e2151c9f2$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $ec8abc1e2151c9f2$export$ccc7b0636abaffc3(first, second);
        },
        empty: $ec8abc1e2151c9f2$export$f0954fd7d5368655
    };
};
var $ec8abc1e2151c9f2$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $ec8abc1e2151c9f2$var$__spreadArray([
                self
            ], args, false));
        };
    };
};

});

parcelRegister("7bKko", function(module, exports) {

$parcel$export(module.exports, "Iso", function () { return Iso; });
$parcel$export(module.exports, "Prism", function () { return Prism; });
$parcel$export(module.exports, "lens", function () { return (parcelRequire("4QCFr")); });
/**
 * @since 1.0.0
 */ 
var $4Rq1U = parcelRequire("4Rq1U");

var $iK9L9 = parcelRequire("iK9L9");

var $kj6DU = parcelRequire("kj6DU");

var $gpfu2 = parcelRequire("gpfu2");

var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");

var $k2VKN = parcelRequire("k2VKN");

var $6Q2iq = parcelRequire("6Q2iq");

var $3j2p6 = parcelRequire("3j2p6");

var $4QCFr = parcelRequire("4QCFr");

var $kyy1y = parcelRequire("kyy1y");

var $bkb82 = parcelRequire("bkb82");

var $qblkL = parcelRequire("qblkL");
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($6Q2iq.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $6Q2iq.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($6Q2iq.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($6Q2iq.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($6Q2iq.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($6Q2iq.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($6Q2iq.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $6piwk.pipe)(this, $6Q2iq.asLens, $4QCFr.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $6piwk.pipe)(this, $6Q2iq.asPrism, $bkb82.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $6piwk.pipe)(this, $6Q2iq.asOptional, $kyy1y.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $6Q2iq.asTraversal, $qblkL.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $6piwk.pipe)($4QCFr.id(), $4QCFr.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $6piwk.pipe)($4QCFr.id(), $4QCFr.props.apply($4QCFr, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $3NXK3.fromNullable)(s[k]);
                if ((0, $3NXK3.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $4QCFr.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($4QCFr.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($4QCFr.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($4QCFr.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $6piwk.pipe)(this, $4QCFr.asOptional, $kyy1y.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $4QCFr.asTraversal, $qblkL.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $6piwk.pipe)(this, $4QCFr.compose((0, $6piwk.pipe)(ab, $6Q2iq.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($4QCFr.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($bkb82.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $3NXK3.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $3NXK3.option).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($bkb82.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($bkb82.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $3NXK3.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($bkb82.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $6piwk.pipe)(this, $bkb82.asOptional, $kyy1y.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $bkb82.asTraversal, $qblkL.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $6piwk.pipe)(this, $bkb82.compose((0, $6piwk.pipe)(ab, $6Q2iq.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($bkb82.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $kj6DU.identity), (0, $3NXK3.some));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $3NXK3.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $kyy1y.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $kyy1y.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($kyy1y.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $3NXK3.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($kyy1y.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $kyy1y.asTraversal, $qblkL.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $6piwk.pipe)(this, $kyy1y.compose((0, $6piwk.pipe)(ab, $4QCFr.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $6piwk.pipe)(this, $kyy1y.compose((0, $6piwk.pipe)(ab, $bkb82.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $6piwk.pipe)(this, $kyy1y.compose((0, $6piwk.pipe)(ab, $6Q2iq.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $qblkL.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $qblkL.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($qblkL.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $iK9L9.getApplicative)(M))(function(a) {
                    return (0, $iK9L9.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($qblkL.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $qblkL.compose((0, $6piwk.pipe)(ab, $4QCFr.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $qblkL.compose((0, $6piwk.pipe)(ab, $bkb82.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $6piwk.pipe)(this, $qblkL.compose((0, $6piwk.pipe)(ab, $6Q2iq.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($k2VKN.fromIso(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($3j2p6.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($3j2p6.fromIso(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($4Rq1U.getMonoid())($4Rq1U.of);
        this.exist = foldMap((0, $gpfu2.monoidAny));
        this.all = foldMap((0, $gpfu2.monoidAll));
        this.foldMapFirst = foldMap((0, $3NXK3.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $3NXK3.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $kj6DU.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $qblkL.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});
parcelRegister("4Rq1U", function(module, exports) {

$parcel$export(module.exports, "of", function () { return $38a04da194065ad1$export$ba255e9e49e00608; });
$parcel$export(module.exports, "getMonoid", function () { return $38a04da194065ad1$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Foldable", function () { return $38a04da194065ad1$export$41404b31838667c9; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $fgwhT = parcelRequire("fgwhT");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $150AS = parcelRequire("150AS");

var $f0bNW = parcelRequire("f0bNW");

var $aRVRH = parcelRequire("aRVRH");

var $LdARg = parcelRequire("LdARg");

var $2GEXo = parcelRequire("2GEXo");
var $38a04da194065ad1$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $38a04da194065ad1$export$a978c53b4062a525 = $150AS.isNonEmpty;
var $38a04da194065ad1$export$68159836694e22c1 = $150AS.prepend;
var $38a04da194065ad1$export$c4c4d41eab625797 = $150AS.prependW;
var $38a04da194065ad1$export$10d8903dec122b9d = $150AS.append;
var $38a04da194065ad1$export$19903a1bf1942f6 = $150AS.appendW;
var $38a04da194065ad1$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $150AS.makeBy(f)(n);
};
var $38a04da194065ad1$export$606959e7ccb797f0 = function(n, a) {
    return $38a04da194065ad1$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $38a04da194065ad1$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $38a04da194065ad1$export$172ec0a6ebfeb6fa = function(ma) {
    return $lOGTm.isNone(ma) ? [] : [
        ma.value
    ];
};
var $38a04da194065ad1$export$80c878c9b1d77917 = function(e) {
    return $lOGTm.isLeft(e) ? [] : [
        e.right
    ];
};
var $38a04da194065ad1$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $38a04da194065ad1$export$4659b591c19bdf3d = $38a04da194065ad1$export$2d55ea551c238330;
var $38a04da194065ad1$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? onNonEmpty($150AS.head(as), $150AS.tail(as)) : onEmpty();
    };
};
var $38a04da194065ad1$export$6280271dfaec4919 = $38a04da194065ad1$export$ebbe93aa91e3abdc;
var $38a04da194065ad1$export$f3163a37d0ef5927 = $38a04da194065ad1$export$6280271dfaec4919;
var $38a04da194065ad1$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? onNonEmpty($150AS.init(as), $150AS.last(as)) : onEmpty();
    };
};
var $38a04da194065ad1$export$b1cacb83a5c6bd02 = $38a04da194065ad1$export$364f7f2cc8473008;
var $38a04da194065ad1$export$77fa89c00b331c4c = $38a04da194065ad1$export$b1cacb83a5c6bd02;
var $38a04da194065ad1$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $38a04da194065ad1$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $38a04da194065ad1$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $38a04da194065ad1$export$346677f925de839c = function(as) {
    return as.length;
};
var $38a04da194065ad1$export$2fde0b1c54fc39b9 = $150AS.isOutOfBound;
var $38a04da194065ad1$export$dfc7155ac0343b8 = $f0bNW.lookup;
var $38a04da194065ad1$export$5fd5031fecdacec3 = $f0bNW.head;
var $38a04da194065ad1$export$4c7897fafd92b108 = $f0bNW.last;
var $38a04da194065ad1$export$c01875f616615628 = function(as) {
    return $38a04da194065ad1$export$a978c53b4062a525(as) ? $lOGTm.some($150AS.tail(as)) : $lOGTm.none;
};
var $38a04da194065ad1$export$2cd8252107eb640b = function(as) {
    return $38a04da194065ad1$export$a978c53b4062a525(as) ? $lOGTm.some($150AS.init(as)) : $lOGTm.none;
};
var $38a04da194065ad1$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $38a04da194065ad1$export$2fde0b1c54fc39b9(n, as) ? $38a04da194065ad1$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $38a04da194065ad1$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $38a04da194065ad1$export$2fde0b1c54fc39b9(n, as) ? $38a04da194065ad1$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $38a04da194065ad1$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $38a04da194065ad1$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $38a04da194065ad1$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $38a04da194065ad1$export$b0d75975ac0be0e1($38a04da194065ad1$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $38a04da194065ad1$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $38a04da194065ad1$export$dd1bc94b04021eeb(as) ? $38a04da194065ad1$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $38a04da194065ad1$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $38a04da194065ad1$export$dd1bc94b04021eeb(as) ? $38a04da194065ad1$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $38a04da194065ad1$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($38a04da194065ad1$var$spanLeftIndex(as, predicate));
    };
}
var $38a04da194065ad1$export$de3a4d4a0d731119 = $f0bNW.findIndex;
function $38a04da194065ad1$export$9a2f228bed5035c2(predicate) {
    return $f0bNW.findFirst(predicate);
}
var $38a04da194065ad1$export$a86c11c94d794a95 = $f0bNW.findFirstMap;
function $38a04da194065ad1$export$296de88ccac4bedb(predicate) {
    return $f0bNW.findLast(predicate);
}
var $38a04da194065ad1$export$8b5e6d6ad82284fa = $f0bNW.findLastMap;
var $38a04da194065ad1$export$8855a8be7bd3e9f8 = $f0bNW.findLastIndex;
var $38a04da194065ad1$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $38a04da194065ad1$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $lOGTm.none : $lOGTm.some($38a04da194065ad1$export$f4863e1822a1860c(i, a, as));
    };
};
var $38a04da194065ad1$export$b6d8713d53419d4c = function(i, a) {
    return $38a04da194065ad1$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $38a04da194065ad1$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $38a04da194065ad1$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some($38a04da194065ad1$export$4937fde8dfc38dbd(i, as));
    };
};
var $38a04da194065ad1$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $38a04da194065ad1$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some($38a04da194065ad1$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $38a04da194065ad1$export$66c1ae025e96b4bc = function(as) {
    return $38a04da194065ad1$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $38a04da194065ad1$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $38a04da194065ad1$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $38a04da194065ad1$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $38a04da194065ad1$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $38a04da194065ad1$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $38a04da194065ad1$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $38a04da194065ad1$export$8901015135f2fb22(bs, as);
    };
    return $38a04da194065ad1$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $38a04da194065ad1$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $38a04da194065ad1$export$849c7567cbd62acc = function(middle) {
    var f = $150AS.prependAll(middle);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $38a04da194065ad1$export$af200dcf8b7cb5de = function(middle) {
    var f = $150AS.intersperse(middle);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? f(as) : $38a04da194065ad1$export$784d13d8ee351f07(as);
    };
};
var $38a04da194065ad1$export$bb628a54ab399bc9 = function(n) {
    var f = $150AS.rotate(n);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? f(as) : $38a04da194065ad1$export$784d13d8ee351f07(as);
    };
};
var $38a04da194065ad1$export$5bf96401662340b7 = $f0bNW.elem;
var $38a04da194065ad1$export$f70730c3d1fc524e = function(E) {
    var f = $150AS.uniq(E);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? f(as) : $38a04da194065ad1$export$784d13d8ee351f07(as);
    };
};
var $38a04da194065ad1$export$b035e44d7bb4278f = function(ords) {
    var f = $150AS.sortBy(ords);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? f(as) : $38a04da194065ad1$export$784d13d8ee351f07(as);
    };
};
var $38a04da194065ad1$export$433fe05b12ba833f = function(f) {
    var g = $150AS.chop(f);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $38a04da194065ad1$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $38a04da194065ad1$export$a978c53b4062a525(as) ? $150AS.splitAt(n)(as) : $38a04da194065ad1$export$dd1bc94b04021eeb(as) ? [
            $38a04da194065ad1$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $38a04da194065ad1$export$784d13d8ee351f07(as)
        ];
    };
};
var $38a04da194065ad1$export$2f0184d5df52135f = function(n) {
    var f = $150AS.chunksOf(n);
    return function(as) {
        return $38a04da194065ad1$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $38a04da194065ad1$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $38a04da194065ad1$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $38a04da194065ad1$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $38a04da194065ad1$export$a978c53b4062a525(input) ? $38a04da194065ad1$export$5b8affa63fc6df16($150AS.head(input), function(a) {
            return go((0, $kj6DU.pipe)(scope, $38a04da194065ad1$export$10d8903dec122b9d(a)), $150AS.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $38a04da194065ad1$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $38a04da194065ad1$export$dd1bc94b04021eeb(first) ? $38a04da194065ad1$export$784d13d8ee351f07(second) : $38a04da194065ad1$export$dd1bc94b04021eeb(second) ? $38a04da194065ad1$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $38a04da194065ad1$export$ee1b3e54f0441b22 = $38a04da194065ad1$export$c8c959650bbe80e2;
function $38a04da194065ad1$export$971dd5b0dfd021b6(E) {
    var unionE = $150AS.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $38a04da194065ad1$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $38a04da194065ad1$export$a978c53b4062a525(first) && $38a04da194065ad1$export$a978c53b4062a525(second) ? unionE(second)(first) : $38a04da194065ad1$export$a978c53b4062a525(first) ? $38a04da194065ad1$export$784d13d8ee351f07(first) : $38a04da194065ad1$export$784d13d8ee351f07(second);
    };
}
function $38a04da194065ad1$export$bc86dfbf7795668c(E) {
    var elemE = $38a04da194065ad1$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $38a04da194065ad1$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $38a04da194065ad1$export$acaf96a27438246b(E) {
    var elemE = $38a04da194065ad1$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $38a04da194065ad1$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $38a04da194065ad1$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_mapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$8f07ddce13659f50(f));
};
var $38a04da194065ad1$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $38a04da194065ad1$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_filter = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_filterMap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_partition = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_partitionMap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$228be17d80722ab(that));
};
var $38a04da194065ad1$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_foldMap = function(M) {
    var foldMapM = $38a04da194065ad1$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $38a04da194065ad1$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_filterMapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_extend = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_traverse = function(F) {
    var traverseF = $38a04da194065ad1$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $38a04da194065ad1$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $38a04da194065ad1$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseWithIndexF(f));
    };
};
var $38a04da194065ad1$var$_chainRecDepthFirst = $f0bNW._chainRecDepthFirst;
var $38a04da194065ad1$var$_chainRecBreadthFirst = $f0bNW._chainRecBreadthFirst;
var $38a04da194065ad1$export$ba255e9e49e00608 = $150AS.of;
var $38a04da194065ad1$export$7f9972325ebfd559 = function() {
    return [];
};
var $38a04da194065ad1$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $38a04da194065ad1$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $38a04da194065ad1$export$5b8affa63fc6df16(function(f) {
        return (0, $kj6DU.pipe)(fa, $38a04da194065ad1$export$871de8747c9eaa88(f));
    });
};
var $38a04da194065ad1$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return (0, $kj6DU.pipe)(ma, $38a04da194065ad1$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $38a04da194065ad1$export$bffa455ba8c619a6 = /*#__PURE__*/ $38a04da194065ad1$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $38a04da194065ad1$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $38a04da194065ad1$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($lOGTm.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $38a04da194065ad1$export$a04c6c6965dd4709 = function(f) {
    return $38a04da194065ad1$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $38a04da194065ad1$export$8e16b83750b44988 = /*#__PURE__*/ $38a04da194065ad1$export$a04c6c6965dd4709((0, $kj6DU.identity));
var $38a04da194065ad1$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $aRVRH.separated)(left, right);
};
var $38a04da194065ad1$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $38a04da194065ad1$export$b29f828819edca8d = function(predicate) {
    return $38a04da194065ad1$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $38a04da194065ad1$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $aRVRH.separated)(left, right);
    };
};
var $38a04da194065ad1$export$3117e3f9ececb6bc = function(f) {
    return $38a04da194065ad1$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $38a04da194065ad1$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $aRVRH.separated)(left, right);
    };
};
var $38a04da194065ad1$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $38a04da194065ad1$export$228be17d80722ab = $38a04da194065ad1$export$1517cca7889d6aaa;
var $38a04da194065ad1$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $38a04da194065ad1$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $38a04da194065ad1$export$ecd5e8ace626722c = /*#__PURE__*/ $38a04da194065ad1$export$8b58be045bf06082((0, $kj6DU.identity));
var $38a04da194065ad1$export$b66cdc0497d8a99a = $f0bNW.foldMap;
var $38a04da194065ad1$export$18153bb1181268e5 = $f0bNW.foldMapWithIndex;
var $38a04da194065ad1$export$533b26079ad0b4b = $f0bNW.reduce;
var $38a04da194065ad1$export$bbd3ef8720e22369 = $f0bNW.reduceWithIndex;
var $38a04da194065ad1$export$7fef8bcdbb34f435 = $f0bNW.reduceRight;
var $38a04da194065ad1$export$ce2b2fe0b88ccd0a = $f0bNW.reduceRightWithIndex;
var $38a04da194065ad1$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $38a04da194065ad1$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $38a04da194065ad1$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $38a04da194065ad1$var$_reduce(ta, F.of($38a04da194065ad1$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $kj6DU.pipe)(as, $38a04da194065ad1$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $38a04da194065ad1$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $38a04da194065ad1$export$bbd3ef8720e22369(F.of($38a04da194065ad1$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $kj6DU.pipe)(bs, $38a04da194065ad1$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $38a04da194065ad1$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $38a04da194065ad1$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $38a04da194065ad1$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $38a04da194065ad1$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $38a04da194065ad1$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($lOGTm.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $38a04da194065ad1$export$9156e739aa33e19f = 'Array';
var $38a04da194065ad1$export$3cb5cd7f7776c81 = $f0bNW.getShow;
var $38a04da194065ad1$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $38a04da194065ad1$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $38a04da194065ad1$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $38a04da194065ad1$export$804fed467fde44e4 = $f0bNW.getEq;
var $38a04da194065ad1$export$1af51209b1b91d07 = $f0bNW.getOrd;
var $38a04da194065ad1$export$baca17b4aff42f82 = function(E) {
    var unionE = $38a04da194065ad1$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $38a04da194065ad1$export$c487aac9f4157837 = function(E) {
    return {
        concat: $38a04da194065ad1$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $38a04da194065ad1$export$d379a869a72e4055 = function(E) {
    var intersectionE = $38a04da194065ad1$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $38a04da194065ad1$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $38a04da194065ad1$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $38a04da194065ad1$export$bd5b6bfc5fa2ee61 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map
};
var $38a04da194065ad1$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($38a04da194065ad1$export$bd5b6bfc5fa2ee61);
var $38a04da194065ad1$export$59a71046037e6c20 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    of: $38a04da194065ad1$export$ba255e9e49e00608
};
var $38a04da194065ad1$export$9fdffe0fe1e91cad = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    mapWithIndex: $38a04da194065ad1$var$_mapWithIndex
};
var $38a04da194065ad1$export$efc21ddc6aeb363d = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap
};
var $38a04da194065ad1$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($38a04da194065ad1$export$efc21ddc6aeb363d);
var $38a04da194065ad1$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($38a04da194065ad1$export$efc21ddc6aeb363d);
var $38a04da194065ad1$export$1279d2b7807629fd = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    of: $38a04da194065ad1$export$ba255e9e49e00608
};
var $38a04da194065ad1$export$f18d5acc27d70423 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    chain: $38a04da194065ad1$export$5b8affa63fc6df16
};
var $38a04da194065ad1$export$e3821ef4970c339c = /*#__PURE__*/ (0, $dya6d.chainFirst)($38a04da194065ad1$export$f18d5acc27d70423);
var $38a04da194065ad1$export$fb641926d034ac7d = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    of: $38a04da194065ad1$export$ba255e9e49e00608,
    chain: $38a04da194065ad1$export$5b8affa63fc6df16
};
var $38a04da194065ad1$export$8fa953f00d3b093 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    unfold: $38a04da194065ad1$export$c48e357c1a89b78d
};
var $38a04da194065ad1$export$25ba4469a069167 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    alt: $38a04da194065ad1$var$_alt
};
var $38a04da194065ad1$export$aaef8a3eae948f03 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    zero: $38a04da194065ad1$export$7f9972325ebfd559
};
var $38a04da194065ad1$export$864d727b48066337 = /*#__PURE__*/ (0, $2GEXo.guard)($38a04da194065ad1$export$aaef8a3eae948f03, $38a04da194065ad1$export$59a71046037e6c20);
var $38a04da194065ad1$export$4acb47accde578d2 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    of: $38a04da194065ad1$export$ba255e9e49e00608,
    alt: $38a04da194065ad1$var$_alt,
    zero: $38a04da194065ad1$export$7f9972325ebfd559
};
var $38a04da194065ad1$export$5b5dd0e212d2a5bc = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    extend: $38a04da194065ad1$var$_extend
};
var $38a04da194065ad1$export$4a21ac48141ac3c9 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    compact: $38a04da194065ad1$export$8e16b83750b44988,
    separate: $38a04da194065ad1$export$709f6946f4e97408
};
var $38a04da194065ad1$export$d00e1c48fb621173 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    compact: $38a04da194065ad1$export$8e16b83750b44988,
    separate: $38a04da194065ad1$export$709f6946f4e97408,
    filter: $38a04da194065ad1$var$_filter,
    filterMap: $38a04da194065ad1$var$_filterMap,
    partition: $38a04da194065ad1$var$_partition,
    partitionMap: $38a04da194065ad1$var$_partitionMap
};
var $38a04da194065ad1$export$c29a647071e542ec = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    mapWithIndex: $38a04da194065ad1$var$_mapWithIndex,
    compact: $38a04da194065ad1$export$8e16b83750b44988,
    separate: $38a04da194065ad1$export$709f6946f4e97408,
    filter: $38a04da194065ad1$var$_filter,
    filterMap: $38a04da194065ad1$var$_filterMap,
    partition: $38a04da194065ad1$var$_partition,
    partitionMap: $38a04da194065ad1$var$_partitionMap,
    partitionMapWithIndex: $38a04da194065ad1$var$_partitionMapWithIndex,
    partitionWithIndex: $38a04da194065ad1$var$_partitionWithIndex,
    filterMapWithIndex: $38a04da194065ad1$var$_filterMapWithIndex,
    filterWithIndex: $38a04da194065ad1$var$_filterWithIndex
};
var $38a04da194065ad1$export$41404b31838667c9 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    reduce: $38a04da194065ad1$var$_reduce,
    foldMap: $38a04da194065ad1$var$_foldMap,
    reduceRight: $38a04da194065ad1$var$_reduceRight
};
var $38a04da194065ad1$export$e8f7d17aaff345cb = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    reduce: $38a04da194065ad1$var$_reduce,
    foldMap: $38a04da194065ad1$var$_foldMap,
    reduceRight: $38a04da194065ad1$var$_reduceRight,
    reduceWithIndex: $38a04da194065ad1$var$_reduceWithIndex,
    foldMapWithIndex: $38a04da194065ad1$var$_foldMapWithIndex,
    reduceRightWithIndex: $38a04da194065ad1$var$_reduceRightWithIndex
};
var $38a04da194065ad1$export$a0202666c3bda011 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    reduce: $38a04da194065ad1$var$_reduce,
    foldMap: $38a04da194065ad1$var$_foldMap,
    reduceRight: $38a04da194065ad1$var$_reduceRight,
    traverse: $38a04da194065ad1$var$_traverse,
    sequence: $38a04da194065ad1$export$49bb65c2ea163039
};
var $38a04da194065ad1$export$bd7b528d8c36ec41 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    mapWithIndex: $38a04da194065ad1$var$_mapWithIndex,
    reduce: $38a04da194065ad1$var$_reduce,
    foldMap: $38a04da194065ad1$var$_foldMap,
    reduceRight: $38a04da194065ad1$var$_reduceRight,
    reduceWithIndex: $38a04da194065ad1$var$_reduceWithIndex,
    foldMapWithIndex: $38a04da194065ad1$var$_foldMapWithIndex,
    reduceRightWithIndex: $38a04da194065ad1$var$_reduceRightWithIndex,
    traverse: $38a04da194065ad1$var$_traverse,
    sequence: $38a04da194065ad1$export$49bb65c2ea163039,
    traverseWithIndex: $38a04da194065ad1$var$_traverseWithIndex
};
var $38a04da194065ad1$var$_wither = /*#__PURE__*/ (0, $LdARg.witherDefault)($38a04da194065ad1$export$a0202666c3bda011, $38a04da194065ad1$export$4a21ac48141ac3c9);
var $38a04da194065ad1$var$_wilt = /*#__PURE__*/ (0, $LdARg.wiltDefault)($38a04da194065ad1$export$a0202666c3bda011, $38a04da194065ad1$export$4a21ac48141ac3c9);
var $38a04da194065ad1$export$748d317b4c426f96 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    compact: $38a04da194065ad1$export$8e16b83750b44988,
    separate: $38a04da194065ad1$export$709f6946f4e97408,
    filter: $38a04da194065ad1$var$_filter,
    filterMap: $38a04da194065ad1$var$_filterMap,
    partition: $38a04da194065ad1$var$_partition,
    partitionMap: $38a04da194065ad1$var$_partitionMap,
    reduce: $38a04da194065ad1$var$_reduce,
    foldMap: $38a04da194065ad1$var$_foldMap,
    reduceRight: $38a04da194065ad1$var$_reduceRight,
    traverse: $38a04da194065ad1$var$_traverse,
    sequence: $38a04da194065ad1$export$49bb65c2ea163039,
    wither: $38a04da194065ad1$var$_wither,
    wilt: $38a04da194065ad1$var$_wilt
};
var $38a04da194065ad1$export$f855115a79f70c1a = $f0bNW.chainRecDepthFirst;
var $38a04da194065ad1$export$7d808dfaa6d54634 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    chain: $38a04da194065ad1$export$5b8affa63fc6df16,
    chainRec: $38a04da194065ad1$var$_chainRecDepthFirst
};
var $38a04da194065ad1$export$bffee57bb00a6859 = $f0bNW.chainRecBreadthFirst;
var $38a04da194065ad1$export$57f3a385c7e59628 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    chain: $38a04da194065ad1$export$5b8affa63fc6df16,
    chainRec: $38a04da194065ad1$var$_chainRecBreadthFirst
};
var $38a04da194065ad1$export$c40604f35db61519 = /*#__PURE__*/ (0, $LdARg.filterE)($38a04da194065ad1$export$748d317b4c426f96);
var $38a04da194065ad1$export$825ea6cb6fc48d49 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    fromEither: $38a04da194065ad1$export$80c878c9b1d77917
};
var $38a04da194065ad1$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $fgwhT.fromEitherK)($38a04da194065ad1$export$825ea6cb6fc48d49);
var $38a04da194065ad1$export$f4863e1822a1860c = $150AS.unsafeInsertAt;
var $38a04da194065ad1$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $38a04da194065ad1$export$a978c53b4062a525(as) ? $150AS.unsafeUpdateAt(i, a, as) : [];
};
var $38a04da194065ad1$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $38a04da194065ad1$export$7ecc1a3b11b57dab = $f0bNW.every;
var $38a04da194065ad1$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $38a04da194065ad1$export$f7e9f41ea797a17 = $38a04da194065ad1$export$ad14ef4001db2bcd;
var $38a04da194065ad1$export$739ec22334c44788 = $f0bNW.intercalate;
var $38a04da194065ad1$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $38a04da194065ad1$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $38a04da194065ad1$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($38a04da194065ad1$export$bd5b6bfc5fa2ee61);
var $38a04da194065ad1$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($38a04da194065ad1$export$bd5b6bfc5fa2ee61);
var $38a04da194065ad1$export$2385a24977818dd0 = /*#__PURE__*/ (0, $dya6d.bind)($38a04da194065ad1$export$f18d5acc27d70423);
var $38a04da194065ad1$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($38a04da194065ad1$export$efc21ddc6aeb363d);
var $38a04da194065ad1$export$e08e3b67e392101e = $38a04da194065ad1$export$5b8affa63fc6df16;
var $38a04da194065ad1$export$d02631cccf789723 = $150AS.range;
var $38a04da194065ad1$export$6e22c362a0406a2c = [];
var $38a04da194065ad1$export$8327ebbef2a0ba76 = $150AS.cons;
var $38a04da194065ad1$export$c40cf5aab899f397 = $150AS.snoc;
var $38a04da194065ad1$export$baeb00bf1e27e233 = $38a04da194065ad1$export$849c7567cbd62acc;
var $38a04da194065ad1$export$2f23118c22fb2630 = {
    URI: $38a04da194065ad1$export$9156e739aa33e19f,
    compact: $38a04da194065ad1$export$8e16b83750b44988,
    separate: $38a04da194065ad1$export$709f6946f4e97408,
    map: $38a04da194065ad1$var$_map,
    ap: $38a04da194065ad1$var$_ap,
    of: $38a04da194065ad1$export$ba255e9e49e00608,
    chain: $38a04da194065ad1$export$5b8affa63fc6df16,
    filter: $38a04da194065ad1$var$_filter,
    filterMap: $38a04da194065ad1$var$_filterMap,
    partition: $38a04da194065ad1$var$_partition,
    partitionMap: $38a04da194065ad1$var$_partitionMap,
    mapWithIndex: $38a04da194065ad1$var$_mapWithIndex,
    partitionMapWithIndex: $38a04da194065ad1$var$_partitionMapWithIndex,
    partitionWithIndex: $38a04da194065ad1$var$_partitionWithIndex,
    filterMapWithIndex: $38a04da194065ad1$var$_filterMapWithIndex,
    filterWithIndex: $38a04da194065ad1$var$_filterWithIndex,
    alt: $38a04da194065ad1$var$_alt,
    zero: $38a04da194065ad1$export$7f9972325ebfd559,
    unfold: $38a04da194065ad1$export$c48e357c1a89b78d,
    reduce: $38a04da194065ad1$var$_reduce,
    foldMap: $38a04da194065ad1$var$_foldMap,
    reduceRight: $38a04da194065ad1$var$_reduceRight,
    traverse: $38a04da194065ad1$var$_traverse,
    sequence: $38a04da194065ad1$export$49bb65c2ea163039,
    reduceWithIndex: $38a04da194065ad1$var$_reduceWithIndex,
    foldMapWithIndex: $38a04da194065ad1$var$_foldMapWithIndex,
    reduceRightWithIndex: $38a04da194065ad1$var$_reduceRightWithIndex,
    traverseWithIndex: $38a04da194065ad1$var$_traverseWithIndex,
    extend: $38a04da194065ad1$var$_extend,
    wither: $38a04da194065ad1$var$_wither,
    wilt: $38a04da194065ad1$var$_wilt
};

});
parcelRegister("j7Bi0", function(module, exports) {

$parcel$export(module.exports, "ap", function () { return $debb98af6a4f0db4$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "apFirst", function () { return $debb98af6a4f0db4$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $debb98af6a4f0db4$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apS", function () { return $debb98af6a4f0db4$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $debb98af6a4f0db4$export$18979a515d2a828e; });
$parcel$export(module.exports, "sequenceT", function () { return $debb98af6a4f0db4$export$6ec24752b7e97e26; });
$parcel$export(module.exports, "sequenceS", function () { return $debb98af6a4f0db4$export$d04bd2c3b28691e; });
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ 
var $kj6DU = parcelRequire("kj6DU");

var $lOGTm = parcelRequire("lOGTm");
function $debb98af6a4f0db4$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $debb98af6a4f0db4$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $debb98af6a4f0db4$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $debb98af6a4f0db4$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $debb98af6a4f0db4$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $debb98af6a4f0db4$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $debb98af6a4f0db4$var$curried(f, n - 1, combined);
    };
}
var $debb98af6a4f0db4$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $debb98af6a4f0db4$var$getTupleConstructor(len) {
    if (!$lOGTm.has.call($debb98af6a4f0db4$var$tupleConstructors, len)) $debb98af6a4f0db4$var$tupleConstructors[len] = $debb98af6a4f0db4$var$curried((0, $kj6DU.tuple), len - 1, []);
    return $debb98af6a4f0db4$var$tupleConstructors[len];
}
function $debb98af6a4f0db4$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $debb98af6a4f0db4$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $debb98af6a4f0db4$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $debb98af6a4f0db4$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $debb98af6a4f0db4$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $debb98af6a4f0db4$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("lOGTm", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $fe1f89eb9c3170f3$export$e56af863d5645d5f; });
$parcel$export(module.exports, "isSome", function () { return $fe1f89eb9c3170f3$export$5d7e502287836e58; });
$parcel$export(module.exports, "none", function () { return $fe1f89eb9c3170f3$export$f883a24d5edde77c; });
$parcel$export(module.exports, "some", function () { return $fe1f89eb9c3170f3$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "isLeft", function () { return $fe1f89eb9c3170f3$export$d649b6842e09f2b; });
$parcel$export(module.exports, "isRight", function () { return $fe1f89eb9c3170f3$export$a9d71693f0c1a85d; });
$parcel$export(module.exports, "left", function () { return $fe1f89eb9c3170f3$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $fe1f89eb9c3170f3$export$79ffe56a765070d2; });
$parcel$export(module.exports, "singleton", function () { return $fe1f89eb9c3170f3$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "isNonEmpty", function () { return $fe1f89eb9c3170f3$export$a978c53b4062a525; });
$parcel$export(module.exports, "head", function () { return $fe1f89eb9c3170f3$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tail", function () { return $fe1f89eb9c3170f3$export$c01875f616615628; });
$parcel$export(module.exports, "emptyReadonlyArray", function () { return $fe1f89eb9c3170f3$export$6ca726a2417e0f3f; });
$parcel$export(module.exports, "emptyRecord", function () { return $fe1f89eb9c3170f3$export$4de80339753b012b; });
$parcel$export(module.exports, "has", function () { return $fe1f89eb9c3170f3$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "fromReadonlyNonEmptyArray", function () { return $fe1f89eb9c3170f3$export$7e77326b0f0e268c; });
$parcel$export(module.exports, "liftNullable", function () { return $fe1f89eb9c3170f3$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $fe1f89eb9c3170f3$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $fe1f89eb9c3170f3$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $fe1f89eb9c3170f3$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "flatMapEither", function () { return $fe1f89eb9c3170f3$export$979f2bb6a976172d; });
$parcel$export(module.exports, "flatMapIO", function () { return $fe1f89eb9c3170f3$export$8b635ef81222764c; });
$parcel$export(module.exports, "flatMapTask", function () { return $fe1f89eb9c3170f3$export$43849ff3f7ffa51c; });

var $kj6DU = parcelRequire("kj6DU");
var $fe1f89eb9c3170f3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $fe1f89eb9c3170f3$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $fe1f89eb9c3170f3$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $fe1f89eb9c3170f3$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $fe1f89eb9c3170f3$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $fe1f89eb9c3170f3$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $fe1f89eb9c3170f3$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $fe1f89eb9c3170f3$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $fe1f89eb9c3170f3$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $fe1f89eb9c3170f3$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $fe1f89eb9c3170f3$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $fe1f89eb9c3170f3$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $fe1f89eb9c3170f3$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $fe1f89eb9c3170f3$export$6ca726a2417e0f3f = [];
var $fe1f89eb9c3170f3$export$4de80339753b012b = {};
var $fe1f89eb9c3170f3$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $fe1f89eb9c3170f3$export$7e77326b0f0e268c = function(as) {
    return $fe1f89eb9c3170f3$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $fe1f89eb9c3170f3$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $fe1f89eb9c3170f3$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $fe1f89eb9c3170f3$export$79ffe56a765070d2(o));
        };
    };
};
var $fe1f89eb9c3170f3$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($fe1f89eb9c3170f3$export$e56af863d5645d5f(o) ? $fe1f89eb9c3170f3$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $fe1f89eb9c3170f3$export$79ffe56a765070d2(o.value));
        };
    };
};
var $fe1f89eb9c3170f3$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $kj6DU.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, $fe1f89eb9c3170f3$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $fe1f89eb9c3170f3$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $kj6DU.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, $fe1f89eb9c3170f3$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $fe1f89eb9c3170f3$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $kj6DU.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $fe1f89eb9c3170f3$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $kj6DU.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $fe1f89eb9c3170f3$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $kj6DU.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $fe1f89eb9c3170f3$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $kj6DU.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

});


parcelRegister("dya6d", function(module, exports) {

$parcel$export(module.exports, "chainFirst", function () { return $9dd648d6f35896fb$export$e3821ef4970c339c; });
$parcel$export(module.exports, "tap", function () { return $9dd648d6f35896fb$export$3f23594af5f37336; });
$parcel$export(module.exports, "bind", function () { return $9dd648d6f35896fb$export$2385a24977818dd0; });
function $9dd648d6f35896fb$export$e3821ef4970c339c(M) {
    var tapM = $9dd648d6f35896fb$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $9dd648d6f35896fb$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $9dd648d6f35896fb$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("fgwhT", function(module, exports) {

$parcel$export(module.exports, "fromOption", function () { return $b1d16545b2a8b568$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromPredicate", function () { return $b1d16545b2a8b568$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromOptionK", function () { return $b1d16545b2a8b568$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $b1d16545b2a8b568$export$12d26179deb6a68a; });
$parcel$export(module.exports, "fromEitherK", function () { return $b1d16545b2a8b568$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "chainEitherK", function () { return $b1d16545b2a8b568$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "tapEither", function () { return $b1d16545b2a8b568$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "filterOrElse", function () { return $b1d16545b2a8b568$export$30af8ca9498ddf5b; });
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 
var $dya6d = parcelRequire("dya6d");

var $kj6DU = parcelRequire("kj6DU");

var $lOGTm = parcelRequire("lOGTm");
function $b1d16545b2a8b568$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($lOGTm.isNone(ma) ? $lOGTm.left(onNone()) : $lOGTm.right(ma.value));
        };
    };
}
function $b1d16545b2a8b568$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $lOGTm.right(a) : $lOGTm.left(onFalse(a)));
        };
    };
}
function $b1d16545b2a8b568$export$a907462f448b49f8(F) {
    var fromOptionF = $b1d16545b2a8b568$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $kj6DU.flow)(f, from);
        };
    };
}
function $b1d16545b2a8b568$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $b1d16545b2a8b568$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $b1d16545b2a8b568$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $kj6DU.flow)(f, F.fromEither);
    };
}
function $b1d16545b2a8b568$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $b1d16545b2a8b568$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $b1d16545b2a8b568$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $b1d16545b2a8b568$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $b1d16545b2a8b568$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $lOGTm.right(a) : $lOGTm.left(onFalse(a)));
            });
        };
    };
}
function $b1d16545b2a8b568$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $b1d16545b2a8b568$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $dya6d.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("6baua", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $47fbe7590acaa31a$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flap", function () { return $47fbe7590acaa31a$export$18c957606d8bdf09; });
$parcel$export(module.exports, "bindTo", function () { return $47fbe7590acaa31a$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $47fbe7590acaa31a$export$5d537b797c421217; });
$parcel$export(module.exports, "getFunctorComposition", function () { return $47fbe7590acaa31a$export$7b0f6fce42e2b480; });
$parcel$export(module.exports, "as", function () { return $47fbe7590acaa31a$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $47fbe7590acaa31a$export$9284b360ca18a0fd; });
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
var $kj6DU = parcelRequire("kj6DU");
function $47fbe7590acaa31a$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $47fbe7590acaa31a$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $47fbe7590acaa31a$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $47fbe7590acaa31a$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $47fbe7590acaa31a$export$7b0f6fce42e2b480(F, G) {
    var _map = $47fbe7590acaa31a$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $kj6DU.pipe)(fga, _map(f));
        }
    };
}
function $47fbe7590acaa31a$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $47fbe7590acaa31a$export$9284b360ca18a0fd(F) {
    var asM = $47fbe7590acaa31a$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});

parcelRegister("150AS", function(module, exports) {

$parcel$export(module.exports, "isNonEmpty", function () { return $0c96b7fc8adf9f18$export$a978c53b4062a525; });
$parcel$export(module.exports, "isOutOfBound", function () { return $0c96b7fc8adf9f18$export$2fde0b1c54fc39b9; });
$parcel$export(module.exports, "prependW", function () { return $0c96b7fc8adf9f18$export$c4c4d41eab625797; });
$parcel$export(module.exports, "prepend", function () { return $0c96b7fc8adf9f18$export$68159836694e22c1; });
$parcel$export(module.exports, "appendW", function () { return $0c96b7fc8adf9f18$export$19903a1bf1942f6; });
$parcel$export(module.exports, "append", function () { return $0c96b7fc8adf9f18$export$10d8903dec122b9d; });
$parcel$export(module.exports, "unsafeInsertAt", function () { return $0c96b7fc8adf9f18$export$f4863e1822a1860c; });
$parcel$export(module.exports, "unsafeUpdateAt", function () { return $0c96b7fc8adf9f18$export$9c0c6889b1fa9bfc; });
$parcel$export(module.exports, "uniq", function () { return $0c96b7fc8adf9f18$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "head", function () { return $0c96b7fc8adf9f18$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tail", function () { return $0c96b7fc8adf9f18$export$c01875f616615628; });
$parcel$export(module.exports, "sortBy", function () { return $0c96b7fc8adf9f18$export$b035e44d7bb4278f; });
$parcel$export(module.exports, "union", function () { return $0c96b7fc8adf9f18$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "rotate", function () { return $0c96b7fc8adf9f18$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "splitAt", function () { return $0c96b7fc8adf9f18$export$b0d75975ac0be0e1; });
$parcel$export(module.exports, "makeBy", function () { return $0c96b7fc8adf9f18$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "range", function () { return $0c96b7fc8adf9f18$export$d02631cccf789723; });
$parcel$export(module.exports, "init", function () { return $0c96b7fc8adf9f18$export$2cd8252107eb640b; });
$parcel$export(module.exports, "last", function () { return $0c96b7fc8adf9f18$export$4c7897fafd92b108; });
$parcel$export(module.exports, "of", function () { return $0c96b7fc8adf9f18$export$ba255e9e49e00608; });
$parcel$export(module.exports, "prependAll", function () { return $0c96b7fc8adf9f18$export$849c7567cbd62acc; });
$parcel$export(module.exports, "intersperse", function () { return $0c96b7fc8adf9f18$export$af200dcf8b7cb5de; });
$parcel$export(module.exports, "chop", function () { return $0c96b7fc8adf9f18$export$433fe05b12ba833f; });
$parcel$export(module.exports, "chunksOf", function () { return $0c96b7fc8adf9f18$export$2f0184d5df52135f; });
$parcel$export(module.exports, "cons", function () { return $0c96b7fc8adf9f18$export$8327ebbef2a0ba76; });
$parcel$export(module.exports, "snoc", function () { return $0c96b7fc8adf9f18$export$c40cf5aab899f397; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $hOuM2 = parcelRequire("hOuM2");

var $kqvcT = parcelRequire("kqvcT");
var $0c96b7fc8adf9f18$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0c96b7fc8adf9f18$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $0c96b7fc8adf9f18$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $0c96b7fc8adf9f18$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $0c96b7fc8adf9f18$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $0c96b7fc8adf9f18$export$68159836694e22c1 = $0c96b7fc8adf9f18$export$c4c4d41eab625797;
var $0c96b7fc8adf9f18$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $0c96b7fc8adf9f18$var$__spreadArray($0c96b7fc8adf9f18$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $0c96b7fc8adf9f18$export$10d8903dec122b9d = $0c96b7fc8adf9f18$export$19903a1bf1942f6;
var $0c96b7fc8adf9f18$export$f4863e1822a1860c = function(i, a, as) {
    if ($0c96b7fc8adf9f18$export$a978c53b4062a525(as)) {
        var xs = $0c96b7fc8adf9f18$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $0c96b7fc8adf9f18$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $0c96b7fc8adf9f18$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $0c96b7fc8adf9f18$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $0c96b7fc8adf9f18$export$784d13d8ee351f07(as);
        var out = [
            $0c96b7fc8adf9f18$export$5fd5031fecdacec3(as)
        ];
        var rest = $0c96b7fc8adf9f18$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $0c96b7fc8adf9f18$export$b035e44d7bb4278f = function(ords) {
    if ($0c96b7fc8adf9f18$export$a978c53b4062a525(ords)) {
        var M = (0, $hOuM2.getMonoid)();
        return $0c96b7fc8adf9f18$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $0c96b7fc8adf9f18$export$784d13d8ee351f07;
};
var $0c96b7fc8adf9f18$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $0c96b7fc8adf9f18$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $kj6DU.pipe)(first, $0c96b7fc8adf9f18$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $0c96b7fc8adf9f18$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($0c96b7fc8adf9f18$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $0c96b7fc8adf9f18$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $0c96b7fc8adf9f18$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $kj6DU.pipe)(s, $0c96b7fc8adf9f18$export$ee1b3e54f0441b22(f));
        } else return $0c96b7fc8adf9f18$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $0c96b7fc8adf9f18$export$7e77326b0f0e268c = $lOGTm.fromReadonlyNonEmptyArray;
var $0c96b7fc8adf9f18$export$571d59b505e6bb4e = function(as) {
    return $0c96b7fc8adf9f18$export$a978c53b4062a525(as) ? $lOGTm.some(as) : $lOGTm.none;
};
var $0c96b7fc8adf9f18$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $0c96b7fc8adf9f18$export$606959e7ccb797f0 = function(a) {
    return $0c96b7fc8adf9f18$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $0c96b7fc8adf9f18$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $0c96b7fc8adf9f18$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $0c96b7fc8adf9f18$export$c04edabe9c8d994f = function(as) {
    return [
        $0c96b7fc8adf9f18$export$5fd5031fecdacec3(as),
        $0c96b7fc8adf9f18$export$c01875f616615628(as)
    ];
};
var $0c96b7fc8adf9f18$export$89a97afc72a83708 = function(as) {
    return [
        $0c96b7fc8adf9f18$export$2cd8252107eb640b(as),
        $0c96b7fc8adf9f18$export$4c7897fafd92b108(as)
    ];
};
function $0c96b7fc8adf9f18$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $0c96b7fc8adf9f18$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $0c96b7fc8adf9f18$export$66c1ae025e96b4bc = function(as) {
    return $0c96b7fc8adf9f18$var$__spreadArray([
        $0c96b7fc8adf9f18$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $0c96b7fc8adf9f18$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $0c96b7fc8adf9f18$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($lOGTm.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $0c96b7fc8adf9f18$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $0c96b7fc8adf9f18$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $lOGTm.none : $lOGTm.some($0c96b7fc8adf9f18$export$f4863e1822a1860c(i, a, as));
    };
};
var $0c96b7fc8adf9f18$export$b6d8713d53419d4c = function(i, a) {
    return $0c96b7fc8adf9f18$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $0c96b7fc8adf9f18$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $0c96b7fc8adf9f18$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some($0c96b7fc8adf9f18$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $0c96b7fc8adf9f18$export$784d13d8ee351f07 = $0c96b7fc8adf9f18$export$7e77326b0f0e268c;
var $0c96b7fc8adf9f18$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $0c96b7fc8adf9f18$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $0c96b7fc8adf9f18$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $0c96b7fc8adf9f18$export$8901015135f2fb22(bs, as);
    };
    return $0c96b7fc8adf9f18$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $0c96b7fc8adf9f18$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $0c96b7fc8adf9f18$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $0c96b7fc8adf9f18$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $0c96b7fc8adf9f18$export$c01875f616615628(as);
        return $0c96b7fc8adf9f18$export$a978c53b4062a525(rest) ? (0, $kj6DU.pipe)(rest, $0c96b7fc8adf9f18$export$849c7567cbd62acc(middle), $0c96b7fc8adf9f18$export$68159836694e22c1($0c96b7fc8adf9f18$export$5fd5031fecdacec3(as))) : $0c96b7fc8adf9f18$export$784d13d8ee351f07(as);
    };
};
var $0c96b7fc8adf9f18$export$18153bb1181268e5 = $kqvcT.foldMapWithIndex;
var $0c96b7fc8adf9f18$export$b66cdc0497d8a99a = $kqvcT.foldMap;
var $0c96b7fc8adf9f18$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $0c96b7fc8adf9f18$export$7e77326b0f0e268c(f(0, $0c96b7fc8adf9f18$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $0c96b7fc8adf9f18$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($0c96b7fc8adf9f18$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $0c96b7fc8adf9f18$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $0c96b7fc8adf9f18$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $kj6DU.pipe)(as.slice(1, m), $0c96b7fc8adf9f18$export$68159836694e22c1($0c96b7fc8adf9f18$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $0c96b7fc8adf9f18$export$2f0184d5df52135f = function(n) {
    return $0c96b7fc8adf9f18$export$433fe05b12ba833f($0c96b7fc8adf9f18$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_mapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $0c96b7fc8adf9f18$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_extend = function(wa, f) {
    return (0, $kj6DU.pipe)(wa, $0c96b7fc8adf9f18$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_foldMap = function(M) {
    var foldMapM = $0c96b7fc8adf9f18$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_traverse = function(F) {
    var traverseF = $0c96b7fc8adf9f18$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $0c96b7fc8adf9f18$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $0c96b7fc8adf9f18$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $0c96b7fc8adf9f18$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $0c96b7fc8adf9f18$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseWithIndexF(f));
    };
};
var $0c96b7fc8adf9f18$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $kj6DU.pipe)(as, $0c96b7fc8adf9f18$export$c8c959650bbe80e2(that()));
    };
};
var $0c96b7fc8adf9f18$export$228be17d80722ab = $0c96b7fc8adf9f18$export$1517cca7889d6aaa;
var $0c96b7fc8adf9f18$export$2f6ca3d3b1f80bf5 = function(as) {
    return $0c96b7fc8adf9f18$export$5b8affa63fc6df16(function(f) {
        return (0, $kj6DU.pipe)(as, $0c96b7fc8adf9f18$export$871de8747c9eaa88(f));
    });
};
var $0c96b7fc8adf9f18$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return (0, $kj6DU.pipe)(ma, $0c96b7fc8adf9f18$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $0c96b7fc8adf9f18$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $0c96b7fc8adf9f18$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($0c96b7fc8adf9f18$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $0c96b7fc8adf9f18$export$c01875f616615628(next);
        }
        return out;
    };
};
var $0c96b7fc8adf9f18$export$ecd5e8ace626722c = /*#__PURE__*/ $0c96b7fc8adf9f18$export$8b58be045bf06082((0, $kj6DU.identity));
var $0c96b7fc8adf9f18$export$bffa455ba8c619a6 = /*#__PURE__*/ $0c96b7fc8adf9f18$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $0c96b7fc8adf9f18$export$871de8747c9eaa88 = function(f) {
    return $0c96b7fc8adf9f18$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $0c96b7fc8adf9f18$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $0c96b7fc8adf9f18$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $0c96b7fc8adf9f18$export$533b26079ad0b4b = $kqvcT.reduce;
var $0c96b7fc8adf9f18$export$bbd3ef8720e22369 = $kqvcT.reduceWithIndex;
var $0c96b7fc8adf9f18$export$7fef8bcdbb34f435 = $kqvcT.reduceRight;
var $0c96b7fc8adf9f18$export$ce2b2fe0b88ccd0a = $kqvcT.reduceRightWithIndex;
var $0c96b7fc8adf9f18$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $0c96b7fc8adf9f18$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $0c96b7fc8adf9f18$export$49bb65c2ea163039 = function(F) {
    return $0c96b7fc8adf9f18$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $0c96b7fc8adf9f18$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $0c96b7fc8adf9f18$export$5fd5031fecdacec3(as)), $0c96b7fc8adf9f18$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $kj6DU.pipe)(bs, $0c96b7fc8adf9f18$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $0c96b7fc8adf9f18$export$f9380c9a627682d3 = $kqvcT.head;
var $0c96b7fc8adf9f18$export$9156e739aa33e19f = 'NonEmptyArray';
var $0c96b7fc8adf9f18$export$3cb5cd7f7776c81 = $kqvcT.getShow;
var $0c96b7fc8adf9f18$export$e759a9a7f8d04692 = function() {
    return {
        concat: $0c96b7fc8adf9f18$export$ee1b3e54f0441b22
    };
};
var $0c96b7fc8adf9f18$export$804fed467fde44e4 = $kqvcT.getEq;
var $0c96b7fc8adf9f18$export$baca17b4aff42f82 = function(E) {
    var unionE = $0c96b7fc8adf9f18$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $0c96b7fc8adf9f18$export$bd5b6bfc5fa2ee61 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map
};
var $0c96b7fc8adf9f18$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($0c96b7fc8adf9f18$export$bd5b6bfc5fa2ee61);
var $0c96b7fc8adf9f18$export$59a71046037e6c20 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    of: $0c96b7fc8adf9f18$export$ba255e9e49e00608
};
var $0c96b7fc8adf9f18$export$9fdffe0fe1e91cad = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    mapWithIndex: $0c96b7fc8adf9f18$var$_mapWithIndex
};
var $0c96b7fc8adf9f18$export$efc21ddc6aeb363d = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    ap: $0c96b7fc8adf9f18$var$_ap
};
var $0c96b7fc8adf9f18$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($0c96b7fc8adf9f18$export$efc21ddc6aeb363d);
var $0c96b7fc8adf9f18$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($0c96b7fc8adf9f18$export$efc21ddc6aeb363d);
var $0c96b7fc8adf9f18$export$1279d2b7807629fd = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    ap: $0c96b7fc8adf9f18$var$_ap,
    of: $0c96b7fc8adf9f18$export$ba255e9e49e00608
};
var $0c96b7fc8adf9f18$export$f18d5acc27d70423 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    ap: $0c96b7fc8adf9f18$var$_ap,
    chain: $0c96b7fc8adf9f18$export$5b8affa63fc6df16
};
var $0c96b7fc8adf9f18$export$e3821ef4970c339c = /*#__PURE__*/ (0, $dya6d.chainFirst)($0c96b7fc8adf9f18$export$f18d5acc27d70423);
var $0c96b7fc8adf9f18$export$fb641926d034ac7d = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    ap: $0c96b7fc8adf9f18$var$_ap,
    of: $0c96b7fc8adf9f18$export$ba255e9e49e00608,
    chain: $0c96b7fc8adf9f18$export$5b8affa63fc6df16
};
var $0c96b7fc8adf9f18$export$41404b31838667c9 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    reduce: $0c96b7fc8adf9f18$var$_reduce,
    foldMap: $0c96b7fc8adf9f18$var$_foldMap,
    reduceRight: $0c96b7fc8adf9f18$var$_reduceRight
};
var $0c96b7fc8adf9f18$export$e8f7d17aaff345cb = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    reduce: $0c96b7fc8adf9f18$var$_reduce,
    foldMap: $0c96b7fc8adf9f18$var$_foldMap,
    reduceRight: $0c96b7fc8adf9f18$var$_reduceRight,
    reduceWithIndex: $0c96b7fc8adf9f18$var$_reduceWithIndex,
    foldMapWithIndex: $0c96b7fc8adf9f18$var$_foldMapWithIndex,
    reduceRightWithIndex: $0c96b7fc8adf9f18$var$_reduceRightWithIndex
};
var $0c96b7fc8adf9f18$export$a0202666c3bda011 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    reduce: $0c96b7fc8adf9f18$var$_reduce,
    foldMap: $0c96b7fc8adf9f18$var$_foldMap,
    reduceRight: $0c96b7fc8adf9f18$var$_reduceRight,
    traverse: $0c96b7fc8adf9f18$var$_traverse,
    sequence: $0c96b7fc8adf9f18$export$49bb65c2ea163039
};
var $0c96b7fc8adf9f18$export$bd7b528d8c36ec41 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    mapWithIndex: $0c96b7fc8adf9f18$var$_mapWithIndex,
    reduce: $0c96b7fc8adf9f18$var$_reduce,
    foldMap: $0c96b7fc8adf9f18$var$_foldMap,
    reduceRight: $0c96b7fc8adf9f18$var$_reduceRight,
    traverse: $0c96b7fc8adf9f18$var$_traverse,
    sequence: $0c96b7fc8adf9f18$export$49bb65c2ea163039,
    reduceWithIndex: $0c96b7fc8adf9f18$var$_reduceWithIndex,
    foldMapWithIndex: $0c96b7fc8adf9f18$var$_foldMapWithIndex,
    reduceRightWithIndex: $0c96b7fc8adf9f18$var$_reduceRightWithIndex,
    traverseWithIndex: $0c96b7fc8adf9f18$var$_traverseWithIndex
};
var $0c96b7fc8adf9f18$export$25ba4469a069167 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    alt: $0c96b7fc8adf9f18$var$_alt
};
var $0c96b7fc8adf9f18$export$fdd73124b9f1de36 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    map: $0c96b7fc8adf9f18$var$_map,
    extend: $0c96b7fc8adf9f18$var$_extend,
    extract: $0c96b7fc8adf9f18$export$f9380c9a627682d3
};
var $0c96b7fc8adf9f18$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $0c96b7fc8adf9f18$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $0c96b7fc8adf9f18$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($0c96b7fc8adf9f18$export$bd5b6bfc5fa2ee61);
var $0c96b7fc8adf9f18$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($0c96b7fc8adf9f18$export$bd5b6bfc5fa2ee61);
var $0c96b7fc8adf9f18$export$2385a24977818dd0 = /*#__PURE__*/ (0, $dya6d.bind)($0c96b7fc8adf9f18$export$f18d5acc27d70423);
var $0c96b7fc8adf9f18$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($0c96b7fc8adf9f18$export$efc21ddc6aeb363d);
var $0c96b7fc8adf9f18$export$5fd5031fecdacec3 = $kqvcT.head;
var $0c96b7fc8adf9f18$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $0c96b7fc8adf9f18$export$4c7897fafd92b108 = $kqvcT.last;
var $0c96b7fc8adf9f18$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $0c96b7fc8adf9f18$export$96ec731ed4dcb222 = $kqvcT.min;
var $0c96b7fc8adf9f18$export$8960430cfd85939f = $kqvcT.max;
var $0c96b7fc8adf9f18$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $0c96b7fc8adf9f18$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($0c96b7fc8adf9f18$export$5fd5031fecdacec3(as), $0c96b7fc8adf9f18$export$c01875f616615628(as));
    };
};
var $0c96b7fc8adf9f18$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($0c96b7fc8adf9f18$export$2cd8252107eb640b(as), $0c96b7fc8adf9f18$export$4c7897fafd92b108(as));
    };
};
var $0c96b7fc8adf9f18$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $0c96b7fc8adf9f18$var$__spreadArray([
            f($0c96b7fc8adf9f18$export$5fd5031fecdacec3(as))
        ], $0c96b7fc8adf9f18$export$c01875f616615628(as), true);
    };
};
var $0c96b7fc8adf9f18$export$20ca6ad9f7762931 = function(a) {
    return $0c96b7fc8adf9f18$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $0c96b7fc8adf9f18$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $kj6DU.pipe)($0c96b7fc8adf9f18$export$2cd8252107eb640b(as), $0c96b7fc8adf9f18$export$10d8903dec122b9d(f($0c96b7fc8adf9f18$export$4c7897fafd92b108(as))));
    };
};
var $0c96b7fc8adf9f18$export$d3affa0a0a83d946 = function(a) {
    return $0c96b7fc8adf9f18$export$302ad361c463800a(function() {
        return a;
    });
};
var $0c96b7fc8adf9f18$export$739ec22334c44788 = $kqvcT.intercalate;
var $0c96b7fc8adf9f18$export$e08e3b67e392101e = $0c96b7fc8adf9f18$export$5b8affa63fc6df16;
function $0c96b7fc8adf9f18$export$103ce2c0a67e4e61(O) {
    var sortO = $0c96b7fc8adf9f18$export$97db5808d8f88186(O);
    var groupO = $0c96b7fc8adf9f18$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $0c96b7fc8adf9f18$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $0c96b7fc8adf9f18$export$3dea766d36a8935f(predicate) {
    return $0c96b7fc8adf9f18$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $0c96b7fc8adf9f18$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $0c96b7fc8adf9f18$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $0c96b7fc8adf9f18$export$b446f6baa3bb1430 = $0c96b7fc8adf9f18$export$c04edabe9c8d994f;
var $0c96b7fc8adf9f18$export$712962e076096ed4 = $0c96b7fc8adf9f18$export$89a97afc72a83708;
function $0c96b7fc8adf9f18$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $0c96b7fc8adf9f18$export$68159836694e22c1(head) : (0, $kj6DU.pipe)(tail, $0c96b7fc8adf9f18$export$68159836694e22c1(head));
}
var $0c96b7fc8adf9f18$export$c40cf5aab899f397 = function(init, end) {
    return (0, $kj6DU.pipe)(init, $0c96b7fc8adf9f18$export$10d8903dec122b9d(end));
};
var $0c96b7fc8adf9f18$export$baeb00bf1e27e233 = $0c96b7fc8adf9f18$export$849c7567cbd62acc;
var $0c96b7fc8adf9f18$export$93e2b83da34ff82a = $kqvcT.concatAll;
var $0c96b7fc8adf9f18$export$a5383a53b408af94 = {
    URI: $0c96b7fc8adf9f18$export$9156e739aa33e19f,
    of: $0c96b7fc8adf9f18$export$ba255e9e49e00608,
    map: $0c96b7fc8adf9f18$var$_map,
    mapWithIndex: $0c96b7fc8adf9f18$var$_mapWithIndex,
    ap: $0c96b7fc8adf9f18$var$_ap,
    chain: $0c96b7fc8adf9f18$export$5b8affa63fc6df16,
    extend: $0c96b7fc8adf9f18$var$_extend,
    extract: $0c96b7fc8adf9f18$export$f9380c9a627682d3,
    reduce: $0c96b7fc8adf9f18$var$_reduce,
    foldMap: $0c96b7fc8adf9f18$var$_foldMap,
    reduceRight: $0c96b7fc8adf9f18$var$_reduceRight,
    traverse: $0c96b7fc8adf9f18$var$_traverse,
    sequence: $0c96b7fc8adf9f18$export$49bb65c2ea163039,
    reduceWithIndex: $0c96b7fc8adf9f18$var$_reduceWithIndex,
    foldMapWithIndex: $0c96b7fc8adf9f18$var$_foldMapWithIndex,
    reduceRightWithIndex: $0c96b7fc8adf9f18$var$_reduceRightWithIndex,
    traverseWithIndex: $0c96b7fc8adf9f18$var$_traverseWithIndex,
    alt: $0c96b7fc8adf9f18$var$_alt
};

});
parcelRegister("hOuM2", function(module, exports) {

$parcel$export(module.exports, "equalsDefault", function () { return $cf7efa31ebaaf661$export$19fbc5aa8790347c; });
$parcel$export(module.exports, "fromCompare", function () { return $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd; });
$parcel$export(module.exports, "tuple", function () { return $cf7efa31ebaaf661$export$65e3907585753458; });
$parcel$export(module.exports, "reverse", function () { return $cf7efa31ebaaf661$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "contramap", function () { return $cf7efa31ebaaf661$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "URI", function () { return $cf7efa31ebaaf661$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getSemigroup", function () { return $cf7efa31ebaaf661$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $cf7efa31ebaaf661$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Contravariant", function () { return $cf7efa31ebaaf661$export$def901a57d5539c3; });
$parcel$export(module.exports, "trivial", function () { return $cf7efa31ebaaf661$export$e5bb9f0f2dedbef6; });
$parcel$export(module.exports, "equals", function () { return $cf7efa31ebaaf661$export$e9bab7fafb253603; });
$parcel$export(module.exports, "lt", function () { return $cf7efa31ebaaf661$export$b961576059b7aeb6; });
$parcel$export(module.exports, "gt", function () { return $cf7efa31ebaaf661$export$dafeacbfe3530cd9; });
$parcel$export(module.exports, "leq", function () { return $cf7efa31ebaaf661$export$8c5f3ec5d3a940d; });
$parcel$export(module.exports, "geq", function () { return $cf7efa31ebaaf661$export$61f00a763551642c; });
$parcel$export(module.exports, "min", function () { return $cf7efa31ebaaf661$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $cf7efa31ebaaf661$export$8960430cfd85939f; });
$parcel$export(module.exports, "clamp", function () { return $cf7efa31ebaaf661$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "between", function () { return $cf7efa31ebaaf661$export$cf95c51b03f10bae; });
$parcel$export(module.exports, "getTupleOrd", function () { return $cf7efa31ebaaf661$export$c41db498223b95e9; });
$parcel$export(module.exports, "getDualOrd", function () { return $cf7efa31ebaaf661$export$35315ebcdff1b05c; });
$parcel$export(module.exports, "ord", function () { return $cf7efa31ebaaf661$export$ad12338f1fefb50e; });
$parcel$export(module.exports, "ordBoolean", function () { return $cf7efa31ebaaf661$export$ef759d57a4e44836; });
$parcel$export(module.exports, "ordString", function () { return $cf7efa31ebaaf661$export$c5f2758e49b2b86a; });
$parcel$export(module.exports, "ordNumber", function () { return $cf7efa31ebaaf661$export$5ed021ff2336715c; });
$parcel$export(module.exports, "ordDate", function () { return $cf7efa31ebaaf661$export$722593c82468f9f4; });

var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");
var $cf7efa31ebaaf661$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $cf7efa31ebaaf661$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $cf7efa31ebaaf661$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $cf7efa31ebaaf661$export$66c1ae025e96b4bc = function(O) {
    return $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $cf7efa31ebaaf661$var$contramap_ = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $cf7efa31ebaaf661$export$53b696d27ecb7ba7(f));
};
var $cf7efa31ebaaf661$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $cf7efa31ebaaf661$export$9156e739aa33e19f = 'Ord';
var $cf7efa31ebaaf661$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $cf7efa31ebaaf661$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $cf7efa31ebaaf661$export$e759a9a7f8d04692().concat,
        empty: $cf7efa31ebaaf661$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $cf7efa31ebaaf661$export$def901a57d5539c3 = {
    URI: $cf7efa31ebaaf661$export$9156e739aa33e19f,
    contramap: $cf7efa31ebaaf661$var$contramap_
};
var $cf7efa31ebaaf661$export$e5bb9f0f2dedbef6 = {
    equals: (0, $kj6DU.constTrue),
    compare: /*#__PURE__*/ (0, $kj6DU.constant)(0)
};
var $cf7efa31ebaaf661$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $cf7efa31ebaaf661$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $cf7efa31ebaaf661$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $cf7efa31ebaaf661$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $cf7efa31ebaaf661$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $cf7efa31ebaaf661$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $cf7efa31ebaaf661$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $cf7efa31ebaaf661$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $cf7efa31ebaaf661$export$96ec731ed4dcb222(O);
    var maxO = $cf7efa31ebaaf661$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $cf7efa31ebaaf661$export$cf95c51b03f10bae = function(O) {
    var ltO = $cf7efa31ebaaf661$export$b961576059b7aeb6(O);
    var gtO = $cf7efa31ebaaf661$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $cf7efa31ebaaf661$export$c41db498223b95e9 = $cf7efa31ebaaf661$export$65e3907585753458;
var $cf7efa31ebaaf661$export$35315ebcdff1b05c = $cf7efa31ebaaf661$export$66c1ae025e96b4bc;
var $cf7efa31ebaaf661$export$ad12338f1fefb50e = $cf7efa31ebaaf661$export$def901a57d5539c3;
// default compare for primitive types
function $cf7efa31ebaaf661$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $cf7efa31ebaaf661$var$strictOrd = {
    equals: (0, $9RyKW.eqStrict).equals,
    compare: $cf7efa31ebaaf661$var$compare
};
var $cf7efa31ebaaf661$export$ef759d57a4e44836 = $cf7efa31ebaaf661$var$strictOrd;
var $cf7efa31ebaaf661$export$c5f2758e49b2b86a = $cf7efa31ebaaf661$var$strictOrd;
var $cf7efa31ebaaf661$export$5ed021ff2336715c = $cf7efa31ebaaf661$var$strictOrd;
var $cf7efa31ebaaf661$export$722593c82468f9f4 = /*#__PURE__*/ (0, $kj6DU.pipe)($cf7efa31ebaaf661$export$5ed021ff2336715c, /*#__PURE__*/ $cf7efa31ebaaf661$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));

});
parcelRegister("9RyKW", function(module, exports) {

$parcel$export(module.exports, "fromEquals", function () { return $72e4062074df6db7$export$fec6acd8d60e8568; });
$parcel$export(module.exports, "struct", function () { return $72e4062074df6db7$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "tuple", function () { return $72e4062074df6db7$export$65e3907585753458; });
$parcel$export(module.exports, "contramap", function () { return $72e4062074df6db7$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "URI", function () { return $72e4062074df6db7$export$9156e739aa33e19f; });
$parcel$export(module.exports, "eqStrict", function () { return $72e4062074df6db7$export$37a88d8211c10fd3; });
$parcel$export(module.exports, "getSemigroup", function () { return $72e4062074df6db7$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $72e4062074df6db7$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Contravariant", function () { return $72e4062074df6db7$export$def901a57d5539c3; });
$parcel$export(module.exports, "getTupleEq", function () { return $72e4062074df6db7$export$1a50cb133a346493; });
$parcel$export(module.exports, "getStructEq", function () { return $72e4062074df6db7$export$b35b2bde1875587a; });
$parcel$export(module.exports, "strictEqual", function () { return $72e4062074df6db7$export$24d177074f8dc6ef; });
$parcel$export(module.exports, "eq", function () { return $72e4062074df6db7$export$9663ddc1cf085b32; });
$parcel$export(module.exports, "eqBoolean", function () { return $72e4062074df6db7$export$d7927e8ffc1afb48; });
$parcel$export(module.exports, "eqString", function () { return $72e4062074df6db7$export$fa624555ca2acbc8; });
$parcel$export(module.exports, "eqNumber", function () { return $72e4062074df6db7$export$e24978670be1e4f3; });
$parcel$export(module.exports, "eqDate", function () { return $72e4062074df6db7$export$4eced57d6183c43d; });

var $kj6DU = parcelRequire("kj6DU");
var $72e4062074df6db7$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $72e4062074df6db7$export$8cf3da7c1c9174ea = function(eqs) {
    return $72e4062074df6db7$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $72e4062074df6db7$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $72e4062074df6db7$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $72e4062074df6db7$var$contramap_ = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $72e4062074df6db7$export$53b696d27ecb7ba7(f));
};
var $72e4062074df6db7$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $72e4062074df6db7$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $72e4062074df6db7$export$9156e739aa33e19f = 'Eq';
var $72e4062074df6db7$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $72e4062074df6db7$var$empty = {
    equals: function() {
        return true;
    }
};
var $72e4062074df6db7$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $72e4062074df6db7$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $72e4062074df6db7$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $72e4062074df6db7$export$e759a9a7f8d04692().concat,
        empty: $72e4062074df6db7$var$empty
    };
};
var $72e4062074df6db7$export$def901a57d5539c3 = {
    URI: $72e4062074df6db7$export$9156e739aa33e19f,
    contramap: $72e4062074df6db7$var$contramap_
};
var $72e4062074df6db7$export$1a50cb133a346493 = $72e4062074df6db7$export$65e3907585753458;
var $72e4062074df6db7$export$b35b2bde1875587a = $72e4062074df6db7$export$8cf3da7c1c9174ea;
var $72e4062074df6db7$export$24d177074f8dc6ef = $72e4062074df6db7$export$37a88d8211c10fd3.equals;
var $72e4062074df6db7$export$9663ddc1cf085b32 = $72e4062074df6db7$export$def901a57d5539c3;
var $72e4062074df6db7$export$d7927e8ffc1afb48 = $72e4062074df6db7$export$37a88d8211c10fd3;
var $72e4062074df6db7$export$fa624555ca2acbc8 = $72e4062074df6db7$export$37a88d8211c10fd3;
var $72e4062074df6db7$export$e24978670be1e4f3 = $72e4062074df6db7$export$37a88d8211c10fd3;
var $72e4062074df6db7$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("kqvcT", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $edee716575af04c0$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "isNonEmpty", function () { return $edee716575af04c0$export$a978c53b4062a525; });
$parcel$export(module.exports, "isOutOfBound", function () { return $edee716575af04c0$export$2fde0b1c54fc39b9; });
$parcel$export(module.exports, "prependW", function () { return $edee716575af04c0$export$c4c4d41eab625797; });
$parcel$export(module.exports, "prepend", function () { return $edee716575af04c0$export$68159836694e22c1; });
$parcel$export(module.exports, "appendW", function () { return $edee716575af04c0$export$19903a1bf1942f6; });
$parcel$export(module.exports, "append", function () { return $edee716575af04c0$export$10d8903dec122b9d; });
$parcel$export(module.exports, "unsafeInsertAt", function () { return $edee716575af04c0$export$f4863e1822a1860c; });
$parcel$export(module.exports, "unsafeUpdateAt", function () { return $edee716575af04c0$export$9c0c6889b1fa9bfc; });
$parcel$export(module.exports, "uniq", function () { return $edee716575af04c0$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "head", function () { return $edee716575af04c0$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tail", function () { return $edee716575af04c0$export$c01875f616615628; });
$parcel$export(module.exports, "sortBy", function () { return $edee716575af04c0$export$b035e44d7bb4278f; });
$parcel$export(module.exports, "sort", function () { return $edee716575af04c0$export$97db5808d8f88186; });
$parcel$export(module.exports, "union", function () { return $edee716575af04c0$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "concat", function () { return $edee716575af04c0$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "rotate", function () { return $edee716575af04c0$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "splitAt", function () { return $edee716575af04c0$export$b0d75975ac0be0e1; });
$parcel$export(module.exports, "fromReadonlyArray", function () { return $edee716575af04c0$export$9288e031f1846591; });
$parcel$export(module.exports, "makeBy", function () { return $edee716575af04c0$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "replicate", function () { return $edee716575af04c0$export$606959e7ccb797f0; });
$parcel$export(module.exports, "range", function () { return $edee716575af04c0$export$d02631cccf789723; });
$parcel$export(module.exports, "unprepend", function () { return $edee716575af04c0$export$c04edabe9c8d994f; });
$parcel$export(module.exports, "unappend", function () { return $edee716575af04c0$export$89a97afc72a83708; });
$parcel$export(module.exports, "init", function () { return $edee716575af04c0$export$2cd8252107eb640b; });
$parcel$export(module.exports, "last", function () { return $edee716575af04c0$export$4c7897fafd92b108; });
$parcel$export(module.exports, "fromArray", function () { return $edee716575af04c0$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "concatW", function () { return $edee716575af04c0$export$c8c959650bbe80e2; });
$parcel$export(module.exports, "reverse", function () { return $edee716575af04c0$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "group", function () { return $edee716575af04c0$export$e5e25fbcc1f7affe; });
$parcel$export(module.exports, "groupBy", function () { return $edee716575af04c0$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "updateAt", function () { return $edee716575af04c0$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $edee716575af04c0$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "zipWith", function () { return $edee716575af04c0$export$b634740ce272acb5; });
$parcel$export(module.exports, "zip", function () { return $edee716575af04c0$export$8901015135f2fb22; });
$parcel$export(module.exports, "unzip", function () { return $edee716575af04c0$export$23c8d3f8757cab88; });
$parcel$export(module.exports, "prependAll", function () { return $edee716575af04c0$export$849c7567cbd62acc; });
$parcel$export(module.exports, "intersperse", function () { return $edee716575af04c0$export$af200dcf8b7cb5de; });
$parcel$export(module.exports, "chainWithIndex", function () { return $edee716575af04c0$export$852cd95c2dfc239; });
$parcel$export(module.exports, "chop", function () { return $edee716575af04c0$export$433fe05b12ba833f; });
$parcel$export(module.exports, "chunksOf", function () { return $edee716575af04c0$export$2f0184d5df52135f; });
$parcel$export(module.exports, "map", function () { return $edee716575af04c0$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithIndex", function () { return $edee716575af04c0$export$8f07ddce13659f50; });
$parcel$export(module.exports, "ap", function () { return $edee716575af04c0$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "extend", function () { return $edee716575af04c0$export$8b58be045bf06082; });
$parcel$export(module.exports, "reduce", function () { return $edee716575af04c0$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $edee716575af04c0$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $edee716575af04c0$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $edee716575af04c0$export$df3f009e3d155b20; });
$parcel$export(module.exports, "alt", function () { return $edee716575af04c0$export$228be17d80722ab; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $edee716575af04c0$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $edee716575af04c0$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $edee716575af04c0$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "traverseWithIndex", function () { return $edee716575af04c0$export$955fdc0d24efa249; });
$parcel$export(module.exports, "of", function () { return $edee716575af04c0$export$ba255e9e49e00608; });
$parcel$export(module.exports, "altW", function () { return $edee716575af04c0$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "flatMap", function () { return $edee716575af04c0$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "duplicate", function () { return $edee716575af04c0$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "flatten", function () { return $edee716575af04c0$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "sequence", function () { return $edee716575af04c0$export$49bb65c2ea163039; });
$parcel$export(module.exports, "extract", function () { return $edee716575af04c0$export$f9380c9a627682d3; });
$parcel$export(module.exports, "URI", function () { return $edee716575af04c0$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $edee716575af04c0$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getSemigroup", function () { return $edee716575af04c0$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getEq", function () { return $edee716575af04c0$export$804fed467fde44e4; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $edee716575af04c0$export$baca17b4aff42f82; });
$parcel$export(module.exports, "Functor", function () { return $edee716575af04c0$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $edee716575af04c0$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $edee716575af04c0$export$59a71046037e6c20; });
$parcel$export(module.exports, "FunctorWithIndex", function () { return $edee716575af04c0$export$9fdffe0fe1e91cad; });
$parcel$export(module.exports, "Apply", function () { return $edee716575af04c0$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "apFirst", function () { return $edee716575af04c0$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $edee716575af04c0$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "Applicative", function () { return $edee716575af04c0$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $edee716575af04c0$export$f18d5acc27d70423; });
$parcel$export(module.exports, "chainFirst", function () { return $edee716575af04c0$export$e3821ef4970c339c; });
$parcel$export(module.exports, "Monad", function () { return $edee716575af04c0$export$fb641926d034ac7d; });
$parcel$export(module.exports, "Foldable", function () { return $edee716575af04c0$export$41404b31838667c9; });
$parcel$export(module.exports, "FoldableWithIndex", function () { return $edee716575af04c0$export$e8f7d17aaff345cb; });
$parcel$export(module.exports, "Traversable", function () { return $edee716575af04c0$export$a0202666c3bda011; });
$parcel$export(module.exports, "TraversableWithIndex", function () { return $edee716575af04c0$export$bd7b528d8c36ec41; });
$parcel$export(module.exports, "Alt", function () { return $edee716575af04c0$export$25ba4469a069167; });
$parcel$export(module.exports, "Comonad", function () { return $edee716575af04c0$export$fdd73124b9f1de36; });
$parcel$export(module.exports, "Do", function () { return $edee716575af04c0$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $edee716575af04c0$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $edee716575af04c0$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $edee716575af04c0$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $edee716575af04c0$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "min", function () { return $edee716575af04c0$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $edee716575af04c0$export$8960430cfd85939f; });
$parcel$export(module.exports, "concatAll", function () { return $edee716575af04c0$export$b314777ae20abca9; });
$parcel$export(module.exports, "matchLeft", function () { return $edee716575af04c0$export$6280271dfaec4919; });
$parcel$export(module.exports, "matchRight", function () { return $edee716575af04c0$export$b1cacb83a5c6bd02; });
$parcel$export(module.exports, "modifyHead", function () { return $edee716575af04c0$export$5c7327d4e64ef2aa; });
$parcel$export(module.exports, "updateHead", function () { return $edee716575af04c0$export$20ca6ad9f7762931; });
$parcel$export(module.exports, "modifyLast", function () { return $edee716575af04c0$export$302ad361c463800a; });
$parcel$export(module.exports, "updateLast", function () { return $edee716575af04c0$export$d3affa0a0a83d946; });
$parcel$export(module.exports, "intercalate", function () { return $edee716575af04c0$export$739ec22334c44788; });
$parcel$export(module.exports, "chain", function () { return $edee716575af04c0$export$e08e3b67e392101e; });
$parcel$export(module.exports, "groupSort", function () { return $edee716575af04c0$export$103ce2c0a67e4e61; });
$parcel$export(module.exports, "filter", function () { return $edee716575af04c0$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterWithIndex", function () { return $edee716575af04c0$export$36e42aef19fc7171; });
$parcel$export(module.exports, "uncons", function () { return $edee716575af04c0$export$b446f6baa3bb1430; });
$parcel$export(module.exports, "unsnoc", function () { return $edee716575af04c0$export$712962e076096ed4; });
$parcel$export(module.exports, "cons", function () { return $edee716575af04c0$export$8327ebbef2a0ba76; });
$parcel$export(module.exports, "snoc", function () { return $edee716575af04c0$export$c40cf5aab899f397; });
$parcel$export(module.exports, "insertAt", function () { return $edee716575af04c0$export$9f200c4466975173; });
$parcel$export(module.exports, "prependToAll", function () { return $edee716575af04c0$export$baeb00bf1e27e233; });
$parcel$export(module.exports, "fold", function () { return $edee716575af04c0$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "readonlyNonEmptyArray", function () { return $edee716575af04c0$export$3c6c57333e3dca24; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $hOuM2 = parcelRequire("hOuM2");

var $flrom = parcelRequire("flrom");
var $edee716575af04c0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $edee716575af04c0$export$6e22c362a0406a2c = $lOGTm.emptyReadonlyArray;
var $edee716575af04c0$export$a978c53b4062a525 = $lOGTm.isNonEmpty;
var $edee716575af04c0$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $edee716575af04c0$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $edee716575af04c0$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $edee716575af04c0$export$68159836694e22c1 = $edee716575af04c0$export$c4c4d41eab625797;
var $edee716575af04c0$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $edee716575af04c0$var$__spreadArray($edee716575af04c0$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $edee716575af04c0$export$10d8903dec122b9d = $edee716575af04c0$export$19903a1bf1942f6;
var $edee716575af04c0$export$f4863e1822a1860c = function(i, a, as) {
    if ($edee716575af04c0$export$a978c53b4062a525(as)) {
        var xs = $lOGTm.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $edee716575af04c0$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $lOGTm.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
var $edee716575af04c0$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $edee716575af04c0$export$5fd5031fecdacec3(as)
        ];
        var rest = $edee716575af04c0$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $edee716575af04c0$export$b035e44d7bb4278f = function(ords) {
    if ($edee716575af04c0$export$a978c53b4062a525(ords)) {
        var M = (0, $hOuM2.getMonoid)();
        return $edee716575af04c0$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $kj6DU.identity;
};
var $edee716575af04c0$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $edee716575af04c0$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $kj6DU.pipe)(first, $edee716575af04c0$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $edee716575af04c0$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($edee716575af04c0$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $edee716575af04c0$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $kj6DU.pipe)(s, $edee716575af04c0$export$ee1b3e54f0441b22(f));
        } else return $edee716575af04c0$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $edee716575af04c0$export$9288e031f1846591 = function(as) {
    return $edee716575af04c0$export$a978c53b4062a525(as) ? $lOGTm.some(as) : $lOGTm.none;
};
var $edee716575af04c0$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $edee716575af04c0$export$606959e7ccb797f0 = function(a) {
    return $edee716575af04c0$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $edee716575af04c0$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $edee716575af04c0$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $edee716575af04c0$export$c04edabe9c8d994f = function(as) {
    return [
        $edee716575af04c0$export$5fd5031fecdacec3(as),
        $edee716575af04c0$export$c01875f616615628(as)
    ];
};
var $edee716575af04c0$export$89a97afc72a83708 = function(as) {
    return [
        $edee716575af04c0$export$2cd8252107eb640b(as),
        $edee716575af04c0$export$4c7897fafd92b108(as)
    ];
};
var $edee716575af04c0$export$571d59b505e6bb4e = function(as) {
    return $edee716575af04c0$export$9288e031f1846591(as.slice());
};
function $edee716575af04c0$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $edee716575af04c0$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $edee716575af04c0$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $edee716575af04c0$var$__spreadArray([
        $edee716575af04c0$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $edee716575af04c0$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $edee716575af04c0$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $edee716575af04c0$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($lOGTm.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $edee716575af04c0$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $edee716575af04c0$export$b6d8713d53419d4c = function(i, a) {
    return $edee716575af04c0$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $edee716575af04c0$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $edee716575af04c0$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some($edee716575af04c0$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $edee716575af04c0$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $edee716575af04c0$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $edee716575af04c0$export$8901015135f2fb22(bs, as);
    };
    return $edee716575af04c0$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $edee716575af04c0$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $edee716575af04c0$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $edee716575af04c0$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $edee716575af04c0$export$c01875f616615628(as);
        return $edee716575af04c0$export$a978c53b4062a525(rest) ? (0, $kj6DU.pipe)(rest, $edee716575af04c0$export$849c7567cbd62acc(middle), $edee716575af04c0$export$68159836694e22c1($edee716575af04c0$export$5fd5031fecdacec3(as))) : as;
    };
};
var $edee716575af04c0$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $lOGTm.fromReadonlyNonEmptyArray(f(0, $edee716575af04c0$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $edee716575af04c0$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($edee716575af04c0$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $edee716575af04c0$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $edee716575af04c0$export$6e22c362a0406a2c
        ] : [
            (0, $kj6DU.pipe)(as.slice(1, m), $edee716575af04c0$export$68159836694e22c1($edee716575af04c0$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $edee716575af04c0$export$2f0184d5df52135f = function(n) {
    return $edee716575af04c0$export$433fe05b12ba833f($edee716575af04c0$export$b0d75975ac0be0e1(n));
};
var $edee716575af04c0$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_mapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$8f07ddce13659f50(f));
};
var $edee716575af04c0$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $edee716575af04c0$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_extend = function(wa, f) {
    return (0, $kj6DU.pipe)(wa, $edee716575af04c0$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_foldMap = function(M) {
    var foldMapM = $edee716575af04c0$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $edee716575af04c0$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_traverse = function(F) {
    var traverseF = $edee716575af04c0$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $edee716575af04c0$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $edee716575af04c0$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $edee716575af04c0$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $edee716575af04c0$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $edee716575af04c0$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $edee716575af04c0$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseWithIndexF(f));
    };
};
var $edee716575af04c0$export$ba255e9e49e00608 = $lOGTm.singleton;
var $edee716575af04c0$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $kj6DU.pipe)(as, $edee716575af04c0$export$c8c959650bbe80e2(that()));
    };
};
var $edee716575af04c0$export$228be17d80722ab = $edee716575af04c0$export$1517cca7889d6aaa;
var $edee716575af04c0$export$2f6ca3d3b1f80bf5 = function(as) {
    return $edee716575af04c0$export$5b8affa63fc6df16(function(f) {
        return (0, $kj6DU.pipe)(as, $edee716575af04c0$export$871de8747c9eaa88(f));
    });
};
var $edee716575af04c0$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return (0, $kj6DU.pipe)(ma, $edee716575af04c0$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $edee716575af04c0$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $edee716575af04c0$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($edee716575af04c0$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $edee716575af04c0$export$c01875f616615628(next);
        }
        return out;
    };
};
var $edee716575af04c0$export$ecd5e8ace626722c = /*#__PURE__*/ $edee716575af04c0$export$8b58be045bf06082((0, $kj6DU.identity));
var $edee716575af04c0$export$bffa455ba8c619a6 = /*#__PURE__*/ $edee716575af04c0$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $edee716575af04c0$export$871de8747c9eaa88 = function(f) {
    return $edee716575af04c0$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $edee716575af04c0$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $edee716575af04c0$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $edee716575af04c0$export$533b26079ad0b4b = function(b, f) {
    return $edee716575af04c0$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $edee716575af04c0$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $edee716575af04c0$export$7fef8bcdbb34f435 = function(b, f) {
    return $edee716575af04c0$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $edee716575af04c0$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $edee716575af04c0$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $edee716575af04c0$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $edee716575af04c0$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $edee716575af04c0$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $edee716575af04c0$export$49bb65c2ea163039 = function(F) {
    return $edee716575af04c0$export$955fdc0d24efa249(F)((0, $kj6DU.SK));
};
var $edee716575af04c0$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $edee716575af04c0$export$5fd5031fecdacec3(as)), $edee716575af04c0$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $kj6DU.pipe)(bs, $edee716575af04c0$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $edee716575af04c0$export$f9380c9a627682d3 = $lOGTm.head;
var $edee716575af04c0$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $edee716575af04c0$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $edee716575af04c0$export$e759a9a7f8d04692 = function() {
    return {
        concat: $edee716575af04c0$export$ee1b3e54f0441b22
    };
};
var $edee716575af04c0$export$804fed467fde44e4 = function(E) {
    return (0, $9RyKW.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $edee716575af04c0$export$baca17b4aff42f82 = function(E) {
    var unionE = $edee716575af04c0$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $edee716575af04c0$export$bd5b6bfc5fa2ee61 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map
};
var $edee716575af04c0$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($edee716575af04c0$export$bd5b6bfc5fa2ee61);
var $edee716575af04c0$export$59a71046037e6c20 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    of: $edee716575af04c0$export$ba255e9e49e00608
};
var $edee716575af04c0$export$9fdffe0fe1e91cad = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    mapWithIndex: $edee716575af04c0$var$_mapWithIndex
};
var $edee716575af04c0$export$efc21ddc6aeb363d = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    ap: $edee716575af04c0$var$_ap
};
var $edee716575af04c0$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($edee716575af04c0$export$efc21ddc6aeb363d);
var $edee716575af04c0$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($edee716575af04c0$export$efc21ddc6aeb363d);
var $edee716575af04c0$export$1279d2b7807629fd = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    ap: $edee716575af04c0$var$_ap,
    of: $edee716575af04c0$export$ba255e9e49e00608
};
var $edee716575af04c0$export$f18d5acc27d70423 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    ap: $edee716575af04c0$var$_ap,
    chain: $edee716575af04c0$export$5b8affa63fc6df16
};
var $edee716575af04c0$export$e3821ef4970c339c = /*#__PURE__*/ (0, $dya6d.chainFirst)($edee716575af04c0$export$f18d5acc27d70423);
var $edee716575af04c0$export$fb641926d034ac7d = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    ap: $edee716575af04c0$var$_ap,
    of: $edee716575af04c0$export$ba255e9e49e00608,
    chain: $edee716575af04c0$export$5b8affa63fc6df16
};
var $edee716575af04c0$export$41404b31838667c9 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    reduce: $edee716575af04c0$var$_reduce,
    foldMap: $edee716575af04c0$var$_foldMap,
    reduceRight: $edee716575af04c0$var$_reduceRight
};
var $edee716575af04c0$export$e8f7d17aaff345cb = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    reduce: $edee716575af04c0$var$_reduce,
    foldMap: $edee716575af04c0$var$_foldMap,
    reduceRight: $edee716575af04c0$var$_reduceRight,
    reduceWithIndex: $edee716575af04c0$var$_reduceWithIndex,
    foldMapWithIndex: $edee716575af04c0$var$_foldMapWithIndex,
    reduceRightWithIndex: $edee716575af04c0$var$_reduceRightWithIndex
};
var $edee716575af04c0$export$a0202666c3bda011 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    reduce: $edee716575af04c0$var$_reduce,
    foldMap: $edee716575af04c0$var$_foldMap,
    reduceRight: $edee716575af04c0$var$_reduceRight,
    traverse: $edee716575af04c0$var$_traverse,
    sequence: $edee716575af04c0$export$49bb65c2ea163039
};
var $edee716575af04c0$export$bd7b528d8c36ec41 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    mapWithIndex: $edee716575af04c0$var$_mapWithIndex,
    reduce: $edee716575af04c0$var$_reduce,
    foldMap: $edee716575af04c0$var$_foldMap,
    reduceRight: $edee716575af04c0$var$_reduceRight,
    traverse: $edee716575af04c0$var$_traverse,
    sequence: $edee716575af04c0$export$49bb65c2ea163039,
    reduceWithIndex: $edee716575af04c0$var$_reduceWithIndex,
    foldMapWithIndex: $edee716575af04c0$var$_foldMapWithIndex,
    reduceRightWithIndex: $edee716575af04c0$var$_reduceRightWithIndex,
    traverseWithIndex: $edee716575af04c0$var$_traverseWithIndex
};
var $edee716575af04c0$export$25ba4469a069167 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    alt: $edee716575af04c0$var$_alt
};
var $edee716575af04c0$export$fdd73124b9f1de36 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    map: $edee716575af04c0$var$_map,
    extend: $edee716575af04c0$var$_extend,
    extract: $edee716575af04c0$export$f9380c9a627682d3
};
var $edee716575af04c0$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $edee716575af04c0$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $edee716575af04c0$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($edee716575af04c0$export$bd5b6bfc5fa2ee61);
var $edee716575af04c0$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($edee716575af04c0$export$bd5b6bfc5fa2ee61);
var $edee716575af04c0$export$2385a24977818dd0 = /*#__PURE__*/ (0, $dya6d.bind)($edee716575af04c0$export$f18d5acc27d70423);
var $edee716575af04c0$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($edee716575af04c0$export$efc21ddc6aeb363d);
var $edee716575af04c0$export$5fd5031fecdacec3 = $edee716575af04c0$export$f9380c9a627682d3;
var $edee716575af04c0$export$c01875f616615628 = $lOGTm.tail;
var $edee716575af04c0$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $edee716575af04c0$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $edee716575af04c0$export$96ec731ed4dcb222 = function(O) {
    var S = $flrom.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $edee716575af04c0$export$8960430cfd85939f = function(O) {
    var S = $flrom.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $edee716575af04c0$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $edee716575af04c0$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($edee716575af04c0$export$5fd5031fecdacec3(as), $edee716575af04c0$export$c01875f616615628(as));
    };
};
var $edee716575af04c0$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($edee716575af04c0$export$2cd8252107eb640b(as), $edee716575af04c0$export$4c7897fafd92b108(as));
    };
};
var $edee716575af04c0$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $edee716575af04c0$var$__spreadArray([
            f($edee716575af04c0$export$5fd5031fecdacec3(as))
        ], $edee716575af04c0$export$c01875f616615628(as), true);
    };
};
var $edee716575af04c0$export$20ca6ad9f7762931 = function(a) {
    return $edee716575af04c0$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $edee716575af04c0$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $kj6DU.pipe)($edee716575af04c0$export$2cd8252107eb640b(as), $edee716575af04c0$export$10d8903dec122b9d(f($edee716575af04c0$export$4c7897fafd92b108(as))));
    };
};
var $edee716575af04c0$export$d3affa0a0a83d946 = function(a) {
    return $edee716575af04c0$export$302ad361c463800a(function() {
        return a;
    });
};
var $edee716575af04c0$export$739ec22334c44788 = function(S) {
    var concatAllS = $edee716575af04c0$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $kj6DU.flow)($edee716575af04c0$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $edee716575af04c0$export$e08e3b67e392101e = $edee716575af04c0$export$5b8affa63fc6df16;
function $edee716575af04c0$export$103ce2c0a67e4e61(O) {
    var sortO = $edee716575af04c0$export$97db5808d8f88186(O);
    var groupO = $edee716575af04c0$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $edee716575af04c0$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $edee716575af04c0$export$6e22c362a0406a2c;
    };
}
function $edee716575af04c0$export$3dea766d36a8935f(predicate) {
    return $edee716575af04c0$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $edee716575af04c0$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $edee716575af04c0$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $edee716575af04c0$export$b446f6baa3bb1430 = $edee716575af04c0$export$c04edabe9c8d994f;
var $edee716575af04c0$export$712962e076096ed4 = $edee716575af04c0$export$89a97afc72a83708;
function $edee716575af04c0$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $edee716575af04c0$export$68159836694e22c1(head) : (0, $kj6DU.pipe)(tail, $edee716575af04c0$export$68159836694e22c1(head));
}
var $edee716575af04c0$export$c40cf5aab899f397 = function(init, end) {
    return (0, $kj6DU.pipe)(init, $edee716575af04c0$export$ee1b3e54f0441b22([
        end
    ]));
};
var $edee716575af04c0$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $lOGTm.none : $lOGTm.some($edee716575af04c0$export$f4863e1822a1860c(i, a, as));
    };
};
var $edee716575af04c0$export$baeb00bf1e27e233 = $edee716575af04c0$export$849c7567cbd62acc;
var $edee716575af04c0$export$93e2b83da34ff82a = $edee716575af04c0$export$b314777ae20abca9;
var $edee716575af04c0$export$3c6c57333e3dca24 = {
    URI: $edee716575af04c0$export$9156e739aa33e19f,
    of: $edee716575af04c0$export$ba255e9e49e00608,
    map: $edee716575af04c0$var$_map,
    mapWithIndex: $edee716575af04c0$var$_mapWithIndex,
    ap: $edee716575af04c0$var$_ap,
    chain: $edee716575af04c0$export$5b8affa63fc6df16,
    extend: $edee716575af04c0$var$_extend,
    extract: $edee716575af04c0$export$f9380c9a627682d3,
    reduce: $edee716575af04c0$var$_reduce,
    foldMap: $edee716575af04c0$var$_foldMap,
    reduceRight: $edee716575af04c0$var$_reduceRight,
    traverse: $edee716575af04c0$var$_traverse,
    sequence: $edee716575af04c0$export$49bb65c2ea163039,
    reduceWithIndex: $edee716575af04c0$var$_reduceWithIndex,
    foldMapWithIndex: $edee716575af04c0$var$_foldMapWithIndex,
    reduceRightWithIndex: $edee716575af04c0$var$_reduceRightWithIndex,
    traverseWithIndex: $edee716575af04c0$var$_traverseWithIndex,
    alt: $edee716575af04c0$var$_alt
};

});
parcelRegister("flrom", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $b2be109fd2828fbe$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $b2be109fd2828fbe$export$8960430cfd85939f; });
$parcel$export(module.exports, "constant", function () { return $b2be109fd2828fbe$export$c983f826f44ff86; });
$parcel$export(module.exports, "reverse", function () { return $b2be109fd2828fbe$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "struct", function () { return $b2be109fd2828fbe$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "tuple", function () { return $b2be109fd2828fbe$export$65e3907585753458; });
$parcel$export(module.exports, "intercalate", function () { return $b2be109fd2828fbe$export$739ec22334c44788; });
$parcel$export(module.exports, "first", function () { return $b2be109fd2828fbe$export$43128fadae87b74a; });
$parcel$export(module.exports, "last", function () { return $b2be109fd2828fbe$export$4c7897fafd92b108; });
$parcel$export(module.exports, "concatAll", function () { return $b2be109fd2828fbe$export$b314777ae20abca9; });
$parcel$export(module.exports, "semigroupVoid", function () { return $b2be109fd2828fbe$export$36aabcd6b6e45f3b; });
$parcel$export(module.exports, "getObjectSemigroup", function () { return $b2be109fd2828fbe$export$2f965793fef2fb8a; });
$parcel$export(module.exports, "getLastSemigroup", function () { return $b2be109fd2828fbe$export$edb0acd3f464ffc5; });
$parcel$export(module.exports, "getFirstSemigroup", function () { return $b2be109fd2828fbe$export$84a57d7a8bf6c3ea; });
$parcel$export(module.exports, "getTupleSemigroup", function () { return $b2be109fd2828fbe$export$bd94daf2735ef9c; });
$parcel$export(module.exports, "getStructSemigroup", function () { return $b2be109fd2828fbe$export$98d1814f8ed74e13; });
$parcel$export(module.exports, "getDualSemigroup", function () { return $b2be109fd2828fbe$export$e0cea6c43ec66a1; });
$parcel$export(module.exports, "getJoinSemigroup", function () { return $b2be109fd2828fbe$export$4278e54cd9769e6d; });
$parcel$export(module.exports, "getMeetSemigroup", function () { return $b2be109fd2828fbe$export$7baccd77d16d1a41; });
$parcel$export(module.exports, "getIntercalateSemigroup", function () { return $b2be109fd2828fbe$export$fcc2cca196b2daf0; });
$parcel$export(module.exports, "fold", function () { return $b2be109fd2828fbe$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "semigroupAll", function () { return $b2be109fd2828fbe$export$e8f9875ab703bdff; });
$parcel$export(module.exports, "semigroupAny", function () { return $b2be109fd2828fbe$export$9511aba5be5ac81b; });
$parcel$export(module.exports, "getFunctionSemigroup", function () { return $b2be109fd2828fbe$export$b2ecf5de014857c2; });
$parcel$export(module.exports, "semigroupString", function () { return $b2be109fd2828fbe$export$d9b7100b101f2c5b; });
$parcel$export(module.exports, "semigroupSum", function () { return $b2be109fd2828fbe$export$1481126044ad2de0; });
$parcel$export(module.exports, "semigroupProduct", function () { return $b2be109fd2828fbe$export$a22a2283cc3aa839; });
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 
var $kj6DU = parcelRequire("kj6DU");

var $lOGTm = parcelRequire("lOGTm");

var $lvGzd = parcelRequire("lvGzd");

var $hOuM2 = parcelRequire("hOuM2");
var $b2be109fd2828fbe$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $hOuM2.min(O)
    };
};
var $b2be109fd2828fbe$export$8960430cfd85939f = function(O) {
    return {
        concat: $hOuM2.max(O)
    };
};
var $b2be109fd2828fbe$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $b2be109fd2828fbe$export$66c1ae025e96b4bc = $lvGzd.reverse;
var $b2be109fd2828fbe$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($lOGTm.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $b2be109fd2828fbe$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $b2be109fd2828fbe$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $b2be109fd2828fbe$export$43128fadae87b74a = function() {
    return {
        concat: (0, $kj6DU.identity)
    };
};
var $b2be109fd2828fbe$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $b2be109fd2828fbe$export$b314777ae20abca9 = $lvGzd.concatAll;
var $b2be109fd2828fbe$export$36aabcd6b6e45f3b = $b2be109fd2828fbe$export$c983f826f44ff86(undefined);
var $b2be109fd2828fbe$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $b2be109fd2828fbe$export$edb0acd3f464ffc5 = $b2be109fd2828fbe$export$4c7897fafd92b108;
var $b2be109fd2828fbe$export$84a57d7a8bf6c3ea = $b2be109fd2828fbe$export$43128fadae87b74a;
var $b2be109fd2828fbe$export$bd94daf2735ef9c = $b2be109fd2828fbe$export$65e3907585753458;
var $b2be109fd2828fbe$export$98d1814f8ed74e13 = $b2be109fd2828fbe$export$8cf3da7c1c9174ea;
var $b2be109fd2828fbe$export$e0cea6c43ec66a1 = $b2be109fd2828fbe$export$66c1ae025e96b4bc;
var $b2be109fd2828fbe$export$4278e54cd9769e6d = $b2be109fd2828fbe$export$8960430cfd85939f;
var $b2be109fd2828fbe$export$7baccd77d16d1a41 = $b2be109fd2828fbe$export$96ec731ed4dcb222;
var $b2be109fd2828fbe$export$fcc2cca196b2daf0 = $b2be109fd2828fbe$export$739ec22334c44788;
function $b2be109fd2828fbe$export$93e2b83da34ff82a(S) {
    var concatAllS = $b2be109fd2828fbe$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $b2be109fd2828fbe$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $b2be109fd2828fbe$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $b2be109fd2828fbe$export$b2ecf5de014857c2 = (0, $kj6DU.getSemigroup);
var $b2be109fd2828fbe$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $b2be109fd2828fbe$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $b2be109fd2828fbe$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("lvGzd", function(module, exports) {

$parcel$export(module.exports, "reverse", function () { return $fa8d832529fabc9c$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "concatAll", function () { return $fa8d832529fabc9c$export$b314777ae20abca9; });
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $fa8d832529fabc9c$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $fa8d832529fabc9c$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $fa8d832529fabc9c$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $fa8d832529fabc9c$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $fa8d832529fabc9c$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};

});




parcelRegister("f0bNW", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $aec0033bd8fc24cf$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "isNonEmpty", function () { return $aec0033bd8fc24cf$export$a978c53b4062a525; });
$parcel$export(module.exports, "prepend", function () { return $aec0033bd8fc24cf$export$68159836694e22c1; });
$parcel$export(module.exports, "prependW", function () { return $aec0033bd8fc24cf$export$c4c4d41eab625797; });
$parcel$export(module.exports, "append", function () { return $aec0033bd8fc24cf$export$10d8903dec122b9d; });
$parcel$export(module.exports, "appendW", function () { return $aec0033bd8fc24cf$export$19903a1bf1942f6; });
$parcel$export(module.exports, "makeBy", function () { return $aec0033bd8fc24cf$export$849fbdcc2211fcde; });
$parcel$export(module.exports, "empty", function () { return $aec0033bd8fc24cf$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "replicate", function () { return $aec0033bd8fc24cf$export$606959e7ccb797f0; });
$parcel$export(module.exports, "fromPredicate", function () { return $aec0033bd8fc24cf$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromOption", function () { return $aec0033bd8fc24cf$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromEither", function () { return $aec0033bd8fc24cf$export$80c878c9b1d77917; });
$parcel$export(module.exports, "matchW", function () { return $aec0033bd8fc24cf$export$2d55ea551c238330; });
$parcel$export(module.exports, "match", function () { return $aec0033bd8fc24cf$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchLeftW", function () { return $aec0033bd8fc24cf$export$ebbe93aa91e3abdc; });
$parcel$export(module.exports, "matchLeft", function () { return $aec0033bd8fc24cf$export$6280271dfaec4919; });
$parcel$export(module.exports, "foldLeft", function () { return $aec0033bd8fc24cf$export$f3163a37d0ef5927; });
$parcel$export(module.exports, "matchRightW", function () { return $aec0033bd8fc24cf$export$364f7f2cc8473008; });
$parcel$export(module.exports, "matchRight", function () { return $aec0033bd8fc24cf$export$b1cacb83a5c6bd02; });
$parcel$export(module.exports, "foldRight", function () { return $aec0033bd8fc24cf$export$77fa89c00b331c4c; });
$parcel$export(module.exports, "chainWithIndex", function () { return $aec0033bd8fc24cf$export$852cd95c2dfc239; });
$parcel$export(module.exports, "scanLeft", function () { return $aec0033bd8fc24cf$export$555ac70de528b074; });
$parcel$export(module.exports, "scanRight", function () { return $aec0033bd8fc24cf$export$d799959bdf780177; });
$parcel$export(module.exports, "size", function () { return $aec0033bd8fc24cf$export$346677f925de839c; });
$parcel$export(module.exports, "isOutOfBound", function () { return $aec0033bd8fc24cf$export$2fde0b1c54fc39b9; });
$parcel$export(module.exports, "lookup", function () { return $aec0033bd8fc24cf$export$dfc7155ac0343b8; });
$parcel$export(module.exports, "head", function () { return $aec0033bd8fc24cf$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "last", function () { return $aec0033bd8fc24cf$export$4c7897fafd92b108; });
$parcel$export(module.exports, "tail", function () { return $aec0033bd8fc24cf$export$c01875f616615628; });
$parcel$export(module.exports, "init", function () { return $aec0033bd8fc24cf$export$2cd8252107eb640b; });
$parcel$export(module.exports, "takeLeft", function () { return $aec0033bd8fc24cf$export$8ea13dbc737d576b; });
$parcel$export(module.exports, "takeRight", function () { return $aec0033bd8fc24cf$export$1bbc425ddca7f2c6; });
$parcel$export(module.exports, "takeLeftWhile", function () { return $aec0033bd8fc24cf$export$5b0b82239a6f6d94; });
$parcel$export(module.exports, "spanLeft", function () { return $aec0033bd8fc24cf$export$104948d9b1d3fb14; });
$parcel$export(module.exports, "splitAt", function () { return $aec0033bd8fc24cf$export$b0d75975ac0be0e1; });
$parcel$export(module.exports, "dropLeft", function () { return $aec0033bd8fc24cf$export$738250583454396; });
$parcel$export(module.exports, "dropRight", function () { return $aec0033bd8fc24cf$export$6ba801e3e123536e; });
$parcel$export(module.exports, "dropLeftWhile", function () { return $aec0033bd8fc24cf$export$d265ccd398ee49c9; });
$parcel$export(module.exports, "findIndex", function () { return $aec0033bd8fc24cf$export$de3a4d4a0d731119; });
$parcel$export(module.exports, "findFirst", function () { return $aec0033bd8fc24cf$export$9a2f228bed5035c2; });
$parcel$export(module.exports, "findFirstMap", function () { return $aec0033bd8fc24cf$export$a86c11c94d794a95; });
$parcel$export(module.exports, "findLast", function () { return $aec0033bd8fc24cf$export$296de88ccac4bedb; });
$parcel$export(module.exports, "findLastMap", function () { return $aec0033bd8fc24cf$export$8b5e6d6ad82284fa; });
$parcel$export(module.exports, "findLastIndex", function () { return $aec0033bd8fc24cf$export$8855a8be7bd3e9f8; });
$parcel$export(module.exports, "insertAt", function () { return $aec0033bd8fc24cf$export$9f200c4466975173; });
$parcel$export(module.exports, "updateAt", function () { return $aec0033bd8fc24cf$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $aec0033bd8fc24cf$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "deleteAt", function () { return $aec0033bd8fc24cf$export$90f9093465da3136; });
$parcel$export(module.exports, "unsafeDeleteAt", function () { return $aec0033bd8fc24cf$export$4937fde8dfc38dbd; });
$parcel$export(module.exports, "unsafeUpdateAt", function () { return $aec0033bd8fc24cf$export$9c0c6889b1fa9bfc; });
$parcel$export(module.exports, "reverse", function () { return $aec0033bd8fc24cf$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "rights", function () { return $aec0033bd8fc24cf$export$cae945d60b6cbe50; });
$parcel$export(module.exports, "lefts", function () { return $aec0033bd8fc24cf$export$837c95301ebad184; });
$parcel$export(module.exports, "sort", function () { return $aec0033bd8fc24cf$export$97db5808d8f88186; });
$parcel$export(module.exports, "zipWith", function () { return $aec0033bd8fc24cf$export$b634740ce272acb5; });
$parcel$export(module.exports, "zip", function () { return $aec0033bd8fc24cf$export$8901015135f2fb22; });
$parcel$export(module.exports, "unzip", function () { return $aec0033bd8fc24cf$export$23c8d3f8757cab88; });
$parcel$export(module.exports, "prependAll", function () { return $aec0033bd8fc24cf$export$849c7567cbd62acc; });
$parcel$export(module.exports, "intersperse", function () { return $aec0033bd8fc24cf$export$af200dcf8b7cb5de; });
$parcel$export(module.exports, "rotate", function () { return $aec0033bd8fc24cf$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "elem", function () { return $aec0033bd8fc24cf$export$5bf96401662340b7; });
$parcel$export(module.exports, "uniq", function () { return $aec0033bd8fc24cf$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "sortBy", function () { return $aec0033bd8fc24cf$export$b035e44d7bb4278f; });
$parcel$export(module.exports, "chop", function () { return $aec0033bd8fc24cf$export$433fe05b12ba833f; });
$parcel$export(module.exports, "chunksOf", function () { return $aec0033bd8fc24cf$export$2f0184d5df52135f; });
$parcel$export(module.exports, "fromOptionK", function () { return $aec0033bd8fc24cf$export$a907462f448b49f8; });
$parcel$export(module.exports, "comprehension", function () { return $aec0033bd8fc24cf$export$105c199d42fdf965; });
$parcel$export(module.exports, "flatMap", function () { return $aec0033bd8fc24cf$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "concatW", function () { return $aec0033bd8fc24cf$export$c8c959650bbe80e2; });
$parcel$export(module.exports, "concat", function () { return $aec0033bd8fc24cf$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "union", function () { return $aec0033bd8fc24cf$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersection", function () { return $aec0033bd8fc24cf$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "difference", function () { return $aec0033bd8fc24cf$export$acaf96a27438246b; });
$parcel$export(module.exports, "map", function () { return $aec0033bd8fc24cf$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithIndex", function () { return $aec0033bd8fc24cf$export$8f07ddce13659f50; });
$parcel$export(module.exports, "ap", function () { return $aec0033bd8fc24cf$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "filter", function () { return $aec0033bd8fc24cf$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $aec0033bd8fc24cf$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "partition", function () { return $aec0033bd8fc24cf$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $aec0033bd8fc24cf$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "partitionWithIndex", function () { return $aec0033bd8fc24cf$export$dad5e500f2bab9bc; });
$parcel$export(module.exports, "partitionMapWithIndex", function () { return $aec0033bd8fc24cf$export$bc7c0794b9c6f3ba; });
$parcel$export(module.exports, "alt", function () { return $aec0033bd8fc24cf$export$228be17d80722ab; });
$parcel$export(module.exports, "reduce", function () { return $aec0033bd8fc24cf$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $aec0033bd8fc24cf$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $aec0033bd8fc24cf$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $aec0033bd8fc24cf$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $aec0033bd8fc24cf$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $aec0033bd8fc24cf$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "filterMapWithIndex", function () { return $aec0033bd8fc24cf$export$30c5cbe848021e97; });
$parcel$export(module.exports, "filterWithIndex", function () { return $aec0033bd8fc24cf$export$36e42aef19fc7171; });
$parcel$export(module.exports, "extend", function () { return $aec0033bd8fc24cf$export$8b58be045bf06082; });
$parcel$export(module.exports, "traverse", function () { return $aec0033bd8fc24cf$export$df3f009e3d155b20; });
$parcel$export(module.exports, "traverseWithIndex", function () { return $aec0033bd8fc24cf$export$955fdc0d24efa249; });
$parcel$export(module.exports, "_chainRecDepthFirst", function () { return $aec0033bd8fc24cf$export$c5c44f872d8af73; });
$parcel$export(module.exports, "chainRecDepthFirst", function () { return $aec0033bd8fc24cf$export$f855115a79f70c1a; });
$parcel$export(module.exports, "_chainRecBreadthFirst", function () { return $aec0033bd8fc24cf$export$b9909b62ceeab991; });
$parcel$export(module.exports, "chainRecBreadthFirst", function () { return $aec0033bd8fc24cf$export$bffee57bb00a6859; });
$parcel$export(module.exports, "of", function () { return $aec0033bd8fc24cf$export$ba255e9e49e00608; });
$parcel$export(module.exports, "zero", function () { return $aec0033bd8fc24cf$export$7f9972325ebfd559; });
$parcel$export(module.exports, "altW", function () { return $aec0033bd8fc24cf$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "flatten", function () { return $aec0033bd8fc24cf$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "separate", function () { return $aec0033bd8fc24cf$export$709f6946f4e97408; });
$parcel$export(module.exports, "compact", function () { return $aec0033bd8fc24cf$export$8e16b83750b44988; });
$parcel$export(module.exports, "duplicate", function () { return $aec0033bd8fc24cf$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "sequence", function () { return $aec0033bd8fc24cf$export$49bb65c2ea163039; });
$parcel$export(module.exports, "wither", function () { return $aec0033bd8fc24cf$export$6c36d01819ecdb31; });
$parcel$export(module.exports, "wilt", function () { return $aec0033bd8fc24cf$export$2439a3bc02b13b03; });
$parcel$export(module.exports, "unfold", function () { return $aec0033bd8fc24cf$export$c48e357c1a89b78d; });
$parcel$export(module.exports, "URI", function () { return $aec0033bd8fc24cf$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $aec0033bd8fc24cf$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getSemigroup", function () { return $aec0033bd8fc24cf$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $aec0033bd8fc24cf$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "getEq", function () { return $aec0033bd8fc24cf$export$804fed467fde44e4; });
$parcel$export(module.exports, "getOrd", function () { return $aec0033bd8fc24cf$export$1af51209b1b91d07; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $aec0033bd8fc24cf$export$baca17b4aff42f82; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $aec0033bd8fc24cf$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $aec0033bd8fc24cf$export$d379a869a72e4055; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $aec0033bd8fc24cf$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "Functor", function () { return $aec0033bd8fc24cf$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $aec0033bd8fc24cf$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $aec0033bd8fc24cf$export$59a71046037e6c20; });
$parcel$export(module.exports, "FunctorWithIndex", function () { return $aec0033bd8fc24cf$export$9fdffe0fe1e91cad; });
$parcel$export(module.exports, "Apply", function () { return $aec0033bd8fc24cf$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "apFirst", function () { return $aec0033bd8fc24cf$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $aec0033bd8fc24cf$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "Applicative", function () { return $aec0033bd8fc24cf$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $aec0033bd8fc24cf$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $aec0033bd8fc24cf$export$fb641926d034ac7d; });
$parcel$export(module.exports, "chainFirst", function () { return $aec0033bd8fc24cf$export$e3821ef4970c339c; });
$parcel$export(module.exports, "Unfoldable", function () { return $aec0033bd8fc24cf$export$8fa953f00d3b093; });
$parcel$export(module.exports, "Alt", function () { return $aec0033bd8fc24cf$export$25ba4469a069167; });
$parcel$export(module.exports, "Zero", function () { return $aec0033bd8fc24cf$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "guard", function () { return $aec0033bd8fc24cf$export$864d727b48066337; });
$parcel$export(module.exports, "Alternative", function () { return $aec0033bd8fc24cf$export$4acb47accde578d2; });
$parcel$export(module.exports, "Extend", function () { return $aec0033bd8fc24cf$export$5b5dd0e212d2a5bc; });
$parcel$export(module.exports, "Compactable", function () { return $aec0033bd8fc24cf$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $aec0033bd8fc24cf$export$d00e1c48fb621173; });
$parcel$export(module.exports, "FilterableWithIndex", function () { return $aec0033bd8fc24cf$export$c29a647071e542ec; });
$parcel$export(module.exports, "Foldable", function () { return $aec0033bd8fc24cf$export$41404b31838667c9; });
$parcel$export(module.exports, "FoldableWithIndex", function () { return $aec0033bd8fc24cf$export$e8f7d17aaff345cb; });
$parcel$export(module.exports, "Traversable", function () { return $aec0033bd8fc24cf$export$a0202666c3bda011; });
$parcel$export(module.exports, "TraversableWithIndex", function () { return $aec0033bd8fc24cf$export$bd7b528d8c36ec41; });
$parcel$export(module.exports, "ChainRecDepthFirst", function () { return $aec0033bd8fc24cf$export$7d808dfaa6d54634; });
$parcel$export(module.exports, "ChainRecBreadthFirst", function () { return $aec0033bd8fc24cf$export$57f3a385c7e59628; });
$parcel$export(module.exports, "Witherable", function () { return $aec0033bd8fc24cf$export$748d317b4c426f96; });
$parcel$export(module.exports, "filterE", function () { return $aec0033bd8fc24cf$export$c40604f35db61519; });
$parcel$export(module.exports, "FromEither", function () { return $aec0033bd8fc24cf$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "fromEitherK", function () { return $aec0033bd8fc24cf$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "unsafeInsertAt", function () { return $aec0033bd8fc24cf$export$f4863e1822a1860c; });
$parcel$export(module.exports, "toArray", function () { return $aec0033bd8fc24cf$export$45b10814cc054894; });
$parcel$export(module.exports, "fromArray", function () { return $aec0033bd8fc24cf$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "every", function () { return $aec0033bd8fc24cf$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "some", function () { return $aec0033bd8fc24cf$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "exists", function () { return $aec0033bd8fc24cf$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "intercalate", function () { return $aec0033bd8fc24cf$export$739ec22334c44788; });
$parcel$export(module.exports, "Do", function () { return $aec0033bd8fc24cf$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $aec0033bd8fc24cf$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $aec0033bd8fc24cf$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $aec0033bd8fc24cf$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $aec0033bd8fc24cf$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "chain", function () { return $aec0033bd8fc24cf$export$e08e3b67e392101e; });
$parcel$export(module.exports, "range", function () { return $aec0033bd8fc24cf$export$d02631cccf789723; });
$parcel$export(module.exports, "cons", function () { return $aec0033bd8fc24cf$export$8327ebbef2a0ba76; });
$parcel$export(module.exports, "snoc", function () { return $aec0033bd8fc24cf$export$c40cf5aab899f397; });
$parcel$export(module.exports, "prependToAll", function () { return $aec0033bd8fc24cf$export$baeb00bf1e27e233; });
$parcel$export(module.exports, "readonlyArray", function () { return $aec0033bd8fc24cf$export$95ca155af9fd5713; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $9RyKW = parcelRequire("9RyKW");

var $fgwhT = parcelRequire("fgwhT");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $cF6yJ = parcelRequire("cF6yJ");

var $hOuM2 = parcelRequire("hOuM2");

var $kqvcT = parcelRequire("kqvcT");

var $aRVRH = parcelRequire("aRVRH");

var $LdARg = parcelRequire("LdARg");

var $2GEXo = parcelRequire("2GEXo");
var $aec0033bd8fc24cf$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $aec0033bd8fc24cf$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $aec0033bd8fc24cf$export$a978c53b4062a525 = $kqvcT.isNonEmpty;
var $aec0033bd8fc24cf$export$68159836694e22c1 = $kqvcT.prepend;
var $aec0033bd8fc24cf$export$c4c4d41eab625797 = $kqvcT.prependW;
var $aec0033bd8fc24cf$export$10d8903dec122b9d = $kqvcT.append;
var $aec0033bd8fc24cf$export$19903a1bf1942f6 = $kqvcT.appendW;
var $aec0033bd8fc24cf$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : $kqvcT.makeBy(f)(n);
};
var $aec0033bd8fc24cf$export$606959e7ccb797f0 = function(n, a) {
    return $aec0033bd8fc24cf$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $aec0033bd8fc24cf$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $aec0033bd8fc24cf$export$6e22c362a0406a2c;
    };
}
var $aec0033bd8fc24cf$export$172ec0a6ebfeb6fa = function(ma) {
    return $lOGTm.isNone(ma) ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $aec0033bd8fc24cf$export$80c878c9b1d77917 = function(e) {
    return $lOGTm.isLeft(e) ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $aec0033bd8fc24cf$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $aec0033bd8fc24cf$export$4659b591c19bdf3d = $aec0033bd8fc24cf$export$2d55ea551c238330;
var $aec0033bd8fc24cf$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? onNonEmpty($kqvcT.head(as), $kqvcT.tail(as)) : onEmpty();
    };
};
var $aec0033bd8fc24cf$export$6280271dfaec4919 = $aec0033bd8fc24cf$export$ebbe93aa91e3abdc;
var $aec0033bd8fc24cf$export$f3163a37d0ef5927 = $aec0033bd8fc24cf$export$6280271dfaec4919;
var $aec0033bd8fc24cf$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? onNonEmpty($kqvcT.init(as), $kqvcT.last(as)) : onEmpty();
    };
};
var $aec0033bd8fc24cf$export$b1cacb83a5c6bd02 = $aec0033bd8fc24cf$export$364f7f2cc8473008;
var $aec0033bd8fc24cf$export$77fa89c00b331c4c = $aec0033bd8fc24cf$export$b1cacb83a5c6bd02;
var $aec0033bd8fc24cf$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($aec0033bd8fc24cf$export$dd1bc94b04021eeb(as)) return $aec0033bd8fc24cf$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $aec0033bd8fc24cf$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $aec0033bd8fc24cf$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $aec0033bd8fc24cf$export$346677f925de839c = function(as) {
    return as.length;
};
var $aec0033bd8fc24cf$export$2fde0b1c54fc39b9 = $kqvcT.isOutOfBound;
function $aec0033bd8fc24cf$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $aec0033bd8fc24cf$export$dfc7155ac0343b8(i, as);
    } : $aec0033bd8fc24cf$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some(as[i]);
}
var $aec0033bd8fc24cf$export$5fd5031fecdacec3 = function(as) {
    return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? $lOGTm.some($kqvcT.head(as)) : $lOGTm.none;
};
var $aec0033bd8fc24cf$export$4c7897fafd92b108 = function(as) {
    return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? $lOGTm.some($kqvcT.last(as)) : $lOGTm.none;
};
var $aec0033bd8fc24cf$export$c01875f616615628 = function(as) {
    return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? $lOGTm.some($kqvcT.tail(as)) : $lOGTm.none;
};
var $aec0033bd8fc24cf$export$2cd8252107eb640b = function(as) {
    return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? $lOGTm.some($kqvcT.init(as)) : $lOGTm.none;
};
var $aec0033bd8fc24cf$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $aec0033bd8fc24cf$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $aec0033bd8fc24cf$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $aec0033bd8fc24cf$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $aec0033bd8fc24cf$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : out;
    };
}
var $aec0033bd8fc24cf$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $aec0033bd8fc24cf$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $aec0033bd8fc24cf$export$b0d75975ac0be0e1($aec0033bd8fc24cf$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $aec0033bd8fc24cf$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $aec0033bd8fc24cf$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $aec0033bd8fc24cf$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $aec0033bd8fc24cf$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $aec0033bd8fc24cf$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $aec0033bd8fc24cf$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $aec0033bd8fc24cf$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $lOGTm.some(i);
        }
        return $lOGTm.none;
    };
};
function $aec0033bd8fc24cf$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $lOGTm.some(as[i]);
        }
        return $lOGTm.none;
    };
}
var $aec0033bd8fc24cf$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($lOGTm.isSome(out)) return out;
        }
        return $lOGTm.none;
    };
};
function $aec0033bd8fc24cf$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $lOGTm.some(as[i]);
        }
        return $lOGTm.none;
    };
}
var $aec0033bd8fc24cf$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($lOGTm.isSome(out)) return out;
        }
        return $lOGTm.none;
    };
};
var $aec0033bd8fc24cf$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $lOGTm.some(i);
        }
        return $lOGTm.none;
    };
};
var $aec0033bd8fc24cf$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $lOGTm.none : $lOGTm.some($kqvcT.unsafeInsertAt(i, a, as));
    };
};
var $aec0033bd8fc24cf$export$b6d8713d53419d4c = function(i, a) {
    return $aec0033bd8fc24cf$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $aec0033bd8fc24cf$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $aec0033bd8fc24cf$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some($aec0033bd8fc24cf$export$4937fde8dfc38dbd(i, as));
    };
};
var $aec0033bd8fc24cf$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $aec0033bd8fc24cf$export$2fde0b1c54fc39b9(i, as) ? $lOGTm.none : $lOGTm.some($aec0033bd8fc24cf$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $aec0033bd8fc24cf$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $aec0033bd8fc24cf$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $aec0033bd8fc24cf$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $aec0033bd8fc24cf$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $aec0033bd8fc24cf$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $aec0033bd8fc24cf$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $aec0033bd8fc24cf$export$8901015135f2fb22(bs, as);
    };
    return $aec0033bd8fc24cf$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $aec0033bd8fc24cf$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $aec0033bd8fc24cf$export$849c7567cbd62acc = function(middle) {
    var f = $kqvcT.prependAll(middle);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aec0033bd8fc24cf$export$af200dcf8b7cb5de = function(middle) {
    var f = $kqvcT.intersperse(middle);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aec0033bd8fc24cf$export$bb628a54ab399bc9 = function(n) {
    var f = $kqvcT.rotate(n);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $aec0033bd8fc24cf$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $aec0033bd8fc24cf$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $aec0033bd8fc24cf$export$f70730c3d1fc524e = function(E) {
    var f = $kqvcT.uniq(E);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aec0033bd8fc24cf$export$b035e44d7bb4278f = function(ords) {
    var f = $kqvcT.sortBy(ords);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aec0033bd8fc24cf$export$433fe05b12ba833f = function(f) {
    var g = $kqvcT.chop(f);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? g(as) : $aec0033bd8fc24cf$export$6e22c362a0406a2c;
    };
};
var $aec0033bd8fc24cf$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? $kqvcT.splitAt(n)(as) : $aec0033bd8fc24cf$export$dd1bc94b04021eeb(as) ? [
            as,
            $aec0033bd8fc24cf$export$6e22c362a0406a2c
        ] : [
            $aec0033bd8fc24cf$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $aec0033bd8fc24cf$export$2f0184d5df52135f = function(n) {
    var f = $kqvcT.chunksOf(n);
    return function(as) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? f(as) : $aec0033bd8fc24cf$export$6e22c362a0406a2c;
    };
};
var $aec0033bd8fc24cf$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $aec0033bd8fc24cf$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $aec0033bd8fc24cf$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $aec0033bd8fc24cf$export$a978c53b4062a525(input) ? $aec0033bd8fc24cf$export$5b8affa63fc6df16($kqvcT.head(input), function(a) {
            return go((0, $kj6DU.pipe)(scope, $aec0033bd8fc24cf$export$10d8903dec122b9d(a)), $kqvcT.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $aec0033bd8fc24cf$export$6e22c362a0406a2c;
    };
    return go($aec0033bd8fc24cf$export$6e22c362a0406a2c, input);
}
var $aec0033bd8fc24cf$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $aec0033bd8fc24cf$export$dd1bc94b04021eeb(first) ? second : $aec0033bd8fc24cf$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $aec0033bd8fc24cf$export$ee1b3e54f0441b22 = $aec0033bd8fc24cf$export$c8c959650bbe80e2;
function $aec0033bd8fc24cf$export$971dd5b0dfd021b6(E) {
    var unionE = $kqvcT.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $aec0033bd8fc24cf$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $aec0033bd8fc24cf$export$a978c53b4062a525(first) && $aec0033bd8fc24cf$export$a978c53b4062a525(second) ? unionE(second)(first) : $aec0033bd8fc24cf$export$a978c53b4062a525(first) ? first : second;
    };
}
function $aec0033bd8fc24cf$export$bc86dfbf7795668c(E) {
    var elemE = $aec0033bd8fc24cf$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $aec0033bd8fc24cf$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $aec0033bd8fc24cf$export$acaf96a27438246b(E) {
    var elemE = $aec0033bd8fc24cf$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $aec0033bd8fc24cf$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $aec0033bd8fc24cf$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$871de8747c9eaa88(f));
};
var $aec0033bd8fc24cf$var$_mapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$8f07ddce13659f50(f));
};
var $aec0033bd8fc24cf$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $aec0033bd8fc24cf$export$2f6ca3d3b1f80bf5(fa));
};
var $aec0033bd8fc24cf$var$_filter = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$3dea766d36a8935f(predicate));
};
var $aec0033bd8fc24cf$var$_filterMap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$a04c6c6965dd4709(f));
};
var $aec0033bd8fc24cf$var$_partition = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$b29f828819edca8d(predicate));
};
var $aec0033bd8fc24cf$var$_partitionMap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$3117e3f9ececb6bc(f));
};
var $aec0033bd8fc24cf$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $aec0033bd8fc24cf$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$bc7c0794b9c6f3ba(f));
};
var $aec0033bd8fc24cf$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$228be17d80722ab(that));
};
var $aec0033bd8fc24cf$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$533b26079ad0b4b(b, f));
};
var $aec0033bd8fc24cf$var$_foldMap = function(M) {
    var foldMapM = $aec0033bd8fc24cf$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
var $aec0033bd8fc24cf$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$7fef8bcdbb34f435(b, f));
};
var $aec0033bd8fc24cf$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$bbd3ef8720e22369(b, f));
};
var $aec0033bd8fc24cf$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $aec0033bd8fc24cf$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $aec0033bd8fc24cf$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$ce2b2fe0b88ccd0a(b, f));
};
var $aec0033bd8fc24cf$var$_filterMapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$30c5cbe848021e97(f));
};
var $aec0033bd8fc24cf$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$36e42aef19fc7171(predicateWithIndex));
};
var $aec0033bd8fc24cf$var$_extend = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$8b58be045bf06082(f));
};
var $aec0033bd8fc24cf$var$_traverse = function(F) {
    var traverseF = $aec0033bd8fc24cf$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $aec0033bd8fc24cf$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $aec0033bd8fc24cf$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseWithIndexF(f));
    };
};
var $aec0033bd8fc24cf$export$c5c44f872d8af73 = function(a, f) {
    return (0, $kj6DU.pipe)(a, $aec0033bd8fc24cf$export$f855115a79f70c1a(f));
};
var $aec0033bd8fc24cf$export$b9909b62ceeab991 = function(a, f) {
    return (0, $kj6DU.pipe)(a, $aec0033bd8fc24cf$export$bffee57bb00a6859(f));
};
var $aec0033bd8fc24cf$export$ba255e9e49e00608 = $kqvcT.of;
var $aec0033bd8fc24cf$export$7f9972325ebfd559 = function() {
    return $aec0033bd8fc24cf$export$6e22c362a0406a2c;
};
var $aec0033bd8fc24cf$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $aec0033bd8fc24cf$export$228be17d80722ab = $aec0033bd8fc24cf$export$1517cca7889d6aaa;
var $aec0033bd8fc24cf$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $aec0033bd8fc24cf$export$5b8affa63fc6df16(function(f) {
        return (0, $kj6DU.pipe)(fa, $aec0033bd8fc24cf$export$871de8747c9eaa88(f));
    });
};
var $aec0033bd8fc24cf$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return (0, $kj6DU.pipe)(ma, $aec0033bd8fc24cf$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $aec0033bd8fc24cf$export$bffa455ba8c619a6 = /*#__PURE__*/ $aec0033bd8fc24cf$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $aec0033bd8fc24cf$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $aec0033bd8fc24cf$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $aec0033bd8fc24cf$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $aRVRH.separated)(left, right);
};
var $aec0033bd8fc24cf$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $aec0033bd8fc24cf$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($lOGTm.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $aec0033bd8fc24cf$export$a04c6c6965dd4709 = function(f) {
    return $aec0033bd8fc24cf$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $aec0033bd8fc24cf$export$8e16b83750b44988 = /*#__PURE__*/ $aec0033bd8fc24cf$export$a04c6c6965dd4709((0, $kj6DU.identity));
var $aec0033bd8fc24cf$export$b29f828819edca8d = function(predicate) {
    return $aec0033bd8fc24cf$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $aec0033bd8fc24cf$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $aRVRH.separated)(left, right);
    };
};
var $aec0033bd8fc24cf$export$3117e3f9ececb6bc = function(f) {
    return $aec0033bd8fc24cf$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $aec0033bd8fc24cf$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $aRVRH.separated)(left, right);
    };
};
var $aec0033bd8fc24cf$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $aec0033bd8fc24cf$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $aec0033bd8fc24cf$export$ecd5e8ace626722c = /*#__PURE__*/ $aec0033bd8fc24cf$export$8b58be045bf06082((0, $kj6DU.identity));
var $aec0033bd8fc24cf$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $aec0033bd8fc24cf$export$533b26079ad0b4b = function(b, f) {
    return $aec0033bd8fc24cf$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $aec0033bd8fc24cf$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $aec0033bd8fc24cf$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $aec0033bd8fc24cf$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $aec0033bd8fc24cf$export$7fef8bcdbb34f435 = function(b, f) {
    return $aec0033bd8fc24cf$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $aec0033bd8fc24cf$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $aec0033bd8fc24cf$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $aec0033bd8fc24cf$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $aec0033bd8fc24cf$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $aec0033bd8fc24cf$var$_reduce(ta, F.of($aec0033bd8fc24cf$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $kj6DU.pipe)(as, $aec0033bd8fc24cf$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $aec0033bd8fc24cf$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $aec0033bd8fc24cf$export$bbd3ef8720e22369(F.of($aec0033bd8fc24cf$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $kj6DU.pipe)(bs, $aec0033bd8fc24cf$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $aec0033bd8fc24cf$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $aec0033bd8fc24cf$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $aec0033bd8fc24cf$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $aec0033bd8fc24cf$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $aec0033bd8fc24cf$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($lOGTm.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $aec0033bd8fc24cf$export$9156e739aa33e19f = 'ReadonlyArray';
var $aec0033bd8fc24cf$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $aec0033bd8fc24cf$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $aec0033bd8fc24cf$export$dd1bc94b04021eeb(first) ? second : $aec0033bd8fc24cf$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $aec0033bd8fc24cf$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $aec0033bd8fc24cf$export$e759a9a7f8d04692().concat,
        empty: $aec0033bd8fc24cf$export$6e22c362a0406a2c
    };
};
var $aec0033bd8fc24cf$export$804fed467fde44e4 = function(E) {
    return (0, $9RyKW.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $aec0033bd8fc24cf$export$1af51209b1b91d07 = function(O) {
    return (0, $hOuM2.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $cF6yJ.Ord.compare(aLen, bLen);
    });
};
var $aec0033bd8fc24cf$export$baca17b4aff42f82 = function(E) {
    var unionE = $aec0033bd8fc24cf$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $aec0033bd8fc24cf$export$c487aac9f4157837 = function(E) {
    return {
        concat: $aec0033bd8fc24cf$export$baca17b4aff42f82(E).concat,
        empty: $aec0033bd8fc24cf$export$6e22c362a0406a2c
    };
};
var $aec0033bd8fc24cf$export$d379a869a72e4055 = function(E) {
    var intersectionE = $aec0033bd8fc24cf$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $aec0033bd8fc24cf$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $aec0033bd8fc24cf$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $aec0033bd8fc24cf$export$bd5b6bfc5fa2ee61 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map
};
var $aec0033bd8fc24cf$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($aec0033bd8fc24cf$export$bd5b6bfc5fa2ee61);
var $aec0033bd8fc24cf$export$59a71046037e6c20 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    of: $aec0033bd8fc24cf$export$ba255e9e49e00608
};
var $aec0033bd8fc24cf$export$9fdffe0fe1e91cad = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    mapWithIndex: $aec0033bd8fc24cf$var$_mapWithIndex
};
var $aec0033bd8fc24cf$export$efc21ddc6aeb363d = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap
};
var $aec0033bd8fc24cf$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($aec0033bd8fc24cf$export$efc21ddc6aeb363d);
var $aec0033bd8fc24cf$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($aec0033bd8fc24cf$export$efc21ddc6aeb363d);
var $aec0033bd8fc24cf$export$1279d2b7807629fd = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    of: $aec0033bd8fc24cf$export$ba255e9e49e00608
};
var $aec0033bd8fc24cf$export$f18d5acc27d70423 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    chain: $aec0033bd8fc24cf$export$5b8affa63fc6df16
};
var $aec0033bd8fc24cf$export$fb641926d034ac7d = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    of: $aec0033bd8fc24cf$export$ba255e9e49e00608,
    chain: $aec0033bd8fc24cf$export$5b8affa63fc6df16
};
var $aec0033bd8fc24cf$export$e3821ef4970c339c = /*#__PURE__*/ (0, $dya6d.chainFirst)($aec0033bd8fc24cf$export$f18d5acc27d70423);
var $aec0033bd8fc24cf$export$8fa953f00d3b093 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    unfold: $aec0033bd8fc24cf$export$c48e357c1a89b78d
};
var $aec0033bd8fc24cf$export$25ba4469a069167 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    alt: $aec0033bd8fc24cf$var$_alt
};
var $aec0033bd8fc24cf$export$aaef8a3eae948f03 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    zero: $aec0033bd8fc24cf$export$7f9972325ebfd559
};
var $aec0033bd8fc24cf$export$864d727b48066337 = /*#__PURE__*/ (0, $2GEXo.guard)($aec0033bd8fc24cf$export$aaef8a3eae948f03, $aec0033bd8fc24cf$export$59a71046037e6c20);
var $aec0033bd8fc24cf$export$4acb47accde578d2 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    of: $aec0033bd8fc24cf$export$ba255e9e49e00608,
    alt: $aec0033bd8fc24cf$var$_alt,
    zero: $aec0033bd8fc24cf$export$7f9972325ebfd559
};
var $aec0033bd8fc24cf$export$5b5dd0e212d2a5bc = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    extend: $aec0033bd8fc24cf$var$_extend
};
var $aec0033bd8fc24cf$export$4a21ac48141ac3c9 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    compact: $aec0033bd8fc24cf$export$8e16b83750b44988,
    separate: $aec0033bd8fc24cf$export$709f6946f4e97408
};
var $aec0033bd8fc24cf$export$d00e1c48fb621173 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    compact: $aec0033bd8fc24cf$export$8e16b83750b44988,
    separate: $aec0033bd8fc24cf$export$709f6946f4e97408,
    filter: $aec0033bd8fc24cf$var$_filter,
    filterMap: $aec0033bd8fc24cf$var$_filterMap,
    partition: $aec0033bd8fc24cf$var$_partition,
    partitionMap: $aec0033bd8fc24cf$var$_partitionMap
};
var $aec0033bd8fc24cf$export$c29a647071e542ec = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    mapWithIndex: $aec0033bd8fc24cf$var$_mapWithIndex,
    compact: $aec0033bd8fc24cf$export$8e16b83750b44988,
    separate: $aec0033bd8fc24cf$export$709f6946f4e97408,
    filter: $aec0033bd8fc24cf$var$_filter,
    filterMap: $aec0033bd8fc24cf$var$_filterMap,
    partition: $aec0033bd8fc24cf$var$_partition,
    partitionMap: $aec0033bd8fc24cf$var$_partitionMap,
    partitionMapWithIndex: $aec0033bd8fc24cf$var$_partitionMapWithIndex,
    partitionWithIndex: $aec0033bd8fc24cf$var$_partitionWithIndex,
    filterMapWithIndex: $aec0033bd8fc24cf$var$_filterMapWithIndex,
    filterWithIndex: $aec0033bd8fc24cf$var$_filterWithIndex
};
var $aec0033bd8fc24cf$export$41404b31838667c9 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    reduce: $aec0033bd8fc24cf$var$_reduce,
    foldMap: $aec0033bd8fc24cf$var$_foldMap,
    reduceRight: $aec0033bd8fc24cf$var$_reduceRight
};
var $aec0033bd8fc24cf$export$e8f7d17aaff345cb = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    reduce: $aec0033bd8fc24cf$var$_reduce,
    foldMap: $aec0033bd8fc24cf$var$_foldMap,
    reduceRight: $aec0033bd8fc24cf$var$_reduceRight,
    reduceWithIndex: $aec0033bd8fc24cf$var$_reduceWithIndex,
    foldMapWithIndex: $aec0033bd8fc24cf$var$_foldMapWithIndex,
    reduceRightWithIndex: $aec0033bd8fc24cf$var$_reduceRightWithIndex
};
var $aec0033bd8fc24cf$export$a0202666c3bda011 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    reduce: $aec0033bd8fc24cf$var$_reduce,
    foldMap: $aec0033bd8fc24cf$var$_foldMap,
    reduceRight: $aec0033bd8fc24cf$var$_reduceRight,
    traverse: $aec0033bd8fc24cf$var$_traverse,
    sequence: $aec0033bd8fc24cf$export$49bb65c2ea163039
};
var $aec0033bd8fc24cf$export$bd7b528d8c36ec41 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    mapWithIndex: $aec0033bd8fc24cf$var$_mapWithIndex,
    reduce: $aec0033bd8fc24cf$var$_reduce,
    foldMap: $aec0033bd8fc24cf$var$_foldMap,
    reduceRight: $aec0033bd8fc24cf$var$_reduceRight,
    reduceWithIndex: $aec0033bd8fc24cf$var$_reduceWithIndex,
    foldMapWithIndex: $aec0033bd8fc24cf$var$_foldMapWithIndex,
    reduceRightWithIndex: $aec0033bd8fc24cf$var$_reduceRightWithIndex,
    traverse: $aec0033bd8fc24cf$var$_traverse,
    sequence: $aec0033bd8fc24cf$export$49bb65c2ea163039,
    traverseWithIndex: $aec0033bd8fc24cf$var$_traverseWithIndex
};
var $aec0033bd8fc24cf$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $aec0033bd8fc24cf$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($lOGTm.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $aec0033bd8fc24cf$export$7d808dfaa6d54634 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    chain: $aec0033bd8fc24cf$export$5b8affa63fc6df16,
    chainRec: $aec0033bd8fc24cf$export$c5c44f872d8af73
};
var $aec0033bd8fc24cf$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($lOGTm.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $aec0033bd8fc24cf$export$57f3a385c7e59628 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    chain: $aec0033bd8fc24cf$export$5b8affa63fc6df16,
    chainRec: $aec0033bd8fc24cf$export$b9909b62ceeab991
};
var $aec0033bd8fc24cf$var$_wither = /*#__PURE__*/ (0, $LdARg.witherDefault)($aec0033bd8fc24cf$export$a0202666c3bda011, $aec0033bd8fc24cf$export$4a21ac48141ac3c9);
var $aec0033bd8fc24cf$var$_wilt = /*#__PURE__*/ (0, $LdARg.wiltDefault)($aec0033bd8fc24cf$export$a0202666c3bda011, $aec0033bd8fc24cf$export$4a21ac48141ac3c9);
var $aec0033bd8fc24cf$export$748d317b4c426f96 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    map: $aec0033bd8fc24cf$var$_map,
    compact: $aec0033bd8fc24cf$export$8e16b83750b44988,
    separate: $aec0033bd8fc24cf$export$709f6946f4e97408,
    filter: $aec0033bd8fc24cf$var$_filter,
    filterMap: $aec0033bd8fc24cf$var$_filterMap,
    partition: $aec0033bd8fc24cf$var$_partition,
    partitionMap: $aec0033bd8fc24cf$var$_partitionMap,
    reduce: $aec0033bd8fc24cf$var$_reduce,
    foldMap: $aec0033bd8fc24cf$var$_foldMap,
    reduceRight: $aec0033bd8fc24cf$var$_reduceRight,
    traverse: $aec0033bd8fc24cf$var$_traverse,
    sequence: $aec0033bd8fc24cf$export$49bb65c2ea163039,
    wither: $aec0033bd8fc24cf$var$_wither,
    wilt: $aec0033bd8fc24cf$var$_wilt
};
var $aec0033bd8fc24cf$export$c40604f35db61519 = /*#__PURE__*/ (0, $LdARg.filterE)($aec0033bd8fc24cf$export$748d317b4c426f96);
var $aec0033bd8fc24cf$export$825ea6cb6fc48d49 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    fromEither: $aec0033bd8fc24cf$export$80c878c9b1d77917
};
var $aec0033bd8fc24cf$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $fgwhT.fromEitherK)($aec0033bd8fc24cf$export$825ea6cb6fc48d49);
var $aec0033bd8fc24cf$export$f4863e1822a1860c = $kqvcT.unsafeInsertAt;
var $aec0033bd8fc24cf$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $aec0033bd8fc24cf$export$a978c53b4062a525(as) ? $kqvcT.unsafeUpdateAt(i, a, as) : as;
};
var $aec0033bd8fc24cf$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $aec0033bd8fc24cf$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $aec0033bd8fc24cf$export$571d59b505e6bb4e = function(as) {
    return $aec0033bd8fc24cf$export$dd1bc94b04021eeb(as) ? $aec0033bd8fc24cf$export$6e22c362a0406a2c : as.slice();
};
var $aec0033bd8fc24cf$export$6e22c362a0406a2c = $kqvcT.empty;
function $aec0033bd8fc24cf$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $aec0033bd8fc24cf$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $aec0033bd8fc24cf$export$f7e9f41ea797a17 = $aec0033bd8fc24cf$export$ad14ef4001db2bcd;
var $aec0033bd8fc24cf$export$739ec22334c44788 = function(M) {
    var intercalateM = $kqvcT.intercalate(M);
    return function(middle) {
        return $aec0033bd8fc24cf$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $aec0033bd8fc24cf$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $aec0033bd8fc24cf$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $aec0033bd8fc24cf$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($aec0033bd8fc24cf$export$bd5b6bfc5fa2ee61);
var $aec0033bd8fc24cf$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($aec0033bd8fc24cf$export$bd5b6bfc5fa2ee61);
var $aec0033bd8fc24cf$export$2385a24977818dd0 = /*#__PURE__*/ (0, $dya6d.bind)($aec0033bd8fc24cf$export$f18d5acc27d70423);
var $aec0033bd8fc24cf$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($aec0033bd8fc24cf$export$efc21ddc6aeb363d);
var $aec0033bd8fc24cf$export$e08e3b67e392101e = $aec0033bd8fc24cf$export$5b8affa63fc6df16;
var $aec0033bd8fc24cf$export$d02631cccf789723 = $kqvcT.range;
var $aec0033bd8fc24cf$export$8327ebbef2a0ba76 = $kqvcT.cons;
var $aec0033bd8fc24cf$export$c40cf5aab899f397 = $kqvcT.snoc;
var $aec0033bd8fc24cf$export$baeb00bf1e27e233 = $aec0033bd8fc24cf$export$849c7567cbd62acc;
var $aec0033bd8fc24cf$export$95ca155af9fd5713 = {
    URI: $aec0033bd8fc24cf$export$9156e739aa33e19f,
    compact: $aec0033bd8fc24cf$export$8e16b83750b44988,
    separate: $aec0033bd8fc24cf$export$709f6946f4e97408,
    map: $aec0033bd8fc24cf$var$_map,
    ap: $aec0033bd8fc24cf$var$_ap,
    of: $aec0033bd8fc24cf$export$ba255e9e49e00608,
    chain: $aec0033bd8fc24cf$export$5b8affa63fc6df16,
    filter: $aec0033bd8fc24cf$var$_filter,
    filterMap: $aec0033bd8fc24cf$var$_filterMap,
    partition: $aec0033bd8fc24cf$var$_partition,
    partitionMap: $aec0033bd8fc24cf$var$_partitionMap,
    mapWithIndex: $aec0033bd8fc24cf$var$_mapWithIndex,
    partitionMapWithIndex: $aec0033bd8fc24cf$var$_partitionMapWithIndex,
    partitionWithIndex: $aec0033bd8fc24cf$var$_partitionWithIndex,
    filterMapWithIndex: $aec0033bd8fc24cf$var$_filterMapWithIndex,
    filterWithIndex: $aec0033bd8fc24cf$var$_filterWithIndex,
    alt: $aec0033bd8fc24cf$var$_alt,
    zero: $aec0033bd8fc24cf$export$7f9972325ebfd559,
    unfold: $aec0033bd8fc24cf$export$c48e357c1a89b78d,
    reduce: $aec0033bd8fc24cf$var$_reduce,
    foldMap: $aec0033bd8fc24cf$var$_foldMap,
    reduceRight: $aec0033bd8fc24cf$var$_reduceRight,
    traverse: $aec0033bd8fc24cf$var$_traverse,
    sequence: $aec0033bd8fc24cf$export$49bb65c2ea163039,
    reduceWithIndex: $aec0033bd8fc24cf$var$_reduceWithIndex,
    foldMapWithIndex: $aec0033bd8fc24cf$var$_foldMapWithIndex,
    reduceRightWithIndex: $aec0033bd8fc24cf$var$_reduceRightWithIndex,
    traverseWithIndex: $aec0033bd8fc24cf$var$_traverseWithIndex,
    extend: $aec0033bd8fc24cf$var$_extend,
    wither: $aec0033bd8fc24cf$var$_wither,
    wilt: $aec0033bd8fc24cf$var$_wilt
};

});
parcelRegister("cF6yJ", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $937e66e9b0171354$export$7e4aa119212bc614; });
$parcel$export(module.exports, "Eq", function () { return $937e66e9b0171354$export$a2050e5b0c4dcf10; });
$parcel$export(module.exports, "Ord", function () { return $937e66e9b0171354$export$ee8aa95bfab51c5; });
$parcel$export(module.exports, "Bounded", function () { return $937e66e9b0171354$export$88f31472ebc405c8; });
$parcel$export(module.exports, "Show", function () { return $937e66e9b0171354$export$f6a3d19be20f5819; });
$parcel$export(module.exports, "MagmaSub", function () { return $937e66e9b0171354$export$d423c79a04b3ae25; });
$parcel$export(module.exports, "SemigroupSum", function () { return $937e66e9b0171354$export$e5fae4f686b09c06; });
$parcel$export(module.exports, "SemigroupProduct", function () { return $937e66e9b0171354$export$5b0bccec79556292; });
$parcel$export(module.exports, "MonoidSum", function () { return $937e66e9b0171354$export$2517c0450e71e789; });
$parcel$export(module.exports, "MonoidProduct", function () { return $937e66e9b0171354$export$ee1a63590489b690; });
$parcel$export(module.exports, "Field", function () { return $937e66e9b0171354$export$a455218a85c89869; });
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $937e66e9b0171354$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $937e66e9b0171354$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $937e66e9b0171354$export$ee8aa95bfab51c5 = {
    equals: $937e66e9b0171354$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $937e66e9b0171354$export$88f31472ebc405c8 = {
    equals: $937e66e9b0171354$export$a2050e5b0c4dcf10.equals,
    compare: $937e66e9b0171354$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $937e66e9b0171354$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $937e66e9b0171354$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $937e66e9b0171354$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $937e66e9b0171354$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $937e66e9b0171354$export$2517c0450e71e789 = {
    concat: $937e66e9b0171354$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $937e66e9b0171354$export$ee1a63590489b690 = {
    concat: $937e66e9b0171354$export$5b0bccec79556292.concat,
    empty: 1
};
var $937e66e9b0171354$export$a455218a85c89869 = {
    add: $937e66e9b0171354$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $937e66e9b0171354$export$5b0bccec79556292.concat,
    one: 1,
    sub: $937e66e9b0171354$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("aRVRH", function(module, exports) {

$parcel$export(module.exports, "separated", function () { return $7e9bbd6cc52097b8$export$beaabdf62f4a639d; });
$parcel$export(module.exports, "map", function () { return $7e9bbd6cc52097b8$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapLeft", function () { return $7e9bbd6cc52097b8$export$472de43a55e4aa49; });
$parcel$export(module.exports, "bimap", function () { return $7e9bbd6cc52097b8$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "left", function () { return $7e9bbd6cc52097b8$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $7e9bbd6cc52097b8$export$79ffe56a765070d2; });
$parcel$export(module.exports, "URI", function () { return $7e9bbd6cc52097b8$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Bifunctor", function () { return $7e9bbd6cc52097b8$export$fd0fe42029639505; });
$parcel$export(module.exports, "Functor", function () { return $7e9bbd6cc52097b8$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $7e9bbd6cc52097b8$export$18c957606d8bdf09; });
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 
var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");
var $7e9bbd6cc52097b8$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $7e9bbd6cc52097b8$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $7e9bbd6cc52097b8$export$871de8747c9eaa88(f));
};
var $7e9bbd6cc52097b8$var$_mapLeft = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $7e9bbd6cc52097b8$export$472de43a55e4aa49(f));
};
var $7e9bbd6cc52097b8$var$_bimap = function(fa, g, f) {
    return (0, $kj6DU.pipe)(fa, $7e9bbd6cc52097b8$export$eb54baf0b342cb1d(g, f));
};
var $7e9bbd6cc52097b8$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $7e9bbd6cc52097b8$export$beaabdf62f4a639d($7e9bbd6cc52097b8$export$eabcd2c8791e7bf4(fa), f($7e9bbd6cc52097b8$export$79ffe56a765070d2(fa)));
    };
};
var $7e9bbd6cc52097b8$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $7e9bbd6cc52097b8$export$beaabdf62f4a639d(f($7e9bbd6cc52097b8$export$eabcd2c8791e7bf4(fa)), $7e9bbd6cc52097b8$export$79ffe56a765070d2(fa));
    };
};
var $7e9bbd6cc52097b8$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $7e9bbd6cc52097b8$export$beaabdf62f4a639d(f($7e9bbd6cc52097b8$export$eabcd2c8791e7bf4(fa)), g($7e9bbd6cc52097b8$export$79ffe56a765070d2(fa)));
    };
};
var $7e9bbd6cc52097b8$export$9156e739aa33e19f = 'Separated';
var $7e9bbd6cc52097b8$export$fd0fe42029639505 = {
    URI: $7e9bbd6cc52097b8$export$9156e739aa33e19f,
    mapLeft: $7e9bbd6cc52097b8$var$_mapLeft,
    bimap: $7e9bbd6cc52097b8$var$_bimap
};
var $7e9bbd6cc52097b8$export$bd5b6bfc5fa2ee61 = {
    URI: $7e9bbd6cc52097b8$export$9156e739aa33e19f,
    map: $7e9bbd6cc52097b8$var$_map
};
var $7e9bbd6cc52097b8$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($7e9bbd6cc52097b8$export$bd5b6bfc5fa2ee61);
var $7e9bbd6cc52097b8$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $7e9bbd6cc52097b8$export$79ffe56a765070d2 = function(s) {
    return s.right;
};

});

parcelRegister("LdARg", function(module, exports) {

$parcel$export(module.exports, "wiltDefault", function () { return $08deef48a0f9534a$export$f4cb42390e44d1d2; });
$parcel$export(module.exports, "witherDefault", function () { return $08deef48a0f9534a$export$1f5c6f948d11a182; });
$parcel$export(module.exports, "filterE", function () { return $08deef48a0f9534a$export$c40604f35db61519; });

var $lOGTm = parcelRequire("lOGTm");
function $08deef48a0f9534a$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $08deef48a0f9534a$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $08deef48a0f9534a$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $lOGTm.some(a) : $lOGTm.none;
                    });
                });
            };
        };
    };
}

});

parcelRegister("2GEXo", function(module, exports) {

$parcel$export(module.exports, "guard", function () { return $1f4f4636ca651663$export$864d727b48066337; });
function $1f4f4636ca651663$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("iK9L9", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $da5417e6c21664ab$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "getApplicative", function () { return $da5417e6c21664ab$export$1402880adb2295a7; });

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");
var $da5417e6c21664ab$export$dd44f18ab656f3bb = (0, $kj6DU.unsafeCoerce);
function $da5417e6c21664ab$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $da5417e6c21664ab$export$804fed467fde44e4 = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$1af51209b1b91d07 = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$c55397fc301c5a = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$e759a9a7f8d04692 = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$c2a7ef2cc9b32b31 = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$3d48c7fefc7b8ec2 = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$575097c1c561f76f = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$2e73cb3f0f25ed55 = (0, $kj6DU.identity);
var $da5417e6c21664ab$export$f37f1abb2c955577 = (0, $kj6DU.identity);
function $da5417e6c21664ab$export$81090df2aa47ff12(S) {
    return {
        URI: $da5417e6c21664ab$export$9156e739aa33e19f,
        _E: undefined,
        map: $da5417e6c21664ab$var$_map,
        ap: function(fab, fa) {
            return $da5417e6c21664ab$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $da5417e6c21664ab$export$1402880adb2295a7(M) {
    var A = $da5417e6c21664ab$export$81090df2aa47ff12(M);
    return {
        URI: $da5417e6c21664ab$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $da5417e6c21664ab$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $da5417e6c21664ab$var$_contramap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $da5417e6c21664ab$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $da5417e6c21664ab$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $da5417e6c21664ab$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $da5417e6c21664ab$var$_bimap = function(fa, f, g) {
    return (0, $kj6DU.pipe)(fa, $da5417e6c21664ab$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $da5417e6c21664ab$var$_mapLeft = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $da5417e6c21664ab$export$472de43a55e4aa49(f));
};
var $da5417e6c21664ab$export$53b696d27ecb7ba7 = function() {
    return 0, $kj6DU.unsafeCoerce;
};
var $da5417e6c21664ab$export$871de8747c9eaa88 = function() {
    return 0, $kj6DU.unsafeCoerce;
};
var $da5417e6c21664ab$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $da5417e6c21664ab$export$dd44f18ab656f3bb(f(fa));
    };
};
var $da5417e6c21664ab$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $da5417e6c21664ab$export$dd44f18ab656f3bb(f(fa));
    };
};
var $da5417e6c21664ab$export$9156e739aa33e19f = 'Const';
var $da5417e6c21664ab$export$bd5b6bfc5fa2ee61 = {
    URI: $da5417e6c21664ab$export$9156e739aa33e19f,
    map: $da5417e6c21664ab$var$_map
};
var $da5417e6c21664ab$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($da5417e6c21664ab$export$bd5b6bfc5fa2ee61);
var $da5417e6c21664ab$export$def901a57d5539c3 = {
    URI: $da5417e6c21664ab$export$9156e739aa33e19f,
    contramap: $da5417e6c21664ab$var$_contramap
};
var $da5417e6c21664ab$export$fd0fe42029639505 = {
    URI: $da5417e6c21664ab$export$9156e739aa33e19f,
    bimap: $da5417e6c21664ab$var$_bimap,
    mapLeft: $da5417e6c21664ab$var$_mapLeft
};
var $da5417e6c21664ab$export$dfdd8a9a12668b21 = {
    URI: $da5417e6c21664ab$export$9156e739aa33e19f,
    map: $da5417e6c21664ab$var$_map,
    contramap: $da5417e6c21664ab$var$_contramap,
    bimap: $da5417e6c21664ab$var$_bimap,
    mapLeft: $da5417e6c21664ab$var$_mapLeft
};

});

parcelRegister("gpfu2", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $bf1afddbf60c3542$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $bf1afddbf60c3542$export$8960430cfd85939f; });
$parcel$export(module.exports, "reverse", function () { return $bf1afddbf60c3542$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "struct", function () { return $bf1afddbf60c3542$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "tuple", function () { return $bf1afddbf60c3542$export$65e3907585753458; });
$parcel$export(module.exports, "concatAll", function () { return $bf1afddbf60c3542$export$b314777ae20abca9; });
$parcel$export(module.exports, "monoidVoid", function () { return $bf1afddbf60c3542$export$50d82750fd26461d; });
$parcel$export(module.exports, "getTupleMonoid", function () { return $bf1afddbf60c3542$export$4ab04e39033ac22a; });
$parcel$export(module.exports, "getStructMonoid", function () { return $bf1afddbf60c3542$export$dfc91d1e5b77420b; });
$parcel$export(module.exports, "getDualMonoid", function () { return $bf1afddbf60c3542$export$5ca84f9b29f1c1a2; });
$parcel$export(module.exports, "getJoinMonoid", function () { return $bf1afddbf60c3542$export$9cc0388793460b00; });
$parcel$export(module.exports, "getMeetMonoid", function () { return $bf1afddbf60c3542$export$6d1c667712a51996; });
$parcel$export(module.exports, "fold", function () { return $bf1afddbf60c3542$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "monoidAll", function () { return $bf1afddbf60c3542$export$ea84ccdc68daa647; });
$parcel$export(module.exports, "monoidAny", function () { return $bf1afddbf60c3542$export$c147905ca5134122; });
$parcel$export(module.exports, "getFunctionMonoid", function () { return $bf1afddbf60c3542$export$616ba591d6210ed8; });
$parcel$export(module.exports, "getEndomorphismMonoid", function () { return $bf1afddbf60c3542$export$5c6d2e402d334f37; });
$parcel$export(module.exports, "monoidString", function () { return $bf1afddbf60c3542$export$fc39f3d77fa2e58a; });
$parcel$export(module.exports, "monoidSum", function () { return $bf1afddbf60c3542$export$8f9c64d4a92a9eb6; });
$parcel$export(module.exports, "monoidProduct", function () { return $bf1afddbf60c3542$export$cb362f92c995f3b8; });

var $5qHLM = parcelRequire("5qHLM");

var $kj6DU = parcelRequire("kj6DU");

var $lOGTm = parcelRequire("lOGTm");

var $flrom = parcelRequire("flrom");
var $bf1afddbf60c3542$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $flrom.min(B).concat,
        empty: B.top
    };
};
var $bf1afddbf60c3542$export$8960430cfd85939f = function(B) {
    return {
        concat: $flrom.max(B).concat,
        empty: B.bottom
    };
};
var $bf1afddbf60c3542$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $flrom.reverse(M).concat,
        empty: M.empty
    };
};
var $bf1afddbf60c3542$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($lOGTm.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $flrom.struct(monoids).concat,
        empty: empty
    };
};
var $bf1afddbf60c3542$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $flrom.tuple.apply($flrom, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $bf1afddbf60c3542$export$b314777ae20abca9 = function(M) {
    return $flrom.concatAll(M)(M.empty);
};
var $bf1afddbf60c3542$export$50d82750fd26461d = {
    concat: $flrom.semigroupVoid.concat,
    empty: undefined
};
var $bf1afddbf60c3542$export$4ab04e39033ac22a = $bf1afddbf60c3542$export$65e3907585753458;
var $bf1afddbf60c3542$export$dfc91d1e5b77420b = $bf1afddbf60c3542$export$8cf3da7c1c9174ea;
var $bf1afddbf60c3542$export$5ca84f9b29f1c1a2 = $bf1afddbf60c3542$export$66c1ae025e96b4bc;
var $bf1afddbf60c3542$export$9cc0388793460b00 = $bf1afddbf60c3542$export$8960430cfd85939f;
var $bf1afddbf60c3542$export$6d1c667712a51996 = $bf1afddbf60c3542$export$96ec731ed4dcb222;
var $bf1afddbf60c3542$export$93e2b83da34ff82a = $bf1afddbf60c3542$export$b314777ae20abca9;
var $bf1afddbf60c3542$export$ea84ccdc68daa647 = {
    concat: $flrom.semigroupAll.concat,
    empty: true
};
var $bf1afddbf60c3542$export$c147905ca5134122 = {
    concat: $flrom.semigroupAny.concat,
    empty: false
};
var $bf1afddbf60c3542$export$616ba591d6210ed8 = (0, $kj6DU.getMonoid);
var $bf1afddbf60c3542$export$5c6d2e402d334f37 = function() {
    return $bf1afddbf60c3542$export$66c1ae025e96b4bc((0, $5qHLM.getMonoid)());
};
var $bf1afddbf60c3542$export$fc39f3d77fa2e58a = {
    concat: $flrom.semigroupString.concat,
    empty: ''
};
var $bf1afddbf60c3542$export$8f9c64d4a92a9eb6 = {
    concat: $flrom.semigroupSum.concat,
    empty: 0
};
var $bf1afddbf60c3542$export$cb362f92c995f3b8 = {
    concat: $flrom.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("5qHLM", function(module, exports) {

$parcel$export(module.exports, "getMonoid", function () { return $3f415532aa5d9847$export$c2a7ef2cc9b32b31; });
/**
 * @since 2.11.0
 */ 
var $kj6DU = parcelRequire("kj6DU");
var $3f415532aa5d9847$export$9156e739aa33e19f = 'Endomorphism';
var $3f415532aa5d9847$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $kj6DU.flow)(first, second);
        }
    };
};
var $3f415532aa5d9847$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $3f415532aa5d9847$export$e759a9a7f8d04692().concat,
        empty: (0, $kj6DU.identity)
    };
};

});


parcelRegister("3NXK3", function(module, exports) {

$parcel$export(module.exports, "none", function () { return $2c544a34519e5d64$export$f883a24d5edde77c; });
$parcel$export(module.exports, "some", function () { return $2c544a34519e5d64$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "fromPredicate", function () { return $2c544a34519e5d64$export$23f31c55d7162b91; });
$parcel$export(module.exports, "getLeft", function () { return $2c544a34519e5d64$export$da405662c16fca8e; });
$parcel$export(module.exports, "getRight", function () { return $2c544a34519e5d64$export$482f3615ecf01dc6; });
$parcel$export(module.exports, "map", function () { return $2c544a34519e5d64$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $2c544a34519e5d64$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "reduce", function () { return $2c544a34519e5d64$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $2c544a34519e5d64$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $2c544a34519e5d64$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $2c544a34519e5d64$export$df3f009e3d155b20; });
$parcel$export(module.exports, "alt", function () { return $2c544a34519e5d64$export$228be17d80722ab; });
$parcel$export(module.exports, "filter", function () { return $2c544a34519e5d64$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $2c544a34519e5d64$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "extend", function () { return $2c544a34519e5d64$export$8b58be045bf06082; });
$parcel$export(module.exports, "partition", function () { return $2c544a34519e5d64$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $2c544a34519e5d64$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "URI", function () { return $2c544a34519e5d64$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $2c544a34519e5d64$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "isNone", function () { return $2c544a34519e5d64$export$e56af863d5645d5f; });
$parcel$export(module.exports, "getEq", function () { return $2c544a34519e5d64$export$804fed467fde44e4; });
$parcel$export(module.exports, "getOrd", function () { return $2c544a34519e5d64$export$1af51209b1b91d07; });
$parcel$export(module.exports, "isSome", function () { return $2c544a34519e5d64$export$5d7e502287836e58; });
$parcel$export(module.exports, "getMonoid", function () { return $2c544a34519e5d64$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Functor", function () { return $2c544a34519e5d64$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $2c544a34519e5d64$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $2c544a34519e5d64$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "of", function () { return $2c544a34519e5d64$export$ba255e9e49e00608; });
$parcel$export(module.exports, "Pointed", function () { return $2c544a34519e5d64$export$59a71046037e6c20; });
$parcel$export(module.exports, "Apply", function () { return $2c544a34519e5d64$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "Applicative", function () { return $2c544a34519e5d64$export$1279d2b7807629fd; });
$parcel$export(module.exports, "flatMap", function () { return $2c544a34519e5d64$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "Chain", function () { return $2c544a34519e5d64$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $2c544a34519e5d64$export$fb641926d034ac7d; });
$parcel$export(module.exports, "Foldable", function () { return $2c544a34519e5d64$export$41404b31838667c9; });
$parcel$export(module.exports, "orElse", function () { return $2c544a34519e5d64$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "altW", function () { return $2c544a34519e5d64$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "Alt", function () { return $2c544a34519e5d64$export$25ba4469a069167; });
$parcel$export(module.exports, "zero", function () { return $2c544a34519e5d64$export$7f9972325ebfd559; });
$parcel$export(module.exports, "Zero", function () { return $2c544a34519e5d64$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "guard", function () { return $2c544a34519e5d64$export$864d727b48066337; });
$parcel$export(module.exports, "Alternative", function () { return $2c544a34519e5d64$export$4acb47accde578d2; });
$parcel$export(module.exports, "Extend", function () { return $2c544a34519e5d64$export$5b5dd0e212d2a5bc; });
$parcel$export(module.exports, "compact", function () { return $2c544a34519e5d64$export$8e16b83750b44988; });
$parcel$export(module.exports, "separate", function () { return $2c544a34519e5d64$export$709f6946f4e97408; });
$parcel$export(module.exports, "Compactable", function () { return $2c544a34519e5d64$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $2c544a34519e5d64$export$d00e1c48fb621173; });
$parcel$export(module.exports, "sequence", function () { return $2c544a34519e5d64$export$49bb65c2ea163039; });
$parcel$export(module.exports, "Traversable", function () { return $2c544a34519e5d64$export$a0202666c3bda011; });
$parcel$export(module.exports, "wither", function () { return $2c544a34519e5d64$export$6c36d01819ecdb31; });
$parcel$export(module.exports, "wilt", function () { return $2c544a34519e5d64$export$2439a3bc02b13b03; });
$parcel$export(module.exports, "Witherable", function () { return $2c544a34519e5d64$export$748d317b4c426f96; });
$parcel$export(module.exports, "throwError", function () { return $2c544a34519e5d64$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "MonadThrow", function () { return $2c544a34519e5d64$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "fromEither", function () { return $2c544a34519e5d64$export$80c878c9b1d77917; });
$parcel$export(module.exports, "FromEither", function () { return $2c544a34519e5d64$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "matchW", function () { return $2c544a34519e5d64$export$2d55ea551c238330; });
$parcel$export(module.exports, "foldW", function () { return $2c544a34519e5d64$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "match", function () { return $2c544a34519e5d64$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "fold", function () { return $2c544a34519e5d64$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "getOrElseW", function () { return $2c544a34519e5d64$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "getOrElse", function () { return $2c544a34519e5d64$export$8832081647a02ee7; });
$parcel$export(module.exports, "flap", function () { return $2c544a34519e5d64$export$18c957606d8bdf09; });
$parcel$export(module.exports, "apFirst", function () { return $2c544a34519e5d64$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $2c544a34519e5d64$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "flatten", function () { return $2c544a34519e5d64$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "tap", function () { return $2c544a34519e5d64$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapEither", function () { return $2c544a34519e5d64$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "duplicate", function () { return $2c544a34519e5d64$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "fromEitherK", function () { return $2c544a34519e5d64$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "chainEitherK", function () { return $2c544a34519e5d64$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "chainFirstEitherK", function () { return $2c544a34519e5d64$export$c5f2bdbf9b43f0c0; });
$parcel$export(module.exports, "fromNullable", function () { return $2c544a34519e5d64$export$b601f49376b4621a; });
$parcel$export(module.exports, "tryCatch", function () { return $2c544a34519e5d64$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $2c544a34519e5d64$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "fromNullableK", function () { return $2c544a34519e5d64$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $2c544a34519e5d64$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "toNullable", function () { return $2c544a34519e5d64$export$b187f57ee1822bc5; });
$parcel$export(module.exports, "toUndefined", function () { return $2c544a34519e5d64$export$cb585b8513fa8577; });
$parcel$export(module.exports, "elem", function () { return $2c544a34519e5d64$export$5bf96401662340b7; });
$parcel$export(module.exports, "exists", function () { return $2c544a34519e5d64$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "Do", function () { return $2c544a34519e5d64$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $2c544a34519e5d64$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $2c544a34519e5d64$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $2c544a34519e5d64$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $2c544a34519e5d64$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "ApT", function () { return $2c544a34519e5d64$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $2c544a34519e5d64$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $2c544a34519e5d64$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $2c544a34519e5d64$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $2c544a34519e5d64$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $2c544a34519e5d64$export$d330b60315c14cd1; });
$parcel$export(module.exports, "chain", function () { return $2c544a34519e5d64$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $2c544a34519e5d64$export$e3821ef4970c339c; });
$parcel$export(module.exports, "getRefinement", function () { return $2c544a34519e5d64$export$4a60bf88193d4686; });
$parcel$export(module.exports, "mapNullable", function () { return $2c544a34519e5d64$export$c2a8dfc107523e74; });
$parcel$export(module.exports, "option", function () { return $2c544a34519e5d64$export$a75d1723e6bda2ec; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $2c544a34519e5d64$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $2c544a34519e5d64$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getFirstMonoid", function () { return $2c544a34519e5d64$export$56cd0d85e73e688f; });
$parcel$export(module.exports, "getLastMonoid", function () { return $2c544a34519e5d64$export$ca391a563a1f3001; });

var $dYcKb = parcelRequire("dYcKb");

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $fgwhT = parcelRequire("fgwhT");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $lSBre = parcelRequire("lSBre");

var $flrom = parcelRequire("flrom");

var $aRVRH = parcelRequire("aRVRH");

var $LdARg = parcelRequire("LdARg");

var $2GEXo = parcelRequire("2GEXo");
var $2c544a34519e5d64$export$f883a24d5edde77c = $lOGTm.none;
var $2c544a34519e5d64$export$ad14ef4001db2bcd = $lOGTm.some;
function $2c544a34519e5d64$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $2c544a34519e5d64$export$ad14ef4001db2bcd(a) : $2c544a34519e5d64$export$f883a24d5edde77c;
    };
}
var $2c544a34519e5d64$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$ad14ef4001db2bcd(ma.left);
};
var $2c544a34519e5d64$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$ad14ef4001db2bcd(ma.right);
};
var $2c544a34519e5d64$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$871de8747c9eaa88(f));
};
var $2c544a34519e5d64$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $2c544a34519e5d64$export$2f6ca3d3b1f80bf5(fa));
};
var $2c544a34519e5d64$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$533b26079ad0b4b(b, f));
};
var $2c544a34519e5d64$var$_foldMap = function(M) {
    var foldMapM = $2c544a34519e5d64$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
var $2c544a34519e5d64$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$7fef8bcdbb34f435(b, f));
};
var $2c544a34519e5d64$var$_traverse = function(F) {
    var traverseF = $2c544a34519e5d64$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $2c544a34519e5d64$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$228be17d80722ab(that));
};
var $2c544a34519e5d64$var$_filter = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $2c544a34519e5d64$var$_filterMap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $2c544a34519e5d64$var$_extend = function(wa, f) {
    return (0, $kj6DU.pipe)(wa, $2c544a34519e5d64$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $2c544a34519e5d64$var$_partition = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $2c544a34519e5d64$var$_partitionMap = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $2c544a34519e5d64$export$3117e3f9ececb6bc(f));
};
var $2c544a34519e5d64$export$9156e739aa33e19f = 'Option';
var $2c544a34519e5d64$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $2c544a34519e5d64$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($2c544a34519e5d64$export$e56af863d5645d5f(x) ? $2c544a34519e5d64$export$e56af863d5645d5f(y) : $2c544a34519e5d64$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $2c544a34519e5d64$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $2c544a34519e5d64$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $2c544a34519e5d64$export$5d7e502287836e58(x) ? $2c544a34519e5d64$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $2c544a34519e5d64$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $2c544a34519e5d64$export$e56af863d5645d5f(x) ? y : $2c544a34519e5d64$export$e56af863d5645d5f(y) ? x : $2c544a34519e5d64$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $2c544a34519e5d64$export$f883a24d5edde77c
    };
};
var $2c544a34519e5d64$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $2c544a34519e5d64$export$bd5b6bfc5fa2ee61 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map
};
var $2c544a34519e5d64$export$6554612db691658e = (0, $kj6DU.dual)(2, (0, $6baua.as)($2c544a34519e5d64$export$bd5b6bfc5fa2ee61));
var $2c544a34519e5d64$export$9284b360ca18a0fd = (0, $6baua.asUnit)($2c544a34519e5d64$export$bd5b6bfc5fa2ee61);
var $2c544a34519e5d64$export$ba255e9e49e00608 = $2c544a34519e5d64$export$ad14ef4001db2bcd;
var $2c544a34519e5d64$export$59a71046037e6c20 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    of: $2c544a34519e5d64$export$ba255e9e49e00608
};
var $2c544a34519e5d64$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(fab) ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $2c544a34519e5d64$export$efc21ddc6aeb363d = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    ap: $2c544a34519e5d64$var$_ap
};
var $2c544a34519e5d64$export$1279d2b7807629fd = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    ap: $2c544a34519e5d64$var$_ap,
    of: $2c544a34519e5d64$export$ba255e9e49e00608
};
var $2c544a34519e5d64$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? $2c544a34519e5d64$export$f883a24d5edde77c : f(ma.value);
});
var $2c544a34519e5d64$export$f18d5acc27d70423 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    ap: $2c544a34519e5d64$var$_ap,
    chain: $2c544a34519e5d64$export$5b8affa63fc6df16
};
var $2c544a34519e5d64$export$fb641926d034ac7d = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    ap: $2c544a34519e5d64$var$_ap,
    of: $2c544a34519e5d64$export$ba255e9e49e00608,
    chain: $2c544a34519e5d64$export$5b8affa63fc6df16
};
var $2c544a34519e5d64$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $2c544a34519e5d64$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $2c544a34519e5d64$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $2c544a34519e5d64$export$41404b31838667c9 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    reduce: $2c544a34519e5d64$var$_reduce,
    foldMap: $2c544a34519e5d64$var$_foldMap,
    reduceRight: $2c544a34519e5d64$var$_reduceRight
};
var $2c544a34519e5d64$export$41d1a04d78e7b141 = (0, $kj6DU.dual)(2, function(self, that) {
    return $2c544a34519e5d64$export$e56af863d5645d5f(self) ? that() : self;
});
var $2c544a34519e5d64$export$1517cca7889d6aaa = $2c544a34519e5d64$export$41d1a04d78e7b141;
var $2c544a34519e5d64$export$228be17d80722ab = $2c544a34519e5d64$export$41d1a04d78e7b141;
var $2c544a34519e5d64$export$25ba4469a069167 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    alt: $2c544a34519e5d64$var$_alt
};
var $2c544a34519e5d64$export$7f9972325ebfd559 = function() {
    return $2c544a34519e5d64$export$f883a24d5edde77c;
};
var $2c544a34519e5d64$export$aaef8a3eae948f03 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    zero: $2c544a34519e5d64$export$7f9972325ebfd559
};
var $2c544a34519e5d64$export$864d727b48066337 = /*#__PURE__*/ (0, $2GEXo.guard)($2c544a34519e5d64$export$aaef8a3eae948f03, $2c544a34519e5d64$export$59a71046037e6c20);
var $2c544a34519e5d64$export$4acb47accde578d2 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    ap: $2c544a34519e5d64$var$_ap,
    of: $2c544a34519e5d64$export$ba255e9e49e00608,
    alt: $2c544a34519e5d64$var$_alt,
    zero: $2c544a34519e5d64$export$7f9972325ebfd559
};
var $2c544a34519e5d64$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(wa) ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$ad14ef4001db2bcd(f(wa));
    };
};
var $2c544a34519e5d64$export$5b5dd0e212d2a5bc = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    extend: $2c544a34519e5d64$var$_extend
};
var $2c544a34519e5d64$export$8e16b83750b44988 = /*#__PURE__*/ $2c544a34519e5d64$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $2c544a34519e5d64$var$defaultSeparated = /*#__PURE__*/ (0, $aRVRH.separated)($2c544a34519e5d64$export$f883a24d5edde77c, $2c544a34519e5d64$export$f883a24d5edde77c);
var $2c544a34519e5d64$export$709f6946f4e97408 = function(ma) {
    return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? $2c544a34519e5d64$var$defaultSeparated : (0, $aRVRH.separated)($2c544a34519e5d64$export$da405662c16fca8e(ma.value), $2c544a34519e5d64$export$482f3615ecf01dc6(ma.value));
};
var $2c544a34519e5d64$export$4a21ac48141ac3c9 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    compact: $2c544a34519e5d64$export$8e16b83750b44988,
    separate: $2c544a34519e5d64$export$709f6946f4e97408
};
var $2c544a34519e5d64$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? $2c544a34519e5d64$export$f883a24d5edde77c : predicate(fa.value) ? fa : $2c544a34519e5d64$export$f883a24d5edde77c;
    };
};
var $2c544a34519e5d64$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(fa) ? $2c544a34519e5d64$export$f883a24d5edde77c : f(fa.value);
    };
};
var $2c544a34519e5d64$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $aRVRH.separated)($2c544a34519e5d64$var$_filter(fa, (0, $lSBre.not)(predicate)), $2c544a34519e5d64$var$_filter(fa, predicate));
    };
};
var $2c544a34519e5d64$export$3117e3f9ececb6bc = function(f) {
    return (0, $kj6DU.flow)($2c544a34519e5d64$export$871de8747c9eaa88(f), $2c544a34519e5d64$export$709f6946f4e97408);
};
var $2c544a34519e5d64$export$d00e1c48fb621173 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    compact: $2c544a34519e5d64$export$8e16b83750b44988,
    separate: $2c544a34519e5d64$export$709f6946f4e97408,
    filter: $2c544a34519e5d64$var$_filter,
    filterMap: $2c544a34519e5d64$var$_filterMap,
    partition: $2c544a34519e5d64$var$_partition,
    partitionMap: $2c544a34519e5d64$var$_partitionMap
};
var $2c544a34519e5d64$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $2c544a34519e5d64$export$e56af863d5645d5f(ta) ? F.of($2c544a34519e5d64$export$f883a24d5edde77c) : F.map(f(ta.value), $2c544a34519e5d64$export$ad14ef4001db2bcd);
        };
    };
};
var $2c544a34519e5d64$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(ta) ? F.of($2c544a34519e5d64$export$f883a24d5edde77c) : F.map(ta.value, $2c544a34519e5d64$export$ad14ef4001db2bcd);
    };
};
var $2c544a34519e5d64$export$a0202666c3bda011 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    reduce: $2c544a34519e5d64$var$_reduce,
    foldMap: $2c544a34519e5d64$var$_foldMap,
    reduceRight: $2c544a34519e5d64$var$_reduceRight,
    traverse: $2c544a34519e5d64$var$_traverse,
    sequence: $2c544a34519e5d64$export$49bb65c2ea163039
};
var $2c544a34519e5d64$var$_wither = /*#__PURE__*/ (0, $LdARg.witherDefault)($2c544a34519e5d64$export$a0202666c3bda011, $2c544a34519e5d64$export$4a21ac48141ac3c9);
var $2c544a34519e5d64$var$_wilt = /*#__PURE__*/ (0, $LdARg.wiltDefault)($2c544a34519e5d64$export$a0202666c3bda011, $2c544a34519e5d64$export$4a21ac48141ac3c9);
var $2c544a34519e5d64$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $2c544a34519e5d64$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $2c544a34519e5d64$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $2c544a34519e5d64$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $2c544a34519e5d64$export$748d317b4c426f96 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    reduce: $2c544a34519e5d64$var$_reduce,
    foldMap: $2c544a34519e5d64$var$_foldMap,
    reduceRight: $2c544a34519e5d64$var$_reduceRight,
    traverse: $2c544a34519e5d64$var$_traverse,
    sequence: $2c544a34519e5d64$export$49bb65c2ea163039,
    compact: $2c544a34519e5d64$export$8e16b83750b44988,
    separate: $2c544a34519e5d64$export$709f6946f4e97408,
    filter: $2c544a34519e5d64$var$_filter,
    filterMap: $2c544a34519e5d64$var$_filterMap,
    partition: $2c544a34519e5d64$var$_partition,
    partitionMap: $2c544a34519e5d64$var$_partitionMap,
    wither: $2c544a34519e5d64$var$_wither,
    wilt: $2c544a34519e5d64$var$_wilt
};
var $2c544a34519e5d64$export$8bf7aba4a9e09055 = function() {
    return $2c544a34519e5d64$export$f883a24d5edde77c;
};
var $2c544a34519e5d64$export$5f956d47d0619c3a = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    ap: $2c544a34519e5d64$var$_ap,
    of: $2c544a34519e5d64$export$ba255e9e49e00608,
    chain: $2c544a34519e5d64$export$5b8affa63fc6df16,
    throwError: $2c544a34519e5d64$export$8bf7aba4a9e09055
};
var $2c544a34519e5d64$export$80c878c9b1d77917 = $2c544a34519e5d64$export$482f3615ecf01dc6;
var $2c544a34519e5d64$export$825ea6cb6fc48d49 = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    fromEither: $2c544a34519e5d64$export$80c878c9b1d77917
};
var $2c544a34519e5d64$export$5d7e502287836e58 = $lOGTm.isSome;
var $2c544a34519e5d64$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $2c544a34519e5d64$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $2c544a34519e5d64$export$ccb09033cefa61e8 = $2c544a34519e5d64$export$2d55ea551c238330;
var $2c544a34519e5d64$export$4659b591c19bdf3d = $2c544a34519e5d64$export$2d55ea551c238330;
var $2c544a34519e5d64$export$93e2b83da34ff82a = $2c544a34519e5d64$export$4659b591c19bdf3d;
var $2c544a34519e5d64$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $2c544a34519e5d64$export$8832081647a02ee7 = $2c544a34519e5d64$export$d8a997ff0e6436f3;
var $2c544a34519e5d64$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($2c544a34519e5d64$export$bd5b6bfc5fa2ee61);
var $2c544a34519e5d64$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($2c544a34519e5d64$export$efc21ddc6aeb363d);
var $2c544a34519e5d64$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($2c544a34519e5d64$export$efc21ddc6aeb363d);
var $2c544a34519e5d64$export$bffa455ba8c619a6 = $2c544a34519e5d64$export$8e16b83750b44988;
var $2c544a34519e5d64$export$3f23594af5f37336 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dya6d.tap($2c544a34519e5d64$export$f18d5acc27d70423));
var $2c544a34519e5d64$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $fgwhT.tapEither)($2c544a34519e5d64$export$825ea6cb6fc48d49, $2c544a34519e5d64$export$f18d5acc27d70423));
var $2c544a34519e5d64$export$ecd5e8ace626722c = /*#__PURE__*/ $2c544a34519e5d64$export$8b58be045bf06082((0, $kj6DU.identity));
var $2c544a34519e5d64$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $fgwhT.fromEitherK)($2c544a34519e5d64$export$825ea6cb6fc48d49);
var $2c544a34519e5d64$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $fgwhT.chainEitherK)($2c544a34519e5d64$export$825ea6cb6fc48d49, $2c544a34519e5d64$export$f18d5acc27d70423);
var $2c544a34519e5d64$export$c5f2bdbf9b43f0c0 = $2c544a34519e5d64$export$be3ff275bb5a8ac9;
var $2c544a34519e5d64$export$b601f49376b4621a = function(a) {
    return a == null ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$ad14ef4001db2bcd(a);
};
var $2c544a34519e5d64$export$d234c058d1d4e435 = function(f) {
    try {
        return $2c544a34519e5d64$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $2c544a34519e5d64$export$f883a24d5edde77c;
    }
};
var $2c544a34519e5d64$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $2c544a34519e5d64$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $2c544a34519e5d64$export$c69ca7b73fad45e1 = function(f) {
    return (0, $kj6DU.flow)(f, $2c544a34519e5d64$export$b601f49376b4621a);
};
var $2c544a34519e5d64$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? $2c544a34519e5d64$export$f883a24d5edde77c : $2c544a34519e5d64$export$b601f49376b4621a(f(ma.value));
    };
};
var $2c544a34519e5d64$export$b187f57ee1822bc5 = /*#__PURE__*/ $2c544a34519e5d64$export$4659b591c19bdf3d((0, $kj6DU.constNull), (0, $kj6DU.identity));
var $2c544a34519e5d64$export$cb585b8513fa8577 = /*#__PURE__*/ $2c544a34519e5d64$export$4659b591c19bdf3d((0, $kj6DU.constUndefined), (0, $kj6DU.identity));
function $2c544a34519e5d64$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $2c544a34519e5d64$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $2c544a34519e5d64$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $2c544a34519e5d64$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $2c544a34519e5d64$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $2c544a34519e5d64$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $2c544a34519e5d64$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($2c544a34519e5d64$export$bd5b6bfc5fa2ee61);
var $2c544a34519e5d64$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($2c544a34519e5d64$export$bd5b6bfc5fa2ee61);
var $2c544a34519e5d64$export$2385a24977818dd0 = /*#__PURE__*/ $dya6d.bind($2c544a34519e5d64$export$f18d5acc27d70423);
var $2c544a34519e5d64$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($2c544a34519e5d64$export$efc21ddc6aeb363d);
var $2c544a34519e5d64$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $2c544a34519e5d64$export$ba255e9e49e00608($lOGTm.emptyReadonlyArray);
var $2c544a34519e5d64$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $lOGTm.head(as));
        if ($2c544a34519e5d64$export$e56af863d5645d5f(o)) return $2c544a34519e5d64$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($2c544a34519e5d64$export$e56af863d5645d5f(o_1)) return $2c544a34519e5d64$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $2c544a34519e5d64$export$ad14ef4001db2bcd(out);
    };
};
var $2c544a34519e5d64$export$d4e79db5dc14cc1 = function(f) {
    var g = $2c544a34519e5d64$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $2c544a34519e5d64$export$c74b6e34b2b6efb0;
    };
};
var $2c544a34519e5d64$export$104a2841e9cbad06 = $2c544a34519e5d64$export$d4e79db5dc14cc1;
var $2c544a34519e5d64$export$64f39b2a2b79e1b1 = function(f) {
    return $2c544a34519e5d64$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $2c544a34519e5d64$export$d330b60315c14cd1 = /*#__PURE__*/ $2c544a34519e5d64$export$64f39b2a2b79e1b1((0, $kj6DU.identity));
var $2c544a34519e5d64$export$e08e3b67e392101e = $2c544a34519e5d64$export$5b8affa63fc6df16;
var $2c544a34519e5d64$export$e3821ef4970c339c = $2c544a34519e5d64$export$3f23594af5f37336;
function $2c544a34519e5d64$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $2c544a34519e5d64$export$5d7e502287836e58(getOption(a));
    };
}
var $2c544a34519e5d64$export$c2a8dfc107523e74 = $2c544a34519e5d64$export$c81f992c08fd0bf3;
var $2c544a34519e5d64$export$a75d1723e6bda2ec = {
    URI: $2c544a34519e5d64$export$9156e739aa33e19f,
    map: $2c544a34519e5d64$var$_map,
    of: $2c544a34519e5d64$export$ba255e9e49e00608,
    ap: $2c544a34519e5d64$var$_ap,
    chain: $2c544a34519e5d64$export$5b8affa63fc6df16,
    reduce: $2c544a34519e5d64$var$_reduce,
    foldMap: $2c544a34519e5d64$var$_foldMap,
    reduceRight: $2c544a34519e5d64$var$_reduceRight,
    traverse: $2c544a34519e5d64$var$_traverse,
    sequence: $2c544a34519e5d64$export$49bb65c2ea163039,
    zero: $2c544a34519e5d64$export$7f9972325ebfd559,
    alt: $2c544a34519e5d64$var$_alt,
    extend: $2c544a34519e5d64$var$_extend,
    compact: $2c544a34519e5d64$export$8e16b83750b44988,
    separate: $2c544a34519e5d64$export$709f6946f4e97408,
    filter: $2c544a34519e5d64$var$_filter,
    filterMap: $2c544a34519e5d64$var$_filterMap,
    partition: $2c544a34519e5d64$var$_partition,
    partitionMap: $2c544a34519e5d64$var$_partitionMap,
    wither: $2c544a34519e5d64$var$_wither,
    wilt: $2c544a34519e5d64$var$_wilt,
    throwError: $2c544a34519e5d64$export$8bf7aba4a9e09055
};
var $2c544a34519e5d64$export$18979a515d2a828e = /*#__PURE__*/ (0, $j7Bi0.getApplySemigroup)($2c544a34519e5d64$export$efc21ddc6aeb363d);
var $2c544a34519e5d64$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $dYcKb.getApplicativeMonoid)($2c544a34519e5d64$export$1279d2b7807629fd);
var $2c544a34519e5d64$export$56cd0d85e73e688f = function() {
    return $2c544a34519e5d64$export$c2a7ef2cc9b32b31((0, $flrom.first)());
};
var $2c544a34519e5d64$export$ca391a563a1f3001 = function() {
    return $2c544a34519e5d64$export$c2a7ef2cc9b32b31((0, $flrom.last)());
};

});
parcelRegister("dYcKb", function(module, exports) {

$parcel$export(module.exports, "getApplicativeMonoid", function () { return $a2bac39af8e800c1$export$c8e1a8ea383fd0ff; });
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 
var $j7Bi0 = parcelRequire("j7Bi0");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");
function $a2bac39af8e800c1$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $j7Bi0.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $a2bac39af8e800c1$export$9833a940afed18f3(F, G) {
    var map = (0, $6baua.getFunctorComposition)(F, G).map;
    var _ap = (0, $j7Bi0.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $kj6DU.pipe)(fgab, _ap(fga));
        }
    };
}

});

parcelRegister("lSBre", function(module, exports) {

$parcel$export(module.exports, "contramap", function () { return $fedbae91b4885adb$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "URI", function () { return $fedbae91b4885adb$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getSemigroupAny", function () { return $fedbae91b4885adb$export$45c71cec3a7e90aa; });
$parcel$export(module.exports, "or", function () { return $fedbae91b4885adb$export$252bb8b3bbdf6749; });
$parcel$export(module.exports, "getMonoidAny", function () { return $fedbae91b4885adb$export$d795ff673668f564; });
$parcel$export(module.exports, "getSemigroupAll", function () { return $fedbae91b4885adb$export$d900a29579818780; });
$parcel$export(module.exports, "and", function () { return $fedbae91b4885adb$export$21c0ac7fe1cef1b8; });
$parcel$export(module.exports, "getMonoidAll", function () { return $fedbae91b4885adb$export$4c43b04d78b174fa; });
$parcel$export(module.exports, "Contravariant", function () { return $fedbae91b4885adb$export$def901a57d5539c3; });
$parcel$export(module.exports, "not", function () { return $fedbae91b4885adb$export$6003a5f097c73977; });

var $kj6DU = parcelRequire("kj6DU");
var $fedbae91b4885adb$var$contramap_ = function(predicate, f) {
    return (0, $kj6DU.pipe)(predicate, $fedbae91b4885adb$export$53b696d27ecb7ba7(f));
};
var $fedbae91b4885adb$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $kj6DU.flow)(f, predicate);
    };
};
var $fedbae91b4885adb$export$9156e739aa33e19f = 'Predicate';
var $fedbae91b4885adb$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $kj6DU.pipe)(first, $fedbae91b4885adb$export$252bb8b3bbdf6749(second));
        }
    };
};
var $fedbae91b4885adb$export$d795ff673668f564 = function() {
    return {
        concat: $fedbae91b4885adb$export$45c71cec3a7e90aa().concat,
        empty: (0, $kj6DU.constFalse)
    };
};
var $fedbae91b4885adb$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $kj6DU.pipe)(first, $fedbae91b4885adb$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $fedbae91b4885adb$export$4c43b04d78b174fa = function() {
    return {
        concat: $fedbae91b4885adb$export$d900a29579818780().concat,
        empty: (0, $kj6DU.constTrue)
    };
};
var $fedbae91b4885adb$export$def901a57d5539c3 = {
    URI: $fedbae91b4885adb$export$9156e739aa33e19f,
    contramap: $fedbae91b4885adb$var$contramap_
};
var $fedbae91b4885adb$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $fedbae91b4885adb$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $fedbae91b4885adb$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};

});


parcelRegister("6piwk", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $4aa371a5447951c3$export$a4627e546088548d; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $kj6DU = parcelRequire("kj6DU");
function $4aa371a5447951c3$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $4aa371a5447951c3$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $4aa371a5447951c3$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $4aa371a5447951c3$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $4aa371a5447951c3$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $4aa371a5447951c3$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $4aa371a5447951c3$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $4aa371a5447951c3$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $4aa371a5447951c3$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $4aa371a5447951c3$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $4aa371a5447951c3$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $4aa371a5447951c3$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $4aa371a5447951c3$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $4aa371a5447951c3$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $4aa371a5447951c3$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $4aa371a5447951c3$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $4aa371a5447951c3$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $4aa371a5447951c3$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $4aa371a5447951c3$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $4aa371a5447951c3$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $4aa371a5447951c3$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $4aa371a5447951c3$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $4aa371a5447951c3$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $4aa371a5447951c3$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $4aa371a5447951c3$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $4aa371a5447951c3$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $4aa371a5447951c3$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $4aa371a5447951c3$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $4aa371a5447951c3$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $4aa371a5447951c3$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $4aa371a5447951c3$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $4aa371a5447951c3$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $4aa371a5447951c3$export$1124ffa357d27237(I) {
    var r = {};
    if ($4aa371a5447951c3$var$isFunctor(I)) r.map = $4aa371a5447951c3$export$871de8747c9eaa88(I);
    if ($4aa371a5447951c3$var$isContravariant(I)) r.contramap = $4aa371a5447951c3$export$53b696d27ecb7ba7(I);
    if ($4aa371a5447951c3$var$isFunctorWithIndex(I)) r.mapWithIndex = $4aa371a5447951c3$export$8f07ddce13659f50(I);
    if ($4aa371a5447951c3$var$isApply(I)) {
        r.ap = $4aa371a5447951c3$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $j7Bi0.apFirst)(I);
        r.apSecond = (0, $j7Bi0.apSecond)(I);
    }
    if ($4aa371a5447951c3$var$isChain(I)) {
        r.chain = $4aa371a5447951c3$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $dya6d.chainFirst)(I);
        r.flatten = r.chain((0, $kj6DU.identity));
    }
    if ($4aa371a5447951c3$var$isBifunctor(I)) {
        r.bimap = $4aa371a5447951c3$export$eb54baf0b342cb1d(I);
        r.mapLeft = $4aa371a5447951c3$export$472de43a55e4aa49(I);
    }
    if ($4aa371a5447951c3$var$isExtend(I)) {
        r.extend = $4aa371a5447951c3$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $kj6DU.identity));
    }
    if ($4aa371a5447951c3$var$isFoldable(I)) {
        r.reduce = $4aa371a5447951c3$export$533b26079ad0b4b(I);
        r.foldMap = $4aa371a5447951c3$export$b66cdc0497d8a99a(I);
        r.reduceRight = $4aa371a5447951c3$export$7fef8bcdbb34f435(I);
    }
    if ($4aa371a5447951c3$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $4aa371a5447951c3$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $4aa371a5447951c3$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $4aa371a5447951c3$export$ce2b2fe0b88ccd0a(I);
    }
    if ($4aa371a5447951c3$var$isAlt(I)) r.alt = $4aa371a5447951c3$export$228be17d80722ab(I);
    if ($4aa371a5447951c3$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($4aa371a5447951c3$var$isFilterable(I)) {
        r.filter = $4aa371a5447951c3$export$3dea766d36a8935f(I);
        r.filterMap = $4aa371a5447951c3$export$a04c6c6965dd4709(I);
        r.partition = $4aa371a5447951c3$export$b29f828819edca8d(I);
        r.partitionMap = $4aa371a5447951c3$export$3117e3f9ececb6bc(I);
    }
    if ($4aa371a5447951c3$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $4aa371a5447951c3$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $4aa371a5447951c3$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $4aa371a5447951c3$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $4aa371a5447951c3$export$bc7c0794b9c6f3ba(I);
    }
    if ($4aa371a5447951c3$var$isProfunctor(I)) r.promap = $4aa371a5447951c3$export$6684e88861ab74ec(I);
    if ($4aa371a5447951c3$var$isSemigroupoid(I)) r.compose = $4aa371a5447951c3$export$f672e0b6f7222cd7(I);
    if ($4aa371a5447951c3$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $4aa371a5447951c3$export$a4627e546088548d = (0, $kj6DU.pipe);

});

parcelRegister("k2VKN", function(module, exports) {

$parcel$export(module.exports, "fromIso", function () { return $e980cb3c5cb32f06$export$3160d47a1ad63980; });

var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");

var $8RK6P = parcelRequire("8RK6P");

var $goBZ5 = parcelRequire("goBZ5");

var $cQdlc = parcelRequire("cQdlc");
var $e980cb3c5cb32f06$export$493d36ec626b6698 = $cQdlc.at;
var $e980cb3c5cb32f06$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $e980cb3c5cb32f06$export$493d36ec626b6698(function(i) {
            return (0, $6piwk.pipe)(iso, $cQdlc.isoAsLens, $cQdlc.lensComposeLens(sia.at(i)));
        });
    };
};
var $e980cb3c5cb32f06$export$ba8573d258bae607 = $cQdlc.atReadonlyRecord;
var $e980cb3c5cb32f06$export$3d6583cb45ca961e = function(E) {
    var lookupE = $8RK6P.lookup(E);
    var deleteAtE = $8RK6P.deleteAt(E);
    var insertAtE = $8RK6P.insertAt(E);
    return function() {
        return $e980cb3c5cb32f06$export$493d36ec626b6698(function(key) {
            return $cQdlc.lens(function(s) {
                return lookupE(key, s);
            }, $3NXK3.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $e980cb3c5cb32f06$export$388a7d8e51ea972f = function(E) {
    var elemE = $goBZ5.elem(E);
    var insertE = $goBZ5.insert(E);
    var removeE = $goBZ5.remove(E);
    return $e980cb3c5cb32f06$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $cQdlc.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $e980cb3c5cb32f06$export$1cfc761eca4929a9 = $cQdlc.atReadonlyRecord;

});
parcelRegister("8RK6P", function(module, exports) {

$parcel$export(module.exports, "fromMap", function () { return $67470a444afacfd5$export$d81aa96f14f987cc; });
$parcel$export(module.exports, "toMap", function () { return $67470a444afacfd5$export$e98af36a72b77685; });
$parcel$export(module.exports, "getShow", function () { return $67470a444afacfd5$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "size", function () { return $67470a444afacfd5$export$346677f925de839c; });
$parcel$export(module.exports, "isEmpty", function () { return $67470a444afacfd5$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "member", function () { return $67470a444afacfd5$export$6a0d13241802fe80; });
$parcel$export(module.exports, "lookup", function () { return $67470a444afacfd5$export$dfc7155ac0343b8; });
$parcel$export(module.exports, "elem", function () { return $67470a444afacfd5$export$5bf96401662340b7; });
$parcel$export(module.exports, "keys", function () { return $67470a444afacfd5$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $67470a444afacfd5$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "collect", function () { return $67470a444afacfd5$export$bb44f104e3c54dae; });
$parcel$export(module.exports, "toReadonlyArray", function () { return $67470a444afacfd5$export$4aaa3912a3956cb7; });
$parcel$export(module.exports, "toUnfoldable", function () { return $67470a444afacfd5$export$823be24f8766da23; });
$parcel$export(module.exports, "upsertAt", function () { return $67470a444afacfd5$export$ff82449ce381c54a; });
$parcel$export(module.exports, "lookupWithKey", function () { return $67470a444afacfd5$export$40b8019a6fc8a5ae; });
$parcel$export(module.exports, "deleteAt", function () { return $67470a444afacfd5$export$90f9093465da3136; });
$parcel$export(module.exports, "updateAt", function () { return $67470a444afacfd5$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $67470a444afacfd5$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "pop", function () { return $67470a444afacfd5$export$3e41007ebfff0e64; });
$parcel$export(module.exports, "isSubmap", function () { return $67470a444afacfd5$export$35d0420a84c5d3ae; });
$parcel$export(module.exports, "empty", function () { return $67470a444afacfd5$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "getEq", function () { return $67470a444afacfd5$export$804fed467fde44e4; });
$parcel$export(module.exports, "getMonoid", function () { return $67470a444afacfd5$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "singleton", function () { return $67470a444afacfd5$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "fromFoldable", function () { return $67470a444afacfd5$export$b7d5d9bb9ff52072; });
$parcel$export(module.exports, "partitionMapWithIndex", function () { return $67470a444afacfd5$export$bc7c0794b9c6f3ba; });
$parcel$export(module.exports, "partitionWithIndex", function () { return $67470a444afacfd5$export$dad5e500f2bab9bc; });
$parcel$export(module.exports, "filterMapWithIndex", function () { return $67470a444afacfd5$export$30c5cbe848021e97; });
$parcel$export(module.exports, "filterWithIndex", function () { return $67470a444afacfd5$export$36e42aef19fc7171; });
$parcel$export(module.exports, "compact", function () { return $67470a444afacfd5$export$8e16b83750b44988; });
$parcel$export(module.exports, "filter", function () { return $67470a444afacfd5$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $67470a444afacfd5$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "map", function () { return $67470a444afacfd5$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapWithIndex", function () { return $67470a444afacfd5$export$8f07ddce13659f50; });
$parcel$export(module.exports, "partition", function () { return $67470a444afacfd5$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $67470a444afacfd5$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "separate", function () { return $67470a444afacfd5$export$709f6946f4e97408; });
$parcel$export(module.exports, "URI", function () { return $67470a444afacfd5$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $67470a444afacfd5$export$baca17b4aff42f82; });
$parcel$export(module.exports, "union", function () { return $67470a444afacfd5$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $67470a444afacfd5$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $67470a444afacfd5$export$d379a869a72e4055; });
$parcel$export(module.exports, "intersection", function () { return $67470a444afacfd5$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $67470a444afacfd5$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "difference", function () { return $67470a444afacfd5$export$acaf96a27438246b; });
$parcel$export(module.exports, "getFilterableWithIndex", function () { return $67470a444afacfd5$export$d600270efcad85ac; });
$parcel$export(module.exports, "Functor", function () { return $67470a444afacfd5$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $67470a444afacfd5$export$18c957606d8bdf09; });
$parcel$export(module.exports, "getFunctorWithIndex", function () { return $67470a444afacfd5$export$7c7748da5f3db60f; });
$parcel$export(module.exports, "Compactable", function () { return $67470a444afacfd5$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $67470a444afacfd5$export$d00e1c48fb621173; });
$parcel$export(module.exports, "reduce", function () { return $67470a444afacfd5$export$533b26079ad0b4b; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $67470a444afacfd5$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMap", function () { return $67470a444afacfd5$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $67470a444afacfd5$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRight", function () { return $67470a444afacfd5$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $67470a444afacfd5$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "getFoldable", function () { return $67470a444afacfd5$export$d544f02c7cebdaed; });
$parcel$export(module.exports, "getFoldableWithIndex", function () { return $67470a444afacfd5$export$6c59d75f118e7bc9; });
$parcel$export(module.exports, "getTraversable", function () { return $67470a444afacfd5$export$4e0ffba11065d2c1; });
$parcel$export(module.exports, "getTraversableWithIndex", function () { return $67470a444afacfd5$export$46b81797a3375b8c; });
$parcel$export(module.exports, "getWitherable", function () { return $67470a444afacfd5$export$bb8ef26a634cac7b; });
$parcel$export(module.exports, "insertAt", function () { return $67470a444afacfd5$export$9f200c4466975173; });
$parcel$export(module.exports, "readonlyMap", function () { return $67470a444afacfd5$export$28562fb56044e6b5; });

var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $3NXK3 = parcelRequire("3NXK3");

var $aRVRH = parcelRequire("aRVRH");

var $LdARg = parcelRequire("LdARg");
var $67470a444afacfd5$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $67470a444afacfd5$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $67470a444afacfd5$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $67470a444afacfd5$export$346677f925de839c = function(m) {
    return m.size;
};
var $67470a444afacfd5$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $67470a444afacfd5$export$6a0d13241802fe80(E) {
    var lookupE = $67470a444afacfd5$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $67470a444afacfd5$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $lOGTm.isSome(lookupE(k, m));
    };
}
function $67470a444afacfd5$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $67470a444afacfd5$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $67470a444afacfd5$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $67470a444afacfd5$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $67470a444afacfd5$export$bb44f104e3c54dae(O) {
    var keysO = $67470a444afacfd5$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $67470a444afacfd5$export$4aaa3912a3956cb7 = function(O) {
    return $67470a444afacfd5$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $67470a444afacfd5$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $67470a444afacfd5$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $lOGTm.some([
                kas[b],
                b + 1
            ]) : $lOGTm.none;
        });
    };
}
var $67470a444afacfd5$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $67470a444afacfd5$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($lOGTm.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $67470a444afacfd5$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $67470a444afacfd5$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($lOGTm.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $67470a444afacfd5$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $67470a444afacfd5$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $67470a444afacfd5$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $67470a444afacfd5$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($lOGTm.isNone(found)) return $lOGTm.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $lOGTm.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $lOGTm.some(r);
        };
    };
};
function $67470a444afacfd5$export$3e41007ebfff0e64(E) {
    var lookupE = $67470a444afacfd5$export$dfc7155ac0343b8(E);
    var deleteAtE = $67470a444afacfd5$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $kj6DU.pipe)(lookupE(k, m), $3NXK3.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $67470a444afacfd5$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $67470a444afacfd5$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $lOGTm.some([
                ka,
                a
            ]);
        }
        return $lOGTm.none;
    };
}
function $67470a444afacfd5$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $67470a444afacfd5$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $67470a444afacfd5$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $kj6DU.pipe)(lookupWithKeyE(k, m), $3NXK3.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $67470a444afacfd5$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $67470a444afacfd5$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $67470a444afacfd5$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($lOGTm.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $67470a444afacfd5$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $67470a444afacfd5$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $67470a444afacfd5$export$35d0420a84c5d3ae(SK, SA);
    return (0, $9RyKW.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $67470a444afacfd5$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $67470a444afacfd5$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(mx)) return my;
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($lOGTm.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $67470a444afacfd5$export$6e22c362a0406a2c
    };
}
var $67470a444afacfd5$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $67470a444afacfd5$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $67470a444afacfd5$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($lOGTm.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $67470a444afacfd5$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $67470a444afacfd5$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($lOGTm.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $aRVRH.separated)(left, right);
    };
};
function $67470a444afacfd5$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $aRVRH.separated)(left, right);
    };
}
var $67470a444afacfd5$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($lOGTm.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $67470a444afacfd5$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $67470a444afacfd5$var$_map = function(fa, f) {
    return $67470a444afacfd5$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $67470a444afacfd5$var$_filter = function(fa, p) {
    return $67470a444afacfd5$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $67470a444afacfd5$var$_filterMap = function(fa, f) {
    return $67470a444afacfd5$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $67470a444afacfd5$var$_partition = function(fa, predicate) {
    return $67470a444afacfd5$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $67470a444afacfd5$var$_partitionMap = function(fa, f) {
    return $67470a444afacfd5$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $67470a444afacfd5$var$_filterWithIndex = function(fa, p) {
    return (0, $kj6DU.pipe)(fa, $67470a444afacfd5$export$36e42aef19fc7171(p));
};
var $67470a444afacfd5$var$_filterMapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $67470a444afacfd5$export$30c5cbe848021e97(f));
};
var $67470a444afacfd5$var$_partitionWithIndex = function(fa, p) {
    return (0, $kj6DU.pipe)(fa, $67470a444afacfd5$export$dad5e500f2bab9bc(p));
};
var $67470a444afacfd5$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $67470a444afacfd5$export$bc7c0794b9c6f3ba(f));
};
var $67470a444afacfd5$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($lOGTm.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
var $67470a444afacfd5$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $67470a444afacfd5$var$_filter(fa, predicate);
    };
};
var $67470a444afacfd5$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $67470a444afacfd5$var$_filterMap(fa, f);
    };
};
var $67470a444afacfd5$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $67470a444afacfd5$var$_map(fa, f);
    };
};
var $67470a444afacfd5$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $67470a444afacfd5$var$_mapWithIndex(fa, f);
    };
};
var $67470a444afacfd5$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $67470a444afacfd5$var$_partition(fa, predicate);
    };
};
var $67470a444afacfd5$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $67470a444afacfd5$var$_partitionMap(fa, f);
    };
};
var $67470a444afacfd5$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($lOGTm.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $aRVRH.separated)(left, right);
};
var $67470a444afacfd5$export$9156e739aa33e19f = 'ReadonlyMap';
var $67470a444afacfd5$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $67470a444afacfd5$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $67470a444afacfd5$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $67470a444afacfd5$export$baca17b4aff42f82(E, S).concat,
        empty: $67470a444afacfd5$export$6e22c362a0406a2c
    };
};
var $67470a444afacfd5$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $67470a444afacfd5$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $67470a444afacfd5$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $67470a444afacfd5$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $67470a444afacfd5$export$d600270efcad85ac() {
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        map: $67470a444afacfd5$var$_map,
        mapWithIndex: $67470a444afacfd5$var$_mapWithIndex,
        compact: $67470a444afacfd5$export$8e16b83750b44988,
        separate: $67470a444afacfd5$export$709f6946f4e97408,
        filter: $67470a444afacfd5$var$_filter,
        filterMap: $67470a444afacfd5$var$_filterMap,
        partition: $67470a444afacfd5$var$_partition,
        partitionMap: $67470a444afacfd5$var$_partitionMap,
        partitionMapWithIndex: $67470a444afacfd5$var$_partitionMapWithIndex,
        partitionWithIndex: $67470a444afacfd5$var$_partitionWithIndex,
        filterMapWithIndex: $67470a444afacfd5$var$_filterMapWithIndex,
        filterWithIndex: $67470a444afacfd5$var$_filterWithIndex
    };
}
var $67470a444afacfd5$export$bd5b6bfc5fa2ee61 = {
    URI: $67470a444afacfd5$export$9156e739aa33e19f,
    map: $67470a444afacfd5$var$_map
};
var $67470a444afacfd5$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($67470a444afacfd5$export$bd5b6bfc5fa2ee61);
var $67470a444afacfd5$export$7c7748da5f3db60f = function() {
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        map: $67470a444afacfd5$var$_map,
        mapWithIndex: $67470a444afacfd5$var$_mapWithIndex
    };
};
var $67470a444afacfd5$export$4a21ac48141ac3c9 = {
    URI: $67470a444afacfd5$export$9156e739aa33e19f,
    compact: $67470a444afacfd5$export$8e16b83750b44988,
    separate: $67470a444afacfd5$export$709f6946f4e97408
};
var $67470a444afacfd5$export$d00e1c48fb621173 = {
    URI: $67470a444afacfd5$export$9156e739aa33e19f,
    map: $67470a444afacfd5$var$_map,
    compact: $67470a444afacfd5$export$8e16b83750b44988,
    separate: $67470a444afacfd5$export$709f6946f4e97408,
    filter: $67470a444afacfd5$var$_filter,
    filterMap: $67470a444afacfd5$var$_filterMap,
    partition: $67470a444afacfd5$var$_partition,
    partitionMap: $67470a444afacfd5$var$_partitionMap
};
var $67470a444afacfd5$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $67470a444afacfd5$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $67470a444afacfd5$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $67470a444afacfd5$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $67470a444afacfd5$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $67470a444afacfd5$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $67470a444afacfd5$export$d544f02c7cebdaed = function(O) {
    var reduceO = $67470a444afacfd5$export$533b26079ad0b4b(O);
    var foldMapO = $67470a444afacfd5$export$b66cdc0497d8a99a(O);
    var reduceRightO = $67470a444afacfd5$export$7fef8bcdbb34f435(O);
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $kj6DU.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $kj6DU.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $kj6DU.pipe)(fa, reduceRightO(b, f));
        }
    };
};
var $67470a444afacfd5$export$bbd3ef8720e22369 = function(O) {
    var keysO = $67470a444afacfd5$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $67470a444afacfd5$export$18153bb1181268e5 = function(O) {
    var keysO = $67470a444afacfd5$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $67470a444afacfd5$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $67470a444afacfd5$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $67470a444afacfd5$export$6c59d75f118e7bc9 = function(O) {
    var F = $67470a444afacfd5$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $67470a444afacfd5$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $67470a444afacfd5$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $67470a444afacfd5$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $kj6DU.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $kj6DU.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $kj6DU.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $67470a444afacfd5$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $67470a444afacfd5$export$46b81797a3375b8c(O);
    var F = $67470a444afacfd5$export$d544f02c7cebdaed(O);
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        map: $67470a444afacfd5$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $67470a444afacfd5$export$46b81797a3375b8c = function(O) {
    var FWI = $67470a444afacfd5$export$6c59d75f118e7bc9(O);
    var keysO = $67470a444afacfd5$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $kj6DU.SK));
        };
    };
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        map: $67470a444afacfd5$var$_map,
        mapWithIndex: $67470a444afacfd5$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $67470a444afacfd5$export$bb8ef26a634cac7b(O) {
    var TWI = $67470a444afacfd5$export$46b81797a3375b8c(O);
    return {
        URI: $67470a444afacfd5$export$9156e739aa33e19f,
        _E: undefined,
        map: $67470a444afacfd5$var$_map,
        compact: $67470a444afacfd5$export$8e16b83750b44988,
        separate: $67470a444afacfd5$export$709f6946f4e97408,
        filter: $67470a444afacfd5$var$_filter,
        filterMap: $67470a444afacfd5$var$_filterMap,
        partition: $67470a444afacfd5$var$_partition,
        partitionMap: $67470a444afacfd5$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $67470a444afacfd5$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $LdARg.wiltDefault)(TWI, $67470a444afacfd5$export$4a21ac48141ac3c9),
        wither: (0, $LdARg.witherDefault)(TWI, $67470a444afacfd5$export$4a21ac48141ac3c9)
    };
}
var $67470a444afacfd5$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $67470a444afacfd5$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(first)) return second;
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($lOGTm.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($lOGTm.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $67470a444afacfd5$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $67470a444afacfd5$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(first) || $67470a444afacfd5$export$dd1bc94b04021eeb(second)) return $67470a444afacfd5$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($lOGTm.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $67470a444afacfd5$export$acaf96a27438246b = function(E) {
    var memberE = $67470a444afacfd5$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(first)) return second;
            if ($67470a444afacfd5$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $67470a444afacfd5$export$9f200c4466975173 = $67470a444afacfd5$export$ff82449ce381c54a;
var $67470a444afacfd5$export$28562fb56044e6b5 = {
    URI: $67470a444afacfd5$export$9156e739aa33e19f,
    map: $67470a444afacfd5$var$_map,
    compact: $67470a444afacfd5$export$8e16b83750b44988,
    separate: $67470a444afacfd5$export$709f6946f4e97408,
    filter: $67470a444afacfd5$var$_filter,
    filterMap: $67470a444afacfd5$var$_filterMap,
    partition: $67470a444afacfd5$var$_partition,
    partitionMap: $67470a444afacfd5$var$_partitionMap
};

});

parcelRegister("goBZ5", function(module, exports) {

$parcel$export(module.exports, "fromSet", function () { return $befc5a1d55c22ad4$export$7d98477f9d1e986f; });
$parcel$export(module.exports, "singleton", function () { return $befc5a1d55c22ad4$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "fromReadonlyArray", function () { return $befc5a1d55c22ad4$export$9288e031f1846591; });
$parcel$export(module.exports, "elem", function () { return $befc5a1d55c22ad4$export$5bf96401662340b7; });
$parcel$export(module.exports, "toSet", function () { return $befc5a1d55c22ad4$export$f416efe173c6901c; });
$parcel$export(module.exports, "map", function () { return $befc5a1d55c22ad4$export$871de8747c9eaa88; });
$parcel$export(module.exports, "chain", function () { return $befc5a1d55c22ad4$export$e08e3b67e392101e; });
$parcel$export(module.exports, "filter", function () { return $befc5a1d55c22ad4$export$3dea766d36a8935f; });
$parcel$export(module.exports, "partition", function () { return $befc5a1d55c22ad4$export$b29f828819edca8d; });
$parcel$export(module.exports, "union", function () { return $befc5a1d55c22ad4$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "isEmpty", function () { return $befc5a1d55c22ad4$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "intersection", function () { return $befc5a1d55c22ad4$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "empty", function () { return $befc5a1d55c22ad4$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "partitionMap", function () { return $befc5a1d55c22ad4$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "difference", function () { return $befc5a1d55c22ad4$export$acaf96a27438246b; });
$parcel$export(module.exports, "reduce", function () { return $befc5a1d55c22ad4$export$533b26079ad0b4b; });
$parcel$export(module.exports, "toReadonlyArray", function () { return $befc5a1d55c22ad4$export$4aaa3912a3956cb7; });
$parcel$export(module.exports, "foldMap", function () { return $befc5a1d55c22ad4$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $befc5a1d55c22ad4$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "insert", function () { return $befc5a1d55c22ad4$export$21a5ca8aa77d35ff; });
$parcel$export(module.exports, "remove", function () { return $befc5a1d55c22ad4$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "toggle", function () { return $befc5a1d55c22ad4$export$e03c1c3201ee8bb7; });
$parcel$export(module.exports, "compact", function () { return $befc5a1d55c22ad4$export$8e16b83750b44988; });
$parcel$export(module.exports, "filterMap", function () { return $befc5a1d55c22ad4$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "separate", function () { return $befc5a1d55c22ad4$export$709f6946f4e97408; });
$parcel$export(module.exports, "size", function () { return $befc5a1d55c22ad4$export$346677f925de839c; });
$parcel$export(module.exports, "some", function () { return $befc5a1d55c22ad4$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "every", function () { return $befc5a1d55c22ad4$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "isSubset", function () { return $befc5a1d55c22ad4$export$af04532ec9ff13d2; });
$parcel$export(module.exports, "URI", function () { return $befc5a1d55c22ad4$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $befc5a1d55c22ad4$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getEq", function () { return $befc5a1d55c22ad4$export$804fed467fde44e4; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $befc5a1d55c22ad4$export$baca17b4aff42f82; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $befc5a1d55c22ad4$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $befc5a1d55c22ad4$export$d379a869a72e4055; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $befc5a1d55c22ad4$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "fromArray", function () { return $befc5a1d55c22ad4$export$571d59b505e6bb4e; });

var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");

var $lSBre = parcelRequire("lSBre");

var $aRVRH = parcelRequire("aRVRH");
var $befc5a1d55c22ad4$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $befc5a1d55c22ad4$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $befc5a1d55c22ad4$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $befc5a1d55c22ad4$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $befc5a1d55c22ad4$export$871de8747c9eaa88(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $befc5a1d55c22ad4$export$e08e3b67e392101e(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $befc5a1d55c22ad4$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $befc5a1d55c22ad4$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $aRVRH.separated)(left, right);
    };
}
function $befc5a1d55c22ad4$export$971dd5b0dfd021b6(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $befc5a1d55c22ad4$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($befc5a1d55c22ad4$export$dd1bc94b04021eeb(me)) return that;
        if ($befc5a1d55c22ad4$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $befc5a1d55c22ad4$export$bc86dfbf7795668c(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $befc5a1d55c22ad4$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($befc5a1d55c22ad4$export$dd1bc94b04021eeb(me) || $befc5a1d55c22ad4$export$dd1bc94b04021eeb(that)) return $befc5a1d55c22ad4$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $befc5a1d55c22ad4$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $befc5a1d55c22ad4$export$5bf96401662340b7(EB);
            var hasC = $befc5a1d55c22ad4$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $aRVRH.separated)(left, right);
        };
    };
}
function $befc5a1d55c22ad4$export$acaf96a27438246b(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $befc5a1d55c22ad4$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $befc5a1d55c22ad4$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $befc5a1d55c22ad4$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $befc5a1d55c22ad4$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $befc5a1d55c22ad4$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $befc5a1d55c22ad4$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $befc5a1d55c22ad4$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $befc5a1d55c22ad4$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $befc5a1d55c22ad4$export$21a5ca8aa77d35ff(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $befc5a1d55c22ad4$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $befc5a1d55c22ad4$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $befc5a1d55c22ad4$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    var removeE = $befc5a1d55c22ad4$export$cd7f480d6b8286c3(E);
    var insertE = $befc5a1d55c22ad4$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $befc5a1d55c22ad4$export$8e16b83750b44988 = function(E) {
    return $befc5a1d55c22ad4$export$a04c6c6965dd4709(E)((0, $kj6DU.identity));
};
function $befc5a1d55c22ad4$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $befc5a1d55c22ad4$export$5bf96401662340b7(EE);
        var elemEA = $befc5a1d55c22ad4$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $aRVRH.separated)(left, right);
    };
}
function $befc5a1d55c22ad4$export$a04c6c6965dd4709(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $befc5a1d55c22ad4$export$6e22c362a0406a2c = new Set();
var $befc5a1d55c22ad4$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $befc5a1d55c22ad4$export$346677f925de839c = function(set) {
    return set.size;
};
var $befc5a1d55c22ad4$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $befc5a1d55c22ad4$export$7ecc1a3b11b57dab(predicate) {
    return (0, $lSBre.not)($befc5a1d55c22ad4$export$ad14ef4001db2bcd((0, $lSBre.not)(predicate)));
}
function $befc5a1d55c22ad4$export$af04532ec9ff13d2(E) {
    var elemE = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $befc5a1d55c22ad4$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $befc5a1d55c22ad4$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $befc5a1d55c22ad4$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $befc5a1d55c22ad4$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $befc5a1d55c22ad4$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $befc5a1d55c22ad4$export$9156e739aa33e19f = 'ReadonlySet';
function $befc5a1d55c22ad4$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $befc5a1d55c22ad4$export$804fed467fde44e4(E) {
    var subsetE = $befc5a1d55c22ad4$export$af04532ec9ff13d2(E);
    return (0, $9RyKW.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $befc5a1d55c22ad4$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $befc5a1d55c22ad4$export$971dd5b0dfd021b6(E)
    };
};
var $befc5a1d55c22ad4$export$c487aac9f4157837 = function(E) {
    return {
        concat: $befc5a1d55c22ad4$export$baca17b4aff42f82(E).concat,
        empty: $befc5a1d55c22ad4$export$6e22c362a0406a2c
    };
};
var $befc5a1d55c22ad4$export$d379a869a72e4055 = function(E) {
    return {
        concat: $befc5a1d55c22ad4$export$bc86dfbf7795668c(E)
    };
};
var $befc5a1d55c22ad4$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $befc5a1d55c22ad4$export$acaf96a27438246b(E)
    };
};
var $befc5a1d55c22ad4$export$571d59b505e6bb4e = $befc5a1d55c22ad4$export$9288e031f1846591;

});

parcelRegister("cQdlc", function(module, exports) {

$parcel$export(module.exports, "iso", function () { return $9594b095b272a1de$export$1aba8f741a0eae06; });
$parcel$export(module.exports, "isoAsLens", function () { return $9594b095b272a1de$export$d001ee9513dee7c1; });
$parcel$export(module.exports, "lens", function () { return $9594b095b272a1de$export$21cde5187c2605a3; });
$parcel$export(module.exports, "isoAsPrism", function () { return $9594b095b272a1de$export$fde8c5b9dff57abc; });
$parcel$export(module.exports, "prism", function () { return $9594b095b272a1de$export$e469dcfea9910464; });
$parcel$export(module.exports, "isoAsOptional", function () { return $9594b095b272a1de$export$4d3db894cf45abd5; });
$parcel$export(module.exports, "optional", function () { return $9594b095b272a1de$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "isoAsTraversal", function () { return $9594b095b272a1de$export$e55a826b3ba968d2; });
$parcel$export(module.exports, "traversal", function () { return $9594b095b272a1de$export$8666ce7a134c2314; });
$parcel$export(module.exports, "lensAsOptional", function () { return $9594b095b272a1de$export$bae94c671b4dc75d; });
$parcel$export(module.exports, "lensAsTraversal", function () { return $9594b095b272a1de$export$e5de01c31c85830c; });
$parcel$export(module.exports, "lensComposeLens", function () { return $9594b095b272a1de$export$62d1b5266563d2b6; });
$parcel$export(module.exports, "prismComposePrism", function () { return $9594b095b272a1de$export$af9c087537c23eb1; });
$parcel$export(module.exports, "lensComposePrism", function () { return $9594b095b272a1de$export$ffffe1ca21811d93; });
$parcel$export(module.exports, "optionalComposeOptional", function () { return $9594b095b272a1de$export$8e08893559c32e38; });
$parcel$export(module.exports, "prismAsOptional", function () { return $9594b095b272a1de$export$70f4d204f3bdc8bd; });
$parcel$export(module.exports, "lensId", function () { return $9594b095b272a1de$export$a4b03755c6673298; });
$parcel$export(module.exports, "lensProp", function () { return $9594b095b272a1de$export$a6ba95b157529836; });
$parcel$export(module.exports, "lensProps", function () { return $9594b095b272a1de$export$c19575454e66bf5f; });
$parcel$export(module.exports, "lensComponent", function () { return $9594b095b272a1de$export$103f2a6258fae742; });
$parcel$export(module.exports, "lensAtKey", function () { return $9594b095b272a1de$export$fc68a3bfc89f0b98; });
$parcel$export(module.exports, "atReadonlyRecord", function () { return $9594b095b272a1de$export$ba8573d258bae607; });
$parcel$export(module.exports, "prismSet", function () { return $9594b095b272a1de$export$97725fa315d6412c; });
$parcel$export(module.exports, "prismAsTraversal", function () { return $9594b095b272a1de$export$18564f4597667b6a; });
$parcel$export(module.exports, "prismModifyOption", function () { return $9594b095b272a1de$export$ddb3ff54eaa1c530; });
$parcel$export(module.exports, "prismModify", function () { return $9594b095b272a1de$export$f545e0bcbe4b5ea7; });
$parcel$export(module.exports, "prismComposeLens", function () { return $9594b095b272a1de$export$dad01448ef670850; });
$parcel$export(module.exports, "prismFromNullable", function () { return $9594b095b272a1de$export$258cc98aa6d7d21b; });
$parcel$export(module.exports, "prismFromPredicate", function () { return $9594b095b272a1de$export$8f316a2f03469694; });
$parcel$export(module.exports, "prismSome", function () { return $9594b095b272a1de$export$782e8b2fe031f968; });
$parcel$export(module.exports, "prismRight", function () { return $9594b095b272a1de$export$929e170fdd93186c; });
$parcel$export(module.exports, "prismLeft", function () { return $9594b095b272a1de$export$97ae81cf28b21f26; });
$parcel$export(module.exports, "optionalAsTraversal", function () { return $9594b095b272a1de$export$a595a5197cc37264; });
$parcel$export(module.exports, "optionalModifyOption", function () { return $9594b095b272a1de$export$48aae8aebe6d3ee9; });
$parcel$export(module.exports, "optionalModify", function () { return $9594b095b272a1de$export$6d575f282c3c1d48; });
$parcel$export(module.exports, "optionalIndex", function () { return $9594b095b272a1de$export$47ac94aa95300c6f; });
$parcel$export(module.exports, "indexReadonlyArray", function () { return $9594b095b272a1de$export$bb0c054375ca4b0; });
$parcel$export(module.exports, "optionalIndexNonEmpty", function () { return $9594b095b272a1de$export$83e62439a4d30c4c; });
$parcel$export(module.exports, "indexReadonlyNonEmptyArray", function () { return $9594b095b272a1de$export$165af7b747e6b1f1; });
$parcel$export(module.exports, "optionalKey", function () { return $9594b095b272a1de$export$a6c26e1663200bf4; });
$parcel$export(module.exports, "indexReadonlyRecord", function () { return $9594b095b272a1de$export$3c3468aec3b83bbf; });
$parcel$export(module.exports, "optionalFindFirst", function () { return $9594b095b272a1de$export$220673392b48821b; });
$parcel$export(module.exports, "optionalFindFirstNonEmpty", function () { return $9594b095b272a1de$export$cf29cfc68de9a659; });
$parcel$export(module.exports, "traversalComposeTraversal", function () { return $9594b095b272a1de$export$2c68ab81171b083f; });
$parcel$export(module.exports, "ApplicativeIdentity", function () { return $9594b095b272a1de$export$7c4912ca011fa00e; });
$parcel$export(module.exports, "fromTraversable", function () { return $9594b095b272a1de$export$126b5a87c58d3f9c; });
$parcel$export(module.exports, "traversalTraverse", function () { return $9594b095b272a1de$export$35db6fcbd934c57; });
$parcel$export(module.exports, "index", function () { return $9594b095b272a1de$export$b610b8812bbcded9; });
$parcel$export(module.exports, "at", function () { return $9594b095b272a1de$export$493d36ec626b6698; });

var $f0bNW = parcelRequire("f0bNW");

var $etcCS = parcelRequire("etcCS");

var $kj6DU = parcelRequire("kj6DU");

var $3NXK3 = parcelRequire("3NXK3");

var $7Rbab = parcelRequire("7Rbab");

var $6piwk = parcelRequire("6piwk");
var $9594b095b272a1de$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9594b095b272a1de$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $9594b095b272a1de$export$d001ee9513dee7c1 = function(sa) {
    return $9594b095b272a1de$export$21cde5187c2605a3(sa.get, (0, $kj6DU.flow)(sa.reverseGet, (0, $kj6DU.constant)));
};
var $9594b095b272a1de$export$fde8c5b9dff57abc = function(sa) {
    return $9594b095b272a1de$export$e469dcfea9910464((0, $kj6DU.flow)(sa.get, $3NXK3.some), sa.reverseGet);
};
var $9594b095b272a1de$export$4d3db894cf45abd5 = function(sa) {
    return $9594b095b272a1de$export$516e28dec6a4b6d4((0, $kj6DU.flow)(sa.get, $3NXK3.some), (0, $kj6DU.flow)(sa.reverseGet, (0, $kj6DU.constant)));
};
var $9594b095b272a1de$export$e55a826b3ba968d2 = function(sa) {
    return $9594b095b272a1de$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $9594b095b272a1de$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $9594b095b272a1de$export$bae94c671b4dc75d = function(sa) {
    return $9594b095b272a1de$export$516e28dec6a4b6d4((0, $kj6DU.flow)(sa.get, $3NXK3.some), sa.set);
};
var $9594b095b272a1de$export$e5de01c31c85830c = function(sa) {
    return $9594b095b272a1de$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $9594b095b272a1de$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $9594b095b272a1de$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $9594b095b272a1de$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $9594b095b272a1de$export$e469dcfea9910464((0, $kj6DU.flow)(sa.getOption, $3NXK3.chain(ab.getOption)), (0, $kj6DU.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $9594b095b272a1de$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $9594b095b272a1de$export$8e08893559c32e38($9594b095b272a1de$export$70f4d204f3bdc8bd(ab))($9594b095b272a1de$export$bae94c671b4dc75d(sa));
    };
};
var $9594b095b272a1de$export$a4b03755c6673298 = function() {
    return $9594b095b272a1de$export$21cde5187c2605a3((0, $kj6DU.identity), (0, $kj6DU.constant));
};
var $9594b095b272a1de$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $9594b095b272a1de$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $9594b095b272a1de$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $9594b095b272a1de$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $9594b095b272a1de$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $9594b095b272a1de$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $9594b095b272a1de$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $9594b095b272a1de$export$62d1b5266563d2b6($9594b095b272a1de$export$ba8573d258bae607().at(key)));
    };
};
var $9594b095b272a1de$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $9594b095b272a1de$export$70f4d204f3bdc8bd = function(sa) {
    return $9594b095b272a1de$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $9594b095b272a1de$export$97725fa315d6412c(a)(sa);
    });
};
var $9594b095b272a1de$export$18564f4597667b6a = function(sa) {
    return $9594b095b272a1de$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $6piwk.pipe)(sa.getOption(s), $3NXK3.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $9594b095b272a1de$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $9594b095b272a1de$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $6piwk.pipe)(sa.getOption(s), $3NXK3.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $9594b095b272a1de$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $9594b095b272a1de$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $6piwk.pipe)(g(s), $3NXK3.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $9594b095b272a1de$export$97725fa315d6412c = function(a) {
    return $9594b095b272a1de$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $9594b095b272a1de$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $9594b095b272a1de$export$8e08893559c32e38($9594b095b272a1de$export$bae94c671b4dc75d(ab))($9594b095b272a1de$export$70f4d204f3bdc8bd(sa));
    };
};
var $9594b095b272a1de$export$258cc98aa6d7d21b = function() {
    return $9594b095b272a1de$export$e469dcfea9910464($3NXK3.fromNullable, (0, $kj6DU.identity));
};
var $9594b095b272a1de$export$8f316a2f03469694 = function(predicate) {
    return $9594b095b272a1de$export$e469dcfea9910464($3NXK3.fromPredicate(predicate), (0, $kj6DU.identity));
};
var $9594b095b272a1de$export$782e8b2fe031f968 = function() {
    return $9594b095b272a1de$export$e469dcfea9910464((0, $kj6DU.identity), $3NXK3.some);
};
var $9594b095b272a1de$export$929e170fdd93186c = function() {
    return $9594b095b272a1de$export$e469dcfea9910464($3NXK3.fromEither, $7Rbab.right);
};
var $9594b095b272a1de$export$97ae81cf28b21f26 = function() {
    return $9594b095b272a1de$export$e469dcfea9910464(function(s) {
        return $7Rbab.isLeft(s) ? $3NXK3.some(s.left) : $3NXK3.none;
    }, $7Rbab.left);
};
var $9594b095b272a1de$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $9594b095b272a1de$export$a595a5197cc37264 = function(sa) {
    return $9594b095b272a1de$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $6piwk.pipe)(sa.getOption(s), $3NXK3.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $9594b095b272a1de$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $6piwk.pipe)(optional.getOption(s), $3NXK3.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $9594b095b272a1de$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $9594b095b272a1de$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $6piwk.pipe)(g(s), $3NXK3.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $9594b095b272a1de$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $9594b095b272a1de$export$516e28dec6a4b6d4((0, $kj6DU.flow)(sa.getOption, $3NXK3.chain(ab.getOption)), function(b) {
            return $9594b095b272a1de$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $9594b095b272a1de$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $9594b095b272a1de$export$8e08893559c32e38($9594b095b272a1de$export$bb0c054375ca4b0().index(i)));
    };
};
var $9594b095b272a1de$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $9594b095b272a1de$export$8e08893559c32e38($9594b095b272a1de$export$165af7b747e6b1f1().index(i)));
    };
};
var $9594b095b272a1de$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $9594b095b272a1de$export$8e08893559c32e38($9594b095b272a1de$export$3c3468aec3b83bbf().index(key)));
    };
};
var $9594b095b272a1de$export$220673392b48821b = function(predicate) {
    return $9594b095b272a1de$export$516e28dec6a4b6d4($f0bNW.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $6piwk.pipe)($f0bNW.findIndex(predicate)(s), $3NXK3.fold(function() {
                return s;
            }, function(i) {
                return $f0bNW.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
var $9594b095b272a1de$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $9594b095b272a1de$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $9594b095b272a1de$export$cf29cfc68de9a659 = function(predicate) {
    return $9594b095b272a1de$export$516e28dec6a4b6d4($f0bNW.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $6piwk.pipe)($f0bNW.findIndex(predicate)(as), $3NXK3.fold(function() {
                return as;
            }, function(i) {
                return $9594b095b272a1de$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $9594b095b272a1de$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $9594b095b272a1de$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $9594b095b272a1de$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $9594b095b272a1de$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $kj6DU.identity),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $9594b095b272a1de$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $9594b095b272a1de$export$126b5a87c58d3f9c(T) {
    return function() {
        return $9594b095b272a1de$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $9594b095b272a1de$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $9594b095b272a1de$export$35db6fcbd934c57(T) {
    return $9594b095b272a1de$export$2c68ab81171b083f($9594b095b272a1de$export$126b5a87c58d3f9c(T)());
}
var $9594b095b272a1de$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $9594b095b272a1de$export$bb0c054375ca4b0 = function() {
    return $9594b095b272a1de$export$b610b8812bbcded9(function(i) {
        return $9594b095b272a1de$export$516e28dec6a4b6d4(function(as) {
            return $f0bNW.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $6piwk.pipe)($f0bNW.lookup(i, as), $3NXK3.fold(function() {
                    return as;
                }, function() {
                    return $f0bNW.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $9594b095b272a1de$export$165af7b747e6b1f1 = function() {
    return $9594b095b272a1de$export$b610b8812bbcded9(function(i) {
        return $9594b095b272a1de$export$516e28dec6a4b6d4(function(as) {
            return $f0bNW.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $6piwk.pipe)($f0bNW.lookup(i, as), $3NXK3.fold(function() {
                    return as;
                }, function() {
                    return $9594b095b272a1de$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $9594b095b272a1de$export$3c3468aec3b83bbf = function() {
    return $9594b095b272a1de$export$b610b8812bbcded9(function(k) {
        return $9594b095b272a1de$export$516e28dec6a4b6d4(function(r) {
            return $etcCS.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $3NXK3.isNone($etcCS.lookup(k, r))) return r;
                return $etcCS.insertAt(k, a)(r);
            };
        });
    });
};
var $9594b095b272a1de$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $9594b095b272a1de$export$ba8573d258bae607() {
    return $9594b095b272a1de$export$493d36ec626b6698(function(key) {
        return $9594b095b272a1de$export$21cde5187c2605a3(function(r) {
            return $etcCS.lookup(key, r);
        }, $3NXK3.fold(function() {
            return $etcCS.deleteAt(key);
        }, function(a) {
            return $etcCS.insertAt(key, a);
        }));
    });
}

});
parcelRegister("etcCS", function(module, exports) {

$parcel$export(module.exports, "fromRecord", function () { return $a88d916adb483d60$export$6c8271f68d66a228; });
$parcel$export(module.exports, "toRecord", function () { return $a88d916adb483d60$export$1a8926de16677683; });
$parcel$export(module.exports, "size", function () { return $a88d916adb483d60$export$346677f925de839c; });
$parcel$export(module.exports, "isEmpty", function () { return $a88d916adb483d60$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "keys", function () { return $a88d916adb483d60$export$ed97f33186d4b816; });
$parcel$export(module.exports, "collect", function () { return $a88d916adb483d60$export$bb44f104e3c54dae; });
$parcel$export(module.exports, "toReadonlyArray", function () { return $a88d916adb483d60$export$4aaa3912a3956cb7; });
$parcel$export(module.exports, "toUnfoldable", function () { return $a88d916adb483d60$export$823be24f8766da23; });
$parcel$export(module.exports, "upsertAt", function () { return $a88d916adb483d60$export$ff82449ce381c54a; });
$parcel$export(module.exports, "has", function () { return $a88d916adb483d60$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "deleteAt", function () { return $a88d916adb483d60$export$90f9093465da3136; });
$parcel$export(module.exports, "updateAt", function () { return $a88d916adb483d60$export$b6d8713d53419d4c; });
$parcel$export(module.exports, "modifyAt", function () { return $a88d916adb483d60$export$cba09f9e3d3e58eb; });
$parcel$export(module.exports, "pop", function () { return $a88d916adb483d60$export$3e41007ebfff0e64; });
$parcel$export(module.exports, "lookup", function () { return $a88d916adb483d60$export$dfc7155ac0343b8; });
$parcel$export(module.exports, "isSubrecord", function () { return $a88d916adb483d60$export$36e6f76a1d117b8a; });
$parcel$export(module.exports, "empty", function () { return $a88d916adb483d60$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "mapWithIndex", function () { return $a88d916adb483d60$export$8f07ddce13659f50; });
$parcel$export(module.exports, "map", function () { return $a88d916adb483d60$export$871de8747c9eaa88; });
$parcel$export(module.exports, "reduceWithIndex", function () { return $a88d916adb483d60$export$bbd3ef8720e22369; });
$parcel$export(module.exports, "foldMapWithIndex", function () { return $a88d916adb483d60$export$18153bb1181268e5; });
$parcel$export(module.exports, "reduceRightWithIndex", function () { return $a88d916adb483d60$export$ce2b2fe0b88ccd0a; });
$parcel$export(module.exports, "singleton", function () { return $a88d916adb483d60$export$439306a4dcaafbb9; });
$parcel$export(module.exports, "traverseWithIndex", function () { return $a88d916adb483d60$export$955fdc0d24efa249; });
$parcel$export(module.exports, "traverse", function () { return $a88d916adb483d60$export$df3f009e3d155b20; });
$parcel$export(module.exports, "_traverse", function () { return $a88d916adb483d60$export$b3c6f3d9661cffba; });
$parcel$export(module.exports, "sequence", function () { return $a88d916adb483d60$export$49bb65c2ea163039; });
$parcel$export(module.exports, "_sequence", function () { return $a88d916adb483d60$export$5d141086b2c0bc6; });
$parcel$export(module.exports, "wither", function () { return $a88d916adb483d60$export$6c36d01819ecdb31; });
$parcel$export(module.exports, "compact", function () { return $a88d916adb483d60$export$8e16b83750b44988; });
$parcel$export(module.exports, "wilt", function () { return $a88d916adb483d60$export$2439a3bc02b13b03; });
$parcel$export(module.exports, "separate", function () { return $a88d916adb483d60$export$709f6946f4e97408; });
$parcel$export(module.exports, "partitionMapWithIndex", function () { return $a88d916adb483d60$export$bc7c0794b9c6f3ba; });
$parcel$export(module.exports, "partitionWithIndex", function () { return $a88d916adb483d60$export$dad5e500f2bab9bc; });
$parcel$export(module.exports, "filterMapWithIndex", function () { return $a88d916adb483d60$export$30c5cbe848021e97; });
$parcel$export(module.exports, "filterWithIndex", function () { return $a88d916adb483d60$export$36e42aef19fc7171; });
$parcel$export(module.exports, "fromFoldable", function () { return $a88d916adb483d60$export$b7d5d9bb9ff52072; });
$parcel$export(module.exports, "fromFoldableMap", function () { return $a88d916adb483d60$export$f658682c0065ad25; });
$parcel$export(module.exports, "toEntries", function () { return $a88d916adb483d60$export$9f69d28786a8399c; });
$parcel$export(module.exports, "fromEntries", function () { return $a88d916adb483d60$export$5150077fc2e7c662; });
$parcel$export(module.exports, "every", function () { return $a88d916adb483d60$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "some", function () { return $a88d916adb483d60$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "elem", function () { return $a88d916adb483d60$export$5bf96401662340b7; });
$parcel$export(module.exports, "union", function () { return $a88d916adb483d60$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersection", function () { return $a88d916adb483d60$export$bc86dfbf7795668c; });
$parcel$export(module.exports, "difference", function () { return $a88d916adb483d60$export$acaf96a27438246b; });
$parcel$export(module.exports, "_map", function () { return $a88d916adb483d60$export$a0135aecf4a782ab; });
$parcel$export(module.exports, "_mapWithIndex", function () { return $a88d916adb483d60$export$45e3e46323e6d66c; });
$parcel$export(module.exports, "_reduce", function () { return $a88d916adb483d60$export$8eef5fdba9512999; });
$parcel$export(module.exports, "reduce", function () { return $a88d916adb483d60$export$533b26079ad0b4b; });
$parcel$export(module.exports, "_foldMap", function () { return $a88d916adb483d60$export$11b0d0e0b70641d9; });
$parcel$export(module.exports, "foldMap", function () { return $a88d916adb483d60$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "_reduceRight", function () { return $a88d916adb483d60$export$ec882fc9def9e5db; });
$parcel$export(module.exports, "reduceRight", function () { return $a88d916adb483d60$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "_filter", function () { return $a88d916adb483d60$export$ec7439dc64f73058; });
$parcel$export(module.exports, "filter", function () { return $a88d916adb483d60$export$3dea766d36a8935f; });
$parcel$export(module.exports, "_filterMap", function () { return $a88d916adb483d60$export$e8609d6e184911e6; });
$parcel$export(module.exports, "filterMap", function () { return $a88d916adb483d60$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "_partition", function () { return $a88d916adb483d60$export$8d112ad5a197e16a; });
$parcel$export(module.exports, "partition", function () { return $a88d916adb483d60$export$b29f828819edca8d; });
$parcel$export(module.exports, "_partitionMap", function () { return $a88d916adb483d60$export$f721fb25a1c72a8d; });
$parcel$export(module.exports, "partitionMap", function () { return $a88d916adb483d60$export$3117e3f9ececb6bc; });
$parcel$export(module.exports, "_reduceWithIndex", function () { return $a88d916adb483d60$export$dd5ca3bcbad0b6af; });
$parcel$export(module.exports, "_foldMapWithIndex", function () { return $a88d916adb483d60$export$e08bbf939bdc3250; });
$parcel$export(module.exports, "_reduceRightWithIndex", function () { return $a88d916adb483d60$export$3b7618311030b1af; });
$parcel$export(module.exports, "_partitionMapWithIndex", function () { return $a88d916adb483d60$export$18034ec93490e9d2; });
$parcel$export(module.exports, "_partitionWithIndex", function () { return $a88d916adb483d60$export$31601036bfbf1c76; });
$parcel$export(module.exports, "_filterMapWithIndex", function () { return $a88d916adb483d60$export$ac207938ecd8ddc4; });
$parcel$export(module.exports, "_filterWithIndex", function () { return $a88d916adb483d60$export$560430393fed15de; });
$parcel$export(module.exports, "URI", function () { return $a88d916adb483d60$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $a88d916adb483d60$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getEq", function () { return $a88d916adb483d60$export$804fed467fde44e4; });
$parcel$export(module.exports, "getMonoid", function () { return $a88d916adb483d60$export$c2a7ef2cc9b32b31; });
$parcel$export(module.exports, "Functor", function () { return $a88d916adb483d60$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $a88d916adb483d60$export$18c957606d8bdf09; });
$parcel$export(module.exports, "FunctorWithIndex", function () { return $a88d916adb483d60$export$9fdffe0fe1e91cad; });
$parcel$export(module.exports, "getFoldable", function () { return $a88d916adb483d60$export$d544f02c7cebdaed; });
$parcel$export(module.exports, "getFoldableWithIndex", function () { return $a88d916adb483d60$export$6c59d75f118e7bc9; });
$parcel$export(module.exports, "Compactable", function () { return $a88d916adb483d60$export$4a21ac48141ac3c9; });
$parcel$export(module.exports, "Filterable", function () { return $a88d916adb483d60$export$d00e1c48fb621173; });
$parcel$export(module.exports, "FilterableWithIndex", function () { return $a88d916adb483d60$export$c29a647071e542ec; });
$parcel$export(module.exports, "getTraversable", function () { return $a88d916adb483d60$export$4e0ffba11065d2c1; });
$parcel$export(module.exports, "getTraversableWithIndex", function () { return $a88d916adb483d60$export$46b81797a3375b8c; });
$parcel$export(module.exports, "getWitherable", function () { return $a88d916adb483d60$export$bb8ef26a634cac7b; });
$parcel$export(module.exports, "getUnionSemigroup", function () { return $a88d916adb483d60$export$baca17b4aff42f82; });
$parcel$export(module.exports, "getUnionMonoid", function () { return $a88d916adb483d60$export$c487aac9f4157837; });
$parcel$export(module.exports, "getIntersectionSemigroup", function () { return $a88d916adb483d60$export$d379a869a72e4055; });
$parcel$export(module.exports, "getDifferenceMagma", function () { return $a88d916adb483d60$export$fdb3296ca0a124e3; });
$parcel$export(module.exports, "Foldable", function () { return $a88d916adb483d60$export$41404b31838667c9; });
$parcel$export(module.exports, "FoldableWithIndex", function () { return $a88d916adb483d60$export$e8f7d17aaff345cb; });
$parcel$export(module.exports, "Traversable", function () { return $a88d916adb483d60$export$a0202666c3bda011; });
$parcel$export(module.exports, "TraversableWithIndex", function () { return $a88d916adb483d60$export$bd7b528d8c36ec41; });
$parcel$export(module.exports, "Witherable", function () { return $a88d916adb483d60$export$748d317b4c426f96; });
$parcel$export(module.exports, "insertAt", function () { return $a88d916adb483d60$export$9f200c4466975173; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $a88d916adb483d60$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "readonlyRecord", function () { return $a88d916adb483d60$export$74b9182b22de2bc1; });

var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $aRVRH = parcelRequire("aRVRH");

var $gSyeU = parcelRequire("gSyeU");

var $LdARg = parcelRequire("LdARg");
var $a88d916adb483d60$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $a88d916adb483d60$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $a88d916adb483d60$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $a88d916adb483d60$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($lOGTm.has.call(r, k)) return false;
    }
    return true;
};
var $a88d916adb483d60$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $a88d916adb483d60$export$ed97f33186d4b816 = /*#__PURE__*/ $a88d916adb483d60$var$keys_($gSyeU.Ord);
function $a88d916adb483d60$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $a88d916adb483d60$export$bb44f104e3c54dae($gSyeU.Ord)(O);
    var keysO = $a88d916adb483d60$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $a88d916adb483d60$export$4aaa3912a3956cb7 = /*#__PURE__*/ $a88d916adb483d60$export$bb44f104e3c54dae($gSyeU.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $a88d916adb483d60$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $a88d916adb483d60$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $lOGTm.some([
                sas[b],
                b + 1
            ]) : $lOGTm.none;
        });
    };
}
var $a88d916adb483d60$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($lOGTm.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $a88d916adb483d60$export$a4f4bb6b1453fff5 = function(k, r) {
    return $lOGTm.has.call(r, k);
};
function $a88d916adb483d60$export$90f9093465da3136(k) {
    return function(r) {
        if (!$lOGTm.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $a88d916adb483d60$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$a88d916adb483d60$export$a4f4bb6b1453fff5(k, r)) return $lOGTm.none;
        if (r[k] === a) return $lOGTm.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $lOGTm.some(out);
    };
};
var $a88d916adb483d60$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$a88d916adb483d60$export$a4f4bb6b1453fff5(k, r)) return $lOGTm.none;
        var next = f(r[k]);
        if (next === r[k]) return $lOGTm.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $lOGTm.some(out);
    };
};
function $a88d916adb483d60$export$3e41007ebfff0e64(k) {
    var deleteAtk = $a88d916adb483d60$export$90f9093465da3136(k);
    return function(r) {
        var oa = $a88d916adb483d60$export$dfc7155ac0343b8(k, r);
        return $lOGTm.isNone(oa) ? $lOGTm.none : $lOGTm.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $a88d916adb483d60$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $a88d916adb483d60$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$lOGTm.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $a88d916adb483d60$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $a88d916adb483d60$export$dfc7155ac0343b8(k, r);
    };
    return $lOGTm.has.call(r, k) ? $lOGTm.some(r[k]) : $lOGTm.none;
}
var $a88d916adb483d60$export$6e22c362a0406a2c = {};
function $a88d916adb483d60$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($lOGTm.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $a88d916adb483d60$export$871de8747c9eaa88(f) {
    return $a88d916adb483d60$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $a88d916adb483d60$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $a88d916adb483d60$export$bbd3ef8720e22369($gSyeU.Ord).apply(void 0, args);
    var keysO = $a88d916adb483d60$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $a88d916adb483d60$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $a88d916adb483d60$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $a88d916adb483d60$export$18153bb1181268e5($gSyeU.Ord)(O);
}
function $a88d916adb483d60$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $a88d916adb483d60$export$ce2b2fe0b88ccd0a($gSyeU.Ord).apply(void 0, args);
    var keysO = $a88d916adb483d60$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $a88d916adb483d60$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $a88d916adb483d60$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $a88d916adb483d60$var$_traverseWithIndex($gSyeU.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $a88d916adb483d60$export$df3f009e3d155b20(F) {
    var traverseOF = $a88d916adb483d60$export$b3c6f3d9661cffba($gSyeU.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $a88d916adb483d60$export$49bb65c2ea163039(F) {
    return $a88d916adb483d60$export$5d141086b2c0bc6($gSyeU.Ord)(F);
}
var $a88d916adb483d60$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $a88d916adb483d60$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $kj6DU.pipe)(fa, traverseF(f)), $a88d916adb483d60$export$8e16b83750b44988);
        };
    };
};
var $a88d916adb483d60$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $a88d916adb483d60$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $kj6DU.pipe)(fa, traverseF(f)), $a88d916adb483d60$export$709f6946f4e97408);
        };
    };
};
function $a88d916adb483d60$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($lOGTm.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $aRVRH.separated)(left, right);
    };
}
function $a88d916adb483d60$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($lOGTm.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $aRVRH.separated)(left, right);
    };
}
function $a88d916adb483d60$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($lOGTm.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($lOGTm.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $a88d916adb483d60$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($lOGTm.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $a88d916adb483d60$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $a88d916adb483d60$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $kj6DU.identity));
    };
}
function $a88d916adb483d60$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $lOGTm.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $a88d916adb483d60$export$9f69d28786a8399c = $a88d916adb483d60$export$4aaa3912a3956cb7;
var $a88d916adb483d60$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $a88d916adb483d60$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $a88d916adb483d60$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $a88d916adb483d60$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $a88d916adb483d60$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $a88d916adb483d60$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($a88d916adb483d60$export$dd1bc94b04021eeb(first)) return second;
            if ($a88d916adb483d60$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($a88d916adb483d60$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$a88d916adb483d60$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $a88d916adb483d60$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($a88d916adb483d60$export$dd1bc94b04021eeb(first) || $a88d916adb483d60$export$dd1bc94b04021eeb(second)) return $a88d916adb483d60$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($a88d916adb483d60$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $a88d916adb483d60$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($a88d916adb483d60$export$dd1bc94b04021eeb(first)) return second;
        if ($a88d916adb483d60$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$a88d916adb483d60$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$a88d916adb483d60$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $a88d916adb483d60$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$871de8747c9eaa88(f));
};
var $a88d916adb483d60$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$8f07ddce13659f50(f));
};
var $a88d916adb483d60$export$8eef5fdba9512999 = function(O) {
    var reduceO = $a88d916adb483d60$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $kj6DU.pipe)(fa, reduceO(b, f));
    };
};
var $a88d916adb483d60$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $a88d916adb483d60$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $kj6DU.pipe)(fa, foldMapM(f));
        };
    };
};
var $a88d916adb483d60$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $a88d916adb483d60$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $kj6DU.pipe)(fa, reduceRightO(b, f));
    };
};
var $a88d916adb483d60$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$3dea766d36a8935f(predicate));
};
var $a88d916adb483d60$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$a04c6c6965dd4709(f));
};
var $a88d916adb483d60$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$b29f828819edca8d(predicate));
};
var $a88d916adb483d60$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$3117e3f9ececb6bc(f));
};
var $a88d916adb483d60$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $a88d916adb483d60$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $kj6DU.pipe)(fa, reduceWithIndexO(b, f));
    };
};
var $a88d916adb483d60$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $a88d916adb483d60$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $kj6DU.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
var $a88d916adb483d60$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $a88d916adb483d60$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $kj6DU.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
var $a88d916adb483d60$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$bc7c0794b9c6f3ba(f));
};
var $a88d916adb483d60$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $a88d916adb483d60$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$30c5cbe848021e97(f));
};
var $a88d916adb483d60$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $kj6DU.pipe)(fa, $a88d916adb483d60$export$36e42aef19fc7171(predicateWithIndex));
};
var $a88d916adb483d60$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $a88d916adb483d60$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $kj6DU.flow)((0, $kj6DU.SK), f));
        };
    };
};
var $a88d916adb483d60$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $a88d916adb483d60$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $kj6DU.identity));
        };
    };
};
var $a88d916adb483d60$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $a88d916adb483d60$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($a88d916adb483d60$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $a88d916adb483d60$export$3dea766d36a8935f = function(predicate) {
    return $a88d916adb483d60$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $a88d916adb483d60$export$a04c6c6965dd4709 = function(f) {
    return $a88d916adb483d60$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $a88d916adb483d60$export$b29f828819edca8d = function(predicate) {
    return $a88d916adb483d60$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $a88d916adb483d60$export$3117e3f9ececb6bc = function(f) {
    return $a88d916adb483d60$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $a88d916adb483d60$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $a88d916adb483d60$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $a88d916adb483d60$export$533b26079ad0b4b($gSyeU.Ord).apply(void 0, args);
}
function $a88d916adb483d60$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $a88d916adb483d60$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $a88d916adb483d60$export$b66cdc0497d8a99a($gSyeU.Ord)(O);
}
function $a88d916adb483d60$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $a88d916adb483d60$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $a88d916adb483d60$export$7fef8bcdbb34f435($gSyeU.Ord).apply(void 0, args);
}
var $a88d916adb483d60$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($lOGTm.has.call(r, k)) {
        var oa = r[k];
        if ($lOGTm.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
var $a88d916adb483d60$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($lOGTm.has.call(r, k)) {
        var e = r[k];
        if ($lOGTm.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $aRVRH.separated)(left, right);
};
var $a88d916adb483d60$export$9156e739aa33e19f = 'ReadonlyRecord';
function $a88d916adb483d60$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $a88d916adb483d60$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $a88d916adb483d60$export$3cb5cd7f7776c81($gSyeU.Ord)(O);
}
function $a88d916adb483d60$export$804fed467fde44e4(E) {
    var isSubrecordE = $a88d916adb483d60$export$36e6f76a1d117b8a(E);
    return (0, $9RyKW.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $a88d916adb483d60$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($a88d916adb483d60$export$dd1bc94b04021eeb(first)) return second;
            if ($a88d916adb483d60$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($lOGTm.has.call(second, k)) r[k] = $lOGTm.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $a88d916adb483d60$export$6e22c362a0406a2c
    };
}
var $a88d916adb483d60$export$bd5b6bfc5fa2ee61 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab
};
var $a88d916adb483d60$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($a88d916adb483d60$export$bd5b6bfc5fa2ee61);
var $a88d916adb483d60$export$9fdffe0fe1e91cad = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    mapWithIndex: $a88d916adb483d60$export$45e3e46323e6d66c
};
var $a88d916adb483d60$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $a88d916adb483d60$export$9156e739aa33e19f,
        reduce: $a88d916adb483d60$export$8eef5fdba9512999(O),
        foldMap: $a88d916adb483d60$export$11b0d0e0b70641d9(O),
        reduceRight: $a88d916adb483d60$export$ec882fc9def9e5db(O)
    };
};
var $a88d916adb483d60$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $a88d916adb483d60$export$9156e739aa33e19f,
        reduce: $a88d916adb483d60$export$8eef5fdba9512999(O),
        foldMap: $a88d916adb483d60$export$11b0d0e0b70641d9(O),
        reduceRight: $a88d916adb483d60$export$ec882fc9def9e5db(O),
        reduceWithIndex: $a88d916adb483d60$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $a88d916adb483d60$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $a88d916adb483d60$export$3b7618311030b1af(O)
    };
};
var $a88d916adb483d60$export$4a21ac48141ac3c9 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    compact: $a88d916adb483d60$export$8e16b83750b44988,
    separate: $a88d916adb483d60$export$709f6946f4e97408
};
var $a88d916adb483d60$export$d00e1c48fb621173 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    compact: $a88d916adb483d60$export$8e16b83750b44988,
    separate: $a88d916adb483d60$export$709f6946f4e97408,
    filter: $a88d916adb483d60$export$ec7439dc64f73058,
    filterMap: $a88d916adb483d60$export$e8609d6e184911e6,
    partition: $a88d916adb483d60$export$8d112ad5a197e16a,
    partitionMap: $a88d916adb483d60$export$f721fb25a1c72a8d
};
var $a88d916adb483d60$export$c29a647071e542ec = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    mapWithIndex: $a88d916adb483d60$export$45e3e46323e6d66c,
    compact: $a88d916adb483d60$export$8e16b83750b44988,
    separate: $a88d916adb483d60$export$709f6946f4e97408,
    filter: $a88d916adb483d60$export$ec7439dc64f73058,
    filterMap: $a88d916adb483d60$export$e8609d6e184911e6,
    partition: $a88d916adb483d60$export$8d112ad5a197e16a,
    partitionMap: $a88d916adb483d60$export$f721fb25a1c72a8d,
    filterMapWithIndex: $a88d916adb483d60$export$ac207938ecd8ddc4,
    filterWithIndex: $a88d916adb483d60$export$560430393fed15de,
    partitionMapWithIndex: $a88d916adb483d60$export$18034ec93490e9d2,
    partitionWithIndex: $a88d916adb483d60$export$31601036bfbf1c76
};
var $a88d916adb483d60$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $a88d916adb483d60$export$9156e739aa33e19f,
        map: $a88d916adb483d60$export$a0135aecf4a782ab,
        reduce: $a88d916adb483d60$export$8eef5fdba9512999(O),
        foldMap: $a88d916adb483d60$export$11b0d0e0b70641d9(O),
        reduceRight: $a88d916adb483d60$export$ec882fc9def9e5db(O),
        traverse: $a88d916adb483d60$export$b3c6f3d9661cffba(O),
        sequence: $a88d916adb483d60$export$5d141086b2c0bc6(O)
    };
};
var $a88d916adb483d60$export$46b81797a3375b8c = function(O) {
    return {
        URI: $a88d916adb483d60$export$9156e739aa33e19f,
        map: $a88d916adb483d60$export$a0135aecf4a782ab,
        mapWithIndex: $a88d916adb483d60$export$45e3e46323e6d66c,
        reduce: $a88d916adb483d60$export$8eef5fdba9512999(O),
        foldMap: $a88d916adb483d60$export$11b0d0e0b70641d9(O),
        reduceRight: $a88d916adb483d60$export$ec882fc9def9e5db(O),
        reduceWithIndex: $a88d916adb483d60$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $a88d916adb483d60$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $a88d916adb483d60$export$3b7618311030b1af(O),
        traverse: $a88d916adb483d60$export$b3c6f3d9661cffba(O),
        sequence: $a88d916adb483d60$export$5d141086b2c0bc6(O),
        traverseWithIndex: $a88d916adb483d60$var$_traverseWithIndex(O)
    };
};
var $a88d916adb483d60$export$bb8ef26a634cac7b = function(O) {
    var T = $a88d916adb483d60$export$4e0ffba11065d2c1(O);
    return {
        URI: $a88d916adb483d60$export$9156e739aa33e19f,
        map: $a88d916adb483d60$export$a0135aecf4a782ab,
        reduce: $a88d916adb483d60$export$8eef5fdba9512999(O),
        foldMap: $a88d916adb483d60$export$11b0d0e0b70641d9(O),
        reduceRight: $a88d916adb483d60$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $a88d916adb483d60$export$8e16b83750b44988,
        separate: $a88d916adb483d60$export$709f6946f4e97408,
        filter: $a88d916adb483d60$export$ec7439dc64f73058,
        filterMap: $a88d916adb483d60$export$e8609d6e184911e6,
        partition: $a88d916adb483d60$export$8d112ad5a197e16a,
        partitionMap: $a88d916adb483d60$export$f721fb25a1c72a8d,
        wither: (0, $LdARg.witherDefault)(T, $a88d916adb483d60$export$4a21ac48141ac3c9),
        wilt: (0, $LdARg.wiltDefault)(T, $a88d916adb483d60$export$4a21ac48141ac3c9)
    };
};
var $a88d916adb483d60$export$baca17b4aff42f82 = function(S) {
    var unionS = $a88d916adb483d60$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $a88d916adb483d60$export$c487aac9f4157837 = function(S) {
    return {
        concat: $a88d916adb483d60$export$baca17b4aff42f82(S).concat,
        empty: $a88d916adb483d60$export$6e22c362a0406a2c
    };
};
var $a88d916adb483d60$export$d379a869a72e4055 = function(S) {
    var intersectionS = $a88d916adb483d60$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $a88d916adb483d60$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $a88d916adb483d60$export$acaf96a27438246b(second)(first);
        }
    };
};
var $a88d916adb483d60$export$41404b31838667c9 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $a88d916adb483d60$export$8eef5fdba9512999($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $a88d916adb483d60$export$11b0d0e0b70641d9($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $a88d916adb483d60$export$ec882fc9def9e5db($gSyeU.Ord)
};
var $a88d916adb483d60$export$e8f7d17aaff345cb = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $a88d916adb483d60$export$8eef5fdba9512999($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $a88d916adb483d60$export$11b0d0e0b70641d9($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $a88d916adb483d60$export$ec882fc9def9e5db($gSyeU.Ord),
    reduceWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$dd5ca3bcbad0b6af($gSyeU.Ord),
    foldMapWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$e08bbf939bdc3250($gSyeU.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$3b7618311030b1af($gSyeU.Ord)
};
var $a88d916adb483d60$export$a0202666c3bda011 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $a88d916adb483d60$export$8eef5fdba9512999($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $a88d916adb483d60$export$11b0d0e0b70641d9($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $a88d916adb483d60$export$ec882fc9def9e5db($gSyeU.Ord),
    traverse: /*#__PURE__*/ $a88d916adb483d60$export$b3c6f3d9661cffba($gSyeU.Ord),
    sequence: $a88d916adb483d60$export$49bb65c2ea163039
};
var $a88d916adb483d60$export$bd7b528d8c36ec41 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    mapWithIndex: $a88d916adb483d60$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $a88d916adb483d60$export$8eef5fdba9512999($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $a88d916adb483d60$export$11b0d0e0b70641d9($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $a88d916adb483d60$export$ec882fc9def9e5db($gSyeU.Ord),
    reduceWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$dd5ca3bcbad0b6af($gSyeU.Ord),
    foldMapWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$e08bbf939bdc3250($gSyeU.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$3b7618311030b1af($gSyeU.Ord),
    traverse: /*#__PURE__*/ $a88d916adb483d60$export$b3c6f3d9661cffba($gSyeU.Ord),
    sequence: $a88d916adb483d60$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $a88d916adb483d60$var$_traverseWithIndex($gSyeU.Ord)
};
var $a88d916adb483d60$var$_wither = /*#__PURE__*/ (0, $LdARg.witherDefault)($a88d916adb483d60$export$a0202666c3bda011, $a88d916adb483d60$export$4a21ac48141ac3c9);
var $a88d916adb483d60$var$_wilt = /*#__PURE__*/ (0, $LdARg.wiltDefault)($a88d916adb483d60$export$a0202666c3bda011, $a88d916adb483d60$export$4a21ac48141ac3c9);
var $a88d916adb483d60$export$748d317b4c426f96 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $a88d916adb483d60$export$8eef5fdba9512999($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $a88d916adb483d60$export$11b0d0e0b70641d9($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $a88d916adb483d60$export$ec882fc9def9e5db($gSyeU.Ord),
    traverse: /*#__PURE__*/ $a88d916adb483d60$export$b3c6f3d9661cffba($gSyeU.Ord),
    sequence: $a88d916adb483d60$export$49bb65c2ea163039,
    compact: $a88d916adb483d60$export$8e16b83750b44988,
    separate: $a88d916adb483d60$export$709f6946f4e97408,
    filter: $a88d916adb483d60$export$ec7439dc64f73058,
    filterMap: $a88d916adb483d60$export$e8609d6e184911e6,
    partition: $a88d916adb483d60$export$8d112ad5a197e16a,
    partitionMap: $a88d916adb483d60$export$f721fb25a1c72a8d,
    wither: $a88d916adb483d60$var$_wither,
    wilt: $a88d916adb483d60$var$_wilt
};
var $a88d916adb483d60$export$9f200c4466975173 = $a88d916adb483d60$export$ff82449ce381c54a;
function $a88d916adb483d60$export$5a15a386532a5ea4(k, r) {
    return $lOGTm.has.call(r === undefined ? this : r, k);
}
var $a88d916adb483d60$export$74b9182b22de2bc1 = {
    URI: $a88d916adb483d60$export$9156e739aa33e19f,
    map: $a88d916adb483d60$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $a88d916adb483d60$export$8eef5fdba9512999($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $a88d916adb483d60$export$11b0d0e0b70641d9($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $a88d916adb483d60$export$ec882fc9def9e5db($gSyeU.Ord),
    traverse: /*#__PURE__*/ $a88d916adb483d60$export$b3c6f3d9661cffba($gSyeU.Ord),
    sequence: $a88d916adb483d60$export$49bb65c2ea163039,
    compact: $a88d916adb483d60$export$8e16b83750b44988,
    separate: $a88d916adb483d60$export$709f6946f4e97408,
    filter: $a88d916adb483d60$export$ec7439dc64f73058,
    filterMap: $a88d916adb483d60$export$e8609d6e184911e6,
    partition: $a88d916adb483d60$export$8d112ad5a197e16a,
    partitionMap: $a88d916adb483d60$export$f721fb25a1c72a8d,
    mapWithIndex: $a88d916adb483d60$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$dd5ca3bcbad0b6af($gSyeU.Ord),
    foldMapWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$e08bbf939bdc3250($gSyeU.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $a88d916adb483d60$export$3b7618311030b1af($gSyeU.Ord),
    filterMapWithIndex: $a88d916adb483d60$export$ac207938ecd8ddc4,
    filterWithIndex: $a88d916adb483d60$export$560430393fed15de,
    partitionMapWithIndex: $a88d916adb483d60$export$18034ec93490e9d2,
    partitionWithIndex: $a88d916adb483d60$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $a88d916adb483d60$var$_traverseWithIndex($gSyeU.Ord),
    wither: $a88d916adb483d60$var$_wither,
    wilt: $a88d916adb483d60$var$_wilt
};

});
parcelRegister("gSyeU", function(module, exports) {

$parcel$export(module.exports, "Eq", function () { return $c49c3fbe27ec4b8b$export$a2050e5b0c4dcf10; });
$parcel$export(module.exports, "Semigroup", function () { return $c49c3fbe27ec4b8b$export$c16b1dbe8a4166b6; });
$parcel$export(module.exports, "empty", function () { return $c49c3fbe27ec4b8b$export$6e22c362a0406a2c; });
$parcel$export(module.exports, "Monoid", function () { return $c49c3fbe27ec4b8b$export$8f55868b713abdc3; });
$parcel$export(module.exports, "Ord", function () { return $c49c3fbe27ec4b8b$export$ee8aa95bfab51c5; });
$parcel$export(module.exports, "Show", function () { return $c49c3fbe27ec4b8b$export$f6a3d19be20f5819; });
$parcel$export(module.exports, "isString", function () { return $c49c3fbe27ec4b8b$export$844ec244b1367d54; });
$parcel$export(module.exports, "toUpperCase", function () { return $c49c3fbe27ec4b8b$export$d80c591a9e16646; });
$parcel$export(module.exports, "toLowerCase", function () { return $c49c3fbe27ec4b8b$export$84b9399c77df0edf; });
$parcel$export(module.exports, "replace", function () { return $c49c3fbe27ec4b8b$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "trim", function () { return $c49c3fbe27ec4b8b$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "trimLeft", function () { return $c49c3fbe27ec4b8b$export$c5557f40488c48ec; });
$parcel$export(module.exports, "trimRight", function () { return $c49c3fbe27ec4b8b$export$da8e5da96e287379; });
$parcel$export(module.exports, "slice", function () { return $c49c3fbe27ec4b8b$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "isEmpty", function () { return $c49c3fbe27ec4b8b$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "size", function () { return $c49c3fbe27ec4b8b$export$346677f925de839c; });
$parcel$export(module.exports, "split", function () { return $c49c3fbe27ec4b8b$export$65980d18b75784e2; });
$parcel$export(module.exports, "includes", function () { return $c49c3fbe27ec4b8b$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "startsWith", function () { return $c49c3fbe27ec4b8b$export$68326237475e9a7d; });
$parcel$export(module.exports, "endsWith", function () { return $c49c3fbe27ec4b8b$export$10fdab3683b55b22; });

var $kqvcT = parcelRequire("kqvcT");
var $c49c3fbe27ec4b8b$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $c49c3fbe27ec4b8b$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $c49c3fbe27ec4b8b$export$6e22c362a0406a2c = '';
var $c49c3fbe27ec4b8b$export$8f55868b713abdc3 = {
    concat: $c49c3fbe27ec4b8b$export$c16b1dbe8a4166b6.concat,
    empty: $c49c3fbe27ec4b8b$export$6e22c362a0406a2c
};
var $c49c3fbe27ec4b8b$export$ee8aa95bfab51c5 = {
    equals: $c49c3fbe27ec4b8b$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $c49c3fbe27ec4b8b$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $c49c3fbe27ec4b8b$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $c49c3fbe27ec4b8b$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $c49c3fbe27ec4b8b$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $c49c3fbe27ec4b8b$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $c49c3fbe27ec4b8b$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $c49c3fbe27ec4b8b$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $c49c3fbe27ec4b8b$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $c49c3fbe27ec4b8b$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $c49c3fbe27ec4b8b$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $c49c3fbe27ec4b8b$export$346677f925de839c = function(s) {
    return s.length;
};
var $c49c3fbe27ec4b8b$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $kqvcT.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
var $c49c3fbe27ec4b8b$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $c49c3fbe27ec4b8b$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $c49c3fbe27ec4b8b$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};

});


parcelRegister("7Rbab", function(module, exports) {

$parcel$export(module.exports, "left", function () { return $5b86246c19ea7abd$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $5b86246c19ea7abd$export$79ffe56a765070d2; });
$parcel$export(module.exports, "flatMap", function () { return $5b86246c19ea7abd$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "isLeft", function () { return $5b86246c19ea7abd$export$d649b6842e09f2b; });
$parcel$export(module.exports, "map", function () { return $5b86246c19ea7abd$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $5b86246c19ea7abd$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "reduce", function () { return $5b86246c19ea7abd$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $5b86246c19ea7abd$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $5b86246c19ea7abd$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $5b86246c19ea7abd$export$df3f009e3d155b20; });
$parcel$export(module.exports, "bimap", function () { return $5b86246c19ea7abd$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapLeft", function () { return $5b86246c19ea7abd$export$472de43a55e4aa49; });
$parcel$export(module.exports, "alt", function () { return $5b86246c19ea7abd$export$228be17d80722ab; });
$parcel$export(module.exports, "extend", function () { return $5b86246c19ea7abd$export$8b58be045bf06082; });
$parcel$export(module.exports, "URI", function () { return $5b86246c19ea7abd$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getShow", function () { return $5b86246c19ea7abd$export$3cb5cd7f7776c81; });
$parcel$export(module.exports, "getEq", function () { return $5b86246c19ea7abd$export$804fed467fde44e4; });
$parcel$export(module.exports, "isRight", function () { return $5b86246c19ea7abd$export$a9d71693f0c1a85d; });
$parcel$export(module.exports, "getSemigroup", function () { return $5b86246c19ea7abd$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getCompactable", function () { return $5b86246c19ea7abd$export$cfae3069ac05ff4c; });
$parcel$export(module.exports, "getFilterable", function () { return $5b86246c19ea7abd$export$a4e870b0a57ec14e; });
$parcel$export(module.exports, "getWitherable", function () { return $5b86246c19ea7abd$export$bb8ef26a634cac7b; });
$parcel$export(module.exports, "sequence", function () { return $5b86246c19ea7abd$export$49bb65c2ea163039; });
$parcel$export(module.exports, "Traversable", function () { return $5b86246c19ea7abd$export$a0202666c3bda011; });
$parcel$export(module.exports, "getApplicativeValidation", function () { return $5b86246c19ea7abd$export$d9540e18497e6036; });
$parcel$export(module.exports, "of", function () { return $5b86246c19ea7abd$export$ba255e9e49e00608; });
$parcel$export(module.exports, "getAltValidation", function () { return $5b86246c19ea7abd$export$a81dd5ed716f5f73; });
$parcel$export(module.exports, "Functor", function () { return $5b86246c19ea7abd$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $5b86246c19ea7abd$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $5b86246c19ea7abd$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "Pointed", function () { return $5b86246c19ea7abd$export$59a71046037e6c20; });
$parcel$export(module.exports, "apW", function () { return $5b86246c19ea7abd$export$321be6e231de8eac; });
$parcel$export(module.exports, "Apply", function () { return $5b86246c19ea7abd$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "Applicative", function () { return $5b86246c19ea7abd$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $5b86246c19ea7abd$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $5b86246c19ea7abd$export$fb641926d034ac7d; });
$parcel$export(module.exports, "Foldable", function () { return $5b86246c19ea7abd$export$41404b31838667c9; });
$parcel$export(module.exports, "Bifunctor", function () { return $5b86246c19ea7abd$export$fd0fe42029639505; });
$parcel$export(module.exports, "altW", function () { return $5b86246c19ea7abd$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "Alt", function () { return $5b86246c19ea7abd$export$25ba4469a069167; });
$parcel$export(module.exports, "Extend", function () { return $5b86246c19ea7abd$export$5b5dd0e212d2a5bc; });
$parcel$export(module.exports, "ChainRec", function () { return $5b86246c19ea7abd$export$be58f7327716329d; });
$parcel$export(module.exports, "throwError", function () { return $5b86246c19ea7abd$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "MonadThrow", function () { return $5b86246c19ea7abd$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "FromEither", function () { return $5b86246c19ea7abd$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "fromPredicate", function () { return $5b86246c19ea7abd$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromOption", function () { return $5b86246c19ea7abd$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "matchW", function () { return $5b86246c19ea7abd$export$2d55ea551c238330; });
$parcel$export(module.exports, "foldW", function () { return $5b86246c19ea7abd$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "match", function () { return $5b86246c19ea7abd$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "fold", function () { return $5b86246c19ea7abd$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "getOrElseW", function () { return $5b86246c19ea7abd$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "getOrElse", function () { return $5b86246c19ea7abd$export$8832081647a02ee7; });
$parcel$export(module.exports, "flap", function () { return $5b86246c19ea7abd$export$18c957606d8bdf09; });
$parcel$export(module.exports, "apFirst", function () { return $5b86246c19ea7abd$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apFirstW", function () { return $5b86246c19ea7abd$export$ac044f4aa9961a4f; });
$parcel$export(module.exports, "apSecond", function () { return $5b86246c19ea7abd$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apSecondW", function () { return $5b86246c19ea7abd$export$8a00020751233172; });
$parcel$export(module.exports, "tap", function () { return $5b86246c19ea7abd$export$3f23594af5f37336; });
$parcel$export(module.exports, "flattenW", function () { return $5b86246c19ea7abd$export$2409099f1fc434fb; });
$parcel$export(module.exports, "flatten", function () { return $5b86246c19ea7abd$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "duplicate", function () { return $5b86246c19ea7abd$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "fromOptionK", function () { return $5b86246c19ea7abd$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $5b86246c19ea7abd$export$12d26179deb6a68a; });
$parcel$export(module.exports, "chainOptionKW", function () { return $5b86246c19ea7abd$export$377cc334277e5c3c; });
$parcel$export(module.exports, "liftNullable", function () { return $5b86246c19ea7abd$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $5b86246c19ea7abd$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $5b86246c19ea7abd$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $5b86246c19ea7abd$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "filterOrElse", function () { return $5b86246c19ea7abd$export$30af8ca9498ddf5b; });
$parcel$export(module.exports, "filterOrElseW", function () { return $5b86246c19ea7abd$export$84511cf4503ec9dd; });
$parcel$export(module.exports, "swap", function () { return $5b86246c19ea7abd$export$b0e76d9850c64156; });
$parcel$export(module.exports, "orElseW", function () { return $5b86246c19ea7abd$export$efd845e0c87089a6; });
$parcel$export(module.exports, "orElse", function () { return $5b86246c19ea7abd$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "fromNullable", function () { return $5b86246c19ea7abd$export$b601f49376b4621a; });
$parcel$export(module.exports, "tryCatch", function () { return $5b86246c19ea7abd$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $5b86246c19ea7abd$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "fromNullableK", function () { return $5b86246c19ea7abd$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $5b86246c19ea7abd$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "toUnion", function () { return $5b86246c19ea7abd$export$a0886ed3a572729f; });
$parcel$export(module.exports, "toError", function () { return $5b86246c19ea7abd$export$cc3b967c039ed3e7; });
$parcel$export(module.exports, "elem", function () { return $5b86246c19ea7abd$export$5bf96401662340b7; });
$parcel$export(module.exports, "exists", function () { return $5b86246c19ea7abd$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "Do", function () { return $5b86246c19ea7abd$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $5b86246c19ea7abd$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $5b86246c19ea7abd$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $5b86246c19ea7abd$export$2385a24977818dd0; });
$parcel$export(module.exports, "bindW", function () { return $5b86246c19ea7abd$export$e0d5b1cbe98976d9; });
$parcel$export(module.exports, "apS", function () { return $5b86246c19ea7abd$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "apSW", function () { return $5b86246c19ea7abd$export$5c01f27714264b3d; });
$parcel$export(module.exports, "ApT", function () { return $5b86246c19ea7abd$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $5b86246c19ea7abd$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $5b86246c19ea7abd$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $5b86246c19ea7abd$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $5b86246c19ea7abd$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $5b86246c19ea7abd$export$d330b60315c14cd1; });
$parcel$export(module.exports, "chainW", function () { return $5b86246c19ea7abd$export$8e5885f0163d737a; });
$parcel$export(module.exports, "chain", function () { return $5b86246c19ea7abd$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $5b86246c19ea7abd$export$e3821ef4970c339c; });
$parcel$export(module.exports, "chainFirstW", function () { return $5b86246c19ea7abd$export$5de78197fc44b933; });
$parcel$export(module.exports, "parseJSON", function () { return $5b86246c19ea7abd$export$27924e57e9afff7f; });
$parcel$export(module.exports, "stringifyJSON", function () { return $5b86246c19ea7abd$export$702e019c6853c7a; });
$parcel$export(module.exports, "either", function () { return $5b86246c19ea7abd$export$5f5be1bb6cd1fded; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $5b86246c19ea7abd$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $5b86246c19ea7abd$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getValidationSemigroup", function () { return $5b86246c19ea7abd$export$5c6835227ac7f658; });
$parcel$export(module.exports, "getValidationMonoid", function () { return $5b86246c19ea7abd$export$c6554235dd19af66; });
$parcel$export(module.exports, "getValidation", function () { return $5b86246c19ea7abd$export$6843f928420ce3e4; });

var $dYcKb = parcelRequire("dYcKb");

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $plDG4 = parcelRequire("plDG4");

var $fgwhT = parcelRequire("fgwhT");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $aRVRH = parcelRequire("aRVRH");

var $LdARg = parcelRequire("LdARg");
var $5b86246c19ea7abd$export$eabcd2c8791e7bf4 = $lOGTm.left;
var $5b86246c19ea7abd$export$79ffe56a765070d2 = $lOGTm.right;
var $5b86246c19ea7abd$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $5b86246c19ea7abd$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $5b86246c19ea7abd$export$871de8747c9eaa88(f));
};
var $5b86246c19ea7abd$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $5b86246c19ea7abd$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $5b86246c19ea7abd$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $5b86246c19ea7abd$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $5b86246c19ea7abd$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $5b86246c19ea7abd$export$b66cdc0497d8a99a(M);
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $5b86246c19ea7abd$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $5b86246c19ea7abd$export$7fef8bcdbb34f435(b, f));
};
var $5b86246c19ea7abd$var$_traverse = function(F) {
    var traverseF = $5b86246c19ea7abd$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
var $5b86246c19ea7abd$var$_bimap = function(fa, f, g) {
    return (0, $kj6DU.pipe)(fa, $5b86246c19ea7abd$export$eb54baf0b342cb1d(f, g));
};
var $5b86246c19ea7abd$var$_mapLeft = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $5b86246c19ea7abd$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $5b86246c19ea7abd$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $5b86246c19ea7abd$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $5b86246c19ea7abd$var$_extend = function(wa, f) {
    return (0, $kj6DU.pipe)(wa, $5b86246c19ea7abd$export$8b58be045bf06082(f));
};
var $5b86246c19ea7abd$var$_chainRec = function(a, f) {
    return (0, $plDG4.tailRec)(f(a), function(e) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(e) ? $5b86246c19ea7abd$export$79ffe56a765070d2($5b86246c19ea7abd$export$eabcd2c8791e7bf4(e.left)) : $5b86246c19ea7abd$export$d649b6842e09f2b(e.right) ? $5b86246c19ea7abd$export$eabcd2c8791e7bf4(f(e.right.left)) : $5b86246c19ea7abd$export$79ffe56a765070d2($5b86246c19ea7abd$export$79ffe56a765070d2(e.right.right));
    });
};
var $5b86246c19ea7abd$export$9156e739aa33e19f = 'Either';
var $5b86246c19ea7abd$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $5b86246c19ea7abd$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($5b86246c19ea7abd$export$d649b6842e09f2b(x) ? $5b86246c19ea7abd$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $5b86246c19ea7abd$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $5b86246c19ea7abd$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(y) ? x : $5b86246c19ea7abd$export$d649b6842e09f2b(x) ? y : $5b86246c19ea7abd$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $5b86246c19ea7abd$export$cfae3069ac05ff4c = function(M) {
    var empty = $5b86246c19ea7abd$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $5b86246c19ea7abd$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? (0, $aRVRH.separated)(ma, ma) : $5b86246c19ea7abd$export$d649b6842e09f2b(ma.right) ? (0, $aRVRH.separated)($5b86246c19ea7abd$export$79ffe56a765070d2(ma.right.left), empty) : (0, $aRVRH.separated)(empty, $5b86246c19ea7abd$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $5b86246c19ea7abd$export$a4e870b0a57ec14e = function(M) {
    var empty = $5b86246c19ea7abd$export$eabcd2c8791e7bf4(M.empty);
    var _a = $5b86246c19ea7abd$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? (0, $aRVRH.separated)(ma, ma) : p(ma.right) ? (0, $aRVRH.separated)(empty, $5b86246c19ea7abd$export$79ffe56a765070d2(ma.right)) : (0, $aRVRH.separated)($5b86246c19ea7abd$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
        _E: undefined,
        map: $5b86246c19ea7abd$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($5b86246c19ea7abd$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $5b86246c19ea7abd$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($5b86246c19ea7abd$export$d649b6842e09f2b(ma)) return (0, $aRVRH.separated)(ma, ma);
            var e = f(ma.right);
            return $5b86246c19ea7abd$export$d649b6842e09f2b(e) ? (0, $aRVRH.separated)($5b86246c19ea7abd$export$79ffe56a765070d2(e.left), empty) : (0, $aRVRH.separated)(empty, $5b86246c19ea7abd$export$79ffe56a765070d2(e.right));
        }
    };
};
var $5b86246c19ea7abd$export$bb8ef26a634cac7b = function(M) {
    var F_ = $5b86246c19ea7abd$export$a4e870b0a57ec14e(M);
    var C = $5b86246c19ea7abd$export$cfae3069ac05ff4c(M);
    return {
        URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
        _E: undefined,
        map: $5b86246c19ea7abd$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $5b86246c19ea7abd$var$_traverse,
        sequence: $5b86246c19ea7abd$export$49bb65c2ea163039,
        reduce: $5b86246c19ea7abd$var$_reduce,
        foldMap: $5b86246c19ea7abd$var$_foldMap,
        reduceRight: $5b86246c19ea7abd$var$_reduceRight,
        wither: (0, $LdARg.witherDefault)($5b86246c19ea7abd$export$a0202666c3bda011, C),
        wilt: (0, $LdARg.wiltDefault)($5b86246c19ea7abd$export$a0202666c3bda011, C)
    };
};
var $5b86246c19ea7abd$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
        _E: undefined,
        map: $5b86246c19ea7abd$var$_map,
        ap: function(fab, fa) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(fab) ? $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? $5b86246c19ea7abd$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? fa : $5b86246c19ea7abd$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $5b86246c19ea7abd$export$ba255e9e49e00608
    };
};
var $5b86246c19ea7abd$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
        _E: undefined,
        map: $5b86246c19ea7abd$var$_map,
        alt: function(me, that) {
            if ($5b86246c19ea7abd$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $5b86246c19ea7abd$export$d649b6842e09f2b(ea) ? $5b86246c19ea7abd$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $5b86246c19ea7abd$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? fa : $5b86246c19ea7abd$export$79ffe56a765070d2(f(fa.right));
    };
};
var $5b86246c19ea7abd$export$bd5b6bfc5fa2ee61 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map
};
var $5b86246c19ea7abd$export$6554612db691658e = (0, $kj6DU.dual)(2, (0, $6baua.as)($5b86246c19ea7abd$export$bd5b6bfc5fa2ee61));
var $5b86246c19ea7abd$export$9284b360ca18a0fd = (0, $6baua.asUnit)($5b86246c19ea7abd$export$bd5b6bfc5fa2ee61);
var $5b86246c19ea7abd$export$ba255e9e49e00608 = $5b86246c19ea7abd$export$79ffe56a765070d2;
var $5b86246c19ea7abd$export$59a71046037e6c20 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    of: $5b86246c19ea7abd$export$ba255e9e49e00608
};
var $5b86246c19ea7abd$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fab) ? fab : $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? fa : $5b86246c19ea7abd$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $5b86246c19ea7abd$export$2f6ca3d3b1f80bf5 = $5b86246c19ea7abd$export$321be6e231de8eac;
var $5b86246c19ea7abd$export$efc21ddc6aeb363d = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    ap: $5b86246c19ea7abd$var$_ap
};
var $5b86246c19ea7abd$export$1279d2b7807629fd = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    ap: $5b86246c19ea7abd$var$_ap,
    of: $5b86246c19ea7abd$export$ba255e9e49e00608
};
var $5b86246c19ea7abd$export$f18d5acc27d70423 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    ap: $5b86246c19ea7abd$var$_ap,
    chain: $5b86246c19ea7abd$export$5b8affa63fc6df16
};
var $5b86246c19ea7abd$export$fb641926d034ac7d = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    ap: $5b86246c19ea7abd$var$_ap,
    of: $5b86246c19ea7abd$export$ba255e9e49e00608,
    chain: $5b86246c19ea7abd$export$5b8affa63fc6df16
};
var $5b86246c19ea7abd$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $5b86246c19ea7abd$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $5b86246c19ea7abd$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $5b86246c19ea7abd$export$41404b31838667c9 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    reduce: $5b86246c19ea7abd$var$_reduce,
    foldMap: $5b86246c19ea7abd$var$_foldMap,
    reduceRight: $5b86246c19ea7abd$var$_reduceRight
};
var $5b86246c19ea7abd$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $5b86246c19ea7abd$export$d649b6842e09f2b(ta) ? F.of($5b86246c19ea7abd$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $5b86246c19ea7abd$export$79ffe56a765070d2);
        };
    };
};
var $5b86246c19ea7abd$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? F.of($5b86246c19ea7abd$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $5b86246c19ea7abd$export$79ffe56a765070d2);
    };
};
var $5b86246c19ea7abd$export$a0202666c3bda011 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    reduce: $5b86246c19ea7abd$var$_reduce,
    foldMap: $5b86246c19ea7abd$var$_foldMap,
    reduceRight: $5b86246c19ea7abd$var$_reduceRight,
    traverse: $5b86246c19ea7abd$var$_traverse,
    sequence: $5b86246c19ea7abd$export$49bb65c2ea163039
};
var $5b86246c19ea7abd$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? $5b86246c19ea7abd$export$eabcd2c8791e7bf4(f(fa.left)) : $5b86246c19ea7abd$export$79ffe56a765070d2(g(fa.right));
    };
};
var $5b86246c19ea7abd$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? $5b86246c19ea7abd$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $5b86246c19ea7abd$export$fd0fe42029639505 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    bimap: $5b86246c19ea7abd$var$_bimap,
    mapLeft: $5b86246c19ea7abd$var$_mapLeft
};
var $5b86246c19ea7abd$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $5b86246c19ea7abd$export$228be17d80722ab = $5b86246c19ea7abd$export$1517cca7889d6aaa;
var $5b86246c19ea7abd$export$25ba4469a069167 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    alt: $5b86246c19ea7abd$var$_alt
};
var $5b86246c19ea7abd$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(wa) ? wa : $5b86246c19ea7abd$export$79ffe56a765070d2(f(wa));
    };
};
var $5b86246c19ea7abd$export$5b5dd0e212d2a5bc = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    extend: $5b86246c19ea7abd$var$_extend
};
var $5b86246c19ea7abd$export$be58f7327716329d = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    ap: $5b86246c19ea7abd$var$_ap,
    chain: $5b86246c19ea7abd$export$5b8affa63fc6df16,
    chainRec: $5b86246c19ea7abd$var$_chainRec
};
var $5b86246c19ea7abd$export$8bf7aba4a9e09055 = $5b86246c19ea7abd$export$eabcd2c8791e7bf4;
var $5b86246c19ea7abd$export$5f956d47d0619c3a = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    ap: $5b86246c19ea7abd$var$_ap,
    of: $5b86246c19ea7abd$export$ba255e9e49e00608,
    chain: $5b86246c19ea7abd$export$5b8affa63fc6df16,
    throwError: $5b86246c19ea7abd$export$8bf7aba4a9e09055
};
var $5b86246c19ea7abd$export$825ea6cb6fc48d49 = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    fromEither: (0, $kj6DU.identity)
};
var $5b86246c19ea7abd$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $fgwhT.fromPredicate)($5b86246c19ea7abd$export$825ea6cb6fc48d49);
var $5b86246c19ea7abd$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $fgwhT.fromOption)($5b86246c19ea7abd$export$825ea6cb6fc48d49);
var $5b86246c19ea7abd$export$d649b6842e09f2b = $lOGTm.isLeft;
var $5b86246c19ea7abd$export$a9d71693f0c1a85d = $lOGTm.isRight;
var $5b86246c19ea7abd$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $5b86246c19ea7abd$export$ccb09033cefa61e8 = $5b86246c19ea7abd$export$2d55ea551c238330;
var $5b86246c19ea7abd$export$4659b591c19bdf3d = $5b86246c19ea7abd$export$2d55ea551c238330;
var $5b86246c19ea7abd$export$93e2b83da34ff82a = $5b86246c19ea7abd$export$4659b591c19bdf3d;
var $5b86246c19ea7abd$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $5b86246c19ea7abd$export$8832081647a02ee7 = $5b86246c19ea7abd$export$d8a997ff0e6436f3;
var $5b86246c19ea7abd$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($5b86246c19ea7abd$export$bd5b6bfc5fa2ee61);
var $5b86246c19ea7abd$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($5b86246c19ea7abd$export$efc21ddc6aeb363d);
var $5b86246c19ea7abd$export$ac044f4aa9961a4f = $5b86246c19ea7abd$export$5f28d9feedcfd46e;
var $5b86246c19ea7abd$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($5b86246c19ea7abd$export$efc21ddc6aeb363d);
var $5b86246c19ea7abd$export$8a00020751233172 = $5b86246c19ea7abd$export$ed01bc59c3d06bf3;
var $5b86246c19ea7abd$export$3f23594af5f37336 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dya6d.tap($5b86246c19ea7abd$export$f18d5acc27d70423));
var $5b86246c19ea7abd$export$2409099f1fc434fb = /*#__PURE__*/ $5b86246c19ea7abd$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $5b86246c19ea7abd$export$bffa455ba8c619a6 = $5b86246c19ea7abd$export$2409099f1fc434fb;
var $5b86246c19ea7abd$export$ecd5e8ace626722c = /*#__PURE__*/ $5b86246c19ea7abd$export$8b58be045bf06082((0, $kj6DU.identity));
var $5b86246c19ea7abd$export$a907462f448b49f8 = /*#__PURE__*/ (0, $fgwhT.fromOptionK)($5b86246c19ea7abd$export$825ea6cb6fc48d49);
var $5b86246c19ea7abd$export$12d26179deb6a68a = /*#__PURE__*/ (0, $fgwhT.chainOptionK)($5b86246c19ea7abd$export$825ea6cb6fc48d49, $5b86246c19ea7abd$export$f18d5acc27d70423);
var $5b86246c19ea7abd$export$377cc334277e5c3c = $5b86246c19ea7abd$export$12d26179deb6a68a;
/** @internal */ var $5b86246c19ea7abd$var$_FromEither = {
    fromEither: $5b86246c19ea7abd$export$825ea6cb6fc48d49.fromEither
};
var $5b86246c19ea7abd$export$cd139e14432f317b = /*#__PURE__*/ $lOGTm.liftNullable($5b86246c19ea7abd$var$_FromEither);
var $5b86246c19ea7abd$export$ea4a22f93200df79 = /*#__PURE__*/ $lOGTm.liftOption($5b86246c19ea7abd$var$_FromEither);
/** @internal */ var $5b86246c19ea7abd$var$_FlatMap = {
    flatMap: $5b86246c19ea7abd$export$5b8affa63fc6df16
};
var $5b86246c19ea7abd$export$1a0515933c5c84fe = /*#__PURE__*/ $lOGTm.flatMapNullable($5b86246c19ea7abd$var$_FromEither, $5b86246c19ea7abd$var$_FlatMap);
var $5b86246c19ea7abd$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $lOGTm.flatMapOption($5b86246c19ea7abd$var$_FromEither, $5b86246c19ea7abd$var$_FlatMap);
var $5b86246c19ea7abd$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $fgwhT.filterOrElse)($5b86246c19ea7abd$export$825ea6cb6fc48d49, $5b86246c19ea7abd$export$f18d5acc27d70423);
var $5b86246c19ea7abd$export$84511cf4503ec9dd = $5b86246c19ea7abd$export$30af8ca9498ddf5b;
var $5b86246c19ea7abd$export$b0e76d9850c64156 = function(ma) {
    return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? $5b86246c19ea7abd$export$79ffe56a765070d2(ma.left) : $5b86246c19ea7abd$export$eabcd2c8791e7bf4(ma.right);
};
var $5b86246c19ea7abd$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $5b86246c19ea7abd$export$41d1a04d78e7b141 = $5b86246c19ea7abd$export$efd845e0c87089a6;
var $5b86246c19ea7abd$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $5b86246c19ea7abd$export$eabcd2c8791e7bf4(e) : $5b86246c19ea7abd$export$79ffe56a765070d2(a);
    };
};
var $5b86246c19ea7abd$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $5b86246c19ea7abd$export$79ffe56a765070d2(f());
    } catch (e) {
        return $5b86246c19ea7abd$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $5b86246c19ea7abd$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $5b86246c19ea7abd$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $5b86246c19ea7abd$export$c69ca7b73fad45e1 = function(e) {
    var from = $5b86246c19ea7abd$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $kj6DU.flow)(f, from);
    };
};
var $5b86246c19ea7abd$export$c81f992c08fd0bf3 = function(e) {
    var from = $5b86246c19ea7abd$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $5b86246c19ea7abd$export$5b8affa63fc6df16(from(f));
    };
};
var $5b86246c19ea7abd$export$a0886ed3a572729f = /*#__PURE__*/ $5b86246c19ea7abd$export$ccb09033cefa61e8((0, $kj6DU.identity), (0, $kj6DU.identity));
function $5b86246c19ea7abd$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $5b86246c19ea7abd$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $5b86246c19ea7abd$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $5b86246c19ea7abd$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $5b86246c19ea7abd$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $5b86246c19ea7abd$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $5b86246c19ea7abd$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $5b86246c19ea7abd$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($5b86246c19ea7abd$export$bd5b6bfc5fa2ee61);
var $5b86246c19ea7abd$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($5b86246c19ea7abd$export$bd5b6bfc5fa2ee61);
var $5b86246c19ea7abd$export$2385a24977818dd0 = /*#__PURE__*/ $dya6d.bind($5b86246c19ea7abd$export$f18d5acc27d70423);
var $5b86246c19ea7abd$export$e0d5b1cbe98976d9 = $5b86246c19ea7abd$export$2385a24977818dd0;
var $5b86246c19ea7abd$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($5b86246c19ea7abd$export$efc21ddc6aeb363d);
var $5b86246c19ea7abd$export$5c01f27714264b3d = $5b86246c19ea7abd$export$8cbfc0239f42bb49;
var $5b86246c19ea7abd$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $5b86246c19ea7abd$export$ba255e9e49e00608($lOGTm.emptyReadonlyArray);
var $5b86246c19ea7abd$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $lOGTm.head(as));
        if ($5b86246c19ea7abd$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($5b86246c19ea7abd$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $5b86246c19ea7abd$export$79ffe56a765070d2(out);
    };
};
var $5b86246c19ea7abd$export$d4e79db5dc14cc1 = function(f) {
    var g = $5b86246c19ea7abd$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $5b86246c19ea7abd$export$c74b6e34b2b6efb0;
    };
};
var $5b86246c19ea7abd$export$104a2841e9cbad06 = $5b86246c19ea7abd$export$d4e79db5dc14cc1;
var $5b86246c19ea7abd$export$64f39b2a2b79e1b1 = function(f) {
    return $5b86246c19ea7abd$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $5b86246c19ea7abd$export$d330b60315c14cd1 = /*#__PURE__*/ $5b86246c19ea7abd$export$64f39b2a2b79e1b1((0, $kj6DU.identity));
var $5b86246c19ea7abd$export$8e5885f0163d737a = $5b86246c19ea7abd$export$5b8affa63fc6df16;
var $5b86246c19ea7abd$export$e08e3b67e392101e = $5b86246c19ea7abd$export$5b8affa63fc6df16;
var $5b86246c19ea7abd$export$e3821ef4970c339c = $5b86246c19ea7abd$export$3f23594af5f37336;
var $5b86246c19ea7abd$export$5de78197fc44b933 = $5b86246c19ea7abd$export$3f23594af5f37336;
function $5b86246c19ea7abd$export$27924e57e9afff7f(s, onError) {
    return $5b86246c19ea7abd$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $5b86246c19ea7abd$export$702e019c6853c7a = function(u, onError) {
    return $5b86246c19ea7abd$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $5b86246c19ea7abd$export$5f5be1bb6cd1fded = {
    URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
    map: $5b86246c19ea7abd$var$_map,
    of: $5b86246c19ea7abd$export$ba255e9e49e00608,
    ap: $5b86246c19ea7abd$var$_ap,
    chain: $5b86246c19ea7abd$export$5b8affa63fc6df16,
    reduce: $5b86246c19ea7abd$var$_reduce,
    foldMap: $5b86246c19ea7abd$var$_foldMap,
    reduceRight: $5b86246c19ea7abd$var$_reduceRight,
    traverse: $5b86246c19ea7abd$var$_traverse,
    sequence: $5b86246c19ea7abd$export$49bb65c2ea163039,
    bimap: $5b86246c19ea7abd$var$_bimap,
    mapLeft: $5b86246c19ea7abd$var$_mapLeft,
    alt: $5b86246c19ea7abd$var$_alt,
    extend: $5b86246c19ea7abd$var$_extend,
    chainRec: $5b86246c19ea7abd$var$_chainRec,
    throwError: $5b86246c19ea7abd$export$8bf7aba4a9e09055
};
var $5b86246c19ea7abd$export$18979a515d2a828e = /*#__PURE__*/ (0, $j7Bi0.getApplySemigroup)($5b86246c19ea7abd$export$efc21ddc6aeb363d);
var $5b86246c19ea7abd$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $dYcKb.getApplicativeMonoid)($5b86246c19ea7abd$export$1279d2b7807629fd);
var $5b86246c19ea7abd$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $j7Bi0.getApplySemigroup)($5b86246c19ea7abd$export$d9540e18497e6036(SE))(SA);
};
var $5b86246c19ea7abd$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $dYcKb.getApplicativeMonoid)($5b86246c19ea7abd$export$d9540e18497e6036(SE))(MA);
};
function $5b86246c19ea7abd$export$6843f928420ce3e4(SE) {
    var ap = $5b86246c19ea7abd$export$d9540e18497e6036(SE).ap;
    var alt = $5b86246c19ea7abd$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $5b86246c19ea7abd$export$9156e739aa33e19f,
        _E: undefined,
        map: $5b86246c19ea7abd$var$_map,
        of: $5b86246c19ea7abd$export$ba255e9e49e00608,
        chain: $5b86246c19ea7abd$export$5b8affa63fc6df16,
        bimap: $5b86246c19ea7abd$var$_bimap,
        mapLeft: $5b86246c19ea7abd$var$_mapLeft,
        reduce: $5b86246c19ea7abd$var$_reduce,
        foldMap: $5b86246c19ea7abd$var$_foldMap,
        reduceRight: $5b86246c19ea7abd$var$_reduceRight,
        extend: $5b86246c19ea7abd$var$_extend,
        traverse: $5b86246c19ea7abd$var$_traverse,
        sequence: $5b86246c19ea7abd$export$49bb65c2ea163039,
        chainRec: $5b86246c19ea7abd$var$_chainRec,
        throwError: $5b86246c19ea7abd$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("plDG4", function(module, exports) {

$parcel$export(module.exports, "tailRec", function () { return $04c31ef5ec0a9b9a$export$2e586eaa876dd2fd; });
/**
 * @since 2.0.0
 */ var $04c31ef5ec0a9b9a$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

});




parcelRegister("6Q2iq", function(module, exports) {

$parcel$export(module.exports, "asLens", function () { return $4fa96165d959e003$export$ba6dbfc52e933ec; });
$parcel$export(module.exports, "asPrism", function () { return $4fa96165d959e003$export$6963d4cf5712e556; });
$parcel$export(module.exports, "asOptional", function () { return $4fa96165d959e003$export$81a625dd455a09de; });
$parcel$export(module.exports, "asTraversal", function () { return $4fa96165d959e003$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $4fa96165d959e003$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "reverse", function () { return $4fa96165d959e003$export$66c1ae025e96b4bc; });
$parcel$export(module.exports, "modify", function () { return $4fa96165d959e003$export$3ff57735a52b8713; });

var $kj6DU = parcelRequire("kj6DU");

var $6piwk = parcelRequire("6piwk");

var $cQdlc = parcelRequire("cQdlc");
var $4fa96165d959e003$export$1aba8f741a0eae06 = $cQdlc.iso;
var $4fa96165d959e003$export$d560c7e4a29451c2 = function() {
    return $4fa96165d959e003$export$1aba8f741a0eae06((0, $kj6DU.identity), (0, $kj6DU.identity));
};
var $4fa96165d959e003$export$ba6dbfc52e933ec = $cQdlc.isoAsLens;
var $4fa96165d959e003$export$6963d4cf5712e556 = $cQdlc.isoAsPrism;
var $4fa96165d959e003$export$81a625dd455a09de = $cQdlc.isoAsOptional;
var $4fa96165d959e003$export$ef38eac73d6f828f = $cQdlc.isoAsTraversal;
var $4fa96165d959e003$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $4fa96165d959e003$export$1aba8f741a0eae06((0, $kj6DU.flow)(sa.get, ab.get), (0, $kj6DU.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $4fa96165d959e003$export$220ad92d18dabdd7 = $4fa96165d959e003$export$f672e0b6f7222cd7;
var $4fa96165d959e003$export$f5c3e419c6a355ce = function(ab) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ba6dbfc52e933ec, $cQdlc.lensComposeLens(ab));
};
var $4fa96165d959e003$export$c1dc05e399870f6 = function(ab) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$6963d4cf5712e556, $cQdlc.prismComposePrism(ab));
};
var $4fa96165d959e003$export$323f76c400675c8b = function(ab) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$81a625dd455a09de, $cQdlc.optionalComposeOptional(ab));
};
var $4fa96165d959e003$export$aa978f69e007229f = function(ab) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ef38eac73d6f828f, $cQdlc.traversalComposeTraversal(ab));
};
var $4fa96165d959e003$export$66c1ae025e96b4bc = function(sa) {
    return $4fa96165d959e003$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $4fa96165d959e003$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $4fa96165d959e003$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $6piwk.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $4fa96165d959e003$export$b601f49376b4621a = function(sa) {
    return $4fa96165d959e003$export$c1dc05e399870f6($cQdlc.prismFromNullable())(sa);
};
function $4fa96165d959e003$export$3dea766d36a8935f(predicate) {
    return $4fa96165d959e003$export$c1dc05e399870f6($cQdlc.prismFromPredicate(predicate));
}
var $4fa96165d959e003$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ba6dbfc52e933ec, $cQdlc.lensProp(prop));
};
var $4fa96165d959e003$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ba6dbfc52e933ec, $cQdlc.lensProps.apply($cQdlc, props));
};
var $4fa96165d959e003$export$d8556a2a8f973135 = function(prop) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ba6dbfc52e933ec, $cQdlc.lensComponent(prop));
};
var $4fa96165d959e003$export$b610b8812bbcded9 = function(i) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$81a625dd455a09de, $cQdlc.optionalIndex(i));
};
var $4fa96165d959e003$export$84162b00c25b711c = function(i) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$81a625dd455a09de, $cQdlc.optionalIndexNonEmpty(i));
};
var $4fa96165d959e003$export$df61b30b684217c0 = function(key) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$81a625dd455a09de, $cQdlc.optionalKey(key));
};
var $4fa96165d959e003$export$976574c443b9185b = function(key) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ba6dbfc52e933ec, $cQdlc.lensAtKey(key));
};
var $4fa96165d959e003$export$ad14ef4001db2bcd = /*#__PURE__*/ $4fa96165d959e003$export$c1dc05e399870f6(/*#__PURE__*/ $cQdlc.prismSome());
var $4fa96165d959e003$export$79ffe56a765070d2 = /*#__PURE__*/ $4fa96165d959e003$export$c1dc05e399870f6(/*#__PURE__*/ $cQdlc.prismRight());
var $4fa96165d959e003$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $4fa96165d959e003$export$c1dc05e399870f6(/*#__PURE__*/ $cQdlc.prismLeft());
function $4fa96165d959e003$export$df3f009e3d155b20(T) {
    return (0, $kj6DU.flow)($4fa96165d959e003$export$ef38eac73d6f828f, $cQdlc.traversalTraverse(T));
}
function $4fa96165d959e003$export$9a2f228bed5035c2(predicate) {
    return $4fa96165d959e003$export$323f76c400675c8b($cQdlc.optionalFindFirst(predicate));
}
function $4fa96165d959e003$export$28e1f787311e0a21(predicate) {
    return $4fa96165d959e003$export$323f76c400675c8b($cQdlc.optionalFindFirstNonEmpty(predicate));
}
var $4fa96165d959e003$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $4fa96165d959e003$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $4fa96165d959e003$var$imap_ = function(ea, ab, ba) {
    return $4fa96165d959e003$export$1aba8f741a0eae06((0, $kj6DU.flow)(ea.get, ab), (0, $kj6DU.flow)(ba, ea.reverseGet));
};
var $4fa96165d959e003$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $4fa96165d959e003$export$dbdf692cc5737cfd = {
    URI: $4fa96165d959e003$export$9156e739aa33e19f,
    imap: $4fa96165d959e003$var$imap_
};
var $4fa96165d959e003$export$67666a3fb7d250d8 = {
    URI: $4fa96165d959e003$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $4fa96165d959e003$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $4fa96165d959e003$export$3a8840c5b2ecf003 = {
    URI: $4fa96165d959e003$export$9156e739aa33e19f,
    compose: $4fa96165d959e003$export$67666a3fb7d250d8.compose,
    id: $4fa96165d959e003$export$d560c7e4a29451c2
};

});

parcelRegister("3j2p6", function(module, exports) {

$parcel$export(module.exports, "fromAt", function () { return $268502cfc8006b3c$export$c4dd3e639c7af330; });
$parcel$export(module.exports, "fromIso", function () { return $268502cfc8006b3c$export$3160d47a1ad63980; });
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 
var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");

var $cQdlc = parcelRequire("cQdlc");

var $8RK6P = parcelRequire("8RK6P");
var $268502cfc8006b3c$export$b610b8812bbcded9 = $cQdlc.index;
var $268502cfc8006b3c$export$c4dd3e639c7af330 = function(at) {
    return $268502cfc8006b3c$export$b610b8812bbcded9(function(i) {
        return $cQdlc.lensComposePrism($cQdlc.prismSome())(at.at(i));
    });
};
var $268502cfc8006b3c$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $268502cfc8006b3c$export$b610b8812bbcded9(function(i) {
            return (0, $6piwk.pipe)(iso, $cQdlc.isoAsOptional, $cQdlc.optionalComposeOptional(sia.index(i)));
        });
    };
};
var $268502cfc8006b3c$export$bb0c054375ca4b0 = $cQdlc.indexReadonlyArray;
var $268502cfc8006b3c$export$165af7b747e6b1f1 = $cQdlc.indexReadonlyNonEmptyArray;
var $268502cfc8006b3c$export$3c3468aec3b83bbf = $cQdlc.indexReadonlyRecord;
var $268502cfc8006b3c$export$92da200d6ddb6846 = function(E) {
    var lookupE = $8RK6P.lookup(E);
    var insertAtE = $8RK6P.insertAt(E);
    return function() {
        return $268502cfc8006b3c$export$b610b8812bbcded9(function(key) {
            return $cQdlc.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $6piwk.pipe)(lookupE(key, s), $3NXK3.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $268502cfc8006b3c$export$2cd1c249765cd0a4 = $cQdlc.indexReadonlyArray;
var $268502cfc8006b3c$export$720226bf1ef46cb2 = $cQdlc.indexReadonlyRecord;

});

parcelRegister("4QCFr", function(module, exports) {

$parcel$export(module.exports, "lens", function () { return $387a0350a51998b1$export$21cde5187c2605a3; });
$parcel$export(module.exports, "id", function () { return $387a0350a51998b1$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "asOptional", function () { return $387a0350a51998b1$export$81a625dd455a09de; });
$parcel$export(module.exports, "asTraversal", function () { return $387a0350a51998b1$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $387a0350a51998b1$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "composeLens", function () { return $387a0350a51998b1$export$f5c3e419c6a355ce; });
$parcel$export(module.exports, "composeIso", function () { return $387a0350a51998b1$export$220ad92d18dabdd7; });
$parcel$export(module.exports, "composePrism", function () { return $387a0350a51998b1$export$c1dc05e399870f6; });
$parcel$export(module.exports, "composeOptional", function () { return $387a0350a51998b1$export$323f76c400675c8b; });
$parcel$export(module.exports, "composeTraversal", function () { return $387a0350a51998b1$export$aa978f69e007229f; });
$parcel$export(module.exports, "modify", function () { return $387a0350a51998b1$export$3ff57735a52b8713; });
$parcel$export(module.exports, "modifyF", function () { return $387a0350a51998b1$export$a28005d3e6beb9a6; });
$parcel$export(module.exports, "fromNullable", function () { return $387a0350a51998b1$export$b601f49376b4621a; });
$parcel$export(module.exports, "filter", function () { return $387a0350a51998b1$export$3dea766d36a8935f; });
$parcel$export(module.exports, "prop", function () { return $387a0350a51998b1$export$977f3f6a9323c0f6; });
$parcel$export(module.exports, "props", function () { return $387a0350a51998b1$export$8128bb6492cf3de7; });
$parcel$export(module.exports, "component", function () { return $387a0350a51998b1$export$d8556a2a8f973135; });
$parcel$export(module.exports, "index", function () { return $387a0350a51998b1$export$b610b8812bbcded9; });
$parcel$export(module.exports, "indexNonEmpty", function () { return $387a0350a51998b1$export$84162b00c25b711c; });
$parcel$export(module.exports, "key", function () { return $387a0350a51998b1$export$df61b30b684217c0; });
$parcel$export(module.exports, "atKey", function () { return $387a0350a51998b1$export$976574c443b9185b; });
$parcel$export(module.exports, "some", function () { return $387a0350a51998b1$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "right", function () { return $387a0350a51998b1$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $387a0350a51998b1$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "traverse", function () { return $387a0350a51998b1$export$df3f009e3d155b20; });
$parcel$export(module.exports, "findFirst", function () { return $387a0350a51998b1$export$9a2f228bed5035c2; });
$parcel$export(module.exports, "findFirstNonEmpty", function () { return $387a0350a51998b1$export$28e1f787311e0a21; });
$parcel$export(module.exports, "imap", function () { return $387a0350a51998b1$export$b2517b0ab3a58435; });
$parcel$export(module.exports, "URI", function () { return $387a0350a51998b1$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Invariant", function () { return $387a0350a51998b1$export$dbdf692cc5737cfd; });
$parcel$export(module.exports, "Semigroupoid", function () { return $387a0350a51998b1$export$67666a3fb7d250d8; });
$parcel$export(module.exports, "Category", function () { return $387a0350a51998b1$export$3a8840c5b2ecf003; });

var $kj6DU = parcelRequire("kj6DU");

var $6piwk = parcelRequire("6piwk");

var $cQdlc = parcelRequire("cQdlc");
var $387a0350a51998b1$export$21cde5187c2605a3 = $cQdlc.lens;
var $387a0350a51998b1$export$d560c7e4a29451c2 = $cQdlc.lensId;
var $387a0350a51998b1$export$81a625dd455a09de = $cQdlc.lensAsOptional;
var $387a0350a51998b1$export$ef38eac73d6f828f = $cQdlc.lensAsTraversal;
var $387a0350a51998b1$export$f672e0b6f7222cd7 = $cQdlc.lensComposeLens;
var $387a0350a51998b1$export$f5c3e419c6a355ce = $387a0350a51998b1$export$f672e0b6f7222cd7;
var $387a0350a51998b1$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.isoAsLens, $387a0350a51998b1$export$f672e0b6f7222cd7);
var $387a0350a51998b1$export$c1dc05e399870f6 = $cQdlc.lensComposePrism;
var $387a0350a51998b1$export$323f76c400675c8b = function(ab) {
    return (0, $kj6DU.flow)($387a0350a51998b1$export$81a625dd455a09de, $cQdlc.optionalComposeOptional(ab));
};
var $387a0350a51998b1$export$aa978f69e007229f = function(ab) {
    return (0, $kj6DU.flow)($387a0350a51998b1$export$ef38eac73d6f828f, $cQdlc.traversalComposeTraversal(ab));
};
var $387a0350a51998b1$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $387a0350a51998b1$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $6piwk.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $387a0350a51998b1$export$b601f49376b4621a = function(sa) {
    return $387a0350a51998b1$export$c1dc05e399870f6($cQdlc.prismFromNullable())(sa);
};
function $387a0350a51998b1$export$3dea766d36a8935f(predicate) {
    return $387a0350a51998b1$export$c1dc05e399870f6($cQdlc.prismFromPredicate(predicate));
}
var $387a0350a51998b1$export$977f3f6a9323c0f6 = $cQdlc.lensProp;
var $387a0350a51998b1$export$8128bb6492cf3de7 = $cQdlc.lensProps;
var $387a0350a51998b1$export$d8556a2a8f973135 = $cQdlc.lensComponent;
var $387a0350a51998b1$export$b610b8812bbcded9 = function(i) {
    return (0, $kj6DU.flow)($387a0350a51998b1$export$81a625dd455a09de, $cQdlc.optionalIndex(i));
};
var $387a0350a51998b1$export$84162b00c25b711c = function(i) {
    return (0, $kj6DU.flow)($387a0350a51998b1$export$81a625dd455a09de, $cQdlc.optionalIndexNonEmpty(i));
};
var $387a0350a51998b1$export$df61b30b684217c0 = function(key) {
    return (0, $kj6DU.flow)($387a0350a51998b1$export$81a625dd455a09de, $cQdlc.optionalKey(key));
};
var $387a0350a51998b1$export$976574c443b9185b = $cQdlc.lensAtKey;
var $387a0350a51998b1$export$ad14ef4001db2bcd = /*#__PURE__*/ $387a0350a51998b1$export$c1dc05e399870f6(/*#__PURE__*/ $cQdlc.prismSome());
var $387a0350a51998b1$export$79ffe56a765070d2 = /*#__PURE__*/ $387a0350a51998b1$export$c1dc05e399870f6(/*#__PURE__*/ $cQdlc.prismRight());
var $387a0350a51998b1$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $387a0350a51998b1$export$c1dc05e399870f6(/*#__PURE__*/ $cQdlc.prismLeft());
function $387a0350a51998b1$export$df3f009e3d155b20(T) {
    return (0, $kj6DU.flow)($387a0350a51998b1$export$ef38eac73d6f828f, $cQdlc.traversalTraverse(T));
}
function $387a0350a51998b1$export$9a2f228bed5035c2(predicate) {
    return $387a0350a51998b1$export$323f76c400675c8b($cQdlc.optionalFindFirst(predicate));
}
function $387a0350a51998b1$export$28e1f787311e0a21(predicate) {
    return $387a0350a51998b1$export$323f76c400675c8b($cQdlc.optionalFindFirstNonEmpty(predicate));
}
var $387a0350a51998b1$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $387a0350a51998b1$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $387a0350a51998b1$var$imap_ = function(ea, ab, ba) {
    return $387a0350a51998b1$export$21cde5187c2605a3((0, $kj6DU.flow)(ea.get, ab), (0, $kj6DU.flow)(ba, ea.set));
};
var $387a0350a51998b1$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $387a0350a51998b1$export$dbdf692cc5737cfd = {
    URI: $387a0350a51998b1$export$9156e739aa33e19f,
    imap: $387a0350a51998b1$var$imap_
};
var $387a0350a51998b1$export$67666a3fb7d250d8 = {
    URI: $387a0350a51998b1$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $387a0350a51998b1$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $387a0350a51998b1$export$3a8840c5b2ecf003 = {
    URI: $387a0350a51998b1$export$9156e739aa33e19f,
    compose: $387a0350a51998b1$export$67666a3fb7d250d8.compose,
    id: $387a0350a51998b1$export$d560c7e4a29451c2
};

});

parcelRegister("kyy1y", function(module, exports) {

$parcel$export(module.exports, "optional", function () { return $ef71601670a1f878$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "id", function () { return $ef71601670a1f878$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "asTraversal", function () { return $ef71601670a1f878$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $ef71601670a1f878$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "composeOptional", function () { return $ef71601670a1f878$export$323f76c400675c8b; });
$parcel$export(module.exports, "composeIso", function () { return $ef71601670a1f878$export$220ad92d18dabdd7; });
$parcel$export(module.exports, "composeLens", function () { return $ef71601670a1f878$export$f5c3e419c6a355ce; });
$parcel$export(module.exports, "composePrism", function () { return $ef71601670a1f878$export$c1dc05e399870f6; });
$parcel$export(module.exports, "composeTraversal", function () { return $ef71601670a1f878$export$aa978f69e007229f; });
$parcel$export(module.exports, "modifyOption", function () { return $ef71601670a1f878$export$a2ef9d652875bdfa; });
$parcel$export(module.exports, "setOption", function () { return $ef71601670a1f878$export$b2a7969df3fe0aa3; });
$parcel$export(module.exports, "modify", function () { return $ef71601670a1f878$export$3ff57735a52b8713; });
$parcel$export(module.exports, "modifyF", function () { return $ef71601670a1f878$export$a28005d3e6beb9a6; });
$parcel$export(module.exports, "fromNullable", function () { return $ef71601670a1f878$export$b601f49376b4621a; });
$parcel$export(module.exports, "filter", function () { return $ef71601670a1f878$export$3dea766d36a8935f; });
$parcel$export(module.exports, "prop", function () { return $ef71601670a1f878$export$977f3f6a9323c0f6; });
$parcel$export(module.exports, "props", function () { return $ef71601670a1f878$export$8128bb6492cf3de7; });
$parcel$export(module.exports, "component", function () { return $ef71601670a1f878$export$d8556a2a8f973135; });
$parcel$export(module.exports, "index", function () { return $ef71601670a1f878$export$b610b8812bbcded9; });
$parcel$export(module.exports, "indexNonEmpty", function () { return $ef71601670a1f878$export$84162b00c25b711c; });
$parcel$export(module.exports, "key", function () { return $ef71601670a1f878$export$df61b30b684217c0; });
$parcel$export(module.exports, "atKey", function () { return $ef71601670a1f878$export$976574c443b9185b; });
$parcel$export(module.exports, "some", function () { return $ef71601670a1f878$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "right", function () { return $ef71601670a1f878$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $ef71601670a1f878$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "traverse", function () { return $ef71601670a1f878$export$df3f009e3d155b20; });
$parcel$export(module.exports, "findFirst", function () { return $ef71601670a1f878$export$9a2f228bed5035c2; });
$parcel$export(module.exports, "findFirstNonEmpty", function () { return $ef71601670a1f878$export$28e1f787311e0a21; });
$parcel$export(module.exports, "imap", function () { return $ef71601670a1f878$export$b2517b0ab3a58435; });
$parcel$export(module.exports, "URI", function () { return $ef71601670a1f878$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Invariant", function () { return $ef71601670a1f878$export$dbdf692cc5737cfd; });
$parcel$export(module.exports, "Semigroupoid", function () { return $ef71601670a1f878$export$67666a3fb7d250d8; });
$parcel$export(module.exports, "Category", function () { return $ef71601670a1f878$export$3a8840c5b2ecf003; });

var $kj6DU = parcelRequire("kj6DU");

var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");

var $cQdlc = parcelRequire("cQdlc");
var $ef71601670a1f878$export$516e28dec6a4b6d4 = $cQdlc.optional;
var $ef71601670a1f878$export$d560c7e4a29451c2 = function() {
    return $ef71601670a1f878$export$516e28dec6a4b6d4($3NXK3.some, (0, $kj6DU.constant));
};
var $ef71601670a1f878$export$ef38eac73d6f828f = $cQdlc.optionalAsTraversal;
var $ef71601670a1f878$export$f672e0b6f7222cd7 = $cQdlc.optionalComposeOptional;
var $ef71601670a1f878$export$323f76c400675c8b = $ef71601670a1f878$export$f672e0b6f7222cd7;
var $ef71601670a1f878$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.isoAsOptional, $ef71601670a1f878$export$f672e0b6f7222cd7);
var $ef71601670a1f878$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.lensAsOptional, $cQdlc.optionalComposeOptional);
var $ef71601670a1f878$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.prismAsOptional, $cQdlc.optionalComposeOptional);
var $ef71601670a1f878$export$aa978f69e007229f = function(ab) {
    return (0, $kj6DU.flow)($ef71601670a1f878$export$ef38eac73d6f828f, $cQdlc.traversalComposeTraversal(ab));
};
var $ef71601670a1f878$export$a2ef9d652875bdfa = $cQdlc.optionalModifyOption;
var $ef71601670a1f878$export$b2a7969df3fe0aa3 = function(a) {
    return $ef71601670a1f878$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $ef71601670a1f878$export$3ff57735a52b8713 = $cQdlc.optionalModify;
function $ef71601670a1f878$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $6piwk.pipe)(sa.getOption(s), $3NXK3.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $ef71601670a1f878$export$b601f49376b4621a = /*#__PURE__*/ $ef71601670a1f878$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsOptional(/*#__PURE__*/ $cQdlc.prismFromNullable()));
function $ef71601670a1f878$export$3dea766d36a8935f(predicate) {
    return $ef71601670a1f878$export$f672e0b6f7222cd7($cQdlc.prismAsOptional($cQdlc.prismFromPredicate(predicate)));
}
var $ef71601670a1f878$export$977f3f6a9323c0f6 = function(prop) {
    return $ef71601670a1f878$export$f672e0b6f7222cd7((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensProp(prop), $cQdlc.lensAsOptional));
};
var $ef71601670a1f878$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $ef71601670a1f878$export$f672e0b6f7222cd7((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensProps.apply($cQdlc, props), $cQdlc.lensAsOptional));
};
var $ef71601670a1f878$export$d8556a2a8f973135 = function(prop) {
    return $ef71601670a1f878$export$f672e0b6f7222cd7((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensComponent(prop), $cQdlc.lensAsOptional));
};
var $ef71601670a1f878$export$b610b8812bbcded9 = $cQdlc.optionalIndex;
var $ef71601670a1f878$export$84162b00c25b711c = $cQdlc.optionalIndexNonEmpty;
var $ef71601670a1f878$export$df61b30b684217c0 = $cQdlc.optionalKey;
var $ef71601670a1f878$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $ef71601670a1f878$export$f672e0b6f7222cd7($cQdlc.lensAsOptional($cQdlc.atReadonlyRecord().at(key))));
    };
};
var $ef71601670a1f878$export$ad14ef4001db2bcd = /*#__PURE__*/ $ef71601670a1f878$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsOptional(/*#__PURE__*/ $cQdlc.prismSome()));
var $ef71601670a1f878$export$79ffe56a765070d2 = /*#__PURE__*/ $ef71601670a1f878$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsOptional(/*#__PURE__*/ $cQdlc.prismRight()));
var $ef71601670a1f878$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $ef71601670a1f878$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsOptional(/*#__PURE__*/ $cQdlc.prismLeft()));
function $ef71601670a1f878$export$df3f009e3d155b20(T) {
    return (0, $kj6DU.flow)($ef71601670a1f878$export$ef38eac73d6f828f, $cQdlc.traversalTraverse(T));
}
function $ef71601670a1f878$export$9a2f228bed5035c2(predicate) {
    return $ef71601670a1f878$export$f672e0b6f7222cd7($cQdlc.optionalFindFirst(predicate));
}
function $ef71601670a1f878$export$28e1f787311e0a21(predicate) {
    return $ef71601670a1f878$export$f672e0b6f7222cd7($cQdlc.optionalFindFirstNonEmpty(predicate));
}
var $ef71601670a1f878$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $ef71601670a1f878$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $ef71601670a1f878$var$imap_ = function(ea, ab, ba) {
    return $ef71601670a1f878$export$516e28dec6a4b6d4((0, $kj6DU.flow)(ea.getOption, $3NXK3.map(ab)), (0, $kj6DU.flow)(ba, ea.set));
};
var $ef71601670a1f878$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $ef71601670a1f878$export$dbdf692cc5737cfd = {
    URI: $ef71601670a1f878$export$9156e739aa33e19f,
    imap: $ef71601670a1f878$var$imap_
};
var $ef71601670a1f878$export$67666a3fb7d250d8 = {
    URI: $ef71601670a1f878$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $ef71601670a1f878$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $ef71601670a1f878$export$3a8840c5b2ecf003 = {
    URI: $ef71601670a1f878$export$9156e739aa33e19f,
    compose: $ef71601670a1f878$export$67666a3fb7d250d8.compose,
    id: $ef71601670a1f878$export$d560c7e4a29451c2
};

});

parcelRegister("bkb82", function(module, exports) {

$parcel$export(module.exports, "fromPredicate", function () { return $83ea31e4f823e051$export$23f31c55d7162b91; });
$parcel$export(module.exports, "asOptional", function () { return $83ea31e4f823e051$export$81a625dd455a09de; });
$parcel$export(module.exports, "asTraversal", function () { return $83ea31e4f823e051$export$ef38eac73d6f828f; });
$parcel$export(module.exports, "compose", function () { return $83ea31e4f823e051$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "composeLens", function () { return $83ea31e4f823e051$export$f5c3e419c6a355ce; });

var $kj6DU = parcelRequire("kj6DU");

var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");

var $cQdlc = parcelRequire("cQdlc");
var $83ea31e4f823e051$export$e469dcfea9910464 = $cQdlc.prism;
var $83ea31e4f823e051$export$d560c7e4a29451c2 = function() {
    return $83ea31e4f823e051$export$e469dcfea9910464($3NXK3.some, (0, $kj6DU.identity));
};
var $83ea31e4f823e051$export$23f31c55d7162b91 = $cQdlc.prismFromPredicate;
var $83ea31e4f823e051$export$81a625dd455a09de = $cQdlc.prismAsOptional;
var $83ea31e4f823e051$export$ef38eac73d6f828f = $cQdlc.prismAsTraversal;
var $83ea31e4f823e051$export$f672e0b6f7222cd7 = $cQdlc.prismComposePrism;
var $83ea31e4f823e051$export$c1dc05e399870f6 = $83ea31e4f823e051$export$f672e0b6f7222cd7;
var $83ea31e4f823e051$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.isoAsPrism, $83ea31e4f823e051$export$f672e0b6f7222cd7);
var $83ea31e4f823e051$export$f5c3e419c6a355ce = $cQdlc.prismComposeLens;
var $83ea31e4f823e051$export$323f76c400675c8b = function(ab) {
    return (0, $kj6DU.flow)($83ea31e4f823e051$export$81a625dd455a09de, $cQdlc.optionalComposeOptional(ab));
};
var $83ea31e4f823e051$export$aa978f69e007229f = function(ab) {
    return (0, $kj6DU.flow)($83ea31e4f823e051$export$ef38eac73d6f828f, $cQdlc.traversalComposeTraversal(ab));
};
var $83ea31e4f823e051$export$adaa4cf7ef1b65be = $cQdlc.prismSet;
var $83ea31e4f823e051$export$a2ef9d652875bdfa = $cQdlc.prismModifyOption;
var $83ea31e4f823e051$export$3ff57735a52b8713 = $cQdlc.prismModify;
function $83ea31e4f823e051$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $6piwk.pipe)(sa.getOption(s), $3NXK3.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $83ea31e4f823e051$export$b601f49376b4621a = /*#__PURE__*/ $83ea31e4f823e051$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismFromNullable());
function $83ea31e4f823e051$export$3dea766d36a8935f(predicate) {
    return $83ea31e4f823e051$export$f672e0b6f7222cd7($cQdlc.prismFromPredicate(predicate));
}
var $83ea31e4f823e051$export$977f3f6a9323c0f6 = function(prop) {
    return $83ea31e4f823e051$export$f5c3e419c6a355ce((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensProp(prop)));
}; // TODO: simplify?
var $83ea31e4f823e051$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $83ea31e4f823e051$export$f5c3e419c6a355ce((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensProps.apply($cQdlc, props)));
};
var $83ea31e4f823e051$export$d8556a2a8f973135 = function(prop) {
    return $83ea31e4f823e051$export$f5c3e419c6a355ce((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensComponent(prop)));
};
var $83ea31e4f823e051$export$b610b8812bbcded9 = function(i) {
    return (0, $kj6DU.flow)($83ea31e4f823e051$export$81a625dd455a09de, $cQdlc.optionalIndex(i));
};
var $83ea31e4f823e051$export$84162b00c25b711c = function(i) {
    return (0, $kj6DU.flow)($83ea31e4f823e051$export$81a625dd455a09de, $cQdlc.optionalIndexNonEmpty(i));
};
var $83ea31e4f823e051$export$df61b30b684217c0 = function(key) {
    return (0, $kj6DU.flow)($83ea31e4f823e051$export$81a625dd455a09de, $cQdlc.optionalKey(key));
};
var $83ea31e4f823e051$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $cQdlc.prismComposeLens($cQdlc.atReadonlyRecord().at(key))(sa);
    };
};
var $83ea31e4f823e051$export$ad14ef4001db2bcd = /*#__PURE__*/ $83ea31e4f823e051$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismSome());
var $83ea31e4f823e051$export$79ffe56a765070d2 = /*#__PURE__*/ $83ea31e4f823e051$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismRight());
var $83ea31e4f823e051$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $83ea31e4f823e051$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismLeft());
function $83ea31e4f823e051$export$df3f009e3d155b20(T) {
    return (0, $kj6DU.flow)($83ea31e4f823e051$export$ef38eac73d6f828f, $cQdlc.traversalTraverse(T));
}
function $83ea31e4f823e051$export$9a2f228bed5035c2(predicate) {
    return $83ea31e4f823e051$export$323f76c400675c8b($cQdlc.optionalFindFirst(predicate));
}
function $83ea31e4f823e051$export$28e1f787311e0a21(predicate) {
    return $83ea31e4f823e051$export$323f76c400675c8b($cQdlc.optionalFindFirstNonEmpty(predicate));
}
var $83ea31e4f823e051$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $83ea31e4f823e051$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $83ea31e4f823e051$var$imap_ = function(ea, ab, ba) {
    return $83ea31e4f823e051$export$e469dcfea9910464((0, $kj6DU.flow)(ea.getOption, $3NXK3.map(ab)), (0, $kj6DU.flow)(ba, ea.reverseGet));
};
var $83ea31e4f823e051$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $83ea31e4f823e051$export$dbdf692cc5737cfd = {
    URI: $83ea31e4f823e051$export$9156e739aa33e19f,
    imap: $83ea31e4f823e051$var$imap_
};
var $83ea31e4f823e051$export$67666a3fb7d250d8 = {
    URI: $83ea31e4f823e051$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $83ea31e4f823e051$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $83ea31e4f823e051$export$3a8840c5b2ecf003 = {
    URI: $83ea31e4f823e051$export$9156e739aa33e19f,
    compose: $83ea31e4f823e051$export$67666a3fb7d250d8.compose,
    id: $83ea31e4f823e051$export$d560c7e4a29451c2
};

});

parcelRegister("qblkL", function(module, exports) {

$parcel$export(module.exports, "fromTraversable", function () { return $04eb3a534b413214$export$126b5a87c58d3f9c; });
$parcel$export(module.exports, "compose", function () { return $04eb3a534b413214$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "modify", function () { return $04eb3a534b413214$export$3ff57735a52b8713; });
$parcel$export(module.exports, "set", function () { return $04eb3a534b413214$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "filter", function () { return $04eb3a534b413214$export$3dea766d36a8935f; });

var $iK9L9 = parcelRequire("iK9L9");

var $kj6DU = parcelRequire("kj6DU");

var $6piwk = parcelRequire("6piwk");

var $f0bNW = parcelRequire("f0bNW");

var $cQdlc = parcelRequire("cQdlc");
var $04eb3a534b413214$export$8666ce7a134c2314 = $cQdlc.traversal;
var $04eb3a534b413214$export$d560c7e4a29451c2 = function() {
    return $04eb3a534b413214$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $04eb3a534b413214$export$126b5a87c58d3f9c = $cQdlc.fromTraversable;
var $04eb3a534b413214$export$f672e0b6f7222cd7 = $cQdlc.traversalComposeTraversal;
var $04eb3a534b413214$export$aa978f69e007229f = $04eb3a534b413214$export$f672e0b6f7222cd7;
var $04eb3a534b413214$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.isoAsTraversal, $04eb3a534b413214$export$f672e0b6f7222cd7);
var $04eb3a534b413214$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.lensAsTraversal, $cQdlc.traversalComposeTraversal);
var $04eb3a534b413214$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.prismAsTraversal, $cQdlc.traversalComposeTraversal);
var $04eb3a534b413214$export$323f76c400675c8b = /*#__PURE__*/ (0, $kj6DU.flow)($cQdlc.optionalAsTraversal, $cQdlc.traversalComposeTraversal);
var $04eb3a534b413214$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($cQdlc.ApplicativeIdentity)(f);
    };
};
var $04eb3a534b413214$export$adaa4cf7ef1b65be = function(a) {
    return $04eb3a534b413214$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $04eb3a534b413214$export$b601f49376b4621a = function(sa) {
    return $04eb3a534b413214$export$c1dc05e399870f6($cQdlc.prismFromNullable())(sa);
};
function $04eb3a534b413214$export$3dea766d36a8935f(predicate) {
    return $04eb3a534b413214$export$f672e0b6f7222cd7($cQdlc.prismAsTraversal($cQdlc.prismFromPredicate(predicate)));
}
var $04eb3a534b413214$export$977f3f6a9323c0f6 = function(prop) {
    return $04eb3a534b413214$export$f672e0b6f7222cd7((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensProp(prop), $cQdlc.lensAsTraversal));
};
var $04eb3a534b413214$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $04eb3a534b413214$export$f672e0b6f7222cd7((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensProps.apply($cQdlc, props), $cQdlc.lensAsTraversal));
};
var $04eb3a534b413214$export$d8556a2a8f973135 = function(prop) {
    return $04eb3a534b413214$export$f672e0b6f7222cd7((0, $6piwk.pipe)($cQdlc.lensId(), $cQdlc.lensComponent(prop), $cQdlc.lensAsTraversal));
};
var $04eb3a534b413214$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $04eb3a534b413214$export$f672e0b6f7222cd7($cQdlc.optionalAsTraversal($cQdlc.indexReadonlyArray().index(i))));
    };
};
var $04eb3a534b413214$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $04eb3a534b413214$export$f672e0b6f7222cd7($cQdlc.optionalAsTraversal($cQdlc.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $04eb3a534b413214$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $04eb3a534b413214$export$f672e0b6f7222cd7($cQdlc.optionalAsTraversal($cQdlc.indexReadonlyRecord().index(key))));
    };
};
var $04eb3a534b413214$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $6piwk.pipe)(sa, $04eb3a534b413214$export$f672e0b6f7222cd7($cQdlc.lensAsTraversal($cQdlc.atReadonlyRecord().at(key))));
    };
};
var $04eb3a534b413214$export$ad14ef4001db2bcd = /*#__PURE__*/ $04eb3a534b413214$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsTraversal(/*#__PURE__*/ $cQdlc.prismSome()));
var $04eb3a534b413214$export$79ffe56a765070d2 = /*#__PURE__*/ $04eb3a534b413214$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsTraversal(/*#__PURE__*/ $cQdlc.prismRight()));
var $04eb3a534b413214$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $04eb3a534b413214$export$f672e0b6f7222cd7(/*#__PURE__*/ $cQdlc.prismAsTraversal(/*#__PURE__*/ $cQdlc.prismLeft()));
var $04eb3a534b413214$export$df3f009e3d155b20 = $cQdlc.traversalTraverse;
function $04eb3a534b413214$export$9a2f228bed5035c2(predicate) {
    return $04eb3a534b413214$export$323f76c400675c8b($cQdlc.optionalFindFirst(predicate));
}
function $04eb3a534b413214$export$28e1f787311e0a21(predicate) {
    return $04eb3a534b413214$export$323f76c400675c8b($cQdlc.optionalFindFirstNonEmpty(predicate));
}
var $04eb3a534b413214$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($iK9L9.getApplicative(M))(function(a) {
                return $iK9L9.make(f(a));
            });
        };
    };
};
var $04eb3a534b413214$export$93e2b83da34ff82a = function(M) {
    return $04eb3a534b413214$export$b66cdc0497d8a99a(M)((0, $kj6DU.identity));
};
var $04eb3a534b413214$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $04eb3a534b413214$export$b66cdc0497d8a99a($f0bNW.getMonoid())($f0bNW.of)(sa)(s);
    };
};
var $04eb3a534b413214$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $04eb3a534b413214$export$67666a3fb7d250d8 = {
    URI: $04eb3a534b413214$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $04eb3a534b413214$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $04eb3a534b413214$export$3a8840c5b2ecf003 = {
    URI: $04eb3a534b413214$export$9156e739aa33e19f,
    compose: $04eb3a534b413214$export$67666a3fb7d250d8.compose,
    id: $04eb3a534b413214$export$d560c7e4a29451c2
};

});


parcelRegister("1zrnp", function(module, exports) {
'use strict';
var $124e4bbb3f3c510d$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $e6ibc = parcelRequire("e6ibc");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $124e4bbb3f3c510d$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $124e4bbb3f3c510d$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $e6ibc();
};

});
parcelRegister("e6ibc", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9ddGv", function(module, exports) {

$parcel$export(module.exports, "assertUnreachable", function () { return $f7bc7fbfbfe0e95e$export$f2525c1d596f8d46; });
$parcel$export(module.exports, "immutableAssign", function () { return $f7bc7fbfbfe0e95e$export$c81b44cfe0e874ce; });
$parcel$export(module.exports, "idcOrd", function () { return $f7bc7fbfbfe0e95e$export$16dae286fd0a05e9; });
$parcel$export(module.exports, "NotUsed", function () { return $f7bc7fbfbfe0e95e$export$6ad3191707c01020; });
$parcel$export(module.exports, "toNotUsed", function () { return $f7bc7fbfbfe0e95e$export$bf979031ac269aa6; });
$parcel$export(module.exports, "Dict", function () { return $f7bc7fbfbfe0e95e$export$bfa56c8ff106f1d; });
$parcel$export(module.exports, "PartialDict", function () { return $f7bc7fbfbfe0e95e$export$38e1f3962181967d; });
$parcel$export(module.exports, "Either", function () { return $f7bc7fbfbfe0e95e$export$37cbe166bfc81b63; });
$parcel$export(module.exports, "Maybe", function () { return $f7bc7fbfbfe0e95e$export$ad3bd6e4e1ec5d06; });
$parcel$export(module.exports, "List", function () { return $f7bc7fbfbfe0e95e$export$54c2e3dc7acea9f5; });
$parcel$export(module.exports, "NonEmptyArray", function () { return $f7bc7fbfbfe0e95e$export$f2d78e4bd16a0737; });
$parcel$export(module.exports, "Tuple", function () { return $f7bc7fbfbfe0e95e$export$1908877435b1d5e9; });
$parcel$export(module.exports, "Try", function () { return $f7bc7fbfbfe0e95e$export$fa957d01b0310fd7; });
$parcel$export(module.exports, "Future", function () { return $f7bc7fbfbfe0e95e$export$c9d7bf589772a8ce; });

var $7Rbab = parcelRequire("7Rbab");
var $OFl2v = parcelRequire("OFl2v");
var $cRv7f = parcelRequire("cRv7f");
var $3NXK3 = parcelRequire("3NXK3");
var $hOuM2 = parcelRequire("hOuM2");
var $f0bNW = parcelRequire("f0bNW");
var $8RK6P = parcelRequire("8RK6P");
var $kqvcT = parcelRequire("kqvcT");
var $etcCS = parcelRequire("etcCS");
var $5PZg8 = parcelRequire("5PZg8");
var $5fNnZ = parcelRequire("5fNnZ");
var $aXpTF = parcelRequire("aXpTF");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $hp7yq = parcelRequire("hp7yq");

var $hPJN4 = parcelRequire("hPJN4");
function $f7bc7fbfbfe0e95e$export$402f4892886ef27f(...args) {
    // eslint-disable-next-line functional/no-throw-statements
    throw Error('Missing implementation');
}
function $f7bc7fbfbfe0e95e$export$f2525c1d596f8d46(n) {
    // eslint-disable-next-line functional/no-throw-statements
    throw Error(`Unexpected value: ${n}`);
}
const $f7bc7fbfbfe0e95e$export$9dec5d1b3b6a130d = (...label)=>(a)=>{
        console.log(...label, a);
        return a;
    };
function $f7bc7fbfbfe0e95e$export$c81b44cfe0e874ce(f, b) {
    return Object.assign(f.bind({}), b);
}
function $f7bc7fbfbfe0e95e$export$16dae286fd0a05e9({ equals: equals }) {
    return {
        equals: equals,
        compare: (first, second)=>equals(first, second) ? 0 : (0, $hOuM2).trivial.compare(first, second)
    };
}
const $f7bc7fbfbfe0e95e$export$6ad3191707c01020 = (0, $hp7yq.iso)().wrap(undefined);
const $f7bc7fbfbfe0e95e$export$bf979031ac269aa6 = (_)=>$f7bc7fbfbfe0e95e$export$6ad3191707c01020;
const $f7bc7fbfbfe0e95e$export$bfa56c8ff106f1d = {
    ...(0, $etcCS),
    empty: ()=>(0, $etcCS).empty
};
const $f7bc7fbfbfe0e95e$var$partialDictMap = (0, $etcCS).map;
const $f7bc7fbfbfe0e95e$var$partialDictMapWithIndex = (0, $etcCS).mapWithIndex;
const $f7bc7fbfbfe0e95e$var$partialDictSequence = (0, $etcCS).sequence;
const $f7bc7fbfbfe0e95e$var$partialDictTraverse = (0, $etcCS).traverse;
const $f7bc7fbfbfe0e95e$var$partialDictTraverseWithIndex = (0, $etcCS).traverseWithIndex;
const $f7bc7fbfbfe0e95e$export$38e1f3962181967d = {
    empty: ()=>({}),
    every: (0, $etcCS).every,
    fromEntries: Object.fromEntries,
    map: (f)=>$f7bc7fbfbfe0e95e$var$partialDictMap((a)=>a !== undefined ? f(a) : undefined),
    mapWithIndex: (f)=>$f7bc7fbfbfe0e95e$var$partialDictMapWithIndex((k, a)=>a !== undefined ? f(k, a) : undefined),
    sequence: $f7bc7fbfbfe0e95e$var$partialDictSequence,
    traverse: (F)=>(f)=>$f7bc7fbfbfe0e95e$var$partialDictTraverse(F)((a)=>a !== undefined ? f(a) : F.of(undefined)),
    traverseWithIndex: (F)=>(f)=>$f7bc7fbfbfe0e95e$var$partialDictTraverseWithIndex(F)((k, a)=>a !== undefined ? f(k, a) : F.of(undefined))
};
function $f7bc7fbfbfe0e95e$export$70151caf3ff99499() {
    return (0, $8RK6P).empty;
}
const $f7bc7fbfbfe0e95e$export$37cbe166bfc81b63 = {
    ...(0, $7Rbab),
    exists: (0, $7Rbab).exists
};
const $f7bc7fbfbfe0e95e$var$maybeDecoder = (decoder)=>({
        decode: (u)=>u === null || u === undefined ? $5zWxO.success((0, $3NXK3).none) : (0, $kj6DU.pipe)(decoder.decode(u), (0, $7Rbab).map((0, $3NXK3).some))
    });
const $f7bc7fbfbfe0e95e$var$maybeEncoder = (encoder)=>({
        encode: (0, $kj6DU.flow)((0, $3NXK3).map(encoder.encode), (0, $3NXK3).toNullable)
    });
const $f7bc7fbfbfe0e95e$export$ad3bd6e4e1ec5d06 = {
    ...(0, $3NXK3),
    every: (predicate)=>(0, $3NXK3).fold(()=>true, predicate),
    decoder: $f7bc7fbfbfe0e95e$var$maybeDecoder,
    encoder: $f7bc7fbfbfe0e95e$var$maybeEncoder,
    codec: (codec)=>$7uCHH.make($f7bc7fbfbfe0e95e$var$maybeDecoder(codec), $f7bc7fbfbfe0e95e$var$maybeEncoder(codec))
};
const $f7bc7fbfbfe0e95e$var$neaDecoder = (decoder)=>(0, $kj6DU.pipe)($5zWxO.array(decoder), $5zWxO.refine($f7bc7fbfbfe0e95e$export$54c2e3dc7acea9f5.isNonEmpty, 'NonEmptyArray'));
const $f7bc7fbfbfe0e95e$var$neaEncoder = (encoder)=>({
        encode: $f7bc7fbfbfe0e95e$export$f2d78e4bd16a0737.map(encoder.encode)
    });
const { groupBy: {}, ...$f7bc7fbfbfe0e95e$var$neaMethods } = (0, $kqvcT);
const $f7bc7fbfbfe0e95e$export$f2d78e4bd16a0737 = {
    ...$f7bc7fbfbfe0e95e$var$neaMethods,
    asMutable: (0, $kj6DU.identity),
    decoder: $f7bc7fbfbfe0e95e$var$neaDecoder,
    encoder: $f7bc7fbfbfe0e95e$var$neaEncoder,
    codec: (codec)=>$7uCHH.make($f7bc7fbfbfe0e95e$var$neaDecoder(codec), $f7bc7fbfbfe0e95e$var$neaEncoder(codec))
};
function $f7bc7fbfbfe0e95e$var$mkString(startOrSep, sep, end) {
    return (list)=>sep !== undefined && end !== undefined ? `${startOrSep}${list.join(sep)}${end}` : list.join(startOrSep);
}
const $f7bc7fbfbfe0e95e$var$listDecoder = $5zWxO.array;
const $f7bc7fbfbfe0e95e$var$listEncoder = (0, $kj6DU.flow)($aXkbA.array, $aXkbA.readonly);
const $f7bc7fbfbfe0e95e$export$54c2e3dc7acea9f5 = {
    ...(0, $f0bNW),
    empty: ()=>(0, $f0bNW).empty,
    differenceW: (0, $f0bNW).difference,
    groupBy: (0, $kqvcT).groupBy,
    groupByStr: (0, $kqvcT).groupBy,
    asMutable: (0, $kj6DU.identity),
    mkString: $f7bc7fbfbfe0e95e$var$mkString,
    decoder: $f7bc7fbfbfe0e95e$var$listDecoder,
    encoder: $f7bc7fbfbfe0e95e$var$listEncoder,
    codec: (codec)=>$7uCHH.make($f7bc7fbfbfe0e95e$var$listDecoder(codec), $f7bc7fbfbfe0e95e$var$listEncoder(codec))
};
const $f7bc7fbfbfe0e95e$export$1908877435b1d5e9 = {
    ...(0, $5PZg8),
    of: (0, $kj6DU.tuple)
};
const { right: {}, left: {}, ...$f7bc7fbfbfe0e95e$var$tryMethods } = (0, $7Rbab);
const $f7bc7fbfbfe0e95e$export$fa957d01b0310fd7 = {
    ...$f7bc7fbfbfe0e95e$var$tryMethods,
    success: (0, $7Rbab).right,
    failure: (0, $7Rbab).left,
    fromNullable: (0, $7Rbab).fromNullable,
    tryCatch: (a)=>$f7bc7fbfbfe0e95e$export$37cbe166bfc81b63.tryCatch(a, $f7bc7fbfbfe0e95e$export$37cbe166bfc81b63.toError),
    getUnsafe: (t)=>(0, $kj6DU.pipe)(t, $f7bc7fbfbfe0e95e$export$37cbe166bfc81b63.getOrElse((e)=>{
            // eslint-disable-next-line functional/no-throw-statements
            throw e;
        }))
};
const $f7bc7fbfbfe0e95e$var$futureNotUsed = (0, $aXpTF).right($f7bc7fbfbfe0e95e$export$6ad3191707c01020);
const { right: {}, left: {}, ...$f7bc7fbfbfe0e95e$var$futureMethods } = (0, $aXpTF);
const $f7bc7fbfbfe0e95e$export$c9d7bf589772a8ce = {
    ...$f7bc7fbfbfe0e95e$var$futureMethods,
    successful: (0, $aXpTF).right,
    failed: (0, $aXpTF).left,
    chainFirstIOEitherK: (f)=>(0, $aXpTF).chainFirst((0, $kj6DU.flow)(f, (0, $aXpTF).fromIOEither)),
    orElseEitherK: (f)=>(0, $aXpTF).orElse((0, $kj6DU.flow)(f, $f7bc7fbfbfe0e95e$export$c9d7bf589772a8ce.fromEither)),
    orElseIOEitherK: (f)=>(0, $aXpTF).orElse((0, $kj6DU.flow)(f, $f7bc7fbfbfe0e95e$export$c9d7bf589772a8ce.fromIOEither)),
    fromIO: (0, $aXpTF).fromIO,
    tryCatch: (f)=>(0, $aXpTF).tryCatch(f, $f7bc7fbfbfe0e95e$export$37cbe166bfc81b63.toError),
    notUsed: $f7bc7fbfbfe0e95e$var$futureNotUsed,
    todo: (...args)=>(0, $aXpTF).fromEither($f7bc7fbfbfe0e95e$export$fa957d01b0310fd7.tryCatch(()=>$f7bc7fbfbfe0e95e$export$402f4892886ef27f(args))),
    run: (onError)=>(f)=>(0, $kj6DU.pipe)(f, (0, $5fNnZ).chain((0, $7Rbab).fold((0, $kj6DU.flow)(onError, (0, $5fNnZ).fromIO), (0, $5fNnZ).of)))(),
    runUnsafe: (fa)=>(0, $kj6DU.pipe)(fa, (0, $5fNnZ).map($f7bc7fbfbfe0e95e$export$fa957d01b0310fd7.getUnsafe))(),
    delay: (ms)=>(future)=>(0, $kj6DU.pipe)(future, (0, $5fNnZ).delay((0, $hPJN4.MsDuration).unwrap(ms)))
};
const $f7bc7fbfbfe0e95e$var$ioNotUsed = (0, $cRv7f).right($f7bc7fbfbfe0e95e$export$6ad3191707c01020);
const $f7bc7fbfbfe0e95e$var$ioFromIO = (0, $cRv7f).fromIO;
const $f7bc7fbfbfe0e95e$var$ioRun = (onError)=>(ioA)=>(0, $kj6DU.pipe)(ioA, (0, $OFl2v).chain((0, $7Rbab).fold(onError, (0, $OFl2v).of)))();
const { right: {}, left: {}, ...$f7bc7fbfbfe0e95e$var$ioMethods } = (0, $cRv7f);
const $f7bc7fbfbfe0e95e$export$8f8422ac5947a789 = {
    ...$f7bc7fbfbfe0e95e$var$ioMethods,
    successful: (0, $cRv7f).right,
    failed: (0, $cRv7f).left,
    tryCatch: (a)=>(0, $cRv7f).tryCatch(a, $f7bc7fbfbfe0e95e$export$37cbe166bfc81b63.toError),
    fromIO: $f7bc7fbfbfe0e95e$var$ioFromIO,
    notUsed: $f7bc7fbfbfe0e95e$var$ioNotUsed,
    runFuture: (onError)=>(f)=>()=>{
                // eslint-disable-next-line functional/no-expression-statements
                (0, $kj6DU.pipe)(f, $f7bc7fbfbfe0e95e$export$c9d7bf589772a8ce.run(onError));
                return $f7bc7fbfbfe0e95e$export$6ad3191707c01020;
            },
    run: $f7bc7fbfbfe0e95e$var$ioRun,
    runUnsafe: (ioA)=>$f7bc7fbfbfe0e95e$export$fa957d01b0310fd7.getUnsafe(ioA()),
    setTimeout: (onError)=>(delay)=>(io_)=>$f7bc7fbfbfe0e95e$export$8f8422ac5947a789.tryCatch(()=>setTimeout(()=>(0, $kj6DU.pipe)(io_, $f7bc7fbfbfe0e95e$var$ioRun(onError)), (0, $hPJN4.MsDuration).unwrap(delay)))
};
const $f7bc7fbfbfe0e95e$export$c017b8e600ceae89 = (0, $kj6DU.identity);

});
parcelRegister("OFl2v", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $0984bc8fa843a512$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $0984bc8fa843a512$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "of", function () { return $0984bc8fa843a512$export$ba255e9e49e00608; });
$parcel$export(module.exports, "flatMap", function () { return $0984bc8fa843a512$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "flatten", function () { return $0984bc8fa843a512$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "URI", function () { return $0984bc8fa843a512$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Functor", function () { return $0984bc8fa843a512$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $0984bc8fa843a512$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $0984bc8fa843a512$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $0984bc8fa843a512$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $0984bc8fa843a512$export$59a71046037e6c20; });
$parcel$export(module.exports, "Apply", function () { return $0984bc8fa843a512$export$efc21ddc6aeb363d; });
$parcel$export(module.exports, "apFirst", function () { return $0984bc8fa843a512$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $0984bc8fa843a512$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "Applicative", function () { return $0984bc8fa843a512$export$1279d2b7807629fd; });
$parcel$export(module.exports, "Chain", function () { return $0984bc8fa843a512$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $0984bc8fa843a512$export$fb641926d034ac7d; });
$parcel$export(module.exports, "tap", function () { return $0984bc8fa843a512$export$3f23594af5f37336; });
$parcel$export(module.exports, "fromIO", function () { return $0984bc8fa843a512$export$d529793c7ff048a8; });
$parcel$export(module.exports, "MonadIO", function () { return $0984bc8fa843a512$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "ChainRec", function () { return $0984bc8fa843a512$export$be58f7327716329d; });
$parcel$export(module.exports, "FromIO", function () { return $0984bc8fa843a512$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "Do", function () { return $0984bc8fa843a512$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $0984bc8fa843a512$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $0984bc8fa843a512$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $0984bc8fa843a512$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $0984bc8fa843a512$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "ApT", function () { return $0984bc8fa843a512$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $0984bc8fa843a512$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $0984bc8fa843a512$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $0984bc8fa843a512$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $0984bc8fa843a512$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $0984bc8fa843a512$export$d330b60315c14cd1; });
$parcel$export(module.exports, "chain", function () { return $0984bc8fa843a512$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $0984bc8fa843a512$export$e3821ef4970c339c; });
$parcel$export(module.exports, "io", function () { return $0984bc8fa843a512$export$841407ceb083bd74; });
$parcel$export(module.exports, "getSemigroup", function () { return $0984bc8fa843a512$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $0984bc8fa843a512$export$c2a7ef2cc9b32b31; });
/**
 * ```ts
 * interface IO<A> {
 *   (): A
 * }
 * ```
 *
 * `IO<A>` represents a non-deterministic synchronous computation that can cause side effects, yields a value of
 * type `A` and **never fails**.
 *
 * If you want to represent a synchronous computation that may fail, please see `IOEither`.
 * If you want to represent a synchronous computation that may yield nothing, please see `IOOption`.
 *
 * @since 2.0.0
 */ 
var $dYcKb = parcelRequire("dYcKb");

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");
var $0984bc8fa843a512$var$_map = function(ma, f) {
    return function() {
        return f(ma());
    };
};
var $0984bc8fa843a512$var$_ap = function(mab, ma) {
    return function() {
        return mab()(ma());
    };
};
var $0984bc8fa843a512$var$_chainRec = function(a, f) {
    return function() {
        var e = f(a)();
        while(e._tag === 'Left')e = f(e.left)();
        return e.right;
    };
};
var $0984bc8fa843a512$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $0984bc8fa843a512$var$_map(fa, f);
    };
};
var $0984bc8fa843a512$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $0984bc8fa843a512$var$_ap(fab, fa);
    };
};
var $0984bc8fa843a512$export$ba255e9e49e00608 = (0, $kj6DU.constant);
var $0984bc8fa843a512$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return function() {
        return f(ma())();
    };
});
var $0984bc8fa843a512$export$bffa455ba8c619a6 = /*#__PURE__*/ $0984bc8fa843a512$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $0984bc8fa843a512$export$9156e739aa33e19f = 'IO';
var $0984bc8fa843a512$export$bd5b6bfc5fa2ee61 = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map
};
var $0984bc8fa843a512$export$6554612db691658e = (0, $kj6DU.dual)(2, (0, $6baua.as)($0984bc8fa843a512$export$bd5b6bfc5fa2ee61));
var $0984bc8fa843a512$export$9284b360ca18a0fd = (0, $6baua.asUnit)($0984bc8fa843a512$export$bd5b6bfc5fa2ee61);
var $0984bc8fa843a512$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($0984bc8fa843a512$export$bd5b6bfc5fa2ee61);
var $0984bc8fa843a512$export$59a71046037e6c20 = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    of: $0984bc8fa843a512$export$ba255e9e49e00608
};
var $0984bc8fa843a512$export$efc21ddc6aeb363d = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    ap: $0984bc8fa843a512$var$_ap
};
var $0984bc8fa843a512$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($0984bc8fa843a512$export$efc21ddc6aeb363d);
var $0984bc8fa843a512$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($0984bc8fa843a512$export$efc21ddc6aeb363d);
var $0984bc8fa843a512$export$1279d2b7807629fd = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    ap: $0984bc8fa843a512$var$_ap,
    of: $0984bc8fa843a512$export$ba255e9e49e00608
};
var $0984bc8fa843a512$export$f18d5acc27d70423 = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    ap: $0984bc8fa843a512$var$_ap,
    chain: $0984bc8fa843a512$export$5b8affa63fc6df16
};
var $0984bc8fa843a512$export$fb641926d034ac7d = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    ap: $0984bc8fa843a512$var$_ap,
    of: $0984bc8fa843a512$export$ba255e9e49e00608,
    chain: $0984bc8fa843a512$export$5b8affa63fc6df16
};
var $0984bc8fa843a512$export$3f23594af5f37336 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dya6d.tap($0984bc8fa843a512$export$f18d5acc27d70423));
var $0984bc8fa843a512$export$d529793c7ff048a8 = (0, $kj6DU.identity);
var $0984bc8fa843a512$export$dc43ee6ccf36ad90 = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    ap: $0984bc8fa843a512$var$_ap,
    of: $0984bc8fa843a512$export$ba255e9e49e00608,
    chain: $0984bc8fa843a512$export$5b8affa63fc6df16,
    fromIO: $0984bc8fa843a512$export$d529793c7ff048a8
};
var $0984bc8fa843a512$export$be58f7327716329d = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    ap: $0984bc8fa843a512$var$_ap,
    chain: $0984bc8fa843a512$export$5b8affa63fc6df16,
    chainRec: $0984bc8fa843a512$var$_chainRec
};
var $0984bc8fa843a512$export$978d37ea2fe360cf = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    fromIO: (0, $kj6DU.identity)
};
var $0984bc8fa843a512$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $0984bc8fa843a512$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $0984bc8fa843a512$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($0984bc8fa843a512$export$bd5b6bfc5fa2ee61);
var $0984bc8fa843a512$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($0984bc8fa843a512$export$bd5b6bfc5fa2ee61);
var $0984bc8fa843a512$export$2385a24977818dd0 = /*#__PURE__*/ $dya6d.bind($0984bc8fa843a512$export$f18d5acc27d70423);
var $0984bc8fa843a512$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($0984bc8fa843a512$export$efc21ddc6aeb363d);
var $0984bc8fa843a512$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $0984bc8fa843a512$export$ba255e9e49e00608($lOGTm.emptyReadonlyArray);
var $0984bc8fa843a512$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        return function() {
            var out = [
                f(0, $lOGTm.head(as))()
            ];
            for(var i = 1; i < as.length; i++)out.push(f(i, as[i])());
            return out;
        };
    };
};
var $0984bc8fa843a512$export$d4e79db5dc14cc1 = function(f) {
    var g = $0984bc8fa843a512$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $0984bc8fa843a512$export$c74b6e34b2b6efb0;
    };
};
var $0984bc8fa843a512$export$104a2841e9cbad06 = $0984bc8fa843a512$export$d4e79db5dc14cc1;
var $0984bc8fa843a512$export$64f39b2a2b79e1b1 = function(f) {
    return $0984bc8fa843a512$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $0984bc8fa843a512$export$d330b60315c14cd1 = /*#__PURE__*/ $0984bc8fa843a512$export$64f39b2a2b79e1b1((0, $kj6DU.identity));
var $0984bc8fa843a512$export$e08e3b67e392101e = $0984bc8fa843a512$export$5b8affa63fc6df16;
var $0984bc8fa843a512$export$e3821ef4970c339c = $0984bc8fa843a512$export$3f23594af5f37336;
var $0984bc8fa843a512$export$841407ceb083bd74 = {
    URI: $0984bc8fa843a512$export$9156e739aa33e19f,
    map: $0984bc8fa843a512$var$_map,
    of: $0984bc8fa843a512$export$ba255e9e49e00608,
    ap: $0984bc8fa843a512$var$_ap,
    chain: $0984bc8fa843a512$export$5b8affa63fc6df16,
    fromIO: $0984bc8fa843a512$export$d529793c7ff048a8,
    chainRec: $0984bc8fa843a512$var$_chainRec
};
var $0984bc8fa843a512$export$e759a9a7f8d04692 = /*#__PURE__*/ (0, $j7Bi0.getApplySemigroup)($0984bc8fa843a512$export$efc21ddc6aeb363d);
var $0984bc8fa843a512$export$c2a7ef2cc9b32b31 = /*#__PURE__*/ (0, $dYcKb.getApplicativeMonoid)($0984bc8fa843a512$export$1279d2b7807629fd);

});

parcelRegister("cRv7f", function(module, exports) {

$parcel$export(module.exports, "left", function () { return $95d292429e983193$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $95d292429e983193$export$79ffe56a765070d2; });
$parcel$export(module.exports, "rightIO", function () { return $95d292429e983193$export$c1cd2021ce1d7fcb; });
$parcel$export(module.exports, "leftIO", function () { return $95d292429e983193$export$9d86f0a38eb969ef; });
$parcel$export(module.exports, "fromEither", function () { return $95d292429e983193$export$80c878c9b1d77917; });
$parcel$export(module.exports, "fromIO", function () { return $95d292429e983193$export$d529793c7ff048a8; });
$parcel$export(module.exports, "match", function () { return $95d292429e983193$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchW", function () { return $95d292429e983193$export$2d55ea551c238330; });
$parcel$export(module.exports, "matchE", function () { return $95d292429e983193$export$398621f19e0a7e4; });
$parcel$export(module.exports, "fold", function () { return $95d292429e983193$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "matchEW", function () { return $95d292429e983193$export$85ac45300d10b517; });
$parcel$export(module.exports, "foldW", function () { return $95d292429e983193$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "getOrElse", function () { return $95d292429e983193$export$8832081647a02ee7; });
$parcel$export(module.exports, "getOrElseW", function () { return $95d292429e983193$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "tryCatch", function () { return $95d292429e983193$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $95d292429e983193$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "toUnion", function () { return $95d292429e983193$export$a0886ed3a572729f; });
$parcel$export(module.exports, "orElse", function () { return $95d292429e983193$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "orElseW", function () { return $95d292429e983193$export$efd845e0c87089a6; });
$parcel$export(module.exports, "tapError", function () { return $95d292429e983193$export$f297679585c88732; });
$parcel$export(module.exports, "orElseFirstIOK", function () { return $95d292429e983193$export$91e9d1839ed8da93; });
$parcel$export(module.exports, "fromIOK", function () { return $95d292429e983193$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "orLeft", function () { return $95d292429e983193$export$e84f0fd7f5bcfbf0; });
$parcel$export(module.exports, "swap", function () { return $95d292429e983193$export$b0e76d9850c64156; });
$parcel$export(module.exports, "map", function () { return $95d292429e983193$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $95d292429e983193$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $95d292429e983193$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "alt", function () { return $95d292429e983193$export$228be17d80722ab; });
$parcel$export(module.exports, "mapBoth", function () { return $95d292429e983193$export$2ab19f8a7e145f0a; });
$parcel$export(module.exports, "bimap", function () { return $95d292429e983193$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapError", function () { return $95d292429e983193$export$d0f6f6f8d08fe167; });
$parcel$export(module.exports, "mapLeft", function () { return $95d292429e983193$export$472de43a55e4aa49; });
$parcel$export(module.exports, "apW", function () { return $95d292429e983193$export$321be6e231de8eac; });
$parcel$export(module.exports, "of", function () { return $95d292429e983193$export$ba255e9e49e00608; });
$parcel$export(module.exports, "flattenW", function () { return $95d292429e983193$export$2409099f1fc434fb; });
$parcel$export(module.exports, "flatten", function () { return $95d292429e983193$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "altW", function () { return $95d292429e983193$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "throwError", function () { return $95d292429e983193$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "URI", function () { return $95d292429e983193$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getApplicativeIOValidation", function () { return $95d292429e983193$export$9b687d4ef3c7df6f; });
$parcel$export(module.exports, "getAltIOValidation", function () { return $95d292429e983193$export$9b5f70484e613d76; });
$parcel$export(module.exports, "getCompactable", function () { return $95d292429e983193$export$cfae3069ac05ff4c; });
$parcel$export(module.exports, "getFilterable", function () { return $95d292429e983193$export$a4e870b0a57ec14e; });
$parcel$export(module.exports, "Functor", function () { return $95d292429e983193$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $95d292429e983193$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $95d292429e983193$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $95d292429e983193$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $95d292429e983193$export$59a71046037e6c20; });
$parcel$export(module.exports, "Bifunctor", function () { return $95d292429e983193$export$fd0fe42029639505; });
$parcel$export(module.exports, "ApplyPar", function () { return $95d292429e983193$export$e825dd8dbbdc0410; });
$parcel$export(module.exports, "apFirst", function () { return $95d292429e983193$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apFirstW", function () { return $95d292429e983193$export$ac044f4aa9961a4f; });
$parcel$export(module.exports, "apSecond", function () { return $95d292429e983193$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apSecondW", function () { return $95d292429e983193$export$8a00020751233172; });
$parcel$export(module.exports, "ApplicativePar", function () { return $95d292429e983193$export$11b888901d89cc2; });
$parcel$export(module.exports, "ApplicativeSeq", function () { return $95d292429e983193$export$9c23f2f51a58ba10; });
$parcel$export(module.exports, "Chain", function () { return $95d292429e983193$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $95d292429e983193$export$fb641926d034ac7d; });
$parcel$export(module.exports, "FromEither", function () { return $95d292429e983193$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "FromIO", function () { return $95d292429e983193$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "tap", function () { return $95d292429e983193$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapEither", function () { return $95d292429e983193$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "tapIO", function () { return $95d292429e983193$export$5bf3b8929fda1158; });
$parcel$export(module.exports, "Alt", function () { return $95d292429e983193$export$25ba4469a069167; });
$parcel$export(module.exports, "MonadIO", function () { return $95d292429e983193$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "MonadThrow", function () { return $95d292429e983193$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "chainFirstIOK", function () { return $95d292429e983193$export$5148ef8785cce359; });
$parcel$export(module.exports, "fromOption", function () { return $95d292429e983193$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromOptionK", function () { return $95d292429e983193$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $95d292429e983193$export$12d26179deb6a68a; });
$parcel$export(module.exports, "chainOptionKW", function () { return $95d292429e983193$export$377cc334277e5c3c; });
$parcel$export(module.exports, "liftNullable", function () { return $95d292429e983193$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $95d292429e983193$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $95d292429e983193$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $95d292429e983193$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "flatMapEither", function () { return $95d292429e983193$export$979f2bb6a976172d; });
$parcel$export(module.exports, "flatMapIO", function () { return $95d292429e983193$export$8b635ef81222764c; });
$parcel$export(module.exports, "chainIOK", function () { return $95d292429e983193$export$dbedca339774a859; });
$parcel$export(module.exports, "chainEitherK", function () { return $95d292429e983193$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "chainEitherKW", function () { return $95d292429e983193$export$148e58f5a13b0a29; });
$parcel$export(module.exports, "chainFirstEitherK", function () { return $95d292429e983193$export$c5f2bdbf9b43f0c0; });
$parcel$export(module.exports, "chainFirstEitherKW", function () { return $95d292429e983193$export$3b38f8f4685eb1a8; });
$parcel$export(module.exports, "fromPredicate", function () { return $95d292429e983193$export$23f31c55d7162b91; });
$parcel$export(module.exports, "filterOrElse", function () { return $95d292429e983193$export$30af8ca9498ddf5b; });
$parcel$export(module.exports, "filterOrElseW", function () { return $95d292429e983193$export$84511cf4503ec9dd; });
$parcel$export(module.exports, "fromEitherK", function () { return $95d292429e983193$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "bracket", function () { return $95d292429e983193$export$df5598cc12b9c8c; });
$parcel$export(module.exports, "bracketW", function () { return $95d292429e983193$export$15093e5f950a635; });
$parcel$export(module.exports, "Do", function () { return $95d292429e983193$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $95d292429e983193$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $95d292429e983193$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $95d292429e983193$export$2385a24977818dd0; });
$parcel$export(module.exports, "bindW", function () { return $95d292429e983193$export$e0d5b1cbe98976d9; });
$parcel$export(module.exports, "apS", function () { return $95d292429e983193$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "apSW", function () { return $95d292429e983193$export$5c01f27714264b3d; });
$parcel$export(module.exports, "ApT", function () { return $95d292429e983193$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $95d292429e983193$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $95d292429e983193$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndexSeq", function () { return $95d292429e983193$export$ccd1b7252ef04791; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndexSeq", function () { return $95d292429e983193$export$674043f9db4279c7; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $95d292429e983193$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $95d292429e983193$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $95d292429e983193$export$d330b60315c14cd1; });
$parcel$export(module.exports, "traverseSeqArrayWithIndex", function () { return $95d292429e983193$export$6702e2a63712b0a0; });
$parcel$export(module.exports, "traverseSeqArray", function () { return $95d292429e983193$export$5932486b5125ca68; });
$parcel$export(module.exports, "sequenceSeqArray", function () { return $95d292429e983193$export$5e316684572fbbb6; });
$parcel$export(module.exports, "Applicative", function () { return $95d292429e983193$export$1279d2b7807629fd; });
$parcel$export(module.exports, "chain", function () { return $95d292429e983193$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainW", function () { return $95d292429e983193$export$8e5885f0163d737a; });
$parcel$export(module.exports, "chainFirst", function () { return $95d292429e983193$export$e3821ef4970c339c; });
$parcel$export(module.exports, "chainFirstW", function () { return $95d292429e983193$export$5de78197fc44b933; });
$parcel$export(module.exports, "orElseFirst", function () { return $95d292429e983193$export$2705983cb222ac0a; });
$parcel$export(module.exports, "orElseFirstW", function () { return $95d292429e983193$export$d43d943be7ad7d62; });
$parcel$export(module.exports, "ioEither", function () { return $95d292429e983193$export$abaf0c7037008059; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $95d292429e983193$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $95d292429e983193$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getSemigroup", function () { return $95d292429e983193$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getIOValidation", function () { return $95d292429e983193$export$9781d05075e655d9; });

var $dYcKb = parcelRequire("dYcKb");

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $eQAK7 = parcelRequire("eQAK7");

var $7Rbab = parcelRequire("7Rbab");

var $dpNXS = parcelRequire("dpNXS");

var $dHiDk = parcelRequire("dHiDk");

var $fgwhT = parcelRequire("fgwhT");

var $bmbrn = parcelRequire("bmbrn");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $OFl2v = parcelRequire("OFl2v");
var $95d292429e983193$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $dpNXS.left($OFl2v.Pointed);
var $95d292429e983193$export$79ffe56a765070d2 = /*#__PURE__*/ $dpNXS.right($OFl2v.Pointed);
var $95d292429e983193$export$c1cd2021ce1d7fcb = /*#__PURE__*/ $dpNXS.rightF($OFl2v.Functor);
var $95d292429e983193$export$9d86f0a38eb969ef = /*#__PURE__*/ $dpNXS.leftF($OFl2v.Functor);
var $95d292429e983193$export$80c878c9b1d77917 = $OFl2v.of;
var $95d292429e983193$export$d529793c7ff048a8 = $95d292429e983193$export$c1cd2021ce1d7fcb;
var $95d292429e983193$export$4659b591c19bdf3d = /*#__PURE__*/ $dpNXS.match($OFl2v.Functor);
var $95d292429e983193$export$2d55ea551c238330 = $95d292429e983193$export$4659b591c19bdf3d;
var $95d292429e983193$export$398621f19e0a7e4 = /*#__PURE__*/ $dpNXS.matchE($OFl2v.Monad);
var $95d292429e983193$export$93e2b83da34ff82a = $95d292429e983193$export$398621f19e0a7e4;
var $95d292429e983193$export$85ac45300d10b517 = $95d292429e983193$export$398621f19e0a7e4;
var $95d292429e983193$export$ccb09033cefa61e8 = $95d292429e983193$export$85ac45300d10b517;
var $95d292429e983193$export$8832081647a02ee7 = /*#__PURE__*/ $dpNXS.getOrElse($OFl2v.Monad);
var $95d292429e983193$export$d8a997ff0e6436f3 = $95d292429e983193$export$8832081647a02ee7;
var $95d292429e983193$export$d234c058d1d4e435 = function(f, onThrow) {
    return function() {
        return $7Rbab.tryCatch(f, onThrow);
    };
};
var $95d292429e983193$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $95d292429e983193$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $95d292429e983193$export$a0886ed3a572729f = /*#__PURE__*/ $dpNXS.toUnion($OFl2v.Functor);
var $95d292429e983193$export$41d1a04d78e7b141 = /*#__PURE__*/ $dpNXS.orElse($OFl2v.Monad);
var $95d292429e983193$export$efd845e0c87089a6 = $95d292429e983193$export$41d1a04d78e7b141;
var $95d292429e983193$export$f297679585c88732 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dpNXS.tapError($OFl2v.Monad));
var $95d292429e983193$export$91e9d1839ed8da93 = function(onLeft) {
    return $95d292429e983193$export$f297679585c88732($95d292429e983193$export$9d3fcca17a044a16(onLeft));
};
var $95d292429e983193$export$e84f0fd7f5bcfbf0 = /*#__PURE__*/ $dpNXS.orLeft($OFl2v.Monad);
var $95d292429e983193$export$b0e76d9850c64156 = /*#__PURE__*/ $dpNXS.swap($OFl2v.Functor);
/* istanbul ignore next */ var $95d292429e983193$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $95d292429e983193$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $95d292429e983193$var$_ap = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $95d292429e983193$export$2f6ca3d3b1f80bf5(fa));
};
var $95d292429e983193$var$_apSeq = function(fab, fa) {
    return $95d292429e983193$export$5b8affa63fc6df16(fab, function(f) {
        return (0, $kj6DU.pipe)(fa, $95d292429e983193$export$871de8747c9eaa88(f));
    });
};
/* istanbul ignore next */ var $95d292429e983193$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $95d292429e983193$export$228be17d80722ab(that));
};
var $95d292429e983193$export$871de8747c9eaa88 = /*#__PURE__*/ $dpNXS.map($OFl2v.Functor);
var $95d292429e983193$export$2ab19f8a7e145f0a = /*#__PURE__*/ (0, $kj6DU.dual)(3, $dpNXS.mapBoth($OFl2v.Functor));
var $95d292429e983193$export$eb54baf0b342cb1d = $95d292429e983193$export$2ab19f8a7e145f0a;
var $95d292429e983193$export$d0f6f6f8d08fe167 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dpNXS.mapError($OFl2v.Functor));
var $95d292429e983193$export$472de43a55e4aa49 = $95d292429e983193$export$d0f6f6f8d08fe167;
var $95d292429e983193$export$2f6ca3d3b1f80bf5 = /*#__PURE__*/ $dpNXS.ap($OFl2v.Apply);
var $95d292429e983193$export$321be6e231de8eac = $95d292429e983193$export$2f6ca3d3b1f80bf5;
var $95d292429e983193$export$ba255e9e49e00608 = $95d292429e983193$export$79ffe56a765070d2;
var $95d292429e983193$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dpNXS.flatMap($OFl2v.Monad));
var $95d292429e983193$export$2409099f1fc434fb = /*#__PURE__*/ $95d292429e983193$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $95d292429e983193$export$bffa455ba8c619a6 = $95d292429e983193$export$2409099f1fc434fb;
var $95d292429e983193$export$228be17d80722ab = /*#__PURE__*/ $dpNXS.alt($OFl2v.Monad);
var $95d292429e983193$export$1517cca7889d6aaa = $95d292429e983193$export$228be17d80722ab;
var $95d292429e983193$export$8bf7aba4a9e09055 = $95d292429e983193$export$eabcd2c8791e7bf4;
var $95d292429e983193$export$9156e739aa33e19f = 'IOEither';
function $95d292429e983193$export$9b687d4ef3c7df6f(S) {
    var ap = (0, $j7Bi0.ap)($OFl2v.Apply, $7Rbab.getApplicativeValidation(S));
    return {
        URI: $95d292429e983193$export$9156e739aa33e19f,
        _E: undefined,
        map: $95d292429e983193$var$_map,
        ap: function(fab, fa) {
            return (0, $kj6DU.pipe)(fab, ap(fa));
        },
        of: $95d292429e983193$export$ba255e9e49e00608
    };
}
function $95d292429e983193$export$9b5f70484e613d76(S) {
    var alt = $dpNXS.altValidation($OFl2v.Monad, S);
    return {
        URI: $95d292429e983193$export$9156e739aa33e19f,
        _E: undefined,
        map: $95d292429e983193$var$_map,
        alt: function(fa, that) {
            return (0, $kj6DU.pipe)(fa, alt(that));
        }
    };
}
var $95d292429e983193$export$cfae3069ac05ff4c = function(M) {
    var C = $7Rbab.getCompactable(M);
    return {
        URI: $95d292429e983193$export$9156e739aa33e19f,
        _E: undefined,
        compact: (0, $eQAK7.compact)($OFl2v.Functor, C),
        separate: (0, $eQAK7.separate)($OFl2v.Functor, C, $7Rbab.Functor)
    };
};
function $95d292429e983193$export$a4e870b0a57ec14e(M) {
    var F = $7Rbab.getFilterable(M);
    var C = $95d292429e983193$export$cfae3069ac05ff4c(M);
    var filter = (0, $dHiDk.filter)($OFl2v.Functor, F);
    var filterMap = (0, $dHiDk.filterMap)($OFl2v.Functor, F);
    var partition = (0, $dHiDk.partition)($OFl2v.Functor, F);
    var partitionMap = (0, $dHiDk.partitionMap)($OFl2v.Functor, F);
    return {
        URI: $95d292429e983193$export$9156e739aa33e19f,
        _E: undefined,
        map: $95d292429e983193$var$_map,
        compact: C.compact,
        separate: C.separate,
        filter: function(fa, predicate) {
            return (0, $kj6DU.pipe)(fa, filter(predicate));
        },
        filterMap: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, filterMap(f));
        },
        partition: function(fa, predicate) {
            return (0, $kj6DU.pipe)(fa, partition(predicate));
        },
        partitionMap: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, partitionMap(f));
        }
    };
}
var $95d292429e983193$export$bd5b6bfc5fa2ee61 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map
};
var $95d292429e983193$export$6554612db691658e = (0, $kj6DU.dual)(2, (0, $6baua.as)($95d292429e983193$export$bd5b6bfc5fa2ee61));
var $95d292429e983193$export$9284b360ca18a0fd = (0, $6baua.asUnit)($95d292429e983193$export$bd5b6bfc5fa2ee61);
var $95d292429e983193$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($95d292429e983193$export$bd5b6bfc5fa2ee61);
var $95d292429e983193$export$59a71046037e6c20 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    of: $95d292429e983193$export$ba255e9e49e00608
};
var $95d292429e983193$export$fd0fe42029639505 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    bimap: $95d292429e983193$export$2ab19f8a7e145f0a,
    mapLeft: $95d292429e983193$export$d0f6f6f8d08fe167
};
var $95d292429e983193$export$e825dd8dbbdc0410 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_ap
};
var $95d292429e983193$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($95d292429e983193$export$e825dd8dbbdc0410);
var $95d292429e983193$export$ac044f4aa9961a4f = $95d292429e983193$export$5f28d9feedcfd46e;
var $95d292429e983193$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($95d292429e983193$export$e825dd8dbbdc0410);
var $95d292429e983193$export$8a00020751233172 = $95d292429e983193$export$ed01bc59c3d06bf3;
var $95d292429e983193$export$11b888901d89cc2 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_ap,
    of: $95d292429e983193$export$ba255e9e49e00608
};
var $95d292429e983193$export$9c23f2f51a58ba10 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_apSeq,
    of: $95d292429e983193$export$ba255e9e49e00608
};
var $95d292429e983193$export$f18d5acc27d70423 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_ap,
    chain: $95d292429e983193$export$5b8affa63fc6df16
};
var $95d292429e983193$export$fb641926d034ac7d = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_ap,
    of: $95d292429e983193$export$ba255e9e49e00608,
    chain: $95d292429e983193$export$5b8affa63fc6df16
};
var $95d292429e983193$export$825ea6cb6fc48d49 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    fromEither: $95d292429e983193$export$80c878c9b1d77917
};
var $95d292429e983193$export$978d37ea2fe360cf = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    fromIO: $95d292429e983193$export$d529793c7ff048a8
};
var $95d292429e983193$export$3f23594af5f37336 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dya6d.tap($95d292429e983193$export$f18d5acc27d70423));
var $95d292429e983193$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $fgwhT.tapEither)($95d292429e983193$export$825ea6cb6fc48d49, $95d292429e983193$export$f18d5acc27d70423));
var $95d292429e983193$export$5bf3b8929fda1158 = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $bmbrn.tapIO)($95d292429e983193$export$978d37ea2fe360cf, $95d292429e983193$export$f18d5acc27d70423));
var $95d292429e983193$export$25ba4469a069167 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    alt: $95d292429e983193$var$_alt
};
var $95d292429e983193$export$dc43ee6ccf36ad90 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_ap,
    of: $95d292429e983193$export$ba255e9e49e00608,
    chain: $95d292429e983193$export$5b8affa63fc6df16,
    fromIO: $95d292429e983193$export$d529793c7ff048a8
};
var $95d292429e983193$export$5f956d47d0619c3a = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    map: $95d292429e983193$var$_map,
    ap: $95d292429e983193$var$_ap,
    of: $95d292429e983193$export$ba255e9e49e00608,
    chain: $95d292429e983193$export$5b8affa63fc6df16,
    throwError: $95d292429e983193$export$8bf7aba4a9e09055
};
var $95d292429e983193$export$9d3fcca17a044a16 = /*#__PURE__*/ (0, $bmbrn.fromIOK)($95d292429e983193$export$978d37ea2fe360cf);
var $95d292429e983193$export$5148ef8785cce359 = $95d292429e983193$export$5bf3b8929fda1158;
var $95d292429e983193$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $fgwhT.fromOption)($95d292429e983193$export$825ea6cb6fc48d49);
var $95d292429e983193$export$a907462f448b49f8 = /*#__PURE__*/ (0, $fgwhT.fromOptionK)($95d292429e983193$export$825ea6cb6fc48d49);
var $95d292429e983193$export$12d26179deb6a68a = /*#__PURE__*/ (0, $fgwhT.chainOptionK)($95d292429e983193$export$825ea6cb6fc48d49, $95d292429e983193$export$f18d5acc27d70423);
var $95d292429e983193$export$377cc334277e5c3c = $95d292429e983193$export$12d26179deb6a68a;
/** @internal */ var $95d292429e983193$var$_FromEither = {
    fromEither: $95d292429e983193$export$825ea6cb6fc48d49.fromEither
};
/** @internal */ var $95d292429e983193$var$_FromIO = {
    fromIO: $95d292429e983193$export$d529793c7ff048a8
};
var $95d292429e983193$export$cd139e14432f317b = /*#__PURE__*/ $lOGTm.liftNullable($95d292429e983193$var$_FromEither);
var $95d292429e983193$export$ea4a22f93200df79 = /*#__PURE__*/ $lOGTm.liftOption($95d292429e983193$var$_FromEither);
/** @internal */ var $95d292429e983193$var$_FlatMap = {
    flatMap: $95d292429e983193$export$5b8affa63fc6df16
};
var $95d292429e983193$export$1a0515933c5c84fe = /*#__PURE__*/ $lOGTm.flatMapNullable($95d292429e983193$var$_FromEither, $95d292429e983193$var$_FlatMap);
var $95d292429e983193$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $lOGTm.flatMapOption($95d292429e983193$var$_FromEither, $95d292429e983193$var$_FlatMap);
var $95d292429e983193$export$979f2bb6a976172d = /*#__PURE__*/ $lOGTm.flatMapEither($95d292429e983193$var$_FromEither, $95d292429e983193$var$_FlatMap);
var $95d292429e983193$export$8b635ef81222764c = /*#__PURE__*/ $lOGTm.flatMapIO($95d292429e983193$var$_FromIO, $95d292429e983193$var$_FlatMap);
var $95d292429e983193$export$dbedca339774a859 = $95d292429e983193$export$8b635ef81222764c;
var $95d292429e983193$export$a3eef2eba9908c3e = $95d292429e983193$export$979f2bb6a976172d;
var $95d292429e983193$export$148e58f5a13b0a29 = $95d292429e983193$export$979f2bb6a976172d;
var $95d292429e983193$export$c5f2bdbf9b43f0c0 = $95d292429e983193$export$be3ff275bb5a8ac9;
var $95d292429e983193$export$3b38f8f4685eb1a8 = $95d292429e983193$export$be3ff275bb5a8ac9;
var $95d292429e983193$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $fgwhT.fromPredicate)($95d292429e983193$export$825ea6cb6fc48d49);
var $95d292429e983193$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $fgwhT.filterOrElse)($95d292429e983193$export$825ea6cb6fc48d49, $95d292429e983193$export$f18d5acc27d70423);
var $95d292429e983193$export$84511cf4503ec9dd = $95d292429e983193$export$30af8ca9498ddf5b;
var $95d292429e983193$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $fgwhT.fromEitherK)($95d292429e983193$export$825ea6cb6fc48d49);
var $95d292429e983193$export$df5598cc12b9c8c = function(acquire, use, release) {
    return $95d292429e983193$export$15093e5f950a635(acquire, use, release);
};
var $95d292429e983193$export$15093e5f950a635 = function(acquire, use, release) {
    return $95d292429e983193$export$5b8affa63fc6df16(acquire, function(a) {
        return $OFl2v.flatMap(use(a), function(e) {
            return $95d292429e983193$export$5b8affa63fc6df16(release(a, e), function() {
                return $OFl2v.of(e);
            });
        });
    });
};
var $95d292429e983193$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $95d292429e983193$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $95d292429e983193$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($95d292429e983193$export$bd5b6bfc5fa2ee61);
var $95d292429e983193$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($95d292429e983193$export$bd5b6bfc5fa2ee61);
var $95d292429e983193$export$2385a24977818dd0 = /*#__PURE__*/ $dya6d.bind($95d292429e983193$export$f18d5acc27d70423);
var $95d292429e983193$export$e0d5b1cbe98976d9 = $95d292429e983193$export$2385a24977818dd0;
var $95d292429e983193$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($95d292429e983193$export$e825dd8dbbdc0410);
var $95d292429e983193$export$5c01f27714264b3d = $95d292429e983193$export$8cbfc0239f42bb49;
var $95d292429e983193$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $95d292429e983193$export$ba255e9e49e00608($lOGTm.emptyReadonlyArray);
var $95d292429e983193$export$817de7d5ba7e6fab = function(f) {
    return (0, $kj6DU.flow)($OFl2v.traverseReadonlyNonEmptyArrayWithIndex(f), $OFl2v.map($7Rbab.traverseReadonlyNonEmptyArrayWithIndex((0, $kj6DU.SK))));
};
var $95d292429e983193$export$d4e79db5dc14cc1 = function(f) {
    var g = $95d292429e983193$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $95d292429e983193$export$c74b6e34b2b6efb0;
    };
};
var $95d292429e983193$export$ccd1b7252ef04791 = function(f) {
    return function(as) {
        return function() {
            var e = f(0, $lOGTm.head(as))();
            if ($lOGTm.isLeft(e)) return e;
            var out = [
                e.right
            ];
            for(var i = 1; i < as.length; i++){
                var e_1 = f(i, as[i])();
                if ($lOGTm.isLeft(e_1)) return e_1;
                out.push(e_1.right);
            }
            return $lOGTm.right(out);
        };
    };
};
var $95d292429e983193$export$674043f9db4279c7 = function(f) {
    var g = $95d292429e983193$export$ccd1b7252ef04791(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $95d292429e983193$export$c74b6e34b2b6efb0;
    };
};
var $95d292429e983193$export$104a2841e9cbad06 = $95d292429e983193$export$d4e79db5dc14cc1;
var $95d292429e983193$export$64f39b2a2b79e1b1 = function(f) {
    return $95d292429e983193$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $95d292429e983193$export$d330b60315c14cd1 = /*#__PURE__*/ $95d292429e983193$export$64f39b2a2b79e1b1((0, $kj6DU.identity));
var $95d292429e983193$export$6702e2a63712b0a0 = $95d292429e983193$export$674043f9db4279c7;
var $95d292429e983193$export$5932486b5125ca68 = function(f) {
    return $95d292429e983193$export$674043f9db4279c7(function(_, a) {
        return f(a);
    });
};
var $95d292429e983193$export$5e316684572fbbb6 = /*#__PURE__*/ $95d292429e983193$export$5932486b5125ca68((0, $kj6DU.identity));
var $95d292429e983193$export$1279d2b7807629fd = $95d292429e983193$export$11b888901d89cc2;
var $95d292429e983193$export$e08e3b67e392101e = $95d292429e983193$export$5b8affa63fc6df16;
var $95d292429e983193$export$8e5885f0163d737a = $95d292429e983193$export$5b8affa63fc6df16;
var $95d292429e983193$export$e3821ef4970c339c = $95d292429e983193$export$3f23594af5f37336;
var $95d292429e983193$export$5de78197fc44b933 = $95d292429e983193$export$3f23594af5f37336;
var $95d292429e983193$export$2705983cb222ac0a = $95d292429e983193$export$f297679585c88732;
var $95d292429e983193$export$d43d943be7ad7d62 = $95d292429e983193$export$f297679585c88732;
var $95d292429e983193$export$abaf0c7037008059 = {
    URI: $95d292429e983193$export$9156e739aa33e19f,
    bimap: $95d292429e983193$export$2ab19f8a7e145f0a,
    mapLeft: $95d292429e983193$export$d0f6f6f8d08fe167,
    map: $95d292429e983193$var$_map,
    of: $95d292429e983193$export$ba255e9e49e00608,
    ap: $95d292429e983193$var$_ap,
    chain: $95d292429e983193$export$5b8affa63fc6df16,
    alt: $95d292429e983193$var$_alt,
    fromIO: $95d292429e983193$export$d529793c7ff048a8,
    throwError: $95d292429e983193$export$8bf7aba4a9e09055
};
var $95d292429e983193$export$18979a515d2a828e = /*#__PURE__*/ (0, $j7Bi0.getApplySemigroup)($95d292429e983193$export$e825dd8dbbdc0410);
var $95d292429e983193$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $dYcKb.getApplicativeMonoid)($95d292429e983193$export$11b888901d89cc2);
var $95d292429e983193$export$e759a9a7f8d04692 = function(S) {
    return (0, $j7Bi0.getApplySemigroup)($OFl2v.Apply)($7Rbab.getSemigroup(S));
};
function $95d292429e983193$export$9781d05075e655d9(SE) {
    var applicativeIOValidation = $95d292429e983193$export$9b687d4ef3c7df6f(SE);
    var altIOValidation = $95d292429e983193$export$9b5f70484e613d76(SE);
    return {
        URI: $95d292429e983193$export$9156e739aa33e19f,
        _E: undefined,
        map: $95d292429e983193$var$_map,
        ap: applicativeIOValidation.ap,
        of: $95d292429e983193$export$ba255e9e49e00608,
        chain: $95d292429e983193$export$5b8affa63fc6df16,
        bimap: $95d292429e983193$export$2ab19f8a7e145f0a,
        mapLeft: $95d292429e983193$export$d0f6f6f8d08fe167,
        alt: altIOValidation.alt,
        fromIO: $95d292429e983193$export$d529793c7ff048a8,
        throwError: $95d292429e983193$export$8bf7aba4a9e09055
    };
}

});
parcelRegister("eQAK7", function(module, exports) {

$parcel$export(module.exports, "compact", function () { return $acf26c65c62bfa95$export$8e16b83750b44988; });
$parcel$export(module.exports, "separate", function () { return $acf26c65c62bfa95$export$709f6946f4e97408; });

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $3NXK3 = parcelRequire("3NXK3");

var $aRVRH = parcelRequire("aRVRH");
function $acf26c65c62bfa95$export$8e16b83750b44988(F, G) {
    return function(fga) {
        return F.map(fga, G.compact);
    };
}
function $acf26c65c62bfa95$export$709f6946f4e97408(F, C, G) {
    var _compact = $acf26c65c62bfa95$export$8e16b83750b44988(F, C);
    var _map = (0, $6baua.map)(F, G);
    return function(fge) {
        return $aRVRH.separated(_compact((0, $kj6DU.pipe)(fge, _map((0, $3NXK3.getLeft)))), _compact((0, $kj6DU.pipe)(fge, _map((0, $3NXK3.getRight)))));
    };
}
function $acf26c65c62bfa95$export$11b9309ca56a3cda(F, G) {
    var map = (0, $6baua.getFunctorComposition)(F, G).map;
    return {
        map: map,
        compact: $acf26c65c62bfa95$export$8e16b83750b44988(F, G),
        separate: $acf26c65c62bfa95$export$709f6946f4e97408(F, G, G)
    };
}

});

parcelRegister("dpNXS", function(module, exports) {

$parcel$export(module.exports, "right", function () { return $9c445e238267fac4$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $9c445e238267fac4$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "rightF", function () { return $9c445e238267fac4$export$6572c0c90699ea15; });
$parcel$export(module.exports, "leftF", function () { return $9c445e238267fac4$export$65a0b8ec3e227a75; });
$parcel$export(module.exports, "fromNullable", function () { return $9c445e238267fac4$export$b601f49376b4621a; });
$parcel$export(module.exports, "fromNullableK", function () { return $9c445e238267fac4$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $9c445e238267fac4$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "map", function () { return $9c445e238267fac4$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $9c445e238267fac4$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $9c445e238267fac4$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "alt", function () { return $9c445e238267fac4$export$228be17d80722ab; });
$parcel$export(module.exports, "mapBoth", function () { return $9c445e238267fac4$export$2ab19f8a7e145f0a; });
$parcel$export(module.exports, "mapError", function () { return $9c445e238267fac4$export$d0f6f6f8d08fe167; });
$parcel$export(module.exports, "altValidation", function () { return $9c445e238267fac4$export$4560910d7b3e445f; });
$parcel$export(module.exports, "match", function () { return $9c445e238267fac4$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchE", function () { return $9c445e238267fac4$export$398621f19e0a7e4; });
$parcel$export(module.exports, "getOrElse", function () { return $9c445e238267fac4$export$8832081647a02ee7; });
$parcel$export(module.exports, "orElse", function () { return $9c445e238267fac4$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "tapError", function () { return $9c445e238267fac4$export$f297679585c88732; });
$parcel$export(module.exports, "orLeft", function () { return $9c445e238267fac4$export$e84f0fd7f5bcfbf0; });
$parcel$export(module.exports, "swap", function () { return $9c445e238267fac4$export$b0e76d9850c64156; });
$parcel$export(module.exports, "toUnion", function () { return $9c445e238267fac4$export$a0886ed3a572729f; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $7Rbab = parcelRequire("7Rbab");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");
function $9c445e238267fac4$export$79ffe56a765070d2(F) {
    return (0, $kj6DU.flow)($7Rbab.right, F.of);
}
function $9c445e238267fac4$export$eabcd2c8791e7bf4(F) {
    return (0, $kj6DU.flow)($7Rbab.left, F.of);
}
function $9c445e238267fac4$export$6572c0c90699ea15(F) {
    return function(fa) {
        return F.map(fa, $7Rbab.right);
    };
}
function $9c445e238267fac4$export$65a0b8ec3e227a75(F) {
    return function(fe) {
        return F.map(fe, $7Rbab.left);
    };
}
function $9c445e238267fac4$export$b601f49376b4621a(F) {
    return function(e) {
        return (0, $kj6DU.flow)($7Rbab.fromNullable(e), F.of);
    };
}
function $9c445e238267fac4$export$c69ca7b73fad45e1(F) {
    var fromNullableF = $9c445e238267fac4$export$b601f49376b4621a(F);
    return function(e) {
        var fromNullableFE = fromNullableF(e);
        return function(f) {
            return (0, $kj6DU.flow)(f, fromNullableFE);
        };
    };
}
function $9c445e238267fac4$export$c81f992c08fd0bf3(M) {
    var chainM = $9c445e238267fac4$export$e08e3b67e392101e(M);
    var fromNullableKM = $9c445e238267fac4$export$c69ca7b73fad45e1(M);
    return function(e) {
        var fromNullableKMe = fromNullableKM(e);
        return function(f) {
            return chainM(fromNullableKMe(f));
        };
    };
}
function $9c445e238267fac4$export$871de8747c9eaa88(F) {
    return (0, $6baua.map)(F, $7Rbab.Functor);
}
function $9c445e238267fac4$export$2f6ca3d3b1f80bf5(F) {
    return (0, $j7Bi0.ap)(F, $7Rbab.Apply);
}
function $9c445e238267fac4$export$e08e3b67e392101e(M) {
    var flatMapM = $9c445e238267fac4$export$5b8affa63fc6df16(M);
    return function(f) {
        return function(ma) {
            return flatMapM(ma, f);
        };
    };
}
function $9c445e238267fac4$export$5b8affa63fc6df16(M) {
    return function(ma, f) {
        return M.chain(ma, function(e) {
            return $7Rbab.isLeft(e) ? M.of(e) : f(e.right);
        });
    };
}
function $9c445e238267fac4$export$228be17d80722ab(M) {
    return function(second) {
        return function(first) {
            return M.chain(first, function(e) {
                return $7Rbab.isLeft(e) ? second() : M.of(e);
            });
        };
    };
}
function $9c445e238267fac4$export$eb54baf0b342cb1d(F) {
    var mapBothF = $9c445e238267fac4$export$2ab19f8a7e145f0a(F);
    return function(f, g) {
        return function(self) {
            return mapBothF(self, f, g);
        };
    };
}
function $9c445e238267fac4$export$2ab19f8a7e145f0a(F) {
    return function(self, f, g) {
        return F.map(self, $7Rbab.bimap(f, g));
    };
}
function $9c445e238267fac4$export$472de43a55e4aa49(F) {
    var mapErrorF = $9c445e238267fac4$export$d0f6f6f8d08fe167(F);
    return function(f) {
        return function(self) {
            return mapErrorF(self, f);
        };
    };
}
function $9c445e238267fac4$export$d0f6f6f8d08fe167(F) {
    return function(self, f) {
        return F.map(self, $7Rbab.mapLeft(f));
    };
}
function $9c445e238267fac4$export$4560910d7b3e445f(M, S) {
    return function(second) {
        return function(first) {
            return M.chain(first, $7Rbab.match(function(e1) {
                return M.map(second(), $7Rbab.mapLeft(function(e2) {
                    return S.concat(e1, e2);
                }));
            }, $9c445e238267fac4$export$79ffe56a765070d2(M)));
        };
    };
}
function $9c445e238267fac4$export$4659b591c19bdf3d(F) {
    return function(onLeft, onRight) {
        return function(ma) {
            return F.map(ma, $7Rbab.match(onLeft, onRight));
        };
    };
}
function $9c445e238267fac4$export$398621f19e0a7e4(M) {
    return function(onLeft, onRight) {
        return function(ma) {
            return M.chain(ma, $7Rbab.match(onLeft, onRight));
        };
    };
}
function $9c445e238267fac4$export$8832081647a02ee7(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, $7Rbab.match(onLeft, M.of));
        };
    };
}
function $9c445e238267fac4$export$41d1a04d78e7b141(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, function(e) {
                return $7Rbab.isLeft(e) ? onLeft(e.left) : M.of(e);
            });
        };
    };
}
function $9c445e238267fac4$export$2705983cb222ac0a(M) {
    var tapErrorM = $9c445e238267fac4$export$f297679585c88732(M);
    return function(onLeft) {
        return function(ma) {
            return tapErrorM(ma, onLeft);
        };
    };
}
function $9c445e238267fac4$export$f297679585c88732(M) {
    var orElseM = $9c445e238267fac4$export$41d1a04d78e7b141(M);
    return function(ma, onLeft) {
        return (0, $kj6DU.pipe)(ma, orElseM(function(e) {
            return M.map(onLeft(e), function(eb) {
                return $7Rbab.isLeft(eb) ? eb : $7Rbab.left(e);
            });
        }));
    };
}
function $9c445e238267fac4$export$e84f0fd7f5bcfbf0(M) {
    return function(onLeft) {
        return function(ma) {
            return M.chain(ma, $7Rbab.match(function(e) {
                return M.map(onLeft(e), $7Rbab.left);
            }, function(a) {
                return M.of($7Rbab.right(a));
            }));
        };
    };
}
function $9c445e238267fac4$export$b0e76d9850c64156(F) {
    return function(ma) {
        return F.map(ma, $7Rbab.swap);
    };
}
function $9c445e238267fac4$export$a0886ed3a572729f(F) {
    return function(fa) {
        return F.map(fa, $7Rbab.toUnion);
    };
}
function $9c445e238267fac4$export$57fa338b953665e0(M) {
    var _ap = $9c445e238267fac4$export$2f6ca3d3b1f80bf5(M);
    var _map = $9c445e238267fac4$export$871de8747c9eaa88(M);
    var _chain = $9c445e238267fac4$export$e08e3b67e392101e(M);
    var _alt = $9c445e238267fac4$export$228be17d80722ab(M);
    var _bimap = $9c445e238267fac4$export$eb54baf0b342cb1d(M);
    var _mapLeft = $9c445e238267fac4$export$472de43a55e4aa49(M);
    var _fold = $9c445e238267fac4$export$398621f19e0a7e4(M);
    var _getOrElse = $9c445e238267fac4$export$8832081647a02ee7(M);
    var _orElse = $9c445e238267fac4$export$41d1a04d78e7b141(M);
    return {
        map: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, _map(f));
        },
        ap: function(fab, fa) {
            return (0, $kj6DU.pipe)(fab, _ap(fa));
        },
        of: $9c445e238267fac4$export$79ffe56a765070d2(M),
        chain: function(ma, f) {
            return (0, $kj6DU.pipe)(ma, _chain(f));
        },
        alt: function(fa, that) {
            return (0, $kj6DU.pipe)(fa, _alt(that));
        },
        bimap: function(fea, f, g) {
            return (0, $kj6DU.pipe)(fea, _bimap(f, g));
        },
        mapLeft: function(fea, f) {
            return (0, $kj6DU.pipe)(fea, _mapLeft(f));
        },
        fold: function(fa, onLeft, onRight) {
            return (0, $kj6DU.pipe)(fa, _fold(onLeft, onRight));
        },
        getOrElse: function(fa, onLeft) {
            return (0, $kj6DU.pipe)(fa, _getOrElse(onLeft));
        },
        orElse: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, _orElse(f));
        },
        swap: $9c445e238267fac4$export$b0e76d9850c64156(M),
        rightM: $9c445e238267fac4$export$6572c0c90699ea15(M),
        leftM: $9c445e238267fac4$export$65a0b8ec3e227a75(M),
        left: $9c445e238267fac4$export$eabcd2c8791e7bf4(M)
    };
}

});

parcelRegister("dHiDk", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $9f8dbeb4a96bbfa7$export$3dea766d36a8935f; });
$parcel$export(module.exports, "filterMap", function () { return $9f8dbeb4a96bbfa7$export$a04c6c6965dd4709; });
$parcel$export(module.exports, "partition", function () { return $9f8dbeb4a96bbfa7$export$b29f828819edca8d; });
$parcel$export(module.exports, "partitionMap", function () { return $9f8dbeb4a96bbfa7$export$3117e3f9ececb6bc; });
/**
 * `Filterable` represents data structures which can be _partitioned_/_filtered_.
 *
 * Adapted from https://github.com/LiamGoodacre/purescript-filterable/blob/master/src/Data/Filterable.purs
 *
 * @since 2.0.0
 */ 
var $eQAK7 = parcelRequire("eQAK7");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $3NXK3 = parcelRequire("3NXK3");

var $lSBre = parcelRequire("lSBre");

var $aRVRH = parcelRequire("aRVRH");
function $9f8dbeb4a96bbfa7$export$3dea766d36a8935f(F, G) {
    return function(predicate) {
        return function(fga) {
            return F.map(fga, function(ga) {
                return G.filter(ga, predicate);
            });
        };
    };
}
function $9f8dbeb4a96bbfa7$export$a04c6c6965dd4709(F, G) {
    return function(f) {
        return function(fga) {
            return F.map(fga, function(ga) {
                return G.filterMap(ga, f);
            });
        };
    };
}
function $9f8dbeb4a96bbfa7$export$b29f828819edca8d(F, G) {
    var _filter = $9f8dbeb4a96bbfa7$export$3dea766d36a8935f(F, G);
    return function(predicate) {
        var left = _filter((0, $lSBre.not)(predicate));
        var right = _filter(predicate);
        return function(fgb) {
            return (0, $aRVRH.separated)(left(fgb), right(fgb));
        };
    };
}
function $9f8dbeb4a96bbfa7$export$3117e3f9ececb6bc(F, G) {
    var _filterMap = $9f8dbeb4a96bbfa7$export$a04c6c6965dd4709(F, G);
    return function(f) {
        return function(fga) {
            return (0, $aRVRH.separated)((0, $kj6DU.pipe)(fga, _filterMap(function(a) {
                return (0, $3NXK3.getLeft)(f(a));
            })), (0, $kj6DU.pipe)(fga, _filterMap(function(a) {
                return (0, $3NXK3.getRight)(f(a));
            })));
        };
    };
}
function $9f8dbeb4a96bbfa7$export$b5e175598dd6497f(F, G) {
    var map = (0, $6baua.getFunctorComposition)(F, G).map;
    var _compact = (0, $eQAK7.compact)(F, G);
    var _separate = (0, $eQAK7.separate)(F, G, G);
    var _filter = $9f8dbeb4a96bbfa7$export$3dea766d36a8935f(F, G);
    var _filterMap = $9f8dbeb4a96bbfa7$export$a04c6c6965dd4709(F, G);
    var _partition = $9f8dbeb4a96bbfa7$export$b29f828819edca8d(F, G);
    var _partitionMap = $9f8dbeb4a96bbfa7$export$3117e3f9ececb6bc(F, G);
    return {
        map: map,
        compact: _compact,
        separate: _separate,
        filter: function(fga, f) {
            return (0, $kj6DU.pipe)(fga, _filter(f));
        },
        filterMap: function(fga, f) {
            return (0, $kj6DU.pipe)(fga, _filterMap(f));
        },
        partition: function(fga, p) {
            return (0, $kj6DU.pipe)(fga, _partition(p));
        },
        partitionMap: function(fga, f) {
            return (0, $kj6DU.pipe)(fga, _partitionMap(f));
        }
    };
}

});

parcelRegister("bmbrn", function(module, exports) {

$parcel$export(module.exports, "fromIOK", function () { return $844a9fa630e4f119$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "tapIO", function () { return $844a9fa630e4f119$export$5bf3b8929fda1158; });
/**
 * Lift a computation from the `IO` monad
 *
 * @since 2.10.0
 */ 
var $dya6d = parcelRequire("dya6d");

var $kj6DU = parcelRequire("kj6DU");
function $844a9fa630e4f119$export$9d3fcca17a044a16(F) {
    return function(f) {
        return (0, $kj6DU.flow)(f, F.fromIO);
    };
}
function $844a9fa630e4f119$export$dbedca339774a859(F, M) {
    return function(f) {
        var g = (0, $kj6DU.flow)(f, F.fromIO);
        return function(first) {
            return M.chain(first, g);
        };
    };
}
function $844a9fa630e4f119$export$5148ef8785cce359(F, M) {
    var tapIOM = $844a9fa630e4f119$export$5bf3b8929fda1158(F, M);
    return function(f) {
        return function(first) {
            return tapIOM(first, f);
        };
    };
}
function $844a9fa630e4f119$export$5bf3b8929fda1158(F, M) {
    var chainFirstM = (0, $dya6d.tap)(M);
    return function(self, f) {
        return chainFirstM(self, (0, $kj6DU.flow)(f, F.fromIO));
    };
}

});


parcelRegister("5PZg8", function(module, exports) {

$parcel$export(module.exports, "fst", function () { return $44013bf989d6fb13$export$9e770fa6ce19a9d6; });
$parcel$export(module.exports, "snd", function () { return $44013bf989d6fb13$export$6f71268a1666ab58; });
$parcel$export(module.exports, "swap", function () { return $44013bf989d6fb13$export$b0e76d9850c64156; });
$parcel$export(module.exports, "getApply", function () { return $44013bf989d6fb13$export$81090df2aa47ff12; });
$parcel$export(module.exports, "URI", function () { return $44013bf989d6fb13$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getApplicative", function () { return $44013bf989d6fb13$export$1402880adb2295a7; });
$parcel$export(module.exports, "getChain", function () { return $44013bf989d6fb13$export$f4608058c83a1dc2; });
$parcel$export(module.exports, "getMonad", function () { return $44013bf989d6fb13$export$a024c9fefbcb9ced; });
$parcel$export(module.exports, "getChainRec", function () { return $44013bf989d6fb13$export$4bab931e633547e6; });
$parcel$export(module.exports, "compose", function () { return $44013bf989d6fb13$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "mapFst", function () { return $44013bf989d6fb13$export$b1cdc73ee064e0df; });
$parcel$export(module.exports, "bimap", function () { return $44013bf989d6fb13$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapSnd", function () { return $44013bf989d6fb13$export$96c3d3b04ed42b1c; });
$parcel$export(module.exports, "extend", function () { return $44013bf989d6fb13$export$8b58be045bf06082; });
$parcel$export(module.exports, "reduce", function () { return $44013bf989d6fb13$export$533b26079ad0b4b; });
$parcel$export(module.exports, "foldMap", function () { return $44013bf989d6fb13$export$b66cdc0497d8a99a; });
$parcel$export(module.exports, "reduceRight", function () { return $44013bf989d6fb13$export$7fef8bcdbb34f435; });
$parcel$export(module.exports, "traverse", function () { return $44013bf989d6fb13$export$df3f009e3d155b20; });
$parcel$export(module.exports, "extract", function () { return $44013bf989d6fb13$export$f9380c9a627682d3; });
$parcel$export(module.exports, "duplicate", function () { return $44013bf989d6fb13$export$ecd5e8ace626722c; });
$parcel$export(module.exports, "sequence", function () { return $44013bf989d6fb13$export$49bb65c2ea163039; });
$parcel$export(module.exports, "Functor", function () { return $44013bf989d6fb13$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "flap", function () { return $44013bf989d6fb13$export$18c957606d8bdf09; });
$parcel$export(module.exports, "map", function () { return $44013bf989d6fb13$export$871de8747c9eaa88; });
$parcel$export(module.exports, "mapLeft", function () { return $44013bf989d6fb13$export$472de43a55e4aa49; });
$parcel$export(module.exports, "Bifunctor", function () { return $44013bf989d6fb13$export$fd0fe42029639505; });
$parcel$export(module.exports, "Semigroupoid", function () { return $44013bf989d6fb13$export$67666a3fb7d250d8; });
$parcel$export(module.exports, "Comonad", function () { return $44013bf989d6fb13$export$fdd73124b9f1de36; });
$parcel$export(module.exports, "Foldable", function () { return $44013bf989d6fb13$export$41404b31838667c9; });
$parcel$export(module.exports, "Traversable", function () { return $44013bf989d6fb13$export$a0202666c3bda011; });
$parcel$export(module.exports, "readonlyTuple", function () { return $44013bf989d6fb13$export$48e131e4e1ae6412; });

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");
function $44013bf989d6fb13$export$9e770fa6ce19a9d6(ea) {
    return ea[0];
}
function $44013bf989d6fb13$export$6f71268a1666ab58(ea) {
    return ea[1];
}
var $44013bf989d6fb13$export$b0e76d9850c64156 = function(ea) {
    return [
        $44013bf989d6fb13$export$6f71268a1666ab58(ea),
        $44013bf989d6fb13$export$9e770fa6ce19a9d6(ea)
    ];
};
function $44013bf989d6fb13$export$81090df2aa47ff12(S) {
    return {
        URI: $44013bf989d6fb13$export$9156e739aa33e19f,
        _E: undefined,
        map: $44013bf989d6fb13$var$_map,
        ap: function(fab, fa) {
            return [
                $44013bf989d6fb13$export$9e770fa6ce19a9d6(fab)($44013bf989d6fb13$export$9e770fa6ce19a9d6(fa)),
                S.concat($44013bf989d6fb13$export$6f71268a1666ab58(fab), $44013bf989d6fb13$export$6f71268a1666ab58(fa))
            ];
        }
    };
}
var $44013bf989d6fb13$var$of = function(M) {
    return function(a) {
        return [
            a,
            M.empty
        ];
    };
};
function $44013bf989d6fb13$export$1402880adb2295a7(M) {
    var A = $44013bf989d6fb13$export$81090df2aa47ff12(M);
    return {
        URI: $44013bf989d6fb13$export$9156e739aa33e19f,
        _E: undefined,
        map: $44013bf989d6fb13$var$_map,
        ap: A.ap,
        of: $44013bf989d6fb13$var$of(M)
    };
}
function $44013bf989d6fb13$export$f4608058c83a1dc2(S) {
    var A = $44013bf989d6fb13$export$81090df2aa47ff12(S);
    return {
        URI: $44013bf989d6fb13$export$9156e739aa33e19f,
        _E: undefined,
        map: $44013bf989d6fb13$var$_map,
        ap: A.ap,
        chain: function(ma, f) {
            var _a = f($44013bf989d6fb13$export$9e770fa6ce19a9d6(ma)), b = _a[0], s = _a[1];
            return [
                b,
                S.concat($44013bf989d6fb13$export$6f71268a1666ab58(ma), s)
            ];
        }
    };
}
function $44013bf989d6fb13$export$a024c9fefbcb9ced(M) {
    var C = $44013bf989d6fb13$export$f4608058c83a1dc2(M);
    return {
        URI: $44013bf989d6fb13$export$9156e739aa33e19f,
        _E: undefined,
        map: $44013bf989d6fb13$var$_map,
        ap: C.ap,
        chain: C.chain,
        of: $44013bf989d6fb13$var$of(M)
    };
}
function $44013bf989d6fb13$export$4bab931e633547e6(M) {
    var chainRec = function(a, f) {
        var result = f(a);
        var acc = M.empty;
        var s = $44013bf989d6fb13$export$9e770fa6ce19a9d6(result);
        while(s._tag === 'Left'){
            acc = M.concat(acc, $44013bf989d6fb13$export$6f71268a1666ab58(result));
            result = f(s.left);
            s = $44013bf989d6fb13$export$9e770fa6ce19a9d6(result);
        }
        return [
            s.right,
            M.concat(acc, $44013bf989d6fb13$export$6f71268a1666ab58(result))
        ];
    };
    var C = $44013bf989d6fb13$export$f4608058c83a1dc2(M);
    return {
        URI: $44013bf989d6fb13$export$9156e739aa33e19f,
        _E: undefined,
        map: $44013bf989d6fb13$var$_map,
        ap: C.ap,
        chain: C.chain,
        chainRec: chainRec
    };
}
/* istanbul ignore next */ var $44013bf989d6fb13$var$_compose = function(bc, ab) {
    return (0, $kj6DU.pipe)(bc, $44013bf989d6fb13$export$f672e0b6f7222cd7(ab));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $44013bf989d6fb13$export$b1cdc73ee064e0df(f));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_bimap = function(fa, f, g) {
    return (0, $kj6DU.pipe)(fa, $44013bf989d6fb13$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_mapLeft = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $44013bf989d6fb13$export$96c3d3b04ed42b1c(f));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_extend = function(wa, f) {
    return (0, $kj6DU.pipe)(wa, $44013bf989d6fb13$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_reduce = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $44013bf989d6fb13$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_foldMap = function(M) {
    var foldMapM = $44013bf989d6fb13$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $kj6DU.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_reduceRight = function(fa, b, f) {
    return (0, $kj6DU.pipe)(fa, $44013bf989d6fb13$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $44013bf989d6fb13$var$_traverse = function(F) {
    var traverseF = $44013bf989d6fb13$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $kj6DU.pipe)(ta, traverseF(f));
    };
};
var $44013bf989d6fb13$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return [
            g($44013bf989d6fb13$export$9e770fa6ce19a9d6(fa)),
            f($44013bf989d6fb13$export$6f71268a1666ab58(fa))
        ];
    };
};
var $44013bf989d6fb13$export$b1cdc73ee064e0df = function(f) {
    return function(fa) {
        return [
            f($44013bf989d6fb13$export$9e770fa6ce19a9d6(fa)),
            $44013bf989d6fb13$export$6f71268a1666ab58(fa)
        ];
    };
};
var $44013bf989d6fb13$export$96c3d3b04ed42b1c = function(f) {
    return function(fa) {
        return [
            $44013bf989d6fb13$export$9e770fa6ce19a9d6(fa),
            f($44013bf989d6fb13$export$6f71268a1666ab58(fa))
        ];
    };
};
var $44013bf989d6fb13$export$f672e0b6f7222cd7 = function(ab) {
    return function(bc) {
        return [
            $44013bf989d6fb13$export$9e770fa6ce19a9d6(bc),
            $44013bf989d6fb13$export$6f71268a1666ab58(ab)
        ];
    };
};
var $44013bf989d6fb13$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return [
            f(wa),
            $44013bf989d6fb13$export$6f71268a1666ab58(wa)
        ];
    };
};
var $44013bf989d6fb13$export$f9380c9a627682d3 = $44013bf989d6fb13$export$9e770fa6ce19a9d6;
var $44013bf989d6fb13$export$ecd5e8ace626722c = /*#__PURE__*/ $44013bf989d6fb13$export$8b58be045bf06082((0, $kj6DU.identity));
var $44013bf989d6fb13$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return f(b, $44013bf989d6fb13$export$9e770fa6ce19a9d6(fa));
    };
};
var $44013bf989d6fb13$export$b66cdc0497d8a99a = function() {
    return function(f) {
        return function(fa) {
            return f($44013bf989d6fb13$export$9e770fa6ce19a9d6(fa));
        };
    };
};
var $44013bf989d6fb13$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return f($44013bf989d6fb13$export$9e770fa6ce19a9d6(fa), b);
    };
};
var $44013bf989d6fb13$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return F.map(f($44013bf989d6fb13$export$9e770fa6ce19a9d6(ta)), function(b) {
                return [
                    b,
                    $44013bf989d6fb13$export$6f71268a1666ab58(ta)
                ];
            });
        };
    };
};
var $44013bf989d6fb13$export$49bb65c2ea163039 = function(F) {
    return function(fas) {
        return F.map($44013bf989d6fb13$export$9e770fa6ce19a9d6(fas), function(a) {
            return [
                a,
                $44013bf989d6fb13$export$6f71268a1666ab58(fas)
            ];
        });
    };
};
var $44013bf989d6fb13$export$9156e739aa33e19f = 'ReadonlyTuple';
var $44013bf989d6fb13$export$bd5b6bfc5fa2ee61 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    map: $44013bf989d6fb13$var$_map
};
var $44013bf989d6fb13$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($44013bf989d6fb13$export$bd5b6bfc5fa2ee61);
var $44013bf989d6fb13$export$871de8747c9eaa88 = $44013bf989d6fb13$export$b1cdc73ee064e0df;
var $44013bf989d6fb13$export$472de43a55e4aa49 = $44013bf989d6fb13$export$96c3d3b04ed42b1c;
var $44013bf989d6fb13$export$fd0fe42029639505 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    bimap: $44013bf989d6fb13$var$_bimap,
    mapLeft: $44013bf989d6fb13$var$_mapLeft
};
var $44013bf989d6fb13$export$67666a3fb7d250d8 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    compose: $44013bf989d6fb13$var$_compose
};
var $44013bf989d6fb13$export$fdd73124b9f1de36 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    map: $44013bf989d6fb13$var$_map,
    extend: $44013bf989d6fb13$var$_extend,
    extract: $44013bf989d6fb13$export$f9380c9a627682d3
};
var $44013bf989d6fb13$export$41404b31838667c9 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    reduce: $44013bf989d6fb13$var$_reduce,
    foldMap: $44013bf989d6fb13$var$_foldMap,
    reduceRight: $44013bf989d6fb13$var$_reduceRight
};
var $44013bf989d6fb13$export$a0202666c3bda011 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    map: $44013bf989d6fb13$var$_map,
    reduce: $44013bf989d6fb13$var$_reduce,
    foldMap: $44013bf989d6fb13$var$_foldMap,
    reduceRight: $44013bf989d6fb13$var$_reduceRight,
    traverse: $44013bf989d6fb13$var$_traverse,
    sequence: $44013bf989d6fb13$export$49bb65c2ea163039
};
var $44013bf989d6fb13$export$48e131e4e1ae6412 = {
    URI: $44013bf989d6fb13$export$9156e739aa33e19f,
    compose: $44013bf989d6fb13$var$_compose,
    map: $44013bf989d6fb13$var$_map,
    bimap: $44013bf989d6fb13$var$_bimap,
    mapLeft: $44013bf989d6fb13$var$_mapLeft,
    extract: $44013bf989d6fb13$export$f9380c9a627682d3,
    extend: $44013bf989d6fb13$var$_extend,
    reduce: $44013bf989d6fb13$var$_reduce,
    foldMap: $44013bf989d6fb13$var$_foldMap,
    reduceRight: $44013bf989d6fb13$var$_reduceRight,
    traverse: $44013bf989d6fb13$var$_traverse,
    sequence: $44013bf989d6fb13$export$49bb65c2ea163039
};

});

parcelRegister("5fNnZ", function(module, exports) {

$parcel$export(module.exports, "fromIO", function () { return $3d34a975a3c0c7aa$export$d529793c7ff048a8; });
$parcel$export(module.exports, "delay", function () { return $3d34a975a3c0c7aa$export$1391212d75b2ee65; });
$parcel$export(module.exports, "map", function () { return $3d34a975a3c0c7aa$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $3d34a975a3c0c7aa$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $3d34a975a3c0c7aa$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "of", function () { return $3d34a975a3c0c7aa$export$ba255e9e49e00608; });
$parcel$export(module.exports, "flatten", function () { return $3d34a975a3c0c7aa$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "URI", function () { return $3d34a975a3c0c7aa$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getRaceMonoid", function () { return $3d34a975a3c0c7aa$export$2376659cd8d5a91f; });
$parcel$export(module.exports, "never", function () { return $3d34a975a3c0c7aa$export$b3e22bcfd64c1022; });
$parcel$export(module.exports, "Functor", function () { return $3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $3d34a975a3c0c7aa$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $3d34a975a3c0c7aa$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $3d34a975a3c0c7aa$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $3d34a975a3c0c7aa$export$59a71046037e6c20; });
$parcel$export(module.exports, "ApplyPar", function () { return $3d34a975a3c0c7aa$export$e825dd8dbbdc0410; });
$parcel$export(module.exports, "apFirst", function () { return $3d34a975a3c0c7aa$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apSecond", function () { return $3d34a975a3c0c7aa$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "ApplicativePar", function () { return $3d34a975a3c0c7aa$export$11b888901d89cc2; });
$parcel$export(module.exports, "ApplySeq", function () { return $3d34a975a3c0c7aa$export$60f1052cde3ba705; });
$parcel$export(module.exports, "ApplicativeSeq", function () { return $3d34a975a3c0c7aa$export$9c23f2f51a58ba10; });
$parcel$export(module.exports, "Chain", function () { return $3d34a975a3c0c7aa$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $3d34a975a3c0c7aa$export$fb641926d034ac7d; });
$parcel$export(module.exports, "MonadIO", function () { return $3d34a975a3c0c7aa$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "fromTask", function () { return $3d34a975a3c0c7aa$export$b13b747e271beee9; });
$parcel$export(module.exports, "MonadTask", function () { return $3d34a975a3c0c7aa$export$ddc01897af104624; });
$parcel$export(module.exports, "FromIO", function () { return $3d34a975a3c0c7aa$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "flatMapIO", function () { return $3d34a975a3c0c7aa$export$8b635ef81222764c; });
$parcel$export(module.exports, "tap", function () { return $3d34a975a3c0c7aa$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapIO", function () { return $3d34a975a3c0c7aa$export$5bf3b8929fda1158; });
$parcel$export(module.exports, "fromIOK", function () { return $3d34a975a3c0c7aa$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "chainIOK", function () { return $3d34a975a3c0c7aa$export$dbedca339774a859; });
$parcel$export(module.exports, "chainFirstIOK", function () { return $3d34a975a3c0c7aa$export$5148ef8785cce359; });
$parcel$export(module.exports, "FromTask", function () { return $3d34a975a3c0c7aa$export$e86019a4d2fb9384; });
$parcel$export(module.exports, "Do", function () { return $3d34a975a3c0c7aa$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $3d34a975a3c0c7aa$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $3d34a975a3c0c7aa$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $3d34a975a3c0c7aa$export$2385a24977818dd0; });
$parcel$export(module.exports, "apS", function () { return $3d34a975a3c0c7aa$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "ApT", function () { return $3d34a975a3c0c7aa$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $3d34a975a3c0c7aa$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $3d34a975a3c0c7aa$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndexSeq", function () { return $3d34a975a3c0c7aa$export$ccd1b7252ef04791; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndexSeq", function () { return $3d34a975a3c0c7aa$export$674043f9db4279c7; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $3d34a975a3c0c7aa$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $3d34a975a3c0c7aa$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $3d34a975a3c0c7aa$export$d330b60315c14cd1; });
$parcel$export(module.exports, "traverseSeqArrayWithIndex", function () { return $3d34a975a3c0c7aa$export$6702e2a63712b0a0; });
$parcel$export(module.exports, "traverseSeqArray", function () { return $3d34a975a3c0c7aa$export$5932486b5125ca68; });
$parcel$export(module.exports, "sequenceSeqArray", function () { return $3d34a975a3c0c7aa$export$5e316684572fbbb6; });
$parcel$export(module.exports, "chain", function () { return $3d34a975a3c0c7aa$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainFirst", function () { return $3d34a975a3c0c7aa$export$e3821ef4970c339c; });
$parcel$export(module.exports, "task", function () { return $3d34a975a3c0c7aa$export$94e939b87ca64fb4; });
$parcel$export(module.exports, "taskSeq", function () { return $3d34a975a3c0c7aa$export$c1b89e6e7c80c0d4; });
$parcel$export(module.exports, "getSemigroup", function () { return $3d34a975a3c0c7aa$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getMonoid", function () { return $3d34a975a3c0c7aa$export$c2a7ef2cc9b32b31; });
/**
 * ```ts
 * interface Task<A> {
 *   (): Promise<A>
 * }
 * ```
 *
 * `Task<A>` represents an asynchronous computation that yields a value of type `A` and **never fails**.
 * If you want to represent an asynchronous computation that may fail, please see `TaskEither`.
 *
 * @since 2.0.0
 */ 
var $dYcKb = parcelRequire("dYcKb");

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $bmbrn = parcelRequire("bmbrn");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");
var $3d34a975a3c0c7aa$export$d529793c7ff048a8 = function(ma) {
    return function() {
        return Promise.resolve().then(ma);
    };
};
function $3d34a975a3c0c7aa$export$1391212d75b2ee65(millis) {
    return function(ma) {
        return function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    Promise.resolve().then(ma).then(resolve);
                }, millis);
            });
        };
    };
}
var $3d34a975a3c0c7aa$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $3d34a975a3c0c7aa$export$871de8747c9eaa88(f));
};
var $3d34a975a3c0c7aa$var$_apPar = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $3d34a975a3c0c7aa$export$2f6ca3d3b1f80bf5(fa));
};
var $3d34a975a3c0c7aa$var$_apSeq = function(fab, fa) {
    return $3d34a975a3c0c7aa$export$5b8affa63fc6df16(fab, function(f) {
        return (0, $kj6DU.pipe)(fa, $3d34a975a3c0c7aa$export$871de8747c9eaa88(f));
    });
};
var $3d34a975a3c0c7aa$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return function() {
            return Promise.resolve().then(fa).then(f);
        };
    };
};
var $3d34a975a3c0c7aa$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return function() {
            return Promise.all([
                Promise.resolve().then(fab),
                Promise.resolve().then(fa)
            ]).then(function(_a) {
                var f = _a[0], a = _a[1];
                return f(a);
            });
        };
    };
};
var $3d34a975a3c0c7aa$export$ba255e9e49e00608 = function(a) {
    return function() {
        return Promise.resolve(a);
    };
};
var $3d34a975a3c0c7aa$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(ma, f) {
    return function() {
        return Promise.resolve().then(ma).then(function(a) {
            return f(a)();
        });
    };
});
var $3d34a975a3c0c7aa$export$bffa455ba8c619a6 = /*#__PURE__*/ $3d34a975a3c0c7aa$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $3d34a975a3c0c7aa$export$9156e739aa33e19f = 'Task';
function $3d34a975a3c0c7aa$export$2376659cd8d5a91f() {
    return {
        concat: function(x, y) {
            return function() {
                return Promise.race([
                    Promise.resolve().then(x),
                    Promise.resolve().then(y)
                ]);
            };
        },
        empty: $3d34a975a3c0c7aa$export$b3e22bcfd64c1022
    };
}
var $3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map
};
var $3d34a975a3c0c7aa$export$6554612db691658e = (0, $kj6DU.dual)(2, (0, $6baua.as)($3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61));
var $3d34a975a3c0c7aa$export$9284b360ca18a0fd = (0, $6baua.asUnit)($3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61);
var $3d34a975a3c0c7aa$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61);
var $3d34a975a3c0c7aa$export$59a71046037e6c20 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608
};
var $3d34a975a3c0c7aa$export$e825dd8dbbdc0410 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    ap: $3d34a975a3c0c7aa$var$_apPar
};
var $3d34a975a3c0c7aa$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($3d34a975a3c0c7aa$export$e825dd8dbbdc0410);
var $3d34a975a3c0c7aa$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($3d34a975a3c0c7aa$export$e825dd8dbbdc0410);
var $3d34a975a3c0c7aa$export$11b888901d89cc2 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    ap: $3d34a975a3c0c7aa$var$_apPar,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608
};
var $3d34a975a3c0c7aa$export$60f1052cde3ba705 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    ap: $3d34a975a3c0c7aa$var$_apSeq
};
var $3d34a975a3c0c7aa$export$9c23f2f51a58ba10 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    ap: $3d34a975a3c0c7aa$var$_apSeq,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608
};
var $3d34a975a3c0c7aa$export$f18d5acc27d70423 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    ap: $3d34a975a3c0c7aa$var$_apPar,
    chain: $3d34a975a3c0c7aa$export$5b8affa63fc6df16
};
var $3d34a975a3c0c7aa$export$fb641926d034ac7d = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608,
    ap: $3d34a975a3c0c7aa$var$_apPar,
    chain: $3d34a975a3c0c7aa$export$5b8affa63fc6df16
};
var $3d34a975a3c0c7aa$export$dc43ee6ccf36ad90 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608,
    ap: $3d34a975a3c0c7aa$var$_apPar,
    chain: $3d34a975a3c0c7aa$export$5b8affa63fc6df16,
    fromIO: $3d34a975a3c0c7aa$export$d529793c7ff048a8
};
var $3d34a975a3c0c7aa$export$b13b747e271beee9 = (0, $kj6DU.identity);
var $3d34a975a3c0c7aa$export$ddc01897af104624 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608,
    ap: $3d34a975a3c0c7aa$var$_apPar,
    chain: $3d34a975a3c0c7aa$export$5b8affa63fc6df16,
    fromIO: $3d34a975a3c0c7aa$export$d529793c7ff048a8,
    fromTask: $3d34a975a3c0c7aa$export$b13b747e271beee9
};
var $3d34a975a3c0c7aa$export$978d37ea2fe360cf = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    fromIO: $3d34a975a3c0c7aa$export$d529793c7ff048a8
};
/** @internal */ var $3d34a975a3c0c7aa$var$_FlatMap = {
    flatMap: $3d34a975a3c0c7aa$export$5b8affa63fc6df16
};
/** @internal */ var $3d34a975a3c0c7aa$var$_FromIO = {
    fromIO: $3d34a975a3c0c7aa$export$978d37ea2fe360cf.fromIO
};
var $3d34a975a3c0c7aa$export$8b635ef81222764c = $lOGTm.flatMapIO($3d34a975a3c0c7aa$var$_FromIO, $3d34a975a3c0c7aa$var$_FlatMap);
var $3d34a975a3c0c7aa$export$3f23594af5f37336 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dya6d.tap($3d34a975a3c0c7aa$export$f18d5acc27d70423));
var $3d34a975a3c0c7aa$export$5bf3b8929fda1158 = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $bmbrn.tapIO)($3d34a975a3c0c7aa$export$978d37ea2fe360cf, $3d34a975a3c0c7aa$export$f18d5acc27d70423));
var $3d34a975a3c0c7aa$export$9d3fcca17a044a16 = /*#__PURE__*/ (0, $bmbrn.fromIOK)($3d34a975a3c0c7aa$export$978d37ea2fe360cf);
var $3d34a975a3c0c7aa$export$dbedca339774a859 = $3d34a975a3c0c7aa$export$8b635ef81222764c;
var $3d34a975a3c0c7aa$export$5148ef8785cce359 = $3d34a975a3c0c7aa$export$5bf3b8929fda1158;
var $3d34a975a3c0c7aa$export$e86019a4d2fb9384 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    fromIO: $3d34a975a3c0c7aa$export$d529793c7ff048a8,
    fromTask: $3d34a975a3c0c7aa$export$b13b747e271beee9
};
var $3d34a975a3c0c7aa$export$b3e22bcfd64c1022 = function() {
    return new Promise(function(_) {
        return undefined;
    });
};
var $3d34a975a3c0c7aa$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $3d34a975a3c0c7aa$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $3d34a975a3c0c7aa$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61);
var $3d34a975a3c0c7aa$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($3d34a975a3c0c7aa$export$bd5b6bfc5fa2ee61);
var $3d34a975a3c0c7aa$export$2385a24977818dd0 = /*#__PURE__*/ $dya6d.bind($3d34a975a3c0c7aa$export$f18d5acc27d70423);
var $3d34a975a3c0c7aa$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($3d34a975a3c0c7aa$export$e825dd8dbbdc0410);
var $3d34a975a3c0c7aa$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $3d34a975a3c0c7aa$export$ba255e9e49e00608($lOGTm.emptyReadonlyArray);
var $3d34a975a3c0c7aa$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        return function() {
            return Promise.all(as.map(function(a, i) {
                return Promise.resolve().then(function() {
                    return f(i, a)();
                });
            }));
        };
    };
};
var $3d34a975a3c0c7aa$export$d4e79db5dc14cc1 = function(f) {
    var g = $3d34a975a3c0c7aa$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $3d34a975a3c0c7aa$export$c74b6e34b2b6efb0;
    };
};
var $3d34a975a3c0c7aa$export$ccd1b7252ef04791 = function(f) {
    return function(as) {
        return function() {
            return $lOGTm.tail(as).reduce(function(acc, a, i) {
                return acc.then(function(bs) {
                    return Promise.resolve().then(f(i + 1, a)).then(function(b) {
                        bs.push(b);
                        return bs;
                    });
                });
            }, Promise.resolve().then(f(0, $lOGTm.head(as))).then($lOGTm.singleton));
        };
    };
};
var $3d34a975a3c0c7aa$export$674043f9db4279c7 = function(f) {
    var g = $3d34a975a3c0c7aa$export$ccd1b7252ef04791(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $3d34a975a3c0c7aa$export$c74b6e34b2b6efb0;
    };
};
var $3d34a975a3c0c7aa$export$104a2841e9cbad06 = $3d34a975a3c0c7aa$export$d4e79db5dc14cc1;
var $3d34a975a3c0c7aa$export$64f39b2a2b79e1b1 = function(f) {
    return $3d34a975a3c0c7aa$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $3d34a975a3c0c7aa$export$d330b60315c14cd1 = /*#__PURE__*/ $3d34a975a3c0c7aa$export$64f39b2a2b79e1b1((0, $kj6DU.identity));
var $3d34a975a3c0c7aa$export$6702e2a63712b0a0 = $3d34a975a3c0c7aa$export$674043f9db4279c7;
var $3d34a975a3c0c7aa$export$5932486b5125ca68 = function(f) {
    return $3d34a975a3c0c7aa$export$674043f9db4279c7(function(_, a) {
        return f(a);
    });
};
var $3d34a975a3c0c7aa$export$5e316684572fbbb6 = /*#__PURE__*/ $3d34a975a3c0c7aa$export$5932486b5125ca68((0, $kj6DU.identity));
var $3d34a975a3c0c7aa$export$e08e3b67e392101e = $3d34a975a3c0c7aa$export$5b8affa63fc6df16;
var $3d34a975a3c0c7aa$export$e3821ef4970c339c = $3d34a975a3c0c7aa$export$3f23594af5f37336;
var $3d34a975a3c0c7aa$export$94e939b87ca64fb4 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608,
    ap: $3d34a975a3c0c7aa$var$_apPar,
    chain: $3d34a975a3c0c7aa$export$5b8affa63fc6df16,
    fromIO: $3d34a975a3c0c7aa$export$d529793c7ff048a8,
    fromTask: $3d34a975a3c0c7aa$export$b13b747e271beee9
};
var $3d34a975a3c0c7aa$export$c1b89e6e7c80c0d4 = {
    URI: $3d34a975a3c0c7aa$export$9156e739aa33e19f,
    map: $3d34a975a3c0c7aa$var$_map,
    of: $3d34a975a3c0c7aa$export$ba255e9e49e00608,
    ap: $3d34a975a3c0c7aa$var$_apSeq,
    chain: $3d34a975a3c0c7aa$export$5b8affa63fc6df16,
    fromIO: $3d34a975a3c0c7aa$export$d529793c7ff048a8,
    fromTask: $3d34a975a3c0c7aa$export$b13b747e271beee9
};
var $3d34a975a3c0c7aa$export$e759a9a7f8d04692 = /*#__PURE__*/ (0, $j7Bi0.getApplySemigroup)($3d34a975a3c0c7aa$export$60f1052cde3ba705);
var $3d34a975a3c0c7aa$export$c2a7ef2cc9b32b31 = /*#__PURE__*/ (0, $dYcKb.getApplicativeMonoid)($3d34a975a3c0c7aa$export$9c23f2f51a58ba10);

});

parcelRegister("aXpTF", function(module, exports) {

$parcel$export(module.exports, "left", function () { return $7fa380a0ada83f69$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "right", function () { return $7fa380a0ada83f69$export$79ffe56a765070d2; });
$parcel$export(module.exports, "rightTask", function () { return $7fa380a0ada83f69$export$f0188b620f44372a; });
$parcel$export(module.exports, "leftTask", function () { return $7fa380a0ada83f69$export$41a4940678f22127; });
$parcel$export(module.exports, "rightIO", function () { return $7fa380a0ada83f69$export$c1cd2021ce1d7fcb; });
$parcel$export(module.exports, "leftIO", function () { return $7fa380a0ada83f69$export$9d86f0a38eb969ef; });
$parcel$export(module.exports, "fromIO", function () { return $7fa380a0ada83f69$export$d529793c7ff048a8; });
$parcel$export(module.exports, "fromTask", function () { return $7fa380a0ada83f69$export$b13b747e271beee9; });
$parcel$export(module.exports, "fromEither", function () { return $7fa380a0ada83f69$export$80c878c9b1d77917; });
$parcel$export(module.exports, "fromIOEither", function () { return $7fa380a0ada83f69$export$9b09e19fe882abba; });
$parcel$export(module.exports, "fromTaskOption", function () { return $7fa380a0ada83f69$export$691693e0bdd7c0dc; });
$parcel$export(module.exports, "match", function () { return $7fa380a0ada83f69$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchW", function () { return $7fa380a0ada83f69$export$2d55ea551c238330; });
$parcel$export(module.exports, "matchE", function () { return $7fa380a0ada83f69$export$398621f19e0a7e4; });
$parcel$export(module.exports, "fold", function () { return $7fa380a0ada83f69$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "matchEW", function () { return $7fa380a0ada83f69$export$85ac45300d10b517; });
$parcel$export(module.exports, "foldW", function () { return $7fa380a0ada83f69$export$ccb09033cefa61e8; });
$parcel$export(module.exports, "getOrElse", function () { return $7fa380a0ada83f69$export$8832081647a02ee7; });
$parcel$export(module.exports, "getOrElseW", function () { return $7fa380a0ada83f69$export$d8a997ff0e6436f3; });
$parcel$export(module.exports, "tryCatch", function () { return $7fa380a0ada83f69$export$d234c058d1d4e435; });
$parcel$export(module.exports, "tryCatchK", function () { return $7fa380a0ada83f69$export$7f3d23c4b0794e72; });
$parcel$export(module.exports, "toUnion", function () { return $7fa380a0ada83f69$export$a0886ed3a572729f; });
$parcel$export(module.exports, "fromNullable", function () { return $7fa380a0ada83f69$export$b601f49376b4621a; });
$parcel$export(module.exports, "fromNullableK", function () { return $7fa380a0ada83f69$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $7fa380a0ada83f69$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "orElse", function () { return $7fa380a0ada83f69$export$41d1a04d78e7b141; });
$parcel$export(module.exports, "orElseW", function () { return $7fa380a0ada83f69$export$efd845e0c87089a6; });
$parcel$export(module.exports, "tapError", function () { return $7fa380a0ada83f69$export$f297679585c88732; });
$parcel$export(module.exports, "orElseFirstIOK", function () { return $7fa380a0ada83f69$export$91e9d1839ed8da93; });
$parcel$export(module.exports, "fromIOK", function () { return $7fa380a0ada83f69$export$9d3fcca17a044a16; });
$parcel$export(module.exports, "orElseFirstTaskK", function () { return $7fa380a0ada83f69$export$85b9777d93691bbc; });
$parcel$export(module.exports, "fromTaskK", function () { return $7fa380a0ada83f69$export$bb6009cf24290313; });
$parcel$export(module.exports, "orLeft", function () { return $7fa380a0ada83f69$export$e84f0fd7f5bcfbf0; });
$parcel$export(module.exports, "swap", function () { return $7fa380a0ada83f69$export$b0e76d9850c64156; });
$parcel$export(module.exports, "fromTaskOptionK", function () { return $7fa380a0ada83f69$export$f956926575b25f94; });
$parcel$export(module.exports, "chainTaskOptionKW", function () { return $7fa380a0ada83f69$export$cc18a684c8cb422d; });
$parcel$export(module.exports, "flatMap", function () { return $7fa380a0ada83f69$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "chainTaskOptionK", function () { return $7fa380a0ada83f69$export$a344f5448340a4a7; });
$parcel$export(module.exports, "fromIOEitherK", function () { return $7fa380a0ada83f69$export$6f981aca7fb40299; });
$parcel$export(module.exports, "map", function () { return $7fa380a0ada83f69$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $7fa380a0ada83f69$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "alt", function () { return $7fa380a0ada83f69$export$228be17d80722ab; });
$parcel$export(module.exports, "mapBoth", function () { return $7fa380a0ada83f69$export$2ab19f8a7e145f0a; });
$parcel$export(module.exports, "bimap", function () { return $7fa380a0ada83f69$export$eb54baf0b342cb1d; });
$parcel$export(module.exports, "mapError", function () { return $7fa380a0ada83f69$export$d0f6f6f8d08fe167; });
$parcel$export(module.exports, "mapLeft", function () { return $7fa380a0ada83f69$export$472de43a55e4aa49; });
$parcel$export(module.exports, "apW", function () { return $7fa380a0ada83f69$export$321be6e231de8eac; });
$parcel$export(module.exports, "flattenW", function () { return $7fa380a0ada83f69$export$2409099f1fc434fb; });
$parcel$export(module.exports, "flatten", function () { return $7fa380a0ada83f69$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "altW", function () { return $7fa380a0ada83f69$export$1517cca7889d6aaa; });
$parcel$export(module.exports, "of", function () { return $7fa380a0ada83f69$export$ba255e9e49e00608; });
$parcel$export(module.exports, "throwError", function () { return $7fa380a0ada83f69$export$8bf7aba4a9e09055; });
$parcel$export(module.exports, "URI", function () { return $7fa380a0ada83f69$export$9156e739aa33e19f; });
$parcel$export(module.exports, "getApplicativeTaskValidation", function () { return $7fa380a0ada83f69$export$f55d048c8c810adb; });
$parcel$export(module.exports, "getAltTaskValidation", function () { return $7fa380a0ada83f69$export$93b1fc7a429347dc; });
$parcel$export(module.exports, "getCompactable", function () { return $7fa380a0ada83f69$export$cfae3069ac05ff4c; });
$parcel$export(module.exports, "getFilterable", function () { return $7fa380a0ada83f69$export$a4e870b0a57ec14e; });
$parcel$export(module.exports, "Functor", function () { return $7fa380a0ada83f69$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "as", function () { return $7fa380a0ada83f69$export$6554612db691658e; });
$parcel$export(module.exports, "asUnit", function () { return $7fa380a0ada83f69$export$9284b360ca18a0fd; });
$parcel$export(module.exports, "flap", function () { return $7fa380a0ada83f69$export$18c957606d8bdf09; });
$parcel$export(module.exports, "Pointed", function () { return $7fa380a0ada83f69$export$59a71046037e6c20; });
$parcel$export(module.exports, "ApplyPar", function () { return $7fa380a0ada83f69$export$e825dd8dbbdc0410; });
$parcel$export(module.exports, "apFirst", function () { return $7fa380a0ada83f69$export$5f28d9feedcfd46e; });
$parcel$export(module.exports, "apFirstW", function () { return $7fa380a0ada83f69$export$ac044f4aa9961a4f; });
$parcel$export(module.exports, "apSecond", function () { return $7fa380a0ada83f69$export$ed01bc59c3d06bf3; });
$parcel$export(module.exports, "apSecondW", function () { return $7fa380a0ada83f69$export$8a00020751233172; });
$parcel$export(module.exports, "ApplicativePar", function () { return $7fa380a0ada83f69$export$11b888901d89cc2; });
$parcel$export(module.exports, "ApplySeq", function () { return $7fa380a0ada83f69$export$60f1052cde3ba705; });
$parcel$export(module.exports, "ApplicativeSeq", function () { return $7fa380a0ada83f69$export$9c23f2f51a58ba10; });
$parcel$export(module.exports, "Chain", function () { return $7fa380a0ada83f69$export$f18d5acc27d70423; });
$parcel$export(module.exports, "Monad", function () { return $7fa380a0ada83f69$export$fb641926d034ac7d; });
$parcel$export(module.exports, "MonadIO", function () { return $7fa380a0ada83f69$export$dc43ee6ccf36ad90; });
$parcel$export(module.exports, "MonadTask", function () { return $7fa380a0ada83f69$export$ddc01897af104624; });
$parcel$export(module.exports, "MonadThrow", function () { return $7fa380a0ada83f69$export$5f956d47d0619c3a; });
$parcel$export(module.exports, "FromEither", function () { return $7fa380a0ada83f69$export$825ea6cb6fc48d49; });
$parcel$export(module.exports, "FromIO", function () { return $7fa380a0ada83f69$export$978d37ea2fe360cf; });
$parcel$export(module.exports, "FromTask", function () { return $7fa380a0ada83f69$export$e86019a4d2fb9384; });
$parcel$export(module.exports, "tap", function () { return $7fa380a0ada83f69$export$3f23594af5f37336; });
$parcel$export(module.exports, "tapEither", function () { return $7fa380a0ada83f69$export$be3ff275bb5a8ac9; });
$parcel$export(module.exports, "tapIO", function () { return $7fa380a0ada83f69$export$5bf3b8929fda1158; });
$parcel$export(module.exports, "tapTask", function () { return $7fa380a0ada83f69$export$a8701ebadf2e95ad; });
$parcel$export(module.exports, "Bifunctor", function () { return $7fa380a0ada83f69$export$fd0fe42029639505; });
$parcel$export(module.exports, "Alt", function () { return $7fa380a0ada83f69$export$25ba4469a069167; });
$parcel$export(module.exports, "fromOption", function () { return $7fa380a0ada83f69$export$172ec0a6ebfeb6fa; });
$parcel$export(module.exports, "fromOptionK", function () { return $7fa380a0ada83f69$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $7fa380a0ada83f69$export$12d26179deb6a68a; });
$parcel$export(module.exports, "chainOptionKW", function () { return $7fa380a0ada83f69$export$377cc334277e5c3c; });
$parcel$export(module.exports, "liftNullable", function () { return $7fa380a0ada83f69$export$cd139e14432f317b; });
$parcel$export(module.exports, "liftOption", function () { return $7fa380a0ada83f69$export$ea4a22f93200df79; });
$parcel$export(module.exports, "flatMapNullable", function () { return $7fa380a0ada83f69$export$1a0515933c5c84fe; });
$parcel$export(module.exports, "flatMapOption", function () { return $7fa380a0ada83f69$export$b5f02b7beb8ed7d8; });
$parcel$export(module.exports, "flatMapEither", function () { return $7fa380a0ada83f69$export$979f2bb6a976172d; });
$parcel$export(module.exports, "flatMapIO", function () { return $7fa380a0ada83f69$export$8b635ef81222764c; });
$parcel$export(module.exports, "flatMapTask", function () { return $7fa380a0ada83f69$export$43849ff3f7ffa51c; });
$parcel$export(module.exports, "flatMapIOEither", function () { return $7fa380a0ada83f69$export$7514610652fa62c0; });
$parcel$export(module.exports, "flatMapTaskOption", function () { return $7fa380a0ada83f69$export$bd2474f1d21e88eb; });
$parcel$export(module.exports, "chainEitherK", function () { return $7fa380a0ada83f69$export$a3eef2eba9908c3e; });
$parcel$export(module.exports, "chainEitherKW", function () { return $7fa380a0ada83f69$export$148e58f5a13b0a29; });
$parcel$export(module.exports, "chainFirstEitherK", function () { return $7fa380a0ada83f69$export$c5f2bdbf9b43f0c0; });
$parcel$export(module.exports, "chainFirstEitherKW", function () { return $7fa380a0ada83f69$export$3b38f8f4685eb1a8; });
$parcel$export(module.exports, "fromPredicate", function () { return $7fa380a0ada83f69$export$23f31c55d7162b91; });
$parcel$export(module.exports, "filterOrElse", function () { return $7fa380a0ada83f69$export$30af8ca9498ddf5b; });
$parcel$export(module.exports, "filterOrElseW", function () { return $7fa380a0ada83f69$export$84511cf4503ec9dd; });
$parcel$export(module.exports, "fromEitherK", function () { return $7fa380a0ada83f69$export$8138b0ae92c9b5d8; });
$parcel$export(module.exports, "chainIOK", function () { return $7fa380a0ada83f69$export$dbedca339774a859; });
$parcel$export(module.exports, "chainFirstIOK", function () { return $7fa380a0ada83f69$export$5148ef8785cce359; });
$parcel$export(module.exports, "chainTaskK", function () { return $7fa380a0ada83f69$export$9e593613eaf643aa; });
$parcel$export(module.exports, "chainFirstTaskK", function () { return $7fa380a0ada83f69$export$43e2f536f6b41427; });
$parcel$export(module.exports, "chainIOEitherKW", function () { return $7fa380a0ada83f69$export$fdc4db8624c799e8; });
$parcel$export(module.exports, "chainIOEitherK", function () { return $7fa380a0ada83f69$export$f596abf27dc7c7bd; });
$parcel$export(module.exports, "taskify", function () { return $7fa380a0ada83f69$export$9ff351a4cbab6799; });
$parcel$export(module.exports, "bracket", function () { return $7fa380a0ada83f69$export$df5598cc12b9c8c; });
$parcel$export(module.exports, "bracketW", function () { return $7fa380a0ada83f69$export$15093e5f950a635; });
$parcel$export(module.exports, "Do", function () { return $7fa380a0ada83f69$export$dfcca0b9d3f9c8f1; });
$parcel$export(module.exports, "bindTo", function () { return $7fa380a0ada83f69$export$7c052ae73f8acff0; });
$parcel$export(module.exports, "let", function () { return $7fa380a0ada83f69$export$5d537b797c421217; });
$parcel$export(module.exports, "bind", function () { return $7fa380a0ada83f69$export$2385a24977818dd0; });
$parcel$export(module.exports, "bindW", function () { return $7fa380a0ada83f69$export$e0d5b1cbe98976d9; });
$parcel$export(module.exports, "apS", function () { return $7fa380a0ada83f69$export$8cbfc0239f42bb49; });
$parcel$export(module.exports, "apSW", function () { return $7fa380a0ada83f69$export$5c01f27714264b3d; });
$parcel$export(module.exports, "ApT", function () { return $7fa380a0ada83f69$export$c74b6e34b2b6efb0; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndex", function () { return $7fa380a0ada83f69$export$817de7d5ba7e6fab; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndex", function () { return $7fa380a0ada83f69$export$d4e79db5dc14cc1; });
$parcel$export(module.exports, "traverseReadonlyNonEmptyArrayWithIndexSeq", function () { return $7fa380a0ada83f69$export$ccd1b7252ef04791; });
$parcel$export(module.exports, "traverseReadonlyArrayWithIndexSeq", function () { return $7fa380a0ada83f69$export$674043f9db4279c7; });
$parcel$export(module.exports, "traverseArrayWithIndex", function () { return $7fa380a0ada83f69$export$104a2841e9cbad06; });
$parcel$export(module.exports, "traverseArray", function () { return $7fa380a0ada83f69$export$64f39b2a2b79e1b1; });
$parcel$export(module.exports, "sequenceArray", function () { return $7fa380a0ada83f69$export$d330b60315c14cd1; });
$parcel$export(module.exports, "traverseSeqArrayWithIndex", function () { return $7fa380a0ada83f69$export$6702e2a63712b0a0; });
$parcel$export(module.exports, "traverseSeqArray", function () { return $7fa380a0ada83f69$export$5932486b5125ca68; });
$parcel$export(module.exports, "sequenceSeqArray", function () { return $7fa380a0ada83f69$export$5e316684572fbbb6; });
$parcel$export(module.exports, "chain", function () { return $7fa380a0ada83f69$export$e08e3b67e392101e; });
$parcel$export(module.exports, "chainW", function () { return $7fa380a0ada83f69$export$8e5885f0163d737a; });
$parcel$export(module.exports, "chainFirst", function () { return $7fa380a0ada83f69$export$e3821ef4970c339c; });
$parcel$export(module.exports, "chainFirstW", function () { return $7fa380a0ada83f69$export$5de78197fc44b933; });
$parcel$export(module.exports, "orElseFirst", function () { return $7fa380a0ada83f69$export$2705983cb222ac0a; });
$parcel$export(module.exports, "orElseFirstW", function () { return $7fa380a0ada83f69$export$d43d943be7ad7d62; });
$parcel$export(module.exports, "taskEither", function () { return $7fa380a0ada83f69$export$bf17ca9b48f5ebc2; });
$parcel$export(module.exports, "taskEitherSeq", function () { return $7fa380a0ada83f69$export$e669e08ee441ca6e; });
$parcel$export(module.exports, "getApplySemigroup", function () { return $7fa380a0ada83f69$export$18979a515d2a828e; });
$parcel$export(module.exports, "getApplyMonoid", function () { return $7fa380a0ada83f69$export$1b097547f7ec9bb3; });
$parcel$export(module.exports, "getSemigroup", function () { return $7fa380a0ada83f69$export$e759a9a7f8d04692; });
$parcel$export(module.exports, "getTaskValidation", function () { return $7fa380a0ada83f69$export$205c8c90abeec407; });

var $dYcKb = parcelRequire("dYcKb");

var $j7Bi0 = parcelRequire("j7Bi0");

var $dya6d = parcelRequire("dya6d");

var $eQAK7 = parcelRequire("eQAK7");

var $7Rbab = parcelRequire("7Rbab");

var $dpNXS = parcelRequire("dpNXS");

var $dHiDk = parcelRequire("dHiDk");

var $fgwhT = parcelRequire("fgwhT");

var $bmbrn = parcelRequire("bmbrn");

var $36y3L = parcelRequire("36y3L");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $5fNnZ = parcelRequire("5fNnZ");
var $7fa380a0ada83f69$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7fa380a0ada83f69$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7fa380a0ada83f69$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $dpNXS.left($5fNnZ.Pointed);
var $7fa380a0ada83f69$export$79ffe56a765070d2 = /*#__PURE__*/ $dpNXS.right($5fNnZ.Pointed);
var $7fa380a0ada83f69$export$f0188b620f44372a = /*#__PURE__*/ $dpNXS.rightF($5fNnZ.Functor);
var $7fa380a0ada83f69$export$41a4940678f22127 = /*#__PURE__*/ $dpNXS.leftF($5fNnZ.Functor);
var $7fa380a0ada83f69$export$c1cd2021ce1d7fcb = /*#__PURE__*/ (0, $kj6DU.flow)($5fNnZ.fromIO, $7fa380a0ada83f69$export$f0188b620f44372a);
var $7fa380a0ada83f69$export$9d86f0a38eb969ef = /*#__PURE__*/ (0, $kj6DU.flow)($5fNnZ.fromIO, $7fa380a0ada83f69$export$41a4940678f22127);
var $7fa380a0ada83f69$export$d529793c7ff048a8 = $7fa380a0ada83f69$export$c1cd2021ce1d7fcb;
var $7fa380a0ada83f69$export$b13b747e271beee9 = $7fa380a0ada83f69$export$f0188b620f44372a;
var $7fa380a0ada83f69$export$80c878c9b1d77917 = $5fNnZ.of;
var $7fa380a0ada83f69$export$9b09e19fe882abba = $5fNnZ.fromIO;
var $7fa380a0ada83f69$export$691693e0bdd7c0dc = function(onNone) {
    return $5fNnZ.map($7Rbab.fromOption(onNone));
};
var $7fa380a0ada83f69$export$4659b591c19bdf3d = /*#__PURE__*/ $dpNXS.match($5fNnZ.Functor);
var $7fa380a0ada83f69$export$2d55ea551c238330 = $7fa380a0ada83f69$export$4659b591c19bdf3d;
var $7fa380a0ada83f69$export$398621f19e0a7e4 = /*#__PURE__*/ $dpNXS.matchE($5fNnZ.Monad);
var $7fa380a0ada83f69$export$93e2b83da34ff82a = $7fa380a0ada83f69$export$398621f19e0a7e4;
var $7fa380a0ada83f69$export$85ac45300d10b517 = $7fa380a0ada83f69$export$398621f19e0a7e4;
var $7fa380a0ada83f69$export$ccb09033cefa61e8 = $7fa380a0ada83f69$export$85ac45300d10b517;
var $7fa380a0ada83f69$export$8832081647a02ee7 = /*#__PURE__*/ $dpNXS.getOrElse($5fNnZ.Monad);
var $7fa380a0ada83f69$export$d8a997ff0e6436f3 = $7fa380a0ada83f69$export$8832081647a02ee7;
var $7fa380a0ada83f69$export$d234c058d1d4e435 = function(f, onRejected) {
    return function() {
        return $7fa380a0ada83f69$var$__awaiter(void 0, void 0, void 0, function() {
            var reason_1;
            return $7fa380a0ada83f69$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            f().then($lOGTm.right)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        reason_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $lOGTm.left(onRejected(reason_1))
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $7fa380a0ada83f69$export$7f3d23c4b0794e72 = function(f, onRejected) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $7fa380a0ada83f69$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onRejected);
    };
};
var $7fa380a0ada83f69$export$a0886ed3a572729f = /*#__PURE__*/ $dpNXS.toUnion($5fNnZ.Functor);
var $7fa380a0ada83f69$export$b601f49376b4621a = /*#__PURE__*/ $dpNXS.fromNullable($5fNnZ.Pointed);
var $7fa380a0ada83f69$export$c69ca7b73fad45e1 = /*#__PURE__*/ $dpNXS.fromNullableK($5fNnZ.Pointed);
var $7fa380a0ada83f69$export$c81f992c08fd0bf3 = /*#__PURE__*/ $dpNXS.chainNullableK($5fNnZ.Monad);
var $7fa380a0ada83f69$export$41d1a04d78e7b141 = /*#__PURE__*/ $dpNXS.orElse($5fNnZ.Monad);
var $7fa380a0ada83f69$export$efd845e0c87089a6 = $7fa380a0ada83f69$export$41d1a04d78e7b141;
var $7fa380a0ada83f69$export$f297679585c88732 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dpNXS.tapError($5fNnZ.Monad));
var $7fa380a0ada83f69$export$91e9d1839ed8da93 = function(onLeft) {
    return $7fa380a0ada83f69$export$f297679585c88732($7fa380a0ada83f69$export$9d3fcca17a044a16(onLeft));
};
var $7fa380a0ada83f69$export$85b9777d93691bbc = function(onLeft) {
    return $7fa380a0ada83f69$export$f297679585c88732($7fa380a0ada83f69$export$bb6009cf24290313(onLeft));
};
var $7fa380a0ada83f69$export$e84f0fd7f5bcfbf0 = /*#__PURE__*/ $dpNXS.orLeft($5fNnZ.Monad);
var $7fa380a0ada83f69$export$b0e76d9850c64156 = /*#__PURE__*/ $dpNXS.swap($5fNnZ.Functor);
var $7fa380a0ada83f69$export$f956926575b25f94 = function(onNone) {
    var from = $7fa380a0ada83f69$export$691693e0bdd7c0dc(onNone);
    return function(f) {
        return (0, $kj6DU.flow)(f, from);
    };
};
var $7fa380a0ada83f69$export$cc18a684c8cb422d = function(onNone) {
    return function(f) {
        return function(ma) {
            return $7fa380a0ada83f69$export$5b8affa63fc6df16(ma, $7fa380a0ada83f69$export$f956926575b25f94(onNone)(f));
        };
    };
};
var $7fa380a0ada83f69$export$a344f5448340a4a7 = $7fa380a0ada83f69$export$cc18a684c8cb422d;
var $7fa380a0ada83f69$export$6f981aca7fb40299 = function(f) {
    return (0, $kj6DU.flow)(f, $7fa380a0ada83f69$export$9b09e19fe882abba);
};
var $7fa380a0ada83f69$var$_map = function(fa, f) {
    return (0, $kj6DU.pipe)(fa, $7fa380a0ada83f69$export$871de8747c9eaa88(f));
};
var $7fa380a0ada83f69$var$_apPar = function(fab, fa) {
    return (0, $kj6DU.pipe)(fab, $7fa380a0ada83f69$export$2f6ca3d3b1f80bf5(fa));
};
var $7fa380a0ada83f69$var$_apSeq = function(fab, fa) {
    return $7fa380a0ada83f69$export$5b8affa63fc6df16(fab, function(f) {
        return (0, $kj6DU.pipe)(fa, $7fa380a0ada83f69$export$871de8747c9eaa88(f));
    });
};
/* istanbul ignore next */ var $7fa380a0ada83f69$var$_alt = function(fa, that) {
    return (0, $kj6DU.pipe)(fa, $7fa380a0ada83f69$export$228be17d80722ab(that));
};
var $7fa380a0ada83f69$export$871de8747c9eaa88 = /*#__PURE__*/ $dpNXS.map($5fNnZ.Functor);
var $7fa380a0ada83f69$export$2ab19f8a7e145f0a = /*#__PURE__*/ (0, $kj6DU.dual)(3, $dpNXS.mapBoth($5fNnZ.Functor));
var $7fa380a0ada83f69$export$eb54baf0b342cb1d = $7fa380a0ada83f69$export$2ab19f8a7e145f0a;
var $7fa380a0ada83f69$export$d0f6f6f8d08fe167 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dpNXS.mapError($5fNnZ.Functor));
var $7fa380a0ada83f69$export$472de43a55e4aa49 = $7fa380a0ada83f69$export$d0f6f6f8d08fe167;
var $7fa380a0ada83f69$export$2f6ca3d3b1f80bf5 = /*#__PURE__*/ $dpNXS.ap($5fNnZ.ApplyPar);
var $7fa380a0ada83f69$export$321be6e231de8eac = $7fa380a0ada83f69$export$2f6ca3d3b1f80bf5;
var $7fa380a0ada83f69$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dpNXS.flatMap($5fNnZ.Monad));
var $7fa380a0ada83f69$export$2409099f1fc434fb = /*#__PURE__*/ $7fa380a0ada83f69$export$5b8affa63fc6df16((0, $kj6DU.identity));
var $7fa380a0ada83f69$export$bffa455ba8c619a6 = $7fa380a0ada83f69$export$2409099f1fc434fb;
var $7fa380a0ada83f69$export$228be17d80722ab = /*#__PURE__*/ $dpNXS.alt($5fNnZ.Monad);
var $7fa380a0ada83f69$export$1517cca7889d6aaa = $7fa380a0ada83f69$export$228be17d80722ab;
var $7fa380a0ada83f69$export$ba255e9e49e00608 = $7fa380a0ada83f69$export$79ffe56a765070d2;
var $7fa380a0ada83f69$export$8bf7aba4a9e09055 = $7fa380a0ada83f69$export$eabcd2c8791e7bf4;
var $7fa380a0ada83f69$export$9156e739aa33e19f = 'TaskEither';
function $7fa380a0ada83f69$export$f55d048c8c810adb(A, S) {
    var ap = (0, $j7Bi0.ap)(A, $7Rbab.getApplicativeValidation(S));
    return {
        URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
        _E: undefined,
        map: $7fa380a0ada83f69$var$_map,
        ap: function(fab, fa) {
            return (0, $kj6DU.pipe)(fab, ap(fa));
        },
        of: $7fa380a0ada83f69$export$ba255e9e49e00608
    };
}
function $7fa380a0ada83f69$export$93b1fc7a429347dc(S) {
    var alt = $dpNXS.altValidation($5fNnZ.Monad, S);
    return {
        URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
        _E: undefined,
        map: $7fa380a0ada83f69$var$_map,
        alt: function(fa, that) {
            return (0, $kj6DU.pipe)(fa, alt(that));
        }
    };
}
var $7fa380a0ada83f69$export$cfae3069ac05ff4c = function(M) {
    var C = $7Rbab.getCompactable(M);
    return {
        URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
        _E: undefined,
        compact: (0, $eQAK7.compact)($5fNnZ.Functor, C),
        separate: (0, $eQAK7.separate)($5fNnZ.Functor, C, $7Rbab.Functor)
    };
};
function $7fa380a0ada83f69$export$a4e870b0a57ec14e(M) {
    var F = $7Rbab.getFilterable(M);
    var C = $7fa380a0ada83f69$export$cfae3069ac05ff4c(M);
    var filter = (0, $dHiDk.filter)($5fNnZ.Functor, F);
    var filterMap = (0, $dHiDk.filterMap)($5fNnZ.Functor, F);
    var partition = (0, $dHiDk.partition)($5fNnZ.Functor, F);
    var partitionMap = (0, $dHiDk.partitionMap)($5fNnZ.Functor, F);
    return {
        URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
        _E: undefined,
        map: $7fa380a0ada83f69$var$_map,
        compact: C.compact,
        separate: C.separate,
        filter: function(fa, predicate) {
            return (0, $kj6DU.pipe)(fa, filter(predicate));
        },
        filterMap: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, filterMap(f));
        },
        partition: function(fa, predicate) {
            return (0, $kj6DU.pipe)(fa, partition(predicate));
        },
        partitionMap: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, partitionMap(f));
        }
    };
}
var $7fa380a0ada83f69$export$bd5b6bfc5fa2ee61 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map
};
var $7fa380a0ada83f69$export$6554612db691658e = (0, $kj6DU.dual)(2, (0, $6baua.as)($7fa380a0ada83f69$export$bd5b6bfc5fa2ee61));
var $7fa380a0ada83f69$export$9284b360ca18a0fd = (0, $6baua.asUnit)($7fa380a0ada83f69$export$bd5b6bfc5fa2ee61);
var $7fa380a0ada83f69$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($7fa380a0ada83f69$export$bd5b6bfc5fa2ee61);
var $7fa380a0ada83f69$export$59a71046037e6c20 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608
};
var $7fa380a0ada83f69$export$e825dd8dbbdc0410 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar
};
var $7fa380a0ada83f69$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $j7Bi0.apFirst)($7fa380a0ada83f69$export$e825dd8dbbdc0410);
var $7fa380a0ada83f69$export$ac044f4aa9961a4f = $7fa380a0ada83f69$export$5f28d9feedcfd46e;
var $7fa380a0ada83f69$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $j7Bi0.apSecond)($7fa380a0ada83f69$export$e825dd8dbbdc0410);
var $7fa380a0ada83f69$export$8a00020751233172 = $7fa380a0ada83f69$export$ed01bc59c3d06bf3;
var $7fa380a0ada83f69$export$11b888901d89cc2 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608
};
var $7fa380a0ada83f69$export$60f1052cde3ba705 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apSeq
};
var $7fa380a0ada83f69$export$9c23f2f51a58ba10 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apSeq,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608
};
var $7fa380a0ada83f69$export$f18d5acc27d70423 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16
};
var $7fa380a0ada83f69$export$fb641926d034ac7d = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608
};
var $7fa380a0ada83f69$export$dc43ee6ccf36ad90 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608,
    fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8
};
var $7fa380a0ada83f69$export$ddc01897af104624 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608,
    fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8,
    fromTask: $7fa380a0ada83f69$export$b13b747e271beee9
};
var $7fa380a0ada83f69$export$5f956d47d0619c3a = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    ap: $7fa380a0ada83f69$var$_apPar,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608,
    throwError: $7fa380a0ada83f69$export$8bf7aba4a9e09055
};
var $7fa380a0ada83f69$export$825ea6cb6fc48d49 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    fromEither: $7fa380a0ada83f69$export$80c878c9b1d77917
};
var $7fa380a0ada83f69$export$978d37ea2fe360cf = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8
};
var $7fa380a0ada83f69$export$e86019a4d2fb9384 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8,
    fromTask: $7fa380a0ada83f69$export$b13b747e271beee9
};
var $7fa380a0ada83f69$export$3f23594af5f37336 = /*#__PURE__*/ (0, $kj6DU.dual)(2, $dya6d.tap($7fa380a0ada83f69$export$f18d5acc27d70423));
var $7fa380a0ada83f69$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $fgwhT.tapEither)($7fa380a0ada83f69$export$825ea6cb6fc48d49, $7fa380a0ada83f69$export$f18d5acc27d70423));
var $7fa380a0ada83f69$export$5bf3b8929fda1158 = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $bmbrn.tapIO)($7fa380a0ada83f69$export$978d37ea2fe360cf, $7fa380a0ada83f69$export$f18d5acc27d70423));
var $7fa380a0ada83f69$export$a8701ebadf2e95ad = /*#__PURE__*/ (0, $kj6DU.dual)(2, (0, $36y3L.tapTask)($7fa380a0ada83f69$export$e86019a4d2fb9384, $7fa380a0ada83f69$export$f18d5acc27d70423));
var $7fa380a0ada83f69$export$fd0fe42029639505 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    bimap: $7fa380a0ada83f69$export$2ab19f8a7e145f0a,
    mapLeft: $7fa380a0ada83f69$export$d0f6f6f8d08fe167
};
var $7fa380a0ada83f69$export$25ba4469a069167 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    map: $7fa380a0ada83f69$var$_map,
    alt: $7fa380a0ada83f69$var$_alt
};
var $7fa380a0ada83f69$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $fgwhT.fromOption)($7fa380a0ada83f69$export$825ea6cb6fc48d49);
var $7fa380a0ada83f69$export$a907462f448b49f8 = /*#__PURE__*/ (0, $fgwhT.fromOptionK)($7fa380a0ada83f69$export$825ea6cb6fc48d49);
var $7fa380a0ada83f69$export$12d26179deb6a68a = /*#__PURE__*/ (0, $fgwhT.chainOptionK)($7fa380a0ada83f69$export$825ea6cb6fc48d49, $7fa380a0ada83f69$export$f18d5acc27d70423);
var $7fa380a0ada83f69$export$377cc334277e5c3c = $7fa380a0ada83f69$export$12d26179deb6a68a;
/** @internal */ var $7fa380a0ada83f69$var$_FromEither = {
    fromEither: $7fa380a0ada83f69$export$825ea6cb6fc48d49.fromEither
};
var $7fa380a0ada83f69$export$cd139e14432f317b = /*#__PURE__*/ $lOGTm.liftNullable($7fa380a0ada83f69$var$_FromEither);
var $7fa380a0ada83f69$export$ea4a22f93200df79 = /*#__PURE__*/ $lOGTm.liftOption($7fa380a0ada83f69$var$_FromEither);
/** @internal */ var $7fa380a0ada83f69$var$_FlatMap = {
    flatMap: $7fa380a0ada83f69$export$5b8affa63fc6df16
};
/** @internal */ var $7fa380a0ada83f69$var$_FromIO = {
    fromIO: $7fa380a0ada83f69$export$978d37ea2fe360cf.fromIO
};
/** @internal */ var $7fa380a0ada83f69$var$_FromTask = {
    fromTask: $7fa380a0ada83f69$export$b13b747e271beee9
};
var $7fa380a0ada83f69$export$1a0515933c5c84fe = /*#__PURE__*/ $lOGTm.flatMapNullable($7fa380a0ada83f69$var$_FromEither, $7fa380a0ada83f69$var$_FlatMap);
var $7fa380a0ada83f69$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $lOGTm.flatMapOption($7fa380a0ada83f69$var$_FromEither, $7fa380a0ada83f69$var$_FlatMap);
var $7fa380a0ada83f69$export$979f2bb6a976172d = /*#__PURE__*/ $lOGTm.flatMapEither($7fa380a0ada83f69$var$_FromEither, $7fa380a0ada83f69$var$_FlatMap);
var $7fa380a0ada83f69$export$8b635ef81222764c = /*#__PURE__*/ $lOGTm.flatMapIO($7fa380a0ada83f69$var$_FromIO, $7fa380a0ada83f69$var$_FlatMap);
var $7fa380a0ada83f69$export$43849ff3f7ffa51c = /*#__PURE__*/ $lOGTm.flatMapTask($7fa380a0ada83f69$var$_FromTask, $7fa380a0ada83f69$var$_FlatMap);
var $7fa380a0ada83f69$export$7514610652fa62c0 = /*#__PURE__*/ (0, $kj6DU.dual)(2, function(self, f) {
    return $7fa380a0ada83f69$export$5b8affa63fc6df16(self, $7fa380a0ada83f69$export$6f981aca7fb40299(f));
});
var $7fa380a0ada83f69$export$bd2474f1d21e88eb = /*#__PURE__*/ (0, $kj6DU.dual)(3, function(self, f, onNone) {
    return $7fa380a0ada83f69$export$5b8affa63fc6df16(self, function(a) {
        return $7fa380a0ada83f69$export$691693e0bdd7c0dc(function() {
            return onNone(a);
        })(f(a));
    });
});
var $7fa380a0ada83f69$export$a3eef2eba9908c3e = $7fa380a0ada83f69$export$979f2bb6a976172d;
var $7fa380a0ada83f69$export$148e58f5a13b0a29 = $7fa380a0ada83f69$export$979f2bb6a976172d;
var $7fa380a0ada83f69$export$c5f2bdbf9b43f0c0 = $7fa380a0ada83f69$export$be3ff275bb5a8ac9;
var $7fa380a0ada83f69$export$3b38f8f4685eb1a8 = $7fa380a0ada83f69$export$be3ff275bb5a8ac9;
var $7fa380a0ada83f69$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $fgwhT.fromPredicate)($7fa380a0ada83f69$export$825ea6cb6fc48d49);
var $7fa380a0ada83f69$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $fgwhT.filterOrElse)($7fa380a0ada83f69$export$825ea6cb6fc48d49, $7fa380a0ada83f69$export$f18d5acc27d70423);
var $7fa380a0ada83f69$export$84511cf4503ec9dd = $7fa380a0ada83f69$export$30af8ca9498ddf5b;
var $7fa380a0ada83f69$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $fgwhT.fromEitherK)($7fa380a0ada83f69$export$825ea6cb6fc48d49);
var $7fa380a0ada83f69$export$9d3fcca17a044a16 = /*#__PURE__*/ (0, $bmbrn.fromIOK)($7fa380a0ada83f69$export$978d37ea2fe360cf);
var $7fa380a0ada83f69$export$dbedca339774a859 = $7fa380a0ada83f69$export$8b635ef81222764c;
var $7fa380a0ada83f69$export$5148ef8785cce359 = $7fa380a0ada83f69$export$5bf3b8929fda1158;
var $7fa380a0ada83f69$export$bb6009cf24290313 = /*#__PURE__*/ (0, $36y3L.fromTaskK)($7fa380a0ada83f69$export$e86019a4d2fb9384);
var $7fa380a0ada83f69$export$9e593613eaf643aa = $7fa380a0ada83f69$export$43849ff3f7ffa51c;
var $7fa380a0ada83f69$export$43e2f536f6b41427 = $7fa380a0ada83f69$export$a8701ebadf2e95ad;
var $7fa380a0ada83f69$export$fdc4db8624c799e8 = $7fa380a0ada83f69$export$7514610652fa62c0;
var $7fa380a0ada83f69$export$f596abf27dc7c7bd = $7fa380a0ada83f69$export$7514610652fa62c0;
function $7fa380a0ada83f69$export$9ff351a4cbab6799(f) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return function() {
            return new Promise(function(resolve) {
                var cbResolver = function(e, r) {
                    return e != null ? resolve($lOGTm.left(e)) : resolve($lOGTm.right(r));
                };
                f.apply(null, args.concat(cbResolver));
            });
        };
    };
}
var $7fa380a0ada83f69$export$df5598cc12b9c8c = function(acquire, use, release) {
    return $7fa380a0ada83f69$export$15093e5f950a635(acquire, use, release);
};
var $7fa380a0ada83f69$export$15093e5f950a635 = function(acquire, use, release) {
    return $7fa380a0ada83f69$export$5b8affa63fc6df16(acquire, function(a) {
        return $5fNnZ.flatMap(use(a), function(e) {
            return $7fa380a0ada83f69$export$5b8affa63fc6df16(release(a, e), function() {
                return $5fNnZ.of(e);
            });
        });
    });
};
var $7fa380a0ada83f69$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $7fa380a0ada83f69$export$ba255e9e49e00608($lOGTm.emptyRecord);
var $7fa380a0ada83f69$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $6baua.bindTo)($7fa380a0ada83f69$export$bd5b6bfc5fa2ee61);
var $7fa380a0ada83f69$export$5d537b797c421217 = /*#__PURE__*/ (0, $6baua.let)($7fa380a0ada83f69$export$bd5b6bfc5fa2ee61);
var $7fa380a0ada83f69$export$2385a24977818dd0 = /*#__PURE__*/ $dya6d.bind($7fa380a0ada83f69$export$f18d5acc27d70423);
var $7fa380a0ada83f69$export$e0d5b1cbe98976d9 = $7fa380a0ada83f69$export$2385a24977818dd0;
var $7fa380a0ada83f69$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $j7Bi0.apS)($7fa380a0ada83f69$export$e825dd8dbbdc0410);
var $7fa380a0ada83f69$export$5c01f27714264b3d = $7fa380a0ada83f69$export$8cbfc0239f42bb49;
var $7fa380a0ada83f69$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $7fa380a0ada83f69$export$ba255e9e49e00608($lOGTm.emptyReadonlyArray);
var $7fa380a0ada83f69$export$817de7d5ba7e6fab = function(f) {
    return (0, $kj6DU.flow)($5fNnZ.traverseReadonlyNonEmptyArrayWithIndex(f), $5fNnZ.map($7Rbab.traverseReadonlyNonEmptyArrayWithIndex((0, $kj6DU.SK))));
};
var $7fa380a0ada83f69$export$d4e79db5dc14cc1 = function(f) {
    var g = $7fa380a0ada83f69$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $7fa380a0ada83f69$export$c74b6e34b2b6efb0;
    };
};
var $7fa380a0ada83f69$export$ccd1b7252ef04791 = function(f) {
    return function(as) {
        return function() {
            return $lOGTm.tail(as).reduce(function(acc, a, i) {
                return acc.then(function(ebs) {
                    return $lOGTm.isLeft(ebs) ? acc : f(i + 1, a)().then(function(eb) {
                        if ($lOGTm.isLeft(eb)) return eb;
                        ebs.right.push(eb.right);
                        return ebs;
                    });
                });
            }, f(0, $lOGTm.head(as))().then($7Rbab.map($lOGTm.singleton)));
        };
    };
};
var $7fa380a0ada83f69$export$674043f9db4279c7 = function(f) {
    var g = $7fa380a0ada83f69$export$ccd1b7252ef04791(f);
    return function(as) {
        return $lOGTm.isNonEmpty(as) ? g(as) : $7fa380a0ada83f69$export$c74b6e34b2b6efb0;
    };
};
var $7fa380a0ada83f69$export$104a2841e9cbad06 = $7fa380a0ada83f69$export$d4e79db5dc14cc1;
var $7fa380a0ada83f69$export$64f39b2a2b79e1b1 = function(f) {
    return $7fa380a0ada83f69$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $7fa380a0ada83f69$export$d330b60315c14cd1 = /*#__PURE__*/ $7fa380a0ada83f69$export$64f39b2a2b79e1b1((0, $kj6DU.identity));
var $7fa380a0ada83f69$export$6702e2a63712b0a0 = $7fa380a0ada83f69$export$674043f9db4279c7;
var $7fa380a0ada83f69$export$5932486b5125ca68 = function(f) {
    return $7fa380a0ada83f69$export$674043f9db4279c7(function(_, a) {
        return f(a);
    });
};
var $7fa380a0ada83f69$export$5e316684572fbbb6 = /*#__PURE__*/ $7fa380a0ada83f69$export$5932486b5125ca68((0, $kj6DU.identity));
var $7fa380a0ada83f69$export$e08e3b67e392101e = $7fa380a0ada83f69$export$5b8affa63fc6df16;
var $7fa380a0ada83f69$export$8e5885f0163d737a = $7fa380a0ada83f69$export$5b8affa63fc6df16;
var $7fa380a0ada83f69$export$e3821ef4970c339c = $7fa380a0ada83f69$export$3f23594af5f37336;
var $7fa380a0ada83f69$export$5de78197fc44b933 = $7fa380a0ada83f69$export$3f23594af5f37336;
var $7fa380a0ada83f69$export$2705983cb222ac0a = $7fa380a0ada83f69$export$f297679585c88732;
var $7fa380a0ada83f69$export$d43d943be7ad7d62 = $7fa380a0ada83f69$export$f297679585c88732;
var $7fa380a0ada83f69$export$bf17ca9b48f5ebc2 = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    bimap: $7fa380a0ada83f69$export$2ab19f8a7e145f0a,
    mapLeft: $7fa380a0ada83f69$export$d0f6f6f8d08fe167,
    map: $7fa380a0ada83f69$var$_map,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608,
    ap: $7fa380a0ada83f69$var$_apPar,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
    alt: $7fa380a0ada83f69$var$_alt,
    fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8,
    fromTask: $7fa380a0ada83f69$export$b13b747e271beee9,
    throwError: $7fa380a0ada83f69$export$8bf7aba4a9e09055
};
var $7fa380a0ada83f69$export$e669e08ee441ca6e = {
    URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
    bimap: $7fa380a0ada83f69$export$2ab19f8a7e145f0a,
    mapLeft: $7fa380a0ada83f69$export$d0f6f6f8d08fe167,
    map: $7fa380a0ada83f69$var$_map,
    of: $7fa380a0ada83f69$export$ba255e9e49e00608,
    ap: $7fa380a0ada83f69$var$_apSeq,
    chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
    alt: $7fa380a0ada83f69$var$_alt,
    fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8,
    fromTask: $7fa380a0ada83f69$export$b13b747e271beee9,
    throwError: $7fa380a0ada83f69$export$8bf7aba4a9e09055
};
var $7fa380a0ada83f69$export$18979a515d2a828e = /*#__PURE__*/ (0, $j7Bi0.getApplySemigroup)($7fa380a0ada83f69$export$60f1052cde3ba705);
var $7fa380a0ada83f69$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $dYcKb.getApplicativeMonoid)($7fa380a0ada83f69$export$9c23f2f51a58ba10);
var $7fa380a0ada83f69$export$e759a9a7f8d04692 = function(S) {
    return (0, $j7Bi0.getApplySemigroup)($5fNnZ.ApplySeq)($7Rbab.getSemigroup(S));
};
function $7fa380a0ada83f69$export$205c8c90abeec407(SE) {
    var applicativeTaskValidation = $7fa380a0ada83f69$export$f55d048c8c810adb($5fNnZ.ApplicativePar, SE);
    var altTaskValidation = $7fa380a0ada83f69$export$93b1fc7a429347dc(SE);
    return {
        URI: $7fa380a0ada83f69$export$9156e739aa33e19f,
        _E: undefined,
        map: $7fa380a0ada83f69$var$_map,
        ap: applicativeTaskValidation.ap,
        of: $7fa380a0ada83f69$export$ba255e9e49e00608,
        chain: $7fa380a0ada83f69$export$5b8affa63fc6df16,
        bimap: $7fa380a0ada83f69$export$2ab19f8a7e145f0a,
        mapLeft: $7fa380a0ada83f69$export$d0f6f6f8d08fe167,
        alt: altTaskValidation.alt,
        fromIO: $7fa380a0ada83f69$export$d529793c7ff048a8,
        fromTask: $7fa380a0ada83f69$export$b13b747e271beee9,
        throwError: $7fa380a0ada83f69$export$8bf7aba4a9e09055
    };
}

});
parcelRegister("36y3L", function(module, exports) {

$parcel$export(module.exports, "fromTaskK", function () { return $242c5a33c2cd2a81$export$bb6009cf24290313; });
$parcel$export(module.exports, "tapTask", function () { return $242c5a33c2cd2a81$export$a8701ebadf2e95ad; });
/**
 * Lift a computation from the `Task` monad
 *
 * @since 2.10.0
 */ 
var $dya6d = parcelRequire("dya6d");

var $kj6DU = parcelRequire("kj6DU");
function $242c5a33c2cd2a81$export$bb6009cf24290313(F) {
    return function(f) {
        return (0, $kj6DU.flow)(f, F.fromTask);
    };
}
function $242c5a33c2cd2a81$export$9e593613eaf643aa(F, M) {
    return function(f) {
        var g = (0, $kj6DU.flow)(f, F.fromTask);
        return function(first) {
            return M.chain(first, g);
        };
    };
}
function $242c5a33c2cd2a81$export$43e2f536f6b41427(F, M) {
    var tapTaskM = $242c5a33c2cd2a81$export$a8701ebadf2e95ad(F, M);
    return function(f) {
        return function(first) {
            return tapTaskM(first, f);
        };
    };
}
function $242c5a33c2cd2a81$export$a8701ebadf2e95ad(F, M) {
    var tapM = (0, $dya6d.tap)(M);
    return function(self, f) {
        return tapM(self, (0, $kj6DU.flow)(f, F.fromTask));
    };
}

});


parcelRegister("7uCHH", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $57495b86f963aadf$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "string", function () { return $57495b86f963aadf$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $57495b86f963aadf$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $57495b86f963aadf$export$4a21f16c33752377; });
$parcel$export(module.exports, "struct", function () { return $57495b86f963aadf$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "compose", function () { return $57495b86f963aadf$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "partial", function () { return $57495b86f963aadf$export$e45945969df8035a; });
$parcel$export(module.exports, "readonly", function () { return $57495b86f963aadf$export$6ec456bd5b7b3c51; });
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community, see these tracking
 * [issues](https://github.com/gcanti/io-ts/issues?q=label%3Av2.2+) for further discussions and enhancements.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.2.3
 */ 
var $kj6DU = parcelRequire("kj6DU");

var $6piwk = parcelRequire("6piwk");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");
function $57495b86f963aadf$export$dd44f18ab656f3bb(decoder, encoder) {
    return {
        decode: decoder.decode,
        encode: encoder.encode
    };
}
function $57495b86f963aadf$export$2d3cac092805cb4f(decoder) {
    return {
        decode: decoder.decode,
        encode: (0, $kj6DU.identity)
    };
}
function $57495b86f963aadf$export$c8ec6e1ec9fefcb0() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return $57495b86f963aadf$export$2d3cac092805cb4f($5zWxO.literal.apply($5zWxO, values));
}
var $57495b86f963aadf$export$22b082955e083ec3 = /*#__PURE__*/ $57495b86f963aadf$export$2d3cac092805cb4f($5zWxO.string);
var $57495b86f963aadf$export$98e628dec113755e = /*#__PURE__*/ $57495b86f963aadf$export$2d3cac092805cb4f($5zWxO.number);
var $57495b86f963aadf$export$4a21f16c33752377 = /*#__PURE__*/ $57495b86f963aadf$export$2d3cac092805cb4f($5zWxO.boolean);
var $57495b86f963aadf$export$837c7bec7087434c = /*#__PURE__*/ $57495b86f963aadf$export$2d3cac092805cb4f($5zWxO.UnknownArray);
var $57495b86f963aadf$export$ecfbd036cf5a99af = /*#__PURE__*/ $57495b86f963aadf$export$2d3cac092805cb4f($5zWxO.UnknownRecord);
var $57495b86f963aadf$export$18b028d1bd14e25c = function(f) {
    return function(codec) {
        return $57495b86f963aadf$export$dd44f18ab656f3bb((0, $6piwk.pipe)(codec, $5zWxO.mapLeftWithInput(f)), codec);
    };
};
var $57495b86f963aadf$export$edc9d475108b3212 = function(refinement, id) {
    var refine = $5zWxO.refine(refinement, id);
    return function(from) {
        return $57495b86f963aadf$export$dd44f18ab656f3bb(refine(from), from);
    };
};
function $57495b86f963aadf$export$133fc36489ac9add(or) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.nullable(or), $aXkbA.nullable(or));
}
function $57495b86f963aadf$export$34355cbaba607122(properties) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.fromStruct(properties), $aXkbA.struct(properties));
}
var $57495b86f963aadf$export$1fc03a2373fc8e75 = $57495b86f963aadf$export$34355cbaba607122;
function $57495b86f963aadf$export$8cf3da7c1c9174ea(properties) {
    return (0, $6piwk.pipe)($57495b86f963aadf$export$ecfbd036cf5a99af, $57495b86f963aadf$export$f672e0b6f7222cd7($57495b86f963aadf$export$34355cbaba607122(properties)));
}
var $57495b86f963aadf$export$bf9fb029d174d554 = $57495b86f963aadf$export$8cf3da7c1c9174ea;
function $57495b86f963aadf$export$fb157a05f56ae99a(properties) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.fromPartial(properties), $aXkbA.partial(properties));
}
function $57495b86f963aadf$export$e45945969df8035a(properties) {
    return (0, $6piwk.pipe)($57495b86f963aadf$export$ecfbd036cf5a99af, $57495b86f963aadf$export$f672e0b6f7222cd7($57495b86f963aadf$export$fb157a05f56ae99a(properties)));
}
function $57495b86f963aadf$export$571d59b505e6bb4e(item) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.fromArray(item), $aXkbA.array(item));
}
function $57495b86f963aadf$export$2f23118c22fb2630(item) {
    return (0, $6piwk.pipe)($57495b86f963aadf$export$837c7bec7087434c, $57495b86f963aadf$export$f672e0b6f7222cd7($57495b86f963aadf$export$571d59b505e6bb4e(item)));
}
function $57495b86f963aadf$export$6c8271f68d66a228(codomain) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.fromRecord(codomain), $aXkbA.record(codomain));
}
function $57495b86f963aadf$export$e5185e241753e543(codomain) {
    return (0, $6piwk.pipe)($57495b86f963aadf$export$ecfbd036cf5a99af, $57495b86f963aadf$export$f672e0b6f7222cd7($57495b86f963aadf$export$6c8271f68d66a228(codomain)));
}
var $57495b86f963aadf$export$54e67896484d10fe = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.fromTuple.apply($5zWxO, components), $aXkbA.tuple.apply($aXkbA, components));
};
function $57495b86f963aadf$export$65e3907585753458() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return (0, $6piwk.pipe)($57495b86f963aadf$export$837c7bec7087434c, $57495b86f963aadf$export$f672e0b6f7222cd7($57495b86f963aadf$export$54e67896484d10fe.apply(void 0, components)));
}
var $57495b86f963aadf$export$1f4807a235930d45 = function(right) {
    var intersectD = $5zWxO.intersect(right);
    var intersectE = $aXkbA.intersect(right);
    return function(left) {
        return $57495b86f963aadf$export$dd44f18ab656f3bb(intersectD(left), intersectE(left));
    };
};
var $57495b86f963aadf$export$bf197727082b6243 = function(tag) {
    var decoder = $5zWxO.fromSum(tag);
    var encoder = $aXkbA.sum(tag);
    return function(members) {
        return $57495b86f963aadf$export$dd44f18ab656f3bb(decoder(members), encoder(members));
    };
};
function $57495b86f963aadf$export$8a63f25cc62965f1(tag) {
    var sum = $57495b86f963aadf$export$bf197727082b6243(tag);
    return function(members) {
        return (0, $6piwk.pipe)($57495b86f963aadf$export$ecfbd036cf5a99af, $57495b86f963aadf$export$f672e0b6f7222cd7(sum(members)));
    };
}
function $57495b86f963aadf$export$488013bae63b21da(id, f) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.lazy(id, f), $aXkbA.lazy(f));
}
var $57495b86f963aadf$export$6ec456bd5b7b3c51 = (0, $kj6DU.identity);
var $57495b86f963aadf$export$f672e0b6f7222cd7 = function(to) {
    return function(from) {
        return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.compose(to)(from), $aXkbA.compose(from)(to));
    };
};
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var $57495b86f963aadf$var$imap_ = function(fa, f, g) {
    return $57495b86f963aadf$export$dd44f18ab656f3bb($5zWxO.Functor.map(fa, f), $aXkbA.Contravariant.contramap(fa, g));
};
var $57495b86f963aadf$export$b2517b0ab3a58435 = function(f, g) {
    return function(fa) {
        return $57495b86f963aadf$var$imap_(fa, f, g);
    };
};
var $57495b86f963aadf$export$9156e739aa33e19f = 'io-ts/Codec';
var $57495b86f963aadf$export$dbdf692cc5737cfd = {
    URI: $57495b86f963aadf$export$9156e739aa33e19f,
    imap: $57495b86f963aadf$var$imap_
};

});
parcelRegister("5zWxO", function(module, exports) {

$parcel$export(module.exports, "SE", function () { return $40fda251b927d750$export$88d2e60d4be28663; });
$parcel$export(module.exports, "ap", function () { return $40fda251b927d750$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "error", function () { return $40fda251b927d750$export$a3bc9b8ed74fc; });
$parcel$export(module.exports, "success", function () { return $40fda251b927d750$export$fe7c49d056ea1d88; });
$parcel$export(module.exports, "failure", function () { return $40fda251b927d750$export$af2dba6db4e9e1f0; });
$parcel$export(module.exports, "fromRefinement", function () { return $40fda251b927d750$export$675cdb7790c17869; });
$parcel$export(module.exports, "fromGuard", function () { return $40fda251b927d750$export$35358b55571cb9f; });
$parcel$export(module.exports, "literal", function () { return $40fda251b927d750$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "string", function () { return $40fda251b927d750$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $40fda251b927d750$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $40fda251b927d750$export$4a21f16c33752377; });
$parcel$export(module.exports, "UnknownArray", function () { return $40fda251b927d750$export$837c7bec7087434c; });
$parcel$export(module.exports, "UnknownRecord", function () { return $40fda251b927d750$export$ecfbd036cf5a99af; });
$parcel$export(module.exports, "mapLeftWithInput", function () { return $40fda251b927d750$export$18b028d1bd14e25c; });
$parcel$export(module.exports, "withMessage", function () { return $40fda251b927d750$export$d330e88f82633eb9; });
$parcel$export(module.exports, "refine", function () { return $40fda251b927d750$export$edc9d475108b3212; });
$parcel$export(module.exports, "parse", function () { return $40fda251b927d750$export$98e6a39c04603d36; });
$parcel$export(module.exports, "nullable", function () { return $40fda251b927d750$export$133fc36489ac9add; });
$parcel$export(module.exports, "fromStruct", function () { return $40fda251b927d750$export$34355cbaba607122; });
$parcel$export(module.exports, "fromType", function () { return $40fda251b927d750$export$1fc03a2373fc8e75; });
$parcel$export(module.exports, "struct", function () { return $40fda251b927d750$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "compose", function () { return $40fda251b927d750$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "type", function () { return $40fda251b927d750$export$bf9fb029d174d554; });
$parcel$export(module.exports, "fromPartial", function () { return $40fda251b927d750$export$fb157a05f56ae99a; });
$parcel$export(module.exports, "partial", function () { return $40fda251b927d750$export$e45945969df8035a; });
$parcel$export(module.exports, "fromArray", function () { return $40fda251b927d750$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "array", function () { return $40fda251b927d750$export$2f23118c22fb2630; });
$parcel$export(module.exports, "fromRecord", function () { return $40fda251b927d750$export$6c8271f68d66a228; });
$parcel$export(module.exports, "record", function () { return $40fda251b927d750$export$e5185e241753e543; });
$parcel$export(module.exports, "fromTuple", function () { return $40fda251b927d750$export$54e67896484d10fe; });
$parcel$export(module.exports, "tuple", function () { return $40fda251b927d750$export$65e3907585753458; });
$parcel$export(module.exports, "union", function () { return $40fda251b927d750$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersect", function () { return $40fda251b927d750$export$1f4807a235930d45; });
$parcel$export(module.exports, "fromSum", function () { return $40fda251b927d750$export$bf197727082b6243; });
$parcel$export(module.exports, "sum", function () { return $40fda251b927d750$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "lazy", function () { return $40fda251b927d750$export$488013bae63b21da; });
$parcel$export(module.exports, "readonly", function () { return $40fda251b927d750$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "map", function () { return $40fda251b927d750$export$871de8747c9eaa88; });
$parcel$export(module.exports, "alt", function () { return $40fda251b927d750$export$228be17d80722ab; });
$parcel$export(module.exports, "id", function () { return $40fda251b927d750$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "URI", function () { return $40fda251b927d750$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Functor", function () { return $40fda251b927d750$export$bd5b6bfc5fa2ee61; });
$parcel$export(module.exports, "Alt", function () { return $40fda251b927d750$export$25ba4469a069167; });
$parcel$export(module.exports, "Category", function () { return $40fda251b927d750$export$3a8840c5b2ecf003; });
$parcel$export(module.exports, "Schemable", function () { return $40fda251b927d750$export$8c48479322816587; });
$parcel$export(module.exports, "WithUnknownContainers", function () { return $40fda251b927d750$export$9fbacd728aa00eea; });
$parcel$export(module.exports, "WithUnion", function () { return $40fda251b927d750$export$70d513615ee15303; });
$parcel$export(module.exports, "WithRefine", function () { return $40fda251b927d750$export$46824d948a594d40; });
$parcel$export(module.exports, "draw", function () { return $40fda251b927d750$export$e529deb2bfd496dc; });
$parcel$export(module.exports, "stringify", function () { return $40fda251b927d750$export$fac44ee5b035f737; });

var $7Rbab = parcelRequire("7Rbab");

var $kj6DU = parcelRequire("kj6DU");

var $6piwk = parcelRequire("6piwk");

var $1pj74 = parcelRequire("1pj74");

var $gy3zr = parcelRequire("gy3zr");

var $fI1nj = parcelRequire("fI1nj");

var $jXdk4 = parcelRequire("jXdk4");
var $40fda251b927d750$export$88d2e60d4be28663 = /*#__PURE__*/ $1pj74.getSemigroup();
var $40fda251b927d750$export$2f6ca3d3b1f80bf5 = function(fab, fa) {
    return $7Rbab.isLeft(fab) ? $7Rbab.isLeft(fa) ? $7Rbab.left($40fda251b927d750$export$88d2e60d4be28663.concat(fab.left, fa.left)) : fab : $7Rbab.isLeft(fa) ? fa : $7Rbab.right(fab.right(fa.right));
};
var $40fda251b927d750$var$M = {
    URI: $7Rbab.URI,
    _E: undefined,
    map: function(fa, f) {
        return (0, $6piwk.pipe)(fa, $7Rbab.map(f));
    },
    ap: $40fda251b927d750$export$2f6ca3d3b1f80bf5,
    of: $7Rbab.right,
    chain: function(ma, f) {
        return (0, $6piwk.pipe)(ma, $7Rbab.chain(f));
    },
    throwError: $7Rbab.left,
    bimap: function(fa, f, g) {
        return (0, $6piwk.pipe)(fa, $7Rbab.bimap(f, g));
    },
    mapLeft: function(fa, f) {
        return (0, $6piwk.pipe)(fa, $7Rbab.mapLeft(f));
    },
    alt: function(me, that) {
        if ($7Rbab.isRight(me)) return me;
        var ea = that();
        return $7Rbab.isLeft(ea) ? $7Rbab.left($40fda251b927d750$export$88d2e60d4be28663.concat(me.left, ea.left)) : ea;
    }
};
var $40fda251b927d750$export$a3bc9b8ed74fc = function(actual, message) {
    return $gy3zr.of($1pj74.leaf(actual, message));
};
var $40fda251b927d750$export$fe7c49d056ea1d88 = $7Rbab.right;
var $40fda251b927d750$export$af2dba6db4e9e1f0 = function(actual, message) {
    return $7Rbab.left($40fda251b927d750$export$a3bc9b8ed74fc(actual, message));
};
var $40fda251b927d750$export$675cdb7790c17869 = function(refinement, expected) {
    return $jXdk4.fromRefinement($40fda251b927d750$var$M)(refinement, function(u) {
        return $40fda251b927d750$export$a3bc9b8ed74fc(u, expected);
    });
};
var $40fda251b927d750$export$35358b55571cb9f = function(guard, expected) {
    return $40fda251b927d750$export$675cdb7790c17869(guard.is, expected);
};
var $40fda251b927d750$export$c8ec6e1ec9fefcb0 = /*#__PURE__*/ $jXdk4.literal($40fda251b927d750$var$M)(function(u, values) {
    return $40fda251b927d750$export$a3bc9b8ed74fc(u, values.map(function(value) {
        return JSON.stringify(value);
    }).join(' | '));
});
var $40fda251b927d750$export$22b082955e083ec3 = /*#__PURE__*/ $40fda251b927d750$export$35358b55571cb9f($fI1nj.string, 'string');
var $40fda251b927d750$export$98e628dec113755e = /*#__PURE__*/ $40fda251b927d750$export$35358b55571cb9f($fI1nj.number, 'number');
var $40fda251b927d750$export$4a21f16c33752377 = /*#__PURE__*/ $40fda251b927d750$export$35358b55571cb9f($fI1nj.boolean, 'boolean');
var $40fda251b927d750$export$837c7bec7087434c = /*#__PURE__*/ $40fda251b927d750$export$35358b55571cb9f($fI1nj.UnknownArray, 'Array<unknown>');
var $40fda251b927d750$export$ecfbd036cf5a99af = /*#__PURE__*/ $40fda251b927d750$export$35358b55571cb9f($fI1nj.UnknownRecord, 'Record<string, unknown>');
var $40fda251b927d750$export$18b028d1bd14e25c = /*#__PURE__*/ $jXdk4.mapLeftWithInput($40fda251b927d750$var$M);
var $40fda251b927d750$export$d330e88f82633eb9 = function(message) {
    return $40fda251b927d750$export$18b028d1bd14e25c(function(input, e) {
        return $gy3zr.of($1pj74.wrap(message(input, e), e));
    });
};
var $40fda251b927d750$export$edc9d475108b3212 = function(refinement, id) {
    return $jXdk4.refine($40fda251b927d750$var$M)(refinement, function(a) {
        return $40fda251b927d750$export$a3bc9b8ed74fc(a, id);
    });
};
var $40fda251b927d750$export$98e6a39c04603d36 = /*#__PURE__*/ $jXdk4.parse($40fda251b927d750$var$M);
var $40fda251b927d750$export$133fc36489ac9add = /*#__PURE__*/ $jXdk4.nullable($40fda251b927d750$var$M)(function(u, e) {
    return $gy3zr.concat($gy3zr.of($1pj74.member(0, $40fda251b927d750$export$a3bc9b8ed74fc(u, 'null'))), $gy3zr.of($1pj74.member(1, e)));
});
var $40fda251b927d750$export$34355cbaba607122 = function(properties) {
    return $jXdk4.fromStruct($40fda251b927d750$var$M)(function(k, e) {
        return $gy3zr.of($1pj74.key(k, $1pj74.required, e));
    })(properties);
};
var $40fda251b927d750$export$1fc03a2373fc8e75 = $40fda251b927d750$export$34355cbaba607122;
var $40fda251b927d750$export$8cf3da7c1c9174ea = function(properties) {
    return (0, $6piwk.pipe)($40fda251b927d750$export$ecfbd036cf5a99af, $40fda251b927d750$export$f672e0b6f7222cd7($40fda251b927d750$export$34355cbaba607122(properties)));
};
var $40fda251b927d750$export$bf9fb029d174d554 = $40fda251b927d750$export$8cf3da7c1c9174ea;
var $40fda251b927d750$export$fb157a05f56ae99a = function(properties) {
    return $jXdk4.fromPartial($40fda251b927d750$var$M)(function(k, e) {
        return $gy3zr.of($1pj74.key(k, $1pj74.optional, e));
    })(properties);
};
var $40fda251b927d750$export$e45945969df8035a = function(properties) {
    return (0, $6piwk.pipe)($40fda251b927d750$export$ecfbd036cf5a99af, $40fda251b927d750$export$f672e0b6f7222cd7($40fda251b927d750$export$fb157a05f56ae99a(properties)));
};
var $40fda251b927d750$export$571d59b505e6bb4e = function(item) {
    return $jXdk4.fromArray($40fda251b927d750$var$M)(function(i, e) {
        return $gy3zr.of($1pj74.index(i, $1pj74.optional, e));
    })(item);
};
var $40fda251b927d750$export$2f23118c22fb2630 = function(item) {
    return (0, $6piwk.pipe)($40fda251b927d750$export$837c7bec7087434c, $40fda251b927d750$export$f672e0b6f7222cd7($40fda251b927d750$export$571d59b505e6bb4e(item)));
};
var $40fda251b927d750$export$6c8271f68d66a228 = function(codomain) {
    return $jXdk4.fromRecord($40fda251b927d750$var$M)(function(k, e) {
        return $gy3zr.of($1pj74.key(k, $1pj74.optional, e));
    })(codomain);
};
var $40fda251b927d750$export$e5185e241753e543 = function(codomain) {
    return (0, $6piwk.pipe)($40fda251b927d750$export$ecfbd036cf5a99af, $40fda251b927d750$export$f672e0b6f7222cd7($40fda251b927d750$export$6c8271f68d66a228(codomain)));
};
var $40fda251b927d750$export$54e67896484d10fe = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return $jXdk4.fromTuple($40fda251b927d750$var$M)(function(i, e) {
        return $gy3zr.of($1pj74.index(i, $1pj74.required, e));
    }).apply(void 0, components);
};
var $40fda251b927d750$export$65e3907585753458 = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return (0, $6piwk.pipe)($40fda251b927d750$export$837c7bec7087434c, $40fda251b927d750$export$f672e0b6f7222cd7($40fda251b927d750$export$54e67896484d10fe.apply(void 0, components)));
};
var $40fda251b927d750$export$971dd5b0dfd021b6 = /*#__PURE__*/ $jXdk4.union($40fda251b927d750$var$M)(function(i, e) {
    return $gy3zr.of($1pj74.member(i, e));
});
var $40fda251b927d750$export$1f4807a235930d45 = /*#__PURE__*/ $jXdk4.intersect($40fda251b927d750$var$M);
var $40fda251b927d750$export$bf197727082b6243 = function(tag) {
    return function(members) {
        return $jXdk4.fromSum($40fda251b927d750$var$M)(function(tag, value, keys) {
            return $gy3zr.of($1pj74.key(tag, $1pj74.required, $40fda251b927d750$export$a3bc9b8ed74fc(value, keys.length === 0 ? 'never' : keys.map(function(k) {
                return JSON.stringify(k);
            }).join(' | '))));
        })(tag)(members);
    };
};
var $40fda251b927d750$export$8a63f25cc62965f1 = function(tag) {
    return function(members) {
        return (0, $6piwk.pipe)($40fda251b927d750$export$ecfbd036cf5a99af, $40fda251b927d750$export$f672e0b6f7222cd7($40fda251b927d750$export$bf197727082b6243(tag)(members)));
    };
};
var $40fda251b927d750$export$488013bae63b21da = /*#__PURE__*/ $jXdk4.lazy($40fda251b927d750$var$M)(function(id, e) {
    return $gy3zr.of($1pj74.lazy(id, e));
});
var $40fda251b927d750$export$6ec456bd5b7b3c51 = (0, $kj6DU.identity);
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var $40fda251b927d750$var$map_ = function(fa, f) {
    return (0, $6piwk.pipe)(fa, $40fda251b927d750$export$871de8747c9eaa88(f));
};
var $40fda251b927d750$var$alt_ = function(me, that) {
    return (0, $6piwk.pipe)(me, $40fda251b927d750$export$228be17d80722ab(that));
};
var $40fda251b927d750$var$compose_ = function(ab, la) {
    return (0, $6piwk.pipe)(la, $40fda251b927d750$export$f672e0b6f7222cd7(ab));
};
var $40fda251b927d750$export$871de8747c9eaa88 = /*#__PURE__*/ $jXdk4.map($40fda251b927d750$var$M);
var $40fda251b927d750$export$228be17d80722ab = /*#__PURE__*/ $jXdk4.alt($40fda251b927d750$var$M);
var $40fda251b927d750$export$f672e0b6f7222cd7 = /*#__PURE__*/ $jXdk4.compose($40fda251b927d750$var$M);
var $40fda251b927d750$export$d560c7e4a29451c2 = /*#__PURE__*/ $jXdk4.id($40fda251b927d750$var$M);
var $40fda251b927d750$export$9156e739aa33e19f = 'io-ts/Decoder';
var $40fda251b927d750$export$bd5b6bfc5fa2ee61 = {
    URI: $40fda251b927d750$export$9156e739aa33e19f,
    map: $40fda251b927d750$var$map_
};
var $40fda251b927d750$export$25ba4469a069167 = {
    URI: $40fda251b927d750$export$9156e739aa33e19f,
    map: $40fda251b927d750$var$map_,
    alt: $40fda251b927d750$var$alt_
};
var $40fda251b927d750$export$3a8840c5b2ecf003 = {
    URI: $40fda251b927d750$export$9156e739aa33e19f,
    compose: $40fda251b927d750$var$compose_,
    id: $40fda251b927d750$export$d560c7e4a29451c2
};
var $40fda251b927d750$export$8c48479322816587 = {
    URI: $40fda251b927d750$export$9156e739aa33e19f,
    literal: $40fda251b927d750$export$c8ec6e1ec9fefcb0,
    string: $40fda251b927d750$export$22b082955e083ec3,
    number: $40fda251b927d750$export$98e628dec113755e,
    boolean: $40fda251b927d750$export$4a21f16c33752377,
    nullable: $40fda251b927d750$export$133fc36489ac9add,
    type: $40fda251b927d750$export$bf9fb029d174d554,
    struct: $40fda251b927d750$export$8cf3da7c1c9174ea,
    partial: $40fda251b927d750$export$e45945969df8035a,
    record: $40fda251b927d750$export$e5185e241753e543,
    array: $40fda251b927d750$export$2f23118c22fb2630,
    tuple: $40fda251b927d750$export$65e3907585753458,
    intersect: $40fda251b927d750$export$1f4807a235930d45,
    sum: $40fda251b927d750$export$8a63f25cc62965f1,
    lazy: $40fda251b927d750$export$488013bae63b21da,
    readonly: $40fda251b927d750$export$6ec456bd5b7b3c51
};
var $40fda251b927d750$export$9fbacd728aa00eea = {
    UnknownArray: $40fda251b927d750$export$837c7bec7087434c,
    UnknownRecord: $40fda251b927d750$export$ecfbd036cf5a99af
};
var $40fda251b927d750$export$70d513615ee15303 = {
    union: $40fda251b927d750$export$971dd5b0dfd021b6
};
var $40fda251b927d750$export$46824d948a594d40 = {
    refine: $40fda251b927d750$export$edc9d475108b3212
};
var $40fda251b927d750$var$empty = [];
var $40fda251b927d750$var$make = function(value, forest) {
    if (forest === void 0) forest = $40fda251b927d750$var$empty;
    return {
        value: value,
        forest: forest
    };
};
var $40fda251b927d750$var$drawTree = function(tree) {
    return tree.value + $40fda251b927d750$var$drawForest('\n', tree.forest);
};
var $40fda251b927d750$var$drawForest = function(indentation, forest) {
    var r = '';
    var len = forest.length;
    var tree;
    for(var i = 0; i < len; i++){
        tree = forest[i];
        var isLast = i === len - 1;
        r += indentation + (isLast ? "\u2514" : "\u251C") + "\u2500 " + tree.value;
        r += $40fda251b927d750$var$drawForest(indentation + (len > 1 && !isLast ? "\u2502  " : '   '), tree.forest);
    }
    return r;
};
var $40fda251b927d750$var$toTree = $1pj74.fold({
    Leaf: function(input, error) {
        return $40fda251b927d750$var$make("cannot decode ".concat(JSON.stringify(input), ", should be ").concat(error));
    },
    Key: function(key, kind, errors) {
        return $40fda251b927d750$var$make("".concat(kind, " property ").concat(JSON.stringify(key)), $40fda251b927d750$var$toForest(errors));
    },
    Index: function(index, kind, errors) {
        return $40fda251b927d750$var$make("".concat(kind, " index ").concat(index), $40fda251b927d750$var$toForest(errors));
    },
    Member: function(index, errors) {
        return $40fda251b927d750$var$make("member ".concat(index), $40fda251b927d750$var$toForest(errors));
    },
    Lazy: function(id, errors) {
        return $40fda251b927d750$var$make("lazy type ".concat(id), $40fda251b927d750$var$toForest(errors));
    },
    Wrap: function(error, errors) {
        return $40fda251b927d750$var$make(error, $40fda251b927d750$var$toForest(errors));
    }
});
var $40fda251b927d750$var$toForest = function(e) {
    var stack = [];
    var focus = e;
    var res = [];
    // eslint-disable-next-line no-constant-condition
    while(true)switch(focus._tag){
        case 'Of':
            res.push($40fda251b927d750$var$toTree(focus.value));
            var tmp = stack.pop();
            if (tmp === undefined) return res;
            else focus = tmp;
            break;
        case 'Concat':
            stack.push(focus.right);
            focus = focus.left;
            break;
    }
};
var $40fda251b927d750$export$e529deb2bfd496dc = function(e) {
    return $40fda251b927d750$var$toForest(e).map($40fda251b927d750$var$drawTree).join('\n');
};
var $40fda251b927d750$export$fac44ee5b035f737 = /*#__PURE__*/ $7Rbab.fold($40fda251b927d750$export$e529deb2bfd496dc, function(a) {
    return JSON.stringify(a, null, 2);
});

});
parcelRegister("1pj74", function(module, exports) {

$parcel$export(module.exports, "required", function () { return $1066f3ac37f856a6$export$a7a0278c004aac3f; });
$parcel$export(module.exports, "optional", function () { return $1066f3ac37f856a6$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "leaf", function () { return $1066f3ac37f856a6$export$bf2348675e1fe8e; });
$parcel$export(module.exports, "key", function () { return $1066f3ac37f856a6$export$df61b30b684217c0; });
$parcel$export(module.exports, "index", function () { return $1066f3ac37f856a6$export$b610b8812bbcded9; });
$parcel$export(module.exports, "member", function () { return $1066f3ac37f856a6$export$6a0d13241802fe80; });
$parcel$export(module.exports, "lazy", function () { return $1066f3ac37f856a6$export$488013bae63b21da; });
$parcel$export(module.exports, "wrap", function () { return $1066f3ac37f856a6$export$4997ffc0176396a6; });
$parcel$export(module.exports, "fold", function () { return $1066f3ac37f856a6$export$93e2b83da34ff82a; });
$parcel$export(module.exports, "getSemigroup", function () { return $1066f3ac37f856a6$export$e759a9a7f8d04692; });

var $gy3zr = parcelRequire("gy3zr");
var $1066f3ac37f856a6$export$a7a0278c004aac3f = 'required';
var $1066f3ac37f856a6$export$516e28dec6a4b6d4 = 'optional';
var $1066f3ac37f856a6$export$bf2348675e1fe8e = function(actual, error) {
    return {
        _tag: 'Leaf',
        actual: actual,
        error: error
    };
};
var $1066f3ac37f856a6$export$df61b30b684217c0 = function(key, kind, errors) {
    return {
        _tag: 'Key',
        key: key,
        kind: kind,
        errors: errors
    };
};
var $1066f3ac37f856a6$export$b610b8812bbcded9 = function(index, kind, errors) {
    return {
        _tag: 'Index',
        index: index,
        kind: kind,
        errors: errors
    };
};
var $1066f3ac37f856a6$export$6a0d13241802fe80 = function(index, errors) {
    return {
        _tag: 'Member',
        index: index,
        errors: errors
    };
};
var $1066f3ac37f856a6$export$488013bae63b21da = function(id, errors) {
    return {
        _tag: 'Lazy',
        id: id,
        errors: errors
    };
};
var $1066f3ac37f856a6$export$4997ffc0176396a6 = function(error, errors) {
    return {
        _tag: 'Wrap',
        error: error,
        errors: errors
    };
};
var $1066f3ac37f856a6$export$93e2b83da34ff82a = function(patterns) {
    var f = function(e) {
        switch(e._tag){
            case 'Leaf':
                return patterns.Leaf(e.actual, e.error);
            case 'Key':
                return patterns.Key(e.key, e.kind, e.errors);
            case 'Index':
                return patterns.Index(e.index, e.kind, e.errors);
            case 'Member':
                return patterns.Member(e.index, e.errors);
            case 'Lazy':
                return patterns.Lazy(e.id, e.errors);
            case 'Wrap':
                return patterns.Wrap(e.error, e.errors);
        }
    };
    return f;
};
function $1066f3ac37f856a6$export$e759a9a7f8d04692() {
    return $gy3zr.getSemigroup();
}

});
parcelRegister("gy3zr", function(module, exports) {

$parcel$export(module.exports, "of", function () { return $c0c297640f13d0f8$export$ba255e9e49e00608; });
$parcel$export(module.exports, "concat", function () { return $c0c297640f13d0f8$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "getSemigroup", function () { return $c0c297640f13d0f8$export$e759a9a7f8d04692; });
/**
 * @category constructors
 * @since 2.2.7
 */ var $c0c297640f13d0f8$export$ba255e9e49e00608 = function(a) {
    return {
        _tag: 'Of',
        value: a
    };
};
var $c0c297640f13d0f8$export$ee1b3e54f0441b22 = function(left, right) {
    return {
        _tag: 'Concat',
        left: left,
        right: right
    };
};
var $c0c297640f13d0f8$export$93e2b83da34ff82a = function(onOf, onConcat) {
    return function(f) {
        switch(f._tag){
            case 'Of':
                return onOf(f.value);
            case 'Concat':
                return onConcat(f.left, f.right);
        }
    };
};
function $c0c297640f13d0f8$export$e759a9a7f8d04692() {
    return {
        concat: $c0c297640f13d0f8$export$ee1b3e54f0441b22
    };
}

});


parcelRegister("fI1nj", function(module, exports) {

$parcel$export(module.exports, "literal", function () { return $b6fc081936c026bb$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "string", function () { return $b6fc081936c026bb$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $b6fc081936c026bb$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $b6fc081936c026bb$export$4a21f16c33752377; });
$parcel$export(module.exports, "UnknownArray", function () { return $b6fc081936c026bb$export$837c7bec7087434c; });
$parcel$export(module.exports, "UnknownRecord", function () { return $b6fc081936c026bb$export$ecfbd036cf5a99af; });
$parcel$export(module.exports, "refine", function () { return $b6fc081936c026bb$export$edc9d475108b3212; });
$parcel$export(module.exports, "nullable", function () { return $b6fc081936c026bb$export$133fc36489ac9add; });
$parcel$export(module.exports, "struct", function () { return $b6fc081936c026bb$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "type", function () { return $b6fc081936c026bb$export$bf9fb029d174d554; });
$parcel$export(module.exports, "partial", function () { return $b6fc081936c026bb$export$e45945969df8035a; });
$parcel$export(module.exports, "array", function () { return $b6fc081936c026bb$export$2f23118c22fb2630; });
$parcel$export(module.exports, "record", function () { return $b6fc081936c026bb$export$e5185e241753e543; });
$parcel$export(module.exports, "tuple", function () { return $b6fc081936c026bb$export$65e3907585753458; });
$parcel$export(module.exports, "intersect", function () { return $b6fc081936c026bb$export$1f4807a235930d45; });
$parcel$export(module.exports, "union", function () { return $b6fc081936c026bb$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "sum", function () { return $b6fc081936c026bb$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "lazy", function () { return $b6fc081936c026bb$export$488013bae63b21da; });
$parcel$export(module.exports, "readonly", function () { return $b6fc081936c026bb$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "alt", function () { return $b6fc081936c026bb$export$228be17d80722ab; });
$parcel$export(module.exports, "zero", function () { return $b6fc081936c026bb$export$7f9972325ebfd559; });
$parcel$export(module.exports, "compose", function () { return $b6fc081936c026bb$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "id", function () { return $b6fc081936c026bb$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "URI", function () { return $b6fc081936c026bb$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Schemable", function () { return $b6fc081936c026bb$export$8c48479322816587; });
$parcel$export(module.exports, "WithUnknownContainers", function () { return $b6fc081936c026bb$export$9fbacd728aa00eea; });
$parcel$export(module.exports, "WithUnion", function () { return $b6fc081936c026bb$export$70d513615ee15303; });
$parcel$export(module.exports, "WithRefine", function () { return $b6fc081936c026bb$export$46824d948a594d40; });
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community, see these tracking
 * [issues](https://github.com/gcanti/io-ts/issues?q=label%3Av2.2+) for further discussions and enhancements.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.2.0
 */ 
var $kj6DU = parcelRequire("kj6DU");

var $6piwk = parcelRequire("6piwk");

var $585aE = parcelRequire("585aE");
var $b6fc081936c026bb$export$c8ec6e1ec9fefcb0 = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return {
        is: function(u) {
            return values.findIndex(function(a) {
                return a === u;
            }) !== -1;
        }
    };
};
var $b6fc081936c026bb$export$22b082955e083ec3 = {
    is: function(u) {
        return typeof u === 'string';
    }
};
var $b6fc081936c026bb$export$98e628dec113755e = {
    is: function(u) {
        return typeof u === 'number' && !isNaN(u);
    }
};
var $b6fc081936c026bb$export$4a21f16c33752377 = {
    is: function(u) {
        return typeof u === 'boolean';
    }
};
var $b6fc081936c026bb$export$837c7bec7087434c = {
    is: Array.isArray
};
var $b6fc081936c026bb$export$ecfbd036cf5a99af = {
    is: function(u) {
        return u !== null && typeof u === 'object' && !Array.isArray(u);
    }
};
var $b6fc081936c026bb$export$edc9d475108b3212 = function(refinement) {
    return function(from) {
        return {
            is: function(i) {
                return from.is(i) && refinement(i);
            }
        };
    };
};
var $b6fc081936c026bb$export$133fc36489ac9add = function(or) {
    return {
        is: function(i) {
            return i === null || or.is(i);
        }
    };
};
var $b6fc081936c026bb$export$8cf3da7c1c9174ea = function(properties) {
    return (0, $6piwk.pipe)($b6fc081936c026bb$export$ecfbd036cf5a99af, $b6fc081936c026bb$export$edc9d475108b3212(function(r) {
        for(var k in properties){
            if (!(k in r) || !properties[k].is(r[k])) return false;
        }
        return true;
    }));
};
var $b6fc081936c026bb$export$bf9fb029d174d554 = $b6fc081936c026bb$export$8cf3da7c1c9174ea;
var $b6fc081936c026bb$export$e45945969df8035a = function(properties) {
    return (0, $6piwk.pipe)($b6fc081936c026bb$export$ecfbd036cf5a99af, $b6fc081936c026bb$export$edc9d475108b3212(function(r) {
        for(var k in properties){
            var v = r[k];
            if (v !== undefined && !properties[k].is(v)) return false;
        }
        return true;
    }));
};
var $b6fc081936c026bb$export$2f23118c22fb2630 = function(item) {
    return (0, $6piwk.pipe)($b6fc081936c026bb$export$837c7bec7087434c, $b6fc081936c026bb$export$edc9d475108b3212(function(us) {
        return us.every(item.is);
    }));
};
var $b6fc081936c026bb$export$e5185e241753e543 = function(codomain) {
    return (0, $6piwk.pipe)($b6fc081936c026bb$export$ecfbd036cf5a99af, $b6fc081936c026bb$export$edc9d475108b3212(function(r) {
        for(var k in r){
            if (!codomain.is(r[k])) return false;
        }
        return true;
    }));
};
var $b6fc081936c026bb$export$65e3907585753458 = function() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return {
        is: function(u) {
            return Array.isArray(u) && u.length === components.length && components.every(function(c, i) {
                return c.is(u[i]);
            });
        }
    };
};
var $b6fc081936c026bb$export$1f4807a235930d45 = function(right) {
    return function(left) {
        return {
            is: function(u) {
                return left.is(u) && right.is(u);
            }
        };
    };
};
var $b6fc081936c026bb$export$971dd5b0dfd021b6 = function() {
    var members = [];
    for(var _i = 0; _i < arguments.length; _i++)members[_i] = arguments[_i];
    return {
        is: function(u) {
            return members.some(function(m) {
                return m.is(u);
            });
        }
    };
};
var $b6fc081936c026bb$export$8a63f25cc62965f1 = function(tag) {
    return function(members) {
        return (0, $6piwk.pipe)($b6fc081936c026bb$export$ecfbd036cf5a99af, $b6fc081936c026bb$export$edc9d475108b3212(function(r) {
            var v = r[tag];
            if (v in members) return members[v].is(r);
            return false;
        }));
    };
};
var $b6fc081936c026bb$export$488013bae63b21da = function(f) {
    var get = $585aE.memoize(f);
    return {
        is: function(u) {
            return get().is(u);
        }
    };
};
var $b6fc081936c026bb$export$6ec456bd5b7b3c51 = (0, $kj6DU.identity);
var $b6fc081936c026bb$export$228be17d80722ab = function(that) {
    return function(me) {
        return {
            is: function(i) {
                return me.is(i) || that().is(i);
            }
        };
    };
};
var $b6fc081936c026bb$export$7f9972325ebfd559 = function() {
    return {
        is: function(_) {
            return false;
        }
    };
};
var $b6fc081936c026bb$export$f672e0b6f7222cd7 = function(to) {
    return function(from) {
        return {
            is: function(i) {
                return from.is(i) && to.is(i);
            }
        };
    };
};
var $b6fc081936c026bb$export$d560c7e4a29451c2 = function() {
    return {
        is: function(_) {
            return true;
        }
    };
};
var $b6fc081936c026bb$export$9156e739aa33e19f = 'io-ts/Guard';
var $b6fc081936c026bb$export$8c48479322816587 = {
    URI: $b6fc081936c026bb$export$9156e739aa33e19f,
    literal: $b6fc081936c026bb$export$c8ec6e1ec9fefcb0,
    string: $b6fc081936c026bb$export$22b082955e083ec3,
    number: $b6fc081936c026bb$export$98e628dec113755e,
    boolean: $b6fc081936c026bb$export$4a21f16c33752377,
    nullable: $b6fc081936c026bb$export$133fc36489ac9add,
    type: $b6fc081936c026bb$export$bf9fb029d174d554,
    struct: $b6fc081936c026bb$export$8cf3da7c1c9174ea,
    partial: $b6fc081936c026bb$export$e45945969df8035a,
    record: $b6fc081936c026bb$export$e5185e241753e543,
    array: $b6fc081936c026bb$export$2f23118c22fb2630,
    tuple: $b6fc081936c026bb$export$65e3907585753458,
    intersect: $b6fc081936c026bb$export$1f4807a235930d45,
    sum: $b6fc081936c026bb$export$8a63f25cc62965f1,
    lazy: function(_, f) {
        return $b6fc081936c026bb$export$488013bae63b21da(f);
    },
    readonly: $b6fc081936c026bb$export$6ec456bd5b7b3c51
};
var $b6fc081936c026bb$export$9fbacd728aa00eea = {
    UnknownArray: $b6fc081936c026bb$export$837c7bec7087434c,
    UnknownRecord: $b6fc081936c026bb$export$ecfbd036cf5a99af
};
var $b6fc081936c026bb$export$70d513615ee15303 = {
    union: $b6fc081936c026bb$export$971dd5b0dfd021b6
};
var $b6fc081936c026bb$export$46824d948a594d40 = {
    refine: $b6fc081936c026bb$export$edc9d475108b3212
};

});
parcelRegister("585aE", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $3bc1b5ef4b95de7f$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "intersect_", function () { return $3bc1b5ef4b95de7f$export$79215695652d139b; });
/**
 * @since 2.2.0
 */ function $3bc1b5ef4b95de7f$export$fc10aeed3a532e2a(f) {
    var cache = new Map();
    return function(a) {
        if (!cache.has(a)) {
            var b = f(a);
            cache.set(a, b);
            return b;
        }
        return cache.get(a);
    };
}
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
var $3bc1b5ef4b95de7f$var$typeOf = function(x) {
    return x === null ? 'null' : typeof x;
};
var $3bc1b5ef4b95de7f$export$79215695652d139b = function(a, b) {
    if (a !== undefined && b !== undefined) {
        var tx = $3bc1b5ef4b95de7f$var$typeOf(a);
        var ty = $3bc1b5ef4b95de7f$var$typeOf(b);
        if (tx === 'object' || ty === 'object') return Object.assign({}, a, b);
    }
    return b;
};

});


parcelRegister("jXdk4", function(module, exports) {

$parcel$export(module.exports, "fromRefinement", function () { return $e86ddc9bd9888541$export$675cdb7790c17869; });
$parcel$export(module.exports, "literal", function () { return $e86ddc9bd9888541$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "mapLeftWithInput", function () { return $e86ddc9bd9888541$export$18b028d1bd14e25c; });
$parcel$export(module.exports, "refine", function () { return $e86ddc9bd9888541$export$edc9d475108b3212; });
$parcel$export(module.exports, "compose", function () { return $e86ddc9bd9888541$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "parse", function () { return $e86ddc9bd9888541$export$98e6a39c04603d36; });
$parcel$export(module.exports, "nullable", function () { return $e86ddc9bd9888541$export$133fc36489ac9add; });
$parcel$export(module.exports, "fromStruct", function () { return $e86ddc9bd9888541$export$34355cbaba607122; });
$parcel$export(module.exports, "fromPartial", function () { return $e86ddc9bd9888541$export$fb157a05f56ae99a; });
$parcel$export(module.exports, "fromArray", function () { return $e86ddc9bd9888541$export$571d59b505e6bb4e; });
$parcel$export(module.exports, "fromRecord", function () { return $e86ddc9bd9888541$export$6c8271f68d66a228; });
$parcel$export(module.exports, "fromTuple", function () { return $e86ddc9bd9888541$export$54e67896484d10fe; });
$parcel$export(module.exports, "union", function () { return $e86ddc9bd9888541$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "intersect", function () { return $e86ddc9bd9888541$export$1f4807a235930d45; });
$parcel$export(module.exports, "fromSum", function () { return $e86ddc9bd9888541$export$bf197727082b6243; });
$parcel$export(module.exports, "lazy", function () { return $e86ddc9bd9888541$export$488013bae63b21da; });
$parcel$export(module.exports, "id", function () { return $e86ddc9bd9888541$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "map", function () { return $e86ddc9bd9888541$export$871de8747c9eaa88; });
$parcel$export(module.exports, "alt", function () { return $e86ddc9bd9888541$export$228be17d80722ab; });

var $7Rbab = parcelRequire("7Rbab");

var $fI1nj = parcelRequire("fI1nj");

var $585aE = parcelRequire("585aE");
function $e86ddc9bd9888541$export$675cdb7790c17869(M) {
    return function(refinement, onError) {
        return {
            decode: function(i) {
                return refinement(i) ? M.of(i) : M.throwError(onError(i));
            }
        };
    };
}
function $e86ddc9bd9888541$export$c8ec6e1ec9fefcb0(M) {
    return function(onError) {
        return function() {
            var values = [];
            for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
            return {
                decode: function(i) {
                    return $fI1nj.literal.apply($fI1nj, values).is(i) ? M.of(i) : M.throwError(onError(i, values));
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$18b028d1bd14e25c(M) {
    return function(f) {
        return function(decoder) {
            return {
                decode: function(i) {
                    return M.mapLeft(decoder.decode(i), function(e) {
                        return f(i, e);
                    });
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$edc9d475108b3212(M) {
    return function(refinement, onError) {
        return function(from) {
            return $e86ddc9bd9888541$export$f672e0b6f7222cd7(M)($e86ddc9bd9888541$export$675cdb7790c17869(M)(refinement, onError))(from);
        };
    };
}
function $e86ddc9bd9888541$export$98e6a39c04603d36(M) {
    return function(decode) {
        return function(from) {
            return $e86ddc9bd9888541$export$f672e0b6f7222cd7(M)({
                decode: decode
            })(from);
        };
    };
}
function $e86ddc9bd9888541$export$133fc36489ac9add(M) {
    return function(onError) {
        return function(or) {
            return {
                decode: function(i) {
                    return i === null ? M.of(null) : M.bimap(or.decode(i), function(e) {
                        return onError(i, e);
                    }, function(a) {
                        return a;
                    });
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$34355cbaba607122(M) {
    var traverse = $e86ddc9bd9888541$var$traverseRecordWithIndex(M);
    return function(onPropertyError) {
        return function(properties) {
            return {
                decode: function(i) {
                    return traverse(properties, function(key, decoder) {
                        return M.mapLeft(decoder.decode(i[key]), function(e) {
                            return onPropertyError(key, e);
                        });
                    });
                }
            };
        };
    };
}
var $e86ddc9bd9888541$export$1fc03a2373fc8e75 = $e86ddc9bd9888541$export$34355cbaba607122;
function $e86ddc9bd9888541$export$fb157a05f56ae99a(M) {
    var traverse = $e86ddc9bd9888541$var$traverseRecordWithIndex(M);
    var undefinedProperty = M.of($7Rbab.right(undefined));
    var skipProperty = M.of($7Rbab.left(undefined));
    return function(onPropertyError) {
        return function(properties) {
            return {
                decode: function(i) {
                    return M.map(traverse(properties, function(key, decoder) {
                        var ikey = i[key];
                        if (ikey === undefined) return key in i ? undefinedProperty : skipProperty;
                        return M.bimap(decoder.decode(ikey), function(e) {
                            return onPropertyError(key, e);
                        }, function(a) {
                            return $7Rbab.right(a);
                        });
                    }), $e86ddc9bd9888541$var$compactRecord);
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$571d59b505e6bb4e(M) {
    var traverse = $e86ddc9bd9888541$var$traverseArrayWithIndex(M);
    return function(onItemError) {
        return function(item) {
            return {
                decode: function(is) {
                    return traverse(is, function(index, i) {
                        return M.mapLeft(item.decode(i), function(e) {
                            return onItemError(index, e);
                        });
                    });
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$6c8271f68d66a228(M) {
    var traverse = $e86ddc9bd9888541$var$traverseRecordWithIndex(M);
    return function(onKeyError) {
        return function(codomain) {
            return {
                decode: function(ir) {
                    return traverse(ir, function(key, i) {
                        return M.mapLeft(codomain.decode(i), function(e) {
                            return onKeyError(key, e);
                        });
                    });
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$54e67896484d10fe(M) {
    var traverse = $e86ddc9bd9888541$var$traverseArrayWithIndex(M);
    return function(onIndexError) {
        return function() {
            var components = [];
            for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
            return {
                decode: function(is) {
                    return traverse(components, function(index, decoder) {
                        return M.mapLeft(decoder.decode(is[index]), function(e) {
                            return onIndexError(index, e);
                        });
                    });
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$971dd5b0dfd021b6(M) {
    return function(onMemberError) {
        return function() {
            var members = [];
            for(var _i = 0; _i < arguments.length; _i++)members[_i] = arguments[_i];
            return {
                decode: function(i) {
                    var out = M.mapLeft(members[0].decode(i), function(e) {
                        return onMemberError(0, e);
                    });
                    var _loop_1 = function(index) {
                        out = M.alt(out, function() {
                            return M.mapLeft(members[index].decode(i), function(e) {
                                return onMemberError(index, e);
                            });
                        });
                    };
                    for(var index = 1; index < members.length; index++)_loop_1(index);
                    return out;
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$1f4807a235930d45(M) {
    return function(right) {
        return function(left) {
            return {
                decode: function(i) {
                    return M.ap(M.map(left.decode(i), function(a) {
                        return function(b) {
                            return $585aE.intersect_(a, b);
                        };
                    }), right.decode(i));
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$bf197727082b6243(M) {
    return function(onTagError) {
        return function(tag) {
            return function(members) {
                var keys = Object.keys(members);
                return {
                    decode: function(ir) {
                        var v = ir[tag];
                        if (Object.prototype.hasOwnProperty.call(members, v)) return members[v].decode(ir);
                        return M.throwError(onTagError(tag, v, keys));
                    }
                };
            };
        };
    };
}
function $e86ddc9bd9888541$export$488013bae63b21da(M) {
    return function(onError) {
        return function(id, f) {
            var get = $585aE.memoize(f);
            return {
                decode: function(u) {
                    return M.mapLeft(get().decode(u), function(e) {
                        return onError(id, e);
                    });
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$f672e0b6f7222cd7(M) {
    return function(ab) {
        return function(ia) {
            return {
                decode: function(i) {
                    return M.chain(ia.decode(i), ab.decode);
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$d560c7e4a29451c2(M) {
    return function() {
        return {
            decode: M.of
        };
    };
}
function $e86ddc9bd9888541$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(ia) {
            return {
                decode: function(i) {
                    return F.map(ia.decode(i), f);
                }
            };
        };
    };
}
function $e86ddc9bd9888541$export$228be17d80722ab(A) {
    return function(that) {
        return function(me) {
            return {
                decode: function(i) {
                    return A.alt(me.decode(i), function() {
                        return that().decode(i);
                    });
                }
            };
        };
    };
}
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
var $e86ddc9bd9888541$var$traverseArrayWithIndex = function(M) {
    return function(as, f) {
        return as.reduce(function(mbs, a, i) {
            return M.ap(M.map(mbs, function(bs) {
                return function(b) {
                    bs.push(b);
                    return bs;
                };
            }), f(i, a));
        }, M.of([]));
    };
};
var $e86ddc9bd9888541$var$traverseRecordWithIndex = function(M) {
    return function(r, f) {
        var ks = Object.keys(r);
        if (ks.length === 0) return M.of({});
        var fr = M.of({});
        var _loop_2 = function(key) {
            fr = M.ap(M.map(fr, function(r) {
                return function(b) {
                    r[key] = b;
                    return r;
                };
            }), f(key, r[key]));
        };
        for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
            var key = ks_1[_i];
            _loop_2(key);
        }
        return fr;
    };
};
var $e86ddc9bd9888541$var$compactRecord = function(r) {
    var out = {};
    for(var k in r){
        var rk = r[k];
        if ($7Rbab.isRight(rk)) out[k] = rk.right;
    }
    return out;
};

});


parcelRegister("aXkbA", function(module, exports) {

$parcel$export(module.exports, "nullable", function () { return $7f9f128e64d404a8$export$133fc36489ac9add; });
$parcel$export(module.exports, "struct", function () { return $7f9f128e64d404a8$export$8cf3da7c1c9174ea; });
$parcel$export(module.exports, "type", function () { return $7f9f128e64d404a8$export$bf9fb029d174d554; });
$parcel$export(module.exports, "partial", function () { return $7f9f128e64d404a8$export$e45945969df8035a; });
$parcel$export(module.exports, "record", function () { return $7f9f128e64d404a8$export$e5185e241753e543; });
$parcel$export(module.exports, "array", function () { return $7f9f128e64d404a8$export$2f23118c22fb2630; });
$parcel$export(module.exports, "tuple", function () { return $7f9f128e64d404a8$export$65e3907585753458; });
$parcel$export(module.exports, "intersect", function () { return $7f9f128e64d404a8$export$1f4807a235930d45; });
$parcel$export(module.exports, "sum", function () { return $7f9f128e64d404a8$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "lazy", function () { return $7f9f128e64d404a8$export$488013bae63b21da; });
$parcel$export(module.exports, "readonly", function () { return $7f9f128e64d404a8$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "contramap", function () { return $7f9f128e64d404a8$export$53b696d27ecb7ba7; });
$parcel$export(module.exports, "compose", function () { return $7f9f128e64d404a8$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "id", function () { return $7f9f128e64d404a8$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "URI", function () { return $7f9f128e64d404a8$export$9156e739aa33e19f; });
$parcel$export(module.exports, "Contravariant", function () { return $7f9f128e64d404a8$export$def901a57d5539c3; });
$parcel$export(module.exports, "Category", function () { return $7f9f128e64d404a8$export$3a8840c5b2ecf003; });

var $kj6DU = parcelRequire("kj6DU");

var $585aE = parcelRequire("585aE");
function $7f9f128e64d404a8$export$133fc36489ac9add(or) {
    return {
        encode: function(a) {
            return a === null ? null : or.encode(a);
        }
    };
}
function $7f9f128e64d404a8$export$8cf3da7c1c9174ea(properties) {
    return {
        encode: function(a) {
            var o = {};
            for(var k in properties)o[k] = properties[k].encode(a[k]);
            return o;
        }
    };
}
var $7f9f128e64d404a8$export$bf9fb029d174d554 = $7f9f128e64d404a8$export$8cf3da7c1c9174ea;
function $7f9f128e64d404a8$export$e45945969df8035a(properties) {
    return {
        encode: function(a) {
            var o = {};
            for(var k in properties){
                var v = a[k];
                // don't add missing properties
                if (k in a) // don't strip undefined properties
                o[k] = v === undefined ? undefined : properties[k].encode(v);
            }
            return o;
        }
    };
}
function $7f9f128e64d404a8$export$e5185e241753e543(codomain) {
    return {
        encode: function(r) {
            var o = {};
            for(var k in r)o[k] = codomain.encode(r[k]);
            return o;
        }
    };
}
function $7f9f128e64d404a8$export$2f23118c22fb2630(item) {
    return {
        encode: function(as) {
            return as.map(item.encode);
        }
    };
}
function $7f9f128e64d404a8$export$65e3907585753458() {
    var components = [];
    for(var _i = 0; _i < arguments.length; _i++)components[_i] = arguments[_i];
    return {
        encode: function(as) {
            return components.map(function(c, i) {
                return c.encode(as[i]);
            });
        }
    };
}
var $7f9f128e64d404a8$export$1f4807a235930d45 = function(right) {
    return function(left) {
        return {
            encode: function(ab) {
                return (0, $585aE.intersect_)(left.encode(ab), right.encode(ab));
            }
        };
    };
};
function $7f9f128e64d404a8$export$8a63f25cc62965f1(tag) {
    return function(members) {
        return {
            encode: function(a) {
                return members[a[tag]].encode(a);
            }
        };
    };
}
function $7f9f128e64d404a8$export$488013bae63b21da(f) {
    var get = (0, $585aE.memoize)(f);
    return {
        encode: function(a) {
            return get().encode(a);
        }
    };
}
var $7f9f128e64d404a8$export$6ec456bd5b7b3c51 = (0, $kj6DU.identity);
// -------------------------------------------------------------------------------------
// non-pipeables
// -------------------------------------------------------------------------------------
var $7f9f128e64d404a8$var$contramap_ = function(ea, f) {
    return {
        encode: function(b) {
            return ea.encode(f(b));
        }
    };
};
var $7f9f128e64d404a8$var$compose_ = function(ab, ea) {
    return $7f9f128e64d404a8$var$contramap_(ea, ab.encode);
};
var $7f9f128e64d404a8$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $7f9f128e64d404a8$var$contramap_(fa, f);
    };
};
var $7f9f128e64d404a8$export$f672e0b6f7222cd7 = function(ea) {
    return function(ab) {
        return $7f9f128e64d404a8$var$compose_(ab, ea);
    };
};
function $7f9f128e64d404a8$export$d560c7e4a29451c2() {
    return {
        encode: (0, $kj6DU.identity)
    };
}
var $7f9f128e64d404a8$export$9156e739aa33e19f = 'io-ts/Encoder';
var $7f9f128e64d404a8$export$def901a57d5539c3 = {
    URI: $7f9f128e64d404a8$export$9156e739aa33e19f,
    contramap: $7f9f128e64d404a8$var$contramap_
};
var $7f9f128e64d404a8$export$3a8840c5b2ecf003 = {
    URI: $7f9f128e64d404a8$export$9156e739aa33e19f,
    compose: $7f9f128e64d404a8$var$compose_,
    id: $7f9f128e64d404a8$export$d560c7e4a29451c2
};

});


parcelRegister("hp7yq", function(module, exports) {

$parcel$export(module.exports, "iso", function () { return $cabaa18f8292f79a$export$1aba8f741a0eae06; });

var $kj6DU = parcelRequire("kj6DU");

var $3NXK3 = parcelRequire("3NXK3");

var $7bKko = parcelRequire("7bKko");
var $cabaa18f8292f79a$export$804fed467fde44e4 = function(S) {
    return S;
};
var $cabaa18f8292f79a$export$1af51209b1b91d07 = function(O) {
    return O;
};
var $cabaa18f8292f79a$export$e759a9a7f8d04692 = function(S) {
    return S;
};
var $cabaa18f8292f79a$export$c2a7ef2cc9b32b31 = function(M) {
    return M;
};
var $cabaa18f8292f79a$export$3d48c7fefc7b8ec2 = function(S) {
    return S;
};
var $cabaa18f8292f79a$export$575097c1c561f76f = function(R) {
    return R;
};
var $cabaa18f8292f79a$export$2c9b3f539cb25b05 = function(F) {
    return F;
};
//
// isos
//
var $cabaa18f8292f79a$var$anyIso = /*#__PURE__*/ new (0, $7bKko.Iso)((0, $kj6DU.unsafeCoerce), (0, $kj6DU.unsafeCoerce));
function $cabaa18f8292f79a$export$1aba8f741a0eae06() {
    return $cabaa18f8292f79a$var$anyIso;
}
function $cabaa18f8292f79a$export$e469dcfea9910464(predicate) {
    return new (0, $7bKko.Prism)(function(s) {
        return predicate(s) ? (0, $3NXK3.some)(s) : (0, $3NXK3.none);
    }, (0, $kj6DU.identity));
}

});

parcelRegister("hPJN4", function(module, exports) {

$parcel$export(module.exports, "MsDuration", function () { return $9caad2ac3e2e8894$export$1b670aa85a2d9176; });
// import type { StringValue } from 'ms'
// import vercelMs from 'ms'

var $cF6yJ = parcelRequire("cF6yJ");
var $hOuM2 = parcelRequire("hOuM2");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $hp7yq = parcelRequire("hp7yq");
const { wrap: $9caad2ac3e2e8894$var$wrap, unwrap: $9caad2ac3e2e8894$var$unwrap } = (0, $hp7yq.iso)();
const $9caad2ac3e2e8894$var$milliseconds = $9caad2ac3e2e8894$var$wrap;
const $9caad2ac3e2e8894$var$codec = $7uCHH.make((0, $kj6DU.pipe)($7uCHH.number, $5zWxO.map($9caad2ac3e2e8894$var$wrap)), (0, $kj6DU.pipe)($7uCHH.number, $aXkbA.contramap($9caad2ac3e2e8894$var$unwrap)));
// const fromStringDecoder = pipe(
//   D.string,
//   D.parse(str =>
//     pipe(
//       fromString(str),
//       either.fromOption(() => D.error(str, 'MsDuration')),
//     ),
//   ),
// )
// const fromString = (str: string): Option<MsDuration> =>
//   pipe(
//     option.tryCatch(() => vercelMs(str as StringValue)),
//     option.filter(predicate.not(isNaN)),
//     option.map(wrap),
//   )
const $9caad2ac3e2e8894$var$infinity = $9caad2ac3e2e8894$var$milliseconds(Infinity);
const $9caad2ac3e2e8894$var$seconds = (n)=>$9caad2ac3e2e8894$var$milliseconds(1000 * n);
const $9caad2ac3e2e8894$var$minutes = (n)=>$9caad2ac3e2e8894$var$seconds(60 * n);
const $9caad2ac3e2e8894$var$hours = (n)=>$9caad2ac3e2e8894$var$minutes(60 * n);
const $9caad2ac3e2e8894$var$days = (n)=>$9caad2ac3e2e8894$var$hours(24 * n);
const $9caad2ac3e2e8894$var$fromDate = (date)=>$9caad2ac3e2e8894$var$milliseconds(date.getTime());
const $9caad2ac3e2e8894$var$add = (b)=>(a)=>$9caad2ac3e2e8894$var$milliseconds($9caad2ac3e2e8894$var$unwrap(a) + $9caad2ac3e2e8894$var$unwrap(b));
const $9caad2ac3e2e8894$var$Ord = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap($9caad2ac3e2e8894$var$unwrap));
const $9caad2ac3e2e8894$export$1b670aa85a2d9176 = {
    codec: $9caad2ac3e2e8894$var$codec,
    infinity: // fromStringDecoder,
    // fromString,
    $9caad2ac3e2e8894$var$infinity,
    millisecond: $9caad2ac3e2e8894$var$milliseconds,
    milliseconds: $9caad2ac3e2e8894$var$milliseconds,
    unwrap: $9caad2ac3e2e8894$var$unwrap,
    seconds: $9caad2ac3e2e8894$var$seconds,
    second: $9caad2ac3e2e8894$var$seconds,
    minutes: $9caad2ac3e2e8894$var$minutes,
    minute: $9caad2ac3e2e8894$var$minutes,
    hours: $9caad2ac3e2e8894$var$hours,
    hour: $9caad2ac3e2e8894$var$hours,
    days: $9caad2ac3e2e8894$var$days,
    day: $9caad2ac3e2e8894$var$days,
    fromDate: $9caad2ac3e2e8894$var$fromDate,
    add: $9caad2ac3e2e8894$var$add,
    Ord: $9caad2ac3e2e8894$var$Ord
};

});


parcelRegister("xJ0AO", function(module, exports) {

$parcel$export(module.exports, "decodeError", function () { return $c294daef64f824cc$export$449744f9c2a1ef0d; });
$parcel$export(module.exports, "fromNewtype", function () { return $c294daef64f824cc$export$5ee9f719c2ac1d11; });
$parcel$export(module.exports, "NonEmptyString", function () { return $c294daef64f824cc$export$5e0a9ee3d3833c14; });
$parcel$export(module.exports, "DayJsFromISOString", function () { return $c294daef64f824cc$export$4ad1d7c17da58c9f; });
$parcel$export(module.exports, "URLFromString", function () { return $c294daef64f824cc$export$9e15310cd81d7993; });
$parcel$export(module.exports, "BooleanFromString", function () { return $c294daef64f824cc$export$92cd16fb2cb73b9e; });
$parcel$export(module.exports, "NumberFromString", function () { return $c294daef64f824cc$export$bc32a0669f971f2e; });
$parcel$export(module.exports, "SetFromString", function () { return $c294daef64f824cc$export$b54a41b1bfb1de0e; });
$parcel$export(module.exports, "StrictPartial", function () { return $c294daef64f824cc$export$436dcbd2431a511d; });
$parcel$export(module.exports, "MapFromArray", function () { return $c294daef64f824cc$export$af572413ef85051; });

var $04bl4 = parcelRequire("04bl4");
var $lSBre = parcelRequire("lSBre");
var $8RK6P = parcelRequire("8RK6P");
var $goBZ5 = parcelRequire("goBZ5");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $7wIl1 = parcelRequire("7wIl1");

var $k6yCu = parcelRequire("k6yCu");

var $8Rx1e = parcelRequire("8Rx1e");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");
const $c294daef64f824cc$var$limit = 10000;
const $c294daef64f824cc$export$528aa702d7f7420 = (name)=>(value)=>(error)=>(0, $hrnY6.StringUtils).stripMargins(`Couldn't decode ${name}:
      |Error:
      |${(0, $kj6DU.pipe)($5zWxO.draw(error), (0, $hrnY6.StringUtils).ellipse($c294daef64f824cc$var$limit))}
      |
      |Value: ${(0, $kj6DU.pipe)((0, $04bl4).stringify(value), (0, $9ddGv.Either).getOrElse(()=>`${value}`), (0, $hrnY6.StringUtils).ellipse($c294daef64f824cc$var$limit))}`);
const $c294daef64f824cc$export$449744f9c2a1ef0d = (name)=>(value)=>(error)=>Error($c294daef64f824cc$export$528aa702d7f7420(name)(value)(error));
const $c294daef64f824cc$export$5ee9f719c2ac1d11 = (codec)=>codec;
/**
 * NonEmptyString
 */ const $c294daef64f824cc$var$nonEmptyStringDecoder = (0, $kj6DU.pipe)($5zWxO.string, $5zWxO.refine((str)=>!(0, $gSyeU).isEmpty(str), 'NonEmptyString'));
const $c294daef64f824cc$var$nonEmptyStringEncoder = $aXkbA.id();
const $c294daef64f824cc$var$nonEmptyStringCodec = $7uCHH.make($c294daef64f824cc$var$nonEmptyStringDecoder, $c294daef64f824cc$var$nonEmptyStringEncoder);
const $c294daef64f824cc$export$5e0a9ee3d3833c14 = {
    decoder: $c294daef64f824cc$var$nonEmptyStringDecoder,
    encoder: $c294daef64f824cc$var$nonEmptyStringEncoder,
    codec: $c294daef64f824cc$var$nonEmptyStringCodec
};
/**
 * DayJsFromISOString
 */ const $c294daef64f824cc$var$dayJsFromISOStringDecoder = (0, $kj6DU.pipe)($5zWxO.string, $5zWxO.parse((str)=>{
    const d = (0, $7wIl1.DayJs).of(str);
    return (0, $7wIl1.DayJs).isValid(d) ? $5zWxO.success(d) : $5zWxO.failure(str, 'DayJsFromISOString');
}));
const $c294daef64f824cc$var$dayJsFromISOStringEncoder = {
    encode: (0, $7wIl1.DayJs).toISOString
};
const $c294daef64f824cc$var$dayJsFromISOStringCodec = $7uCHH.make($c294daef64f824cc$var$dayJsFromISOStringDecoder, $c294daef64f824cc$var$dayJsFromISOStringEncoder);
const $c294daef64f824cc$export$4ad1d7c17da58c9f = {
    decoder: $c294daef64f824cc$var$dayJsFromISOStringDecoder,
    encoder: $c294daef64f824cc$var$dayJsFromISOStringEncoder,
    codec: $c294daef64f824cc$var$dayJsFromISOStringCodec
};
/**
 * URLFromString
 */ const $c294daef64f824cc$var$urlFromStringDecoder = (0, $kj6DU.pipe)($5zWxO.string, $5zWxO.parse((s)=>(0, $kj6DU.pipe)((0, $9ddGv.Maybe).tryCatch(()=>new URL(s)), (0, $9ddGv.Maybe).fold(()=>$5zWxO.failure(s, 'URLFromString'), $5zWxO.success))));
const $c294daef64f824cc$export$9e15310cd81d7993 = {
    decoder: $c294daef64f824cc$var$urlFromStringDecoder
};
/**
 * BooleanFromString
 */ const $c294daef64f824cc$var$booleanFromStringDecoder = (0, $kj6DU.pipe)($5zWxO.string, $5zWxO.parse((s)=>s === 'true' ? $5zWxO.success(true) : s === 'false' ? $5zWxO.success(false) : $5zWxO.failure(s, 'BooleanFromString')));
const $c294daef64f824cc$export$92cd16fb2cb73b9e = {
    decoder: $c294daef64f824cc$var$booleanFromStringDecoder
};
/**
 * NumberFromString
 */ const $c294daef64f824cc$var$numberFromStringDecoder = (0, $kj6DU.pipe)($5zWxO.string, $5zWxO.parse((s)=>{
    const n = Number(s);
    return isNaN(n) ? $5zWxO.failure(s, 'NumberFromString') : $5zWxO.success(n);
}));
const $c294daef64f824cc$var$numberFromStringEncoder = (0, $kj6DU.pipe)($aXkbA.id(), $aXkbA.contramap(String));
const $c294daef64f824cc$var$numberFromStringCodec = $7uCHH.make($c294daef64f824cc$var$numberFromStringDecoder, $c294daef64f824cc$var$numberFromStringEncoder);
const $c294daef64f824cc$export$bc32a0669f971f2e = {
    decoder: $c294daef64f824cc$var$numberFromStringDecoder,
    encoder: $c294daef64f824cc$var$numberFromStringEncoder,
    codec: $c294daef64f824cc$var$numberFromStringCodec
};
/**
 * ArrayFromString
 */ const $c294daef64f824cc$var$prepareArray = (separator)=>(0, $kj6DU.flow)((0, $gSyeU).split(separator), (0, $9ddGv.NonEmptyArray).map((0, $gSyeU).trim), (0, $9ddGv.List).filter((0, $lSBre).not((0, $gSyeU).isEmpty)));
const $c294daef64f824cc$var$arrayFromStringDecoder = (separator)=>(decoder)=>(0, $kj6DU.pipe)($5zWxO.string, $5zWxO.map($c294daef64f824cc$var$prepareArray(separator)), $5zWxO.compose((0, $9ddGv.List).decoder(decoder)));
const $c294daef64f824cc$var$arrayFromStringEncoder = (separator)=>(encoder)=>({
            encode: (0, $kj6DU.flow)((0, $9ddGv.List).map(encoder.encode), (0, $9ddGv.List).mkString(separator))
        });
const $c294daef64f824cc$var$arrayFromStringCodec = (separator)=>(codec)=>$7uCHH.make($c294daef64f824cc$var$arrayFromStringDecoder(separator)(codec), $c294daef64f824cc$var$arrayFromStringEncoder(separator)(codec));
const $c294daef64f824cc$export$74c6dc94601093e1 = {
    decoder: $c294daef64f824cc$var$arrayFromStringDecoder,
    encoder: $c294daef64f824cc$var$arrayFromStringEncoder,
    codec: $c294daef64f824cc$var$arrayFromStringCodec
};
/**
 * SetFromString
 */ const $c294daef64f824cc$var$setFromStringDecoder = (separator)=>(decoder, eq_)=>(0, $kj6DU.pipe)($c294daef64f824cc$var$arrayFromStringDecoder(separator)(decoder), $5zWxO.map((0, $goBZ5).fromReadonlyArray(eq_)));
const $c294daef64f824cc$var$setFromStringEncoder = (separator)=>(ord)=>(encoder)=>(0, $kj6DU.pipe)($c294daef64f824cc$var$arrayFromStringEncoder(separator)(encoder), $aXkbA.contramap((0, $goBZ5).toReadonlyArray(ord)));
const $c294daef64f824cc$var$setFromStringCodec = (separator)=>(codec, ord)=>$7uCHH.make($c294daef64f824cc$var$setFromStringDecoder(separator)(codec, ord), $c294daef64f824cc$var$setFromStringEncoder(separator)(ord)(codec));
const $c294daef64f824cc$export$b54a41b1bfb1de0e = {
    decoder: $c294daef64f824cc$var$setFromStringDecoder,
    encoder: $c294daef64f824cc$var$setFromStringEncoder,
    codec: $c294daef64f824cc$var$setFromStringCodec
};
/**
 * NonEmptyArrayFromString
 */ const $c294daef64f824cc$var$nonEmptyArrayFromStringDecoder = (separator)=>(decoder)=>(0, $kj6DU.pipe)($5zWxO.string, $5zWxO.map($c294daef64f824cc$var$prepareArray(separator)), $5zWxO.compose((0, $9ddGv.NonEmptyArray).decoder(decoder)));
const $c294daef64f824cc$export$31b3d0b5e9317fb7 = {
    decoder: $c294daef64f824cc$var$nonEmptyArrayFromStringDecoder
};
/**
 * StrictStruct
 */ const $c294daef64f824cc$var$strictStructDecoder = (properties)=>(0, $kj6DU.pipe)($5zWxO.UnknownRecord, $5zWxO.parse((pjo)=>(0, $kj6DU.pipe)($5zWxO.fromStruct(properties), $5zWxO.parse((res)=>{
            const diff = (0, $kj6DU.pipe)((0, $k6yCu.DictUtils).keys(pjo), (0, $9ddGv.List).difference((0, $gSyeU).Eq)((0, $k6yCu.DictUtils).keys(res)));
            if ((0, $9ddGv.List).isNonEmpty(diff)) return $5zWxO.failure(pjo, $c294daef64f824cc$var$notParsed('StrictStruct', diff));
            return $5zWxO.success(res);
        })).decode(pjo)));
function $c294daef64f824cc$var$notParsed(name, diff) {
    return (0, $kj6DU.pipe)(diff, (0, $9ddGv.List).map(JSON.stringify), (0, $9ddGv.List).mkString(`${name}<{ notParsed: `, ' | ', ' }>'));
}
const $c294daef64f824cc$export$755acf784375ada8 = {
    decoder: $c294daef64f824cc$var$strictStructDecoder
};
/**
 * StrictPartial
 */ const $c294daef64f824cc$var$strictPartialDecoder = (properties)=>(0, $kj6DU.pipe)($5zWxO.UnknownRecord, $5zWxO.parse((pjo)=>(0, $kj6DU.pipe)($5zWxO.fromPartial(properties), $5zWxO.parse((res)=>{
            const diff = (0, $kj6DU.pipe)((0, $k6yCu.DictUtils).keys(pjo), (0, $9ddGv.List).difference((0, $gSyeU).Eq)((0, $k6yCu.DictUtils).keys(res)));
            if ((0, $9ddGv.List).isNonEmpty(diff)) return $5zWxO.failure(pjo, $c294daef64f824cc$var$notParsed('StrictPartial', diff));
            return $5zWxO.success(res);
        })).decode(pjo)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c294daef64f824cc$var$strictPartialCodec = (properties)=>$7uCHH.make($c294daef64f824cc$var$strictPartialDecoder(properties), $aXkbA.partial(properties));
const $c294daef64f824cc$export$436dcbd2431a511d = {
    decoder: $c294daef64f824cc$var$strictPartialDecoder,
    codec: $c294daef64f824cc$var$strictPartialCodec
};
/**
 * StrictTuple
 */ const $c294daef64f824cc$var$strictTupleDecoder = (...components)=>(0, $kj6DU.pipe)($5zWxO.UnknownArray, $5zWxO.refine($c294daef64f824cc$var$refinementFromPredicate((us)=>us.length === components.length), `ArrayOfLength${components.length}`), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $5zWxO.compose($5zWxO.fromTuple(...components)));
const $c294daef64f824cc$export$5b6abe6fe632fddd = {
    decoder: $c294daef64f824cc$var$strictTupleDecoder
};
const $c294daef64f824cc$var$refinementFromPredicate = (0, $kj6DU.identity);
/**
 * SetFromArray
 */ const $c294daef64f824cc$var$setFromArrayDecoder = (eq)=>(decoder)=>(0, $kj6DU.pipe)((0, $9ddGv.List).decoder(decoder), $5zWxO.map((0, $goBZ5).fromReadonlyArray(eq)));
const $c294daef64f824cc$var$setFromArrayEncoder = (encoder)=>(0, $kj6DU.pipe)((0, $9ddGv.List).encoder(encoder), $aXkbA.contramap((as)=>[
            ...as
        ]));
const $c294daef64f824cc$var$setFromArrayCodec = (eq)=>(codec)=>$7uCHH.make($c294daef64f824cc$var$setFromArrayDecoder(eq)(codec), $c294daef64f824cc$var$setFromArrayEncoder(codec));
const $c294daef64f824cc$export$8d90948fe855fc4d = {
    decoder: $c294daef64f824cc$var$setFromArrayDecoder,
    encoder: $c294daef64f824cc$var$setFromArrayEncoder,
    codec: $c294daef64f824cc$var$setFromArrayCodec
};
/**
 * MapFromArray
 */ const $c294daef64f824cc$var$mapFromArrayDecoder = (eq)=>(keyDecoder, valueDecoder)=>(0, $kj6DU.pipe)((0, $9ddGv.List).decoder($5zWxO.tuple(keyDecoder, valueDecoder)), $5zWxO.map((0, $8Rx1e.MapUtils).fromReadonlyArray(eq)));
const $c294daef64f824cc$var$mapFromArrayEncoder = (ord)=>(keyEncoder, valueEncoder)=>(0, $kj6DU.pipe)((0, $9ddGv.List).encoder($aXkbA.readonly($aXkbA.tuple(keyEncoder, valueEncoder))), $aXkbA.contramap((m)=>(0, $8RK6P).toReadonlyArray(ord)(m)));
const $c294daef64f824cc$var$mapFromArrayCodec = (ord)=>(keyCodec, valueCodec)=>$7uCHH.make($c294daef64f824cc$var$mapFromArrayDecoder(ord)(keyCodec, valueCodec), $c294daef64f824cc$var$mapFromArrayEncoder(ord)(keyCodec, valueCodec));
const $c294daef64f824cc$export$af572413ef85051 = {
    decoder: $c294daef64f824cc$var$mapFromArrayDecoder,
    encoder: $c294daef64f824cc$var$mapFromArrayEncoder,
    codec: $c294daef64f824cc$var$mapFromArrayCodec
};

});
parcelRegister("04bl4", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $00c92b7be7b1d129$export$98e6a39c04603d36; });
$parcel$export(module.exports, "stringify", function () { return $00c92b7be7b1d129$export$fac44ee5b035f737; });
/**
 * @since 2.10.0
 */ 
var $7Rbab = parcelRequire("7Rbab");

var $kj6DU = parcelRequire("kj6DU");
var $00c92b7be7b1d129$export$98e6a39c04603d36 = function(s) {
    return (0, $7Rbab.tryCatch)(function() {
        return JSON.parse(s);
    }, (0, $kj6DU.identity));
};
var $00c92b7be7b1d129$export$fac44ee5b035f737 = function(a) {
    return (0, $7Rbab.tryCatch)(function() {
        var s = JSON.stringify(a);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, (0, $kj6DU.identity));
};

});

parcelRegister("7wIl1", function(module, exports) {

$parcel$export(module.exports, "DayJs", function () { return $a4baef91e0508113$export$e8e34f7172c7371a; });

var $13Rru = parcelRequire("13Rru");
parcelRequire("cJaKm");

var $gQe25 = parcelRequire("gQe25");

var $90VJL = parcelRequire("90VJL");

var $9vqIZ = parcelRequire("9vqIZ");

var $OFl2v = parcelRequire("OFl2v");
var $hOuM2 = parcelRequire("hOuM2");

var $kj6DU = parcelRequire("kj6DU");

var $hp7yq = parcelRequire("hp7yq");

var $hPJN4 = parcelRequire("hPJN4");
/* eslint-disable functional/no-expression-statements */ (0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gQe25))));
(0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).extend((0, (/*@__PURE__*/$parcel$interopDefault($9vqIZ))));
(0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).extend((0, (/*@__PURE__*/$parcel$interopDefault($90VJL))));
(0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).locale('fr') // TODO: always FR?
;
const { wrap: $a4baef91e0508113$var$wrap, unwrap: $a4baef91e0508113$var$unwrap } = (0, $hp7yq.iso)();
const $a4baef91e0508113$var$modify = (0, $kj6DU.identity);
function $a4baef91e0508113$var$of(date, format, { locale: locale = false } = {}) {
    return $a4baef91e0508113$var$wrap((locale ? (0, (/*@__PURE__*/$parcel$interopDefault($13Rru))) : (0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).utc)(date, format, true));
}
const $a4baef91e0508113$var$now = (0, $kj6DU.pipe)((0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).utc, (0, $OFl2v).map($a4baef91e0508113$var$wrap));
// tests
const $a4baef91e0508113$var$isValid = (date)=>$a4baef91e0508113$var$unwrap(date).isValid();
const $a4baef91e0508113$var$isHourSharp = (h)=>(date)=>$a4baef91e0508113$var$hour.get(date) === h && $a4baef91e0508113$var$minute.get(date) === 0;
// modifiers
const $a4baef91e0508113$var$add = (ms)=>$a4baef91e0508113$var$modify((d)=>d.add((0, $hPJN4.MsDuration).unwrap(ms), 'millisecond'));
const $a4baef91e0508113$var$subtract = (ms)=>$a4baef91e0508113$var$modify((d)=>d.subtract((0, $hPJN4.MsDuration).unwrap(ms), 'millisecond'));
const $a4baef91e0508113$var$startOf = (unit)=>$a4baef91e0508113$var$modify((d)=>d.startOf(unit));
const $a4baef91e0508113$var$format = (template, { locale: locale = false } = {})=>(date)=>{
        const unwrapped = $a4baef91e0508113$var$unwrap(date);
        return (locale ? unwrapped.local() : unwrapped).format(template);
    };
const $a4baef91e0508113$var$toDate = (date)=>$a4baef91e0508113$var$unwrap(date).toDate();
const $a4baef91e0508113$var$toISOString = (date)=>$a4baef91e0508113$var$unwrap(date).toISOString();
const $a4baef91e0508113$var$unix = (date)=>$a4baef91e0508113$var$unwrap(date).unix();
const $a4baef91e0508113$var$unixMs = (date)=>(0, $hPJN4.MsDuration).milliseconds($a4baef91e0508113$var$unwrap(date).valueOf());
function $a4baef91e0508113$var$diff(b, unit) {
    return (a)=>unit === undefined ? (0, $hPJN4.MsDuration).milliseconds($a4baef91e0508113$var$unwrap(a).diff($a4baef91e0508113$var$unwrap(b))) : $a4baef91e0508113$var$unwrap(a).diff($a4baef91e0508113$var$unwrap(b), unit);
}
// Ord
const $a4baef91e0508113$var$Ord = (0, $hOuM2).fromCompare((first, second)=>{
    const f = $a4baef91e0508113$var$unwrap(first);
    const s = $a4baef91e0508113$var$unwrap(second);
    if (f.isSame(s)) return 0;
    if (f.isBefore(s)) return -1;
    return 1;
});
// Eq
const $a4baef91e0508113$var$Eq = $a4baef91e0508113$var$Ord;
// Lens
const $a4baef91e0508113$var$year = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).year(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.year(n))
};
const $a4baef91e0508113$var$month = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).month(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.month(n))
};
// date of month
const $a4baef91e0508113$var$date = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).date(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.date(n))
};
// day of week
const $a4baef91e0508113$var$day = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).day(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.day(n))
};
const $a4baef91e0508113$var$hour = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).hour(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.hour(n))
};
const $a4baef91e0508113$var$minute = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).minute(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.minute(n))
};
const $a4baef91e0508113$var$second = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).second(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.second(n))
};
const $a4baef91e0508113$var$millisecond = {
    get: (d)=>$a4baef91e0508113$var$unwrap(d).millisecond(),
    set: (n)=>$a4baef91e0508113$var$modify((d)=>d.millisecond(n))
};
const $a4baef91e0508113$export$e8e34f7172c7371a = {
    of: $a4baef91e0508113$var$of,
    now: $a4baef91e0508113$var$now,
    isValid: $a4baef91e0508113$var$isValid,
    isHourSharp: $a4baef91e0508113$var$isHourSharp,
    add: $a4baef91e0508113$var$add,
    subtract: $a4baef91e0508113$var$subtract,
    startOf: $a4baef91e0508113$var$startOf,
    format: $a4baef91e0508113$var$format,
    toDate: $a4baef91e0508113$var$toDate,
    toISOString: $a4baef91e0508113$var$toISOString,
    unix: $a4baef91e0508113$var$unix,
    unixMs: $a4baef91e0508113$var$unixMs,
    diff: $a4baef91e0508113$var$diff,
    unwrap: $a4baef91e0508113$var$unwrap,
    Eq: $a4baef91e0508113$var$Eq,
    Ord: $a4baef91e0508113$var$Ord,
    year: $a4baef91e0508113$var$year,
    month: $a4baef91e0508113$var$month,
    date: $a4baef91e0508113$var$date,
    day: $a4baef91e0508113$var$day,
    hour: $a4baef91e0508113$var$hour,
    minute: $a4baef91e0508113$var$minute,
    second: $a4baef91e0508113$var$second,
    millisecond: $a4baef91e0508113$var$millisecond,
    Duration: {
        formatSeconds: (s)=>(0, (/*@__PURE__*/$parcel$interopDefault($13Rru))).duration(s, 'seconds').format('m:ss')
    }
};

});
parcelRegister("13Rru", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("cJaKm", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("13Rru")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), i = {
        name: "fr",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        ordinal: function(e) {
            return "" + e + (1 === e ? "er" : "");
        }
    };
    return t.default.locale(i, null, !0), i;
});

});

parcelRegister("gQe25", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("90VJL", function(module, exports) {
!function(t, s) {
    module.exports = s();
}(module.exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

});

parcelRegister("9vqIZ", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});


parcelRegister("k6yCu", function(module, exports) {

$parcel$export(module.exports, "DictUtils", function () { return $4475e0f8f5240d96$export$df53bd4d4dca8e93; });
const $4475e0f8f5240d96$export$df53bd4d4dca8e93 = {
    entries: Object.entries,
    keys: Object.keys,
    values: Object.values,
    partial: {
        entries: Object.entries,
        values: Object.values
    }
};

});

parcelRegister("8Rx1e", function(module, exports) {

$parcel$export(module.exports, "MapUtils", function () { return $81cefc532332ec9e$export$947bf818db604d74; });

var $8RK6P = parcelRequire("8RK6P");
var $flrom = parcelRequire("flrom");

var $9ddGv = parcelRequire("9ddGv");
const $81cefc532332ec9e$var$fromReadonlyArray = (eq)=>(fa)=>(0, $8RK6P).fromFoldable(eq, (0, $flrom).last(), (0, $9ddGv.List).Foldable)(fa);
const $81cefc532332ec9e$export$947bf818db604d74 = {
    fromReadonlyArray: $81cefc532332ec9e$var$fromReadonlyArray
};

});

parcelRegister("hrnY6", function(module, exports) {

$parcel$export(module.exports, "StringUtils", function () { return $291e7e7ef0e7105d$export$ecc754f99843e759; });

var $kj6DU = parcelRequire("kj6DU");

var $7wIl1 = parcelRequire("7wIl1");

var $hPJN4 = parcelRequire("hPJN4");

var $9ddGv = parcelRequire("9ddGv");
const $291e7e7ef0e7105d$var$margin = /^\s*\|/gm;
const $291e7e7ef0e7105d$var$stripMargins = (str)=>str.replace($291e7e7ef0e7105d$var$margin, '');
const $291e7e7ef0e7105d$var$ellipse = (take)=>(str)=>take < str.length && 3 <= take ? `${str.slice(0, take - 3)}...` : str;
const $291e7e7ef0e7105d$var$matcher = (regex, f)=>(str)=>(0, $kj6DU.pipe)(str.match(regex), (0, $9ddGv.Maybe).fromNullable, (0, $9ddGv.Maybe).map(f));
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $291e7e7ef0e7105d$var$matcher1 = (regex)=>$291e7e7ef0e7105d$var$matcher(regex, ([, a])=>a);
const $291e7e7ef0e7105d$var$matcher2 = (regex)=>$291e7e7ef0e7105d$var$matcher(regex, ([, a, b])=>[
            a,
            b
        ]);
const $291e7e7ef0e7105d$var$matcher3 = (regex)=>$291e7e7ef0e7105d$var$matcher(regex, ([, a, b, c])=>[
            a,
            b,
            c
        ]);
const $291e7e7ef0e7105d$var$padStart = (maxLength)=>(n)=>`${n}`.padStart(maxLength, '0');
const $291e7e7ef0e7105d$var$pad10 = $291e7e7ef0e7105d$var$padStart(2);
const $291e7e7ef0e7105d$var$pad100 = $291e7e7ef0e7105d$var$padStart(3);
const $291e7e7ef0e7105d$var$cleanUTF8ToASCII = (str)=>str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $291e7e7ef0e7105d$var$whiteSpaces = /\s+/g;
const $291e7e7ef0e7105d$var$cleanWhitespaces = (str)=>str.replace($291e7e7ef0e7105d$var$whiteSpaces, ' ');
const $291e7e7ef0e7105d$var$nonAZ = /[^a-z]/g;
const $291e7e7ef0e7105d$var$cleanChampionName = (name)=>$291e7e7ef0e7105d$export$ecc754f99843e759.cleanUTF8ToASCII(name).toLowerCase().replaceAll($291e7e7ef0e7105d$var$nonAZ, '');
const $291e7e7ef0e7105d$var$cleanHtml = (str)=>$291e7e7ef0e7105d$var$cleanWhitespaces(str// newline please
    .trim().normalize());
const $291e7e7ef0e7105d$var$prettyMs = (ms)=>{
    const date = (0, $7wIl1.DayJs).of((0, $hPJN4.MsDuration).unwrap(ms));
    const zero = (0, $7wIl1.DayJs).of(0);
    const d = (0, $kj6DU.pipe)(date, (0, $7wIl1.DayJs).diff(zero, 'days'));
    const h = (0, $7wIl1.DayJs).hour.get(date);
    const m = (0, $7wIl1.DayJs).minute.get(date);
    const s = (0, $7wIl1.DayJs).second.get(date);
    const ms_ = (0, $7wIl1.DayJs).millisecond.get(date);
    if (d !== 0) return `${d}d${$291e7e7ef0e7105d$var$pad10(h)}h${$291e7e7ef0e7105d$var$pad10(m)}'${$291e7e7ef0e7105d$var$pad10(s)}.${$291e7e7ef0e7105d$var$pad100(ms_)}"`;
    if (h !== 0) return `${$291e7e7ef0e7105d$var$pad10(h)}h${$291e7e7ef0e7105d$var$pad10(m)}'${$291e7e7ef0e7105d$var$pad10(s)}.${$291e7e7ef0e7105d$var$pad100(ms_)}"`;
    if (m !== 0) return `${$291e7e7ef0e7105d$var$pad10(m)}'${$291e7e7ef0e7105d$var$pad10(s)}.${$291e7e7ef0e7105d$var$pad100(ms_)}"`;
    return `${$291e7e7ef0e7105d$var$pad10(s)}.${$291e7e7ef0e7105d$var$pad100(ms_)}"`;
};
const $291e7e7ef0e7105d$var$toLowerCase = (str)=>str.toLowerCase();
const $291e7e7ef0e7105d$var$toUpperCase = (str)=>str.toUpperCase();
const $291e7e7ef0e7105d$export$ecc754f99843e759 = {
    ellipse: $291e7e7ef0e7105d$var$ellipse,
    matcher1: $291e7e7ef0e7105d$var$matcher1,
    matcher2: $291e7e7ef0e7105d$var$matcher2,
    matcher3: $291e7e7ef0e7105d$var$matcher3,
    stripMargins: $291e7e7ef0e7105d$var$stripMargins,
    pad10: $291e7e7ef0e7105d$var$pad10,
    cleanUTF8ToASCII: $291e7e7ef0e7105d$var$cleanUTF8ToASCII,
    cleanChampionName: $291e7e7ef0e7105d$var$cleanChampionName,
    cleanHtml: $291e7e7ef0e7105d$var$cleanHtml,
    prettyMs: $291e7e7ef0e7105d$var$prettyMs,
    toLowerCase: $291e7e7ef0e7105d$var$toLowerCase,
    toUpperCase: $291e7e7ef0e7105d$var$toUpperCase
};

});


parcelRegister("fcoXO", function(module, exports) {

$parcel$export(module.exports, "StaticDataContextProvider", function () { return $8410ddc83e8edbdb$export$33d831eb72d359f8; });
$parcel$export(module.exports, "useStaticData", function () { return $8410ddc83e8edbdb$export$221db652f891ae59; });
/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $exYeM = parcelRequire("exYeM");

var $cn7Rc = parcelRequire("cn7Rc");

var $i92em = parcelRequire("i92em");

var $632HS = parcelRequire("632HS");

var $k1y2D = parcelRequire("k1y2D");

var $52dbH = parcelRequire("52dbH");

var $javAY = parcelRequire("javAY");

var $9ddGv = parcelRequire("9ddGv");

var $kJ6py = parcelRequire("kJ6py");

var $cmF7r = parcelRequire("cmF7r");

var $bN7FL = parcelRequire("bN7FL");

var $hZroh = parcelRequire("hZroh");
const { ddragonCdn: $8410ddc83e8edbdb$var$ddragonCdn } = (0, $52dbH.DDragonUtils);
const $8410ddc83e8edbdb$var$StaticDataContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
const $8410ddc83e8edbdb$export$33d831eb72d359f8 = ({ children: children })=>{
    const { lang: lang } = (0, $hZroh.useTranslation)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
        ...(0, $cmF7r.useSWRHttp)((0, $cn7Rc.apiRoutes).staticData(lang).get, {}, [
            (0, $i92em.ValidatedSoft).decoder((0, $k1y2D.StaticData).codec, $5zWxO.string),
            'ValidatedSoft<StaticData, string>'
        ], {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }),
        children: (data)=>/*#__PURE__*/ (0, $aSiaI.jsx)($8410ddc83e8edbdb$var$StaticDataLoaded, {
                data: data,
                children: children
            })
    });
};
const $8410ddc83e8edbdb$var$StaticDataLoaded = ({ data: data, children: children })=>{
    const { version: version, champions: champions } = data.value;
    const { showToaster: showToaster } = (0, $bN7FL.useToaster)();
    (0, $exYeM.useEffect)(()=>{
        if ((0, $9ddGv.List).isNonEmpty(data.errors)) {
            console.warn((0, $9ddGv.List).mkString('Static data errors:\n- ', '\n- ', '\n')(data.errors));
            showToaster('warn', 'Static data warning');
        }
    }, [
        data.errors,
        showToaster
    ]);
    const championByKey = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(champions, (0, $javAY.ListUtils).findFirstBy((0, $632HS.ChampionKey).Eq)((c)=>c.key)), [
        champions
    ]);
    const value = {
        champions: champions,
        championByKey: championByKey,
        assets: {
            champion: {
                square: (0, $kj6DU.flow)(championByKey, (0, $9ddGv.Maybe).map((c)=>c.id), (0, $9ddGv.Maybe).toNullable, (name)=>$8410ddc83e8edbdb$var$ddragonCdn(version, `/img/champion/${name}.png`))
            },
            summonerIcon: (iconId)=>$8410ddc83e8edbdb$var$ddragonCdn(version, `/img/profileicon/${iconId}.png`),
            summonerSpell: (spellId)=>$8410ddc83e8edbdb$var$ddragonCdn(version, `/img/spell/${spellId}.png`),
            item: (itemId)=>$8410ddc83e8edbdb$var$ddragonCdn(version, `/img/item/${itemId}.png`)
        }
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)($8410ddc83e8edbdb$var$StaticDataContext.Provider, {
        value: value,
        children: children
    });
};
const $8410ddc83e8edbdb$export$221db652f891ae59 = ()=>{
    const context = (0, $exYeM.useContext)($8410ddc83e8edbdb$var$StaticDataContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useStaticData must be used within a StaticDataContextProvider');
    return context;
};

});
parcelRegister("cn7Rc", function(module, exports) {

$parcel$export(module.exports, "apiRoutes", function () { return $4f966a2f6a742273$export$926815f3873d207a; });

var $61eNN = parcelRequire("61eNN");
var $9fMqj = parcelRequire("9fMqj");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $bWyUJ = parcelRequire("bWyUJ");

var $aPuMp = parcelRequire("aPuMp");

var $5Dwzl = parcelRequire("5Dwzl");

var $7pd72 = parcelRequire("7pd72");

var $kaLCO = parcelRequire("kaLCO");

var $appXD = parcelRequire("appXD");

var $gkOpi = parcelRequire("gkOpi");

var $87QkX = parcelRequire("87QkX");

var $xJ0AO = parcelRequire("xJ0AO");
const { codec: $4f966a2f6a742273$var$codec } = (0, $87QkX.RouterUtils);
/**
 * matches
 */ // intermediate
const $4f966a2f6a742273$var$langM = $4f966a2f6a742273$var$codec('lang', (0, $aPuMp.Lang).codec);
const $4f966a2f6a742273$var$platformM = $4f966a2f6a742273$var$codec('platform', (0, $5Dwzl.Platform).codec);
const $4f966a2f6a742273$var$puuidM = $4f966a2f6a742273$var$codec('puuid', (0, $7pd72.Puuid).codec);
const $4f966a2f6a742273$var$riotIdM = $4f966a2f6a742273$var$codec('gameName', (0, $kaLCO.GameName).codec).then($4f966a2f6a742273$var$codec('tagLine', (0, $gkOpi.TagLine).codec)).imap(({ gameName: gameName, tagLine: tagLine })=>({
        riotId: (0, $appXD.RiotId)(gameName, tagLine)
    }), ({ riotId: riotId })=>riotId);
const $4f966a2f6a742273$var$gameIdM = $4f966a2f6a742273$var$codec('gameId', (0, $kj6DU.pipe)((0, $xJ0AO.NumberFromString).codec, $7uCHH.compose((0, $bWyUJ.GameId).codec)));
const $4f966a2f6a742273$var$api = (0, $61eNN.lit)('api');
const $4f966a2f6a742273$var$staticDataLang = $4f966a2f6a742273$var$api.then((0, $61eNN.lit)('staticData')).then($4f966a2f6a742273$var$langM);
const $4f966a2f6a742273$var$summoner = $4f966a2f6a742273$var$api.then((0, $61eNN.lit)('summoner'));
const $4f966a2f6a742273$var$summonerByPuuid = $4f966a2f6a742273$var$summoner.then((0, $61eNN.lit)('byPuuid')).then($4f966a2f6a742273$var$platformM).then($4f966a2f6a742273$var$puuidM);
const $4f966a2f6a742273$var$summonerByRiotId = $4f966a2f6a742273$var$summoner.then((0, $61eNN.lit)('byRiotId')).then($4f966a2f6a742273$var$platformM).then($4f966a2f6a742273$var$riotIdM);
const $4f966a2f6a742273$var$user = $4f966a2f6a742273$var$api.then((0, $61eNN.lit)('user'));
const $4f966a2f6a742273$var$userSelf = $4f966a2f6a742273$var$user.then((0, $61eNN.lit)('self'));
const $4f966a2f6a742273$var$userSelfFavorites = $4f966a2f6a742273$var$userSelf.then((0, $61eNN.lit)('favorites'));
const $4f966a2f6a742273$var$userLogin = $4f966a2f6a742273$var$user.then((0, $61eNN.lit)('login'));
const $4f966a2f6a742273$var$userRegister = $4f966a2f6a742273$var$user.then((0, $61eNN.lit)('register'));
const $4f966a2f6a742273$var$admin = $4f966a2f6a742273$var$api.then((0, $61eNN.lit)('admin'));
const $4f966a2f6a742273$var$adminHallOfFame = $4f966a2f6a742273$var$admin.then((0, $61eNN.lit)('hallOfFame'));
const $4f966a2f6a742273$var$madosayentisuto = $4f966a2f6a742273$var$api.then((0, $61eNN.lit)('madosayentisuto'));
// final
const $4f966a2f6a742273$var$healthcheckGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$api.then((0, $61eNN.lit)('healthcheck')), 'get');
const $4f966a2f6a742273$var$staticDataLangGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$staticDataLang, 'get');
const $4f966a2f6a742273$var$staticDataLangAdditionalGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$staticDataLang.then((0, $61eNN.lit)('additional')), 'get');
const $4f966a2f6a742273$var$summonerByPuuidGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByPuuid, 'get');
const $4f966a2f6a742273$var$summonerByPuuidMasteriesGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByPuuid.then((0, $61eNN.lit)('masteries')), 'get');
const $4f966a2f6a742273$var$summonerByPuuidChallengesGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByPuuid.then((0, $61eNN.lit)('challenges')), 'get');
const $4f966a2f6a742273$var$summonerByPuuidActiveGameLangGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByPuuid.then((0, $61eNN.lit)('activeGame').then($4f966a2f6a742273$var$langM)), 'get');
const $4f966a2f6a742273$var$summonerByRiotIdGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByRiotId, 'get');
const $4f966a2f6a742273$var$summonerByRiotIdMasteriesGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByRiotId.then((0, $61eNN.lit)('masteries')), 'get');
const $4f966a2f6a742273$var$summonerByRiotIdActiveGameLangGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$summonerByRiotId.then((0, $61eNN.lit)('activeGame').then($4f966a2f6a742273$var$langM)), 'get');
const $4f966a2f6a742273$var$userSelfGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userSelf, 'get');
const $4f966a2f6a742273$var$userSelfFavoritesPut = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userSelfFavorites, 'put');
const $4f966a2f6a742273$var$userSelfFavoritesDelete = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userSelfFavorites, 'delete');
const $4f966a2f6a742273$var$userSelfSummonerChampionsShardsCountPost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userSelf.then((0, $61eNN.lit)('summoner')).then($4f966a2f6a742273$var$platformM).then($4f966a2f6a742273$var$puuidM).then((0, $61eNN.lit)('championsShardsCount')), 'post');
const $4f966a2f6a742273$var$userLoginDiscordPost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userLogin.then((0, $61eNN.lit)('discord')), 'post');
const $4f966a2f6a742273$var$userLoginPasswordPost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userLogin.then((0, $61eNN.lit)('password')), 'post');
const $4f966a2f6a742273$var$userLogoutPost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$user.then((0, $61eNN.lit)('logout')), 'post');
const $4f966a2f6a742273$var$userRegisterPasswordPost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$userRegister.then((0, $61eNN.lit)('password')), 'post');
const $4f966a2f6a742273$var$adminHallOfFameGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$adminHallOfFame, 'get');
const $4f966a2f6a742273$var$adminHallOfFamePost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$adminHallOfFame, 'post');
const $4f966a2f6a742273$var$madosayentisutoStaticDataGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$madosayentisuto.then((0, $61eNN.lit)('staticData')), 'get');
const $4f966a2f6a742273$var$madosayentisutoMatchGet = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$madosayentisuto.then((0, $61eNN.lit)('match').then($4f966a2f6a742273$var$platformM).then($4f966a2f6a742273$var$gameIdM)), 'get');
const $4f966a2f6a742273$var$madosayentisutoUsersGetProgressionPost = $4f966a2f6a742273$var$m($4f966a2f6a742273$var$madosayentisuto.then((0, $61eNN.lit)('users')).then((0, $61eNN.lit)('getProgression')), 'post');
const $4f966a2f6a742273$export$1506055a580f4d6d = {
    healthcheck: {
        get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$healthcheckGet)
    },
    staticData: {
        lang: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$staticDataLangGet),
            additional: {
                get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$staticDataLangAdditionalGet)
            }
        }
    },
    summoner: {
        byPuuid: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByPuuidGet),
            masteries: {
                get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByPuuidMasteriesGet)
            },
            challenges: {
                get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByPuuidChallengesGet)
            },
            activeGame: {
                lang: {
                    get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByPuuidActiveGameLangGet)
                }
            }
        },
        byRiotId: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByRiotIdGet),
            masteries: {
                get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByRiotIdMasteriesGet)
            },
            activeGame: {
                lang: {
                    get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$summonerByRiotIdActiveGameLangGet)
                }
            }
        }
    },
    user: {
        self: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userSelfGet),
            favorites: {
                put: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userSelfFavoritesPut),
                delete: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userSelfFavoritesDelete)
            },
            summoner: {
                championsShardsCount: {
                    post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userSelfSummonerChampionsShardsCountPost)
                }
            }
        },
        login: {
            discord: {
                post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userLoginDiscordPost)
            },
            password: {
                post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userLoginPasswordPost)
            }
        },
        logout: {
            post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userLogoutPost)
        },
        register: {
            password: {
                post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$userRegisterPasswordPost)
            }
        }
    },
    admin: {
        hallOfFame: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$adminHallOfFameGet),
            post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$adminHallOfFamePost)
        }
    },
    madosayentisuto: {
        staticData: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$madosayentisutoStaticDataGet)
        },
        match: {
            get: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$madosayentisutoMatchGet)
        },
        users: {
            getProgression: {
                post: $4f966a2f6a742273$var$p($4f966a2f6a742273$var$madosayentisutoUsersGetProgressionPost)
            }
        }
    }
};
const $4f966a2f6a742273$export$926815f3873d207a = {
    staticData: (lang)=>({
            get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$staticDataLangGet, {
                lang: lang
            }),
            additional: {
                get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$staticDataLangAdditionalGet, {
                    lang: lang
                })
            }
        }),
    summoner: {
        byPuuid: (platform)=>(puuid)=>({
                    masteries: {
                        get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$summonerByPuuidMasteriesGet, {
                            platform: platform,
                            puuid: puuid
                        })
                    },
                    challenges: {
                        get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$summonerByPuuidChallengesGet, {
                            platform: platform,
                            puuid: puuid
                        })
                    },
                    activeGame: (lang)=>({
                            get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$summonerByPuuidActiveGameLangGet, {
                                platform: platform,
                                puuid: puuid,
                                lang: lang
                            })
                        })
                }),
        byRiotId: (platform)=>(riotId_)=>{
                const riotId = (0, $appXD.RiotId).clean(riotId_);
                return {
                    get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$summonerByRiotIdGet, {
                        platform: platform,
                        riotId: riotId
                    }),
                    masteries: {
                        get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$summonerByRiotIdMasteriesGet, {
                            platform: platform,
                            riotId: riotId
                        })
                    },
                    activeGame: (lang)=>({
                            get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$summonerByRiotIdActiveGameLangGet, {
                                platform: platform,
                                riotId: riotId,
                                lang: lang
                            })
                        })
                };
            }
    },
    user: {
        self: {
            get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userSelfGet, {}),
            favorites: {
                put: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userSelfFavoritesPut, {}),
                delete: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userSelfFavoritesDelete, {})
            },
            summoner: (platform)=>(puuid)=>({
                        championsShardsCount: {
                            post: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userSelfSummonerChampionsShardsCountPost, {
                                platform: platform,
                                puuid: puuid
                            })
                        }
                    })
        },
        login: {
            discord: {
                post: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userLoginDiscordPost, {})
            },
            password: {
                post: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userLoginPasswordPost, {})
            }
        },
        logout: {
            post: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userLogoutPost, {})
        },
        register: {
            password: {
                post: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$userRegisterPasswordPost, {})
            }
        }
    },
    admin: {
        hallOfFame: {
            get: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$adminHallOfFameGet, {}),
            post: $4f966a2f6a742273$var$r($4f966a2f6a742273$var$adminHallOfFamePost, {})
        }
    }
};
// Match with Method
function $4f966a2f6a742273$var$m(match, method) {
    return [
        match.then((0, $61eNN.end)),
        method
    ];
}
// Parser with Method
function $4f966a2f6a742273$var$p([match, method]) {
    return [
        match.parser,
        method
    ];
}
// Route with Method
function $4f966a2f6a742273$var$r([match, method], a) {
    return [
        (0, $9fMqj.format)(match.formatter, a),
        method
    ];
}

});
parcelRegister("61eNN", function(module, exports) {

$parcel$export(module.exports, "Match", function () { return $461e517575f15437$export$f421feb8fad20413; });
$parcel$export(module.exports, "end", function () { return $461e517575f15437$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "lit", function () { return $461e517575f15437$export$f9c0624c04b6af9f; });
/**
 * @since 0.6.0
 */ 
var $7Rbab = parcelRequire("7Rbab");

var $kj6DU = parcelRequire("kj6DU");

var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");

var $cQECE = parcelRequire("cQECE");

var $9fMqj = parcelRequire("9fMqj");

var $idTJH = parcelRequire("idTJH");

var $2MDjk = parcelRequire("2MDjk");
/**
 * @category matchers
 * @since 0.4.0
 */ var $461e517575f15437$export$f421feb8fad20413 = /** @class */ function() {
    function Match(parser, formatter) {
        this.parser = parser;
        this.formatter = formatter;
    }
    /**
     * @since 0.4.0
     */ Match.prototype.imap = function(f, g) {
        return new Match(this.parser.map(f), this.formatter.contramap(g));
    };
    /**
     * @since 0.4.0
     */ Match.prototype.then = function(that) {
        return new Match(this.parser.then(that.parser), this.formatter.then(that.formatter));
    };
    return Match;
}();
var $461e517575f15437$export$b2517b0ab3a58435 = function(f, g) {
    return function(ma) {
        return ma.imap(f, g);
    };
};
var $461e517575f15437$export$ff2899a39f81dcfa = function(mb) {
    return function(ma) {
        return ma.then(mb);
    };
};
var $461e517575f15437$var$singleton = function(k, v) {
    var _a;
    return _a = {}, _a[k] = v, _a;
};
var $461e517575f15437$export$9094b7742a87955e = function(a) {
    return new $461e517575f15437$export$f421feb8fad20413(new (0, $idTJH.Parser)(function(r) {
        return $3NXK3.some([
            a,
            r
        ]);
    }), new (0, $9fMqj.Formatter)((0, $kj6DU.identity)));
};
var $461e517575f15437$export$bd5df0f255a350f8 = new $461e517575f15437$export$f421feb8fad20413(new (0, $idTJH.Parser)(function(r) {
    return (0, $2MDjk.Route).isEmpty(r) ? $3NXK3.some([
        {},
        r
    ]) : $3NXK3.none;
}), new (0, $9fMqj.Formatter)((0, $kj6DU.identity)));
var $461e517575f15437$export$bf9fb029d174d554 = function(k, type) {
    return new $461e517575f15437$export$f421feb8fad20413(new (0, $idTJH.Parser)(function(r) {
        if (r.parts.length === 0) return $3NXK3.none;
        return (0, $6piwk.pipe)(type.decode(r.parts[0]), $3NXK3.fromEither, $3NXK3.map(function(a) {
            return [
                $461e517575f15437$var$singleton(k, a),
                new (0, $2MDjk.Route)(r.parts.slice(1), r.query)
            ];
        }));
    }), new (0, $9fMqj.Formatter)(function(r, o) {
        return new (0, $2MDjk.Route)(r.parts.concat(type.encode(o[k])), r.query);
    }));
};
var $461e517575f15437$export$42d51816ce590c93 = function(k) {
    return $461e517575f15437$export$bf9fb029d174d554(k, (0, $cQECE.string));
};
var $461e517575f15437$export$74614f128b444bd0 = new (0, $cQECE.Type)('IntegerFromString', function(u) {
    return (0, $cQECE.Int).is(u);
}, function(u, c) {
    return (0, $6piwk.pipe)((0, $cQECE.string).validate(u, c), $7Rbab.chain(function(s) {
        var n = +s;
        return isNaN(n) || !Number.isInteger(n) ? (0, $cQECE.failure)(s, c) : (0, $cQECE.success)(n);
    }));
}, String);
var $461e517575f15437$export$7d260a2a5f8bc19e = function(k) {
    return $461e517575f15437$export$bf9fb029d174d554(k, $461e517575f15437$export$74614f128b444bd0);
};
var $461e517575f15437$export$f9c0624c04b6af9f = function(literal) {
    return new $461e517575f15437$export$f421feb8fad20413(new (0, $idTJH.Parser)(function(r) {
        if (r.parts.length === 0) return $3NXK3.none;
        return r.parts[0] === literal ? $3NXK3.some([
            {},
            new (0, $2MDjk.Route)(r.parts.slice(1), r.query)
        ]) : $3NXK3.none;
    }), new (0, $9fMqj.Formatter)(function(r) {
        return new (0, $2MDjk.Route)(r.parts.concat(literal), r.query);
    }));
};
var $461e517575f15437$export$2fa187e846a241c4 = function(type) {
    return new $461e517575f15437$export$f421feb8fad20413(new (0, $idTJH.Parser)(function(r) {
        return (0, $6piwk.pipe)(type.decode(r.query), $3NXK3.fromEither, $3NXK3.map(function(query) {
            return [
                query,
                new (0, $2MDjk.Route)(r.parts, {})
            ];
        }));
    }), new (0, $9fMqj.Formatter)(function(r, query) {
        return new (0, $2MDjk.Route)(r.parts, type.encode(query));
    }));
};

});
parcelRegister("cQECE", function(module, exports) {

$parcel$export(module.exports, "failure", function () { return $95a9da22a3dbeafd$export$af2dba6db4e9e1f0; });
$parcel$export(module.exports, "success", function () { return $95a9da22a3dbeafd$export$fe7c49d056ea1d88; });
$parcel$export(module.exports, "Type", function () { return $95a9da22a3dbeafd$export$92738401e1603719; });
$parcel$export(module.exports, "string", function () { return $95a9da22a3dbeafd$export$22b082955e083ec3; });
$parcel$export(module.exports, "Int", function () { return $95a9da22a3dbeafd$export$fdd676b64b72b00; });

var $7Rbab = parcelRequire("7Rbab");
var $95a9da22a3dbeafd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $95a9da22a3dbeafd$var$__assign = undefined && undefined.__assign || function() {
    $95a9da22a3dbeafd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95a9da22a3dbeafd$var$__assign.apply(this, arguments);
};
var $95a9da22a3dbeafd$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $95a9da22a3dbeafd$export$fd43912fe64ec8ed = (0, $7Rbab.left);
var $95a9da22a3dbeafd$export$af2dba6db4e9e1f0 = function(value, context, message) {
    return $95a9da22a3dbeafd$export$fd43912fe64ec8ed([
        {
            value: value,
            context: context,
            message: message
        }
    ]);
};
var $95a9da22a3dbeafd$export$fe7c49d056ea1d88 = (0, $7Rbab.right);
/**
 * @category Codec
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$92738401e1603719 = /** @class */ function() {
    function Type(/** a unique name for this codec */ name, /** a custom type guard */ is, /** succeeds if a value of type I can be decoded to a value of type A */ validate, /** converts a value of type A to a value of type O */ encode) {
        this.name = name;
        this.is = is;
        this.validate = validate;
        this.encode = encode;
        this.decode = this.decode.bind(this);
    }
    /**
     * @since 1.0.0
     */ Type.prototype.pipe = function(ab, name) {
        var _this = this;
        if (name === void 0) name = "pipe(".concat(this.name, ", ").concat(ab.name, ")");
        return new Type(name, ab.is, function(i, c) {
            var e = _this.validate(i, c);
            if ((0, $7Rbab.isLeft)(e)) return e;
            return ab.validate(e.right, c);
        }, this.encode === $95a9da22a3dbeafd$export$f0954fd7d5368655 && ab.encode === $95a9da22a3dbeafd$export$f0954fd7d5368655 ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(b) {
            return _this.encode(ab.encode(b));
        });
    };
    /**
     * @since 1.0.0
     */ Type.prototype.asDecoder = function() {
        return this;
    };
    /**
     * @since 1.0.0
     */ Type.prototype.asEncoder = function() {
        return this;
    };
    /**
     * a version of `validate` with a default context
     * @since 1.0.0
     */ Type.prototype.decode = function(i) {
        return this.validate(i, [
            {
                key: '',
                type: this,
                actual: i
            }
        ]);
    };
    return Type;
}();
var $95a9da22a3dbeafd$export$f0954fd7d5368655 = function(a) {
    return a;
};
function $95a9da22a3dbeafd$export$aad197c7121a6651(f) {
    return f.displayName || f.name || "<function".concat(f.length, ">");
}
function $95a9da22a3dbeafd$export$540babbc0c244fa1(key, decoder) {
    return {
        key: key,
        type: decoder
    };
}
function $95a9da22a3dbeafd$export$c5d593f2380f5045(c, key, decoder, actual) {
    var len = c.length;
    var r = Array(len + 1);
    for(var i = 0; i < len; i++)r[i] = c[i];
    r[len] = {
        key: key,
        type: decoder,
        actual: actual
    };
    return r;
}
function $95a9da22a3dbeafd$var$pushAll(xs, ys) {
    var l = ys.length;
    for(var i = 0; i < l; i++)xs.push(ys[i]);
}
var $95a9da22a3dbeafd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $95a9da22a3dbeafd$var$getNameFromProps(props) {
    return Object.keys(props).map(function(k) {
        return "".concat(k, ": ").concat(props[k].name);
    }).join(', ');
}
function $95a9da22a3dbeafd$var$useIdentity(codecs) {
    for(var i = 0; i < codecs.length; i++){
        if (codecs[i].encode !== $95a9da22a3dbeafd$export$f0954fd7d5368655) return false;
    }
    return true;
}
function $95a9da22a3dbeafd$var$getInterfaceTypeName(props) {
    return "{ ".concat($95a9da22a3dbeafd$var$getNameFromProps(props), " }");
}
function $95a9da22a3dbeafd$var$getPartialTypeName(inner) {
    return "Partial<".concat(inner, ">");
}
function $95a9da22a3dbeafd$var$enumerableRecord(keys, domain, codomain, name) {
    if (name === void 0) name = "{ [K in ".concat(domain.name, "]: ").concat(codomain.name, " }");
    var len = keys.length;
    var props = {};
    for(var i = 0; i < len; i++)props[keys[i]] = codomain;
    var exactCodec = $95a9da22a3dbeafd$export$29be874c1daba180(props, name);
    return new $95a9da22a3dbeafd$export$b3333eddd0be649b(name, function(u) {
        return exactCodec.is(u);
    }, exactCodec.validate, exactCodec.encode, domain, codomain);
}
function $95a9da22a3dbeafd$export$e1d2dd375485c85d(domain) {
    var _a;
    if ($95a9da22a3dbeafd$var$isLiteralC(domain)) {
        var literal_1 = domain.value;
        if ($95a9da22a3dbeafd$export$22b082955e083ec3.is(literal_1)) return _a = {}, _a[literal_1] = null, _a;
    } else if ($95a9da22a3dbeafd$var$isKeyofC(domain)) return domain.keys;
    else if ($95a9da22a3dbeafd$var$isUnionC(domain)) {
        var keys = domain.types.map(function(type) {
            return $95a9da22a3dbeafd$export$e1d2dd375485c85d(type);
        });
        return keys.some($95a9da22a3dbeafd$export$1db45310990710a5.is) ? undefined : Object.assign.apply(Object, $95a9da22a3dbeafd$var$__spreadArray([
            {}
        ], keys, false));
    }
    return undefined;
}
function $95a9da22a3dbeafd$var$stripNonDomainKeys(o, domain) {
    var keys = Object.keys(o);
    var len = keys.length;
    var shouldStrip = false;
    var r = {};
    for(var i = 0; i < len; i++){
        var k = keys[i];
        if (domain.is(k)) r[k] = o[k];
        else shouldStrip = true;
    }
    return shouldStrip ? r : o;
}
function $95a9da22a3dbeafd$var$nonEnumerableRecord(domain, codomain, name) {
    if (name === void 0) name = "{ [K in ".concat(domain.name, "]: ").concat(codomain.name, " }");
    return new $95a9da22a3dbeafd$export$b3333eddd0be649b(name, function(u) {
        if ($95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(u)) return Object.keys(u).every(function(k) {
            return !domain.is(k) || codomain.is(u[k]);
        });
        return $95a9da22a3dbeafd$var$isAnyC(codomain) && Array.isArray(u);
    }, function(u, c) {
        if ($95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(u)) {
            var a = {};
            var errors = [];
            var keys = Object.keys(u);
            var len = keys.length;
            var changed = false;
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var ok = u[k];
                var domainResult = domain.validate(k, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, k, domain, k));
                if ((0, $7Rbab.isLeft)(domainResult)) changed = true;
                else {
                    var vk = domainResult.right;
                    changed = changed || vk !== k;
                    k = vk;
                    var codomainResult = codomain.validate(ok, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, k, codomain, ok));
                    if ((0, $7Rbab.isLeft)(codomainResult)) $95a9da22a3dbeafd$var$pushAll(errors, codomainResult.left);
                    else {
                        var vok = codomainResult.right;
                        changed = changed || vok !== ok;
                        a[k] = vok;
                    }
                }
            }
            return errors.length > 0 ? $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors) : $95a9da22a3dbeafd$export$fe7c49d056ea1d88(changed ? a : u);
        }
        if ($95a9da22a3dbeafd$var$isAnyC(codomain) && Array.isArray(u)) return $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u);
        return $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
    }, domain.encode === $95a9da22a3dbeafd$export$f0954fd7d5368655 && codomain.encode === $95a9da22a3dbeafd$export$f0954fd7d5368655 ? function(a) {
        return $95a9da22a3dbeafd$var$stripNonDomainKeys(a, domain);
    } : function(a) {
        var s = {};
        var keys = Object.keys($95a9da22a3dbeafd$var$stripNonDomainKeys(a, domain));
        var len = keys.length;
        for(var i = 0; i < len; i++){
            var k = keys[i];
            s[String(domain.encode(k))] = codomain.encode(a[k]);
        }
        return s;
    }, domain, codomain);
}
function $95a9da22a3dbeafd$var$getUnionName(codecs) {
    return '(' + codecs.map(function(type) {
        return type.name;
    }).join(' | ') + ')';
}
function $95a9da22a3dbeafd$export$18aef43295bbe906(base, us) {
    var equal = true;
    var primitive = true;
    var baseIsNotADictionary = !$95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(base);
    for(var _i = 0, us_1 = us; _i < us_1.length; _i++){
        var u = us_1[_i];
        if (u !== base) equal = false;
        if ($95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(u)) primitive = false;
    }
    if (equal) return base;
    else if (primitive) return us[us.length - 1];
    var r = {};
    for(var _a = 0, us_2 = us; _a < us_2.length; _a++){
        var u = us_2[_a];
        for(var k in u)if (!$95a9da22a3dbeafd$var$hasOwnProperty.call(r, k) || baseIsNotADictionary || u[k] !== base[k]) r[k] = u[k];
    }
    return r;
}
function $95a9da22a3dbeafd$var$getProps(codec) {
    switch(codec._tag){
        case 'RefinementType':
        case 'ReadonlyType':
            return $95a9da22a3dbeafd$var$getProps(codec.type);
        case 'InterfaceType':
        case 'StrictType':
        case 'PartialType':
            return codec.props;
        case 'IntersectionType':
            return codec.types.reduce(function(props, type) {
                return Object.assign(props, $95a9da22a3dbeafd$var$getProps(type));
            }, {});
    }
}
function $95a9da22a3dbeafd$var$stripKeys(o, props) {
    var keys = Object.getOwnPropertyNames(o);
    var shouldStrip = false;
    var r = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$95a9da22a3dbeafd$var$hasOwnProperty.call(props, key)) shouldStrip = true;
        else r[key] = o[key];
    }
    return shouldStrip ? r : o;
}
function $95a9da22a3dbeafd$var$getExactTypeName(codec) {
    if ($95a9da22a3dbeafd$var$isTypeC(codec)) return "{| ".concat($95a9da22a3dbeafd$var$getNameFromProps(codec.props), " |}");
    else if ($95a9da22a3dbeafd$var$isPartialC(codec)) return $95a9da22a3dbeafd$var$getPartialTypeName("{| ".concat($95a9da22a3dbeafd$var$getNameFromProps(codec.props), " |}"));
    return "Exact<".concat(codec.name, ">");
}
function $95a9da22a3dbeafd$var$isNonEmpty(as) {
    return as.length > 0;
}
var $95a9da22a3dbeafd$export$5a86f723dfda3441 = {};
function $95a9da22a3dbeafd$var$intersect(a, b) {
    var r = [];
    for(var _i = 0, a_1 = a; _i < a_1.length; _i++){
        var v = a_1[_i];
        if (b.indexOf(v) !== -1) r.push(v);
    }
    return r;
}
function $95a9da22a3dbeafd$var$mergeTags(a, b) {
    if (a === $95a9da22a3dbeafd$export$5a86f723dfda3441) return b;
    if (b === $95a9da22a3dbeafd$export$5a86f723dfda3441) return a;
    var r = Object.assign({}, a);
    for(var k in b)if ($95a9da22a3dbeafd$var$hasOwnProperty.call(a, k)) {
        var intersection_1 = $95a9da22a3dbeafd$var$intersect(a[k], b[k]);
        if ($95a9da22a3dbeafd$var$isNonEmpty(intersection_1)) r[k] = intersection_1;
        else {
            r = $95a9da22a3dbeafd$export$5a86f723dfda3441;
            break;
        }
    } else r[k] = b[k];
    return r;
}
function $95a9da22a3dbeafd$var$intersectTags(a, b) {
    if (a === $95a9da22a3dbeafd$export$5a86f723dfda3441 || b === $95a9da22a3dbeafd$export$5a86f723dfda3441) return $95a9da22a3dbeafd$export$5a86f723dfda3441;
    var r = $95a9da22a3dbeafd$export$5a86f723dfda3441;
    for(var k in a)if ($95a9da22a3dbeafd$var$hasOwnProperty.call(b, k)) {
        var intersection_2 = $95a9da22a3dbeafd$var$intersect(a[k], b[k]);
        if (intersection_2.length === 0) {
            if (r === $95a9da22a3dbeafd$export$5a86f723dfda3441) r = {};
            r[k] = a[k].concat(b[k]);
        }
    }
    return r;
}
// tslint:disable-next-line: deprecation
function $95a9da22a3dbeafd$var$isAnyC(codec) {
    return codec._tag === 'AnyType';
}
function $95a9da22a3dbeafd$var$isLiteralC(codec) {
    return codec._tag === 'LiteralType';
}
function $95a9da22a3dbeafd$var$isKeyofC(codec) {
    return codec._tag === 'KeyofType';
}
function $95a9da22a3dbeafd$var$isTypeC(codec) {
    return codec._tag === 'InterfaceType';
}
function $95a9da22a3dbeafd$var$isPartialC(codec) {
    return codec._tag === 'PartialType';
}
// tslint:disable-next-line: deprecation
function $95a9da22a3dbeafd$var$isStrictC(codec) {
    return codec._tag === 'StrictType';
}
function $95a9da22a3dbeafd$var$isExactC(codec) {
    return codec._tag === 'ExactType';
}
// tslint:disable-next-line: deprecation
function $95a9da22a3dbeafd$var$isRefinementC(codec) {
    return codec._tag === 'RefinementType';
}
function $95a9da22a3dbeafd$var$isIntersectionC(codec) {
    return codec._tag === 'IntersectionType';
}
function $95a9da22a3dbeafd$var$isUnionC(codec) {
    return codec._tag === 'UnionType';
}
function $95a9da22a3dbeafd$var$isRecursiveC(codec) {
    return codec._tag === 'RecursiveType';
}
function $95a9da22a3dbeafd$var$isReadonlyC(codec) {
    return codec._tag === 'ReadonlyType';
}
var $95a9da22a3dbeafd$var$lazyCodecs = [];
function $95a9da22a3dbeafd$export$af63d7414243dad3(codec) {
    if ($95a9da22a3dbeafd$var$lazyCodecs.indexOf(codec) !== -1) return $95a9da22a3dbeafd$export$5a86f723dfda3441;
    if ($95a9da22a3dbeafd$var$isTypeC(codec) || $95a9da22a3dbeafd$var$isStrictC(codec)) {
        var index = $95a9da22a3dbeafd$export$5a86f723dfda3441;
        // tslint:disable-next-line: forin
        for(var k in codec.props){
            var prop = codec.props[k];
            if ($95a9da22a3dbeafd$var$isLiteralC(prop)) {
                if (index === $95a9da22a3dbeafd$export$5a86f723dfda3441) index = {};
                index[k] = [
                    prop.value
                ];
            }
        }
        return index;
    } else if ($95a9da22a3dbeafd$var$isExactC(codec) || $95a9da22a3dbeafd$var$isRefinementC(codec) || $95a9da22a3dbeafd$var$isReadonlyC(codec)) return $95a9da22a3dbeafd$export$af63d7414243dad3(codec.type);
    else if ($95a9da22a3dbeafd$var$isIntersectionC(codec)) return codec.types.reduce(function(tags, codec) {
        return $95a9da22a3dbeafd$var$mergeTags(tags, $95a9da22a3dbeafd$export$af63d7414243dad3(codec));
    }, $95a9da22a3dbeafd$export$5a86f723dfda3441);
    else if ($95a9da22a3dbeafd$var$isUnionC(codec)) return codec.types.slice(1).reduce(function(tags, codec) {
        return $95a9da22a3dbeafd$var$intersectTags(tags, $95a9da22a3dbeafd$export$af63d7414243dad3(codec));
    }, $95a9da22a3dbeafd$export$af63d7414243dad3(codec.types[0]));
    else if ($95a9da22a3dbeafd$var$isRecursiveC(codec)) {
        $95a9da22a3dbeafd$var$lazyCodecs.push(codec);
        var tags = $95a9da22a3dbeafd$export$af63d7414243dad3(codec.type);
        $95a9da22a3dbeafd$var$lazyCodecs.pop();
        return tags;
    }
    return $95a9da22a3dbeafd$export$5a86f723dfda3441;
}
function $95a9da22a3dbeafd$export$ddfa24987dade61b(codecs) {
    var tags = $95a9da22a3dbeafd$export$af63d7414243dad3(codecs[0]);
    var keys = Object.keys(tags);
    var len = codecs.length;
    var _loop_1 = function(k) {
        var all = tags[k].slice();
        var index = [
            tags[k]
        ];
        for(var i = 1; i < len; i++){
            var codec = codecs[i];
            var ctags = $95a9da22a3dbeafd$export$af63d7414243dad3(codec);
            var values = ctags[k];
            // tslint:disable-next-line: strict-type-predicates
            if (values === undefined) return "continue-keys";
            else {
                if (values.some(function(v) {
                    return all.indexOf(v) !== -1;
                })) return "continue-keys";
                else {
                    all.push.apply(all, values);
                    index.push(values);
                }
            }
        }
        return {
            value: [
                k,
                index
            ]
        };
    };
    keys: for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var k = keys_1[_i];
        var state_1 = _loop_1(k);
        if (typeof state_1 === "object") return state_1.value;
        switch(state_1){
            case "continue-keys":
                continue keys;
        }
    }
    return undefined;
}
// -------------------------------------------------------------------------------------
// primitives
// -------------------------------------------------------------------------------------
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$95d6ca0ebe20dc35 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(NullType, _super);
    function NullType() {
        var _this = _super.call(this, 'null', function(u) {
            return u === null;
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NullType';
        return _this;
    }
    return NullType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$9d93593e0583cfae = new $95a9da22a3dbeafd$export$95d6ca0ebe20dc35();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$f2e4e29641fb7943 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(UndefinedType, _super);
    function UndefinedType() {
        var _this = _super.call(this, 'undefined', function(u) {
            return u === void 0;
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'UndefinedType';
        return _this;
    }
    return UndefinedType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$1db45310990710a5 = new $95a9da22a3dbeafd$export$f2e4e29641fb7943();
/**
 * @since 1.2.0
 */ var $95a9da22a3dbeafd$export$ba8a14deee5e9cf6 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(VoidType, _super);
    function VoidType() {
        var _this = _super.call(this, 'void', $95a9da22a3dbeafd$export$1db45310990710a5.is, $95a9da22a3dbeafd$export$1db45310990710a5.validate, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'VoidType';
        return _this;
    }
    return VoidType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$83daf831650100a1 = new $95a9da22a3dbeafd$export$ba8a14deee5e9cf6();
/**
 * @since 1.5.0
 */ var $95a9da22a3dbeafd$export$df145d679177b39 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(UnknownType, _super);
    function UnknownType() {
        var _this = _super.call(this, 'unknown', function(_) {
            return true;
        }, $95a9da22a3dbeafd$export$fe7c49d056ea1d88, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'UnknownType';
        return _this;
    }
    return UnknownType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$19282c40b967aec6 = new $95a9da22a3dbeafd$export$df145d679177b39();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$2b93044cbf134323 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(StringType, _super);
    function StringType() {
        var _this = _super.call(this, 'string', function(u) {
            return typeof u === 'string';
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'StringType';
        return _this;
    }
    return StringType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$22b082955e083ec3 = new $95a9da22a3dbeafd$export$2b93044cbf134323();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$86a7aca748b1e260 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(NumberType, _super);
    function NumberType() {
        var _this = _super.call(this, 'number', function(u) {
            return typeof u === 'number';
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NumberType';
        return _this;
    }
    return NumberType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$98e628dec113755e = new $95a9da22a3dbeafd$export$86a7aca748b1e260();
/**
 * @since 2.1.0
 */ var $95a9da22a3dbeafd$export$619c1c26d1e391ec = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(BigIntType, _super);
    function BigIntType() {
        var _this = _super.call(this, 'bigint', // tslint:disable-next-line: valid-typeof
        function(u) {
            return typeof u === 'bigint';
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'BigIntType';
        return _this;
    }
    return BigIntType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$a0f65b52274bcc00 = new $95a9da22a3dbeafd$export$619c1c26d1e391ec();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$240f7fffab1b25a0 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(BooleanType, _super);
    function BooleanType() {
        var _this = _super.call(this, 'boolean', function(u) {
            return typeof u === 'boolean';
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'BooleanType';
        return _this;
    }
    return BooleanType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$4a21f16c33752377 = new $95a9da22a3dbeafd$export$240f7fffab1b25a0();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$ac86d7574eec6a20 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(AnyArrayType, _super);
    function AnyArrayType() {
        var _this = _super.call(this, 'UnknownArray', Array.isArray, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyArrayType';
        return _this;
    }
    return AnyArrayType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$837c7bec7087434c = new $95a9da22a3dbeafd$export$ac86d7574eec6a20();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$114de0f37b8f7d23 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(AnyDictionaryType, _super);
    function AnyDictionaryType() {
        var _this = _super.call(this, 'UnknownRecord', function(u) {
            return u !== null && typeof u === 'object' && !Array.isArray(u);
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyDictionaryType';
        return _this;
    }
    return AnyDictionaryType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$ecfbd036cf5a99af = new $95a9da22a3dbeafd$export$114de0f37b8f7d23();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$d6c96d9c1c53b151 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(LiteralType, _super);
    function LiteralType(name, is, validate, encode, value) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.value = value;
        /**
         * @since 1.0.0
         */ _this._tag = 'LiteralType';
        return _this;
    }
    return LiteralType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$c8ec6e1ec9fefcb0(value, name) {
    if (name === void 0) name = JSON.stringify(value);
    var is = function(u) {
        return u === value;
    };
    return new $95a9da22a3dbeafd$export$d6c96d9c1c53b151(name, is, function(u, c) {
        return is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(value) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
    }, $95a9da22a3dbeafd$export$f0954fd7d5368655, value);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$9716a65a8e770652 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(KeyofType, _super);
    function KeyofType(name, is, validate, encode, keys) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.keys = keys;
        /**
         * @since 1.0.0
         */ _this._tag = 'KeyofType';
        return _this;
    }
    return KeyofType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$7e1278799275f68e(keys, name) {
    if (name === void 0) name = Object.keys(keys).map(function(k) {
        return JSON.stringify(k);
    }).join(' | ');
    var is = function(u) {
        return $95a9da22a3dbeafd$export$22b082955e083ec3.is(u) && $95a9da22a3dbeafd$var$hasOwnProperty.call(keys, u);
    };
    return new $95a9da22a3dbeafd$export$9716a65a8e770652(name, is, function(u, c) {
        return is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
    }, $95a9da22a3dbeafd$export$f0954fd7d5368655, keys);
}
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$75d4a1b670774175 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(RefinementType, _super);
    function RefinementType(name, is, validate, encode, type, predicate) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        _this.predicate = predicate;
        /**
         * @since 1.0.0
         */ _this._tag = 'RefinementType';
        return _this;
    }
    return RefinementType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$96ff94e0adb1d772(codec, predicate, name) {
    return $95a9da22a3dbeafd$export$99656c995101768a(codec, predicate, name);
}
var $95a9da22a3dbeafd$export$fdd676b64b72b00 = $95a9da22a3dbeafd$export$96ff94e0adb1d772($95a9da22a3dbeafd$export$98e628dec113755e, function(n) {
    return Number.isInteger(n);
}, 'Int');
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$430fa421231b5068 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(RecursiveType, _super);
    function RecursiveType(name, is, validate, encode, runDefinition) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.runDefinition = runDefinition;
        /**
         * @since 1.0.0
         */ _this._tag = 'RecursiveType';
        return _this;
    }
    return RecursiveType;
}($95a9da22a3dbeafd$export$92738401e1603719);
Object.defineProperty($95a9da22a3dbeafd$export$430fa421231b5068.prototype, 'type', {
    get: function() {
        return this.runDefinition();
    },
    enumerable: true,
    configurable: true
});
function $95a9da22a3dbeafd$export$74c5cab0f9a94551(name, definition) {
    var cache;
    var runDefinition = function() {
        if (!cache) {
            cache = definition(Self);
            cache.name = name;
        }
        return cache;
    };
    var Self = new $95a9da22a3dbeafd$export$430fa421231b5068(name, function(u) {
        return runDefinition().is(u);
    }, function(u, c) {
        return runDefinition().validate(u, c);
    }, function(a) {
        return runDefinition().encode(a);
    }, runDefinition);
    return Self;
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$49c146ea18b05474 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(ArrayType, _super);
    function ArrayType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ArrayType';
        return _this;
    }
    return ArrayType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$2f23118c22fb2630(item, name) {
    if (name === void 0) name = "Array<".concat(item.name, ">");
    return new $95a9da22a3dbeafd$export$49c146ea18b05474(name, function(u) {
        return $95a9da22a3dbeafd$export$837c7bec7087434c.is(u) && u.every(item.is);
    }, function(u, c) {
        var e = $95a9da22a3dbeafd$export$837c7bec7087434c.validate(u, c);
        if ((0, $7Rbab.isLeft)(e)) return e;
        var us = e.right;
        var len = us.length;
        var as = us;
        var errors = [];
        for(var i = 0; i < len; i++){
            var ui = us[i];
            var result = item.validate(ui, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, String(i), item, ui));
            if ((0, $7Rbab.isLeft)(result)) $95a9da22a3dbeafd$var$pushAll(errors, result.left);
            else {
                var ai = result.right;
                if (ai !== ui) {
                    if (as === us) as = us.slice();
                    as[i] = ai;
                }
            }
        }
        return errors.length > 0 ? $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors) : $95a9da22a3dbeafd$export$fe7c49d056ea1d88(as);
    }, item.encode === $95a9da22a3dbeafd$export$f0954fd7d5368655 ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
        return a.map(item.encode);
    }, item);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$f57ee166a379f505 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(InterfaceType, _super);
    function InterfaceType(name, is, validate, encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'InterfaceType';
        return _this;
    }
    return InterfaceType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$bf9fb029d174d554(props, name) {
    if (name === void 0) name = $95a9da22a3dbeafd$var$getInterfaceTypeName(props);
    var keys = Object.keys(props);
    var types = keys.map(function(key) {
        return props[key];
    });
    var len = keys.length;
    return new $95a9da22a3dbeafd$export$f57ee166a379f505(name, function(u) {
        if ($95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(u)) {
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var uk = u[k];
                if (uk === undefined && !$95a9da22a3dbeafd$var$hasOwnProperty.call(u, k) || !types[i].is(uk)) return false;
            }
            return true;
        }
        return false;
    }, function(u, c) {
        var e = $95a9da22a3dbeafd$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $7Rbab.isLeft)(e)) return e;
        var o = e.right;
        var a = o;
        var errors = [];
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            var type_1 = types[i];
            var result = type_1.validate(ak, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, k, type_1, ak));
            if ((0, $7Rbab.isLeft)(result)) $95a9da22a3dbeafd$var$pushAll(errors, result.left);
            else {
                var vak = result.right;
                if (vak !== ak || vak === undefined && !$95a9da22a3dbeafd$var$hasOwnProperty.call(a, k)) {
                    /* istanbul ignore next */ if (a === o) a = $95a9da22a3dbeafd$var$__assign({}, o);
                    a[k] = vak;
                }
            }
        }
        return errors.length > 0 ? $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors) : $95a9da22a3dbeafd$export$fe7c49d056ea1d88(a);
    }, $95a9da22a3dbeafd$var$useIdentity(types) ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
        var s = $95a9da22a3dbeafd$var$__assign({}, a);
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var encode = types[i].encode;
            if (encode !== $95a9da22a3dbeafd$export$f0954fd7d5368655) s[k] = encode(a[k]);
        }
        return s;
    }, props);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$3c1c44baadfdf95a = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(PartialType, _super);
    function PartialType(name, is, validate, encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'PartialType';
        return _this;
    }
    return PartialType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$e45945969df8035a(props, name) {
    if (name === void 0) name = $95a9da22a3dbeafd$var$getPartialTypeName($95a9da22a3dbeafd$var$getInterfaceTypeName(props));
    var keys = Object.keys(props);
    var types = keys.map(function(key) {
        return props[key];
    });
    var len = keys.length;
    return new $95a9da22a3dbeafd$export$3c1c44baadfdf95a(name, function(u) {
        if ($95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(u)) {
            for(var i = 0; i < len; i++){
                var k = keys[i];
                var uk = u[k];
                if (uk !== undefined && !props[k].is(uk)) return false;
            }
            return true;
        }
        return false;
    }, function(u, c) {
        var e = $95a9da22a3dbeafd$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $7Rbab.isLeft)(e)) return e;
        var o = e.right;
        var a = o;
        var errors = [];
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            var type_2 = props[k];
            var result = type_2.validate(ak, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, k, type_2, ak));
            if ((0, $7Rbab.isLeft)(result)) {
                if (ak !== undefined) $95a9da22a3dbeafd$var$pushAll(errors, result.left);
            } else {
                var vak = result.right;
                if (vak !== ak) {
                    /* istanbul ignore next */ if (a === o) a = $95a9da22a3dbeafd$var$__assign({}, o);
                    a[k] = vak;
                }
            }
        }
        return errors.length > 0 ? $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors) : $95a9da22a3dbeafd$export$fe7c49d056ea1d88(a);
    }, $95a9da22a3dbeafd$var$useIdentity(types) ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
        var s = $95a9da22a3dbeafd$var$__assign({}, a);
        for(var i = 0; i < len; i++){
            var k = keys[i];
            var ak = a[k];
            if (ak !== undefined) s[k] = types[i].encode(ak);
        }
        return s;
    }, props);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$b3333eddd0be649b = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(DictionaryType, _super);
    function DictionaryType(name, is, validate, encode, domain, codomain) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.domain = domain;
        _this.codomain = codomain;
        /**
         * @since 1.0.0
         */ _this._tag = 'DictionaryType';
        return _this;
    }
    return DictionaryType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$e5185e241753e543(domain, codomain, name) {
    var keys = $95a9da22a3dbeafd$export$e1d2dd375485c85d(domain);
    return keys ? $95a9da22a3dbeafd$var$enumerableRecord(Object.keys(keys), domain, codomain, name) : $95a9da22a3dbeafd$var$nonEnumerableRecord(domain, codomain, name);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$9b31524cbbc7993 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(UnionType, _super);
    function UnionType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'UnionType';
        return _this;
    }
    return UnionType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$971dd5b0dfd021b6(codecs, name) {
    if (name === void 0) name = $95a9da22a3dbeafd$var$getUnionName(codecs);
    var index = $95a9da22a3dbeafd$export$ddfa24987dade61b(codecs);
    if (index !== undefined && codecs.length > 0) {
        var tag_1 = index[0], groups_1 = index[1];
        var len_1 = groups_1.length;
        var find_1 = function(value) {
            for(var i = 0; i < len_1; i++){
                if (groups_1[i].indexOf(value) !== -1) return i;
            }
            return undefined;
        };
        // tslint:disable-next-line: deprecation
        return new $95a9da22a3dbeafd$export$b00fe6dbb0de05b6(name, function(u) {
            if ($95a9da22a3dbeafd$export$ecfbd036cf5a99af.is(u)) {
                var i = find_1(u[tag_1]);
                return i !== undefined ? codecs[i].is(u) : false;
            }
            return false;
        }, function(u, c) {
            var e = $95a9da22a3dbeafd$export$ecfbd036cf5a99af.validate(u, c);
            if ((0, $7Rbab.isLeft)(e)) return e;
            var r = e.right;
            var i = find_1(r[tag_1]);
            if (i === undefined) return $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
            var codec = codecs[i];
            return codec.validate(r, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, String(i), codec, r));
        }, $95a9da22a3dbeafd$var$useIdentity(codecs) ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
            var i = find_1(a[tag_1]);
            if (i === undefined) // https://github.com/gcanti/io-ts/pull/305
            throw new Error("no codec found to encode value in union codec ".concat(name));
            else return codecs[i].encode(a);
        }, codecs, tag_1);
    } else return new $95a9da22a3dbeafd$export$9b31524cbbc7993(name, function(u) {
        return codecs.some(function(type) {
            return type.is(u);
        });
    }, function(u, c) {
        var errors = [];
        for(var i = 0; i < codecs.length; i++){
            var codec = codecs[i];
            var result = codec.validate(u, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, String(i), codec, u));
            if ((0, $7Rbab.isLeft)(result)) $95a9da22a3dbeafd$var$pushAll(errors, result.left);
            else return $95a9da22a3dbeafd$export$fe7c49d056ea1d88(result.right);
        }
        return $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors);
    }, $95a9da22a3dbeafd$var$useIdentity(codecs) ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
        for(var _i = 0, codecs_1 = codecs; _i < codecs_1.length; _i++){
            var codec = codecs_1[_i];
            if (codec.is(a)) return codec.encode(a);
        }
        // https://github.com/gcanti/io-ts/pull/305
        throw new Error("no codec found to encode value in union type ".concat(name));
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$28e23bba31d0f3b2 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(IntersectionType, _super);
    function IntersectionType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'IntersectionType';
        return _this;
    }
    return IntersectionType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$bc86dfbf7795668c(codecs, name) {
    if (name === void 0) name = "(".concat(codecs.map(function(type) {
        return type.name;
    }).join(' & '), ")");
    var len = codecs.length;
    return new $95a9da22a3dbeafd$export$28e23bba31d0f3b2(name, function(u) {
        return codecs.every(function(type) {
            return type.is(u);
        });
    }, codecs.length === 0 ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88 : function(u, c) {
        var us = [];
        var errors = [];
        for(var i = 0; i < len; i++){
            var codec = codecs[i];
            var result = codec.validate(u, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, String(i), codec, u));
            if ((0, $7Rbab.isLeft)(result)) $95a9da22a3dbeafd$var$pushAll(errors, result.left);
            else us.push(result.right);
        }
        return errors.length > 0 ? $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors) : $95a9da22a3dbeafd$export$fe7c49d056ea1d88($95a9da22a3dbeafd$export$18aef43295bbe906(u, us));
    }, codecs.length === 0 ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
        return $95a9da22a3dbeafd$export$18aef43295bbe906(a, codecs.map(function(codec) {
            return codec.encode(a);
        }));
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$4e91a628a05a1342 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(TupleType, _super);
    function TupleType(name, is, validate, encode, types) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.types = types;
        /**
         * @since 1.0.0
         */ _this._tag = 'TupleType';
        return _this;
    }
    return TupleType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$65e3907585753458(codecs, name) {
    if (name === void 0) name = "[".concat(codecs.map(function(type) {
        return type.name;
    }).join(', '), "]");
    var len = codecs.length;
    return new $95a9da22a3dbeafd$export$4e91a628a05a1342(name, function(u) {
        return $95a9da22a3dbeafd$export$837c7bec7087434c.is(u) && u.length === len && codecs.every(function(type, i) {
            return type.is(u[i]);
        });
    }, function(u, c) {
        var e = $95a9da22a3dbeafd$export$837c7bec7087434c.validate(u, c);
        if ((0, $7Rbab.isLeft)(e)) return e;
        var us = e.right;
        var as = us.length > len ? us.slice(0, len) : us; // strip additional components
        var errors = [];
        for(var i = 0; i < len; i++){
            var a = us[i];
            var type_3 = codecs[i];
            var result = type_3.validate(a, $95a9da22a3dbeafd$export$c5d593f2380f5045(c, String(i), type_3, a));
            if ((0, $7Rbab.isLeft)(result)) $95a9da22a3dbeafd$var$pushAll(errors, result.left);
            else {
                var va = result.right;
                if (va !== a) {
                    /* istanbul ignore next */ if (as === us) as = us.slice();
                    as[i] = va;
                }
            }
        }
        return errors.length > 0 ? $95a9da22a3dbeafd$export$fd43912fe64ec8ed(errors) : $95a9da22a3dbeafd$export$fe7c49d056ea1d88(as);
    }, $95a9da22a3dbeafd$var$useIdentity(codecs) ? $95a9da22a3dbeafd$export$f0954fd7d5368655 : function(a) {
        return codecs.map(function(type, i) {
            return type.encode(a[i]);
        });
    }, codecs);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$13011d386df050c2 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(ReadonlyType, _super);
    function ReadonlyType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ReadonlyType';
        return _this;
    }
    return ReadonlyType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$6ec456bd5b7b3c51(codec, name) {
    if (name === void 0) name = "Readonly<".concat(codec.name, ">");
    return new $95a9da22a3dbeafd$export$13011d386df050c2(name, codec.is, codec.validate, codec.encode, codec);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$fe6530276c28a251 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(ReadonlyArrayType, _super);
    function ReadonlyArrayType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ReadonlyArrayType';
        return _this;
    }
    return ReadonlyArrayType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$95ca155af9fd5713(item, name) {
    if (name === void 0) name = "ReadonlyArray<".concat(item.name, ">");
    var codec = $95a9da22a3dbeafd$export$2f23118c22fb2630(item);
    return new $95a9da22a3dbeafd$export$fe6530276c28a251(name, codec.is, codec.validate, codec.encode, item);
}
var $95a9da22a3dbeafd$export$29be874c1daba180 = function(props, name) {
    return $95a9da22a3dbeafd$export$5f3c29cf4492ebb9($95a9da22a3dbeafd$export$bf9fb029d174d554(props), name);
};
/**
 * @since 1.1.0
 */ var $95a9da22a3dbeafd$export$aee107ca284ccf4e = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(ExactType, _super);
    function ExactType(name, is, validate, encode, type) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.type = type;
        /**
         * @since 1.0.0
         */ _this._tag = 'ExactType';
        return _this;
    }
    return ExactType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$5f3c29cf4492ebb9(codec, name) {
    if (name === void 0) name = $95a9da22a3dbeafd$var$getExactTypeName(codec);
    var props = $95a9da22a3dbeafd$var$getProps(codec);
    return new $95a9da22a3dbeafd$export$aee107ca284ccf4e(name, codec.is, function(u, c) {
        var e = $95a9da22a3dbeafd$export$ecfbd036cf5a99af.validate(u, c);
        if ((0, $7Rbab.isLeft)(e)) return e;
        var ce = codec.validate(u, c);
        if ((0, $7Rbab.isLeft)(ce)) return ce;
        return (0, $7Rbab.right)($95a9da22a3dbeafd$var$stripKeys(ce.right, props));
    }, function(a) {
        return codec.encode($95a9da22a3dbeafd$var$stripKeys(a, props));
    }, codec);
}
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$47dda4034ce65bf2 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(FunctionType, _super);
    function FunctionType() {
        var _this = _super.call(this, 'Function', // tslint:disable-next-line:strict-type-predicates
        function(u) {
            return typeof u === 'function';
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'FunctionType';
        return _this;
    }
    return FunctionType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$f3890eeaf6851387 = new $95a9da22a3dbeafd$export$47dda4034ce65bf2();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$203633b10d4a485e = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(NeverType, _super);
    function NeverType() {
        var _this = _super.call(this, 'never', function(_) {
            return false;
        }, function(u, c) {
            return $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, /* istanbul ignore next */ function() {
            throw new Error('cannot encode never');
        }) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'NeverType';
        return _this;
    }
    return NeverType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$b3e22bcfd64c1022 = new $95a9da22a3dbeafd$export$203633b10d4a485e();
/**
 * @since 1.0.0
 */ var $95a9da22a3dbeafd$export$ec4c9a150bae86cd = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(AnyType, _super);
    function AnyType() {
        var _this = _super.call(this, 'any', function(_) {
            return true;
        }, $95a9da22a3dbeafd$export$fe7c49d056ea1d88, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'AnyType';
        return _this;
    }
    return AnyType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$4154a199d7d90455 = new $95a9da22a3dbeafd$export$ec4c9a150bae86cd();
function $95a9da22a3dbeafd$export$99656c995101768a(codec, predicate, name) {
    if (name === void 0) name = "(".concat(codec.name, " | ").concat($95a9da22a3dbeafd$export$aad197c7121a6651(predicate), ")");
    return new $95a9da22a3dbeafd$export$75d4a1b670774175(name, function(u) {
        return codec.is(u) && predicate(u);
    }, function(i, c) {
        var e = codec.validate(i, c);
        if ((0, $7Rbab.isLeft)(e)) return e;
        var a = e.right;
        return predicate(a) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(a) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(a, c);
    }, codec.encode, codec, predicate);
}
var $95a9da22a3dbeafd$export$70ffa26850098d01 = $95a9da22a3dbeafd$export$99656c995101768a($95a9da22a3dbeafd$export$98e628dec113755e, Number.isInteger, 'Integer');
// -------------------------------------------------------------------------------------
// deprecated
// -------------------------------------------------------------------------------------
/**
 * @since 1.3.0
 * @deprecated
 */ var $95a9da22a3dbeafd$export$b00fe6dbb0de05b6 = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(TaggedUnionType, _super);
    function TaggedUnionType(name, // tslint:disable-next-line: deprecation
    is, // tslint:disable-next-line: deprecation
    validate, // tslint:disable-next-line: deprecation
    encode, codecs, tag) {
        var _this = _super.call(this, name, is, validate, encode, codecs) // <= workaround for https://github.com/Microsoft/TypeScript/issues/13455
         || this;
        _this.tag = tag;
        return _this;
    }
    return TaggedUnionType;
}($95a9da22a3dbeafd$export$9b31524cbbc7993);
var $95a9da22a3dbeafd$export$fd8e3b454da0843e = function(tag, codecs, name) {
    if (name === void 0) name = $95a9da22a3dbeafd$var$getUnionName(codecs);
    var U = $95a9da22a3dbeafd$export$971dd5b0dfd021b6(codecs, name);
    // tslint:disable-next-line: deprecation
    if (U instanceof $95a9da22a3dbeafd$export$b00fe6dbb0de05b6) return U;
    else {
        console.warn("[io-ts] Cannot build a tagged union for ".concat(name, ", returning a de-optimized union"));
        // tslint:disable-next-line: deprecation
        return new $95a9da22a3dbeafd$export$b00fe6dbb0de05b6(name, U.is, U.validate, U.encode, codecs, tag);
    }
};
var $95a9da22a3dbeafd$export$519bb523eb7aafa2 /* istanbul ignore next */  = function(value, context) {
    return {
        value: value,
        context: context
    };
};
var $95a9da22a3dbeafd$export$6cb944b539722d98 /* istanbul ignore next */  = function(decoder) {
    return [
        {
            key: '',
            type: decoder
        }
    ];
};
var $95a9da22a3dbeafd$export$4ee70ab773570fb9 = $95a9da22a3dbeafd$export$ecfbd036cf5a99af;
/**
 * @since 1.0.0
 * @deprecated
 */ var $95a9da22a3dbeafd$export$53f0d9fcb05d9d1d = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(ObjectType, _super);
    function ObjectType() {
        var _this = _super.call(this, 'object', function(u) {
            return u !== null && typeof u === 'object';
        }, function(u, c) {
            return _this.is(u) ? $95a9da22a3dbeafd$export$fe7c49d056ea1d88(u) : $95a9da22a3dbeafd$export$af2dba6db4e9e1f0(u, c);
        }, $95a9da22a3dbeafd$export$f0954fd7d5368655) || this;
        /**
         * @since 1.0.0
         */ _this._tag = 'ObjectType';
        return _this;
    }
    return ObjectType;
}($95a9da22a3dbeafd$export$92738401e1603719);
var $95a9da22a3dbeafd$export$be5493f9613cbbe = new $95a9da22a3dbeafd$export$53f0d9fcb05d9d1d();
var $95a9da22a3dbeafd$export$d3757880ed390b62 = $95a9da22a3dbeafd$export$e5185e241753e543;
/**
 * @since 1.0.0
 * @deprecated
 */ var $95a9da22a3dbeafd$export$b343c5704aeb93fd = /** @class */ function(_super) {
    $95a9da22a3dbeafd$var$__extends(StrictType, _super);
    function StrictType(name, // tslint:disable-next-line: deprecation
    is, // tslint:disable-next-line: deprecation
    validate, // tslint:disable-next-line: deprecation
    encode, props) {
        var _this = _super.call(this, name, is, validate, encode) || this;
        _this.props = props;
        /**
         * @since 1.0.0
         */ _this._tag = 'StrictType';
        return _this;
    }
    return StrictType;
}($95a9da22a3dbeafd$export$92738401e1603719);
function $95a9da22a3dbeafd$export$cf0b2a6c63f9e656(codec) {
    return codec;
}
function $95a9da22a3dbeafd$export$8de3e08801b34e5a(codec) {
    return function() {
        return codec;
    };
}

});

parcelRegister("9fMqj", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $6bcb139fae170fb0$export$a06636add2a09fd8; });
$parcel$export(module.exports, "format", function () { return $6bcb139fae170fb0$export$d9468344d3651243; });

var $2MDjk = parcelRequire("2MDjk");
/**
 * @category formatters
 * @since 0.4.0
 */ var $6bcb139fae170fb0$export$a06636add2a09fd8 = /** @class */ function() {
    function Formatter(run) {
        this.run = run;
    }
    /**
     * @since 0.4.0
     */ Formatter.prototype.contramap = function(f) {
        var _this = this;
        return new Formatter(function(r, b) {
            return _this.run(r, f(b));
        });
    };
    /**
     * @since 0.4.0
     */ Formatter.prototype.then = function(that) {
        var _this = this;
        return new Formatter(function(r, ab) {
            return that.run(_this.run(r, ab), ab);
        });
    };
    return Formatter;
}();
var $6bcb139fae170fb0$var$FORMATTER_URI = 'fp-ts-routing/Formatter';
var $6bcb139fae170fb0$export$4bedd3f7d169f13c = {
    URI: $6bcb139fae170fb0$var$FORMATTER_URI,
    contramap: function(fa, f) {
        return fa.contramap(f);
    }
};
var $6bcb139fae170fb0$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $6bcb139fae170fb0$export$4bedd3f7d169f13c.contramap(fa, f);
    };
};
var $6bcb139fae170fb0$export$ff2899a39f81dcfa = function(fb) {
    return function(fa) {
        return fa.then(fb);
    };
};
var $6bcb139fae170fb0$export$d9468344d3651243 = function(formatter, a, encode) {
    if (encode === void 0) encode = true;
    return formatter.run((0, $2MDjk.Route).empty, a).toString(encode);
};

});
parcelRegister("2MDjk", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $206e8ec298c37cd2$export$e7b0ac011bb776c6; });

var $cv56T = parcelRequire("cv56T");
var $206e8ec298c37cd2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $206e8ec298c37cd2$export$e7b0ac011bb776c6 = /** @class */ function() {
    function Route(parts, query) {
        this.parts = parts;
        this.query = query;
    }
    /**
     * @since 0.4.0
     */ Route.isEmpty = function(r) {
        return r.parts.length === 0 && (0, $cv56T.isEmpty)(r.query);
    };
    /**
     * @since 0.4.0
     */ Route.parse = function(s, decode) {
        var _a;
        if (decode === void 0) decode = true;
        var pathname = (_a = new URL(s, 'http://localhost'), _a.pathname), searchParams = _a.searchParams; // `base` is needed when `path` is relative
        var segments = pathname.split('/').filter(Boolean);
        var parts = decode ? segments.map(decodeURIComponent) : segments;
        return new Route(parts, $206e8ec298c37cd2$var$toQuery(searchParams));
    };
    /**
     * @since 0.4.0
     */ Route.prototype.toString = function(encode) {
        if (encode === void 0) encode = true;
        var qs = $206e8ec298c37cd2$var$fromQuery(this.query).toString();
        var parts = encode ? this.parts.map(encodeURIComponent) : this.parts;
        return '/' + parts.join('/') + (qs ? '?' + qs : '');
    };
    /**
     * @since 0.4.0
     */ Route.empty = new Route([], {});
    return Route;
}();
var $206e8ec298c37cd2$var$fromQuery = function(query) {
    var qs = new URLSearchParams();
    Object.entries(query).forEach(function(_a) {
        var k = _a[0], v = _a[1];
        if (typeof v === 'undefined') return;
        return Array.isArray(v) ? v.forEach(function(x) {
            return qs.append(k, x);
        }) : qs.set(k, v);
    });
    return qs;
};
var $206e8ec298c37cd2$var$toQuery = function(params) {
    var q = {};
    params.forEach(function(v, k) {
        var current = q[k];
        if (current) q[k] = Array.isArray(current) ? $206e8ec298c37cd2$var$__spreadArray($206e8ec298c37cd2$var$__spreadArray([], current, true), [
            v
        ], false) : [
            current,
            v
        ];
        else q[k] = v;
    });
    return q;
};

});
parcelRegister("cv56T", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $919c580cdc166d3d$export$dd1bc94b04021eeb; });

var $4Rq1U = parcelRequire("4Rq1U");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $lOGTm = parcelRequire("lOGTm");

var $etcCS = parcelRequire("etcCS");

var $flrom = parcelRequire("flrom");

var $gSyeU = parcelRequire("gSyeU");

var $LdARg = parcelRequire("LdARg");
var $919c580cdc166d3d$var$__assign = undefined && undefined.__assign || function() {
    $919c580cdc166d3d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $919c580cdc166d3d$var$__assign.apply(this, arguments);
};
var $919c580cdc166d3d$export$346677f925de839c = $etcCS.size;
var $919c580cdc166d3d$export$dd1bc94b04021eeb = $etcCS.isEmpty;
var $919c580cdc166d3d$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $919c580cdc166d3d$export$ed97f33186d4b816 = /*#__PURE__*/ $919c580cdc166d3d$var$keys_($gSyeU.Ord);
function $919c580cdc166d3d$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $919c580cdc166d3d$export$bb44f104e3c54dae($gSyeU.Ord)(O);
    var keysO = $919c580cdc166d3d$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $919c580cdc166d3d$export$45b10814cc054894 = /*#__PURE__*/ $919c580cdc166d3d$export$bb44f104e3c54dae($gSyeU.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $919c580cdc166d3d$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $919c580cdc166d3d$export$45b10814cc054894(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $lOGTm.some([
                sas[b],
                b + 1
            ]) : $lOGTm.none;
        });
    };
}
var $919c580cdc166d3d$export$ff82449ce381c54a = $etcCS.upsertAt;
var $919c580cdc166d3d$export$a4f4bb6b1453fff5 = $etcCS.has;
function $919c580cdc166d3d$export$90f9093465da3136(k) {
    return function(r) {
        if (!$lOGTm.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $919c580cdc166d3d$export$b6d8713d53419d4c = function(k, a) {
    return $919c580cdc166d3d$export$cba09f9e3d3e58eb(k, function() {
        return a;
    });
};
var $919c580cdc166d3d$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$919c580cdc166d3d$export$a4f4bb6b1453fff5(k, r)) return $lOGTm.none;
        var out = Object.assign({}, r);
        out[k] = f(r[k]);
        return $lOGTm.some(out);
    };
};
function $919c580cdc166d3d$export$3e41007ebfff0e64(k) {
    var deleteAtk = $919c580cdc166d3d$export$90f9093465da3136(k);
    return function(r) {
        var oa = $919c580cdc166d3d$export$dfc7155ac0343b8(k, r);
        return $lOGTm.isNone(oa) ? $lOGTm.none : $lOGTm.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
var $919c580cdc166d3d$export$36e6f76a1d117b8a = $etcCS.isSubrecord;
var $919c580cdc166d3d$export$dfc7155ac0343b8 = $etcCS.lookup;
var $919c580cdc166d3d$export$8f07ddce13659f50 = $etcCS.mapWithIndex;
var $919c580cdc166d3d$export$871de8747c9eaa88 = $etcCS.map;
function $919c580cdc166d3d$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $etcCS.reduceWithIndex(args[0]) : $etcCS.reduceWithIndex($gSyeU.Ord).apply(void 0, args);
}
function $919c580cdc166d3d$export$18153bb1181268e5(O) {
    return 'compare' in O ? $etcCS.foldMapWithIndex(O) : $etcCS.foldMapWithIndex($gSyeU.Ord)(O);
}
function $919c580cdc166d3d$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $etcCS.reduceRightWithIndex(args[0]) : $etcCS.reduceRightWithIndex($gSyeU.Ord).apply(void 0, args);
}
var $919c580cdc166d3d$export$439306a4dcaafbb9 = $etcCS.singleton;
function $919c580cdc166d3d$export$955fdc0d24efa249(F) {
    return $etcCS.traverseWithIndex(F);
}
function $919c580cdc166d3d$export$df3f009e3d155b20(F) {
    return $etcCS.traverse(F);
}
function $919c580cdc166d3d$export$49bb65c2ea163039(F) {
    return $etcCS.sequence(F);
}
var $919c580cdc166d3d$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $919c580cdc166d3d$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $kj6DU.pipe)(fa, traverseF(f)), $919c580cdc166d3d$export$8e16b83750b44988);
        };
    };
};
var $919c580cdc166d3d$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $919c580cdc166d3d$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $kj6DU.pipe)(fa, traverseF(f)), $919c580cdc166d3d$export$709f6946f4e97408);
        };
    };
};
var $919c580cdc166d3d$export$bc7c0794b9c6f3ba = $etcCS.partitionMapWithIndex;
function $919c580cdc166d3d$export$dad5e500f2bab9bc(predicateWithIndex) {
    return $etcCS.partitionWithIndex(predicateWithIndex);
}
var $919c580cdc166d3d$export$30c5cbe848021e97 = $etcCS.filterMapWithIndex;
function $919c580cdc166d3d$export$36e42aef19fc7171(predicateWithIndex) {
    return $etcCS.filterWithIndex(predicateWithIndex);
}
function $919c580cdc166d3d$export$b7d5d9bb9ff52072(M, F) {
    return $etcCS.fromFoldable(M, F);
}
var $919c580cdc166d3d$export$9f69d28786a8399c = $919c580cdc166d3d$export$45b10814cc054894;
var $919c580cdc166d3d$export$5150077fc2e7c662 = function(fa) {
    return $919c580cdc166d3d$export$b7d5d9bb9ff52072($flrom.last(), $4Rq1U.Foldable)(fa);
};
function $919c580cdc166d3d$export$f658682c0065ad25(M, F) {
    return $etcCS.fromFoldableMap(M, F);
}
var $919c580cdc166d3d$export$7ecc1a3b11b57dab = $etcCS.every;
var $919c580cdc166d3d$export$ad14ef4001db2bcd = $etcCS.some;
var $919c580cdc166d3d$export$5bf96401662340b7 = $etcCS.elem;
var $919c580cdc166d3d$export$971dd5b0dfd021b6 = function(M) {
    var unionM = $etcCS.union(M);
    return function(second) {
        return function(first) {
            if ($919c580cdc166d3d$export$dd1bc94b04021eeb(first)) return $919c580cdc166d3d$var$__assign({}, second);
            if ($919c580cdc166d3d$export$dd1bc94b04021eeb(second)) return $919c580cdc166d3d$var$__assign({}, first);
            return unionM(second)(first);
        };
    };
};
var $919c580cdc166d3d$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($919c580cdc166d3d$export$dd1bc94b04021eeb(first) || $919c580cdc166d3d$export$dd1bc94b04021eeb(second)) return {};
            return $etcCS.intersection(M)(second)(first);
        };
    };
};
var $919c580cdc166d3d$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($919c580cdc166d3d$export$dd1bc94b04021eeb(first)) return $919c580cdc166d3d$var$__assign({}, second);
        if ($919c580cdc166d3d$export$dd1bc94b04021eeb(second)) return $919c580cdc166d3d$var$__assign({}, first);
        return $etcCS.difference(second)(first);
    };
};
var $919c580cdc166d3d$var$_map = $etcCS._map;
var $919c580cdc166d3d$var$_mapWithIndex = $etcCS._mapWithIndex;
var $919c580cdc166d3d$var$_reduce = $etcCS._reduce;
var $919c580cdc166d3d$var$_foldMap = $etcCS._foldMap;
var $919c580cdc166d3d$var$_reduceRight = $etcCS._reduceRight;
var $919c580cdc166d3d$var$_filter = $etcCS._filter;
var $919c580cdc166d3d$var$_filterMap = $etcCS._filterMap;
var $919c580cdc166d3d$var$_partition = $etcCS._partition;
var $919c580cdc166d3d$var$_partitionMap = $etcCS._partitionMap;
var $919c580cdc166d3d$var$_reduceWithIndex = $etcCS._reduceWithIndex;
var $919c580cdc166d3d$var$_foldMapWithIndex = $etcCS._foldMapWithIndex;
var $919c580cdc166d3d$var$_reduceRightWithIndex = $etcCS._reduceRightWithIndex;
var $919c580cdc166d3d$var$_partitionMapWithIndex = $etcCS._partitionMapWithIndex;
var $919c580cdc166d3d$var$_partitionWithIndex = $etcCS._partitionWithIndex;
var $919c580cdc166d3d$var$_filterMapWithIndex = $etcCS._filterMapWithIndex;
var $919c580cdc166d3d$var$_filterWithIndex = $etcCS._filterWithIndex;
var $919c580cdc166d3d$var$_traverse = $etcCS._traverse;
var $919c580cdc166d3d$var$_sequence = $etcCS._sequence;
var $919c580cdc166d3d$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $919c580cdc166d3d$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of({});
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        r[key] = b;
                        return r;
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $919c580cdc166d3d$export$3dea766d36a8935f = $etcCS.filter;
var $919c580cdc166d3d$export$a04c6c6965dd4709 = $etcCS.filterMap;
var $919c580cdc166d3d$export$b29f828819edca8d = $etcCS.partition;
var $919c580cdc166d3d$export$3117e3f9ececb6bc = $etcCS.partitionMap;
function $919c580cdc166d3d$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $etcCS.reduce(args[0]) : $etcCS.reduce($gSyeU.Ord).apply(void 0, args);
}
function $919c580cdc166d3d$export$b66cdc0497d8a99a(O) {
    return 'compare' in O ? $etcCS.foldMap(O) : $etcCS.foldMap($gSyeU.Ord)(O);
}
function $919c580cdc166d3d$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? $etcCS.reduceRight(args[0]) : $etcCS.reduceRight($gSyeU.Ord).apply(void 0, args);
}
var $919c580cdc166d3d$export$8e16b83750b44988 = $etcCS.compact;
var $919c580cdc166d3d$export$709f6946f4e97408 = $etcCS.separate;
var $919c580cdc166d3d$export$9156e739aa33e19f = 'Record';
function $919c580cdc166d3d$export$3cb5cd7f7776c81(O) {
    return 'compare' in O ? $etcCS.getShow(O) : $etcCS.getShow($gSyeU.Ord)(O);
}
var $919c580cdc166d3d$export$804fed467fde44e4 = $etcCS.getEq;
var $919c580cdc166d3d$export$c2a7ef2cc9b32b31 = $etcCS.getMonoid;
var $919c580cdc166d3d$export$bd5b6bfc5fa2ee61 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map
};
var $919c580cdc166d3d$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $6baua.flap)($919c580cdc166d3d$export$bd5b6bfc5fa2ee61);
var $919c580cdc166d3d$export$9fdffe0fe1e91cad = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    mapWithIndex: $919c580cdc166d3d$var$_mapWithIndex
};
var $919c580cdc166d3d$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $919c580cdc166d3d$export$9156e739aa33e19f,
        reduce: $919c580cdc166d3d$var$_reduce(O),
        foldMap: $919c580cdc166d3d$var$_foldMap(O),
        reduceRight: $919c580cdc166d3d$var$_reduceRight(O)
    };
};
var $919c580cdc166d3d$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $919c580cdc166d3d$export$9156e739aa33e19f,
        reduce: $919c580cdc166d3d$var$_reduce(O),
        foldMap: $919c580cdc166d3d$var$_foldMap(O),
        reduceRight: $919c580cdc166d3d$var$_reduceRight(O),
        reduceWithIndex: $919c580cdc166d3d$var$_reduceWithIndex(O),
        foldMapWithIndex: $919c580cdc166d3d$var$_foldMapWithIndex(O),
        reduceRightWithIndex: $919c580cdc166d3d$var$_reduceRightWithIndex(O)
    };
};
var $919c580cdc166d3d$export$4a21ac48141ac3c9 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    compact: $919c580cdc166d3d$export$8e16b83750b44988,
    separate: $919c580cdc166d3d$export$709f6946f4e97408
};
var $919c580cdc166d3d$export$d00e1c48fb621173 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    compact: $919c580cdc166d3d$export$8e16b83750b44988,
    separate: $919c580cdc166d3d$export$709f6946f4e97408,
    filter: $919c580cdc166d3d$var$_filter,
    filterMap: $919c580cdc166d3d$var$_filterMap,
    partition: $919c580cdc166d3d$var$_partition,
    partitionMap: $919c580cdc166d3d$var$_partitionMap
};
var $919c580cdc166d3d$export$c29a647071e542ec = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    mapWithIndex: $919c580cdc166d3d$var$_mapWithIndex,
    compact: $919c580cdc166d3d$export$8e16b83750b44988,
    separate: $919c580cdc166d3d$export$709f6946f4e97408,
    filter: $919c580cdc166d3d$var$_filter,
    filterMap: $919c580cdc166d3d$var$_filterMap,
    partition: $919c580cdc166d3d$var$_partition,
    partitionMap: $919c580cdc166d3d$var$_partitionMap,
    filterMapWithIndex: $919c580cdc166d3d$var$_filterMapWithIndex,
    filterWithIndex: $919c580cdc166d3d$var$_filterWithIndex,
    partitionMapWithIndex: $919c580cdc166d3d$var$_partitionMapWithIndex,
    partitionWithIndex: $919c580cdc166d3d$var$_partitionWithIndex
};
var $919c580cdc166d3d$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $919c580cdc166d3d$export$9156e739aa33e19f,
        map: $919c580cdc166d3d$var$_map,
        reduce: $919c580cdc166d3d$var$_reduce(O),
        foldMap: $919c580cdc166d3d$var$_foldMap(O),
        reduceRight: $919c580cdc166d3d$var$_reduceRight(O),
        traverse: $919c580cdc166d3d$var$_traverse(O),
        sequence: $919c580cdc166d3d$var$_sequence(O)
    };
};
var $919c580cdc166d3d$export$46b81797a3375b8c = function(O) {
    return {
        URI: $919c580cdc166d3d$export$9156e739aa33e19f,
        map: $919c580cdc166d3d$var$_map,
        mapWithIndex: $919c580cdc166d3d$var$_mapWithIndex,
        reduce: $919c580cdc166d3d$var$_reduce(O),
        foldMap: $919c580cdc166d3d$var$_foldMap(O),
        reduceRight: $919c580cdc166d3d$var$_reduceRight(O),
        reduceWithIndex: $919c580cdc166d3d$var$_reduceWithIndex(O),
        foldMapWithIndex: $919c580cdc166d3d$var$_foldMapWithIndex(O),
        reduceRightWithIndex: $919c580cdc166d3d$var$_reduceRightWithIndex(O),
        traverse: $919c580cdc166d3d$var$_traverse(O),
        sequence: $919c580cdc166d3d$var$_sequence(O),
        traverseWithIndex: $919c580cdc166d3d$var$_traverseWithIndex(O)
    };
};
var $919c580cdc166d3d$export$bb8ef26a634cac7b = function(O) {
    var T = $919c580cdc166d3d$export$4e0ffba11065d2c1(O);
    return {
        URI: $919c580cdc166d3d$export$9156e739aa33e19f,
        map: $919c580cdc166d3d$var$_map,
        reduce: $919c580cdc166d3d$var$_reduce(O),
        foldMap: $919c580cdc166d3d$var$_foldMap(O),
        reduceRight: $919c580cdc166d3d$var$_reduceRight(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $919c580cdc166d3d$export$8e16b83750b44988,
        separate: $919c580cdc166d3d$export$709f6946f4e97408,
        filter: $919c580cdc166d3d$var$_filter,
        filterMap: $919c580cdc166d3d$var$_filterMap,
        partition: $919c580cdc166d3d$var$_partition,
        partitionMap: $919c580cdc166d3d$var$_partitionMap,
        wither: (0, $LdARg.witherDefault)(T, $919c580cdc166d3d$export$4a21ac48141ac3c9),
        wilt: (0, $LdARg.wiltDefault)(T, $919c580cdc166d3d$export$4a21ac48141ac3c9)
    };
};
var $919c580cdc166d3d$export$baca17b4aff42f82 = function(S) {
    var unionS = $919c580cdc166d3d$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $919c580cdc166d3d$export$c487aac9f4157837 = function(S) {
    return {
        concat: $919c580cdc166d3d$export$baca17b4aff42f82(S).concat,
        empty: {}
    };
};
var $919c580cdc166d3d$export$d379a869a72e4055 = function(S) {
    var intersectionS = $919c580cdc166d3d$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $919c580cdc166d3d$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $919c580cdc166d3d$export$acaf96a27438246b(second)(first);
        }
    };
};
var $919c580cdc166d3d$export$41404b31838667c9 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $919c580cdc166d3d$var$_reduce($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMap($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRight($gSyeU.Ord)
};
var $919c580cdc166d3d$export$e8f7d17aaff345cb = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $919c580cdc166d3d$var$_reduce($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMap($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRight($gSyeU.Ord),
    reduceWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceWithIndex($gSyeU.Ord),
    foldMapWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMapWithIndex($gSyeU.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRightWithIndex($gSyeU.Ord)
};
var $919c580cdc166d3d$export$a0202666c3bda011 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    reduce: /*#__PURE__*/ $919c580cdc166d3d$var$_reduce($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMap($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRight($gSyeU.Ord),
    traverse: /*#__PURE__*/ $919c580cdc166d3d$var$_traverse($gSyeU.Ord),
    sequence: $919c580cdc166d3d$export$49bb65c2ea163039
};
var $919c580cdc166d3d$export$bd7b528d8c36ec41 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    mapWithIndex: $919c580cdc166d3d$var$_mapWithIndex,
    reduce: /*#__PURE__*/ $919c580cdc166d3d$var$_reduce($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMap($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRight($gSyeU.Ord),
    reduceWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceWithIndex($gSyeU.Ord),
    foldMapWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMapWithIndex($gSyeU.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRightWithIndex($gSyeU.Ord),
    traverse: /*#__PURE__*/ $919c580cdc166d3d$var$_traverse($gSyeU.Ord),
    sequence: $919c580cdc166d3d$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_traverseWithIndex($gSyeU.Ord)
};
var $919c580cdc166d3d$var$_wither = /*#__PURE__*/ (0, $LdARg.witherDefault)($919c580cdc166d3d$export$a0202666c3bda011, $919c580cdc166d3d$export$4a21ac48141ac3c9);
var $919c580cdc166d3d$var$_wilt = /*#__PURE__*/ (0, $LdARg.wiltDefault)($919c580cdc166d3d$export$a0202666c3bda011, $919c580cdc166d3d$export$4a21ac48141ac3c9);
var $919c580cdc166d3d$export$748d317b4c426f96 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    reduce: /*#__PURE__*/ $919c580cdc166d3d$var$_reduce($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMap($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRight($gSyeU.Ord),
    traverse: /*#__PURE__*/ $919c580cdc166d3d$var$_traverse($gSyeU.Ord),
    sequence: $919c580cdc166d3d$export$49bb65c2ea163039,
    compact: $919c580cdc166d3d$export$8e16b83750b44988,
    separate: $919c580cdc166d3d$export$709f6946f4e97408,
    filter: $919c580cdc166d3d$var$_filter,
    filterMap: $919c580cdc166d3d$var$_filterMap,
    partition: $919c580cdc166d3d$var$_partition,
    partitionMap: $919c580cdc166d3d$var$_partitionMap,
    wither: $919c580cdc166d3d$var$_wither,
    wilt: $919c580cdc166d3d$var$_wilt
};
var $919c580cdc166d3d$export$6e22c362a0406a2c = {};
var $919c580cdc166d3d$export$9f200c4466975173 = $919c580cdc166d3d$export$ff82449ce381c54a;
var $919c580cdc166d3d$export$5a15a386532a5ea4 = $etcCS.hasOwnProperty;
var $919c580cdc166d3d$export$e5185e241753e543 = {
    URI: $919c580cdc166d3d$export$9156e739aa33e19f,
    map: $919c580cdc166d3d$var$_map,
    reduce: /*#__PURE__*/ $919c580cdc166d3d$var$_reduce($gSyeU.Ord),
    foldMap: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMap($gSyeU.Ord),
    reduceRight: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRight($gSyeU.Ord),
    traverse: /*#__PURE__*/ $919c580cdc166d3d$var$_traverse($gSyeU.Ord),
    sequence: $919c580cdc166d3d$export$49bb65c2ea163039,
    compact: $919c580cdc166d3d$export$8e16b83750b44988,
    separate: $919c580cdc166d3d$export$709f6946f4e97408,
    filter: $919c580cdc166d3d$var$_filter,
    filterMap: $919c580cdc166d3d$var$_filterMap,
    partition: $919c580cdc166d3d$var$_partition,
    partitionMap: $919c580cdc166d3d$var$_partitionMap,
    mapWithIndex: $919c580cdc166d3d$var$_mapWithIndex,
    reduceWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceWithIndex($gSyeU.Ord),
    foldMapWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_foldMapWithIndex($gSyeU.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_reduceRightWithIndex($gSyeU.Ord),
    filterMapWithIndex: $919c580cdc166d3d$var$_filterMapWithIndex,
    filterWithIndex: $919c580cdc166d3d$var$_filterWithIndex,
    partitionMapWithIndex: $919c580cdc166d3d$var$_partitionMapWithIndex,
    partitionWithIndex: $919c580cdc166d3d$var$_partitionWithIndex,
    traverseWithIndex: /*#__PURE__*/ $919c580cdc166d3d$var$_traverseWithIndex($gSyeU.Ord),
    wither: $919c580cdc166d3d$var$_wither,
    wilt: $919c580cdc166d3d$var$_wilt
};

});



parcelRegister("idTJH", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return Parser; });
$parcel$export(module.exports, "zero", function () { return zero; });
$parcel$export(module.exports, "parse", function () { return parse; });

var $kj6DU = parcelRequire("kj6DU");

var $3NXK3 = parcelRequire("3NXK3");

var $6piwk = parcelRequire("6piwk");
var PARSER_URI = 'fp-ts-routing/Parser';
/**
 * @category parsers
 * @since 0.4.0
 */ var Parser = /** @class */ function() {
    function Parser(run) {
        this.run = run;
    }
    /**
     * @since 0.4.0
     */ Parser.of = function(a) {
        return new Parser(function(s) {
            return $3NXK3.some([
                a,
                s
            ]);
        });
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.map = function(f) {
        return this.chain(function(a) {
            return Parser.of(f(a));
        }); // <= derived
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.ap = function(fab) {
        var _this = this;
        return fab.chain(function(f) {
            return _this.map(f);
        }); // <= derived
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.chain = function(f) {
        var _this = this;
        return new Parser(function(r) {
            return (0, $6piwk.pipe)(_this.run(r), $3NXK3.chain(function(_a) {
                var a = _a[0], r2 = _a[1];
                return f(a).run(r2);
            }));
        });
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.alt = function(that) {
        var _this = this;
        return new Parser(function(r) {
            return (0, $6piwk.pipe)(_this.run(r), $3NXK3.alt(function() {
                return that.run(r);
            }));
        });
    };
    /**
     * @since 0.4.0
     */ Parser.prototype.then = function(that) {
        return that.ap(this.map(assign));
    };
    return Parser;
}();
var zero = function() {
    return new Parser(function() {
        return $3NXK3.none;
    });
};
var parse = function(parser, r, a) {
    return (0, $6piwk.pipe)(parser.run(r), $3NXK3.fold(function() {
        return a;
    }, function(_a) {
        var x = _a[0];
        return x;
    }));
};
var getParserMonoid = function() {
    return {
        concat: function(x, y) {
            return x.alt(y);
        },
        empty: zero()
    };
};
var parser = {
    URI: PARSER_URI,
    map: function(ma, f) {
        return ma.map(f);
    },
    of: Parser.of,
    ap: function(mab, ma) {
        return ma.ap(mab);
    },
    chain: function(ma, f) {
        return ma.chain(f);
    },
    alt: function(fx, f) {
        return new Parser(function(r) {
            return (0, $6piwk.pipe)(fx.run(r), $3NXK3.alt(function() {
                return f().run(r);
            }));
        });
    },
    zero: zero
};
var alt = function(that) {
    return function(fa) {
        return parser.alt(fa, that);
    };
};
var ap = function(fa) {
    return function(fab) {
        return parser.ap(fab, fa);
    };
};
var apFirst = function(fb) {
    return function(fa) {
        return parser.ap(parser.map(fa, function(a) {
            return function() {
                return a;
            };
        }), fb);
    };
};
var apSecond = function(fb) {
    return function(fa) {
        return parser.ap(parser.map(fa, function() {
            return function(b) {
                return b;
            };
        }), fb);
    };
};
var chain = function(f) {
    return function(ma) {
        return parser.chain(ma, f);
    };
};
var chainFirst = function(f) {
    return function(ma) {
        return parser.chain(ma, function(a) {
            return parser.map(f(a), function() {
                return a;
            });
        });
    };
};
var flatten = function(mma) {
    return parser.chain(mma, (0, $kj6DU.identity));
};
var map = function(f) {
    return function(fa) {
        return parser.map(fa, f);
    };
};
var then = function(fb) {
    return function(fa) {
        return fa.then(fb);
    };
};
// --- Helpers
var assign = function(a) {
    return function(b) {
        return Object.assign({}, a, b);
    };
};

});


parcelRegister("bWyUJ", function(module, exports) {

$parcel$export(module.exports, "GameId", function () { return $9424ff85ba7324db$export$27b7f43ad4dafa40; });

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $9424ff85ba7324db$var$wrap, unwrap: $9424ff85ba7324db$var$unwrap } = (0, $hp7yq.iso)();
const $9424ff85ba7324db$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $9424ff85ba7324db$export$27b7f43ad4dafa40 = (0, $9ddGv.immutableAssign)($9424ff85ba7324db$var$wrap, {
    unwrap: $9424ff85ba7324db$var$unwrap,
    codec: $9424ff85ba7324db$var$codec
});

});

parcelRegister("aPuMp", function(module, exports) {

$parcel$export(module.exports, "Lang", function () { return $f28218601b276f7c$export$8a4528ea5590497a; });

var $3a4Bg = parcelRequire("3a4Bg");
const $f28218601b276f7c$var$e = (0, $3a4Bg.createEnum)(// 'en_US',
// 'cs_CZ',
// 'de_DE',
// 'el_GR',
// 'en_AU',
'en_GB', // 'en_PH',
// 'en_SG',
// 'es_AR',
// 'es_ES',
// 'es_MX',
'fr_FR');
const $f28218601b276f7c$var$fromNavigatorLanguage = (lang)=>{
    switch(lang){
        // case 'es-ES':
        // case 'es':
        //   return 'es_ES'
        case 'fr-FR':
        case 'fr':
            return 'fr_FR';
        default:
            return 'en_GB';
    }
};
const $f28218601b276f7c$export$8a4528ea5590497a = {
    ...$f28218601b276f7c$var$e,
    fromNavigatorLanguage: $f28218601b276f7c$var$fromNavigatorLanguage
};

});
parcelRegister("3a4Bg", function(module, exports) {

$parcel$export(module.exports, "createEnum", function () { return $48890e26de1348a3$export$37b2eedf6b7b231a; });

var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");
var $hOuM2 = parcelRequire("hOuM2");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $9ddGv = parcelRequire("9ddGv");
const $48890e26de1348a3$export$37b2eedf6b7b231a = (...values)=>{
    const [head, ...tail] = values;
    const decoder = $5zWxO.literal(head, ...tail);
    const encoder = $aXkbA.id();
    const codec = $7uCHH.make(decoder, encoder);
    const Eq = (0, $9RyKW).eqStrict;
    const Ord = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((value)=>(0, $kj6DU.pipe)(values, (0, $9ddGv.List).findIndex((v)=>Eq.equals(v, value)), (0, $9ddGv.Maybe).getOrElse(()=>Infinity))));
    const res = {
        values: values,
        decoder: decoder,
        encoder: encoder,
        codec: codec,
        Eq: Eq,
        Ord: Ord
    };
    return res;
};

});


parcelRegister("5Dwzl", function(module, exports) {

$parcel$export(module.exports, "Platform", function () { return $d9f95f5124f11d6e$export$2dffd0b5373a4389; });

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $hrnY6 = parcelRequire("hrnY6");

var $3a4Bg = parcelRequire("3a4Bg");
const $d9f95f5124f11d6e$var$e = (0, $3a4Bg.createEnum)('BR', 'EUN', 'EUW', 'JP', 'KR', 'LA1', 'LA2', 'NA', 'OC', 'TR', 'RU', 'PH2', 'SG2', 'TH2', 'TW2', 'VN2');
const $d9f95f5124f11d6e$var$decoderLower = $5zWxO.literal(// eslint-disable-next-line @typescript-eslint/no-explicit-any
...$d9f95f5124f11d6e$var$e.values.map((0, $hrnY6.StringUtils).toLowerCase));
const $d9f95f5124f11d6e$var$encoderLower = {
    encode: (0, $hrnY6.StringUtils).toLowerCase
};
const $d9f95f5124f11d6e$var$orLowerCaseCodec = $7uCHH.make($5zWxO.union($d9f95f5124f11d6e$var$e.decoder, $d9f95f5124f11d6e$var$decoderLower), $d9f95f5124f11d6e$var$encoderLower);
const $d9f95f5124f11d6e$var$defaultPlatform = 'EUW';
const $d9f95f5124f11d6e$export$2dffd0b5373a4389 = {
    ...$d9f95f5124f11d6e$var$e,
    encoderLower: $d9f95f5124f11d6e$var$encoderLower,
    orLowerCaseCodec: $d9f95f5124f11d6e$var$orLowerCaseCodec,
    defaultPlatform: $d9f95f5124f11d6e$var$defaultPlatform
};

});

parcelRegister("7pd72", function(module, exports) {

$parcel$export(module.exports, "Puuid", function () { return $1cebda14173078fc$export$75429ad826a6037b; });

var $9RyKW = parcelRequire("9RyKW");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $1cebda14173078fc$var$wrap, unwrap: $1cebda14173078fc$var$unwrap } = (0, $hp7yq.iso)();
const $1cebda14173078fc$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $1cebda14173078fc$var$Eq = (0, $kj6DU.pipe)((0, $gSyeU).Eq, (0, $9RyKW).contramap($1cebda14173078fc$var$unwrap));
const $1cebda14173078fc$export$75429ad826a6037b = (0, $9ddGv.immutableAssign)($1cebda14173078fc$var$wrap, {
    unwrap: $1cebda14173078fc$var$unwrap,
    codec: $1cebda14173078fc$var$codec,
    Eq: $1cebda14173078fc$var$Eq
});

});

parcelRegister("kaLCO", function(module, exports) {

$parcel$export(module.exports, "GameName", function () { return $d4275445de5489db$export$5317697ff0dbedd3; });

var $9RyKW = parcelRequire("9RyKW");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $d4275445de5489db$var$wrap, unwrap: $d4275445de5489db$var$unwrap } = (0, $hp7yq.iso)();
const $d4275445de5489db$var$modify = (0, $kj6DU.identity);
const $d4275445de5489db$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $d4275445de5489db$var$trim = $d4275445de5489db$var$modify((0, $gSyeU).trim);
const $d4275445de5489db$var$whiteSpaces = /\s+/g;
const $d4275445de5489db$var$clean = $d4275445de5489db$var$modify((name)=>name.toLowerCase().replaceAll($d4275445de5489db$var$whiteSpaces, ''));
const $d4275445de5489db$var$Eq = (0, $kj6DU.pipe)((0, $gSyeU).Eq, (0, $9RyKW).contramap($d4275445de5489db$var$unwrap));
const $d4275445de5489db$export$5317697ff0dbedd3 = (0, $9ddGv.immutableAssign)($d4275445de5489db$var$wrap, {
    unwrap: $d4275445de5489db$var$unwrap,
    codec: $d4275445de5489db$var$codec,
    trim: $d4275445de5489db$var$trim,
    clean: $d4275445de5489db$var$clean,
    Eq: $d4275445de5489db$var$Eq
});

});

parcelRegister("appXD", function(module, exports) {

$parcel$export(module.exports, "RiotId", function () { return $729558781f2b0a97$export$5c53af361d6e628b; });

var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $kaLCO = parcelRequire("kaLCO");

var $gkOpi = parcelRequire("gkOpi");
const $729558781f2b0a97$var$empty = {
    gameName: (0, $kaLCO.GameName)(''),
    tagLine: (0, $gkOpi.TagLine)('')
};
function $729558781f2b0a97$var$construct(gameName, tagLine) {
    return {
        gameName: gameName,
        tagLine: tagLine
    };
}
// {3-16}#{3-5}
function $729558781f2b0a97$var$regex(sep) {
    return RegExp(`^(.+)${sep}([^${sep}]+)$`);
}
function $729558781f2b0a97$var$getFromStringDecoder(sep) {
    return {
        decode: (str)=>(0, $kj6DU.pipe)(str, (0, $hrnY6.StringUtils).matcher2($729558781f2b0a97$var$regex(sep)), (0, $9ddGv.Maybe).fold(()=>$5zWxO.failure(str, `RiotId[${sep}]`), ([gameName, tagLine])=>$5zWxO.success($729558781f2b0a97$var$construct((0, $kaLCO.GameName)(gameName), (0, $gkOpi.TagLine)(tagLine)))))
    };
}
function $729558781f2b0a97$var$getFromStringUnknownDecoder(sep) {
    return (0, $kj6DU.pipe)($5zWxO.string, $5zWxO.compose($729558781f2b0a97$var$getFromStringDecoder(sep)));
}
const $729558781f2b0a97$var$getStringify = (sep)=>({ gameName: gameName, tagLine: tagLine })=>`${gameName}${sep}${tagLine}`;
function $729558781f2b0a97$var$getFromStringEncoder(sep) {
    return (0, $kj6DU.pipe)($aXkbA.id(), $aXkbA.contramap($729558781f2b0a97$var$getStringify(sep)));
}
function $729558781f2b0a97$var$getFromStringCodec(sep) {
    return $7uCHH.make($729558781f2b0a97$var$getFromStringUnknownDecoder(sep), $729558781f2b0a97$var$getFromStringEncoder(sep));
}
function $729558781f2b0a97$var$trim({ gameName: gameName, tagLine: tagLine }) {
    return {
        gameName: (0, $kaLCO.GameName).trim(gameName),
        tagLine: (0, $gkOpi.TagLine).trim(tagLine)
    };
}
function $729558781f2b0a97$var$clean({ gameName: gameName, tagLine: tagLine }) {
    return {
        gameName: (0, $kaLCO.GameName).clean(gameName),
        tagLine: (0, $gkOpi.TagLine).clean(tagLine)
    };
}
const $729558781f2b0a97$var$Eq = (0, $9RyKW).struct({
    gameName: (0, $kaLCO.GameName).Eq,
    tagLine: (0, $gkOpi.TagLine).Eq
});
const $729558781f2b0a97$export$5c53af361d6e628b = (0, $9ddGv.immutableAssign)($729558781f2b0a97$var$construct, {
    empty: $729558781f2b0a97$var$empty,
    getFromStringCodec: $729558781f2b0a97$var$getFromStringCodec,
    fromStringDecoder: $729558781f2b0a97$var$getFromStringDecoder('#'),
    fromStringCodec: $729558781f2b0a97$var$getFromStringCodec('#'),
    stringify: $729558781f2b0a97$var$getStringify('#'),
    trim: $729558781f2b0a97$var$trim,
    clean: $729558781f2b0a97$var$clean,
    Eq: $729558781f2b0a97$var$Eq
});

});
parcelRegister("gkOpi", function(module, exports) {

$parcel$export(module.exports, "TagLine", function () { return $7fe9e7588c0168cf$export$eb80c4b532487e1b; });

var $9RyKW = parcelRequire("9RyKW");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $7fe9e7588c0168cf$var$wrap, unwrap: $7fe9e7588c0168cf$var$unwrap } = (0, $hp7yq.iso)();
const $7fe9e7588c0168cf$var$modify = (0, $kj6DU.identity);
const $7fe9e7588c0168cf$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $7fe9e7588c0168cf$var$trim = $7fe9e7588c0168cf$var$modify((0, $gSyeU).trim);
const $7fe9e7588c0168cf$var$whiteSpaces = /\s+/g;
const $7fe9e7588c0168cf$var$clean = $7fe9e7588c0168cf$var$modify((name)=>name.toLowerCase().replaceAll($7fe9e7588c0168cf$var$whiteSpaces, ''));
const $7fe9e7588c0168cf$var$Eq = (0, $kj6DU.pipe)((0, $gSyeU).Eq, (0, $9RyKW).contramap($7fe9e7588c0168cf$var$unwrap));
const $7fe9e7588c0168cf$export$eb80c4b532487e1b = (0, $9ddGv.immutableAssign)($7fe9e7588c0168cf$var$wrap, {
    unwrap: $7fe9e7588c0168cf$var$unwrap,
    codec: $7fe9e7588c0168cf$var$codec,
    trim: $7fe9e7588c0168cf$var$trim,
    clean: $7fe9e7588c0168cf$var$clean,
    Eq: $7fe9e7588c0168cf$var$Eq
});

});


parcelRegister("87QkX", function(module, exports) {

$parcel$export(module.exports, "RouterUtils", function () { return $fdb1865893c77336$export$68c7f300a63aab8e; });

var $9fMqj = parcelRequire("9fMqj");
var $61eNN = parcelRequire("61eNN");
var $idTJH = parcelRequire("idTJH");
var $2MDjk = parcelRequire("2MDjk");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
const $fdb1865893c77336$var$codec_ = (k, codec)=>new (0, $61eNN.Match)(new (0, $idTJH.Parser)((r)=>{
        if (!(0, $9ddGv.List).isNonEmpty(r.parts)) return (0, $9ddGv.Maybe).none;
        const [head, tail] = (0, $9ddGv.NonEmptyArray).unprepend(r.parts);
        return (0, $kj6DU.pipe)(codec.decode(head), (0, $9ddGv.Maybe).fromEither, (0, $9ddGv.Maybe).map((a)=>(0, $9ddGv.Tuple).of($fdb1865893c77336$var$singleton(k, a), new (0, $2MDjk.Route)((0, $9ddGv.List).asMutable(tail), r.query))));
    }), new (0, $9fMqj.Formatter)((r, o)=>new (0, $2MDjk.Route)(r.parts.concat(codec.encode(o[k])), r.query)));
const $fdb1865893c77336$var$singleton = (k, a)=>({
        [k]: a
    });
const $fdb1865893c77336$export$68c7f300a63aab8e = {
    codec: $fdb1865893c77336$var$codec_
};

});


parcelRegister("i92em", function(module, exports) {

$parcel$export(module.exports, "ValidatedSoft", function () { return $0a813cd8ccf1df17$export$47e6e6513f17b8f2; });

var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $9ddGv = parcelRequire("9ddGv");
const $0a813cd8ccf1df17$var$URI = 'ValidatedSoft';
function $0a813cd8ccf1df17$var$of(value, ...errors) {
    return {
        value: value,
        errors: errors
    };
}
const $0a813cd8ccf1df17$var$fromOption = (onNone)=>(0, $9ddGv.Maybe).fold(()=>$0a813cd8ccf1df17$var$of(...onNone()), $0a813cd8ccf1df17$var$of);
const $0a813cd8ccf1df17$var$value = (fa)=>fa.value;
const $0a813cd8ccf1df17$var$errors = (fa)=>fa.errors;
const $0a813cd8ccf1df17$var$map = (f)=>(fa)=>({
            value: f(fa.value),
            errors: fa.errors
        });
const $0a813cd8ccf1df17$var$mapLeft = (f)=>(fa)=>({
            value: fa.value,
            errors: fa.errors.map(f)
        });
const $0a813cd8ccf1df17$var$bimap = (g, f)=>(fa)=>({
            value: f(fa.value),
            errors: fa.errors.map(g)
        });
function $0a813cd8ccf1df17$var$ap_(fab, fa) {
    return {
        value: fab.value(fa.value),
        errors: (0, $kj6DU.pipe)(fab.errors, (0, $9ddGv.List).concat(fa.errors))
    };
}
const $0a813cd8ccf1df17$var$chain = (f)=>(fa)=>{
        const fb = f(fa.value);
        return {
            value: fb.value,
            errors: (0, $kj6DU.pipe)(fa.errors, (0, $9ddGv.List).concat(fb.errors))
        };
    };
const $0a813cd8ccf1df17$var$chainFirst = (f)=>$0a813cd8ccf1df17$var$chain((a)=>(0, $kj6DU.pipe)(f(a), $0a813cd8ccf1df17$var$map(()=>a)));
const $0a813cd8ccf1df17$var$map_ = (fa, f)=>(0, $kj6DU.pipe)(fa, $0a813cd8ccf1df17$var$map(f));
const $0a813cd8ccf1df17$var$Applicative = {
    URI: $0a813cd8ccf1df17$var$URI,
    map: $0a813cd8ccf1df17$var$map_,
    ap: $0a813cd8ccf1df17$var$ap_,
    of: $0a813cd8ccf1df17$var$of
};
function $0a813cd8ccf1df17$var$decoder(valueDecoder, errorDecoder) {
    return $5zWxO.struct({
        value: valueDecoder,
        errors: $5zWxO.array(errorDecoder)
    });
}
// don't declare encoder to enforce empty errors if no permission for user
const $0a813cd8ccf1df17$export$47e6e6513f17b8f2 = (0, $9ddGv.immutableAssign)($0a813cd8ccf1df17$var$of, {
    fromOption: $0a813cd8ccf1df17$var$fromOption,
    value: $0a813cd8ccf1df17$var$value,
    errors: $0a813cd8ccf1df17$var$errors,
    map: $0a813cd8ccf1df17$var$map,
    mapLeft: $0a813cd8ccf1df17$var$mapLeft,
    bimap: $0a813cd8ccf1df17$var$bimap,
    chain: $0a813cd8ccf1df17$var$chain,
    chainFirst: $0a813cd8ccf1df17$var$chainFirst,
    Applicative: $0a813cd8ccf1df17$var$Applicative,
    decoder: $0a813cd8ccf1df17$var$decoder
});

});

parcelRegister("632HS", function(module, exports) {

$parcel$export(module.exports, "ChampionKey", function () { return $95e98f031735e150$export$6743586dfba67091; });

var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $95e98f031735e150$var$wrap, unwrap: $95e98f031735e150$var$unwrap } = (0, $hp7yq.iso)();
const $95e98f031735e150$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $95e98f031735e150$var$fromStringCodec = $7uCHH.make((0, $kj6DU.pipe)((0, $xJ0AO.NumberFromString).decoder, $5zWxO.map($95e98f031735e150$var$wrap)), {
    encode: String
});
const $95e98f031735e150$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($95e98f031735e150$var$unwrap));
const $95e98f031735e150$export$6743586dfba67091 = (0, $9ddGv.immutableAssign)($95e98f031735e150$var$wrap, {
    unwrap: $95e98f031735e150$var$unwrap,
    codec: $95e98f031735e150$var$codec,
    fromStringCodec: $95e98f031735e150$var$fromStringCodec,
    Eq: $95e98f031735e150$var$Eq
});

});

parcelRegister("k1y2D", function(module, exports) {

$parcel$export(module.exports, "StaticData", function () { return $e61a6212f48234d5$export$6dbc8f75f0b63bf9; });

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $iNmEk = parcelRequire("iNmEk");

var $f96Tp = parcelRequire("f96Tp");
const $e61a6212f48234d5$var$codec = $7uCHH.struct({
    version: (0, $iNmEk.DDragonVersion).codec,
    champions: (0, $9ddGv.List).codec((0, $f96Tp.StaticDataChampion).codec)
});
const $e61a6212f48234d5$export$6dbc8f75f0b63bf9 = {
    codec: $e61a6212f48234d5$var$codec
};

});
parcelRegister("iNmEk", function(module, exports) {

$parcel$export(module.exports, "DDragonVersion", function () { return $6b6f197afd270213$export$3fff7f6212ffbb69; });

var $9RyKW = parcelRequire("9RyKW");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $xJ0AO = parcelRequire("xJ0AO");
const { unwrap: $6b6f197afd270213$var$unwrap } = (0, $hp7yq.iso)();
const $6b6f197afd270213$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $6b6f197afd270213$var$Eq = (0, $kj6DU.pipe)((0, $gSyeU).Eq, (0, $9RyKW).contramap($6b6f197afd270213$var$unwrap));
const $6b6f197afd270213$export$3fff7f6212ffbb69 = {
    codec: $6b6f197afd270213$var$codec,
    Eq: $6b6f197afd270213$var$Eq
};

});

parcelRegister("f96Tp", function(module, exports) {

$parcel$export(module.exports, "StaticDataChampion", function () { return $c92581a632137b78$export$1f782643d91c024c; });

var $hOuM2 = parcelRequire("hOuM2");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $8yAcT = parcelRequire("8yAcT");

var $ffzmL = parcelRequire("ffzmL");

var $l6DgY = parcelRequire("l6DgY");

var $632HS = parcelRequire("632HS");

var $lfkrA = parcelRequire("lfkrA");
const $c92581a632137b78$var$codec = $7uCHH.struct({
    id: (0, $l6DgY.ChampionId).codec,
    key: (0, $632HS.ChampionKey).codec,
    name: $7uCHH.string,
    positions: (0, $9ddGv.List).codec((0, $lfkrA.ChampionPosition).codec),
    factions: (0, $9ddGv.List).codec((0, $ffzmL.ChampionFaction).codec),
    aram: (0, $8yAcT.MapChangesData).codec,
    urf: (0, $8yAcT.MapChangesData).codec
});
const $c92581a632137b78$var$getFaction = (0, $kj6DU.flow)((0, $9ddGv.List).head, (0, $9ddGv.Maybe).getOrElse(()=>'none'));
const $c92581a632137b78$var$byName = (0, $kj6DU.pipe)((0, $gSyeU).Ord, (0, $hOuM2).contramap((c)=>(0, $hrnY6.StringUtils).cleanUTF8ToASCII(c.name)));
const $c92581a632137b78$export$1f782643d91c024c = {
    codec: $c92581a632137b78$var$codec,
    getFaction: $c92581a632137b78$var$getFaction,
    Ord: {
        byName: $c92581a632137b78$var$byName
    }
};

});
parcelRegister("8yAcT", function(module, exports) {

$parcel$export(module.exports, "MapChangesData", function () { return $4c2f84947246033f$export$22f9c37e0e6f8419; });

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $7znXl = parcelRequire("7znXl");

var $kMW27 = parcelRequire("kMW27");

var $cdTKd = parcelRequire("cdTKd");
const $4c2f84947246033f$var$mapChangesDataAbilityCodec = $7uCHH.struct({
    icon: $7uCHH.string,
    description: $7uCHH.string
});
const $4c2f84947246033f$var$abilitiesCodec = (0, $xJ0AO.MapFromArray).codec((0, $9ddGv.idcOrd)((0, $kMW27.Ability).Eq))((0, $kMW27.Ability).codec, $4c2f84947246033f$var$mapChangesDataAbilityCodec);
const $4c2f84947246033f$var$skillCodec = $7uCHH.struct({
    name: (0, $kMW27.Ability).codec,
    icon: $7uCHH.string,
    abilities: $4c2f84947246033f$var$abilitiesCodec
});
const $4c2f84947246033f$var$skillsProperties = (0, $kj6DU.pipe)((0, $cdTKd.Skill).values, (0, $9ddGv.List).reduce((0, $9ddGv.Dict).empty(), (acc, skill)=>({
        ...acc,
        [skill]: $4c2f84947246033f$var$skillCodec
    })));
const $4c2f84947246033f$var$skillsCodec = $7uCHH.partial($4c2f84947246033f$var$skillsProperties);
const $4c2f84947246033f$var$codec = $7uCHH.struct({
    stats: (0, $9ddGv.Maybe).codec((0, $7znXl.WikiStatsBalance).codec),
    skills: (0, $9ddGv.Maybe).codec($4c2f84947246033f$var$skillsCodec)
});
const $4c2f84947246033f$var$empty = {
    stats: (0, $9ddGv.Maybe).none,
    skills: (0, $9ddGv.Maybe).none
};
const $4c2f84947246033f$export$22f9c37e0e6f8419 = {
    codec: $4c2f84947246033f$var$codec,
    empty: $4c2f84947246033f$var$empty
};

});
parcelRegister("7znXl", function(module, exports) {

$parcel$export(module.exports, "WikiStatsBalance", function () { return $174f206153181cfa$export$35c2593264a51fd1; });

var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $k6yCu = parcelRequire("k6yCu");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const $174f206153181cfa$var$properties = {
    dmg_dealt: $7uCHH.number,
    dmg_taken: $7uCHH.number,
    healing: $7uCHH.number,
    shielding: $7uCHH.number,
    ability_haste: $7uCHH.number,
    energyregen_mod: $7uCHH.number,
    total_as: $7uCHH.number,
    movement_speed: $7uCHH.number,
    tenacity: $7uCHH.number
};
const $174f206153181cfa$var$rawCodec = (0, $xJ0AO.StrictPartial).codec($174f206153181cfa$var$properties);
const $174f206153181cfa$var$codec = $7uCHH.make((0, $kj6DU.pipe)($174f206153181cfa$var$rawCodec, $5zWxO.map((0, $kj6DU.flow)((0, $k6yCu.DictUtils).partial.entries, (0, $9ddGv.List).reduce({}, (acc, [key, val])=>{
    if (val === undefined) return acc;
    if ($174f206153181cfa$var$isModifierStat(key)) {
        if (val === 1) return acc;
    } else {
        if (val === 0) return acc;
    }
    return {
        ...acc,
        [key]: val
    };
})))), $174f206153181cfa$var$rawCodec);
const $174f206153181cfa$var$Eq = (0, $gSyeU).Eq;
const $174f206153181cfa$var$keys = (0, $k6yCu.DictUtils).keys($174f206153181cfa$var$properties);
const $174f206153181cfa$var$modifierStats = [
    'dmg_dealt',
    'dmg_taken',
    'healing',
    'shielding',
    'energyregen_mod',
    'total_as',
    'movement_speed',
    'tenacity'
];
const $174f206153181cfa$var$percentsStats = (0, $kj6DU.pipe)($174f206153181cfa$var$modifierStats, (0, $9ddGv.List).difference($174f206153181cfa$var$Eq)([
    'tenacity'
]));
const $174f206153181cfa$var$malusStats = [
    'dmg_taken'
];
const $174f206153181cfa$var$isModifierStat = (stat)=>(0, $9ddGv.List).elem($174f206153181cfa$var$Eq)(stat, $174f206153181cfa$var$modifierStats);
const $174f206153181cfa$var$isPercentsStat = (stat)=>(0, $9ddGv.List).elem($174f206153181cfa$var$Eq)(stat, $174f206153181cfa$var$percentsStats);
const $174f206153181cfa$var$isMalusStat = (stat)=>(0, $9ddGv.List).elem($174f206153181cfa$var$Eq)(stat, $174f206153181cfa$var$malusStats);
const $174f206153181cfa$export$35c2593264a51fd1 = {
    keys: $174f206153181cfa$var$keys,
    codec: $174f206153181cfa$var$codec,
    isModifierStat: $174f206153181cfa$var$isModifierStat,
    isPercentsStat: $174f206153181cfa$var$isPercentsStat,
    isMalusStat: $174f206153181cfa$var$isMalusStat,
    Eq: $174f206153181cfa$var$Eq
};

});

parcelRegister("kMW27", function(module, exports) {

$parcel$export(module.exports, "Ability", function () { return $4ace30f31d76e471$export$b6ec296273510720; });

var $9RyKW = parcelRequire("9RyKW");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $4ace30f31d76e471$var$wrap, unwrap: $4ace30f31d76e471$var$unwrap } = (0, $hp7yq.iso)();
const $4ace30f31d76e471$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $4ace30f31d76e471$var$Eq = (0, $kj6DU.pipe)((0, $gSyeU).Eq, (0, $9RyKW).contramap($4ace30f31d76e471$var$unwrap));
const $4ace30f31d76e471$export$b6ec296273510720 = (0, $9ddGv.immutableAssign)($4ace30f31d76e471$var$wrap, {
    unwrap: $4ace30f31d76e471$var$unwrap,
    codec: $4ace30f31d76e471$var$codec,
    Eq: $4ace30f31d76e471$var$Eq
});

});

parcelRegister("cdTKd", function(module, exports) {

$parcel$export(module.exports, "Skill", function () { return $5368ec575fc4c064$export$118171a82d109c04; });

var $3a4Bg = parcelRequire("3a4Bg");
const $5368ec575fc4c064$var$e = (0, $3a4Bg.createEnum)('I', 'Q', 'W', 'E', 'R');
const $5368ec575fc4c064$export$118171a82d109c04 = $5368ec575fc4c064$var$e;

});


parcelRegister("ffzmL", function(module, exports) {

$parcel$export(module.exports, "ChampionFaction", function () { return $8a9d15f7920ba9bf$export$e5c84eb6bac9e227; });
$parcel$export(module.exports, "ChampionFactionOrNone", function () { return $8a9d15f7920ba9bf$export$ceff5ef58cc8afca; });

var $kj6DU = parcelRequire("kj6DU");

var $3a4Bg = parcelRequire("3a4Bg");

var $9ddGv = parcelRequire("9ddGv");
const $8a9d15f7920ba9bf$var$e = (0, $3a4Bg.createEnum)('bandle', 'bilgewater', 'demacia', 'freljord', 'ionia', 'ixtal', 'noxus', 'piltover', 'shadowIsles', 'shurima', 'targon', 'void', 'zaun');
const $8a9d15f7920ba9bf$export$e5c84eb6bac9e227 = $8a9d15f7920ba9bf$var$e;
const $8a9d15f7920ba9bf$var$eOrNone = (0, $3a4Bg.createEnum)(...$8a9d15f7920ba9bf$var$e.values, 'none');
// sortBy, but always with 'none' as last
const $8a9d15f7920ba9bf$var$valuesSortBy = (ords)=>(0, $kj6DU.pipe)($8a9d15f7920ba9bf$export$e5c84eb6bac9e227.values, (0, $9ddGv.List).sortBy(ords), (0, $9ddGv.List).append('none'));
const $8a9d15f7920ba9bf$export$ceff5ef58cc8afca = {
    ...$8a9d15f7920ba9bf$var$eOrNone,
    valuesSortBy: $8a9d15f7920ba9bf$var$valuesSortBy
};

});

parcelRegister("l6DgY", function(module, exports) {

$parcel$export(module.exports, "ChampionId", function () { return $1f75a50ee717e9da$export$4a330e2d617c0861; });

var $7uCHH = parcelRequire("7uCHH");

var $xJ0AO = parcelRequire("xJ0AO");
const $1f75a50ee717e9da$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $1f75a50ee717e9da$export$4a330e2d617c0861 = {
    codec: $1f75a50ee717e9da$var$codec
};

});

parcelRegister("lfkrA", function(module, exports) {

$parcel$export(module.exports, "ChampionPosition", function () { return $bd44bc15f12f9175$export$a7d164f5e8c25a4d; });

var $3a4Bg = parcelRequire("3a4Bg");
const $bd44bc15f12f9175$var$e = (0, $3a4Bg.createEnum)('top', 'jun', 'mid', 'bot', 'sup');
const $bd44bc15f12f9175$export$a7d164f5e8c25a4d = $bd44bc15f12f9175$var$e;

});



parcelRegister("52dbH", function(module, exports) {

$parcel$export(module.exports, "DDragonUtils", function () { return $9994c6a980dc2e6a$export$c5501039374a79ad; });
const $9994c6a980dc2e6a$var$ddragon = (path)=>`https://ddragon.leagueoflegends.com${path}`;
const $9994c6a980dc2e6a$var$ddragonCdn = (version, path)=>$9994c6a980dc2e6a$var$ddragon(`/cdn/${version}${path}`);
const $9994c6a980dc2e6a$export$c5501039374a79ad = {
    ddragon: $9994c6a980dc2e6a$var$ddragon,
    ddragonCdn: $9994c6a980dc2e6a$var$ddragonCdn
};

});

parcelRegister("javAY", function(module, exports) {

$parcel$export(module.exports, "ListUtils", function () { return $477cdbd868750c34$export$f2e7765fb620050; });

var $cF6yJ = parcelRequire("cF6yJ");
var $hOuM2 = parcelRequire("hOuM2");
var $8RK6P = parcelRequire("8RK6P");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
const $477cdbd868750c34$var$findFirstBy = (eq)=>(f)=>(as)=>(value)=>(0, $kj6DU.pipe)(as, (0, $9ddGv.List).findFirst((v)=>eq.equals(f(v), value)));
const $477cdbd868750c34$var$findFirstWithIndex = (predicate)=>(as)=>(0, $kj6DU.pipe)(as, (0, $9ddGv.List).findIndex(predicate), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $9ddGv.Maybe).map((i)=>(0, $9ddGv.Tuple).of(i, as[i])));
const $477cdbd868750c34$var$findFirstWithPrevious = (f)=>(as)=>{
        // eslint-disable-next-line functional/no-let
        let prev = (0, $9ddGv.Maybe).none;
        return (0, $kj6DU.pipe)(as, (0, $9ddGv.List).findFirst((a)=>{
            const res = f(prev, a);
            // eslint-disable-next-line functional/no-expression-statements
            prev = (0, $9ddGv.Maybe).some(a);
            return res;
        }));
    };
const $477cdbd868750c34$var$groupByAsMap = (eq)=>(f)=>(as)=>(0, $kj6DU.pipe)(as, (0, $9ddGv.List).map((0, $kj6DU.flow)(f, (0, $9ddGv.Tuple).mapSnd((0, $9ddGv.NonEmptyArray).of))), (0, $8RK6P).fromFoldable(eq, (0, $9ddGv.NonEmptyArray).getSemigroup(), (0, $9ddGv.List).Foldable));
const $477cdbd868750c34$var$mapWithPrevious = (f)=>(as)=>{
        // eslint-disable-next-line functional/no-let
        let prev = (0, $9ddGv.Maybe).none;
        return (0, $kj6DU.pipe)(as, (0, $9ddGv.List).map((a)=>{
            const res = f(prev, a);
            // eslint-disable-next-line functional/no-expression-statements
            prev = (0, $9ddGv.Maybe).some(a);
            return res;
        }));
    };
const $477cdbd868750c34$var$multipleGroupBy = (f)=>(as)=>{
        const out = {};
        /* eslint-disable functional/no-loop-statements */ for (const a of as){
            const ks = f(a);
            for (const k of ks)/* eslint-enable functional/no-loop-statements */ if ($477cdbd868750c34$var$has.call(out, k)) /* eslint-disable functional/no-expression-statements */ // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            out[k].push(a);
            else // eslint-disable-next-line functional/immutable-data
            out[k] = [
                a
            ];
        }
        return out;
    };
const $477cdbd868750c34$var$updateOrAppend = (eq)=>(a)=>(as)=>(0, $kj6DU.pipe)(as, (0, $9ddGv.List).findIndex((a_)=>eq.equals(a_, a)), (0, $9ddGv.Maybe).fold(()=>(0, $kj6DU.pipe)(as, (0, $9ddGv.List).append(a)), (i)=>(0, $9ddGv.List).unsafeUpdateAt(i, a, as)));
const $477cdbd868750c34$var$padEnd = (maxLength, fillWith)=>(as)=>maxLength <= as.length ? as : (0, $kj6DU.pipe)(as, (0, $9ddGv.List).concatW((0, $9ddGv.List).makeBy(maxLength - as.length, ()=>fillWith)));
const $477cdbd868750c34$var$listLengthOrd = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((0, $9ddGv.List).size));
const $477cdbd868750c34$var$commonElems = (eq)=>(as)=>{
        if (!(0, $9ddGv.List).isNonEmpty(as)) return [];
        if (as.length === 1) return (0, $9ddGv.NonEmptyArray).head(as);
        const [shortest, remain] = (0, $kj6DU.pipe)(as, (0, $9ddGv.NonEmptyArray).sort($477cdbd868750c34$var$listLengthOrd), (0, $9ddGv.NonEmptyArray).unprepend);
        if (!(0, $9ddGv.List).isNonEmpty(shortest)) return [];
        return (0, $kj6DU.pipe)(shortest, (0, $9ddGv.List).filter((a)=>(0, $kj6DU.pipe)(remain, (0, $9ddGv.List).every((0, $9ddGv.List).elem(eq)(a)))), (0, $9ddGv.List).uniq(eq));
    };
/**
 * https://github.com/granteagon/move/blob/master/src/index.js
 *
 * Note: This is a pure function so a new array will be returned, instead of altering the array argument.
 *
 * @param as Array in which to move an item.
 * @param moveIndex The index of the item to move.
 * @param toIndex The index to move item at moveIndex to.
 * @returns
 */ const $477cdbd868750c34$var$move = (as, moveIndex, toIndex)=>{
    const item = as[moveIndex];
    const length = as.length;
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...as.slice(0, toIndex),
        item,
        ...as.slice(toIndex, moveIndex),
        ...as.slice(moveIndex + 1, length)
    ];
    if (diff < 0) {
        // move right
        const targetIndex = toIndex + 1;
        return [
            ...as.slice(0, moveIndex),
            ...as.slice(moveIndex + 1, targetIndex),
            item,
            ...as.slice(targetIndex, length)
        ];
    }
    return as;
};
const $477cdbd868750c34$var$swap = (as, swapIndex, toIndex)=>{
    const res = as.slice();
    /* eslint-disable @typescript-eslint/no-non-null-assertion, functional/no-expression-statements, functional/immutable-data */ res[swapIndex] = as[toIndex];
    res[toIndex] = as[swapIndex];
    /* eslint-enable functional/no-expression-statements, functional/immutable-data */ return res;
};
const $477cdbd868750c34$export$f2e7765fb620050 = {
    findFirstBy: $477cdbd868750c34$var$findFirstBy,
    findFirstWithIndex: $477cdbd868750c34$var$findFirstWithIndex,
    findFirstWithPrevious: $477cdbd868750c34$var$findFirstWithPrevious,
    groupByAsMap: $477cdbd868750c34$var$groupByAsMap,
    mapWithPrevious: $477cdbd868750c34$var$mapWithPrevious,
    multipleGroupBy: $477cdbd868750c34$var$multipleGroupBy,
    updateOrAppend: $477cdbd868750c34$var$updateOrAppend,
    padEnd: $477cdbd868750c34$var$padEnd,
    commonElems: $477cdbd868750c34$var$commonElems,
    move: $477cdbd868750c34$var$move,
    swap: $477cdbd868750c34$var$swap
};
// eslint-disable-next-line @typescript-eslint/unbound-method
const $477cdbd868750c34$var$has = Object.prototype.hasOwnProperty;

});

parcelRegister("kJ6py", function(module, exports) {

$parcel$export(module.exports, "AsyncRenderer", function () { return $d03926c83e242231$export$e13071d3daf42cea; });

var $aSiaI = parcelRequire("aSiaI");

var $1VnRj = parcelRequire("1VnRj");

var $hZroh = parcelRequire("hZroh");

var $8Wmxp = parcelRequire("8Wmxp");

var $cwvCy = parcelRequire("cwvCy");
function $d03926c83e242231$export$e13071d3daf42cea({ data: data, error: error, children: children }) {
    const { t: t } = (0, $hZroh.useTranslation)('common');
    if (error !== undefined) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex justify-center",
        children: error instanceof (0, $1VnRj.HTTPError) && error.response.status === 404 ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cwvCy.Pre), {
            className: "mt-4",
            children: t.notFound
        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cwvCy.Pre), {
            className: "mt-4",
            children: t.error
        })
    });
    if (data === undefined) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
            className: "mt-4 h-6"
        })
    });
    return children(data);
}

});
parcelRegister("1VnRj", function(module, exports) {

$parcel$export(module.exports, "HTTPError", function () { return $166d9f31c8728179$export$aa9d629c530f62a7; });
class $166d9f31c8728179$export$aa9d629c530f62a7 extends Error {
    response;
    request;
    options;
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText || '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}: ${request.method} ${request.url}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
    }
}

});

parcelRegister("hZroh", function(module, exports) {

$parcel$export(module.exports, "TranslationContextProvider", function () { return $403c8f6ec3654478$export$6dd9d1cecb6d3d0; });
$parcel$export(module.exports, "useTranslation", function () { return $403c8f6ec3654478$export$9fc83ad70ead8663; });

var $aSiaI = parcelRequire("aSiaI");

var $5fNnZ = parcelRequire("5fNnZ");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $jVoNn = parcelRequire("jVoNn");

var $aPuMp = parcelRequire("aPuMp");

var $8Wmxp = parcelRequire("8Wmxp");

var $cwvCy = parcelRequire("cwvCy");

var $9WYKv = parcelRequire("9WYKv");


const $403c8f6ec3654478$var$translations = {
    en_GB: $403c8f6ec3654478$var$tDefault(()=>(parcelRequire("izUth"))),
    fr_FR: $403c8f6ec3654478$var$tDefault(()=>(parcelRequire("brfzP")))
};
const $403c8f6ec3654478$var$languageKey = 'language';
const $403c8f6ec3654478$var$TranslationContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
const $403c8f6ec3654478$export$6dd9d1cecb6d3d0 = ({ children: children })=>{
    const [lang, setLang] = (0, $9WYKv.useLocalStorageState)($403c8f6ec3654478$var$languageKey, [
        (0, $aPuMp.Lang).codec,
        'Lang'
    ], (0, $aPuMp.Lang).fromNavigatorLanguage(window.navigator.language));
    const { data: data, error: error } = (0, $jVoNn.default)([
        lang
    ], ([lang_])=>$403c8f6ec3654478$var$translations[lang_]());
    if (error !== undefined) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cwvCy.Pre), {
            className: "mt-4",
            children: "error."
        })
    });
    if (data === undefined) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
            className: "mt-4 h-6"
        })
    });
    const value = {
        lang: lang,
        setLang: setLang,
        t: data
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)($403c8f6ec3654478$var$TranslationContext.Provider, {
        value: value,
        children: children
    });
};
function $403c8f6ec3654478$export$9fc83ad70ead8663(key) {
    const context = (0, $exYeM.useContext)($403c8f6ec3654478$var$TranslationContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useTranslation must be used within a TranslationContextProvider');
    if (key === undefined) return context;
    const { t: t, ...context_ } = context;
    return {
        ...context_,
        t: t[key]
    };
}
function $403c8f6ec3654478$var$tDefault(fa) {
    return (0, $kj6DU.pipe)(fa, (0, $5fNnZ).map((t)=>t.default));
}

});
parcelRegister("jVoNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9105985a0e72b5c2$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");

var $ePGDo = parcelRequire("ePGDo");

var $6coed = parcelRequire("6coed");parcelRequire("7h4Dl");
var $6coed = parcelRequire("6coed");
var $7h4Dl = parcelRequire("7h4Dl");
var $9FMkK = parcelRequire("9FMkK");
// Shared state between server components and client components
const $9105985a0e72b5c2$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $9105985a0e72b5c2$var$UNDEFINED = /*#__NOINLINE__*/ $9105985a0e72b5c2$var$noop();
const $9105985a0e72b5c2$var$OBJECT = Object;
const $9105985a0e72b5c2$var$isUndefined = (v)=>v === $9105985a0e72b5c2$var$UNDEFINED;
const $9105985a0e72b5c2$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $9105985a0e72b5c2$var$table = new WeakMap();
const $9105985a0e72b5c2$var$isObjectType = (value, type)=>$9105985a0e72b5c2$var$OBJECT.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $9105985a0e72b5c2$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $9105985a0e72b5c2$var$stableHash = (arg)=>{
    const type = typeof arg;
    const isDate = $9105985a0e72b5c2$var$isObjectType(arg, 'Date');
    const isRegex = $9105985a0e72b5c2$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $9105985a0e72b5c2$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($9105985a0e72b5c2$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $9105985a0e72b5c2$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$9105985a0e72b5c2$var$counter + '~';
        $9105985a0e72b5c2$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $9105985a0e72b5c2$var$stableHash(arg[index]) + ',';
            $9105985a0e72b5c2$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $9105985a0e72b5c2$var$OBJECT.keys(arg).sort();
            while(!$9105985a0e72b5c2$var$isUndefined(index = keys.pop()))if (!$9105985a0e72b5c2$var$isUndefined(arg[index])) result += index + ':' + $9105985a0e72b5c2$var$stableHash(arg[index]) + ',';
            $9105985a0e72b5c2$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $9105985a0e72b5c2$var$serialize = (key)=>{
    if ($9105985a0e72b5c2$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $9105985a0e72b5c2$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $9105985a0e72b5c2$export$dbab534a48e651ef = (key)=>$9105985a0e72b5c2$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $9105985a0e72b5c2$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $9105985a0e72b5c2$var$WITH_DEDUPE = {
    dedupe: true
};
const $9105985a0e72b5c2$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $6coed.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $6coed.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $exYeM.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $exYeM.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $exYeM.useRef)(key);
    const fetcherRef = (0, $exYeM.useRef)(fetcher);
    const configRef = (0, $exYeM.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $6coed.z)(cache, key);
    const stateDependencies = (0, $exYeM.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $6coed.e)(fallbackData) ? (0, $6coed.e)(config.fallback) ? (0, $6coed.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $6coed.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $exYeM.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $6coed.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $6coed.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $ePGDo.useSyncExternalStore)((0, $exYeM.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $6coed.e)(cachedData) ? fallback && (0, $6coed.B)(fallback) ? $9105985a0e72b5c2$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $exYeM.useRef)(data);
    const returnedData = keepPreviousData ? (0, $6coed.e)(cachedData) ? (0, $6coed.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $6coed.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $6coed.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $6coed.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $6coed.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $6coed.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $6coed.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $exYeM.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $6coed.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $6coed.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $6coed.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $6coed.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $6coed.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $6coed.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $6coed.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $9FMkK).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $exYeM.useCallback)((...args)=>{
        return (0, $6coed.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $6coed.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $6coed.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $6coed.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $6coed.U), $9105985a0e72b5c2$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $9FMkK).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $9FMkK).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $9FMkK).MUTATE_EVENT) return revalidate();
            else if (type == (0, $9FMkK).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $7h4Dl.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $6coed.e)(data) || (0, $6coed.r)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $6coed.t)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $6coed.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $6coed.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($9105985a0e72b5c2$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $exYeM.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $6coed.e)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $6coed.I) && (0, $6coed.r)) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $6coed.e)(req)) {
            const promise = boundMutate(req);
            $9105985a0e72b5c2$var$use(promise);
        }
        if ((0, $6coed.e)(error)) {
            const promise = revalidate($9105985a0e72b5c2$var$WITH_DEDUPE);
            if (!(0, $6coed.e)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $9105985a0e72b5c2$var$use(promise);
        } else throw error;
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $9105985a0e72b5c2$export$4c7bbecdacc3ca2c = (0, $6coed.O).defineProperty((0, $6coed.g), 'defaultValue', {
    value: (0, $6coed.d)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $9105985a0e72b5c2$export$2e2bcd8739ae039 = (0, $7h4Dl.withArgs)($9105985a0e72b5c2$var$useSWRHandler);

});
parcelRegister("ePGDo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1nNjm"));

});
parcelRegister("1nNjm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $101e30a3eef9e9c6$export$306c0aa65ff9ec16; }, function (v) { return $101e30a3eef9e9c6$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $101e30a3eef9e9c6$export$306c0aa65ff9ec16;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $101e30a3eef9e9c6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $101e30a3eef9e9c6$var$objectIs = "function" === typeof Object.is ? Object.is : $101e30a3eef9e9c6$var$is, $101e30a3eef9e9c6$var$useState = $exYeM.useState, $101e30a3eef9e9c6$var$useEffect = $exYeM.useEffect, $101e30a3eef9e9c6$var$useLayoutEffect = $exYeM.useLayoutEffect, $101e30a3eef9e9c6$var$useDebugValue = $exYeM.useDebugValue;
function $101e30a3eef9e9c6$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $101e30a3eef9e9c6$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $101e30a3eef9e9c6$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $101e30a3eef9e9c6$var$useEffect(function() {
        $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $101e30a3eef9e9c6$var$useDebugValue(value);
    return value;
}
function $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$101e30a3eef9e9c6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $101e30a3eef9e9c6$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $101e30a3eef9e9c6$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $101e30a3eef9e9c6$var$useSyncExternalStore$1 : $101e30a3eef9e9c6$var$useSyncExternalStore$2;
$101e30a3eef9e9c6$export$306c0aa65ff9ec16 = void 0 !== $exYeM.useSyncExternalStore ? $exYeM.useSyncExternalStore : $101e30a3eef9e9c6$var$shim;

});


parcelRegister("6coed", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $dea9675a90211875$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "U", function () { return $dea9675a90211875$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "O", function () { return $dea9675a90211875$export$c4ce752e73470fba; });
$parcel$export(module.exports, "e", function () { return $dea9675a90211875$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $dea9675a90211875$export$407448d2b89b1813; });
$parcel$export(module.exports, "m", function () { return $dea9675a90211875$export$953cecd6e717a553; });
$parcel$export(module.exports, "B", function () { return $dea9675a90211875$export$ef35774e6d314e91; });
$parcel$export(module.exports, "i", function () { return $dea9675a90211875$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "z", function () { return $dea9675a90211875$export$df995fae86a55f06; });
$parcel$export(module.exports, "I", function () { return $dea9675a90211875$export$9bb611d729802a56; });
$parcel$export(module.exports, "r", function () { return $dea9675a90211875$export$43caf9889c228507; });
$parcel$export(module.exports, "t", function () { return $dea9675a90211875$export$625550452a3fa3ec; });
$parcel$export(module.exports, "u", function () { return $dea9675a90211875$export$3b14a55fb2447963; });
$parcel$export(module.exports, "s", function () { return $dea9675a90211875$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "o", function () { return $dea9675a90211875$export$ae1af26003f05816; });
$parcel$export(module.exports, "n", function () { return $dea9675a90211875$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "c", function () { return $dea9675a90211875$export$db3b6bfb95261072; });
$parcel$export(module.exports, "d", function () { return $dea9675a90211875$export$4368d992c4eafac0; });
$parcel$export(module.exports, "f", function () { return $dea9675a90211875$export$2d1720544b23b823; });
$parcel$export(module.exports, "S", function () { return $dea9675a90211875$export$25ce5a424b770e84; });
$parcel$export(module.exports, "g", function () { return $dea9675a90211875$export$39b482c5e57630a8; });

var $exYeM = parcelRequire("exYeM");

var $9FMkK = parcelRequire("9FMkK");

var $79Fe9 = parcelRequire("79Fe9");
'use client';
// Global state used to deduplicate requests and store listeners
const $dea9675a90211875$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $dea9675a90211875$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $dea9675a90211875$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $dea9675a90211875$export$ebd11618f299a286();
const $dea9675a90211875$export$c4ce752e73470fba = Object;
const $dea9675a90211875$export$f1e1789686576879 = (v)=>v === $dea9675a90211875$export$3a6d5c9ae78a2c08;
const $dea9675a90211875$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $dea9675a90211875$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $dea9675a90211875$export$ef35774e6d314e91 = (x)=>$dea9675a90211875$export$407448d2b89b1813(x.then);
const $dea9675a90211875$var$EMPTY_CACHE = {};
const $dea9675a90211875$var$INITIAL_CACHE = {};
const $dea9675a90211875$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $dea9675a90211875$export$23f2a1d2818174ef = typeof window != $dea9675a90211875$var$STR_UNDEFINED;
const $dea9675a90211875$export$efccba1c4a2ef57b = typeof document != $dea9675a90211875$var$STR_UNDEFINED;
const $dea9675a90211875$export$d141bba7fdc215a3 = $dea9675a90211875$export$23f2a1d2818174ef && 'Deno' in window;
const $dea9675a90211875$export$4a5767248b18ef41 = ()=>$dea9675a90211875$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $dea9675a90211875$var$STR_UNDEFINED;
const $dea9675a90211875$export$df995fae86a55f06 = (cache, key)=>{
    const state = $dea9675a90211875$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$dea9675a90211875$export$f1e1789686576879(key) && cache.get(key) || $dea9675a90211875$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$dea9675a90211875$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $dea9675a90211875$var$INITIAL_CACHE)) $dea9675a90211875$var$INITIAL_CACHE[key] = prev;
                state[5](key, $dea9675a90211875$export$953cecd6e717a553(prev, info), prev || $dea9675a90211875$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$dea9675a90211875$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $dea9675a90211875$var$INITIAL_CACHE) return $dea9675a90211875$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$dea9675a90211875$export$f1e1789686576879(key) && cache.get(key) || $dea9675a90211875$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $dea9675a90211875$var$online = true;
const $dea9675a90211875$var$isOnline = ()=>$dea9675a90211875$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$dea9675a90211875$var$onWindowEvent, $dea9675a90211875$var$offWindowEvent] = $dea9675a90211875$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $dea9675a90211875$export$ebd11618f299a286,
    $dea9675a90211875$export$ebd11618f299a286
];
const $dea9675a90211875$var$isVisible = ()=>{
    const visibilityState = $dea9675a90211875$export$efccba1c4a2ef57b && document.visibilityState;
    return $dea9675a90211875$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $dea9675a90211875$var$initFocus = (callback)=>{
    // focus revalidate
    if ($dea9675a90211875$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $dea9675a90211875$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($dea9675a90211875$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $dea9675a90211875$var$offWindowEvent('focus', callback);
    };
};
const $dea9675a90211875$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $dea9675a90211875$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $dea9675a90211875$var$online = false;
    };
    $dea9675a90211875$var$onWindowEvent('online', onOnline);
    $dea9675a90211875$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $dea9675a90211875$var$offWindowEvent('online', onOnline);
        $dea9675a90211875$var$offWindowEvent('offline', onOffline);
    };
};
const $dea9675a90211875$export$ffb5f4729a158638 = {
    isOnline: $dea9675a90211875$var$isOnline,
    isVisible: $dea9675a90211875$var$isVisible
};
const $dea9675a90211875$export$9e5f44173e64f162 = {
    initFocus: $dea9675a90211875$var$initFocus,
    initReconnect: $dea9675a90211875$var$initReconnect
};
const $dea9675a90211875$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useId;
const $dea9675a90211875$export$43caf9889c228507 = !$dea9675a90211875$export$23f2a1d2818174ef || $dea9675a90211875$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $dea9675a90211875$export$625550452a3fa3ec = (f)=>$dea9675a90211875$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $dea9675a90211875$export$3b14a55fb2447963 = $dea9675a90211875$export$43caf9889c228507 ? (0, $exYeM.useEffect) : (0, $exYeM.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $dea9675a90211875$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $dea9675a90211875$export$90a7f3efeed30595 = !$dea9675a90211875$export$43caf9889c228507 && $dea9675a90211875$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($dea9675a90211875$var$navigatorConnection.effectiveType) || $dea9675a90211875$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $dea9675a90211875$var$table = new WeakMap();
const $dea9675a90211875$var$isObjectType = (value, type)=>$dea9675a90211875$export$c4ce752e73470fba.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $dea9675a90211875$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $dea9675a90211875$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const isDate = $dea9675a90211875$var$isObjectType(arg, 'Date');
    const isRegex = $dea9675a90211875$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $dea9675a90211875$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($dea9675a90211875$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $dea9675a90211875$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$dea9675a90211875$var$counter + '~';
        $dea9675a90211875$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $dea9675a90211875$export$882b5998b3b9117c(arg[index]) + ',';
            $dea9675a90211875$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $dea9675a90211875$export$c4ce752e73470fba.keys(arg).sort();
            while(!$dea9675a90211875$export$f1e1789686576879(index = keys.pop()))if (!$dea9675a90211875$export$f1e1789686576879(arg[index])) result += index + ':' + $dea9675a90211875$export$882b5998b3b9117c(arg[index]) + ',';
            $dea9675a90211875$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $dea9675a90211875$export$2408f22a0fab9ae5 = (key)=>{
    if ($dea9675a90211875$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $dea9675a90211875$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $dea9675a90211875$var$__timestamp = 0;
const $dea9675a90211875$export$ae1af26003f05816 = ()=>++$dea9675a90211875$var$__timestamp;
async function $dea9675a90211875$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $dea9675a90211875$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($dea9675a90211875$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $dea9675a90211875$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $dea9675a90211875$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $dea9675a90211875$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $dea9675a90211875$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($9FMkK.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $dea9675a90211875$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$dea9675a90211875$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $dea9675a90211875$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $dea9675a90211875$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($dea9675a90211875$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $dea9675a90211875$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $dea9675a90211875$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($dea9675a90211875$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $dea9675a90211875$export$3a6d5c9ae78a2c08,
                        _c: $dea9675a90211875$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $dea9675a90211875$export$3a6d5c9ae78a2c08,
                    _c: $dea9675a90211875$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $dea9675a90211875$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $dea9675a90211875$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $dea9675a90211875$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $dea9675a90211875$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$dea9675a90211875$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $dea9675a90211875$export$953cecd6e717a553($dea9675a90211875$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $dea9675a90211875$export$7ccc53e8f1e7dfc5.bind($dea9675a90211875$export$3a6d5c9ae78a2c08, provider);
        let unmount = $dea9675a90211875$export$ebd11618f299a286;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$dea9675a90211875$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $dea9675a90211875$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$dea9675a90211875$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($dea9675a90211875$export$3a6d5c9ae78a2c08, $dea9675a90211875$var$revalidateAllKeys.bind($dea9675a90211875$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $9FMkK.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($dea9675a90211875$export$3a6d5c9ae78a2c08, $dea9675a90211875$var$revalidateAllKeys.bind($dea9675a90211875$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $9FMkK.RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $dea9675a90211875$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $dea9675a90211875$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $dea9675a90211875$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$dea9675a90211875$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $dea9675a90211875$export$342063e11d6c3cad = (0, $79Fe9.dequal);
// Default cache provider
const [$dea9675a90211875$export$db3b6bfb95261072, $dea9675a90211875$export$35e795649ee09318] = $dea9675a90211875$export$dda1d9f60106f0e9(new Map());
// Default config
const $dea9675a90211875$export$4368d992c4eafac0 = $dea9675a90211875$export$953cecd6e717a553({
    // events
    onLoadingSlow: $dea9675a90211875$export$ebd11618f299a286,
    onSuccess: $dea9675a90211875$export$ebd11618f299a286,
    onError: $dea9675a90211875$export$ebd11618f299a286,
    onErrorRetry: $dea9675a90211875$var$onErrorRetry,
    onDiscarded: $dea9675a90211875$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $dea9675a90211875$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $dea9675a90211875$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $dea9675a90211875$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $dea9675a90211875$export$db3b6bfb95261072,
    mutate: $dea9675a90211875$export$35e795649ee09318,
    fallback: {}
}, $dea9675a90211875$export$ffb5f4729a158638);
const $dea9675a90211875$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $dea9675a90211875$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $dea9675a90211875$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $dea9675a90211875$export$25ce5a424b770e84 = (0, $exYeM.createContext)({});
const $dea9675a90211875$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $exYeM.useContext)($dea9675a90211875$export$25ce5a424b770e84);
    const isFunctionalConfig = $dea9675a90211875$export$407448d2b89b1813(value);
    const config = (0, $exYeM.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $exYeM.useMemo)(()=>isFunctionalConfig ? config : $dea9675a90211875$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $exYeM.useRef)($dea9675a90211875$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $dea9675a90211875$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $dea9675a90211875$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $dea9675a90211875$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $exYeM.createElement)($dea9675a90211875$export$25ce5a424b770e84.Provider, $dea9675a90211875$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};

});
parcelRegister("9FMkK", function(module, exports) {

$parcel$export(module.exports, "FOCUS_EVENT", function () { return $6dcb095fdaa8cac7$export$831c820ad60f9d12; });
$parcel$export(module.exports, "RECONNECT_EVENT", function () { return $6dcb095fdaa8cac7$export$24e9454cb99a11dc; });
$parcel$export(module.exports, "MUTATE_EVENT", function () { return $6dcb095fdaa8cac7$export$75ea288459391154; });
$parcel$export(module.exports, "ERROR_REVALIDATE_EVENT", function () { return $6dcb095fdaa8cac7$export$b019c3839228f243; });
const $6dcb095fdaa8cac7$export$831c820ad60f9d12 = 0;
const $6dcb095fdaa8cac7$export$24e9454cb99a11dc = 1;
const $6dcb095fdaa8cac7$export$75ea288459391154 = 2;
const $6dcb095fdaa8cac7$export$b019c3839228f243 = 3;

});

parcelRegister("79Fe9", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $df07ca25a8d524dd$export$de8294bb3be0322f; });
var $df07ca25a8d524dd$var$has = Object.prototype.hasOwnProperty;
function $df07ca25a8d524dd$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $df07ca25a8d524dd$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($df07ca25a8d524dd$var$has.call(foo, ctor) && ++len && !$df07ca25a8d524dd$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$df07ca25a8d524dd$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});


parcelRegister("7h4Dl", function(module, exports) {

$parcel$export(module.exports, "useSWRConfig", function () { return $3b10437cf9c130d5$export$f1dc0e282d4c1c0; });
$parcel$export(module.exports, "withArgs", function () { return $3b10437cf9c130d5$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $3b10437cf9c130d5$export$e005210ed621746; });
$parcel$export(module.exports, "SWRGlobalState", function () { return (parcelRequire("6coed")).b; });
$parcel$export(module.exports, "defaultConfig", function () { return (parcelRequire("6coed")).d; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("6coed")).a; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("6coed")).e; });
$parcel$export(module.exports, "mergeObjects", function () { return (parcelRequire("6coed")).m; });
$parcel$export(module.exports, "serialize", function () { return (parcelRequire("6coed")).s; });

var $6coed = parcelRequire("6coed");

var $9FMkK = parcelRequire("9FMkK");

var $2IW6t = parcelRequire("2IW6t");

var $exYeM = parcelRequire("exYeM");

// @ts-expect-error
const $3b10437cf9c130d5$var$enableDevtools = (0, $6coed.i) && window.__SWR_DEVTOOLS_USE__;
const $3b10437cf9c130d5$var$use = $3b10437cf9c130d5$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $3b10437cf9c130d5$var$setupDevTools = ()=>{
    if ($3b10437cf9c130d5$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
};
const $3b10437cf9c130d5$export$a3295358bff77e = (args)=>{
    return (0, $6coed.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $3b10437cf9c130d5$export$f1dc0e282d4c1c0 = ()=>{
    return (0, $6coed.m)((0, $6coed.d), (0, $exYeM.useContext)((0, $6coed.S)));
};
const $3b10437cf9c130d5$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $6coed.s)(key_);
    const [, , , PRELOAD] = (0, $6coed.b).get((0, $6coed.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $3b10437cf9c130d5$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $6coed.s)(key_);
            const [, , , PRELOAD] = (0, $6coed.b).get((0, $6coed.c));
            if (key.startsWith((0, $2IW6t.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $6coed.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $3b10437cf9c130d5$var$BUILT_IN_MIDDLEWARE = $3b10437cf9c130d5$var$use.concat($3b10437cf9c130d5$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $3b10437cf9c130d5$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $3b10437cf9c130d5$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $3b10437cf9c130d5$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $6coed.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($3b10437cf9c130d5$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $3b10437cf9c130d5$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $3b10437cf9c130d5$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $3b10437cf9c130d5$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$3b10437cf9c130d5$var$setupDevTools();

});
parcelRegister("2IW6t", function(module, exports) {

$parcel$export(module.exports, "INFINITE_PREFIX", function () { return $3687c8f1a722fa4b$export$8667f065faedc62c; });
const $3687c8f1a722fa4b$export$8667f065faedc62c = '$inf$';

});



parcelRegister("8Wmxp", function(module, exports) {

$parcel$export(module.exports, "Loading", function () { return $554a1af870a678ac$export$669f6ea7d267feaf; });

var $aSiaI = parcelRequire("aSiaI");

var $5MBh5 = parcelRequire("5MBh5");
const $554a1af870a678ac$export$669f6ea7d267feaf = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        className: (0, $5MBh5.cx)('animate-spin', className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "4",
                opacity: 0.25
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                fill: "currentColor",
                opacity: 0.75
            })
        ]
    });

});
parcelRegister("5MBh5", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $8ac6184f8864118d$export$a274e22fb40f762e; });

var $9ddGv = parcelRequire("9ddGv");
function $8ac6184f8864118d$export$a274e22fb40f762e(...c) {
    const classes = c.flatMap((arg)=>{
        if (arg === undefined) return [];
        if (typeof arg === 'string') return [
            arg
        ];
        if ($8ac6184f8864118d$var$isArray(arg)) {
            const [className, display] = arg;
            if (className === undefined || !display) return [];
            return [
                className
            ];
        }
        return (0, $9ddGv.Dict).toReadonlyArray(arg).flatMap(([className, display])=>display ? [
                className
            ] : []);
    });
    if ((0, $9ddGv.List).isEmpty(classes)) return undefined;
    return classes.join(' ');
}
const $8ac6184f8864118d$var$isArray = Array.isArray;

});


parcelRegister("cwvCy", function(module, exports) {

$parcel$export(module.exports, "Pre", function () { return $1452b8d7a7dd4b3f$export$bba54bd7e8a0d398; });

var $aSiaI = parcelRequire("aSiaI");

var $5MBh5 = parcelRequire("5MBh5");
const $1452b8d7a7dd4b3f$export$bba54bd7e8a0d398 = ({ className: className, children: children, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        className: (0, $5MBh5.cx)('font-lib-mono', className),
        ...props,
        children: children
    });

});

parcelRegister("9WYKv", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageState", function () { return $accb6b7b578fae41$export$b313845ce8fd18ca; });

var $04bl4 = parcelRequire("04bl4");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const $accb6b7b578fae41$export$b313845ce8fd18ca = (key, [codec, codecName], initialState)=>{
    const [a, setA] = (0, $exYeM.useState)(()=>{
        const item = localStorage.getItem(key);
        if (item === null) return $accb6b7b578fae41$var$init(initialState);
        return (0, $kj6DU.pipe)((0, $04bl4).parse(item), (0, $9ddGv.Either).mapLeft((0, $9ddGv.Either).toError), (0, $9ddGv.Either).chain((u)=>(0, $kj6DU.pipe)(codec.decode(u), (0, $9ddGv.Either).mapLeft((0, $xJ0AO.decodeError)(codecName)(u)))), (0, $9ddGv.Either).getOrElse((e)=>{
            console.warn('useLocalStorageState: error while reading from localStorage', e);
            return $accb6b7b578fae41$var$init(initialState);
        }));
    });
    (0, $exYeM.useEffect)(()=>(0, $kj6DU.pipe)(codec.encode(a), (0, $04bl4).stringify, (0, $9ddGv.Either).mapLeft((0, $9ddGv.Either).toError), (0, $9ddGv.Either).fold((e)=>console.warn('useLocalStorageState: error while writing to localStorage', e), (str)=>localStorage.setItem(key, str))), [
        a,
        codec,
        key
    ]);
    return [
        a,
        setA
    ];
};
const $accb6b7b578fae41$var$init = (a)=>$accb6b7b578fae41$var$isFunction(a) ? a() : a;
const $accb6b7b578fae41$var$isFunction = (a)=>typeof a === 'function';

});

parcelRegister("izUth", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("7dwKU")).then(()=>parcelRequire('avjCz'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("brfzP", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("3Z31E")).then(()=>parcelRequire('b3vTk'));

});



parcelRegister("cmF7r", function(module, exports) {

$parcel$export(module.exports, "useSWRHttp", function () { return $355301b9bb0709bc$export$4d6a303bc40d3272; });

var $jVoNn = parcelRequire("jVoNn");

var $abFKR = parcelRequire("abFKR");

var $lQ3eP = parcelRequire("lQ3eP");

var $fviO3 = parcelRequire("fviO3");
const $355301b9bb0709bc$export$4d6a303bc40d3272 = (urlWithMethod, httpOptions, decoderWithName, swrOptions)=>(0, $jVoNn.default)(urlWithMethod, (urlWithMethod_)=>(0, $lQ3eP.futureRunUnsafe)((0, $fviO3.http)(urlWithMethod_, {
            ...httpOptions
        }, decoderWithName)), {
        ...swrOptions,
        revalidateIfStale: swrOptions?.revalidateIfStale ?? !(0, $abFKR.config).isDev,
        revalidateOnFocus: swrOptions?.revalidateOnFocus ?? !(0, $abFKR.config).isDev,
        revalidateOnReconnect: swrOptions?.revalidateOnReconnect ?? !(0, $abFKR.config).isDev
    });

});
parcelRegister("abFKR", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $a705015bfe84b86e$export$e506a1d27d1eaa20; });

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");

var $24LbD = parcelRequire("24LbD");
// It's important to have process.env.ENV_VAR fully, as it is inlined by Parcel
const $a705015bfe84b86e$var$inlined = {
    IS_DEV: "false",
    API_HOST: "https://laquete.blbl.ch",
    DISCORD_CLIENT_ID: "703679541117190155",
    DISCORD_CLIENT_REDIRECT_URI: "https://laquete.blbl.ch/discordRedirect",
    PORO_BASE_URL: "https://porofessor.gg"
};
const $a705015bfe84b86e$export$e506a1d27d1eaa20 = (0, $kj6DU.pipe)($a705015bfe84b86e$var$inlined, (0, $24LbD.Config).parse, (0, $9ddGv.Try).getUnsafe);

});
parcelRegister("24LbD", function(module, exports) {

$parcel$export(module.exports, "Config", function () { return $8842d192e8d10952$export$29cd7b75162a9425; });

var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $iZXyo = parcelRequire("iZXyo");

var $2VOFK = parcelRequire("2VOFK");

var $iszqO = parcelRequire("iszqO");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const $8842d192e8d10952$var$seqS = (0, $iZXyo.ValidatedNea).getSeqS();
const $8842d192e8d10952$var$parse = (rawConfig)=>(0, $iszqO.parseConfig)(rawConfig)((r)=>$8842d192e8d10952$var$seqS({
            isDev: (0, $kj6DU.pipe)(r((0, $9ddGv.Maybe).decoder((0, $xJ0AO.BooleanFromString).decoder))('IS_DEV'), (0, $9ddGv.Either).map((0, $9ddGv.Maybe).getOrElseW(()=>false))),
            apiHost: r((0, $xJ0AO.URLFromString).decoder)('API_HOST'),
            discordClient: $8842d192e8d10952$var$seqS({
                id: r((0, $2VOFK.DiscordUserId).codec)('DISCORD_CLIENT_ID'),
                redirectUri: r($5zWxO.string)('DISCORD_CLIENT_REDIRECT_URI')
            }),
            poroApiBaseUrl: r($5zWxO.string)('PORO_BASE_URL')
        }));
const $8842d192e8d10952$export$29cd7b75162a9425 = {
    parse: $8842d192e8d10952$var$parse
};

});
parcelRegister("iZXyo", function(module, exports) {

$parcel$export(module.exports, "ValidatedNea", function () { return $e67398eb4c216532$export$f6fe293a33f3a9aa; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
const $e67398eb4c216532$var$valid = (0, $9ddGv.Either).right;
const $e67398eb4c216532$var$invalid = (0, $9ddGv.Either).left;
const $e67398eb4c216532$var$fromEither = (0, $9ddGv.Either).mapLeft((0, $9ddGv.NonEmptyArray).of);
const $e67398eb4c216532$var$fromOption = (onNone)=>(0, $kj6DU.flow)((0, $9ddGv.Either).fromOption(onNone), $e67398eb4c216532$var$fromEither);
const $e67398eb4c216532$var$fromEmptyE = (e)=>(0, $9ddGv.Either).mapLeft((0, $kj6DU.flow)((0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).getOrElse(()=>(0, $9ddGv.NonEmptyArray).of(e))));
const $e67398eb4c216532$var$fromEmptyErrors = $e67398eb4c216532$var$fromEmptyE('Got empty Errors from codec');
const $e67398eb4c216532$var$chainOptionK = (onNone)=>(f)=>(0, $9ddGv.Either).chain((0, $kj6DU.flow)(f, $e67398eb4c216532$var$fromOption(onNone)));
const $e67398eb4c216532$var$chainEitherK = (f)=>(0, $9ddGv.Either).chain((0, $kj6DU.flow)(f, $e67398eb4c216532$var$fromEither));
const $e67398eb4c216532$var$bimap = (f, g)=>(0, $9ddGv.Either).bimap((0, $9ddGv.NonEmptyArray).map(f), g);
const $e67398eb4c216532$var$getValidation = ()=>(0, $9ddGv.Either).getApplicativeValidation((0, $9ddGv.NonEmptyArray).getSemigroup());
const $e67398eb4c216532$var$getSeqS = ()=>(0, $j7Bi0).sequenceS($e67398eb4c216532$var$getValidation());
const { left: {}, right: {}, ...$e67398eb4c216532$var$validatedNea } = (0, $9ddGv.Either);
const $e67398eb4c216532$export$f6fe293a33f3a9aa = {
    ...$e67398eb4c216532$var$validatedNea,
    valid: $e67398eb4c216532$var$valid,
    invalid: $e67398eb4c216532$var$invalid,
    fromEither: $e67398eb4c216532$var$fromEither,
    fromOption: $e67398eb4c216532$var$fromOption,
    fromNullable: (0, $9ddGv.Either).fromNullable,
    fromEmptyE: $e67398eb4c216532$var$fromEmptyE,
    fromEmptyErrors: $e67398eb4c216532$var$fromEmptyErrors,
    fold: (0, $9ddGv.Either).fold,
    map: (0, $9ddGv.Either).map,
    chain: (0, $9ddGv.Either).chain,
    chainOptionK: $e67398eb4c216532$var$chainOptionK,
    chainNullableK: (0, $9ddGv.Either).chainNullableK,
    chainEitherK: $e67398eb4c216532$var$chainEitherK,
    bimap: $e67398eb4c216532$var$bimap,
    bind: (0, $9ddGv.Either).bind,
    getValidation: $e67398eb4c216532$var$getValidation,
    getSeqS: $e67398eb4c216532$var$getSeqS
};

});

parcelRegister("2VOFK", function(module, exports) {

$parcel$export(module.exports, "DiscordUserId", function () { return $5aaec630520e2682$export$a5b9a9eb90856ab; });

var $hOuM2 = parcelRequire("hOuM2");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $5aaec630520e2682$var$wrap, unwrap: $5aaec630520e2682$var$unwrap } = (0, $hp7yq.iso)();
const $5aaec630520e2682$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $5aaec630520e2682$var$Ord = (0, $kj6DU.pipe)((0, $gSyeU).Ord, (0, $hOuM2).contramap($5aaec630520e2682$var$unwrap));
const $5aaec630520e2682$var$Eq = $5aaec630520e2682$var$Ord;
const $5aaec630520e2682$export$a5b9a9eb90856ab = (0, $9ddGv.immutableAssign)($5aaec630520e2682$var$wrap, {
    codec: $5aaec630520e2682$var$codec,
    unwrap: $5aaec630520e2682$var$unwrap,
    Ord: $5aaec630520e2682$var$Ord,
    Eq: $5aaec630520e2682$var$Eq
});

});

parcelRegister("iszqO", function(module, exports) {

$parcel$export(module.exports, "parseConfig", function () { return $212eeaa742991278$export$ddb7710e72db552d; });

var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $9ddGv = parcelRequire("9ddGv");
const $212eeaa742991278$export$ddb7710e72db552d = (rawConfig)=>(f)=>(0, $kj6DU.pipe)(f((decoder)=>(key)=>(0, $kj6DU.pipe)(decoder.decode(rawConfig[key]), (0, $9ddGv.Either).mapLeft((e)=>(0, $9ddGv.NonEmptyArray).of(`${key}: ${$5zWxO.draw(e)}`)))), (0, $9ddGv.Either).mapLeft((0, $kj6DU.flow)((0, $9ddGv.List).mkString('Errors while reading config:\n', '\n', ''), Error)));

});



parcelRegister("lQ3eP", function(module, exports) {

$parcel$export(module.exports, "futureRunUnsafe", function () { return $e340187ba07af6a8$export$a7654a1d6fb561a8; });

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
const $e340187ba07af6a8$export$a7654a1d6fb561a8 = (0, $kj6DU.flow)((0, $9ddGv.Future).orElse((e)=>{
    console.error(e);
    return (0, $9ddGv.Future).failed(e);
}), (0, $9ddGv.Future).runUnsafe);

});

parcelRegister("fviO3", function(module, exports) {

$parcel$export(module.exports, "http", function () { return $61468d9a64643e44$export$7d6f1c8842f9f527; });
$parcel$export(module.exports, "statusesToOption", function () { return $61468d9a64643e44$export$a9d48c43ab87d831; });

var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7HmBx = parcelRequire("7HmBx");
var $1VnRj = parcelRequire("1VnRj");

var $hPJN4 = parcelRequire("hPJN4");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $abFKR = parcelRequire("abFKR");
function $61468d9a64643e44$export$7d6f1c8842f9f527([url, method], { credentials: credentials, timeout: timeout, ...options } = {}, decoderWithName) {
    const json = (()=>{
        if (options.json === undefined) return undefined;
        const [encoder, b] = options.json;
        return encoder.encode(b);
    })();
    return (0, $kj6DU.pipe)((0, $9ddGv.Future).tryCatch(()=>(0, $7HmBx.default)(new URL(url, (0, $abFKR.config).apiHost), {
            ...options,
            method: method,
            json: json,
            credentials: credentials ?? 'include',
            ...timeout === undefined ? {} : {
                timeout: (0, $hPJN4.MsDuration).unwrap(timeout)
            }
        }).json()), (0, $9ddGv.Future).chainEitherK((u)=>{
        if (decoderWithName === undefined) return (0, $9ddGv.Either).right(u);
        const [decoder, decoderName] = decoderWithName;
        return (0, $kj6DU.pipe)(decoder.decode(u), (0, $9ddGv.Either).mapLeft((0, $xJ0AO.decodeError)(decoderName)(u)));
    }));
}
const $61468d9a64643e44$export$a9d48c43ab87d831 = (...statuses)=>(0, $kj6DU.flow)((0, $9ddGv.Future).map((0, $9ddGv.Maybe).some), (0, $9ddGv.Future).orElseEitherK((e)=>e instanceof (0, $1VnRj.HTTPError) && (0, $kj6DU.pipe)(statuses, (0, $9ddGv.List).elem((0, $cF6yJ).Eq)(e.response.status)) ? (0, $9ddGv.Try).success((0, $9ddGv.Maybe).none) : (0, $9ddGv.Try).failure(e)));

});
parcelRegister("7HmBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59ae15552c3335ec$export$2e2bcd8739ae039; });
/*! MIT License © Sindre Sorhus */ 
var $aHYe2 = parcelRequire("aHYe2");

var $cRgPT = parcelRequire("cRgPT");

var $2dLH8 = parcelRequire("2dLH8");

var $1VnRj = parcelRequire("1VnRj");

const $59ae15552c3335ec$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $aHYe2.Ky).create(input, (0, $2dLH8.validateAndMerge)(defaults, options));
    for (const method of (0, $cRgPT.requestMethods))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $aHYe2.Ky).create(input, (0, $2dLH8.validateAndMerge)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$59ae15552c3335ec$var$createInstance((0, $2dLH8.validateAndMerge)(newDefaults));
    ky.extend = (newDefaults)=>{
        if (typeof newDefaults === 'function') newDefaults = newDefaults(defaults ?? {});
        return $59ae15552c3335ec$var$createInstance((0, $2dLH8.validateAndMerge)(defaults, newDefaults));
    };
    ky.stop = (0, $cRgPT.stop);
    return ky;
};
const $59ae15552c3335ec$var$ky = $59ae15552c3335ec$var$createInstance();
var $59ae15552c3335ec$export$2e2bcd8739ae039 = $59ae15552c3335ec$var$ky;

});
parcelRegister("aHYe2", function(module, exports) {

$parcel$export(module.exports, "Ky", function () { return $7cbca30f25e84ae2$export$c482d6f00e170af3; });

var $1VnRj = parcelRequire("1VnRj");

var $eWumj = parcelRequire("eWumj");

var $2dLH8 = parcelRequire("2dLH8");

var $hPAzg = parcelRequire("hPAzg");

var $gZ9DJ = parcelRequire("gZ9DJ");

var $lAk3x = parcelRequire("lAk3x");

var $chMJ5 = parcelRequire("chMJ5");

var $cRgPT = parcelRequire("cRgPT");
class $7cbca30f25e84ae2$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $7cbca30f25e84ae2$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky._options.timeout === 'number' && ky._options.timeout > (0, $cRgPT.maxSafeTimeout)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $cRgPT.maxSafeTimeout)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new (0, $1VnRj.HTTPError)(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error);
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!(0, $cRgPT.supportsResponseStreams)) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return ky._stream(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = isRetriableMethod ? ky._retry(function_) : function_();
        for (const [type, mimeType] of Object.entries((0, $cRgPT.responseTypes)))result[type] = async ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
            const response = await result;
            if (type === 'json') {
                if (response.status === 204) return '';
                const arrayBuffer = await response.clone().arrayBuffer();
                const responseSize = arrayBuffer.byteLength;
                if (responseSize === 0) return '';
                if (options.parseJson) return options.parseJson(await response.text());
            }
            return response[type]();
        };
        return result;
    }
    request;
    abortController;
    _retryCount = 0;
    _input;
    _options;
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        this._input = input;
        this._options = {
            ...options,
            headers: (0, $2dLH8.mergeHeaders)(this._input.headers, options.headers),
            hooks: (0, $2dLH8.mergeHooks)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $hPAzg.normalizeRequestMethod)(options.method ?? this._input.method ?? 'GET'),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ''),
            retry: (0, $hPAzg.normalizeRetryOptions)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis)
        };
        if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this._options.prefixUrl && typeof this._input === 'string') {
            if (this._input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this._options.prefixUrl.endsWith('/')) this._options.prefixUrl += '/';
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $cRgPT.supportsAbortController) {
            this.abortController = new globalThis.AbortController();
            const originalSignal = this._options.signal ?? this._input.signal;
            if (originalSignal?.aborted) this.abortController.abort(originalSignal?.reason);
            originalSignal?.addEventListener('abort', ()=>{
                this.abortController.abort(originalSignal.reason);
            });
            this._options.signal = this.abortController.signal;
        }
        if (0, $cRgPT.supportsRequestStreams) // @ts-expect-error - Types are outdated.
        this._options.duplex = 'half';
        if (this._options.json !== undefined) {
            this._options.body = this._options.stringifyJson?.(this._options.json) ?? JSON.stringify(this._options.json);
            this._options.headers.set('content-type', this._options.headers.get('content-type') ?? 'application/json');
        }
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === 'string' ? this._options.searchParams.replace(/^\?/, '') : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = '?' + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $cRgPT.supportsFormData) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers['content-type'])) this.request.headers.delete('content-type');
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, {
                ...this.request
            }), this._options);
        }
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount > this._options.retry.limit || error instanceof (0, $eWumj.TimeoutError)) throw error;
        if (error instanceof (0, $1VnRj.HTTPError)) {
            if (!this._options.retry.statusCodes.includes(error.response.status)) throw error;
            const retryAfter = error.response.headers.get('Retry-After') ?? error.response.headers.get('RateLimit-Reset') ?? error.response.headers.get('X-RateLimit-Reset') // GitHub
             ?? error.response.headers.get('X-Rate-Limit-Reset'); // Twitter
            if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                let after = Number(retryAfter) * 1000;
                if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                else if (after >= Date.parse('2024-01-01')) // A large number is treated as a timestamp (fixed threshold protects against clock skew)
                after -= Date.now();
                const max = this._options.retry.maxRetryAfter ?? after;
                return after < max ? after : max;
            }
            if (error.response.status === 413) throw error;
        }
        const retryDelay = this._options.retry.delay(this._retryCount);
        return Math.min(this._options.retry.backoffLimit, retryDelay);
    }
    _decorateResponse(response) {
        if (this._options.parseJson) response.json = async ()=>this._options.parseJson(await response.text());
        return response;
    }
    async _retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), (0, $cRgPT.maxSafeTimeout));
            if (this._retryCount < 1) throw error;
            await (0, $lAk3x.default)(ms, {
                signal: this._options.signal
            });
            for (const hook of this._options.hooks.beforeRetry){
                // eslint-disable-next-line no-await-in-loop
                const hookResult = await hook({
                    request: this.request,
                    options: this._options,
                    error: error,
                    retryCount: this._retryCount
                });
                // If `stop` is returned from the hook, the retry process is stopped
                if (hookResult === (0, $cRgPT.stop)) return;
            }
            return this._retry(function_);
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        const nonRequestOptions = (0, $chMJ5.findUnknownOptions)(this.request, this._options);
        // Cloning is done here to prepare in advance for retries
        const mainRequest = this.request;
        this.request = mainRequest.clone();
        if (this._options.timeout === false) return this._options.fetch(mainRequest, nonRequestOptions);
        return (0, $gZ9DJ.default)(mainRequest, nonRequestOptions, this.abortController, this._options);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get('content-length')) || 0;
        let transferredBytes = 0;
        if (response.status === 204) {
            if (onDownloadProgress) onDownloadProgress({
                percent: 1,
                totalBytes: totalBytes,
                transferredBytes: transferredBytes
            }, new Uint8Array());
            return new globalThis.Response(null, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return new globalThis.Response(new globalThis.ReadableStream({
            async start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    await read();
                }
                await read();
            }
        }), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
}

});
parcelRegister("eWumj", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", function () { return $ae0e081d12012525$export$66d311bf29d5c89c; });
class $ae0e081d12012525$export$66d311bf29d5c89c extends Error {
    request;
    constructor(request){
        super(`Request timed out: ${request.method} ${request.url}`);
        this.name = 'TimeoutError';
        this.request = request;
    }
}

});

parcelRegister("2dLH8", function(module, exports) {

$parcel$export(module.exports, "validateAndMerge", function () { return $19e1cad4986955d6$export$8886f5ba30bd5e0; });
$parcel$export(module.exports, "mergeHeaders", function () { return $19e1cad4986955d6$export$eee1781d075786ae; });
$parcel$export(module.exports, "mergeHooks", function () { return $19e1cad4986955d6$export$3de1ffbf114b9f2d; });

var $bvOhO = parcelRequire("bvOhO");
const $19e1cad4986955d6$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $bvOhO.isObject)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError('The `options` argument must be an object');
    }
    return $19e1cad4986955d6$export$6969335ea1e4e77c({}, ...sources);
};
const $19e1cad4986955d6$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === 'undefined' || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
function $19e1cad4986955d6$var$newHookValue(original, incoming, property) {
    return Object.hasOwn(incoming, property) && incoming[property] === undefined ? [] : $19e1cad4986955d6$export$6969335ea1e4e77c(original[property] ?? [], incoming[property] ?? []);
}
const $19e1cad4986955d6$export$3de1ffbf114b9f2d = (original = {}, incoming = {})=>({
        beforeRequest: $19e1cad4986955d6$var$newHookValue(original, incoming, 'beforeRequest'),
        beforeRetry: $19e1cad4986955d6$var$newHookValue(original, incoming, 'beforeRetry'),
        afterResponse: $19e1cad4986955d6$var$newHookValue(original, incoming, 'afterResponse'),
        beforeError: $19e1cad4986955d6$var$newHookValue(original, incoming, 'beforeError')
    });
const $19e1cad4986955d6$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    let hooks = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $bvOhO.isObject)(source)) {
            for (let [key, value] of Object.entries(source)){
                if ((0, $bvOhO.isObject)(value) && key in returnValue) value = $19e1cad4986955d6$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $bvOhO.isObject)(source.hooks)) {
                hooks = $19e1cad4986955d6$export$3de1ffbf114b9f2d(hooks, source.hooks);
                returnValue.hooks = hooks;
            }
            if ((0, $bvOhO.isObject)(source.headers)) {
                headers = $19e1cad4986955d6$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};

});
parcelRegister("bvOhO", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $861998c6908fd708$export$a6cdc56e425d0d0a; });
// eslint-disable-next-line @typescript-eslint/ban-types
const $861998c6908fd708$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === 'object';

});


parcelRegister("hPAzg", function(module, exports) {

$parcel$export(module.exports, "normalizeRequestMethod", function () { return $cfb390b29a27f7e5$export$d585027d4667ffce; });
$parcel$export(module.exports, "normalizeRetryOptions", function () { return $cfb390b29a27f7e5$export$3e5471bb9440c9c1; });

var $cRgPT = parcelRequire("cRgPT");
const $cfb390b29a27f7e5$export$d585027d4667ffce = (input)=>(0, $cRgPT.requestMethods).includes(input) ? input.toUpperCase() : input;
const $cfb390b29a27f7e5$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $cfb390b29a27f7e5$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $cfb390b29a27f7e5$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $cfb390b29a27f7e5$var$defaultRetryOptions = {
    limit: 2,
    methods: $cfb390b29a27f7e5$var$retryMethods,
    statusCodes: $cfb390b29a27f7e5$var$retryStatusCodes,
    afterStatusCodes: $cfb390b29a27f7e5$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000
};
const $cfb390b29a27f7e5$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$cfb390b29a27f7e5$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$cfb390b29a27f7e5$var$defaultRetryOptions,
        ...retry
    };
};

});
parcelRegister("cRgPT", function(module, exports) {

$parcel$export(module.exports, "supportsRequestStreams", function () { return $95c77e88185d0a90$export$d8618555562b76b7; });
$parcel$export(module.exports, "supportsAbortController", function () { return $95c77e88185d0a90$export$6c0aacaed85a4966; });
$parcel$export(module.exports, "supportsResponseStreams", function () { return $95c77e88185d0a90$export$135162ac70ac2b21; });
$parcel$export(module.exports, "supportsFormData", function () { return $95c77e88185d0a90$export$f1525fa7979d0aa9; });
$parcel$export(module.exports, "requestMethods", function () { return $95c77e88185d0a90$export$fb003dbd6df95edb; });
$parcel$export(module.exports, "responseTypes", function () { return $95c77e88185d0a90$export$a6f212d4ee888d8c; });
$parcel$export(module.exports, "maxSafeTimeout", function () { return $95c77e88185d0a90$export$9b60a72e3f70a1d2; });
$parcel$export(module.exports, "stop", function () { return $95c77e88185d0a90$export$fa6813432f753b0d; });
$parcel$export(module.exports, "kyOptionKeys", function () { return $95c77e88185d0a90$export$601fffa09f19102d; });
$parcel$export(module.exports, "requestOptionsRegistry", function () { return $95c77e88185d0a90$export$b2ec467665ae937d; });
const $95c77e88185d0a90$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === 'function';
    const supportsRequest = typeof globalThis.Request === 'function';
    if (supportsReadableStream && supportsRequest) try {
        hasContentType = new globalThis.Request('https://empty.invalid', {
            body: new globalThis.ReadableStream(),
            method: 'POST',
            // @ts-expect-error - Types are outdated.
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
    } catch (error) {
        // QQBrowser on iOS throws "unsupported BodyInit type" error (see issue #581)
        if (error instanceof Error && error.message === 'unsupported BodyInit type') return false;
        throw error;
    }
    return duplexAccessed && !hasContentType;
})();
const $95c77e88185d0a90$export$6c0aacaed85a4966 = typeof globalThis.AbortController === 'function';
const $95c77e88185d0a90$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === 'function';
const $95c77e88185d0a90$export$f1525fa7979d0aa9 = typeof globalThis.FormData === 'function';
const $95c77e88185d0a90$export$fb003dbd6df95edb = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $95c77e88185d0a90$var$validate = ()=>undefined;
$95c77e88185d0a90$var$validate();
const $95c77e88185d0a90$export$a6f212d4ee888d8c = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*'
};
const $95c77e88185d0a90$export$9b60a72e3f70a1d2 = 2147483647;
const $95c77e88185d0a90$export$fa6813432f753b0d = Symbol('stop');
const $95c77e88185d0a90$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    stringifyJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true
};
const $95c77e88185d0a90$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    priority: true
};

});


parcelRegister("gZ9DJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5d9d222c7ea65ca$export$2e2bcd8739ae039; });

var $eWumj = parcelRequire("eWumj");
async function $c5d9d222c7ea65ca$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $eWumj.TimeoutError)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}

});

parcelRegister("lAk3x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb6c847a8a710dc0$export$2e2bcd8739ae039; });
// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $fb6c847a8a710dc0$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener('abort', abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
    });
}

});

parcelRegister("chMJ5", function(module, exports) {

$parcel$export(module.exports, "findUnknownOptions", function () { return $8f1cde8f0e979cde$export$95d8775889ec941f; });

var $cRgPT = parcelRequire("cRgPT");
const $8f1cde8f0e979cde$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options)if (!(key in (0, $cRgPT.requestOptionsRegistry)) && !(key in (0, $cRgPT.kyOptionKeys)) && !(key in request)) unknownOptions[key] = options[key];
    return unknownOptions;
};

});





parcelRegister("bN7FL", function(module, exports) {

$parcel$export(module.exports, "ToasterContextProvider", function () { return $15229e7c34b0dc52$export$49af044743387d11; });
$parcel$export(module.exports, "useToaster", function () { return $15229e7c34b0dc52$export$f46171b59bb094f9; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $lr3g3 = parcelRequire("lr3g3");
var $dGJql = parcelRequire("dGJql");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $hPJN4 = parcelRequire("hPJN4");

var $9ddGv = parcelRequire("9ddGv");

var $dR62Q = parcelRequire("dR62Q");

var $9Zft8 = parcelRequire("9Zft8");

var $5MBh5 = parcelRequire("5MBh5");
const $15229e7c34b0dc52$var$defaultDuration = (0, $hPJN4.MsDuration).seconds(3);
const $15229e7c34b0dc52$var$config = {
    tension: 125,
    friction: 20,
    precision: 0.1
};
const $15229e7c34b0dc52$var$toasterLayerId = 'toaster-layer';
const $15229e7c34b0dc52$var$toasterLayer = document.getElementById($15229e7c34b0dc52$var$toasterLayerId);
if ($15229e7c34b0dc52$var$toasterLayer === null) // eslint-disable-next-line functional/no-throw-statements
throw Error(`Toaster layer not found: #${$15229e7c34b0dc52$var$toasterLayerId}`);
const $15229e7c34b0dc52$var$ToasterContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
const $15229e7c34b0dc52$export$49af044743387d11 = ({ children: children })=>{
    const refMap = (0, $exYeM.useMemo)(()=>new WeakMap(), []);
    const cancelMap = (0, $exYeM.useMemo)(()=>new WeakMap(), []);
    const [toasters, setToasters] = (0, $exYeM.useState)((0, $9ddGv.List).empty());
    const transitions = (0, $dGJql.useTransition)(toasters, {
        from: {
            opacity: 0,
            height: 0,
            ttl: 100
        },
        keys: (toaster)=>(0, $9Zft8.ToasterId).unwrap(toaster.id),
        enter: (toaster)=>(next, cancel)=>{
                cancelMap.set(toaster, cancel);
                return next({
                    opacity: 1,
                    height: refMap.get(toaster)?.offsetHeight
                }).then(()=>next({
                        ttl: 0
                    }));
            },
        leave: [
            {
                opacity: 0
            },
            {
                height: 0
            }
        ],
        onRest: (result, ctrl, toaster)=>{
            setToasters((0, $9ddGv.List).filter((t)=>!(0, $9Zft8.ToasterId).Eq.equals(t.id, toaster.id)));
        },
        config: (toaster, index, phase)=>(key)=>// eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
                phase === 'enter' && key === 'ttl' ? {
                    duration: (0, $hPJN4.MsDuration).unwrap(toaster.duration ?? (toaster.type === 'error' ? (0, $hPJN4.MsDuration).infinity : $15229e7c34b0dc52$var$defaultDuration))
                } : $15229e7c34b0dc52$var$config
    });
    const showToaster = (0, $exYeM.useCallback)((type, content, options)=>{
        const id = (0, $9Zft8.ToasterId).generate();
        setToasters((0, $9ddGv.List).append({
            id: id,
            type: type,
            content: content,
            ...options
        }));
        return id;
    }, []);
    const onMount = (0, $exYeM.useCallback)((toaster)=>(elt)=>{
            if (elt !== null) refMap.set(toaster, elt);
        }, [
        refMap
    ]);
    const onClick = (0, $exYeM.useCallback)((ttl, toaster)=>()=>{
            if (cancelMap.has(toaster) && ttl.get() !== 0) cancelMap.get(toaster)?.();
        }, [
        cancelMap
    ]);
    const value = {
        showToaster: showToaster
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($15229e7c34b0dc52$var$ToasterContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                children: /*#__PURE__*/ (0, $d2lNW.createPortal)(/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "absolute right-0 top-0 flex w-96 max-w-screen flex-col",
                    children: transitions(({ opacity: opacity, height: height, ttl: ttl }, toaster)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $lr3g3.animated).div, {
                            style: {
                                opacity: opacity,
                                height: height
                            },
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                ref: onMount(toaster),
                                className: "pt-1",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: (0, $5MBh5.cx)('p-0.75 text-beige shadow-even', $15229e7c34b0dc52$var$container[toaster.type]),
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: (0, $5MBh5.cx)('grid grid-cols-[1fr_auto] border-3 py-2 pl-2 pr-1', $15229e7c34b0dc52$var$border[toaster.type]),
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                                className: "text-sm",
                                                children: toaster.content
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                                type: "button",
                                                onClick: onClick(ttl, toaster),
                                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CloseFilled), {
                                                    className: "w-5"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }))
                }), $15229e7c34b0dc52$var$toasterLayer)
            })
        ]
    });
};
const $15229e7c34b0dc52$var$container = {
    success: 'bg-green-toaster',
    warn: 'bg-orange-toaster',
    error: 'bg-red-toaster'
};
const $15229e7c34b0dc52$var$border = {
    success: 'border-green-toaster-bis',
    warn: 'border-orange-toaster-bis',
    error: 'border-red-toaster-bis'
};
const $15229e7c34b0dc52$export$f46171b59bb094f9 = ()=>{
    const context = (0, $exYeM.useContext)($15229e7c34b0dc52$var$ToasterContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useToaster must be used within a ToasterContextProvider');
    return context;
};

});
parcelRegister("lr3g3", function(module, exports) {
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("lxYz2")).Globals; });
$parcel$export(module.exports, "useSprings", function () { return (parcelRequire("dGJql")).useSprings; });
$parcel$export(module.exports, "useTransition", function () { return (parcelRequire("dGJql")).useTransition; });

$parcel$export(module.exports, "animated", function () { return $f9aea5876333360d$export$407448d2b89b1813; });
// src/index.ts
parcelRequire("dGJql");
var $lxYz2 = parcelRequire("lxYz2");

var $d2lNW = parcelRequire("d2lNW");

var $lxYz2 = parcelRequire("lxYz2");

var $aDLJU = parcelRequire("aDLJU");
// src/applyAnimatedValues.ts
var $f9aea5876333360d$var$isCustomPropRE = /^--/;
function $f9aea5876333360d$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$f9aea5876333360d$var$isCustomPropRE.test(name) && !($f9aea5876333360d$var$isUnitlessNumber.hasOwnProperty(name) && $f9aea5876333360d$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $f9aea5876333360d$var$attributeCache = {};
function $f9aea5876333360d$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $f9aea5876333360d$var$attributeCache[name] || ($f9aea5876333360d$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $f9aea5876333360d$var$dangerousStyleValue(name, style[name]);
        if ($f9aea5876333360d$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $f9aea5876333360d$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $f9aea5876333360d$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $f9aea5876333360d$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$f9aea5876333360d$var$isUnitlessNumber = Object.keys($f9aea5876333360d$var$isUnitlessNumber).reduce((acc, prop)=>{
    $f9aea5876333360d$var$prefixes.forEach((prefix)=>acc[$f9aea5876333360d$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $f9aea5876333360d$var$isUnitlessNumber);
var $f9aea5876333360d$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $f9aea5876333360d$var$pxTransforms = /^(translate)/;
var $f9aea5876333360d$var$degTransforms = /^(rotate|skew)/;
var $f9aea5876333360d$var$addUnit = (value, unit)=>(0, $lxYz2.is).num(value) && value !== 0 ? value + unit : value;
var $f9aea5876333360d$var$isValueIdentity = (value, id)=>(0, $lxYz2.is).arr(value) ? value.every((v)=>$f9aea5876333360d$var$isValueIdentity(v, id)) : (0, $lxYz2.is).num(value) ? value === id : parseFloat(value) === id;
var $f9aea5876333360d$var$AnimatedStyle = class extends (0, $aDLJU.AnimatedObject) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$f9aea5876333360d$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $f9aea5876333360d$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $lxYz2.eachProp)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($f9aea5876333360d$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $lxYz2.is).und(value)) return;
                const unit = $f9aea5876333360d$var$pxTransforms.test(key) ? "px" : $f9aea5876333360d$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $lxYz2.toArray)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$f9aea5876333360d$var$addUnit(deg, unit)})`,
                        $f9aea5876333360d$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$f9aea5876333360d$var$addUnit(v, unit)).join(",")})`,
                        $f9aea5876333360d$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $f9aea5876333360d$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $f9aea5876333360d$var$FluidTransform = class extends (0, $lxYz2.FluidValue) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $lxYz2.each)(this.inputs, (input, i)=>{
            const arg1 = (0, $lxYz2.getFluidValue)(input[0]);
            const [t, id] = this.transforms[i]((0, $lxYz2.is).arr(arg1) ? arg1 : input.map((0, $lxYz2.getFluidValue)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $lxYz2.each)(this.inputs, (input)=>(0, $lxYz2.each)(input, (value)=>(0, $lxYz2.hasFluidValue)(value) && (0, $lxYz2.addFluidObserver)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $lxYz2.each)(this.inputs, (input)=>(0, $lxYz2.each)(input, (value)=>(0, $lxYz2.hasFluidValue)(value) && (0, $lxYz2.removeFluidObserver)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $lxYz2.callFluidObservers)(this, event);
    }
};
// src/primitives.ts
var $f9aea5876333360d$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $lxYz2.Globals).assign({
    batchedUpdates: (0, $d2lNW.unstable_batchedUpdates),
    createStringInterpolator: $lxYz2.createStringInterpolator,
    colors: $lxYz2.colors
});
var $f9aea5876333360d$var$host = (0, $aDLJU.createHost)($f9aea5876333360d$var$primitives, {
    applyAnimatedValues: $f9aea5876333360d$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $f9aea5876333360d$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $f9aea5876333360d$export$407448d2b89b1813 = $f9aea5876333360d$var$host.animated;

});
parcelRegister("dGJql", function(module, exports) {

$parcel$export(module.exports, "useSprings", function () { return $9f726edb03f4840c$export$15786d483ab9f469; });
$parcel$export(module.exports, "useTransition", function () { return $9f726edb03f4840c$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "Globals", function () { return (parcelRequire("lxYz2")).Globals; });
// src/hooks/useChain.ts

var $lxYz2 = parcelRequire("lxYz2");
var $lwA3x = parcelRequire("lwA3x");

var $exYeM = parcelRequire("exYeM");

var $aDLJU = parcelRequire("aDLJU");
parcelRequire("kL38t");
function $9f726edb03f4840c$var$callProp(value, ...args) {
    return (0, $lxYz2.is).fun(value) ? value(...args) : value;
}
var $9f726edb03f4840c$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $lxYz2.is).fun(value) ? value(key) : (0, $lxYz2.toArray)(value).includes(key)));
var $9f726edb03f4840c$var$resolveProp = (prop, key)=>(0, $lxYz2.is).obj(prop) ? key && prop[key] : prop;
var $9f726edb03f4840c$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $9f726edb03f4840c$var$noopTransform = (value)=>value;
var $9f726edb03f4840c$var$getDefaultProps = (props, transform = $9f726edb03f4840c$var$noopTransform)=>{
    let keys = $9f726edb03f4840c$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $lxYz2.is).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $9f726edb03f4840c$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $9f726edb03f4840c$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $9f726edb03f4840c$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $lxYz2.eachProp)(props, (value, prop)=>{
        if (!$9f726edb03f4840c$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $9f726edb03f4840c$export$b971039a739bf227(props) {
    const to2 = $9f726edb03f4840c$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $lxYz2.eachProp)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $9f726edb03f4840c$var$computeGoal(value) {
    value = (0, $lxYz2.getFluidValue)(value);
    return (0, $lxYz2.is).arr(value) ? value.map($9f726edb03f4840c$var$computeGoal) : (0, $lxYz2.isAnimatedString)(value) ? (0, $lxYz2.Globals).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $9f726edb03f4840c$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $9f726edb03f4840c$var$isAsyncTo(to2) {
    return (0, $lxYz2.is).fun(to2) || (0, $lxYz2.is).arr(to2) && (0, $lxYz2.is).obj(to2[0]);
}
function $9f726edb03f4840c$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $9f726edb03f4840c$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $9f726edb03f4840c$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $lxYz2.each)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $lxYz2.each)(controllers, (ctrl)=>{
                        (0, $lxYz2.each)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $9f726edb03f4840c$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $lxYz2.each)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $lxYz2.each)(controllers, (ctrl, i)=>(0, $lxYz2.each)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $9f726edb03f4840c$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $9f726edb03f4840c$var$defaults = {
    ...$9f726edb03f4840c$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $lxYz2.easings).linear,
    clamp: false
};
var $9f726edb03f4840c$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $9f726edb03f4840c$var$defaults);
    }
};
function $9f726edb03f4840c$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $9f726edb03f4840c$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $9f726edb03f4840c$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $9f726edb03f4840c$var$defaults)if (config2[key] == null) config2[key] = $9f726edb03f4840c$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $lxYz2.is).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $9f726edb03f4840c$var$sanitizeConfig(config2, props) {
    if (!(0, $lxYz2.is).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $lxYz2.is).und(props.tension) || !(0, $lxYz2.is).und(props.friction);
        if (isTensionConfig || !(0, $lxYz2.is).und(props.frequency) || !(0, $lxYz2.is).und(props.damping) || !(0, $lxYz2.is).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $9f726edb03f4840c$var$emptyArray = [];
var $9f726edb03f4840c$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $9f726edb03f4840c$var$emptyArray;
        this.toValues = null;
        this.fromValues = $9f726edb03f4840c$var$emptyArray;
        this.config = new $9f726edb03f4840c$var$AnimationConfig();
        this.immediate = false;
    }
};
function $9f726edb03f4840c$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $9f726edb03f4840c$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $lxYz2.is).und(props.pause)) state.paused = $9f726edb03f4840c$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $9f726edb03f4840c$var$matchProp(pause, key);
            delay = $9f726edb03f4840c$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $lwA3x.raf).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $lxYz2.Globals).skipAnimation) {
                state.delayed = true;
                timeout = (0, $lwA3x.raf).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $9f726edb03f4840c$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $9f726edb03f4840c$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $9f726edb03f4840c$var$getNoopResult(target.get()) : $9f726edb03f4840c$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $9f726edb03f4840c$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $9f726edb03f4840c$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $9f726edb03f4840c$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $9f726edb03f4840c$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $9f726edb03f4840c$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $9f726edb03f4840c$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $9f726edb03f4840c$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $9f726edb03f4840c$export$d362d093fa99dc7();
            const skipAnimationSignal = new $9f726edb03f4840c$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $lxYz2.Globals).skipAnimation) {
                    $9f726edb03f4840c$var$stopAsync(state);
                    skipAnimationSignal.result = $9f726edb03f4840c$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $lxYz2.is).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $lxYz2.eachProp)(defaultProps, (value, key)=>{
                    if ((0, $lxYz2.is).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $lxYz2.Globals).skipAnimation) {
            $9f726edb03f4840c$var$stopAsync(state);
            return $9f726edb03f4840c$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $lxYz2.is).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $9f726edb03f4840c$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $9f726edb03f4840c$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $9f726edb03f4840c$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $lxYz2.is).fun(onRest)) (0, $lwA3x.raf).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $9f726edb03f4840c$var$stopAsync(state, cancelId) {
    (0, $lxYz2.flush)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $9f726edb03f4840c$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $9f726edb03f4840c$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $9f726edb03f4840c$var$isFrameValue = (value)=>value instanceof $9f726edb03f4840c$export$8229896f80e2495e;
var $9f726edb03f4840c$var$nextId = 1;
var $9f726edb03f4840c$export$8229896f80e2495e = class extends (0, $lxYz2.FluidValue) {
    constructor(){
        super(...arguments);
        this.id = $9f726edb03f4840c$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $aDLJU.getAnimated)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $lxYz2.Globals).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $lxYz2.deprecateInterpolate)();
        return (0, $lxYz2.Globals).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $lxYz2.callFluidObservers)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $lxYz2.frameLoop).sort(this);
        (0, $lxYz2.callFluidObservers)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $9f726edb03f4840c$var$$P = Symbol.for("SpringPhase");
var $9f726edb03f4840c$var$HAS_ANIMATED = 1;
var $9f726edb03f4840c$var$IS_ANIMATING = 2;
var $9f726edb03f4840c$var$IS_PAUSED = 4;
var $9f726edb03f4840c$var$hasAnimated = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$HAS_ANIMATED) > 0;
var $9f726edb03f4840c$var$isAnimating = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$IS_ANIMATING) > 0;
var $9f726edb03f4840c$var$isPaused = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$IS_PAUSED) > 0;
var $9f726edb03f4840c$var$setActiveBit = (target, active)=>active ? target[$9f726edb03f4840c$var$$P] |= $9f726edb03f4840c$var$IS_ANIMATING | $9f726edb03f4840c$var$HAS_ANIMATED : target[$9f726edb03f4840c$var$$P] &= ~$9f726edb03f4840c$var$IS_ANIMATING;
var $9f726edb03f4840c$var$setPausedBit = (target, paused)=>paused ? target[$9f726edb03f4840c$var$$P] |= $9f726edb03f4840c$var$IS_PAUSED : target[$9f726edb03f4840c$var$$P] &= ~$9f726edb03f4840c$var$IS_PAUSED;
// src/SpringValue.ts
var $9f726edb03f4840c$export$5854d13427d5a954 = class extends $9f726edb03f4840c$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $9f726edb03f4840c$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $lxYz2.is).und(arg1) || !(0, $lxYz2.is).und(arg2)) {
            const props = (0, $lxYz2.is).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $lxYz2.is).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($9f726edb03f4840c$var$isAnimating(this) || this._state.asyncTo) || $9f726edb03f4840c$var$isPaused(this);
    }
    get goal() {
        return (0, $lxYz2.getFluidValue)(this.animation.to);
    }
    get velocity() {
        const node = (0, $aDLJU.getAnimated)(this);
        return node instanceof (0, $aDLJU.AnimatedValue) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $9f726edb03f4840c$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $9f726edb03f4840c$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $9f726edb03f4840c$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $aDLJU.getPayload)(anim.to);
        if (!payload && (0, $lxYz2.hasFluidValue)(anim.to)) toValues = (0, $lxYz2.toArray)((0, $lxYz2.getFluidValue)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $aDLJU.AnimatedString) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $lxYz2.is).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $lxYz2.is).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $lxYz2.is).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $aDLJU.getAnimated)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $lxYz2.getFluidValue)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $lwA3x.raf).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($9f726edb03f4840c$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $lwA3x.raf).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $lxYz2.is).und(to2)) queue = [
            (0, $lxYz2.is).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$9f726edb03f4840c$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $9f726edb03f4840c$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $lwA3x.raf).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $lxYz2.is).obj(to2) ? to2[key] : to2;
        if (to2 == null || $9f726edb03f4840c$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $lxYz2.is).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$9f726edb03f4840c$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $lxYz2.getFluidValue)(from);
            if (!(0, $lxYz2.is).und(from)) this._set(from);
            else if (!(0, $aDLJU.getAnimated)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $9f726edb03f4840c$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $9f726edb03f4840c$var$resolveProp(value, key) : value));
        $9f726edb03f4840c$var$mergeActiveFn(this, props, "onProps");
        $9f726edb03f4840c$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $9f726edb03f4840c$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$9f726edb03f4840c$var$isPaused(this)) {
                        $9f726edb03f4840c$var$setPausedBit(this, true);
                        (0, $lxYz2.flushCalls)(state.pauseQueue);
                        $9f726edb03f4840c$var$sendEvent(this, "onPause", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($9f726edb03f4840c$var$isPaused(this)) {
                        $9f726edb03f4840c$var$setPausedBit(this, false);
                        if ($9f726edb03f4840c$var$isAnimating(this)) this._resume();
                        (0, $lxYz2.flushCalls)(state.resumeQueue);
                        $9f726edb03f4840c$var$sendEvent(this, "onResume", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $9f726edb03f4840c$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($9f726edb03f4840c$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $lxYz2.is).und(range.to);
        const hasFromProp = !(0, $lxYz2.is).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($9f726edb03f4840c$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $lxYz2.is).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $lxYz2.isEqual)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $lxYz2.getFluidValue)(from);
        const hasToChanged = !(0, $lxYz2.isEqual)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $9f726edb03f4840c$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $9f726edb03f4840c$var$mergeConfig(config2, $9f726edb03f4840c$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $9f726edb03f4840c$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $aDLJU.getAnimated)(this);
        if (!node || (0, $lxYz2.is).und(to2)) return resolve($9f726edb03f4840c$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $lxYz2.is).und(props.reset) ? hasFromProp && !props.default : !(0, $lxYz2.is).und(from) && $9f726edb03f4840c$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $9f726edb03f4840c$var$computeGoal(to2);
        const isAnimatable = (0, $lxYz2.is).num(goal) || (0, $lxYz2.is).arr(goal) || (0, $lxYz2.isAnimatedString)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $9f726edb03f4840c$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $aDLJU.getAnimatedType)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $lxYz2.hasFluidValue)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$9f726edb03f4840c$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $lxYz2.isEqual)($9f726edb03f4840c$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $lxYz2.isEqual)(anim.immediate, immediate) && !immediate || !(0, $lxYz2.isEqual)(config2.decay, decay) || !(0, $lxYz2.isEqual)(config2.velocity, velocity)) started = true;
        }
        if (finished && $9f726edb03f4840c$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $lxYz2.hasFluidValue)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $lxYz2.hasFluidValue)(to2) ? null : goalType == (0, $aDLJU.AnimatedString) ? [
                    1
                ] : (0, $lxYz2.toArray)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $lxYz2.each)($9f726edb03f4840c$var$ACTIVE_EVENTS, (type)=>$9f726edb03f4840c$var$mergeActiveFn(this, props, type));
                const result = $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, prevTo));
                (0, $lxYz2.flushCalls)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $lwA3x.raf).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $9f726edb03f4840c$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($9f726edb03f4840c$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($9f726edb03f4840c$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($9f726edb03f4840c$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $lxYz2.getFluidObservers)(this)) this._detach();
            anim.to = value;
            if ((0, $lxYz2.getFluidObservers)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $lxYz2.hasFluidValue)(to2)) {
            (0, $lxYz2.addFluidObserver)(to2, this);
            if ($9f726edb03f4840c$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $lxYz2.hasFluidValue)(to2)) (0, $lxYz2.removeFluidObserver)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $lxYz2.getFluidValue)(arg);
        if (!(0, $lxYz2.is).und(value)) {
            const oldNode = (0, $aDLJU.getAnimated)(this);
            if (!oldNode || !(0, $lxYz2.isEqual)(value, oldNode.getValue())) {
                const nodeType = (0, $aDLJU.getAnimatedType)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $aDLJU.setAnimated)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $lwA3x.raf).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $aDLJU.getAnimated)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $9f726edb03f4840c$var$sendEvent(this, "onStart", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $9f726edb03f4840c$var$callProp(this.animation.onChange, value, this);
        }
        $9f726edb03f4840c$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $aDLJU.getAnimated)(this).reset((0, $lxYz2.getFluidValue)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$9f726edb03f4840c$var$isAnimating(this)) {
            $9f726edb03f4840c$var$setActiveBit(this, true);
            if (!$9f726edb03f4840c$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $lxYz2.Globals).skipAnimation) this.finish();
        else (0, $lxYz2.frameLoop).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($9f726edb03f4840c$var$isAnimating(this)) {
            $9f726edb03f4840c$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $lxYz2.each)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $lxYz2.callFluidObservers)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $9f726edb03f4840c$var$getCancelledResult(this.get()) : $9f726edb03f4840c$var$getFinishedResult(this.get(), $9f726edb03f4840c$var$checkFinished(this, goal ?? anim.to));
            (0, $lxYz2.flushCalls)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $9f726edb03f4840c$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $9f726edb03f4840c$var$checkFinished(target, to2) {
    const goal = $9f726edb03f4840c$var$computeGoal(to2);
    const value = $9f726edb03f4840c$var$computeGoal(target.get());
    return (0, $lxYz2.isEqual)(value, goal);
}
function $9f726edb03f4840c$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $9f726edb03f4840c$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $9f726edb03f4840c$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $9f726edb03f4840c$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $9f726edb03f4840c$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $9f726edb03f4840c$var$createUpdate(props) {
    const { to: to2, from: from } = props = $9f726edb03f4840c$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $lxYz2.is).obj(to2)) $9f726edb03f4840c$var$findDefined(to2, keys);
    if ((0, $lxYz2.is).obj(from)) $9f726edb03f4840c$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $9f726edb03f4840c$var$declareUpdate(props) {
    const update2 = $9f726edb03f4840c$var$createUpdate(props);
    if ((0, $lxYz2.is).und(update2.default)) update2.default = $9f726edb03f4840c$var$getDefaultProps(update2);
    return update2;
}
function $9f726edb03f4840c$var$findDefined(values, keys) {
    (0, $lxYz2.eachProp)(values, (value, key)=>value != null && keys.add(key));
}
var $9f726edb03f4840c$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $9f726edb03f4840c$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $9f726edb03f4840c$var$getDefaultProp(props, type) ? $9f726edb03f4840c$var$resolveProp(props[type], target.key) : void 0;
}
function $9f726edb03f4840c$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $9f726edb03f4840c$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $9f726edb03f4840c$var$nextId2 = 1;
var $9f726edb03f4840c$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $9f726edb03f4840c$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $lxYz2.is).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($9f726edb03f4840c$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $lxYz2.toArray)(props).map($9f726edb03f4840c$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $9f726edb03f4840c$var$prepareKeys(this, queue);
        return $9f726edb03f4840c$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $lxYz2.each)((0, $lxYz2.toArray)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $9f726edb03f4840c$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $lxYz2.is).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $lxYz2.each)((0, $lxYz2.toArray)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $lxYz2.is).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $lxYz2.each)((0, $lxYz2.toArray)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $lxYz2.eachProp)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $lxYz2.flush)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $lxYz2.flush)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $lxYz2.flush)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $lwA3x.raf).onFrame(this._onFrame);
    }
};
function $9f726edb03f4840c$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$9f726edb03f4840c$var$flushUpdate(ctrl, props))).then((results)=>$9f726edb03f4840c$var$getCombinedResult(ctrl, results));
}
async function $9f726edb03f4840c$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $lxYz2.is).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $lxYz2.is).arr(to2) || (0, $lxYz2.is).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $lxYz2.each)($9f726edb03f4840c$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $lxYz2.is).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $lxYz2.flushCalls)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $9f726edb03f4840c$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($9f726edb03f4840c$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $lxYz2.noop),
            resume: (0, $lxYz2.noop),
            start (props2, resolve) {
                if (cancel) {
                    $9f726edb03f4840c$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($9f726edb03f4840c$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($9f726edb03f4840c$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $9f726edb03f4840c$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $9f726edb03f4840c$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $9f726edb03f4840c$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $9f726edb03f4840c$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $lwA3x.raf).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $9f726edb03f4840c$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $lxYz2.each)((0, $lxYz2.toArray)(props), (props2)=>{
        if ((0, $lxYz2.is).und(props2.keys)) props2 = $9f726edb03f4840c$var$createUpdate(props2);
        if (!(0, $lxYz2.is).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $9f726edb03f4840c$var$prepareSprings(springs, props2, (key)=>{
            return $9f726edb03f4840c$var$createSpring(key);
        });
    });
    $9f726edb03f4840c$var$setSprings(ctrl, springs);
    return springs;
}
function $9f726edb03f4840c$var$setSprings(ctrl, springs) {
    (0, $lxYz2.eachProp)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $lxYz2.addFluidObserver)(spring, ctrl);
        }
    });
}
function $9f726edb03f4840c$var$createSpring(key, observer) {
    const spring = new $9f726edb03f4840c$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $lxYz2.addFluidObserver)(spring, observer);
    return spring;
}
function $9f726edb03f4840c$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $lxYz2.each)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $9f726edb03f4840c$var$prepareKeys(ctrl, queue) {
    (0, $lxYz2.each)(queue, (props)=>{
        $9f726edb03f4840c$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $9f726edb03f4840c$var$createSpring(key, ctrl);
        });
    });
}
var $9f726edb03f4840c$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $exYeM.useContext)($9f726edb03f4840c$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $lxYz2.useMemoOne)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $9f726edb03f4840c$var$ctx;
    return /* @__PURE__ */ $exYeM.createElement(Provider, {
        value: props
    }, children);
};
var $9f726edb03f4840c$var$ctx = $9f726edb03f4840c$var$makeContext($9f726edb03f4840c$export$f12a216ec50d2cf1, {});
$9f726edb03f4840c$export$f12a216ec50d2cf1.Provider = $9f726edb03f4840c$var$ctx.Provider;
$9f726edb03f4840c$export$f12a216ec50d2cf1.Consumer = $9f726edb03f4840c$var$ctx.Consumer;
function $9f726edb03f4840c$var$makeContext(target, init) {
    Object.assign(target, $exYeM.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $9f726edb03f4840c$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $lxYz2.deprecateDirectCall)();
        const results = [];
        (0, $lxYz2.each)(current, (ctrl, i)=>{
            if ((0, $lxYz2.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $lxYz2.each)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $lxYz2.each)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $lxYz2.each)(current, (ctrl, i)=>{
            const update2 = (0, $lxYz2.is).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $lxYz2.each)(current, (ctrl, i)=>{
            if ((0, $lxYz2.is).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $lxYz2.each)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $lxYz2.each)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $lxYz2.is).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $9f726edb03f4840c$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $lxYz2.is).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $exYeM.useMemo)(()=>propsFn || arguments.length == 3 ? $9f726edb03f4840c$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $exYeM.useRef)(0);
    const forceUpdate = (0, $lxYz2.useForceUpdate)();
    const state = (0, $exYeM.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $9f726edb03f4840c$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $9f726edb03f4840c$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $9f726edb03f4840c$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($9f726edb03f4840c$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $exYeM.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $lxYz2.usePrev)(length) || 0;
    (0, $exYeM.useMemo)(()=>{
        (0, $lxYz2.each)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $9f726edb03f4840c$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $exYeM.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $9f726edb03f4840c$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $9f726edb03f4840c$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$9f726edb03f4840c$var$getSprings(ctrl, updates[i]));
    const context = (0, $exYeM.useContext)($9f726edb03f4840c$export$f12a216ec50d2cf1);
    const prevContext = (0, $lxYz2.usePrev)(context);
    const hasContext = context !== prevContext && $9f726edb03f4840c$var$hasProps(context);
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $lxYz2.each)(queue, (cb)=>cb());
        }
        (0, $lxYz2.each)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $9f726edb03f4840c$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $lxYz2.useOnce)(()=>()=>{
            (0, $lxYz2.each)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $9f726edb03f4840c$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $lxYz2.is).fun(props);
    const [[values], ref] = $9f726edb03f4840c$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $9f726edb03f4840c$var$initSpringRef = ()=>$9f726edb03f4840c$export$2471ae76e2946684();
var $9f726edb03f4840c$export$564bff9c23cad2ca = ()=>(0, $exYeM.useState)($9f726edb03f4840c$var$initSpringRef)[0];
var $9f726edb03f4840c$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $lxYz2.useConstant)(()=>new $9f726edb03f4840c$export$5854d13427d5a954(initial, props));
    (0, $lxYz2.useOnce)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $9f726edb03f4840c$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $lxYz2.is).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $9f726edb03f4840c$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        (0, $lxYz2.each)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $9f726edb03f4840c$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $lxYz2.is).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $9f726edb03f4840c$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $lxYz2.is).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $exYeM.useMemo)(()=>propsFn || arguments.length == 3 ? $9f726edb03f4840c$export$2471ae76e2946684() : void 0, []);
    const items = (0, $lxYz2.toArray)(data);
    const transitions = [];
    const usedTransitions = (0, $exYeM.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $lxYz2.useOnce)(()=>{
        (0, $lxYz2.each)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $lxYz2.each)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $9f726edb03f4840c$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $9f726edb03f4840c$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>(0, $lxYz2.each)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $9f726edb03f4840c$var$detachRefs(ctrl, ref);
            $9f726edb03f4840c$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $lxYz2.each)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $lxYz2.each)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $9f726edb03f4840c$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $lxYz2.each)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $lxYz2.is).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $lxYz2.useForceUpdate)();
    const defaultProps = $9f726edb03f4840c$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $exYeM.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $exYeM.useRef)(false);
    (0, $lxYz2.each)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $9f726edb03f4840c$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $9f726edb03f4840c$var$callProp(to2, t.item, i);
        to2 = (0, $lxYz2.is).obj(to2) ? $9f726edb03f4840c$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $9f726edb03f4840c$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $lxYz2.is).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $lxYz2.is).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $9f726edb03f4840c$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $9f726edb03f4840c$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $9f726edb03f4840c$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $9f726edb03f4840c$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $exYeM.useContext)($9f726edb03f4840c$export$f12a216ec50d2cf1);
    const prevContext = (0, $lxYz2.usePrev)(context);
    const hasContext = context !== prevContext && $9f726edb03f4840c$var$hasProps(context);
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        if (hasContext) (0, $lxYz2.each)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $lxYz2.each)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        (0, $lxYz2.each)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $9f726edb03f4840c$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $exYeM.createElement(elem.type, {
                ...elem.props,
                key: (0, $lxYz2.is).str(t.key) || (0, $lxYz2.is).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $9f726edb03f4840c$var$nextKey = 1;
function $9f726edb03f4840c$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $9f726edb03f4840c$var$nextKey++;
        });
    }
    return (0, $lxYz2.is).und(keys) ? items : (0, $lxYz2.is).fun(keys) ? items.map(keys) : (0, $lxYz2.toArray)(keys);
}
var $9f726edb03f4840c$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $lxYz2.onScroll)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $lxYz2.each)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $9f726edb03f4840c$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        const cleanupScroll = (0, $lxYz2.onResize)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $lxYz2.each)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $9f726edb03f4840c$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $9f726edb03f4840c$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $exYeM.useState)(false);
    const ref = (0, $exYeM.useRef)();
    const propsFn = (0, $lxYz2.is).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $lxYz2.is).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $9f726edb03f4840c$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $9f726edb03f4840c$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($9f726edb03f4840c$export$c4af9125706c4d30(props));
}
function $9f726edb03f4840c$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $9f726edb03f4840c$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $lxYz2.is).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $9f726edb03f4840c$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $9f726edb03f4840c$export$7b286972b8d8ccbf(items, props)(children);
}
var $9f726edb03f4840c$export$b0cc4f9860136880 = class extends $9f726edb03f4840c$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $lxYz2.createInterpolator)(...args);
        const value = this._get();
        const nodeType = (0, $aDLJU.getAnimatedType)(value);
        (0, $aDLJU.setAnimated)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $lxYz2.isEqual)(value, oldValue)) {
            (0, $aDLJU.getAnimated)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $9f726edb03f4840c$var$checkIdle(this._active)) $9f726edb03f4840c$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $lxYz2.is).arr(this.source) ? this.source.map((0, $lxYz2.getFluidValue)) : (0, $lxYz2.toArray)((0, $lxYz2.getFluidValue)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$9f726edb03f4840c$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $lxYz2.each)((0, $aDLJU.getPayload)(this), (node)=>{
                node.done = false;
            });
            if ((0, $lxYz2.Globals).skipAnimation) {
                (0, $lwA3x.raf).batchedUpdates(()=>this.advance());
                $9f726edb03f4840c$var$becomeIdle(this);
            } else (0, $lxYz2.frameLoop).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $lxYz2.each)((0, $lxYz2.toArray)(this.source), (source)=>{
            if ((0, $lxYz2.hasFluidValue)(source)) (0, $lxYz2.addFluidObserver)(source, this);
            if ($9f726edb03f4840c$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $lxYz2.each)((0, $lxYz2.toArray)(this.source), (source)=>{
            if ((0, $lxYz2.hasFluidValue)(source)) (0, $lxYz2.removeFluidObserver)(source, this);
        });
        this._active.clear();
        $9f726edb03f4840c$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $lxYz2.toArray)(this.source).reduce((highest, parent)=>Math.max(highest, ($9f726edb03f4840c$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $9f726edb03f4840c$var$isIdle(source) {
    return source.idle !== false;
}
function $9f726edb03f4840c$var$checkIdle(active) {
    return !active.size || Array.from(active).every($9f726edb03f4840c$var$isIdle);
}
function $9f726edb03f4840c$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $lxYz2.each)((0, $aDLJU.getPayload)(self), (node)=>{
            node.done = true;
        });
        (0, $lxYz2.callFluidObservers)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $9f726edb03f4840c$export$2c618a4308a30424 = (source, ...args)=>new $9f726edb03f4840c$export$b0cc4f9860136880(source, args);
var $9f726edb03f4840c$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $lxYz2.deprecateInterpolate)(), new $9f726edb03f4840c$export$b0cc4f9860136880(source, args));
(0, $lxYz2.Globals).assign({
    createStringInterpolator: $lxYz2.createStringInterpolator,
    to: (source, args)=>new $9f726edb03f4840c$export$b0cc4f9860136880(source, args)
});
var $9f726edb03f4840c$export$722fbec263ad908a = (0, $lxYz2.frameLoop).advance;

});
parcelRegister("lxYz2", function(module, exports) {

$parcel$export(module.exports, "Globals", function () { return $fafba8d3e1bed3b4$export$cceeabf822b64fc0; });
$parcel$export(module.exports, "noop", function () { return $fafba8d3e1bed3b4$export$8793edee2d425525; });
$parcel$export(module.exports, "defineHidden", function () { return $fafba8d3e1bed3b4$export$5c74248ea0e35446; });
$parcel$export(module.exports, "is", function () { return $fafba8d3e1bed3b4$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isEqual", function () { return $fafba8d3e1bed3b4$export$248d38f6296296c5; });
$parcel$export(module.exports, "each", function () { return $fafba8d3e1bed3b4$export$79b2f7037acddd43; });
$parcel$export(module.exports, "eachProp", function () { return $fafba8d3e1bed3b4$export$f4c6fe153f5a944e; });
$parcel$export(module.exports, "toArray", function () { return $fafba8d3e1bed3b4$export$45b10814cc054894; });
$parcel$export(module.exports, "flush", function () { return $fafba8d3e1bed3b4$export$4909b86c8034bf73; });
$parcel$export(module.exports, "flushCalls", function () { return $fafba8d3e1bed3b4$export$7ba486852759e806; });
$parcel$export(module.exports, "frameLoop", function () { return $fafba8d3e1bed3b4$export$a57f5080a3bcc90a; });
$parcel$export(module.exports, "colors", function () { return $fafba8d3e1bed3b4$export$8f45430ccf837300; });
$parcel$export(module.exports, "createInterpolator", function () { return $fafba8d3e1bed3b4$export$b12af43b97697ef5; });
$parcel$export(module.exports, "easings", function () { return $fafba8d3e1bed3b4$export$15a0bf1b4bbacad8; });
$parcel$export(module.exports, "hasFluidValue", function () { return $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7; });
$parcel$export(module.exports, "getFluidValue", function () { return $fafba8d3e1bed3b4$export$e37b7520edd66839; });
$parcel$export(module.exports, "getFluidObservers", function () { return $fafba8d3e1bed3b4$export$133f54e9f7cf1796; });
$parcel$export(module.exports, "callFluidObservers", function () { return $fafba8d3e1bed3b4$export$31752c40a5fab62a; });
$parcel$export(module.exports, "FluidValue", function () { return $fafba8d3e1bed3b4$export$aff8e1ac1a016a2; });
$parcel$export(module.exports, "addFluidObserver", function () { return $fafba8d3e1bed3b4$export$72d604e3f8d000a5; });
$parcel$export(module.exports, "removeFluidObserver", function () { return $fafba8d3e1bed3b4$export$7a0eb830d336339b; });
$parcel$export(module.exports, "createStringInterpolator", function () { return $fafba8d3e1bed3b4$export$4759a013d387347a; });
$parcel$export(module.exports, "deprecateInterpolate", function () { return $fafba8d3e1bed3b4$export$2abfcde8ae218ba8; });
$parcel$export(module.exports, "deprecateDirectCall", function () { return $fafba8d3e1bed3b4$export$d99d974913ad3b12; });
$parcel$export(module.exports, "isAnimatedString", function () { return $fafba8d3e1bed3b4$export$75bed621f62abfa9; });
$parcel$export(module.exports, "onResize", function () { return $fafba8d3e1bed3b4$export$45b39e67d4ce4921; });
$parcel$export(module.exports, "onScroll", function () { return $fafba8d3e1bed3b4$export$d4d89fd61e5416ee; });
$parcel$export(module.exports, "useConstant", function () { return $fafba8d3e1bed3b4$export$fe4300aa8eebea86; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $fafba8d3e1bed3b4$export$700979bc83e7db82; });
$parcel$export(module.exports, "useForceUpdate", function () { return $fafba8d3e1bed3b4$export$91db9bc4f8ac944a; });
$parcel$export(module.exports, "useMemoOne", function () { return $fafba8d3e1bed3b4$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "useOnce", function () { return $fafba8d3e1bed3b4$export$392544347a18b6ea; });
$parcel$export(module.exports, "usePrev", function () { return $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf; });
$parcel$export(module.exports, "raf", function () { return (parcelRequire("lwA3x")).raf; });

var $lwA3x = parcelRequire("lwA3x");

var $exYeM = parcelRequire("exYeM");
var $fafba8d3e1bed3b4$var$__defProp = Object.defineProperty;
var $fafba8d3e1bed3b4$var$__export = (target, all)=>{
    for(var name in all)$fafba8d3e1bed3b4$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $fafba8d3e1bed3b4$export$cceeabf822b64fc0 = {};
$fafba8d3e1bed3b4$var$__export($fafba8d3e1bed3b4$export$cceeabf822b64fc0, {
    assign: ()=>$fafba8d3e1bed3b4$var$assign,
    colors: ()=>$fafba8d3e1bed3b4$var$colors,
    createStringInterpolator: ()=>$fafba8d3e1bed3b4$var$createStringInterpolator,
    skipAnimation: ()=>$fafba8d3e1bed3b4$var$skipAnimation,
    to: ()=>$fafba8d3e1bed3b4$var$to,
    willAdvance: ()=>$fafba8d3e1bed3b4$var$willAdvance
});
// src/helpers.ts
function $fafba8d3e1bed3b4$export$8793edee2d425525() {}
var $fafba8d3e1bed3b4$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $fafba8d3e1bed3b4$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $fafba8d3e1bed3b4$export$248d38f6296296c5(a, b) {
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(a)) {
        if (!$fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $fafba8d3e1bed3b4$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $fafba8d3e1bed3b4$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $fafba8d3e1bed3b4$export$45b10814cc054894 = (a)=>$fafba8d3e1bed3b4$export$226b3eccf92c9ed9.und(a) ? [] : $fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $fafba8d3e1bed3b4$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $fafba8d3e1bed3b4$export$79b2f7037acddd43(items, iterator);
    }
}
var $fafba8d3e1bed3b4$export$7ba486852759e806 = (queue, ...args)=>$fafba8d3e1bed3b4$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $fafba8d3e1bed3b4$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $fafba8d3e1bed3b4$var$createStringInterpolator;
var $fafba8d3e1bed3b4$var$to;
var $fafba8d3e1bed3b4$var$colors = null;
var $fafba8d3e1bed3b4$var$skipAnimation = false;
var $fafba8d3e1bed3b4$var$willAdvance = $fafba8d3e1bed3b4$export$8793edee2d425525;
var $fafba8d3e1bed3b4$var$assign = (globals)=>{
    if (globals.to) $fafba8d3e1bed3b4$var$to = globals.to;
    if (globals.now) (0, $lwA3x.raf).now = globals.now;
    if (globals.colors !== void 0) $fafba8d3e1bed3b4$var$colors = globals.colors;
    if (globals.skipAnimation != null) $fafba8d3e1bed3b4$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $fafba8d3e1bed3b4$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $lwA3x.raf).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $lwA3x.raf).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $fafba8d3e1bed3b4$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $lwA3x.raf).frameLoop = globals.frameLoop;
};
var $fafba8d3e1bed3b4$var$startQueue = /* @__PURE__ */ new Set();
var $fafba8d3e1bed3b4$var$currentFrame = [];
var $fafba8d3e1bed3b4$var$prevFrame = [];
var $fafba8d3e1bed3b4$var$priority = 0;
var $fafba8d3e1bed3b4$export$a57f5080a3bcc90a = {
    get idle () {
        return !$fafba8d3e1bed3b4$var$startQueue.size && !$fafba8d3e1bed3b4$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($fafba8d3e1bed3b4$var$priority > animation.priority) {
            $fafba8d3e1bed3b4$var$startQueue.add(animation);
            (0, $lwA3x.raf).onStart($fafba8d3e1bed3b4$var$flushStartQueue);
        } else {
            $fafba8d3e1bed3b4$var$startSafely(animation);
            (0, $lwA3x.raf)($fafba8d3e1bed3b4$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $fafba8d3e1bed3b4$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($fafba8d3e1bed3b4$var$priority) (0, $lwA3x.raf).onFrame(()=>$fafba8d3e1bed3b4$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $fafba8d3e1bed3b4$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $fafba8d3e1bed3b4$var$currentFrame.splice(prevIndex, 1);
                $fafba8d3e1bed3b4$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $fafba8d3e1bed3b4$var$currentFrame = [];
        $fafba8d3e1bed3b4$var$startQueue.clear();
    }
};
function $fafba8d3e1bed3b4$var$flushStartQueue() {
    $fafba8d3e1bed3b4$var$startQueue.forEach($fafba8d3e1bed3b4$var$startSafely);
    $fafba8d3e1bed3b4$var$startQueue.clear();
    (0, $lwA3x.raf)($fafba8d3e1bed3b4$var$advance);
}
function $fafba8d3e1bed3b4$var$startSafely(animation) {
    if (!$fafba8d3e1bed3b4$var$currentFrame.includes(animation)) $fafba8d3e1bed3b4$var$startUnsafely(animation);
}
function $fafba8d3e1bed3b4$var$startUnsafely(animation) {
    $fafba8d3e1bed3b4$var$currentFrame.splice($fafba8d3e1bed3b4$var$findIndex($fafba8d3e1bed3b4$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $fafba8d3e1bed3b4$var$advance(dt) {
    const nextFrame = $fafba8d3e1bed3b4$var$prevFrame;
    for(let i = 0; i < $fafba8d3e1bed3b4$var$currentFrame.length; i++){
        const animation = $fafba8d3e1bed3b4$var$currentFrame[i];
        $fafba8d3e1bed3b4$var$priority = animation.priority;
        if (!animation.idle) {
            $fafba8d3e1bed3b4$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $fafba8d3e1bed3b4$var$priority = 0;
    $fafba8d3e1bed3b4$var$prevFrame = $fafba8d3e1bed3b4$var$currentFrame;
    $fafba8d3e1bed3b4$var$prevFrame.length = 0;
    $fafba8d3e1bed3b4$var$currentFrame = nextFrame;
    return $fafba8d3e1bed3b4$var$currentFrame.length > 0;
}
function $fafba8d3e1bed3b4$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $fafba8d3e1bed3b4$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $fafba8d3e1bed3b4$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $fafba8d3e1bed3b4$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $fafba8d3e1bed3b4$var$PERCENTAGE = $fafba8d3e1bed3b4$var$NUMBER + "%";
function $fafba8d3e1bed3b4$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $fafba8d3e1bed3b4$export$8972dc0e6ad9238f = new RegExp("rgb" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$4e46ac54fc82cf3b = new RegExp("rgba" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$PERCENTAGE));
var $fafba8d3e1bed3b4$export$810b04175080204c = new RegExp("hsla" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fafba8d3e1bed3b4$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fafba8d3e1bed3b4$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $fafba8d3e1bed3b4$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $fafba8d3e1bed3b4$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $fafba8d3e1bed3b4$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($fafba8d3e1bed3b4$var$colors && $fafba8d3e1bed3b4$var$colors[color] !== void 0) return $fafba8d3e1bed3b4$var$colors[color];
    if (match = $fafba8d3e1bed3b4$export$8972dc0e6ad9238f.exec(color)) return ($fafba8d3e1bed3b4$var$parse255(match[1]) << 24 | // r
    $fafba8d3e1bed3b4$var$parse255(match[2]) << 16 | // g
    $fafba8d3e1bed3b4$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$4e46ac54fc82cf3b.exec(color)) return ($fafba8d3e1bed3b4$var$parse255(match[1]) << 24 | // r
    $fafba8d3e1bed3b4$var$parse255(match[2]) << 16 | // g
    $fafba8d3e1bed3b4$var$parse255(match[3]) << 8 | // b
    $fafba8d3e1bed3b4$var$parse1(match[4])) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$8f4a7c0bb78e6ea8.exec(color)) return ($fafba8d3e1bed3b4$var$hslToRgb($fafba8d3e1bed3b4$var$parse360(match[1]), // h
    $fafba8d3e1bed3b4$var$parsePercentage(match[2]), // s
    $fafba8d3e1bed3b4$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$810b04175080204c.exec(color)) return ($fafba8d3e1bed3b4$var$hslToRgb($fafba8d3e1bed3b4$var$parse360(match[1]), // h
    $fafba8d3e1bed3b4$var$parsePercentage(match[2]), // s
    $fafba8d3e1bed3b4$var$parsePercentage(match[3])) | $fafba8d3e1bed3b4$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $fafba8d3e1bed3b4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fafba8d3e1bed3b4$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h + 1 / 3);
    const g = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h);
    const b = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $fafba8d3e1bed3b4$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $fafba8d3e1bed3b4$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $fafba8d3e1bed3b4$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $fafba8d3e1bed3b4$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $fafba8d3e1bed3b4$export$61db176b839af1f(input) {
    let int32Color = $fafba8d3e1bed3b4$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $fafba8d3e1bed3b4$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(range)) return $fafba8d3e1bed3b4$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.str(range.output[0])) return $fafba8d3e1bed3b4$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $fafba8d3e1bed3b4$var$findRange(input, inputRange);
        return $fafba8d3e1bed3b4$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $fafba8d3e1bed3b4$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $fafba8d3e1bed3b4$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $fafba8d3e1bed3b4$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $fafba8d3e1bed3b4$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $fafba8d3e1bed3b4$var$c1 = 1.70158;
var $fafba8d3e1bed3b4$var$c2 = $fafba8d3e1bed3b4$var$c1 * 1.525;
var $fafba8d3e1bed3b4$var$c3 = $fafba8d3e1bed3b4$var$c1 + 1;
var $fafba8d3e1bed3b4$var$c4 = 2 * Math.PI / 3;
var $fafba8d3e1bed3b4$var$c5 = 2 * Math.PI / 4.5;
var $fafba8d3e1bed3b4$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $fafba8d3e1bed3b4$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$fafba8d3e1bed3b4$var$c3 * x * x * x - $fafba8d3e1bed3b4$var$c1 * x * x,
    easeOutBack: (x)=>1 + $fafba8d3e1bed3b4$var$c3 * Math.pow(x - 1, 3) + $fafba8d3e1bed3b4$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($fafba8d3e1bed3b4$var$c2 + 1) * 2 * x - $fafba8d3e1bed3b4$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($fafba8d3e1bed3b4$var$c2 + 1) * (x * 2 - 2) + $fafba8d3e1bed3b4$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $fafba8d3e1bed3b4$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $fafba8d3e1bed3b4$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $fafba8d3e1bed3b4$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $fafba8d3e1bed3b4$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $fafba8d3e1bed3b4$var$bounceOut(1 - x),
    easeOutBounce: $fafba8d3e1bed3b4$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $fafba8d3e1bed3b4$var$bounceOut(1 - 2 * x)) / 2 : (1 + $fafba8d3e1bed3b4$var$bounceOut(2 * x - 1)) / 2,
    steps: $fafba8d3e1bed3b4$var$steps
};
// src/fluids.ts
var $fafba8d3e1bed3b4$var$$get = Symbol.for("FluidValue.get");
var $fafba8d3e1bed3b4$var$$observers = Symbol.for("FluidValue.observers");
var $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$fafba8d3e1bed3b4$var$$get]);
var $fafba8d3e1bed3b4$export$e37b7520edd66839 = (arg)=>arg && arg[$fafba8d3e1bed3b4$var$$get] ? arg[$fafba8d3e1bed3b4$var$$get]() : arg;
var $fafba8d3e1bed3b4$export$133f54e9f7cf1796 = (target)=>target[$fafba8d3e1bed3b4$var$$observers] || null;
function $fafba8d3e1bed3b4$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $fafba8d3e1bed3b4$export$31752c40a5fab62a(target, event) {
    const observers = target[$fafba8d3e1bed3b4$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $fafba8d3e1bed3b4$export$8cbca1207adce0c0(observer2, event);
    });
}
var $fafba8d3e1bed3b4$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $fafba8d3e1bed3b4$export$a3b4618659637aa3(this, get);
    }
};
$fafba8d3e1bed3b4$var$$get, $fafba8d3e1bed3b4$var$$observers;
var $fafba8d3e1bed3b4$export$a3b4618659637aa3 = (target, get)=>$fafba8d3e1bed3b4$var$setHidden(target, $fafba8d3e1bed3b4$var$$get, get);
function $fafba8d3e1bed3b4$export$72d604e3f8d000a5(target, observer2) {
    if (target[$fafba8d3e1bed3b4$var$$get]) {
        let observers = target[$fafba8d3e1bed3b4$var$$observers];
        if (!observers) $fafba8d3e1bed3b4$var$setHidden(target, $fafba8d3e1bed3b4$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $fafba8d3e1bed3b4$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$fafba8d3e1bed3b4$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$fafba8d3e1bed3b4$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $fafba8d3e1bed3b4$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $fafba8d3e1bed3b4$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $fafba8d3e1bed3b4$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $fafba8d3e1bed3b4$var$unitRegex = new RegExp(`(${$fafba8d3e1bed3b4$var$numberRegex.source})(%|[a-z]+)`, "i");
var $fafba8d3e1bed3b4$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $fafba8d3e1bed3b4$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $fafba8d3e1bed3b4$var$variableToRgba = (input)=>{
    const [token, fallback] = $fafba8d3e1bed3b4$var$parseCSSVariable(input);
    if (!token || $fafba8d3e1bed3b4$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $fafba8d3e1bed3b4$var$cssVariableRegex.test(fallback)) return $fafba8d3e1bed3b4$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $fafba8d3e1bed3b4$var$parseCSSVariable = (current)=>{
    const match = $fafba8d3e1bed3b4$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $fafba8d3e1bed3b4$var$namedColorRegex;
var $fafba8d3e1bed3b4$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $fafba8d3e1bed3b4$export$4759a013d387347a = (config)=>{
    if (!$fafba8d3e1bed3b4$var$namedColorRegex) $fafba8d3e1bed3b4$var$namedColorRegex = $fafba8d3e1bed3b4$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($fafba8d3e1bed3b4$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $fafba8d3e1bed3b4$export$e37b7520edd66839(value).replace($fafba8d3e1bed3b4$var$cssVariableRegex, $fafba8d3e1bed3b4$var$variableToRgba).replace($fafba8d3e1bed3b4$var$colorRegex, $fafba8d3e1bed3b4$export$61db176b839af1f).replace($fafba8d3e1bed3b4$var$namedColorRegex, $fafba8d3e1bed3b4$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($fafba8d3e1bed3b4$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$fafba8d3e1bed3b4$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$fafba8d3e1bed3b4$var$unitRegex.test(output[0]) && output.find((value)=>$fafba8d3e1bed3b4$var$unitRegex.test(value))?.replace($fafba8d3e1bed3b4$var$numberRegex, "");
        let i = 0;
        return output[0].replace($fafba8d3e1bed3b4$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($fafba8d3e1bed3b4$var$rgbaRegex, $fafba8d3e1bed3b4$var$rgbaRound);
    };
};
// src/deprecations.ts
var $fafba8d3e1bed3b4$export$82e9f45cca5ba907 = "react-spring: ";
var $fafba8d3e1bed3b4$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $fafba8d3e1bed3b4$var$warnInterpolate = $fafba8d3e1bed3b4$export$d2de3aaeafa91619(console.warn);
function $fafba8d3e1bed3b4$export$2abfcde8ae218ba8() {
    $fafba8d3e1bed3b4$var$warnInterpolate(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $fafba8d3e1bed3b4$var$warnDirectCall = $fafba8d3e1bed3b4$export$d2de3aaeafa91619(console.warn);
function $fafba8d3e1bed3b4$export$d99d974913ad3b12() {
    $fafba8d3e1bed3b4$var$warnDirectCall(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $fafba8d3e1bed3b4$export$75bed621f62abfa9(value) {
    return $fafba8d3e1bed3b4$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$fafba8d3e1bed3b4$export$48d7c418edadb60c() && $fafba8d3e1bed3b4$var$cssVariableRegex.test(value) || value in ($fafba8d3e1bed3b4$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $fafba8d3e1bed3b4$var$observer;
var $fafba8d3e1bed3b4$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $fafba8d3e1bed3b4$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $fafba8d3e1bed3b4$var$resizeElement(handler, target) {
    if (!$fafba8d3e1bed3b4$var$observer) {
        if (typeof ResizeObserver !== "undefined") $fafba8d3e1bed3b4$var$observer = new ResizeObserver($fafba8d3e1bed3b4$var$handleObservation);
    }
    let elementHandlers = $fafba8d3e1bed3b4$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $fafba8d3e1bed3b4$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($fafba8d3e1bed3b4$var$observer) $fafba8d3e1bed3b4$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $fafba8d3e1bed3b4$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $fafba8d3e1bed3b4$var$observer) $fafba8d3e1bed3b4$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $fafba8d3e1bed3b4$var$listeners = /* @__PURE__ */ new Set();
var $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler;
var $fafba8d3e1bed3b4$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $fafba8d3e1bed3b4$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $fafba8d3e1bed3b4$var$resizeWindow = (callback)=>{
    $fafba8d3e1bed3b4$var$listeners.add(callback);
    if (!$fafba8d3e1bed3b4$var$cleanupWindowResizeHandler) $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler = $fafba8d3e1bed3b4$var$createResizeHandler();
    return ()=>{
        $fafba8d3e1bed3b4$var$listeners.delete(callback);
        if (!$fafba8d3e1bed3b4$var$listeners.size && $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler) {
            $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler();
            $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $fafba8d3e1bed3b4$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $fafba8d3e1bed3b4$var$resizeWindow(callback);
    else return $fafba8d3e1bed3b4$var$resizeElement(callback, container);
};
// src/progress.ts
var $fafba8d3e1bed3b4$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $fafba8d3e1bed3b4$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $fafba8d3e1bed3b4$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $fafba8d3e1bed3b4$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $fafba8d3e1bed3b4$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $fafba8d3e1bed3b4$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $fafba8d3e1bed3b4$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $fafba8d3e1bed3b4$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $fafba8d3e1bed3b4$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $fafba8d3e1bed3b4$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$fafba8d3e1bed3b4$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $fafba8d3e1bed3b4$var$scrollListeners.set(container, listener);
        const target = $fafba8d3e1bed3b4$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $fafba8d3e1bed3b4$var$resizeListeners.set(container, $fafba8d3e1bed3b4$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $fafba8d3e1bed3b4$var$scrollListeners.get(container);
    (0, $lwA3x.raf)(animateScroll);
    return ()=>{
        (0, $lwA3x.raf).cancel(animateScroll);
        const containerHandlers2 = $fafba8d3e1bed3b4$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $fafba8d3e1bed3b4$var$scrollListeners.get(container);
        $fafba8d3e1bed3b4$var$scrollListeners.delete(container);
        if (listener) {
            $fafba8d3e1bed3b4$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $fafba8d3e1bed3b4$var$resizeListeners.get(container)?.();
        }
    };
};
function $fafba8d3e1bed3b4$export$fe4300aa8eebea86(init) {
    const ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $fafba8d3e1bed3b4$export$700979bc83e7db82 = $fafba8d3e1bed3b4$export$48d7c418edadb60c() ? (0, $exYeM.useEffect) : (0, $exYeM.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $fafba8d3e1bed3b4$var$useIsMounted = ()=>{
    const isMounted = (0, $exYeM.useRef)(false);
    $fafba8d3e1bed3b4$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $fafba8d3e1bed3b4$export$91db9bc4f8ac944a() {
    const update = (0, $exYeM.useState)()[1];
    const isMounted = $fafba8d3e1bed3b4$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $fafba8d3e1bed3b4$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $exYeM.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $exYeM.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $fafba8d3e1bed3b4$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $exYeM.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $fafba8d3e1bed3b4$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $fafba8d3e1bed3b4$export$392544347a18b6ea = (effect)=>(0, $exYeM.useEffect)(effect, $fafba8d3e1bed3b4$var$emptyDeps);
var $fafba8d3e1bed3b4$var$emptyDeps = [];
function $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $fafba8d3e1bed3b4$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $exYeM.useState)(null);
    $fafba8d3e1bed3b4$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $fafba8d3e1bed3b4$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};

});
parcelRegister("lwA3x", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $fab88e22ed4c5ac7$export$27f233d61a9e2fa4; });
// src/index.ts
var $fab88e22ed4c5ac7$var$updateQueue = $fab88e22ed4c5ac7$var$makeQueue();
var $fab88e22ed4c5ac7$export$27f233d61a9e2fa4 = (fn)=>$fab88e22ed4c5ac7$var$schedule(fn, $fab88e22ed4c5ac7$var$updateQueue);
var $fab88e22ed4c5ac7$var$writeQueue = $fab88e22ed4c5ac7$var$makeQueue();
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.write = (fn)=>$fab88e22ed4c5ac7$var$schedule(fn, $fab88e22ed4c5ac7$var$writeQueue);
var $fab88e22ed4c5ac7$var$onStartQueue = $fab88e22ed4c5ac7$var$makeQueue();
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.onStart = (fn)=>$fab88e22ed4c5ac7$var$schedule(fn, $fab88e22ed4c5ac7$var$onStartQueue);
var $fab88e22ed4c5ac7$var$onFrameQueue = $fab88e22ed4c5ac7$var$makeQueue();
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.onFrame = (fn)=>$fab88e22ed4c5ac7$var$schedule(fn, $fab88e22ed4c5ac7$var$onFrameQueue);
var $fab88e22ed4c5ac7$var$onFinishQueue = $fab88e22ed4c5ac7$var$makeQueue();
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.onFinish = (fn)=>$fab88e22ed4c5ac7$var$schedule(fn, $fab88e22ed4c5ac7$var$onFinishQueue);
var $fab88e22ed4c5ac7$var$timeouts = [];
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $fab88e22ed4c5ac7$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $fab88e22ed4c5ac7$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $fab88e22ed4c5ac7$var$timeouts.splice(i, 1);
        $fab88e22ed4c5ac7$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $fab88e22ed4c5ac7$var$timeouts.splice($fab88e22ed4c5ac7$var$findTimeout(time), 0, timeout);
    $fab88e22ed4c5ac7$var$pendingCount += 1;
    $fab88e22ed4c5ac7$var$start();
    return timeout;
};
var $fab88e22ed4c5ac7$var$findTimeout = (time)=>~(~$fab88e22ed4c5ac7$var$timeouts.findIndex((t)=>t.time > time) || ~$fab88e22ed4c5ac7$var$timeouts.length);
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $fab88e22ed4c5ac7$var$onStartQueue.delete(fn);
    $fab88e22ed4c5ac7$var$onFrameQueue.delete(fn);
    $fab88e22ed4c5ac7$var$onFinishQueue.delete(fn);
    $fab88e22ed4c5ac7$var$updateQueue.delete(fn);
    $fab88e22ed4c5ac7$var$writeQueue.delete(fn);
};
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.sync = (fn)=>{
    $fab88e22ed4c5ac7$var$sync = true;
    $fab88e22ed4c5ac7$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $fab88e22ed4c5ac7$var$sync = false;
};
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $fab88e22ed4c5ac7$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $fab88e22ed4c5ac7$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $fab88e22ed4c5ac7$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.use = (impl)=>$fab88e22ed4c5ac7$var$nativeRaf = impl;
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.catch = console.error;
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.frameLoop = "always";
$fab88e22ed4c5ac7$export$27f233d61a9e2fa4.advance = ()=>{
    if ($fab88e22ed4c5ac7$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $fab88e22ed4c5ac7$var$update();
};
var $fab88e22ed4c5ac7$var$ts = -1;
var $fab88e22ed4c5ac7$var$pendingCount = 0;
var $fab88e22ed4c5ac7$var$sync = false;
function $fab88e22ed4c5ac7$var$schedule(fn, queue) {
    if ($fab88e22ed4c5ac7$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $fab88e22ed4c5ac7$var$start();
    }
}
function $fab88e22ed4c5ac7$var$start() {
    if ($fab88e22ed4c5ac7$var$ts < 0) {
        $fab88e22ed4c5ac7$var$ts = 0;
        if ($fab88e22ed4c5ac7$export$27f233d61a9e2fa4.frameLoop !== "demand") $fab88e22ed4c5ac7$var$nativeRaf($fab88e22ed4c5ac7$var$loop);
    }
}
function $fab88e22ed4c5ac7$var$stop() {
    $fab88e22ed4c5ac7$var$ts = -1;
}
function $fab88e22ed4c5ac7$var$loop() {
    if (~$fab88e22ed4c5ac7$var$ts) {
        $fab88e22ed4c5ac7$var$nativeRaf($fab88e22ed4c5ac7$var$loop);
        $fab88e22ed4c5ac7$export$27f233d61a9e2fa4.batchedUpdates($fab88e22ed4c5ac7$var$update);
    }
}
function $fab88e22ed4c5ac7$var$update() {
    const prevTs = $fab88e22ed4c5ac7$var$ts;
    $fab88e22ed4c5ac7$var$ts = $fab88e22ed4c5ac7$export$27f233d61a9e2fa4.now();
    const count = $fab88e22ed4c5ac7$var$findTimeout($fab88e22ed4c5ac7$var$ts);
    if (count) {
        $fab88e22ed4c5ac7$var$eachSafely($fab88e22ed4c5ac7$var$timeouts.splice(0, count), (t)=>t.handler());
        $fab88e22ed4c5ac7$var$pendingCount -= count;
    }
    if (!$fab88e22ed4c5ac7$var$pendingCount) {
        $fab88e22ed4c5ac7$var$stop();
        return;
    }
    $fab88e22ed4c5ac7$var$onStartQueue.flush();
    $fab88e22ed4c5ac7$var$updateQueue.flush(prevTs ? Math.min(64, $fab88e22ed4c5ac7$var$ts - prevTs) : 16.667);
    $fab88e22ed4c5ac7$var$onFrameQueue.flush();
    $fab88e22ed4c5ac7$var$writeQueue.flush();
    $fab88e22ed4c5ac7$var$onFinishQueue.flush();
}
function $fab88e22ed4c5ac7$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $fab88e22ed4c5ac7$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $fab88e22ed4c5ac7$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $fab88e22ed4c5ac7$var$pendingCount -= current.size;
                $fab88e22ed4c5ac7$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $fab88e22ed4c5ac7$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $fab88e22ed4c5ac7$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $fab88e22ed4c5ac7$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $fab88e22ed4c5ac7$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $fab88e22ed4c5ac7$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $fab88e22ed4c5ac7$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $fab88e22ed4c5ac7$var$ts = -1;
        $fab88e22ed4c5ac7$var$timeouts = [];
        $fab88e22ed4c5ac7$var$onStartQueue = $fab88e22ed4c5ac7$var$makeQueue();
        $fab88e22ed4c5ac7$var$updateQueue = $fab88e22ed4c5ac7$var$makeQueue();
        $fab88e22ed4c5ac7$var$onFrameQueue = $fab88e22ed4c5ac7$var$makeQueue();
        $fab88e22ed4c5ac7$var$writeQueue = $fab88e22ed4c5ac7$var$makeQueue();
        $fab88e22ed4c5ac7$var$onFinishQueue = $fab88e22ed4c5ac7$var$makeQueue();
        $fab88e22ed4c5ac7$var$pendingCount = 0;
    }
};

});


parcelRegister("aDLJU", function(module, exports) {

$parcel$export(module.exports, "getAnimated", function () { return $7bf293f4fe511ca6$export$6b63995194a3a9e4; });
$parcel$export(module.exports, "setAnimated", function () { return $7bf293f4fe511ca6$export$b553cb5b22b81b04; });
$parcel$export(module.exports, "getPayload", function () { return $7bf293f4fe511ca6$export$ccab2b64c5d440; });
$parcel$export(module.exports, "AnimatedValue", function () { return $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5; });
$parcel$export(module.exports, "AnimatedString", function () { return $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93; });
$parcel$export(module.exports, "AnimatedObject", function () { return $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4; });
$parcel$export(module.exports, "getAnimatedType", function () { return $7bf293f4fe511ca6$export$e6b77ddbe47b132e; });
$parcel$export(module.exports, "createHost", function () { return $7bf293f4fe511ca6$export$4ee5c78f6dcbcef; });
// src/Animated.ts

var $lxYz2 = parcelRequire("lxYz2");
var $lwA3x = parcelRequire("lwA3x");

var $exYeM = parcelRequire("exYeM");
var $7bf293f4fe511ca6$var$$node = Symbol.for("Animated:node");
var $7bf293f4fe511ca6$export$3df5e165e801a70f = (value)=>!!value && value[$7bf293f4fe511ca6$var$$node] === value;
var $7bf293f4fe511ca6$export$6b63995194a3a9e4 = (owner)=>owner && owner[$7bf293f4fe511ca6$var$$node];
var $7bf293f4fe511ca6$export$b553cb5b22b81b04 = (owner, node)=>(0, $lxYz2.defineHidden)(owner, $7bf293f4fe511ca6$var$$node, node);
var $7bf293f4fe511ca6$export$ccab2b64c5d440 = (owner)=>owner && owner[$7bf293f4fe511ca6$var$$node] && owner[$7bf293f4fe511ca6$var$$node].getPayload();
var $7bf293f4fe511ca6$export$31627395a3b18e54 = class {
    constructor(){
        $7bf293f4fe511ca6$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5 = class extends $7bf293f4fe511ca6$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $lxYz2.is).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $lxYz2.is).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $lxYz2.is).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 = class extends $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $lxYz2.createInterpolator)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $lxYz2.is).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $lxYz2.createInterpolator)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $7bf293f4fe511ca6$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4 = class extends $7bf293f4fe511ca6$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $lxYz2.eachProp)(this.source, (source, key)=>{
            if ($7bf293f4fe511ca6$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $lxYz2.hasFluidValue)(source)) values[key] = (0, $lxYz2.getFluidValue)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $lxYz2.each)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $lxYz2.eachProp)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($7bf293f4fe511ca6$var$TreeContext.dependencies && (0, $lxYz2.hasFluidValue)(source)) $7bf293f4fe511ca6$var$TreeContext.dependencies.add(source);
        const payload = $7bf293f4fe511ca6$export$ccab2b64c5d440(source);
        if (payload) (0, $lxYz2.each)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $7bf293f4fe511ca6$export$ede394683406942d = class extends $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $7bf293f4fe511ca6$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($7bf293f4fe511ca6$var$makeAnimated));
        return true;
    }
};
function $7bf293f4fe511ca6$var$makeAnimated(value) {
    const nodeType = (0, $lxYz2.isAnimatedString)(value) ? $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 : $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $7bf293f4fe511ca6$export$e6b77ddbe47b132e(value) {
    const parentNode = $7bf293f4fe511ca6$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $lxYz2.is).arr(value) ? $7bf293f4fe511ca6$export$ede394683406942d : (0, $lxYz2.isAnimatedString)(value) ? $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 : $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5;
}
var $7bf293f4fe511ca6$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $lxYz2.is).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $exYeM.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $exYeM.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $exYeM.useCallback)((value)=>{
            instanceRef.current = $7bf293f4fe511ca6$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $7bf293f4fe511ca6$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $lxYz2.useForceUpdate)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $7bf293f4fe511ca6$var$PropsObserver(callback, deps);
        const observerRef = (0, $exYeM.useRef)();
        (0, $lxYz2.useIsomorphicLayoutEffect)(()=>{
            observerRef.current = observer;
            (0, $lxYz2.each)(deps, (dep)=>(0, $lxYz2.addFluidObserver)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $lxYz2.each)(observerRef.current.deps, (dep)=>(0, $lxYz2.removeFluidObserver)(dep, observerRef.current));
                    (0, $lwA3x.raf).cancel(observerRef.current.update);
                }
            };
        });
        (0, $exYeM.useEffect)(callback, []);
        (0, $lxYz2.useOnce)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $lxYz2.each)(observer2.deps, (dep)=>(0, $lxYz2.removeFluidObserver)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $exYeM.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $7bf293f4fe511ca6$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $lwA3x.raf).write(this.update);
    }
};
function $7bf293f4fe511ca6$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $7bf293f4fe511ca6$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4(props);
    $7bf293f4fe511ca6$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $7bf293f4fe511ca6$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $lxYz2.is).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $7bf293f4fe511ca6$var$cacheKey = Symbol.for("AnimatedComponent");
var $7bf293f4fe511ca6$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $7bf293f4fe511ca6$var$getDisplayName(Component) || "Anonymous";
        if ((0, $lxYz2.is).str(Component)) Component = animated[Component] || (animated[Component] = $7bf293f4fe511ca6$var$withAnimated(Component, hostConfig));
        else Component = Component[$7bf293f4fe511ca6$var$cacheKey] || (Component[$7bf293f4fe511ca6$var$cacheKey] = $7bf293f4fe511ca6$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $lxYz2.eachProp)(components, (Component, key)=>{
        if ((0, $lxYz2.is).arr(components)) key = $7bf293f4fe511ca6$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $7bf293f4fe511ca6$var$getDisplayName = (arg)=>(0, $lxYz2.is).str(arg) ? arg : arg && (0, $lxYz2.is).str(arg.displayName) ? arg.displayName : (0, $lxYz2.is).fun(arg) && arg.name || null;

});

parcelRegister("kL38t", function(module, exports) {
// src/utils.ts
var $f1caa117d6d189d7$export$b24b633b1364b94b = class {
};

});


parcelRegister("d2lNW", function(module, exports) {
'use strict';
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("h8vP0"));

});


parcelRegister("dR62Q", function(module, exports) {

$parcel$export(module.exports, "AddOutline", function () { return $e26bc463fe4967d7$export$153c75dc7c5411ee; });
$parcel$export(module.exports, "AppsSharp", function () { return $e26bc463fe4967d7$export$7aad6ca0460ebff4; });
$parcel$export(module.exports, "CaretDownOutline", function () { return $e26bc463fe4967d7$export$1c2a14ef1dd3961e; });
$parcel$export(module.exports, "CaretUpOutline", function () { return $e26bc463fe4967d7$export$dc3c92c813e5ee59; });
$parcel$export(module.exports, "CaretUpSharpCropped", function () { return $e26bc463fe4967d7$export$baf835abbfe63f23; });
$parcel$export(module.exports, "CheckMarkSharp", function () { return $e26bc463fe4967d7$export$b8eb23a8127db75b; });
$parcel$export(module.exports, "ChevronForwardFilled", function () { return $e26bc463fe4967d7$export$a5dd0a93f2774df5; });
$parcel$export(module.exports, "CircleOffOutline", function () { return $e26bc463fe4967d7$export$8d5c269d0c171f30; });
$parcel$export(module.exports, "CloseFilled", function () { return $e26bc463fe4967d7$export$4300487bd08a483b; });
$parcel$export(module.exports, "DiceFilled", function () { return $e26bc463fe4967d7$export$74daf8fe3aed2eea; });
$parcel$export(module.exports, "HourglassOutline", function () { return $e26bc463fe4967d7$export$7654f4060bbdae0a; });
$parcel$export(module.exports, "InformationCircleOutline", function () { return $e26bc463fe4967d7$export$91af38ab072f1384; });
$parcel$export(module.exports, "LanguageOutline", function () { return $e26bc463fe4967d7$export$17b5d4fa44d8b948; });
$parcel$export(module.exports, "OpenInNew", function () { return $e26bc463fe4967d7$export$b7339c1e478ebfca; });
$parcel$export(module.exports, "PeopleSharp", function () { return $e26bc463fe4967d7$export$7895ee831b11a2f; });
$parcel$export(module.exports, "PersonFilled", function () { return $e26bc463fe4967d7$export$482a8d6d84213ca8; });
$parcel$export(module.exports, "RefreshOutline", function () { return $e26bc463fe4967d7$export$19549bcb22a57d52; });
$parcel$export(module.exports, "RemoveOutline", function () { return $e26bc463fe4967d7$export$93a54c445d204d44; });
$parcel$export(module.exports, "SearchOutline", function () { return $e26bc463fe4967d7$export$b77c0fd6d1c65b0a; });
$parcel$export(module.exports, "SparklesSharp", function () { return $e26bc463fe4967d7$export$beddf0d47ff121db; });
$parcel$export(module.exports, "SparkSolid", function () { return $e26bc463fe4967d7$export$af9f487d50a84b8a; });
$parcel$export(module.exports, "StarOutline", function () { return $e26bc463fe4967d7$export$ac31625c0615bb80; });
$parcel$export(module.exports, "StarFilled", function () { return $e26bc463fe4967d7$export$5c83eb0ad220f681; });
$parcel$export(module.exports, "StatsChartSharp", function () { return $e26bc463fe4967d7$export$2f92b5a5eafc51a5; });
$parcel$export(module.exports, "TimeOutline", function () { return $e26bc463fe4967d7$export$804ff2f92a91d6bd; });

var $aSiaI = parcelRequire("aSiaI");

var $ahEiN = parcelRequire("ahEiN");
const $e26bc463fe4967d7$export$153c75dc7c5411ee = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32",
            d: "M256 112v288M400 256H112"
        })
    });
const $e26bc463fe4967d7$export$7aad6ca0460ebff4 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "48",
                y: "48",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "200",
                y: "48",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "352",
                y: "48",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "48",
                y: "200",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "200",
                y: "200",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "352",
                y: "200",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "48",
                y: "352",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "200",
                y: "352",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "352",
                y: "352",
                width: "112",
                height: "112",
                rx: "8",
                ry: "8",
                fill: "currentColor"
            })
        ]
    });
const $e26bc463fe4967d7$export$6f417fd7cd228c34 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M58.79 439.13A16 16 0 0148 424c0-73.1 14.68-131.56 43.65-173.77 35-51 90.21-78.46 164.35-81.87V88a16 16 0 0127.05-11.57l176 168a16 16 0 010 23.14l-176 168A16 16 0 01256 424v-79.77c-45 1.36-79 8.65-106.07 22.64-29.25 15.12-50.46 37.71-73.32 67a16 16 0 01-17.82 5.28z"
        })
    });
const $e26bc463fe4967d7$export$1c2a14ef1dd3961e = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$dc3c92c813e5ee59 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$8c0dc4ceaba1bc68 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M448 368L256 144 64 368h384z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$baf835abbfe63f23 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 384 224",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
            transform: "translate(-64,-144)",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M448 368L256 144 64 368h384z",
                fill: "currentColor"
            })
        })
    });
const $e26bc463fe4967d7$export$b8eb23a8127db75b = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "44",
            d: "M416 128L192 384l-96-96"
        })
    });
const $e26bc463fe4967d7$export$a5dd0a93f2774df5 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48",
            d: "M184 112l144 144-144 144"
        })
    });
const $e26bc463fe4967d7$export$8d5c269d0c171f30 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M22.11 21.46L2.39 1.73L1.11 3L4.06 5.95C2.78 7.63 2 9.72 2 12C2 17.5 6.5 22 12 22C14.28 22 16.37 21.23 18.05 19.94L20.84 22.73L22.11 21.46M12 20C7.58 20 4 16.42 4 12C4 10.27 4.56 8.68 5.5 7.38L16.62 18.5C15.32 19.45 13.73 20 12 20M8.17 4.97L6.72 3.5C8.25 2.56 10.06 2 12 2C17.5 2 22 6.5 22 12C22 13.94 21.44 15.75 20.5 17.28L19.03 15.83C19.65 14.69 20 13.39 20 12C20 7.58 16.42 4 12 4C10.61 4 9.31 4.35 8.17 4.97Z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$4300487bd08a483b = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$4127fbdca3a71de6 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M121.72 32a4 4 0 00-3.72 5.56l2.3 5.43 40.7 94.9a4 4 0 006.88.82L243 38.4a4 4 0 00-3.2-6.4zM419.93 58.06l-41.28 96.37a4 4 0 003.68 5.57h101a4 4 0 003.4-6.11L427 57.53a4 4 0 00-7.07.53zM85 57.57l-59.71 96.32a4 4 0 003.4 6.11h101a4 4 0 003.67-5.58L92 58.1a4 4 0 00-7-.53zM393.27 32H267.82a1.94 1.94 0 00-1.56 3.11l79.92 106.46a1.94 1.94 0 003.34-.4L391.6 43l3.4-8.34a1.92 1.92 0 00-1.7-2.66zM239 448l-89.43-253.49A3.78 3.78 0 00146 192H25.7a3.72 3.72 0 00-2.95 6l216 279.81a5.06 5.06 0 006.39 1.37 5 5 0 002.39-6.08zM486.3 192H366a3.75 3.75 0 00-3.54 2.51l-98.2 278.16a5.21 5.21 0 002.42 6.31 5.22 5.22 0 006.61-1.39L489.25 198a3.72 3.72 0 00-2.95-6zM259.2 78.93l56 74.67a4 4 0 01-3.2 6.4H200a4 4 0 01-3.2-6.4l56-74.67a4 4 0 016.4 0zm-7 310.31l-67.7-191.91a4 4 0 013.77-5.33h135.46a4 4 0 013.77 5.33l-67.73 191.91a4 4 0 01-7.54 0z"
        })
    });
const $e26bc463fe4967d7$export$74daf8fe3aed2eea = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M440.88 129.37L288.16 40.62a64.14 64.14 0 00-64.33 0L71.12 129.37a4 4 0 000 6.9L254 243.85a4 4 0 004.06 0L440.9 136.27a4 4 0 00-.02-6.9zM256 152c-13.25 0-24-7.16-24-16s10.75-16 24-16 24 7.16 24 16-10.75 16-24 16zM238 270.81L54 163.48a4 4 0 00-6 3.46v173.92a48 48 0 0023.84 41.39L234 479.48a4 4 0 006-3.46V274.27a4 4 0 00-2-3.46zM96 368c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96-32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zM458 163.51L274 271.56a4 4 0 00-2 3.45V476a4 4 0 006 3.46l162.15-97.23A48 48 0 00464 340.86V167a4 4 0 00-6-3.49zM320 424c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm96 32c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24zm0-88c-8.84 0-16-10.75-16-24s7.16-24 16-24 16 10.75 16 24-7.16 24-16 24z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$8f597f99fda68ae5 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M69 153.99l187 110 187-110M256 463.99v-200"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "256",
                cy: "152",
                rx: "24",
                ry: "16"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "208",
                cy: "296",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "112",
                cy: "328",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "304",
                cy: "296",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "400",
                cy: "240",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "304",
                cy: "384",
                rx: "16",
                ry: "24"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "400",
                cy: "328",
                rx: "16",
                ry: "24"
            })
        ]
    });
const $e26bc463fe4967d7$export$96a6722341cc5ba4 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M256 48c-58.07 0-112.67 93.13-112.67 208S197.93 464 256 464s112.67-93.13 112.67-208S314.07 48 256 48z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34M394.67 394.67c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M256 48v416M464 256H48"
            })
        ]
    });
const $e26bc463fe4967d7$export$5f2da371755202ed = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M277.42 247a24.68 24.68 0 00-4.08-5.47L255 223.44a21.63 21.63 0 00-6.56-4.57 20.93 20.93 0 00-23.28 4.27c-6.36 6.26-18 17.68-39 38.43C146 301.3 71.43 367.89 37.71 396.29a16 16 0 00-1.09 23.54l39 39.43a16.13 16.13 0 0023.67-.89c29.24-34.37 96.3-109 136-148.23 20.39-20.06 31.82-31.58 38.29-37.94a21.76 21.76 0 003.84-25.2zM478.43 201l-34.31-34a5.44 5.44 0 00-4-1.59 5.59 5.59 0 00-4 1.59h0a11.41 11.41 0 01-9.55 3.27c-4.48-.49-9.25-1.88-12.33-4.86-7-6.86 1.09-20.36-5.07-29a242.88 242.88 0 00-23.08-26.72c-7.06-7-34.81-33.47-81.55-52.53a123.79 123.79 0 00-47-9.24c-26.35 0-46.61 11.76-54 18.51-5.88 5.32-12 13.77-12 13.77a91.29 91.29 0 0110.81-3.2 79.53 79.53 0 0123.28-1.49C241.19 76.8 259.94 84.1 270 92c16.21 13 23.18 30.39 24.27 52.83.8 16.69-15.23 37.76-30.44 54.94a7.85 7.85 0 00.4 10.83l21.24 21.23a8 8 0 0011.14.1c13.93-13.51 31.09-28.47 40.82-34.46s17.58-7.68 21.35-8.09a35.71 35.71 0 0121.3 4.62 13.65 13.65 0 013.08 2.38c6.46 6.56 6.07 17.28-.5 23.74l-2 1.89a5.5 5.5 0 000 7.84l34.31 34a5.5 5.5 0 004 1.58 5.65 5.65 0 004-1.58L478.43 209a5.82 5.82 0 000-8z",
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32"
        })
    });
const $e26bc463fe4967d7$export$7654f4060bbdae0a = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M145.61 464h220.78c19.8 0 35.55-16.29 33.42-35.06C386.06 308 304 310 304 256s83.11-51 95.8-172.94c2-18.78-13.61-35.06-33.41-35.06H145.61c-19.8 0-35.37 16.28-33.41 35.06C124.89 205 208 201 208 256s-82.06 52-95.8 172.94c-2.14 18.77 13.61 35.06 33.41 35.06z",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M343.3 432H169.13c-15.6 0-20-18-9.06-29.16C186.55 376 240 356.78 240 326V224c0-19.85-38-35-61.51-67.2-3.88-5.31-3.49-12.8 6.37-12.8h142.73c8.41 0 10.23 7.43 6.4 12.75C310.82 189 272 204.05 272 224v102c0 30.53 55.71 47 80.4 76.87 9.95 12.04 6.47 29.13-9.1 29.13z",
                fill: (0, $ahEiN.secondaryColor)
            })
        ]
    });
const $e26bc463fe4967d7$export$91af38ab072f1384 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        fill: "currentColor",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M220 220h32v116"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M208 340h88"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M248 130a26 26 0 1026 26 26 26 0 00-26-26z",
                fill: "currentColor"
            })
        ]
    });
const $e26bc463fe4967d7$export$17b5d4fa44d8b948 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M48 112h288M192 64v48M272 448l96-224 96 224M301.5 384h133M281.3 112S257 206 199 277 80 384 80 384"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M256 336s-35-27-72-75-56-85-56-85",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            })
        ]
    });
const $e26bc463fe4967d7$export$4463b97b803ca5c0 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M464 66.52A50 50 0 00414.12 17L97.64 16A49.65 49.65 0 0048 65.52V392c0 27.3 22.28 48 49.64 48H368l-13-44 109 100zM324.65 329.81s-8.72-10.39-16-19.32C340.39 301.55 352.5 282 352.5 282a139 139 0 01-27.85 14.25 173.31 173.31 0 01-35.11 10.39 170.05 170.05 0 01-62.72-.24 184.45 184.45 0 01-35.59-10.4 141.46 141.46 0 01-17.68-8.21c-.73-.48-1.45-.72-2.18-1.21-.49-.24-.73-.48-1-.48-4.36-2.42-6.78-4.11-6.78-4.11s11.62 19.09 42.38 28.26c-7.27 9.18-16.23 19.81-16.23 19.81-53.51-1.69-73.85-36.47-73.85-36.47 0-77.06 34.87-139.62 34.87-139.62 34.87-25.85 67.8-25.12 67.8-25.12l2.42 2.9c-43.59 12.32-63.44 31.4-63.44 31.4s5.32-2.9 14.28-6.77c25.91-11.35 46.5-14.25 55-15.21a24 24 0 014.12-.49 205.62 205.62 0 0148.91-.48 201.62 201.62 0 0172.89 22.95s-19.13-18.15-60.3-30.45l3.39-3.86s33.17-.73 67.81 25.16c0 0 34.87 62.56 34.87 139.62 0-.28-20.35 34.5-73.86 36.19z"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M212.05 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.8 0 24.7-11.83 24.7-26.57.25-14.76-10.9-26.57-24.7-26.57zM300.43 218c-13.8 0-24.7 11.84-24.7 26.57s11.14 26.57 24.7 26.57c13.81 0 24.7-11.83 24.7-26.57S314 218 300.43 218z"
            })
        ]
    });
const $e26bc463fe4967d7$export$11137d1629e065ab = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M256 480a80.09 80.09 0 0073.3-48H182.7a80.09 80.09 0 0073.3 48zM400 288v-60.53C400 157 372.64 95.61 304 80l-8-48h-80l-8 48c-68.88 15.61-96 76.76-96 147.47V288l-48 64v48h384v-48z"
        })
    });
const $e26bc463fe4967d7$export$b7339c1e478ebfca = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            fill: "currentColor",
            d: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
        })
    });
const $e26bc463fe4967d7$export$7895ee831b11a2f = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                cx: "152",
                cy: "184",
                r: "72",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                cx: "340",
                cy: "168",
                r: "88",
                fill: "currentColor"
            })
        ]
    });
const $e26bc463fe4967d7$export$482a8d6d84213ca8 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6zM432 480H80a31 31 0 01-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75 1.94 10.73-.68 21.34-7.18 29.11A31 31 0 01432 480z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$19549bcb22a57d52 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M320 146s24.36-12-64-12a160 160 0 10160 160",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M256 58l80 80-80 80"
            })
        ]
    });
const $e26bc463fe4967d7$export$93a54c445d204d44 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "32",
            d: "M400 256H112"
        })
    });
const $e26bc463fe4967d7$export$b77c0fd6d1c65b0a = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M338.29 338.29L448 448"
            })
        ]
    });
const $e26bc463fe4967d7$export$beddf0d47ff121db = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M208 512l-52.38-139.62L16 320l139.62-52.38L208 128l52.38 139.62L400 320l-139.62 52.38zM88 176l-23.57-64.43L0 88l64.43-23.57L88 0l23.57 64.43L176 88l-64.43 23.57zM400 256l-31.11-80.89L288 144l80.89-31.11L400 32l31.11 80.89L512 144l-80.89 31.11z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$af9f487d50a84b8a = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "2 2 20 20",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M3 12C9.26752 12 12 9.36306 12 3C12 9.36306 14.7134 12 21 12C14.7134 12 12 14.7134 12 21C12 14.7134 9.26752 12 3 12Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinejoin: "round"
        })
    });
const $e26bc463fe4967d7$export$ac31625c0615bb80 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z",
            fill: "none",
            stroke: "currentColor",
            strokeLinejoin: "round",
            strokeWidth: "32"
        })
    });
const $e26bc463fe4967d7$export$5c83eb0ad220f681 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$2f92b5a5eafc51a5 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M128 496H48V304h80zM352 496h-80V208h80zM464 496h-80V96h80zM240 496h-80V16h80z",
            fill: "currentColor"
        })
    });
const $e26bc463fe4967d7$export$9ec12bcab4b99393 = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M2 4.31092C2 4.31092 6.22172 7.55158 9.88185 4.18414C13.542 0.8167 15.3333 2.34686 15.3333 2.34686L12.2222 12.6667H11.4379C11.4379 12.6667 12.1961 10.8619 7.52891 10.8619C2.39216 10.8619 2 4.31092 2 4.31092Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M16.2223 2.44444H18.0001L13.5556 18H11.7778L16.2223 2.44444Z",
                fill: "currentColor"
            })
        ]
    });
const $e26bc463fe4967d7$export$804ff2f92a91d6bd = (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M256 128v144h96"
            })
        ]
    });
const $e26bc463fe4967d7$export$1166f58a2eef63af = (props)=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M368 112H144C64.6 112 0 176.6 0 256s64.6 144 144 144h224c79.4 0 144-64.6 144-144s-64.6-144-144-144zm0 256a112 112 0 11112-112 112.12 112.12 0 01-112 112z",
            fill: "currentColor"
        })
    });

});
parcelRegister("ahEiN", function(module, exports) {

$parcel$export(module.exports, "secondaryColor", function () { return $4cc64468fb99c817$export$8195e3f84f31a7bf; });
const $4cc64468fb99c817$export$8195e3f84f31a7bf = 'var(--secondary-color, currentColor)';

});


parcelRegister("9Zft8", function(module, exports) {

$parcel$export(module.exports, "ToasterId", function () { return $f34eec40cf304025$export$4786645933ae8b1e; });

var $aAB6i = parcelRequire("aAB6i");
var $9RyKW = parcelRequire("9RyKW");
var $OFl2v = parcelRequire("OFl2v");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $hp7yq = parcelRequire("hp7yq");
const { wrap: $f34eec40cf304025$var$wrap, unwrap: $f34eec40cf304025$var$unwrap } = (0, $hp7yq.iso)();
const $f34eec40cf304025$var$generate = (0, $kj6DU.pipe)((0, $aAB6i).now, (0, $OFl2v).map($f34eec40cf304025$var$wrap));
const $f34eec40cf304025$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($f34eec40cf304025$var$unwrap));
const $f34eec40cf304025$export$4786645933ae8b1e = {
    generate: $f34eec40cf304025$var$generate,
    unwrap: $f34eec40cf304025$var$unwrap,
    Eq: $f34eec40cf304025$var$Eq
};

});
parcelRegister("aAB6i", function(module, exports) {

$parcel$export(module.exports, "Eq", function () { return $7b5a0b983533e4d6$export$a2050e5b0c4dcf10; });
$parcel$export(module.exports, "eqDate", function () { return $7b5a0b983533e4d6$export$4eced57d6183c43d; });
$parcel$export(module.exports, "eqMonth", function () { return $7b5a0b983533e4d6$export$927de8112dffb3f8; });
$parcel$export(module.exports, "eqYear", function () { return $7b5a0b983533e4d6$export$a20272c1d8245ff5; });
$parcel$export(module.exports, "Ord", function () { return $7b5a0b983533e4d6$export$ee8aa95bfab51c5; });
$parcel$export(module.exports, "create", function () { return $7b5a0b983533e4d6$export$185802fd694ee1f5; });
$parcel$export(module.exports, "now", function () { return $7b5a0b983533e4d6$export$461939dd4422153; });

var $kj6DU = parcelRequire("kj6DU");

var $cF6yJ = parcelRequire("cF6yJ");

var $hOuM2 = parcelRequire("hOuM2");
var $7b5a0b983533e4d6$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};
var $7b5a0b983533e4d6$export$4eced57d6183c43d = {
    equals: function(x, y) {
        return x.getDate() === y.getDate();
    }
};
var $7b5a0b983533e4d6$export$927de8112dffb3f8 = {
    equals: function(x, y) {
        return x.getMonth() === y.getMonth();
    }
};
var $7b5a0b983533e4d6$export$a20272c1d8245ff5 = {
    equals: function(x, y) {
        return x.getFullYear() === y.getFullYear();
    }
};
var $7b5a0b983533e4d6$export$ee8aa95bfab51c5 = /*#__PURE__*/ (0, $kj6DU.pipe)($cF6yJ.Ord, /*#__PURE__*/ $hOuM2.contramap(function(date) {
    return date.valueOf();
}));
var $7b5a0b983533e4d6$export$185802fd694ee1f5 = function() {
    return new Date();
};
var $7b5a0b983533e4d6$export$461939dd4422153 = function() {
    return new Date().getTime();
};

});




parcelRegister("dCazK", function(module, exports) {

$parcel$export(module.exports, "UserContextProvider", function () { return $61439835a438ae91$export$2e7f18b06f26b111; });
$parcel$export(module.exports, "useUser", function () { return $61439835a438ae91$export$23bbbc4533528f03; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $9RyKW = parcelRequire("9RyKW");
var $lSBre = parcelRequire("lSBre");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $exYeM = parcelRequire("exYeM");

var $jVoNn = parcelRequire("jVoNn");

var $cn7Rc = parcelRequire("cn7Rc");

var $7pd72 = parcelRequire("7pd72");

var $hhoaA = parcelRequire("hhoaA");

var $as4O1 = parcelRequire("as4O1");

var $9ddGv = parcelRequire("9ddGv");

var $4erZY = parcelRequire("4erZY");

var $exi8o = parcelRequire("exi8o");

var $cwvCy = parcelRequire("cwvCy");

var $exJMo = parcelRequire("exJMo");

var $9WYKv = parcelRequire("9WYKv");

var $3sLwn = parcelRequire("3sLwn");

var $4MhX7 = parcelRequire("4MhX7");

var $lQ3eP = parcelRequire("lQ3eP");

var $fviO3 = parcelRequire("fviO3");

var $bN7FL = parcelRequire("bN7FL");

var $hZroh = parcelRequire("hZroh");
const $61439835a438ae91$var$recentSearchesKey = 'recentSearches';
const $61439835a438ae91$var$recentSearchesCodec = (0, $9ddGv.Tuple).of((0, $9ddGv.List).codec((0, $4MhX7.PartialSummonerShort).codec), 'List<PartialSummonerShort>');
const $61439835a438ae91$var$byPuuidEq = (0, $9RyKW).struct({
    puuid: (0, $7pd72.Puuid).Eq
});
const $61439835a438ae91$var$UserContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
const $61439835a438ae91$export$2e7f18b06f26b111 = ({ children: children })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { showToaster: showToaster } = (0, $bN7FL.useToaster)();
    const { data: data, error: error, mutate: mutate } = (0, $jVoNn.default)((0, $cn7Rc.apiRoutes).user.self.get, ([url, method])=>(0, $kj6DU.pipe)((0, $fviO3.http)([
            url,
            method
        ], {
            retry: 0
        }, [
            (0, $as4O1.UserView).codec,
            'UserView'
        ]), (0, $fviO3.statusesToOption)(401, 404), (0, $4erZY.futureMaybe).map((0, $kj6DU.pipe)((0, $as4O1.UserView).Lens.favoriteSearches, (0, $4QCFr).modify((0, $9ddGv.List).sort((0, $hhoaA.SummonerShort).byRiotIdOrd)))), (0, $9ddGv.Future).orElse((e)=>{
            console.error(e);
            showToaster('error', t.errors.fetchUserError);
            return (0, $9ddGv.Future).failed(e);
        }), (0, $lQ3eP.futureRunUnsafe)), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    const addFavoriteSearch = (0, $exYeM.useCallback)((summoner)=>(0, $kj6DU.pipe)((0, $9ddGv.Maybe).fromNullable(data), (0, $9ddGv.Maybe).flatten, (0, $9ddGv.Maybe).filter((0, $kj6DU.flow)((0, $as4O1.UserView).Lens.favoriteSearches.get, (0, $lSBre).not((0, $9ddGv.List).elem($61439835a438ae91$var$byPuuidEq)(summoner)))), (0, $9ddGv.Maybe).map((oldData)=>(0, $kj6DU.pipe)((0, $exi8o.apiUserSelfFavoritesPut)(summoner), (0, $fviO3.statusesToOption)(404), (0, $4erZY.futureMaybe).map(()=>{
                mutate((0, $9ddGv.Maybe).some((0, $kj6DU.pipe)((0, $as4O1.UserView).Lens.favoriteSearches, (0, $4QCFr).modify((0, $kj6DU.flow)((0, $9ddGv.List).append(summoner), (0, $9ddGv.List).sort((0, $hhoaA.SummonerShort).byRiotIdOrd))))(oldData)), {
                    revalidate: false
                });
                return 0, $9ddGv.NotUsed;
            }))), (0, $9ddGv.Maybe).getOrElse(()=>(0, $9ddGv.Future).failed(Error('Inconsistent state'))), (0, $9ddGv.Future).orElse((e)=>{
            console.error(e);
            showToaster('error', t.errors.addFavoriteError);
            return (0, $4erZY.futureMaybe).some((0, $9ddGv.NotUsed));
        })), [
        data,
        mutate,
        showToaster,
        t
    ]);
    const removeFavoriteSearch = (0, $exYeM.useCallback)((puuid)=>(0, $kj6DU.pipe)((0, $9ddGv.Maybe).fromNullable(data), (0, $9ddGv.Maybe).flatten, (0, $9ddGv.Maybe).filter((0, $kj6DU.flow)((0, $as4O1.UserView).Lens.favoriteSearches.get, (0, $9ddGv.List).elem($61439835a438ae91$var$byPuuidEq)({
            puuid: puuid
        }))), (0, $9ddGv.Maybe).map((oldData)=>(0, $kj6DU.pipe)((0, $exi8o.apiUserSelfFavoritesDelete)(puuid), (0, $9ddGv.Future).map(()=>{
                mutate((0, $9ddGv.Maybe).some((0, $kj6DU.pipe)((0, $as4O1.UserView).Lens.favoriteSearches, (0, $4QCFr).modify((0, $9ddGv.List).differenceW($61439835a438ae91$var$byPuuidEq)([
                    {
                        puuid: puuid
                    }
                ])))(oldData)), {
                    revalidate: false
                });
                return 0, $9ddGv.NotUsed;
            }))), (0, $9ddGv.Maybe).getOrElse(()=>(0, $9ddGv.Future).failed(Error('Inconsistent state'))), (0, $9ddGv.Future).orElse((e)=>{
            console.error(e);
            showToaster('error', t.errors.removeFavoriteError);
            return (0, $9ddGv.Future).notUsed;
        })), [
        data,
        mutate,
        showToaster,
        t
    ]);
    const [recentSearches_, setRecentSearches_] = (0, $9WYKv.useLocalStorageState)($61439835a438ae91$var$recentSearchesKey, $61439835a438ae91$var$recentSearchesCodec, []);
    const addRecentSearch = (0, $exYeM.useCallback)((summoner)=>setRecentSearches_((0, $kj6DU.flow)((0, $9ddGv.List).prepend((0, $4MhX7.PartialSummonerShort).fromSummonerShort(summoner)), (0, $9ddGv.List).uniq($61439835a438ae91$var$byPuuidEq), (0, $9ddGv.List).takeLeft((0, $exJMo.constants).recentSearchesMaxCount))), [
        setRecentSearches_
    ]);
    const removeRecentSearch = (0, $exYeM.useCallback)((puuid)=>setRecentSearches_((0, $9ddGv.List).differenceW($61439835a438ae91$var$byPuuidEq)([
            {
                puuid: puuid
            }
        ])), [
        setRecentSearches_
    ]);
    const refreshUser = (0, $exYeM.useMemo)(()=>(0, $9ddGv.Future).tryCatch(()=>mutate(()=>Promise.resolve(undefined))), [
        mutate
    ]);
    const user = (0, $exYeM.useMemo)(()=>(0, $3sLwn.AsyncState).fromSWR({
            data: data,
            error: error
        }), [
        data,
        error
    ]);
    const maybeUser = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(user, (0, $3sLwn.AsyncState).toOption, (0, $9ddGv.Maybe).flatten), [
        user
    ]);
    const recentSearches = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(recentSearches_, (0, $9ddGv.List).differenceW($61439835a438ae91$var$byPuuidEq)((0, $kj6DU.pipe)((0, $9ddGv.List).fromOption(maybeUser), (0, $9ddGv.List).chain((u)=>(0, $kj6DU.pipe)(u.favoriteSearches, (0, $9ddGv.List).concat((0, $9ddGv.List).fromOption(u.linkedRiotAccount))))))), [
        maybeUser,
        recentSearches_
    ]);
    if (error !== undefined) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cwvCy.Pre), {
            className: "mt-4",
            children: "error"
        })
    });
    const value = {
        refreshUser: refreshUser,
        user: user,
        maybeUser: maybeUser,
        addFavoriteSearch: addFavoriteSearch,
        removeFavoriteSearch: removeFavoriteSearch,
        recentSearches: recentSearches,
        addRecentSearch: addRecentSearch,
        removeRecentSearch: removeRecentSearch
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)($61439835a438ae91$var$UserContext.Provider, {
        value: value,
        children: children
    });
};
const $61439835a438ae91$export$23bbbc4533528f03 = ()=>{
    const context = (0, $exYeM.useContext)($61439835a438ae91$var$UserContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useUser must be used within a UserContextProvider');
    return context;
};

});
parcelRegister("hhoaA", function(module, exports) {

$parcel$export(module.exports, "SummonerShort", function () { return $4f60f580a5d9c142$export$50e6e519eacc19ff; });

var $hOuM2 = parcelRequire("hOuM2");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $appXD = parcelRequire("appXD");

var $hFHAv = parcelRequire("hFHAv");

var $5Dwzl = parcelRequire("5Dwzl");

var $7pd72 = parcelRequire("7pd72");
const $4f60f580a5d9c142$var$codecProperties = {
    platform: (0, $5Dwzl.Platform).codec,
    puuid: (0, $7pd72.Puuid).codec,
    riotId: (0, $appXD.RiotId).fromStringCodec,
    name: (0, $9ddGv.Maybe).codec((0, $hFHAv.SummonerName).codec),
    profileIconId: $7uCHH.number
};
const $4f60f580a5d9c142$var$codec = $7uCHH.struct($4f60f580a5d9c142$var$codecProperties);
const $4f60f580a5d9c142$var$byRiotIdOrd = (0, $kj6DU.pipe)((0, $gSyeU).Ord, (0, $hOuM2).contramap((s)=>(0, $hrnY6.StringUtils).cleanUTF8ToASCII((0, $appXD.RiotId).stringify(s.riotId)).toLowerCase()));
const $4f60f580a5d9c142$export$50e6e519eacc19ff = {
    codecProperties: $4f60f580a5d9c142$var$codecProperties,
    codec: $4f60f580a5d9c142$var$codec,
    byRiotIdOrd: $4f60f580a5d9c142$var$byRiotIdOrd
};

});
parcelRegister("hFHAv", function(module, exports) {

$parcel$export(module.exports, "SummonerName", function () { return $0d076d2a9853f067$export$d838340f48ae024a; });

var $9RyKW = parcelRequire("9RyKW");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $0d076d2a9853f067$var$wrap, unwrap: $0d076d2a9853f067$var$unwrap } = (0, $hp7yq.iso)();
const $0d076d2a9853f067$var$modify = (0, $kj6DU.identity);
const $0d076d2a9853f067$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $0d076d2a9853f067$var$whiteSpaces = /\s+/g;
const $0d076d2a9853f067$var$clean = $0d076d2a9853f067$var$modify((name)=>name.toLowerCase().replaceAll($0d076d2a9853f067$var$whiteSpaces, ''));
const $0d076d2a9853f067$var$Eq = (0, $kj6DU.pipe)((0, $gSyeU).Eq, (0, $9RyKW).contramap($0d076d2a9853f067$var$unwrap));
const $0d076d2a9853f067$export$d838340f48ae024a = (0, $9ddGv.immutableAssign)($0d076d2a9853f067$var$wrap, {
    unwrap: $0d076d2a9853f067$var$unwrap,
    codec: $0d076d2a9853f067$var$codec,
    clean: $0d076d2a9853f067$var$clean,
    Eq: $0d076d2a9853f067$var$Eq
});

});


parcelRegister("as4O1", function(module, exports) {

$parcel$export(module.exports, "UserView", function () { return $aa62122200bf8da3$export$93c94555daa109c4; });

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $9ddGv = parcelRequire("9ddGv");

var $hhoaA = parcelRequire("hhoaA");

var $iiWSW = parcelRequire("iiWSW");
const $aa62122200bf8da3$var$codec = $7uCHH.struct({
    userName: $7uCHH.string,
    favoriteSearches: (0, $9ddGv.List).codec((0, $hhoaA.SummonerShort).codec),
    linkedRiotAccount: (0, $9ddGv.Maybe).codec((0, $hhoaA.SummonerShort).codec),
    role: (0, $iiWSW.UserRole).codec
});
const $aa62122200bf8da3$var$favoriteSearchesLens = (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('favoriteSearches'));
const $aa62122200bf8da3$export$93c94555daa109c4 = {
    codec: $aa62122200bf8da3$var$codec,
    Lens: {
        favoriteSearches: $aa62122200bf8da3$var$favoriteSearchesLens
    }
};

});
parcelRegister("iiWSW", function(module, exports) {

$parcel$export(module.exports, "UserRole", function () { return $26922e37c08f4ef4$export$eb3485a690c2f0b8; });

var $3a4Bg = parcelRequire("3a4Bg");
const $26922e37c08f4ef4$export$eb3485a690c2f0b8 = (0, $3a4Bg.createEnum)('base', 'admin');

});


parcelRegister("4erZY", function(module, exports) {

$parcel$export(module.exports, "futureMaybe", function () { return $002f984b844a66f5$export$7e537f1fc6d62628; });

var $j7Bi0 = parcelRequire("j7Bi0");
var $dya6d = parcelRequire("dya6d");
var $6baua = parcelRequire("6baua");
var $6CLBd = parcelRequire("6CLBd");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
const $002f984b844a66f5$var$URI = 'TaskEitherOption';
const $002f984b844a66f5$var$some = (0, $6CLBd).some((0, $9ddGv.Future).Pointed);
const $002f984b844a66f5$var$apPar_ = (fab, fa)=>(0, $kj6DU.pipe)(fab, $002f984b844a66f5$var$ap(fa));
const $002f984b844a66f5$var$chain_ = (ma, f)=>(0, $kj6DU.pipe)(ma, $002f984b844a66f5$var$chain(f));
const $002f984b844a66f5$var$map_ = (fa, f)=>(0, $kj6DU.pipe)(fa, $002f984b844a66f5$var$map(f));
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const $002f984b844a66f5$var$Do = $002f984b844a66f5$var$some({});
const $002f984b844a66f5$var$ApplicativePar = {
    URI: $002f984b844a66f5$var$URI,
    map: $002f984b844a66f5$var$map_,
    ap: $002f984b844a66f5$var$apPar_,
    of: $002f984b844a66f5$var$some
};
const $002f984b844a66f5$var$ApplyPar = {
    URI: $002f984b844a66f5$var$URI,
    map: $002f984b844a66f5$var$map_,
    ap: $002f984b844a66f5$var$apPar_
};
const $002f984b844a66f5$var$Chain = {
    URI: $002f984b844a66f5$var$URI,
    map: $002f984b844a66f5$var$map_,
    ap: $002f984b844a66f5$var$apPar_,
    chain: $002f984b844a66f5$var$chain_
};
const $002f984b844a66f5$var$Functor = {
    URI: $002f984b844a66f5$var$URI,
    map: $002f984b844a66f5$var$map_
};
const $002f984b844a66f5$var$ap = (0, $6CLBd).ap((0, $9ddGv.Future).ApplyPar);
const $002f984b844a66f5$var$chain = (0, $6CLBd).chain((0, $9ddGv.Future).Monad);
const $002f984b844a66f5$var$chainEitherK = (f)=>$002f984b844a66f5$var$chainTaskEitherK((0, $kj6DU.flow)(f, (0, $9ddGv.Future).fromEither));
const $002f984b844a66f5$var$chainNullableK = (0, $6CLBd).chainNullableK((0, $9ddGv.Future).Monad);
const $002f984b844a66f5$var$chainOptionK = (0, $6CLBd).chainOptionK((0, $9ddGv.Future).Monad);
const $002f984b844a66f5$var$chainTaskEitherK = (f)=>$002f984b844a66f5$var$chain((0, $kj6DU.flow)(f, (0, $9ddGv.Future).map((0, $9ddGv.Maybe).some)));
const $002f984b844a66f5$var$chainIOK = (f)=>$002f984b844a66f5$var$chainTaskEitherK((0, $kj6DU.flow)(f, (0, $9ddGv.Future).fromIO));
const $002f984b844a66f5$var$chainFirst = (0, $dya6d).chainFirst($002f984b844a66f5$var$Chain);
const $002f984b844a66f5$var$chainFirstTaskEitherK = (f)=>$002f984b844a66f5$var$chainFirst((0, $kj6DU.flow)(f, (0, $9ddGv.Future).map((0, $9ddGv.Maybe).some)));
const $002f984b844a66f5$var$chainFirstIOEitherK = (f)=>$002f984b844a66f5$var$chainFirstTaskEitherK((0, $kj6DU.flow)(f, (0, $9ddGv.Future).fromIOEither));
const $002f984b844a66f5$var$filter = (0, $kj6DU.flow)((0, $9ddGv.Maybe).filter, (0, $9ddGv.Future).map);
const $002f984b844a66f5$var$fromTaskEither = (0, $6CLBd).fromF((0, $9ddGv.Future).Functor);
const $002f984b844a66f5$var$fromIO = (0, $kj6DU.flow)((0, $9ddGv.Future).fromIO, $002f984b844a66f5$var$fromTaskEither);
const $002f984b844a66f5$var$fromNullable = (0, $6CLBd).fromNullable((0, $9ddGv.Future).Pointed);
const $002f984b844a66f5$var$fromOption = (0, $6CLBd).fromOptionK((0, $9ddGv.Future).Pointed)((0, $kj6DU.identity));
const $002f984b844a66f5$var$fromIOEither = (0, $kj6DU.flow)((0, $9ddGv.Future).fromIOEither, (0, $9ddGv.Future).map((0, $9ddGv.Maybe).some));
const $002f984b844a66f5$var$getOrElse = (0, $6CLBd).getOrElse((0, $9ddGv.Future).Monad);
const $002f984b844a66f5$var$map = (0, $6CLBd).map((0, $9ddGv.Future).Functor);
const $002f984b844a66f5$var$none = (0, $6CLBd).zero((0, $9ddGv.Future).Pointed)();
const $002f984b844a66f5$export$7e537f1fc6d62628 = {
    Do: $002f984b844a66f5$var$Do,
    ApplicativePar: $002f984b844a66f5$var$ApplicativePar,
    ApplyPar: $002f984b844a66f5$var$ApplyPar,
    Functor: $002f984b844a66f5$var$Functor,
    alt: (0, $6CLBd).alt((0, $9ddGv.Future).Monad),
    apS: (0, $j7Bi0).apS($002f984b844a66f5$var$ApplyPar),
    bind: (0, $dya6d).bind($002f984b844a66f5$var$Chain),
    bindTo: (0, $6baua).bindTo($002f984b844a66f5$var$Functor),
    let: (0, $6baua).let($002f984b844a66f5$var$Functor),
    chain: $002f984b844a66f5$var$chain,
    chainEitherK: $002f984b844a66f5$var$chainEitherK,
    chainNullableK: $002f984b844a66f5$var$chainNullableK,
    chainOptionK: $002f984b844a66f5$var$chainOptionK,
    chainTaskEitherK: $002f984b844a66f5$var$chainTaskEitherK,
    chainIOK: $002f984b844a66f5$var$chainIOK,
    chainFirst: $002f984b844a66f5$var$chainFirst,
    chainFirstTaskEitherK: $002f984b844a66f5$var$chainFirstTaskEitherK,
    chainFirstIOEitherK: $002f984b844a66f5$var$chainFirstIOEitherK,
    filter: $002f984b844a66f5$var$filter,
    fromTaskEither: $002f984b844a66f5$var$fromTaskEither,
    fromIO: $002f984b844a66f5$var$fromIO,
    fromNullable: $002f984b844a66f5$var$fromNullable,
    fromOption: $002f984b844a66f5$var$fromOption,
    fromIOEither: $002f984b844a66f5$var$fromIOEither,
    getOrElse: $002f984b844a66f5$var$getOrElse,
    map: $002f984b844a66f5$var$map,
    match: (0, $6CLBd).match((0, $9ddGv.Future).Functor),
    matchE: (0, $6CLBd).matchE((0, $9ddGv.Future).Chain),
    none: $002f984b844a66f5$var$none,
    some: $002f984b844a66f5$var$some
};

});
parcelRegister("6CLBd", function(module, exports) {

$parcel$export(module.exports, "some", function () { return $4d2b36e63206890d$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "zero", function () { return $4d2b36e63206890d$export$7f9972325ebfd559; });
$parcel$export(module.exports, "fromF", function () { return $4d2b36e63206890d$export$f892bc4f66df4228; });
$parcel$export(module.exports, "fromNullable", function () { return $4d2b36e63206890d$export$b601f49376b4621a; });
$parcel$export(module.exports, "fromNullableK", function () { return $4d2b36e63206890d$export$c69ca7b73fad45e1; });
$parcel$export(module.exports, "chainNullableK", function () { return $4d2b36e63206890d$export$c81f992c08fd0bf3; });
$parcel$export(module.exports, "chain", function () { return $4d2b36e63206890d$export$e08e3b67e392101e; });
$parcel$export(module.exports, "fromOptionK", function () { return $4d2b36e63206890d$export$a907462f448b49f8; });
$parcel$export(module.exports, "chainOptionK", function () { return $4d2b36e63206890d$export$12d26179deb6a68a; });
$parcel$export(module.exports, "fromPredicate", function () { return $4d2b36e63206890d$export$23f31c55d7162b91; });
$parcel$export(module.exports, "fromEither", function () { return $4d2b36e63206890d$export$80c878c9b1d77917; });
$parcel$export(module.exports, "match", function () { return $4d2b36e63206890d$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "matchE", function () { return $4d2b36e63206890d$export$398621f19e0a7e4; });
$parcel$export(module.exports, "getOrElse", function () { return $4d2b36e63206890d$export$8832081647a02ee7; });
$parcel$export(module.exports, "map", function () { return $4d2b36e63206890d$export$871de8747c9eaa88; });
$parcel$export(module.exports, "ap", function () { return $4d2b36e63206890d$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "flatMap", function () { return $4d2b36e63206890d$export$5b8affa63fc6df16; });
$parcel$export(module.exports, "alt", function () { return $4d2b36e63206890d$export$228be17d80722ab; });
$parcel$export(module.exports, "getOptionM", function () { return $4d2b36e63206890d$export$76c6439d480fbaad; });

var $j7Bi0 = parcelRequire("j7Bi0");

var $kj6DU = parcelRequire("kj6DU");

var $6baua = parcelRequire("6baua");

var $3NXK3 = parcelRequire("3NXK3");
function $4d2b36e63206890d$export$ad14ef4001db2bcd(F) {
    return (0, $kj6DU.flow)($3NXK3.some, F.of);
}
function $4d2b36e63206890d$export$7f9972325ebfd559(F) {
    return (0, $kj6DU.constant)(F.of($3NXK3.none));
}
function $4d2b36e63206890d$export$f892bc4f66df4228(F) {
    return function(ma) {
        return F.map(ma, $3NXK3.some);
    };
}
function $4d2b36e63206890d$export$b601f49376b4621a(F) {
    return (0, $kj6DU.flow)($3NXK3.fromNullable, F.of);
}
function $4d2b36e63206890d$export$c69ca7b73fad45e1(F) {
    var fromNullableF = $4d2b36e63206890d$export$b601f49376b4621a(F);
    return function(f) {
        return (0, $kj6DU.flow)(f, fromNullableF);
    };
}
function $4d2b36e63206890d$export$c81f992c08fd0bf3(M) {
    var chainM = $4d2b36e63206890d$export$e08e3b67e392101e(M);
    var fromNullableKM = $4d2b36e63206890d$export$c69ca7b73fad45e1(M);
    return function(f) {
        return chainM(fromNullableKM(f));
    };
}
function $4d2b36e63206890d$export$a907462f448b49f8(F) {
    return function(f) {
        return (0, $kj6DU.flow)(f, F.of);
    };
}
function $4d2b36e63206890d$export$12d26179deb6a68a(M) {
    var chainM = $4d2b36e63206890d$export$e08e3b67e392101e(M);
    var fromOptionKM = $4d2b36e63206890d$export$a907462f448b49f8(M);
    return function(f) {
        return chainM(fromOptionKM(f));
    };
}
function $4d2b36e63206890d$export$23f31c55d7162b91(F) {
    return function(predicate) {
        return function(a) {
            return F.of($3NXK3.fromPredicate(predicate)(a));
        };
    };
}
function $4d2b36e63206890d$export$80c878c9b1d77917(F) {
    return (0, $kj6DU.flow)($3NXK3.fromEither, F.of);
}
function $4d2b36e63206890d$export$4659b591c19bdf3d(F) {
    return function(onNone, onSome) {
        return function(ma) {
            return F.map(ma, $3NXK3.match(onNone, onSome));
        };
    };
}
function $4d2b36e63206890d$export$398621f19e0a7e4(M) {
    return function(onNone, onSome) {
        return function(ma) {
            return M.chain(ma, $3NXK3.match(onNone, onSome));
        };
    };
}
function $4d2b36e63206890d$export$8832081647a02ee7(M) {
    return function(onNone) {
        return function(fa) {
            return M.chain(fa, $3NXK3.match(onNone, M.of));
        };
    };
}
function $4d2b36e63206890d$export$871de8747c9eaa88(F) {
    return (0, $6baua.map)(F, $3NXK3.Functor);
}
function $4d2b36e63206890d$export$2f6ca3d3b1f80bf5(F) {
    return (0, $j7Bi0.ap)(F, $3NXK3.Apply);
}
function $4d2b36e63206890d$export$e08e3b67e392101e(M) {
    var flatMapM = $4d2b36e63206890d$export$5b8affa63fc6df16(M);
    return function(f) {
        return function(ma) {
            return flatMapM(ma, f);
        };
    };
}
function $4d2b36e63206890d$export$5b8affa63fc6df16(M) {
    var zeroM = $4d2b36e63206890d$export$7f9972325ebfd559(M);
    return function(ma, f) {
        return M.chain(ma, $3NXK3.match(function() {
            return zeroM();
        }, f));
    };
}
function $4d2b36e63206890d$export$228be17d80722ab(M) {
    var _some = $4d2b36e63206890d$export$ad14ef4001db2bcd(M);
    return function(second) {
        return function(first) {
            return M.chain(first, $3NXK3.match(second, _some));
        };
    };
}
function $4d2b36e63206890d$export$76c6439d480fbaad(M) {
    var apM = $4d2b36e63206890d$export$2f6ca3d3b1f80bf5(M);
    var mapM = $4d2b36e63206890d$export$871de8747c9eaa88(M);
    var chainM = $4d2b36e63206890d$export$e08e3b67e392101e(M);
    var altM = $4d2b36e63206890d$export$228be17d80722ab(M);
    var foldM = $4d2b36e63206890d$export$398621f19e0a7e4(M);
    var getOrElseM = $4d2b36e63206890d$export$8832081647a02ee7(M);
    var zeroM = $4d2b36e63206890d$export$7f9972325ebfd559(M);
    return {
        map: function(fa, f) {
            return (0, $kj6DU.pipe)(fa, mapM(f));
        },
        ap: function(fab, fa) {
            return (0, $kj6DU.pipe)(fab, apM(fa));
        },
        of: $4d2b36e63206890d$export$ad14ef4001db2bcd(M),
        chain: function(ma, f) {
            return (0, $kj6DU.pipe)(ma, chainM(f));
        },
        alt: function(fa, that) {
            return (0, $kj6DU.pipe)(fa, altM(that));
        },
        fold: function(fa, onNone, onSome) {
            return (0, $kj6DU.pipe)(fa, foldM(onNone, onSome));
        },
        getOrElse: function(fa, onNone) {
            return (0, $kj6DU.pipe)(fa, getOrElseM(onNone));
        },
        fromM: $4d2b36e63206890d$export$f892bc4f66df4228(M),
        none: function() {
            return zeroM();
        }
    };
}

});


parcelRegister("exi8o", function(module, exports) {

$parcel$export(module.exports, "apiSummonerGet", function () { return $aa9caf37915e645a$export$d61a9862bcd571ae; });
$parcel$export(module.exports, "apiUserRegisterPost", function () { return $aa9caf37915e645a$export$d64d5d74aa8cf9b6; });
$parcel$export(module.exports, "apiUserLoginPasswordPost", function () { return $aa9caf37915e645a$export$45f5d04ed4119063; });
$parcel$export(module.exports, "apiUserLogoutPost", function () { return $aa9caf37915e645a$export$329d70dc4dbea004; });
$parcel$export(module.exports, "apiUserSelfFavoritesPut", function () { return $aa9caf37915e645a$export$a1a189d26ecb01d5; });
$parcel$export(module.exports, "apiUserSelfFavoritesDelete", function () { return $aa9caf37915e645a$export$d4f91cea631a4f48; });
$parcel$export(module.exports, "apiUserSelfSummonerChampionsShardsCountPost", function () { return $aa9caf37915e645a$export$67029896d27d4e4f; });
$parcel$export(module.exports, "apiAdminMadosayentisutoPost", function () { return $aa9caf37915e645a$export$f0646fc238d5c797; });

var $kj6DU = parcelRequire("kj6DU");

var $cn7Rc = parcelRequire("cn7Rc");

var $23GAO = parcelRequire("23GAO");

var $62CHf = parcelRequire("62CHf");

var $6bEoh = parcelRequire("6bEoh");

var $7pd72 = parcelRequire("7pd72");

var $hhoaA = parcelRequire("hhoaA");

var $kf3m0 = parcelRequire("kf3m0");

var $fviO3 = parcelRequire("fviO3");
function $aa9caf37915e645a$export$d61a9862bcd571ae(platform, riotId) {
    return (0, $kj6DU.pipe)((0, $fviO3.http)((0, $cn7Rc.apiRoutes).summoner.byRiotId(platform)(riotId).get, {}, [
        (0, $hhoaA.SummonerShort).codec,
        'SummonerShort'
    ]), (0, $fviO3.statusesToOption)(404));
}
function $aa9caf37915e645a$export$d64d5d74aa8cf9b6(payload) {
    return (0, $fviO3.http)((0, $cn7Rc.apiRoutes).user.register.password.post, {
        json: [
            (0, $kf3m0.LoginPasswordPayload).codec,
            payload
        ]
    });
}
function $aa9caf37915e645a$export$45f5d04ed4119063(payload) {
    return (0, $fviO3.http)((0, $cn7Rc.apiRoutes).user.login.password.post, {
        json: [
            (0, $kf3m0.LoginPasswordPayload).codec,
            payload
        ]
    });
}
const $aa9caf37915e645a$export$329d70dc4dbea004 = (0, $fviO3.http)((0, $cn7Rc.apiRoutes).user.logout.post);
function $aa9caf37915e645a$export$a1a189d26ecb01d5(platformWithPuuid) {
    return (0, $fviO3.http)((0, $cn7Rc.apiRoutes).user.self.favorites.put, {
        json: [
            (0, $6bEoh.PlatformWithPuuid).codec,
            platformWithPuuid
        ]
    });
}
function $aa9caf37915e645a$export$d4f91cea631a4f48(puuid) {
    return (0, $fviO3.http)((0, $cn7Rc.apiRoutes).user.self.favorites.delete, {
        json: [
            (0, $7pd72.Puuid).codec,
            puuid
        ]
    });
}
function $aa9caf37915e645a$export$67029896d27d4e4f(platform, puuid, championsShards) {
    return (0, $fviO3.http)((0, $cn7Rc.apiRoutes).user.self.summoner(platform)(puuid).championsShardsCount.post, {
        json: [
            (0, $62CHf.ChampionShardsPayload).codec,
            championsShards
        ]
    });
}
function $aa9caf37915e645a$export$f0646fc238d5c797(payload) {
    return (0, $fviO3.http)((0, $cn7Rc.apiRoutes).admin.hallOfFame.post, {
        json: [
            (0, $23GAO.HallOfFameMembersPayload).codec,
            payload
        ]
    });
}

});
parcelRegister("23GAO", function(module, exports) {

$parcel$export(module.exports, "HallOfFameMembersPayload", function () { return $8cd5d087b6045b03$export$e36427e6de497278; });

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $2VOFK = parcelRequire("2VOFK");

var $6bEoh = parcelRequire("6bEoh");
const $8cd5d087b6045b03$var$codec = (0, $xJ0AO.MapFromArray).codec((0, $9ddGv.idcOrd)((0, $2VOFK.DiscordUserId).Eq))((0, $2VOFK.DiscordUserId).codec, (0, $6bEoh.PlatformWithPuuid).codec);
const $8cd5d087b6045b03$export$e36427e6de497278 = {
    codec: $8cd5d087b6045b03$var$codec
};

});
parcelRegister("6bEoh", function(module, exports) {

$parcel$export(module.exports, "PlatformWithPuuid", function () { return $f923aa58d15901ef$export$dfc3df3713e6992c; });

var $7uCHH = parcelRequire("7uCHH");

var $5Dwzl = parcelRequire("5Dwzl");

var $7pd72 = parcelRequire("7pd72");
const $f923aa58d15901ef$var$codec = $7uCHH.struct({
    platform: (0, $5Dwzl.Platform).codec,
    puuid: (0, $7pd72.Puuid).codec
});
const $f923aa58d15901ef$export$dfc3df3713e6992c = {
    codec: $f923aa58d15901ef$var$codec
};

});


parcelRegister("62CHf", function(module, exports) {

$parcel$export(module.exports, "ChampionShardsPayload", function () { return $89f67adb35bba860$export$7156dffe74864932; });

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $4YO8e = parcelRequire("4YO8e");

var $632HS = parcelRequire("632HS");
const $89f67adb35bba860$var$shardCodec = $7uCHH.struct({
    championId: (0, $632HS.ChampionKey).codec,
    shardsCount: (0, $4YO8e.ShardsCount).codec
});
const $89f67adb35bba860$export$24480d1f591a811a = {
    codec: $89f67adb35bba860$var$shardCodec
};
const $89f67adb35bba860$var$codec = (0, $9ddGv.NonEmptyArray).codec($89f67adb35bba860$export$24480d1f591a811a.codec);
const $89f67adb35bba860$export$7156dffe74864932 = {
    codec: $89f67adb35bba860$var$codec
};

});
parcelRegister("4YO8e", function(module, exports) {

$parcel$export(module.exports, "ShardsCount", function () { return $997dd1a964a48aed$export$2fa5e477db1261c8; });

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");
const $997dd1a964a48aed$var$decoder = (0, $kj6DU.pipe)($5zWxO.number, $5zWxO.refine((n)=>Number.isInteger(n), 'Integer'), $5zWxO.refine((n)=>0 <= n && n <= 9, 'Between0And9'));
const $997dd1a964a48aed$var$encoder = $aXkbA.id();
const $997dd1a964a48aed$var$codec = $7uCHH.make($997dd1a964a48aed$var$decoder, $997dd1a964a48aed$var$encoder);
const $997dd1a964a48aed$export$2fa5e477db1261c8 = {
    codec: $997dd1a964a48aed$var$codec
};

});


parcelRegister("kf3m0", function(module, exports) {

$parcel$export(module.exports, "LoginPasswordPayload", function () { return $30a00326ef82d9c3$export$8be910c59786c76d; });

var $7uCHH = parcelRequire("7uCHH");

var $98dC6 = parcelRequire("98dC6");

var $h1xNs = parcelRequire("h1xNs");
const $30a00326ef82d9c3$var$codec = $7uCHH.struct({
    userName: (0, $h1xNs.UserName).codec,
    password: (0, $98dC6.ClearPassword).codec
});
const $30a00326ef82d9c3$export$8be910c59786c76d = {
    codec: $30a00326ef82d9c3$var$codec
};

});
parcelRegister("98dC6", function(module, exports) {

$parcel$export(module.exports, "ClearPassword", function () { return $ea79968592ed550b$export$c945fb7fdfdff4ef; });

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $ea79968592ed550b$var$wrap, unwrap: $ea79968592ed550b$var$unwrap } = (0, $hp7yq.iso)();
const $ea79968592ed550b$var$codec = (0, $xJ0AO.fromNewtype)((0, $xJ0AO.NonEmptyString).codec);
const $ea79968592ed550b$export$c945fb7fdfdff4ef = (0, $9ddGv.immutableAssign)($ea79968592ed550b$var$wrap, {
    unwrap: $ea79968592ed550b$var$unwrap,
    codec: $ea79968592ed550b$var$codec
});

});

parcelRegister("h1xNs", function(module, exports) {

$parcel$export(module.exports, "UserName", function () { return $78bfa8685d4de5fd$export$7bf5e3f2a1fc0a63; });

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $78bfa8685d4de5fd$var$wrap, unwrap: $78bfa8685d4de5fd$var$unwrap } = (0, $hp7yq.iso)();
const $78bfa8685d4de5fd$var$codec = (0, $xJ0AO.fromNewtype)((0, $xJ0AO.NonEmptyString).codec);
const $78bfa8685d4de5fd$export$7bf5e3f2a1fc0a63 = (0, $9ddGv.immutableAssign)($78bfa8685d4de5fd$var$wrap, {
    unwrap: $78bfa8685d4de5fd$var$unwrap,
    codec: $78bfa8685d4de5fd$var$codec
});

});



parcelRegister("exJMo", function(module, exports) {

$parcel$export(module.exports, "constants", function () { return $811a3119f341a328$export$1a988e7317c65621; });
const $811a3119f341a328$export$1a988e7317c65621 = {
    recentSearchesMaxCount: 10
};

});

parcelRegister("3sLwn", function(module, exports) {

$parcel$export(module.exports, "AsyncState", function () { return $e481b54e21b53ad9$export$e59cffac92a1baf3; });

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
const $e481b54e21b53ad9$var$loading = {
    type: 'Loading'
};
const $e481b54e21b53ad9$var$failure = (error)=>({
        type: 'Failure',
        error: error
    });
const $e481b54e21b53ad9$var$success = (loadedValue)=>({
        type: 'Success',
        loadedValue: loadedValue
    });
const $e481b54e21b53ad9$var$fromSWR = ({ data: data, error: error })=>{
    if (error !== undefined) return $e481b54e21b53ad9$var$failure(error);
    if (data === undefined) return $e481b54e21b53ad9$var$loading;
    return $e481b54e21b53ad9$var$success(data);
};
const $e481b54e21b53ad9$var$fold = (onLoading, onFailure, onSuccess)=>(as)=>{
        switch(as.type){
            case 'Loading':
                return onLoading();
            case 'Failure':
                return onFailure(as.error);
            case 'Success':
                return onSuccess(as.loadedValue);
        }
    };
const $e481b54e21b53ad9$var$toOption = $e481b54e21b53ad9$var$fold(()=>(0, $9ddGv.Maybe).none, ()=>(0, $9ddGv.Maybe).none, (0, $9ddGv.Maybe).some);
const $e481b54e21b53ad9$var$toSWR = (as)=>(0, $kj6DU.pipe)(as, $e481b54e21b53ad9$var$fold(()=>({
            data: undefined,
            error: undefined
        }), (error)=>({
            data: undefined,
            error: error
        }), (data)=>({
            data: data,
            error: undefined
        })));
const $e481b54e21b53ad9$export$e59cffac92a1baf3 = {
    fromSWR: $e481b54e21b53ad9$var$fromSWR,
    fold: $e481b54e21b53ad9$var$fold,
    toOption: $e481b54e21b53ad9$var$toOption,
    toSWR: $e481b54e21b53ad9$var$toSWR
};

});

parcelRegister("4MhX7", function(module, exports) {

$parcel$export(module.exports, "PartialSummonerShort", function () { return $b4ea716954bc621d$export$53a0f8657ff653de; });

var $7uCHH = parcelRequire("7uCHH");

var $hhoaA = parcelRequire("hhoaA");

var $appXD = parcelRequire("appXD");

var $9ddGv = parcelRequire("9ddGv");
const $b4ea716954bc621d$var$codec = $7uCHH.struct({
    ...(0, $hhoaA.SummonerShort).codecProperties,
    riotId: (0, $9ddGv.Maybe).codec((0, $appXD.RiotId).fromStringCodec)
});
function $b4ea716954bc621d$var$fromSummonerShort(summoner) {
    return {
        ...summoner,
        riotId: (0, $9ddGv.Maybe).some(summoner.riotId)
    };
}
const $b4ea716954bc621d$export$53a0f8657ff653de = {
    codec: $b4ea716954bc621d$var$codec,
    fromSummonerShort: $b4ea716954bc621d$var$fromSummonerShort
};

});


parcelRegister("5N26n", function(module, exports) {

$parcel$export(module.exports, "Navigate", function () { return $d52e840c4a4717ce$export$444b3ab0cb9aec40; });
/* eslint-disable functional/no-expression-statements */ 
var $exYeM = parcelRequire("exYeM");

var $2Yib7 = parcelRequire("2Yib7");
const $d52e840c4a4717ce$export$444b3ab0cb9aec40 = ({ to: to, ...options })=>{
    const { navigate: navigate } = (0, $2Yib7.useHistory)();
    (0, $exYeM.useEffect)(()=>{
        navigate(to, options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

});
parcelRegister("2Yib7", function(module, exports) {

$parcel$export(module.exports, "HistoryContextProvider", function () { return $c783bb4b6ed54b76$export$a7f2b2c281690bcd; });
$parcel$export(module.exports, "HistoryState", function () { return $c783bb4b6ed54b76$export$95c891a1f5736881; });
$parcel$export(module.exports, "useHistory", function () { return $c783bb4b6ed54b76$export$3420e1dc2c4a518c; });
/* eslint-disable functional/no-expression-statements, 
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $egJUG = parcelRequire("egJUG");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $2art4 = parcelRequire("2art4");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $4IdVv = parcelRequire("4IdVv");

var $fzgvm = parcelRequire("fzgvm");

var $2SjoC = parcelRequire("2SjoC");

var $bdAIi = parcelRequire("bdAIi");
const $c783bb4b6ed54b76$var$HistoryContext = /*#__PURE__*/ (0, $exYeM.createContext)(undefined);
const $c783bb4b6ed54b76$export$a7f2b2c281690bcd = ({ children: children })=>{
    const historyStateRef = (0, $exYeM.useRef)($c783bb4b6ed54b76$export$95c891a1f5736881.empty);
    const modifyHistoryStateRef = (0, $exYeM.useCallback)((f)=>{
        // eslint-disable-next-line functional/immutable-data
        historyStateRef.current = f(historyStateRef.current);
    }, []);
    const h = (0, $exYeM.useMemo)(()=>$egJUG.createBrowserHistory(), []);
    const [location, setLocation] = (0, $exYeM.useState)(h.location);
    (0, $exYeM.useEffect)(()=>h.listen((l)=>setLocation(l.location)), [
        h
    ]);
    const navigate = (0, $exYeM.useCallback)((pathname, { replace: replace = false } = {})=>{
        const to = {
            pathname: pathname,
            search: '',
            hash: ''
        };
        if (replace) return h.replace(to);
        return h.push(to);
    }, [
        h
    ]);
    const query = (0, $exYeM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2art4))).parse(location.search.slice(1)), [
        location.search
    ]);
    const masteriesQuery = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)((0, $bdAIi.PartialMasteriesQuery).decoder.decode(query), (0, $9ddGv.Either).getOrElse(()=>({})), (0, $2SjoC.MasteriesQuery).fromPartial), [
        query
    ]);
    const updateMasteriesQuery = (0, $exYeM.useCallback)((f)=>{
        const newQuery = f(masteriesQuery);
        const to = {
            search: (0, $kj6DU.pipe)(newQuery, (0, $2SjoC.MasteriesQuery).toPartial, (0, $bdAIi.PartialMasteriesQuery).qsStringify)
        };
        if (masteriesQuery.view !== newQuery.view) return h.push(to);
        return h.replace(to);
    }, [
        h,
        masteriesQuery
    ]);
    const genericQuery = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)((0, $fzgvm.PartialGenericQuery).decoder.decode(query), (0, $9ddGv.Either).getOrElse(()=>({})), (0, $4IdVv.GenericQuery).fromPartial), [
        query
    ]);
    const updateGenericQuery = (0, $exYeM.useCallback)((f)=>h.replace({
            search: (0, $kj6DU.pipe)(f(genericQuery), (0, $4IdVv.GenericQuery).toPartial, (0, $fzgvm.PartialGenericQuery).qsStringify)
        }), [
        genericQuery,
        h
    ]);
    const value = {
        historyStateRef: historyStateRef,
        modifyHistoryStateRef: modifyHistoryStateRef,
        location: location,
        navigate: navigate,
        query: query,
        masteriesQuery: masteriesQuery,
        updateMasteriesQuery: updateMasteriesQuery,
        genericQuery: genericQuery,
        updateGenericQuery: updateGenericQuery
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)($c783bb4b6ed54b76$var$HistoryContext.Provider, {
        value: value,
        children: children
    });
};
const $c783bb4b6ed54b76$export$3420e1dc2c4a518c = ()=>{
    const context = (0, $exYeM.useContext)($c783bb4b6ed54b76$var$HistoryContext);
    if (context === undefined) // eslint-disable-next-line functional/no-throw-statements
    throw Error('useHistory must be used within a HistoryContextProvider');
    return context;
};
const $c783bb4b6ed54b76$var$empty = {
    masteries: (0, $9ddGv.Maybe).none,
    game: (0, $9ddGv.Maybe).none
};
const $c783bb4b6ed54b76$export$95c891a1f5736881 = {
    empty: $c783bb4b6ed54b76$var$empty,
    Lens: {
        masteries: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('masteries')),
        game: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('game'))
    }
};

});
parcelRegister("egJUG", function(module, exports) {

$parcel$export(module.exports, "createBrowserHistory", function () { return $a6362cb91f1b83be$export$719fc203c4e16dee; });

var $aJx1R = parcelRequire("aJx1R");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $a6362cb91f1b83be$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a6362cb91f1b83be$export$e19cd5f9376f8cee || ($a6362cb91f1b83be$export$e19cd5f9376f8cee = {}));
var $a6362cb91f1b83be$var$readOnly = function(obj) {
    return obj;
};
function $a6362cb91f1b83be$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $a6362cb91f1b83be$var$BeforeUnloadEventType = 'beforeunload';
var $a6362cb91f1b83be$var$HashChangeEventType = 'hashchange';
var $a6362cb91f1b83be$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a6362cb91f1b83be$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $a6362cb91f1b83be$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($a6362cb91f1b83be$var$PopStateEventType, handlePop);
    var action = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $a6362cb91f1b83be$var$createEvents();
    var blockers = $a6362cb91f1b83be$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $aJx1R.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $a6362cb91f1b83be$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $a6362cb91f1b83be$var$readOnly((0, $aJx1R.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $a6362cb91f1b83be$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $a6362cb91f1b83be$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($a6362cb91f1b83be$var$BeforeUnloadEventType, $a6362cb91f1b83be$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($a6362cb91f1b83be$var$BeforeUnloadEventType, $a6362cb91f1b83be$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a6362cb91f1b83be$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $a6362cb91f1b83be$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $a6362cb91f1b83be$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($a6362cb91f1b83be$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($a6362cb91f1b83be$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($a6362cb91f1b83be$export$fe53371bee54353d(nextLocation) !== $a6362cb91f1b83be$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $a6362cb91f1b83be$var$createEvents();
    var blockers = $a6362cb91f1b83be$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $aJx1R.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $a6362cb91f1b83be$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $a6362cb91f1b83be$var$readOnly((0, $aJx1R.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $a6362cb91f1b83be$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $a6362cb91f1b83be$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($a6362cb91f1b83be$var$BeforeUnloadEventType, $a6362cb91f1b83be$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($a6362cb91f1b83be$var$BeforeUnloadEventType, $a6362cb91f1b83be$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $a6362cb91f1b83be$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $a6362cb91f1b83be$var$readOnly((0, $aJx1R.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $a6362cb91f1b83be$var$createKey()
        }, typeof entry === 'string' ? $a6362cb91f1b83be$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $a6362cb91f1b83be$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $a6362cb91f1b83be$var$createEvents();
    var blockers = $a6362cb91f1b83be$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $a6362cb91f1b83be$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $a6362cb91f1b83be$var$readOnly((0, $aJx1R.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $a6362cb91f1b83be$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $a6362cb91f1b83be$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $a6362cb91f1b83be$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $a6362cb91f1b83be$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $a6362cb91f1b83be$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $a6362cb91f1b83be$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $a6362cb91f1b83be$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $a6362cb91f1b83be$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $a6362cb91f1b83be$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $a6362cb91f1b83be$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}

});
parcelRegister("aJx1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d07ba38ace95d14$export$2e2bcd8739ae039; });
function $7d07ba38ace95d14$export$2e2bcd8739ae039() {
    return $7d07ba38ace95d14$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d07ba38ace95d14$export$2e2bcd8739ae039.apply(null, arguments);
}

});


parcelRegister("2art4", function(module, exports) {
'use strict';

var $6eAtP = parcelRequire("6eAtP");

var $37qVe = parcelRequire("37qVe");

var $g8zwH = parcelRequire("g8zwH");
module.exports = {
    formats: $g8zwH,
    parse: $37qVe,
    stringify: $6eAtP
};

});
parcelRegister("6eAtP", function(module, exports) {
'use strict';

var $felPn = parcelRequire("felPn");

var $6IwJh = parcelRequire("6IwJh");

var $g8zwH = parcelRequire("g8zwH");
var $48a05912c9fbd5b7$var$has = Object.prototype.hasOwnProperty;
var $48a05912c9fbd5b7$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $48a05912c9fbd5b7$var$isArray = Array.isArray;
var $48a05912c9fbd5b7$var$push = Array.prototype.push;
var $48a05912c9fbd5b7$var$pushToArray = function(arr, valueOrArray) {
    $48a05912c9fbd5b7$var$push.apply(arr, $48a05912c9fbd5b7$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $48a05912c9fbd5b7$var$toISO = Date.prototype.toISOString;
var $48a05912c9fbd5b7$var$defaultFormat = $g8zwH.default;
var $48a05912c9fbd5b7$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $6IwJh.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $48a05912c9fbd5b7$var$defaultFormat,
    formatter: $g8zwH.formatters[$48a05912c9fbd5b7$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $48a05912c9fbd5b7$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $48a05912c9fbd5b7$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $48a05912c9fbd5b7$var$sentinel = {};
var $48a05912c9fbd5b7$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($48a05912c9fbd5b7$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($48a05912c9fbd5b7$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $48a05912c9fbd5b7$var$isArray(obj)) obj = $6IwJh.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $48a05912c9fbd5b7$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($48a05912c9fbd5b7$var$isNonNullishPrimitive(obj) || $6IwJh.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $48a05912c9fbd5b7$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $48a05912c9fbd5b7$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $48a05912c9fbd5b7$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $6IwJh.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($48a05912c9fbd5b7$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $48a05912c9fbd5b7$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $48a05912c9fbd5b7$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $48a05912c9fbd5b7$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $felPn();
        valueSideChannel.set($48a05912c9fbd5b7$var$sentinel, sideChannel);
        $48a05912c9fbd5b7$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $48a05912c9fbd5b7$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $48a05912c9fbd5b7$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $48a05912c9fbd5b7$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $48a05912c9fbd5b7$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $g8zwH.default;
    if (typeof opts.format !== 'undefined') {
        if (!$48a05912c9fbd5b7$var$has.call($g8zwH.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $g8zwH.formatters[format];
    var filter = $48a05912c9fbd5b7$var$defaults.filter;
    if (typeof opts.filter === 'function' || $48a05912c9fbd5b7$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $48a05912c9fbd5b7$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $48a05912c9fbd5b7$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $48a05912c9fbd5b7$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $48a05912c9fbd5b7$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $48a05912c9fbd5b7$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $48a05912c9fbd5b7$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $48a05912c9fbd5b7$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $48a05912c9fbd5b7$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $48a05912c9fbd5b7$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $48a05912c9fbd5b7$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $48a05912c9fbd5b7$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $48a05912c9fbd5b7$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $48a05912c9fbd5b7$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $48a05912c9fbd5b7$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $48a05912c9fbd5b7$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($48a05912c9fbd5b7$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $48a05912c9fbd5b7$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $felPn();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $48a05912c9fbd5b7$var$pushToArray(keys, $48a05912c9fbd5b7$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("felPn", function(module, exports) {
'use strict';

var $OG0Ue = parcelRequire("OG0Ue");

var $jrvhS = parcelRequire("jrvhS");

var $7uPqe = parcelRequire("7uPqe");

var $6KRk5 = parcelRequire("6KRk5");

var $58Xr7 = parcelRequire("58Xr7");
var $b169185aab3e5a24$var$makeChannel = $58Xr7 || $6KRk5 || $7uPqe;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $OG0Ue('Side channel does not contain ' + $jrvhS(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $b169185aab3e5a24$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("OG0Ue", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("jrvhS", function(module, exports) {
var $e278ceee2711ea6e$var$hasMap = typeof Map === 'function' && Map.prototype;
var $e278ceee2711ea6e$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $e278ceee2711ea6e$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $e278ceee2711ea6e$var$mapSize = $e278ceee2711ea6e$var$hasMap && $e278ceee2711ea6e$var$mapSizeDescriptor && typeof $e278ceee2711ea6e$var$mapSizeDescriptor.get === 'function' ? $e278ceee2711ea6e$var$mapSizeDescriptor.get : null;
var $e278ceee2711ea6e$var$mapForEach = $e278ceee2711ea6e$var$hasMap && Map.prototype.forEach;
var $e278ceee2711ea6e$var$hasSet = typeof Set === 'function' && Set.prototype;
var $e278ceee2711ea6e$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $e278ceee2711ea6e$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $e278ceee2711ea6e$var$setSize = $e278ceee2711ea6e$var$hasSet && $e278ceee2711ea6e$var$setSizeDescriptor && typeof $e278ceee2711ea6e$var$setSizeDescriptor.get === 'function' ? $e278ceee2711ea6e$var$setSizeDescriptor.get : null;
var $e278ceee2711ea6e$var$setForEach = $e278ceee2711ea6e$var$hasSet && Set.prototype.forEach;
var $e278ceee2711ea6e$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $e278ceee2711ea6e$var$weakMapHas = $e278ceee2711ea6e$var$hasWeakMap ? WeakMap.prototype.has : null;
var $e278ceee2711ea6e$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $e278ceee2711ea6e$var$weakSetHas = $e278ceee2711ea6e$var$hasWeakSet ? WeakSet.prototype.has : null;
var $e278ceee2711ea6e$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $e278ceee2711ea6e$var$weakRefDeref = $e278ceee2711ea6e$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $e278ceee2711ea6e$var$booleanValueOf = Boolean.prototype.valueOf;
var $e278ceee2711ea6e$var$objectToString = Object.prototype.toString;
var $e278ceee2711ea6e$var$functionToString = Function.prototype.toString;
var $e278ceee2711ea6e$var$$match = String.prototype.match;
var $e278ceee2711ea6e$var$$slice = String.prototype.slice;
var $e278ceee2711ea6e$var$$replace = String.prototype.replace;
var $e278ceee2711ea6e$var$$toUpperCase = String.prototype.toUpperCase;
var $e278ceee2711ea6e$var$$toLowerCase = String.prototype.toLowerCase;
var $e278ceee2711ea6e$var$$test = RegExp.prototype.test;
var $e278ceee2711ea6e$var$$concat = Array.prototype.concat;
var $e278ceee2711ea6e$var$$join = Array.prototype.join;
var $e278ceee2711ea6e$var$$arrSlice = Array.prototype.slice;
var $e278ceee2711ea6e$var$$floor = Math.floor;
var $e278ceee2711ea6e$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $e278ceee2711ea6e$var$gOPS = Object.getOwnPropertySymbols;
var $e278ceee2711ea6e$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $e278ceee2711ea6e$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $e278ceee2711ea6e$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $e278ceee2711ea6e$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $e278ceee2711ea6e$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $e278ceee2711ea6e$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $e278ceee2711ea6e$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $e278ceee2711ea6e$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$e278ceee2711ea6e$var$$floor(-num) : $e278ceee2711ea6e$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $e278ceee2711ea6e$var$$slice.call(str, intStr.length + 1);
            return $e278ceee2711ea6e$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $e278ceee2711ea6e$var$$replace.call($e278ceee2711ea6e$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $e278ceee2711ea6e$var$$replace.call(str, sepRegex, '$&_');
}

var $1wVs5 = parcelRequire("1wVs5");
var $e278ceee2711ea6e$var$inspectCustom = $1wVs5.custom;
var $e278ceee2711ea6e$var$inspectSymbol = $e278ceee2711ea6e$var$isSymbol($e278ceee2711ea6e$var$inspectCustom) ? $e278ceee2711ea6e$var$inspectCustom : null;
var $e278ceee2711ea6e$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $e278ceee2711ea6e$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($e278ceee2711ea6e$var$has(opts, 'quoteStyle') && !$e278ceee2711ea6e$var$has($e278ceee2711ea6e$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($e278ceee2711ea6e$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $e278ceee2711ea6e$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($e278ceee2711ea6e$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($e278ceee2711ea6e$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $e278ceee2711ea6e$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $e278ceee2711ea6e$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $e278ceee2711ea6e$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $e278ceee2711ea6e$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $e278ceee2711ea6e$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($e278ceee2711ea6e$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $e278ceee2711ea6e$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($e278ceee2711ea6e$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$e278ceee2711ea6e$var$isRegExp(obj)) {
        var name = $e278ceee2711ea6e$var$nameOf(obj);
        var keys = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $e278ceee2711ea6e$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($e278ceee2711ea6e$var$isSymbol(obj)) {
        var symString = $e278ceee2711ea6e$var$hasShammedSymbols ? $e278ceee2711ea6e$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $e278ceee2711ea6e$var$symToString.call(obj);
        return typeof obj === 'object' && !$e278ceee2711ea6e$var$hasShammedSymbols ? $e278ceee2711ea6e$var$markBoxed(symString) : symString;
    }
    if ($e278ceee2711ea6e$var$isElement(obj)) {
        var s = '<' + $e278ceee2711ea6e$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $e278ceee2711ea6e$var$wrapQuotes($e278ceee2711ea6e$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $e278ceee2711ea6e$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($e278ceee2711ea6e$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        if (indent && !$e278ceee2711ea6e$var$singleLineValues(xs)) return '[' + $e278ceee2711ea6e$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $e278ceee2711ea6e$var$$join.call(xs, ', ') + ' ]';
    }
    if ($e278ceee2711ea6e$var$isError(obj)) {
        var parts = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$e278ceee2711ea6e$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $e278ceee2711ea6e$var$$join.call($e278ceee2711ea6e$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $e278ceee2711ea6e$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($e278ceee2711ea6e$var$inspectSymbol && typeof obj[$e278ceee2711ea6e$var$inspectSymbol] === 'function' && $1wVs5) return $1wVs5(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($e278ceee2711ea6e$var$isMap(obj)) {
        var mapParts = [];
        if ($e278ceee2711ea6e$var$mapForEach) $e278ceee2711ea6e$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $e278ceee2711ea6e$var$collectionOf('Map', $e278ceee2711ea6e$var$mapSize.call(obj), mapParts, indent);
    }
    if ($e278ceee2711ea6e$var$isSet(obj)) {
        var setParts = [];
        if ($e278ceee2711ea6e$var$setForEach) $e278ceee2711ea6e$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $e278ceee2711ea6e$var$collectionOf('Set', $e278ceee2711ea6e$var$setSize.call(obj), setParts, indent);
    }
    if ($e278ceee2711ea6e$var$isWeakMap(obj)) return $e278ceee2711ea6e$var$weakCollectionOf('WeakMap');
    if ($e278ceee2711ea6e$var$isWeakSet(obj)) return $e278ceee2711ea6e$var$weakCollectionOf('WeakSet');
    if ($e278ceee2711ea6e$var$isWeakRef(obj)) return $e278ceee2711ea6e$var$weakCollectionOf('WeakRef');
    if ($e278ceee2711ea6e$var$isNumber(obj)) return $e278ceee2711ea6e$var$markBoxed(inspect(Number(obj)));
    if ($e278ceee2711ea6e$var$isBigInt(obj)) return $e278ceee2711ea6e$var$markBoxed(inspect($e278ceee2711ea6e$var$bigIntValueOf.call(obj)));
    if ($e278ceee2711ea6e$var$isBoolean(obj)) return $e278ceee2711ea6e$var$markBoxed($e278ceee2711ea6e$var$booleanValueOf.call(obj));
    if ($e278ceee2711ea6e$var$isString(obj)) return $e278ceee2711ea6e$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$e278ceee2711ea6e$var$isDate(obj) && !$e278ceee2711ea6e$var$isRegExp(obj)) {
        var ys = $e278ceee2711ea6e$var$arrObjKeys(obj, inspect);
        var isPlainObject = $e278ceee2711ea6e$var$gPO ? $e278ceee2711ea6e$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $e278ceee2711ea6e$var$toStringTag && Object(obj) === obj && $e278ceee2711ea6e$var$toStringTag in obj ? $e278ceee2711ea6e$var$$slice.call($e278ceee2711ea6e$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $e278ceee2711ea6e$var$$join.call($e278ceee2711ea6e$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $e278ceee2711ea6e$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $e278ceee2711ea6e$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $e278ceee2711ea6e$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $e278ceee2711ea6e$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $e278ceee2711ea6e$var$quote(s) {
    return $e278ceee2711ea6e$var$$replace.call(String(s), /"/g, '&quot;');
}
function $e278ceee2711ea6e$var$canTrustToString(obj) {
    return !$e278ceee2711ea6e$var$toStringTag || !(typeof obj === 'object' && ($e278ceee2711ea6e$var$toStringTag in obj || typeof obj[$e278ceee2711ea6e$var$toStringTag] !== 'undefined'));
}
function $e278ceee2711ea6e$var$isArray(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object Array]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
function $e278ceee2711ea6e$var$isDate(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object Date]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
function $e278ceee2711ea6e$var$isRegExp(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object RegExp]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
function $e278ceee2711ea6e$var$isError(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object Error]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
function $e278ceee2711ea6e$var$isString(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object String]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
function $e278ceee2711ea6e$var$isNumber(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object Number]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
function $e278ceee2711ea6e$var$isBoolean(obj) {
    return $e278ceee2711ea6e$var$toStr(obj) === '[object Boolean]' && $e278ceee2711ea6e$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $e278ceee2711ea6e$var$isSymbol(obj) {
    if ($e278ceee2711ea6e$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$e278ceee2711ea6e$var$symToString) return false;
    try {
        $e278ceee2711ea6e$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$e278ceee2711ea6e$var$bigIntValueOf) return false;
    try {
        $e278ceee2711ea6e$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $e278ceee2711ea6e$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $e278ceee2711ea6e$var$has(obj, key) {
    return $e278ceee2711ea6e$var$hasOwn.call(obj, key);
}
function $e278ceee2711ea6e$var$toStr(obj) {
    return $e278ceee2711ea6e$var$objectToString.call(obj);
}
function $e278ceee2711ea6e$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $e278ceee2711ea6e$var$$match.call($e278ceee2711ea6e$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $e278ceee2711ea6e$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $e278ceee2711ea6e$var$isMap(x) {
    if (!$e278ceee2711ea6e$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $e278ceee2711ea6e$var$mapSize.call(x);
        try {
            $e278ceee2711ea6e$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isWeakMap(x) {
    if (!$e278ceee2711ea6e$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $e278ceee2711ea6e$var$weakMapHas.call(x, $e278ceee2711ea6e$var$weakMapHas);
        try {
            $e278ceee2711ea6e$var$weakSetHas.call(x, $e278ceee2711ea6e$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isWeakRef(x) {
    if (!$e278ceee2711ea6e$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $e278ceee2711ea6e$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isSet(x) {
    if (!$e278ceee2711ea6e$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $e278ceee2711ea6e$var$setSize.call(x);
        try {
            $e278ceee2711ea6e$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isWeakSet(x) {
    if (!$e278ceee2711ea6e$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $e278ceee2711ea6e$var$weakSetHas.call(x, $e278ceee2711ea6e$var$weakSetHas);
        try {
            $e278ceee2711ea6e$var$weakMapHas.call(x, $e278ceee2711ea6e$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $e278ceee2711ea6e$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $e278ceee2711ea6e$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $e278ceee2711ea6e$var$inspectString($e278ceee2711ea6e$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $e278ceee2711ea6e$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $e278ceee2711ea6e$var$$replace.call($e278ceee2711ea6e$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $e278ceee2711ea6e$var$lowbyte);
    return $e278ceee2711ea6e$var$wrapQuotes(s, 'single', opts);
}
function $e278ceee2711ea6e$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $e278ceee2711ea6e$var$$toUpperCase.call(n.toString(16));
}
function $e278ceee2711ea6e$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $e278ceee2711ea6e$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $e278ceee2711ea6e$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $e278ceee2711ea6e$var$indentedJoin(entries, indent) : $e278ceee2711ea6e$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $e278ceee2711ea6e$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($e278ceee2711ea6e$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $e278ceee2711ea6e$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $e278ceee2711ea6e$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $e278ceee2711ea6e$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $e278ceee2711ea6e$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $e278ceee2711ea6e$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $e278ceee2711ea6e$var$arrObjKeys(obj, inspect) {
    var isArr = $e278ceee2711ea6e$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $e278ceee2711ea6e$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $e278ceee2711ea6e$var$gOPS === 'function' ? $e278ceee2711ea6e$var$gOPS(obj) : [];
    var symMap;
    if ($e278ceee2711ea6e$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$e278ceee2711ea6e$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($e278ceee2711ea6e$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($e278ceee2711ea6e$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $e278ceee2711ea6e$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($e278ceee2711ea6e$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("1wVs5", function(module, exports) {
"use strict";

});


parcelRegister("7uPqe", function(module, exports) {
'use strict';

var $jrvhS = parcelRequire("jrvhS");

var $OG0Ue = parcelRequire("OG0Ue");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $575339202568485c$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $575339202568485c$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $575339202568485c$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $575339202568485c$var$listSet = function(objects, key, value) {
    var node = $575339202568485c$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $575339202568485c$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$575339202568485c$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $575339202568485c$var$listDelete = function(objects, key) {
    if (objects) return $575339202568485c$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $OG0Ue('Side channel does not contain ' + $jrvhS(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $575339202568485c$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $575339202568485c$var$listGet($o, key);
        },
        has: function(key) {
            return $575339202568485c$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $575339202568485c$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("6KRk5", function(module, exports) {
'use strict';

var $5XoKB = parcelRequire("5XoKB");

var $gXmQa = parcelRequire("gXmQa");

var $jrvhS = parcelRequire("jrvhS");

var $OG0Ue = parcelRequire("OG0Ue");
var $4eb066c5acb7d1b2$var$$Map = $5XoKB('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $4eb066c5acb7d1b2$var$$mapGet = $gXmQa('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $4eb066c5acb7d1b2$var$$mapSet = $gXmQa('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $4eb066c5acb7d1b2$var$$mapHas = $gXmQa('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $4eb066c5acb7d1b2$var$$mapDelete = $gXmQa('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $4eb066c5acb7d1b2$var$$mapSize = $gXmQa('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$4eb066c5acb7d1b2$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $OG0Ue('Side channel does not contain ' + $jrvhS(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $4eb066c5acb7d1b2$var$$mapDelete($m, key);
                if ($4eb066c5acb7d1b2$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $4eb066c5acb7d1b2$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $4eb066c5acb7d1b2$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $4eb066c5acb7d1b2$var$$Map();
            $4eb066c5acb7d1b2$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("5XoKB", function(module, exports) {
'use strict';
var $4565a9698af8efed$var$undefined1;

var $5koM0 = parcelRequire("5koM0");

var $f6Akk = parcelRequire("f6Akk");

var $fpQns = parcelRequire("fpQns");

var $ag3DL = parcelRequire("ag3DL");

var $eFn1R = parcelRequire("eFn1R");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $fK7Rv = parcelRequire("fK7Rv");

var $1r8xK = parcelRequire("1r8xK");

var $3U084 = parcelRequire("3U084");

var $4smBG = parcelRequire("4smBG");

var $kXYnx = parcelRequire("kXYnx");

var $5ZVK2 = parcelRequire("5ZVK2");

var $2gwEj = parcelRequire("2gwEj");

var $7JwSw = parcelRequire("7JwSw");
var $4565a9698af8efed$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $4565a9698af8efed$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4565a9698af8efed$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $eJu2D = parcelRequire("eJu2D");

var $7dXGV = parcelRequire("7dXGV");
var $4565a9698af8efed$var$throwTypeError = function() {
    throw new $OG0Ue();
};
var $4565a9698af8efed$var$ThrowTypeError = $eJu2D ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4565a9698af8efed$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $eJu2D(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $4565a9698af8efed$var$throwTypeError;
        }
    }
}() : $4565a9698af8efed$var$throwTypeError;

var $4565a9698af8efed$var$hasSymbols = (parcelRequire("1zrnp"))();

var $l6OwD = parcelRequire("l6OwD");

var $ihBW5 = parcelRequire("ihBW5");

var $9BidC = parcelRequire("9BidC");

var $irkS1 = parcelRequire("irkS1");

var $dwYm7 = parcelRequire("dwYm7");
var $4565a9698af8efed$var$needsEval = {};
var $4565a9698af8efed$var$TypedArray = typeof Uint8Array === 'undefined' || !$l6OwD ? undefined : $l6OwD(Uint8Array);
var $4565a9698af8efed$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $4565a9698af8efed$var$hasSymbols && $l6OwD ? $l6OwD([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $4565a9698af8efed$var$needsEval,
    '%AsyncGenerator%': $4565a9698af8efed$var$needsEval,
    '%AsyncGeneratorFunction%': $4565a9698af8efed$var$needsEval,
    '%AsyncIteratorPrototype%': $4565a9698af8efed$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $f6Akk,
    '%eval%': eval,
    '%EvalError%': $fpQns,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $4565a9698af8efed$var$$Function,
    '%GeneratorFunction%': $4565a9698af8efed$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $4565a9698af8efed$var$hasSymbols && $l6OwD ? $l6OwD($l6OwD([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$4565a9698af8efed$var$hasSymbols || !$l6OwD ? undefined : $l6OwD(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $5koM0,
    '%Object.getOwnPropertyDescriptor%': $eJu2D,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $ag3DL,
    '%ReferenceError%': $eFn1R,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$4565a9698af8efed$var$hasSymbols || !$l6OwD ? undefined : $l6OwD(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $4565a9698af8efed$var$hasSymbols && $l6OwD ? $l6OwD(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $4565a9698af8efed$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $6TBlj,
    '%ThrowTypeError%': $4565a9698af8efed$var$ThrowTypeError,
    '%TypedArray%': $4565a9698af8efed$var$TypedArray,
    '%TypeError%': $OG0Ue,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $fK7Rv,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $dwYm7,
    '%Function.prototype.apply%': $irkS1,
    '%Object.defineProperty%': $7dXGV,
    '%Object.getPrototypeOf%': $ihBW5,
    '%Math.abs%': $1r8xK,
    '%Math.floor%': $3U084,
    '%Math.max%': $4smBG,
    '%Math.min%': $kXYnx,
    '%Math.pow%': $5ZVK2,
    '%Math.round%': $2gwEj,
    '%Math.sign%': $7JwSw,
    '%Reflect.getPrototypeOf%': $9BidC
};
if ($l6OwD) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $4565a9698af8efed$var$errorProto = $l6OwD($l6OwD(e));
    $4565a9698af8efed$var$INTRINSICS['%Error.prototype%'] = $4565a9698af8efed$var$errorProto;
}
var $4565a9698af8efed$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $4565a9698af8efed$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $4565a9698af8efed$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $4565a9698af8efed$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $l6OwD) value = $l6OwD(gen.prototype);
    }
    $4565a9698af8efed$var$INTRINSICS[name] = value;
    return value;
};
var $4565a9698af8efed$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $dY0J9 = parcelRequire("dY0J9");

var $l8o8U = parcelRequire("l8o8U");
var $4565a9698af8efed$var$$concat = $dY0J9.call($dwYm7, Array.prototype.concat);
var $4565a9698af8efed$var$$spliceApply = $dY0J9.call($irkS1, Array.prototype.splice);
var $4565a9698af8efed$var$$replace = $dY0J9.call($dwYm7, String.prototype.replace);
var $4565a9698af8efed$var$$strSlice = $dY0J9.call($dwYm7, String.prototype.slice);
var $4565a9698af8efed$var$$exec = $dY0J9.call($dwYm7, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4565a9698af8efed$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4565a9698af8efed$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4565a9698af8efed$var$stringToPath = function stringToPath(string) {
    var first = $4565a9698af8efed$var$$strSlice(string, 0, 1);
    var last = $4565a9698af8efed$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $6TBlj('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $6TBlj('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $4565a9698af8efed$var$$replace(string, $4565a9698af8efed$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4565a9698af8efed$var$$replace(subString, $4565a9698af8efed$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $4565a9698af8efed$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($l8o8U($4565a9698af8efed$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4565a9698af8efed$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicName)) {
        var value = $4565a9698af8efed$var$INTRINSICS[intrinsicName];
        if (value === $4565a9698af8efed$var$needsEval) value = $4565a9698af8efed$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $OG0Ue('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6TBlj('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $OG0Ue('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $OG0Ue('"allowMissing" argument must be a boolean');
    if ($4565a9698af8efed$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6TBlj('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $4565a9698af8efed$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $4565a9698af8efed$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4565a9698af8efed$var$$spliceApply(parts, $4565a9698af8efed$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4565a9698af8efed$var$$strSlice(part, 0, 1);
        var last = $4565a9698af8efed$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $6TBlj('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicRealName)) value = $4565a9698af8efed$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $OG0Ue('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($eJu2D && i + 1 >= parts.length) {
                var desc = $eJu2D(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $l8o8U(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4565a9698af8efed$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5koM0", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("f6Akk", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("fpQns", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ag3DL", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("eFn1R", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6TBlj", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("fK7Rv", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("1r8xK", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("3U084", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("4smBG", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("kXYnx", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("5ZVK2", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("2gwEj", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("7JwSw", function(module, exports) {
'use strict';

var $cLte6 = parcelRequire("cLte6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($cLte6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("cLte6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("eJu2D", function(module, exports) {
'use strict';

var $j4KH7 = parcelRequire("j4KH7");
var $ab9c92447e4858f1$require$$gOPD = $j4KH7;
if ($ab9c92447e4858f1$require$$gOPD) try {
    $ab9c92447e4858f1$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $ab9c92447e4858f1$require$$gOPD = null;
}
module.exports = $ab9c92447e4858f1$require$$gOPD;

});
parcelRegister("j4KH7", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("7dXGV", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $54280cbbb5bff3df$var$$defineProperty = Object.defineProperty || false;
if ($54280cbbb5bff3df$var$$defineProperty) try {
    $54280cbbb5bff3df$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $54280cbbb5bff3df$var$$defineProperty = false;
}
module.exports = $54280cbbb5bff3df$var$$defineProperty;

});

parcelRegister("l6OwD", function(module, exports) {
'use strict';

var $9BidC = parcelRequire("9BidC");

var $ihBW5 = parcelRequire("ihBW5");

var $wFGxt = parcelRequire("wFGxt");
/** @type {import('.')} */ module.exports = $9BidC ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $9BidC(O);
} : $ihBW5 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $ihBW5(O);
} : $wFGxt ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $wFGxt(O);
} : null;

});
parcelRegister("9BidC", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("ihBW5", function(module, exports) {
'use strict';

var $5koM0 = parcelRequire("5koM0");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $5koM0.getPrototypeOf || null;

});

parcelRegister("wFGxt", function(module, exports) {
'use strict';

var $9XTQG = parcelRequire("9XTQG");

var $eJu2D = parcelRequire("eJu2D");
var $0623531189ee5241$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $0623531189ee5241$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $0623531189ee5241$var$desc = !!$0623531189ee5241$var$hasProtoAccessor && $eJu2D && $eJu2D(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $0623531189ee5241$var$$Object = Object;
var $0623531189ee5241$var$$getPrototypeOf = $0623531189ee5241$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $0623531189ee5241$var$desc && typeof $0623531189ee5241$var$desc.get === 'function' ? $9XTQG([
    $0623531189ee5241$var$desc.get
]) : typeof $0623531189ee5241$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $0623531189ee5241$var$$getPrototypeOf(value == null ? value : $0623531189ee5241$var$$Object(value));
} : false;

});
parcelRegister("9XTQG", function(module, exports) {
'use strict';

var $dY0J9 = parcelRequire("dY0J9");

var $OG0Ue = parcelRequire("OG0Ue");

var $dwYm7 = parcelRequire("dwYm7");

var $irSVr = parcelRequire("irSVr");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $OG0Ue('a function is required');
    return $irSVr($dY0J9, $dwYm7, args);
};

});
parcelRegister("dY0J9", function(module, exports) {
'use strict';

var $a9gvA = parcelRequire("a9gvA");
module.exports = Function.prototype.bind || $a9gvA;

});
parcelRegister("a9gvA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $76378ce80e32fd91$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $76378ce80e32fd91$var$toStr = Object.prototype.toString;
var $76378ce80e32fd91$var$max = Math.max;
var $76378ce80e32fd91$var$funcType = '[object Function]';
var $76378ce80e32fd91$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $76378ce80e32fd91$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $76378ce80e32fd91$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $76378ce80e32fd91$var$toStr.apply(target) !== $76378ce80e32fd91$var$funcType) throw new TypeError($76378ce80e32fd91$var$ERROR_MESSAGE + target);
    var args = $76378ce80e32fd91$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $76378ce80e32fd91$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $76378ce80e32fd91$var$concatty(args, arguments));
    };
    var boundLength = $76378ce80e32fd91$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $76378ce80e32fd91$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("dwYm7", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("irSVr", function(module, exports) {
'use strict';

var $dY0J9 = parcelRequire("dY0J9");

var $irkS1 = parcelRequire("irkS1");

var $dwYm7 = parcelRequire("dwYm7");

var $h70Yl = parcelRequire("h70Yl");
/** @type {import('./actualApply')} */ module.exports = $h70Yl || $dY0J9.call($dwYm7, $irkS1);

});
parcelRegister("irkS1", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("h70Yl", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("l8o8U", function(module, exports) {
'use strict';
var $f62d1296f319593b$var$call = Function.prototype.call;
var $f62d1296f319593b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $dY0J9 = parcelRequire("dY0J9");
/** @type {import('.')} */ module.exports = $dY0J9.call($f62d1296f319593b$var$call, $f62d1296f319593b$var$$hasOwn);

});


parcelRegister("gXmQa", function(module, exports) {
'use strict';

var $5XoKB = parcelRequire("5XoKB");

var $9XTQG = parcelRequire("9XTQG");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $c583dfac6bdc47c4$var$$indexOf = $9XTQG([
    $5XoKB('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ $5XoKB(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $c583dfac6bdc47c4$var$$indexOf(name, '.prototype.') > -1) return $9XTQG([
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("58Xr7", function(module, exports) {
'use strict';

var $5XoKB = parcelRequire("5XoKB");

var $gXmQa = parcelRequire("gXmQa");

var $jrvhS = parcelRequire("jrvhS");

var $6KRk5 = parcelRequire("6KRk5");

var $OG0Ue = parcelRequire("OG0Ue");
var $3bebcdef672ce6a9$var$$WeakMap = $5XoKB('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $3bebcdef672ce6a9$var$$weakMapGet = $gXmQa('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $3bebcdef672ce6a9$var$$weakMapSet = $gXmQa('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $3bebcdef672ce6a9$var$$weakMapHas = $gXmQa('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $3bebcdef672ce6a9$var$$weakMapDelete = $gXmQa('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $3bebcdef672ce6a9$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $OG0Ue('Side channel does not contain ' + $jrvhS(key));
        },
        'delete': function(key) {
            if ($3bebcdef672ce6a9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $3bebcdef672ce6a9$var$$weakMapDelete($wm, key);
            } else if ($6KRk5) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($3bebcdef672ce6a9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $3bebcdef672ce6a9$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($3bebcdef672ce6a9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $3bebcdef672ce6a9$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($3bebcdef672ce6a9$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $3bebcdef672ce6a9$var$$WeakMap();
                $3bebcdef672ce6a9$var$$weakMapSet($wm, key, value);
            } else if ($6KRk5) {
                if (!$m) $m = $6KRk5();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $6KRk5;

});


parcelRegister("6IwJh", function(module, exports) {
'use strict';

var $g8zwH = parcelRequire("g8zwH");
var $4e403d81bb30a235$var$has = Object.prototype.hasOwnProperty;
var $4e403d81bb30a235$var$isArray = Array.isArray;
var $4e403d81bb30a235$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $4e403d81bb30a235$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($4e403d81bb30a235$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $4e403d81bb30a235$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $4e403d81bb30a235$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($4e403d81bb30a235$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$4e403d81bb30a235$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($4e403d81bb30a235$var$isArray(target) && !$4e403d81bb30a235$var$isArray(source)) mergeTarget = $4e403d81bb30a235$var$arrayToObject(target, options);
    if ($4e403d81bb30a235$var$isArray(target) && $4e403d81bb30a235$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($4e403d81bb30a235$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($4e403d81bb30a235$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $4e403d81bb30a235$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $4e403d81bb30a235$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $4e403d81bb30a235$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $4e403d81bb30a235$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $4e403d81bb30a235$var$limit){
        var segment = string.length >= $4e403d81bb30a235$var$limit ? string.slice(j, j + $4e403d81bb30a235$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $g8zwH.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $4e403d81bb30a235$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $4e403d81bb30a235$var$hexTable[0xC0 | c >> 6] + $4e403d81bb30a235$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $4e403d81bb30a235$var$hexTable[0xE0 | c >> 12] + $4e403d81bb30a235$var$hexTable[0x80 | c >> 6 & 0x3F] + $4e403d81bb30a235$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $4e403d81bb30a235$var$hexTable[0xF0 | c >> 18] + $4e403d81bb30a235$var$hexTable[0x80 | c >> 12 & 0x3F] + $4e403d81bb30a235$var$hexTable[0x80 | c >> 6 & 0x3F] + $4e403d81bb30a235$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $4e403d81bb30a235$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $4e403d81bb30a235$var$compactQueue(queue);
    return value;
};
var $4e403d81bb30a235$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $4e403d81bb30a235$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $4e403d81bb30a235$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $4e403d81bb30a235$var$maybeMap = function maybeMap(val, fn) {
    if ($4e403d81bb30a235$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $4e403d81bb30a235$var$arrayToObject,
    assign: $4e403d81bb30a235$var$assign,
    combine: $4e403d81bb30a235$var$combine,
    compact: $4e403d81bb30a235$var$compact,
    decode: $4e403d81bb30a235$var$decode,
    encode: $4e403d81bb30a235$var$encode,
    isBuffer: $4e403d81bb30a235$var$isBuffer,
    isRegExp: $4e403d81bb30a235$var$isRegExp,
    maybeMap: $4e403d81bb30a235$var$maybeMap,
    merge: $4e403d81bb30a235$var$merge
};

});
parcelRegister("g8zwH", function(module, exports) {
'use strict';
var $bbf8f385fd5adb28$var$replace = String.prototype.replace;
var $bbf8f385fd5adb28$var$percentTwenties = /%20/g;
var $bbf8f385fd5adb28$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $bbf8f385fd5adb28$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $bbf8f385fd5adb28$var$replace.call(value, $bbf8f385fd5adb28$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $bbf8f385fd5adb28$var$Format.RFC1738,
    RFC3986: $bbf8f385fd5adb28$var$Format.RFC3986
};

});



parcelRegister("37qVe", function(module, exports) {
'use strict';

var $6IwJh = parcelRequire("6IwJh");
var $2456e8b28c0abc7e$var$has = Object.prototype.hasOwnProperty;
var $2456e8b28c0abc7e$var$isArray = Array.isArray;
var $2456e8b28c0abc7e$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $6IwJh.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $2456e8b28c0abc7e$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $2456e8b28c0abc7e$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $2456e8b28c0abc7e$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $2456e8b28c0abc7e$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $2456e8b28c0abc7e$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $2456e8b28c0abc7e$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $2456e8b28c0abc7e$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $2456e8b28c0abc7e$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $2456e8b28c0abc7e$var$defaults.decoder, charset, 'key');
            val = $6IwJh.maybeMap($2456e8b28c0abc7e$var$parseArrayValue(part.slice(pos + 1), options, $2456e8b28c0abc7e$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $2456e8b28c0abc7e$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $2456e8b28c0abc7e$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $2456e8b28c0abc7e$var$isArray(val) ? [
            val
        ] : val;
        var existing = $2456e8b28c0abc7e$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $6IwJh.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $2456e8b28c0abc7e$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $2456e8b28c0abc7e$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $6IwJh.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $2456e8b28c0abc7e$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $2456e8b28c0abc7e$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $2456e8b28c0abc7e$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $2456e8b28c0abc7e$var$parseObject(keys, val, options, valuesParsed);
};
var $2456e8b28c0abc7e$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $2456e8b28c0abc7e$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $2456e8b28c0abc7e$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $2456e8b28c0abc7e$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $2456e8b28c0abc7e$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $2456e8b28c0abc7e$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $2456e8b28c0abc7e$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $2456e8b28c0abc7e$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $2456e8b28c0abc7e$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $2456e8b28c0abc7e$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $2456e8b28c0abc7e$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $2456e8b28c0abc7e$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $2456e8b28c0abc7e$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $6IwJh.isRegExp(opts.delimiter) ? opts.delimiter : $2456e8b28c0abc7e$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $2456e8b28c0abc7e$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $2456e8b28c0abc7e$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $2456e8b28c0abc7e$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $2456e8b28c0abc7e$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $2456e8b28c0abc7e$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $2456e8b28c0abc7e$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $2456e8b28c0abc7e$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $2456e8b28c0abc7e$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $2456e8b28c0abc7e$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $6IwJh.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $6IwJh.compact(obj);
};

});


parcelRegister("4IdVv", function(module, exports) {

$parcel$export(module.exports, "GenericQuery", function () { return $5a3cb8a3ac2b5924$export$5ba030c5649e7498; });

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $9ddGv = parcelRequire("9ddGv");
const $5a3cb8a3ac2b5924$var$fromPartial = (partial)=>({
        search: (0, $9ddGv.Maybe).fromNullable(partial.search)
    });
const $5a3cb8a3ac2b5924$var$toPartial = (query)=>{
    const res = {
        search: (0, $9ddGv.Maybe).toUndefined(query.search)
    };
    return (0, $kj6DU.pipe)(res, (0, $9ddGv.Dict).filter((val)=>val !== undefined));
};
const $5a3cb8a3ac2b5924$var$Lens = {
    search: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('search'))
};
const $5a3cb8a3ac2b5924$export$5ba030c5649e7498 = {
    fromPartial: $5a3cb8a3ac2b5924$var$fromPartial,
    toPartial: $5a3cb8a3ac2b5924$var$toPartial,
    Lens: $5a3cb8a3ac2b5924$var$Lens
};

});

parcelRegister("fzgvm", function(module, exports) {

$parcel$export(module.exports, "PartialGenericQuery", function () { return $1301df01c674926b$export$3dd2c3cb2f38ff53; });

var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $2art4 = parcelRequire("2art4");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $cVWuQ = parcelRequire("cVWuQ");
const $1301df01c674926b$var$properties = {
    search: (0, $xJ0AO.NonEmptyString).codec
};
const $1301df01c674926b$var$decoder = $5zWxO.partial($1301df01c674926b$var$properties);
const $1301df01c674926b$var$encoder = $aXkbA.partial($1301df01c674926b$var$properties);
const $1301df01c674926b$var$qsStringify = (query)=>(0, $kj6DU.pipe)(query, (0, $9ddGv.Dict).filter((0, $cVWuQ.isDefined)), $1301df01c674926b$var$encoder.encode, (0, (/*@__PURE__*/$parcel$interopDefault($2art4))).stringify);
const $1301df01c674926b$export$3dd2c3cb2f38ff53 = {
    decoder: $1301df01c674926b$var$decoder,
    qsStringify: $1301df01c674926b$var$qsStringify
};

});
parcelRegister("cVWuQ", function(module, exports) {

$parcel$export(module.exports, "isDefined", function () { return $891d5f5ea540e77b$export$4e62c701997796c1; });
const $891d5f5ea540e77b$export$4e62c701997796c1 = (a)=>a !== null && a !== undefined;

});


parcelRegister("2SjoC", function(module, exports) {

$parcel$export(module.exports, "MasteriesQuery", function () { return $76dedb0aca2972e5$export$ae498ba88dc8a413; });

var $goBZ5 = parcelRequire("goBZ5");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $ffzmL = parcelRequire("ffzmL");

var $3Em0q = parcelRequire("3Em0q");

var $lfkrA = parcelRequire("lfkrA");

var $9ddGv = parcelRequire("9ddGv");

var $5EDDu = parcelRequire("5EDDu");

var $1KINn = parcelRequire("1KINn");

var $dpwSR = parcelRequire("dpwSR");
const $76dedb0aca2972e5$var$levelDefault = new Set((0, $3Em0q.ChampionLevel).values);
const $76dedb0aca2972e5$var$levelEq = (0, $goBZ5).getEq((0, $3Em0q.ChampionLevel).Eq);
const $76dedb0aca2972e5$var$positionDefault = new Set((0, $lfkrA.ChampionPosition).values);
const $76dedb0aca2972e5$var$positionEq = (0, $goBZ5).getEq((0, $lfkrA.ChampionPosition).Eq);
const $76dedb0aca2972e5$var$factionDefault = new Set((0, $ffzmL.ChampionFactionOrNone).values);
const $76dedb0aca2972e5$var$factionEq = (0, $goBZ5).getEq((0, $ffzmL.ChampionFactionOrNone).Eq);
const $76dedb0aca2972e5$var$fromPartial = (partial)=>({
        sort: partial.sort ?? (0, $1KINn.MasteriesQuerySort).default,
        order: partial.order ?? (0, $5EDDu.MasteriesQueryOrder).default,
        view: partial.view ?? (0, $dpwSR.MasteriesQueryView).default,
        level: partial.level ?? $76dedb0aca2972e5$var$levelDefault,
        faction: partial.faction ?? $76dedb0aca2972e5$var$factionDefault,
        position: partial.position ?? $76dedb0aca2972e5$var$positionDefault,
        search: (0, $9ddGv.Maybe).fromNullable(partial.search)
    });
const $76dedb0aca2972e5$var$toPartial = (query)=>{
    const res = {
        sort: query.sort === (0, $1KINn.MasteriesQuerySort).default ? undefined : query.sort,
        order: query.order === (0, $5EDDu.MasteriesQueryOrder).default ? undefined : query.order,
        view: query.view === (0, $dpwSR.MasteriesQueryView).default ? undefined : query.view,
        level: $76dedb0aca2972e5$var$levelEq.equals(query.level, $76dedb0aca2972e5$var$levelDefault) ? undefined : query.level,
        faction: $76dedb0aca2972e5$var$factionEq.equals(query.faction, $76dedb0aca2972e5$var$factionDefault) ? undefined : query.faction,
        position: $76dedb0aca2972e5$var$positionEq.equals(query.position, $76dedb0aca2972e5$var$positionDefault) ? undefined : query.position,
        search: (0, $9ddGv.Maybe).toUndefined(query.search)
    };
    return (0, $kj6DU.pipe)(res, (0, $9ddGv.Dict).filter((val)=>val !== undefined));
};
const $76dedb0aca2972e5$var$Lens = {
    sort: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('sort')),
    order: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('order')),
    view: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('view')),
    level: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('level')),
    faction: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('faction')),
    position: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('position')),
    search: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('search'))
};
const $76dedb0aca2972e5$export$ae498ba88dc8a413 = {
    fromPartial: $76dedb0aca2972e5$var$fromPartial,
    toPartial: $76dedb0aca2972e5$var$toPartial,
    Lens: $76dedb0aca2972e5$var$Lens
};

});
parcelRegister("3Em0q", function(module, exports) {

$parcel$export(module.exports, "ChampionLevel", function () { return $fc4569eca2e6eab5$export$8e3f96dd5c74b907; });

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $3a4Bg = parcelRequire("3a4Bg");

var $xJ0AO = parcelRequire("xJ0AO");
const $fc4569eca2e6eab5$var$e = (0, $3a4Bg.createEnum)(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10);
const $fc4569eca2e6eab5$var$stringCodec = (0, $kj6DU.pipe)((0, $xJ0AO.NumberFromString).codec, $7uCHH.compose($fc4569eca2e6eab5$var$e.codec));
const $fc4569eca2e6eab5$var$stringify = String;
const $fc4569eca2e6eab5$var$values = $fc4569eca2e6eab5$var$e.values;
function $fc4569eca2e6eab5$var$isChampionLevel(n) {
    return $fc4569eca2e6eab5$var$values.includes(n);
}
/**
 * @returns `10` if `n` is not a valid ChampionLevel
 */ function $fc4569eca2e6eab5$var$fromNumber(n) {
    return $fc4569eca2e6eab5$var$isChampionLevel(n) ? n : 10;
}
const $fc4569eca2e6eab5$export$8e3f96dd5c74b907 = {
    codec: $fc4569eca2e6eab5$var$e.codec,
    values: $fc4569eca2e6eab5$var$e.values,
    stringCodec: $fc4569eca2e6eab5$var$stringCodec,
    stringify: $fc4569eca2e6eab5$var$stringify,
    fromNumber: $fc4569eca2e6eab5$var$fromNumber,
    Eq: $fc4569eca2e6eab5$var$e.Eq,
    Ord: $fc4569eca2e6eab5$var$e.Ord
};

});

parcelRegister("5EDDu", function(module, exports) {

$parcel$export(module.exports, "MasteriesQueryOrder", function () { return $c826dbdf197e999c$export$1dedd29df924e3a3; });

var $3a4Bg = parcelRequire("3a4Bg");
const $c826dbdf197e999c$var$e = (0, $3a4Bg.createEnum)('desc', 'asc');
const $c826dbdf197e999c$var$default_ = 'desc';
const $c826dbdf197e999c$export$1dedd29df924e3a3 = {
    codec: $c826dbdf197e999c$var$e.codec,
    values: $c826dbdf197e999c$var$e.values,
    default: $c826dbdf197e999c$var$default_
};

});

parcelRegister("1KINn", function(module, exports) {

$parcel$export(module.exports, "MasteriesQuerySort", function () { return $6e06b8a541f880f9$export$d056c52114b85b89; });

var $3a4Bg = parcelRequire("3a4Bg");
const $6e06b8a541f880f9$var$e = (0, $3a4Bg.createEnum)('level', 'percents', 'points', 'name');
const $6e06b8a541f880f9$var$default_ = 'level';
const $6e06b8a541f880f9$export$d056c52114b85b89 = {
    codec: $6e06b8a541f880f9$var$e.codec,
    values: $6e06b8a541f880f9$var$e.values,
    default: $6e06b8a541f880f9$var$default_
};

});

parcelRegister("dpwSR", function(module, exports) {

$parcel$export(module.exports, "MasteriesQueryView", function () { return $6624663d3e82e520$export$dd815ae300c96b75; });

var $3a4Bg = parcelRequire("3a4Bg");

var $9ddGv = parcelRequire("9ddGv");
const $6624663d3e82e520$var$balanceViews = [
    'aram',
    'urf'
];
const $6624663d3e82e520$var$e = (0, $3a4Bg.createEnum)('compact', 'histogram', ...$6624663d3e82e520$var$balanceViews, 'factions');
const $6624663d3e82e520$var$default_ = 'compact';
function $6624663d3e82e520$var$isBalance(view) {
    return (0, $9ddGv.List).elem($6624663d3e82e520$var$e.Eq)(view, $6624663d3e82e520$var$balanceViews);
}
const $6624663d3e82e520$export$dd815ae300c96b75 = {
    ...$6624663d3e82e520$var$e,
    default: $6624663d3e82e520$var$default_,
    isBalance: $6624663d3e82e520$var$isBalance
};

});


parcelRegister("bdAIi", function(module, exports) {

$parcel$export(module.exports, "PartialMasteriesQuery", function () { return $acfb12885e2a6989$export$e0786fe8dcd5897f; });

var $goBZ5 = parcelRequire("goBZ5");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $aXkbA = parcelRequire("aXkbA");

var $2art4 = parcelRequire("2art4");

var $ffzmL = parcelRequire("ffzmL");

var $3Em0q = parcelRequire("3Em0q");

var $lfkrA = parcelRequire("lfkrA");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $cVWuQ = parcelRequire("cVWuQ");

var $5EDDu = parcelRequire("5EDDu");

var $1KINn = parcelRequire("1KINn");

var $dpwSR = parcelRequire("dpwSR");
const $acfb12885e2a6989$var$setFromStringCodec = (0, $xJ0AO.SetFromString).codec(',');
const $acfb12885e2a6989$var$properties = {
    sort: (0, $1KINn.MasteriesQuerySort).codec,
    order: (0, $5EDDu.MasteriesQueryOrder).codec,
    view: (0, $dpwSR.MasteriesQueryView).codec,
    level: $acfb12885e2a6989$var$setFromStringOrAllCodec((0, $3Em0q.ChampionLevel).stringCodec, (0, $3Em0q.ChampionLevel).Ord, new Set((0, $3Em0q.ChampionLevel).values)),
    faction: $acfb12885e2a6989$var$setFromStringOrAllCodec((0, $ffzmL.ChampionFactionOrNone).codec, (0, $ffzmL.ChampionFactionOrNone).Ord, new Set((0, $ffzmL.ChampionFactionOrNone).values)),
    position: $acfb12885e2a6989$var$setFromStringOrAllCodec((0, $lfkrA.ChampionPosition).codec, (0, $lfkrA.ChampionPosition).Ord, new Set((0, $lfkrA.ChampionPosition).values)),
    search: (0, $xJ0AO.NonEmptyString).codec
};
const $acfb12885e2a6989$var$decoder = $5zWxO.partial($acfb12885e2a6989$var$properties);
const $acfb12885e2a6989$var$encoder = $aXkbA.partial($acfb12885e2a6989$var$properties);
const $acfb12885e2a6989$var$qsStringify = (query)=>(0, $kj6DU.pipe)(query, (0, $9ddGv.Dict).filter((0, $cVWuQ.isDefined)), $acfb12885e2a6989$var$encoder.encode, (0, (/*@__PURE__*/$parcel$interopDefault($2art4))).stringify);
const $acfb12885e2a6989$export$e0786fe8dcd5897f = {
    decoder: $acfb12885e2a6989$var$decoder,
    qsStringify: $acfb12885e2a6989$var$qsStringify
};
function $acfb12885e2a6989$var$setFromStringOrAllCodec(codec, ord, allValues) {
    const setCodec = $acfb12885e2a6989$var$setFromStringCodec(codec, ord);
    const setEq = (0, $goBZ5).getEq(ord);
    return $7uCHH.make($5zWxO.union((0, $kj6DU.pipe)($5zWxO.literal('all'), $5zWxO.map(()=>allValues)), setCodec), {
        encode: (set)=>setEq.equals(set, allValues) ? 'all' : setCodec.encode(set)
    });
}

});



parcelRegister("lMH1q", function(module, exports) {

$parcel$export(module.exports, "MainLayout", function () { return $08cedbf473eafa98$export$93af822566053b3e; });

var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");

var $lFNyc = parcelRequire("lFNyc");

var $5mLQo = parcelRequire("5mLQo");

var $khrbF = parcelRequire("khrbF");

var $dR62Q = parcelRequire("dR62Q");

var $3sLwn = parcelRequire("3sLwn");

var $iz2wS = parcelRequire("iz2wS");

var $avpuJ = parcelRequire("avpuJ");

var $8Wmxp = parcelRequire("8Wmxp");

var $7CMrG = parcelRequire("7CMrG");

var $1sXco = parcelRequire("1sXco");

var $iOYiC = parcelRequire("iOYiC");

var $leRp4 = parcelRequire("leRp4");

var $7YXQd = parcelRequire("7YXQd");

var $21lR3 = parcelRequire("21lR3");

var $fAUNn = parcelRequire("fAUNn");
const $08cedbf473eafa98$export$93af822566053b3e = ({ children: children })=>{
    const { user: user } = (0, $dCazK.useUser)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const summoner = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).anyPlatformRiotId);
    const homeRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex h-full flex-col",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("header", {
                className: "flex justify-center border-b border-goldenrod bg-gradient-to-br from-zinc-950 to-zinc-900 px-3",
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "relative flex w-full max-w-7xl flex-wrap items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex grow basis-0 flex-wrap items-center gap-x-6",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                                    ref: homeRef,
                                    to: (0, $iz2wS.appRoutes).index,
                                    className: "pt-2",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                        src: (0, $5mLQo.Assets).yuumiHome,
                                        alt: t.layout.yuumiHomeAlt,
                                        width: 224,
                                        height: 128,
                                        className: "h-14 w-auto text-2xs text-transparent opacity-90"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                    hoverRef: homeRef,
                                    children: t.layout.home
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-center gap-4 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                                            to: (0, $iz2wS.appRoutes).aram({}),
                                            parser: (0, $iz2wS.appParsers).aram,
                                            tooltip: t.layout.aramSpecificBalanceChanges,
                                            className: "py-2",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $khrbF.HowlingAbyssSimple), {
                                                className: "w-5 secondary-wheat/60"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                                            to: (0, $iz2wS.appRoutes).urf({}),
                                            parser: (0, $iz2wS.appParsers).urf,
                                            tooltip: t.layout.urfSpecificBalanceChanges,
                                            className: "py-2",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7CMrG.MaskedImage), {
                                                src: (0, $5mLQo.Assets).spatula,
                                                className: "size-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                                            to: (0, $iz2wS.appRoutes).factions({}),
                                            parser: (0, $iz2wS.appParsers).factions,
                                            tooltip: t.layout.globetrotterChallenges,
                                            className: "py-2",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7CMrG.MaskedImage), {
                                                src: (0, $5mLQo.Assets).runeterra,
                                                className: "size-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                                            to: (0, $iz2wS.appRoutes).timers,
                                            parser: (0, $iz2wS.appParsers).timers,
                                            tooltip: t.layout.timers,
                                            className: "overflow-x-hidden py-1",
                                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.HourglassOutline), {
                                                className: "-mx-0.5 w-6 secondary-wheat/60"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fAUNn.SearchSummoner), {}),
                                summoner !== undefined ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-wrap items-center gap-4 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                                            to: (0, $iz2wS.appRoutes).platformRiotId(summoner.platform, summoner.riotId, {}),
                                            parser: (0, $iz2wS.appParsers).platformRiotId,
                                            tooltip: t.layout.championMasteries,
                                            className: "mt-0.5 py-0.5",
                                            children: t.layout.profile
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                                            to: (0, $iz2wS.appRoutes).platformRiotIdGame(summoner.platform, summoner.riotId),
                                            parser: (0, $iz2wS.appParsers).platformRiotIdGame,
                                            tooltip: t.layout.activeGame,
                                            className: "mt-0.5 py-0.5",
                                            children: t.layout.game
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex grow basis-0 flex-wrap items-center justify-end gap-x-4 self-stretch",
                            children: [
                                (0, $kj6DU.pipe)(user, (0, $3sLwn.AsyncState).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                                        className: "my-2 h-5"
                                    }), ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $leRp4.AccountDisconnected), {}), (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $leRp4.AccountDisconnected), {}), (u)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $iOYiC.AccountConnected), {
                                        user: u
                                    })))),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $21lR3.Languages), {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("main", {
                className: "grow overflow-auto",
                children: children
            })
        ]
    });
};

});
parcelRegister("lFNyc", function(module, exports) {

$parcel$export(module.exports, "usePathMatch", function () { return $16f0a1cc3cfa744a$export$e9d005d8e9334cae; });

var $idTJH = parcelRequire("idTJH");
var $2MDjk = parcelRequire("2MDjk");

var $exYeM = parcelRequire("exYeM");

var $2Yib7 = parcelRequire("2Yib7");
function $16f0a1cc3cfa744a$export$e9d005d8e9334cae(parser) {
    const { location: location } = (0, $2Yib7.useHistory)();
    return (0, $exYeM.useMemo)(()=>(0, $idTJH.parse)(parser, (0, $2MDjk.Route).parse(location.pathname), undefined), [
        location.pathname,
        parser
    ]);
}

});

parcelRegister("5mLQo", function(module, exports) {

$parcel$export(module.exports, "Assets", function () { return $0366ac435b2e3320$export$c8eca95e306f7116; });













// https://wiki.leagueoflegends.com/en-us/Category:Lore_icons
const $0366ac435b2e3320$var$factions = {
    bandle: new URL((parcelRequire("2ypbw"))).toString(),
    bilgewater: new URL((parcelRequire("1sINg"))).toString(),
    demacia: new URL((parcelRequire("gXQKY"))).toString(),
    freljord: new URL((parcelRequire("5In6r"))).toString(),
    ionia: new URL((parcelRequire("gQpSx"))).toString(),
    ixtal: new URL((parcelRequire("kgkG3"))).toString(),
    noxus: new URL((parcelRequire("82NcC"))).toString(),
    piltover: new URL((parcelRequire("9ebom"))).toString(),
    shadowIsles: new URL((parcelRequire("5nIDx"))).toString(),
    shurima: new URL((parcelRequire("iGg0s"))).toString(),
    targon: new URL((parcelRequire("3JQd5"))).toString(),
    void: new URL((parcelRequire("30H6y"))).toString(),
    zaun: new URL((parcelRequire("e2GJm"))).toString()
};











// https://raw.communitydragon.org/latest/plugins/rcp-fe-lol-shared-components/global/default/mastery-{n}.png
//
// Pre-process:
// 1. Put all masteries together (each in its own layer)
// 2. Create mastery 0 by removing wings of mastery 1
// 3. Crop to content
// 4. Commit those "large" versions
// 5. Reduce widths for actual use (2 times the in-app width):
//   - masteries 10-8: width 240
//   - masteries 7-0: width 116
const $0366ac435b2e3320$var$masteries = {
    0: new URL((parcelRequire("kGGMF"))).toString(),
    1: new URL((parcelRequire("P2gSk"))).toString(),
    2: new URL((parcelRequire("d7Scc"))).toString(),
    3: new URL((parcelRequire("PHyO6"))).toString(),
    4: new URL((parcelRequire("a1Pni"))).toString(),
    5: new URL((parcelRequire("fQi9j"))).toString(),
    6: new URL((parcelRequire("3DN9f"))).toString(),
    7: new URL((parcelRequire("96WMY"))).toString(),
    8: new URL((parcelRequire("dDlK4"))).toString(),
    9: new URL((parcelRequire("01WQ5"))).toString(),
    10: new URL((parcelRequire("8l2jh"))).toString()
};









// https://wiki.leagueoflegends.com/en-us/Category:Champion_stat_assets
const $0366ac435b2e3320$var$stats = {
    dmg_dealt: new URL((parcelRequire("lFsUp"))).toString(),
    dmg_taken: new URL((parcelRequire("6PYkj"))).toString(),
    healing: new URL((parcelRequire("5NORk"))).toString(),
    shielding: new URL((parcelRequire("4T1Sm"))).toString(),
    ability_haste: new URL((parcelRequire("2Odga"))).toString(),
    energyregen_mod: new URL((parcelRequire("g71LI"))).toString(),
    total_as: new URL((parcelRequire("bh9QC"))).toString(),
    movement_speed: new URL((parcelRequire("1BRnl"))).toString(),
    tenacity: new URL((parcelRequire("6GqZv"))).toString()
};










const $0366ac435b2e3320$export$c8eca95e306f7116 = {
    champion: new URL((parcelRequire("iHzuC"))).toString(),
    factions: $0366ac435b2e3320$var$factions,
    globetrotter: new URL((parcelRequire("3GRQ2"))).toString(),
    masteries: $0366ac435b2e3320$var$masteries,
    runeterra: new URL((parcelRequire("jQRry"))).toString(),
    spatula: new URL((parcelRequire("elexp"))).toString(),
    stats: $0366ac435b2e3320$var$stats,
    thirdParty: {
        dpmLol: new URL((parcelRequire("8JDW5"))).toString(),
        leagueOfGraphs: new URL((parcelRequire("hPlGP"))).toString(),
        opGg: new URL((parcelRequire("9WKQi"))).toString(),
        porofessor: new URL((parcelRequire("1Temx"))).toString(),
        yearInLol: new URL((parcelRequire("gdqTL"))).toString()
    },
    yuumiHome: new URL((parcelRequire("jLVBy"))).toString()
};

});
parcelRegister("2ypbw", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "bandle.c006a2a6.webp";

});

parcelRegister("1sINg", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "bilgewater.58d00087.webp";

});

parcelRegister("gXQKY", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "demacia.e4daa11c.webp";

});

parcelRegister("5In6r", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "freljord.744001bf.webp";

});

parcelRegister("gQpSx", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "ionia.6aea9ace.webp";

});

parcelRegister("kgkG3", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "ixtal.86197ae2.webp";

});

parcelRegister("82NcC", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "noxus.954ce344.webp";

});

parcelRegister("9ebom", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "piltover.011e21bc.webp";

});

parcelRegister("5nIDx", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "shadowIsles.25801c44.webp";

});

parcelRegister("iGg0s", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "shurima.3cd980ed.webp";

});

parcelRegister("3JQd5", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "targon.23d59733.webp";

});

parcelRegister("30H6y", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "void.43168c65.webp";

});

parcelRegister("e2GJm", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "zaun.e8da4a2f.webp";

});

parcelRegister("kGGMF", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-0.8fed1ae0.png";

});

parcelRegister("P2gSk", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-1.21920b27.png";

});

parcelRegister("d7Scc", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-2.a4fc1478.png";

});

parcelRegister("PHyO6", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-3.1cbe45a6.png";

});

parcelRegister("a1Pni", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-4.0c0f346b.png";

});

parcelRegister("fQi9j", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-5.cfc9ee95.png";

});

parcelRegister("3DN9f", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-6.2b6317f1.png";

});

parcelRegister("96WMY", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-7.d4edf5f3.png";

});

parcelRegister("dDlK4", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-8.ac344fe0.png";

});

parcelRegister("01WQ5", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-9.8f1c8b65.png";

});

parcelRegister("8l2jh", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "mastery-10.de3bd6c9.png";

});

parcelRegister("lFsUp", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "damage_amp.cb2ff0cf.webp";

});

parcelRegister("6PYkj", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "armor_penetration.66104771.webp";

});

parcelRegister("5NORk", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "heal_power.c8b3d796.webp";

});

parcelRegister("4T1Sm", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "shield_power.437195fc.webp";

});

parcelRegister("2Odga", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "ability_haste.8fbe6db0.webp";

});

parcelRegister("g71LI", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "energy_regen.f768e637.webp";

});

parcelRegister("bh9QC", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "attack_speed.81e8ef98.webp";

});

parcelRegister("1BRnl", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "movement_speed.bdd9f2d2.webp";

});

parcelRegister("6GqZv", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "tenacity.d3b34d47.webp";

});

parcelRegister("iHzuC", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "champion.3213ca9c.webp";

});

parcelRegister("3GRQ2", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "globetrotter.8936141a.png";

});

parcelRegister("jQRry", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "runeterra.83ef5934.png";

});

parcelRegister("elexp", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "spatula.4655b2c1.png";

});

parcelRegister("8JDW5", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "dpm-lol.d7c4d9eb.png";

});

parcelRegister("hPlGP", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "league-of-graphs.143b9e5d.png";

});

parcelRegister("9WKQi", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "op-gg.3c7751c0.png";

});

parcelRegister("1Temx", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "porofessor.06889782.png";

});

parcelRegister("gdqTL", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "year-in-lol.1d22245c.png";

});

parcelRegister("jLVBy", function(module, exports) {

module.exports = (parcelRequire("aNJCr")).getBundleURL('fLaAm') + "yuumi-home.2e417a16.png";

});


parcelRegister("khrbF", function(module, exports) {

$parcel$export(module.exports, "HowlingAbyssSimple", function () { return $50eeeb14d42dc36b$export$d375e6851ad80dc0; });

var $aSiaI = parcelRequire("aSiaI");

var $ahEiN = parcelRequire("ahEiN");
const $50eeeb14d42dc36b$export$6d4d0c47818f0b1f = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 91 91",
        className: className,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("g", {
            transform: "translate(-5,-5)",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeDasharray: "none",
                    d: "m 55.5,7.5 -6,6 h -8 l -6,6 h -16 v 16 l -6,6 v 8 L 7.5,55.5 V 93.5 H 45.5 l 6,-6 h 8 l 6,-6 h 16 v -16 l 6,-6 v -8 l 6,-6 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "3",
                    strokeDasharray: "none",
                    d: "M 55.5,7.5 43.5,19.5 H 19.5 V 43.5 L 7.5,55.5 V 93.5 H 45.5 L 57.5,81.5 H 81.5 V 57.5 L 93.5,45.5 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "5",
                    strokeDasharray: "none",
                    d: "M 55.5,7.5 37.5,25.5 H 25.5 V 37.5 L 7.5,55.5 V 93.5 H 45.5 L 63.5,75.5 H 75.5 V 63.5 L 93.5,45.5 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    fill: (0, $ahEiN.secondaryColor),
                    stroke: "none",
                    d: "m 15.5,59.5 44,-44 h 26 v 26 l -44,44 h -26 z"
                })
            ]
        })
    });
const $50eeeb14d42dc36b$export$d375e6851ad80dc0 = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 96 96",
        className: className,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("g", {
            transform: "translate(-2.5,-2.5)",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "10",
                    strokeDasharray: "none",
                    d: "M 55.5,7.5 43.5,19.5 H 19.5 V 43.5 L 7.5,55.5 V 93.5 H 45.5 L 57.5,81.5 H 81.5 V 57.5 L 93.5,45.5 V 7.5 Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    fill: (0, $ahEiN.secondaryColor),
                    stroke: "none",
                    d: "m 23.5,62.5 39,-39 h 15 v 15 l -39,39 h -15 z"
                })
            ]
        })
    });

});

parcelRegister("iz2wS", function(module, exports) {

$parcel$export(module.exports, "appMatches", function () { return $8c50312319fd8b4f$export$ca9aa00c3e4d1655; });
$parcel$export(module.exports, "appParsers", function () { return $8c50312319fd8b4f$export$bcd2c8cb769b6f17; });
$parcel$export(module.exports, "appRoutes", function () { return $8c50312319fd8b4f$export$61147a57d3c24ac8; });

var $61eNN = parcelRequire("61eNN");
var $9fMqj = parcelRequire("9fMqj");

var $5Dwzl = parcelRequire("5Dwzl");

var $7pd72 = parcelRequire("7pd72");

var $appXD = parcelRequire("appXD");

var $87QkX = parcelRequire("87QkX");

var $hrnY6 = parcelRequire("hrnY6");

var $fzgvm = parcelRequire("fzgvm");

var $bdAIi = parcelRequire("bdAIi");

var $bICKq = parcelRequire("bICKq");
const { codec: $8c50312319fd8b4f$var$codec } = (0, $87QkX.RouterUtils);
const $8c50312319fd8b4f$export$3ceb0509ba9dc0e5 = (0, $appXD.RiotId).getFromStringCodec('-');
/**
 * matches
 */ const $8c50312319fd8b4f$var$platformM = $8c50312319fd8b4f$var$codec('platform', (0, $5Dwzl.Platform).orLowerCaseCodec);
const $8c50312319fd8b4f$var$sPlatformPuuidMatch = (0, $61eNN.lit)('s').then($8c50312319fd8b4f$var$platformM).then($8c50312319fd8b4f$var$codec('puuid', (0, $7pd72.Puuid).codec));
const $8c50312319fd8b4f$var$sPlatformPuuidGameMatch = $8c50312319fd8b4f$var$sPlatformPuuidMatch.then((0, $61eNN.lit)('game'));
const $8c50312319fd8b4f$var$platformRiotIdMatch = $8c50312319fd8b4f$var$platformM.then($8c50312319fd8b4f$var$codec('riotId', $8c50312319fd8b4f$export$3ceb0509ba9dc0e5));
const $8c50312319fd8b4f$var$platformRiotIdGameMatch = $8c50312319fd8b4f$var$platformRiotIdMatch.then((0, $61eNN.lit)('game'));
const $8c50312319fd8b4f$var$aramMatch = (0, $61eNN.lit)('aram');
const $8c50312319fd8b4f$var$urfMatch = (0, $61eNN.lit)('urf');
const $8c50312319fd8b4f$var$factionsMatch = (0, $61eNN.lit)('factions');
const $8c50312319fd8b4f$var$timersMatch = (0, $61eNN.lit)('timers');
const $8c50312319fd8b4f$var$loginMatch = (0, $61eNN.lit)('login');
const $8c50312319fd8b4f$var$registerMatch = (0, $61eNN.lit)('register');
const $8c50312319fd8b4f$var$discordRedirectMatch = (0, $61eNN.lit)('discordRedirect');
const $8c50312319fd8b4f$export$ca9aa00c3e4d1655 = {
    sPlatformPuuid: $8c50312319fd8b4f$var$sPlatformPuuidMatch.then((0, $61eNN.end)),
    sPlatformPuuidGame: $8c50312319fd8b4f$var$sPlatformPuuidGameMatch.then((0, $61eNN.end)),
    platformRiotId: $8c50312319fd8b4f$var$platformRiotIdMatch.then((0, $61eNN.end)),
    platformRiotIdGame: $8c50312319fd8b4f$var$platformRiotIdGameMatch.then((0, $61eNN.end))
};
/**
 * parsers
 *
 * Don't forget .then(end).parser (or use p)
 */ const $8c50312319fd8b4f$var$sPlatformPuuid = $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$sPlatformPuuidMatch);
const $8c50312319fd8b4f$var$sPlatformPuuidGame = $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$sPlatformPuuidGameMatch);
const $8c50312319fd8b4f$var$platformRiotId = $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$platformRiotIdMatch);
const $8c50312319fd8b4f$var$platformRiotIdGame = $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$platformRiotIdGameMatch);
const $8c50312319fd8b4f$var$anyPlatformRiotId = $8c50312319fd8b4f$var$platformRiotId.alt($8c50312319fd8b4f$var$platformRiotIdGame).map(({ platform: platform, riotId: riotId })=>({
        platform: (0, $hrnY6.StringUtils).toUpperCase(platform),
        riotId: riotId
    }));
const $8c50312319fd8b4f$var$anyPlatform = $8c50312319fd8b4f$var$sPlatformPuuid.alt($8c50312319fd8b4f$var$sPlatformPuuidGame).map(({ platform: platform })=>({
        platform: (0, $hrnY6.StringUtils).toUpperCase(platform)
    })).alt($8c50312319fd8b4f$var$anyPlatformRiotId);
const $8c50312319fd8b4f$export$bcd2c8cb769b6f17 = {
    index: (0, $61eNN.end).parser,
    sPlatformPuuid: $8c50312319fd8b4f$var$sPlatformPuuid,
    sPlatformPuuidGame: $8c50312319fd8b4f$var$sPlatformPuuidGame,
    platformRiotId: $8c50312319fd8b4f$var$platformRiotId,
    platformRiotIdGame: $8c50312319fd8b4f$var$platformRiotIdGame,
    aram: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$aramMatch),
    urf: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$urfMatch),
    factions: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$factionsMatch),
    timers: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$timersMatch),
    login: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$loginMatch),
    register: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$registerMatch),
    discordRedirect: $8c50312319fd8b4f$var$p($8c50312319fd8b4f$var$discordRedirectMatch),
    anyAdmin: (0, $bICKq.adminParsers).any,
    anyPlatform: $8c50312319fd8b4f$var$anyPlatform,
    anyPlatformRiotId: $8c50312319fd8b4f$var$anyPlatformRiotId
};
const $8c50312319fd8b4f$export$61147a57d3c24ac8 = {
    index: (0, $9fMqj.format)((0, $61eNN.end).formatter, {}),
    sPlatformPuuid: (platform, puuid, query)=>$8c50312319fd8b4f$var$withQuery((0, $9fMqj.format)($8c50312319fd8b4f$var$sPlatformPuuidMatch.formatter, {
            platform: platform,
            puuid: puuid
        }), (0, $bdAIi.PartialMasteriesQuery), query),
    sPlatformPuuidGame: (platform, puuid)=>(0, $9fMqj.format)($8c50312319fd8b4f$var$sPlatformPuuidGameMatch.formatter, {
            platform: platform,
            puuid: puuid
        }),
    platformRiotId: (platform, riotId, query)=>$8c50312319fd8b4f$var$withQuery((0, $9fMqj.format)($8c50312319fd8b4f$var$platformRiotIdMatch.formatter, {
            platform: platform,
            riotId: riotId
        }), (0, $bdAIi.PartialMasteriesQuery), query),
    platformRiotIdGame: (platform, riotId)=>(0, $9fMqj.format)($8c50312319fd8b4f$var$platformRiotIdGameMatch.formatter, {
            platform: platform,
            riotId: riotId
        }),
    aram: (query)=>$8c50312319fd8b4f$var$withQuery((0, $9fMqj.format)($8c50312319fd8b4f$var$aramMatch.formatter, {}), (0, $fzgvm.PartialGenericQuery), query),
    urf: (query)=>$8c50312319fd8b4f$var$withQuery((0, $9fMqj.format)($8c50312319fd8b4f$var$urfMatch.formatter, {}), (0, $fzgvm.PartialGenericQuery), query),
    factions: (query)=>$8c50312319fd8b4f$var$withQuery((0, $9fMqj.format)($8c50312319fd8b4f$var$factionsMatch.formatter, {}), (0, $fzgvm.PartialGenericQuery), query),
    timers: (0, $9fMqj.format)($8c50312319fd8b4f$var$timersMatch.formatter, {}),
    login: (0, $9fMqj.format)($8c50312319fd8b4f$var$loginMatch.formatter, {}),
    register: (0, $9fMqj.format)($8c50312319fd8b4f$var$registerMatch.formatter, {})
};
const $8c50312319fd8b4f$var$withQuery = (path, { qsStringify: qsStringify }, a)=>{
    const query = qsStringify(a);
    return `${path}${query === '' ? '' : `?${query}`}`;
};
function $8c50312319fd8b4f$var$p(match) {
    return match.then((0, $61eNN.end)).parser;
}

});
parcelRegister("bICKq", function(module, exports) {

$parcel$export(module.exports, "adminParsers", function () { return $ee245f3dac253e3a$export$49ed771160a51f2; });
$parcel$export(module.exports, "adminRoutes", function () { return $ee245f3dac253e3a$export$37e8e188eda774db; });

var $61eNN = parcelRequire("61eNN");
var $9fMqj = parcelRequire("9fMqj");
/**
 * matches
 */ const $ee245f3dac253e3a$var$admin = (0, $61eNN.lit)('admin');
const $ee245f3dac253e3a$var$adminHallOfFame = $ee245f3dac253e3a$var$admin.then((0, $61eNN.lit)('hall-of-fame'));
const $ee245f3dac253e3a$export$49ed771160a51f2 = {
    index: $ee245f3dac253e3a$var$p($ee245f3dac253e3a$var$admin),
    hallOfFame: $ee245f3dac253e3a$var$p($ee245f3dac253e3a$var$adminHallOfFame),
    any: $ee245f3dac253e3a$var$admin.parser
};
const $ee245f3dac253e3a$export$37e8e188eda774db = {
    index: (0, $9fMqj.format)($ee245f3dac253e3a$var$admin.formatter, {}),
    hallOfFame: (0, $9fMqj.format)($ee245f3dac253e3a$var$adminHallOfFame.formatter, {})
};
function $ee245f3dac253e3a$var$p(match) {
    return match.then((0, $61eNN.end)).parser;
}

});


parcelRegister("avpuJ", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $6cf8858448d410af$export$a6c7ac8248d6e38a; });
/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $2Yib7 = parcelRequire("2Yib7");

var $5MBh5 = parcelRequire("5MBh5");
const $6cf8858448d410af$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ to: to, onClick: onClick_, disabled: disabled = false, className: className, children: children }, ref)=>{
    const { navigate: navigate } = (0, $2Yib7.useHistory)();
    const onClick = (0, $exYeM.useCallback)((e)=>{
        if (disabled) e.preventDefault();
        else {
            onClick_?.(e);
            if (!e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                navigate(to);
            }
        }
    }, [
        disabled,
        navigate,
        onClick_,
        to
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
        ref: ref,
        href: to,
        onClick: onClick,
        className: (0, $5MBh5.cx)([
            'cursor-default',
            disabled
        ], className),
        children: children
    });
});

});

parcelRegister("7CMrG", function(module, exports) {

$parcel$export(module.exports, "MaskedImage", function () { return $29e8e7112e2a219c$export$defc10abee3e0fb8; });

var $aSiaI = parcelRequire("aSiaI");

var $5MBh5 = parcelRequire("5MBh5");
const $29e8e7112e2a219c$export$defc10abee3e0fb8 = ({ src: src, className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        className: (0, $5MBh5.cx)('block bg-current', className),
        style: {
            maskImage: `url(${src})`,
            WebkitMaskImage: `url(${src})`,
            maskSize: '100% 100%, contain',
            WebkitMaskSize: '100% 100%, contain'
        }
    });

});

parcelRegister("1sXco", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $2e497f5a496f21a5$export$28c660c63b792dea; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $hPJN4 = parcelRequire("hPJN4");

var $9ddGv = parcelRequire("9ddGv");

var $14u1Q = parcelRequire("14u1Q");

var $dR62Q = parcelRequire("dR62Q");

var $5MBh5 = parcelRequire("5MBh5");
const $2e497f5a496f21a5$var$tooltipLayerId = 'tooltip-layer';
const $2e497f5a496f21a5$var$tooltipLayer = document.getElementById($2e497f5a496f21a5$var$tooltipLayerId);
if ($2e497f5a496f21a5$var$tooltipLayer === null) // eslint-disable-next-line functional/no-throw-statements
throw Error(`Tooltip layer not found: #${$2e497f5a496f21a5$var$tooltipLayerId}`);
const $2e497f5a496f21a5$export$28c660c63b792dea = ({ hoverRef: hoverRef_, placementRef: maybePlacementRef, openedDuration: openedDuration = (0, $hPJN4.MsDuration).seconds(3), placement: placement = 'bottom', alwaysVisible: alwaysVisible = false, shouldHide: shouldHide, className: className, children: children })=>{
    const hoverRefs_ = $2e497f5a496f21a5$var$isArray(hoverRef_) ? hoverRef_ : (0, $9ddGv.NonEmptyArray).of(hoverRef_);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const hoverRefs = (0, $exYeM.useMemo)(()=>hoverRefs_, hoverRefs_);
    const placementRef_ = maybePlacementRef ?? (0, $9ddGv.NonEmptyArray).head(hoverRefs);
    const [shouldDisplay_, setShouldDisplay_] = (0, $exYeM.useState)(false);
    const tooltipRef = (0, $exYeM.useRef)(null);
    const arrowRef = (0, $exYeM.useRef)(null);
    const shouldDisplay = alwaysVisible || shouldDisplay_;
    const [eventListenersEnabled, setEventListenersEnabled] = (0, $exYeM.useState)(false);
    const options = (0, $exYeM.useMemo)(()=>({
            placement: placement,
            modifiers: [
                {
                    name: 'arrow',
                    options: {
                        element: arrowRef.current
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            7
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 8
                    }
                },
                {
                    name: 'flip',
                    options: {
                        padding: 8
                    }
                },
                {
                    name: 'eventListeners',
                    enabled: eventListenersEnabled
                }
            ]
        }), [
        eventListenersEnabled,
        placement
    ]);
    const { styles: styles, attributes: attributes } = (0, $14u1Q.useVisiblePopper)(shouldDisplay, placementRef_.current, tooltipRef.current, options);
    const timer = (0, $exYeM.useRef)();
    const hideTooltip = (0, $exYeM.useCallback)(()=>{
        window.clearTimeout(timer.current);
        setEventListenersEnabled(false);
        setShouldDisplay_(false);
    }, []);
    // Calls `hideTooltip` when changed to `true`
    (0, $exYeM.useEffect)(()=>{
        if (shouldHide === true) hideTooltip();
    }, [
        hideTooltip,
        shouldHide
    ]);
    /**
   * Function that adds 'click' and 'mouseover/mouseleave' event listeners on 'hoverRef'.
   * Those listeners will mutate `shouldDisplayRef` inner value to control whether or not the tooltip should be displayed.
   */ const setupHoverClickListeners = (0, $exYeM.useCallback)(()=>{
        const hovers = hoverRefs.map((r)=>r.current);
        function showTooltip() {
            if (hovers.every((h)=>h === null)) return;
            window.clearTimeout(timer.current);
            setEventListenersEnabled(true);
            setShouldDisplay_(true);
        }
        function clickTooltip() {
            showTooltip();
            // And hide it afterwards.
            // eslint-disable-next-line functional/immutable-data
            timer.current = window.setTimeout(()=>{
                hideTooltip();
            }, (0, $hPJN4.MsDuration).unwrap(openedDuration));
        }
        hovers.forEach((hover)=>{
            if (hover === null) return;
            // React to hover in / out for desktop users.
            hover.addEventListener('mouseover', showTooltip, true);
            hover.addEventListener('mouseleave', hideTooltip, true);
            // React to click / tap for tablet users.
            hover.addEventListener('click', clickTooltip, true);
        });
        return ()=>{
            window.clearTimeout(timer.current);
            hovers.forEach((hover)=>{
                if (hover === null) return;
                hover.removeEventListener('click', clickTooltip, true);
                hover.removeEventListener('mouseover', showTooltip, true);
                hover.removeEventListener('mouseleave', hideTooltip, true);
            });
        };
    }, [
        hideTooltip,
        hoverRefs,
        openedDuration
    ]);
    // Set hover / click listeners to display or hide the tooltip.
    (0, $exYeM.useEffect)(setupHoverClickListeners, [
        setupHoverClickListeners
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $d2lNW.createPortal)(/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            ref: tooltipRef,
            className: (0, $5MBh5.cx)('group z-40 whitespace-nowrap border border-tooltip bg-zinc-900 px-2 py-1 text-sm text-wheat shadow-even shadow-black transition-opacity duration-300', shouldDisplay ? 'visible opacity-100' : 'invisible opacity-0', className),
            style: styles['popper'],
            ...attributes['popper'],
            children: [
                children,
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    ref: arrowRef,
                    className: "h-1.5 w-2.5 group-data-popper-top:-bottom-1.5 group-data-popper-bottom:-top-1.5 group-data-popper-left:-right-2 group-data-popper-right:-left-2",
                    style: styles['arrow'],
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CaretUpSharpCropped), {
                        className: (0, $5MBh5.cx)('text-tooltip group-data-popper-top:rotate-180', {
                            'group-data-popper-bottom:rotate-0': placement.startsWith('top'),
                            'group-data-popper-left:rotate-90 group-data-popper-right:-rotate-90': placement.startsWith('right') || placement.startsWith('left')
                        })
                    })
                })
            ]
        }), $2e497f5a496f21a5$var$tooltipLayer)
    });
};
const $2e497f5a496f21a5$var$isArray = Array.isArray;

});
parcelRegister("14u1Q", function(module, exports) {

$parcel$export(module.exports, "useVisiblePopper", function () { return $51700a42a6b2c09a$export$7fa6200c0c44eb2e; });
/* eslint-disable functional/no-expression-statements */ 
var $exYeM = parcelRequire("exYeM");

var $ipxnx = parcelRequire("ipxnx");
function $51700a42a6b2c09a$export$7fa6200c0c44eb2e(isVisible, referenceElement, popperElement, options) {
    const result = (0, $ipxnx.usePopper)(referenceElement, popperElement, options);
    const { update: update } = result;
    (0, $exYeM.useEffect)(()=>{
        if (isVisible) update?.();
    }, [
        isVisible,
        update
    ]);
    return result;
}

});
parcelRegister("ipxnx", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $d674741d7e6ed1a9$export$f4d5bf230a36dd6e; });

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $d6CNR = parcelRequire("d6CNR");

var $g6MkC = parcelRequire("g6MkC");

var $QeZ0i = parcelRequire("QeZ0i");
var $d674741d7e6ed1a9$var$EMPTY_MODIFIERS = [];
var $d674741d7e6ed1a9$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $exYeM.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $d674741d7e6ed1a9$var$EMPTY_MODIFIERS
    };
    var _React$useState = $exYeM.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $exYeM.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $d2lNW.flushSync(function() {
                    setState({
                        styles: (0, $QeZ0i.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $QeZ0i.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $exYeM.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($g6MkC)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $exYeM.useRef();
    (0, $QeZ0i.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $QeZ0i.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $d6CNR.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("d6CNR", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $98a9ef6d31ff03cd$export$8f7491d57c8f97a9; });

var $24WJr = parcelRequire("24WJr");

var $lsNQz = parcelRequire("lsNQz");

var $ksntq = parcelRequire("ksntq");

var $xcXwJ = parcelRequire("xcXwJ");

var $4dG9Q = parcelRequire("4dG9Q");

var $c8CJF = parcelRequire("c8CJF");

var $iMl36 = parcelRequire("iMl36");

var $6blW5 = parcelRequire("6blW5");

var $2P8UZ = parcelRequire("2P8UZ");

var $aKE1P = parcelRequire("aKE1P");


var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $lsNQz.default),
    (0, $ksntq.default),
    (0, $xcXwJ.default),
    (0, $4dG9Q.default),
    (0, $c8CJF.default),
    (0, $iMl36.default),
    (0, $6blW5.default),
    (0, $2P8UZ.default),
    (0, $aKE1P.default)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $24WJr.popperGenerator)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("24WJr", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $1839837374f95732$export$ed5e13716264f202; });

var $f7rEH = parcelRequire("f7rEH");

var $eQTzt = parcelRequire("eQTzt");

var $3yaXD = parcelRequire("3yaXD");

var $5jKxG = parcelRequire("5jKxG");

var $5XeBn = parcelRequire("5XeBn");

var $9n6Ia = parcelRequire("9n6Ia");

var $b7Gje = parcelRequire("b7Gje");


var $9ghG1 = parcelRequire("9ghG1");
var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $9ghG1.isElement)(reference) ? (0, $3yaXD.default)(reference) : reference.contextElement ? (0, $3yaXD.default)(reference.contextElement) : [],
                    popper: (0, $3yaXD.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $5XeBn.default)((0, $b7Gje.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $f7rEH.default)(reference, (0, $5jKxG.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $eQTzt.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9n6Ia.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("f7rEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b01cf64433a5b37b$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");

var $fIrSM = parcelRequire("fIrSM");

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");

var $k1Xeb = parcelRequire("k1Xeb");

var $4NPk2 = parcelRequire("4NPk2");

var $d5v3T = parcelRequire("d5v3T");

var $c79oh = parcelRequire("c79oh");
function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $c79oh.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $c79oh.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $9ghG1.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $9ghG1.isHTMLElement)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $4NPk2.default)(offsetParent);
    var rect = (0, $2mYUo.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1DgzM.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $d5v3T.default)(documentElement)) scroll = (0, $fIrSM.default)(offsetParent);
        if ((0, $9ghG1.isHTMLElement)(offsetParent)) {
            offsets = (0, $2mYUo.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $k1Xeb.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2mYUo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b9ce20ada6267ed$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");

var $c79oh = parcelRequire("c79oh");

var $3s2ws = parcelRequire("3s2ws");

var $fvb08 = parcelRequire("fvb08");
function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $9ghG1.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $c79oh.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $c79oh.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $9ghG1.isElement)(element) ? (0, $3s2ws.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fvb08.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("9ghG1", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $6be351e83d6bf643$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $6be351e83d6bf643$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $6be351e83d6bf643$export$af51f0f06c0f328a; });

var $3s2ws = parcelRequire("3s2ws");
function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3s2ws.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3s2ws.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $3s2ws.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3s2ws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2835f189066da699$export$2e2bcd8739ae039; });
function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("c79oh", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $8d1d6c453d67c9ab$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $8d1d6c453d67c9ab$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $8d1d6c453d67c9ab$export$2077e0241d6afd3c; });
var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fvb08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b49248e188a52b8b$export$2e2bcd8739ae039; });

var $cTNvd = parcelRequire("cTNvd");
function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $cTNvd.default)());
}

});
parcelRegister("cTNvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9641053f99441231$export$2e2bcd8739ae039; });
function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("fIrSM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71097fc0b0e5f5c$export$2e2bcd8739ae039; });

var $VtlZ3 = parcelRequire("VtlZ3");

var $3s2ws = parcelRequire("3s2ws");

var $9ghG1 = parcelRequire("9ghG1");

var $hbsCN = parcelRequire("hbsCN");
function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $3s2ws.default)(node) || !(0, $9ghG1.isHTMLElement)(node)) return (0, $VtlZ3.default)(node);
    else return (0, $hbsCN.default)(node);
}

});
parcelRegister("VtlZ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0acc17feb41c51bd$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $3s2ws.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("hbsCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c829ab0279467772$export$2e2bcd8739ae039; });
function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("1DgzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13064aa41dd611dc$export$2e2bcd8739ae039; });
function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("k1Xeb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e951d80a0194865c$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");

var $4NPk2 = parcelRequire("4NPk2");

var $VtlZ3 = parcelRequire("VtlZ3");
function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2mYUo.default)((0, $4NPk2.default)(element)).left + (0, $VtlZ3.default)(element).scrollLeft;
}

});
parcelRegister("4NPk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f38c85c1edad4d$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");
function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $9ghG1.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("d5v3T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9873d63ab8539814$export$2e2bcd8739ae039; });

var $3lU8c = parcelRequire("3lU8c");
function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3lU8c.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("3lU8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $270edfbc2bfbd22f$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $3s2ws.default)(element).getComputedStyle(element);
}

});



parcelRegister("eQTzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad01075005a54bff$export$2e2bcd8739ae039; });

var $2mYUo = parcelRequire("2mYUo");
function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2mYUo.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("3yaXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $295d0ca7e8ef250a$export$2e2bcd8739ae039; });

var $gScKu = parcelRequire("gScKu");

var $gBzyr = parcelRequire("gBzyr");

var $3s2ws = parcelRequire("3s2ws");

var $d5v3T = parcelRequire("d5v3T");
function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $gScKu.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3s2ws.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $d5v3T.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $gBzyr.default)(target)));
}

});
parcelRegister("gScKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c48b941fd834c962$export$2e2bcd8739ae039; });

var $gBzyr = parcelRequire("gBzyr");

var $d5v3T = parcelRequire("d5v3T");

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");
function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $1DgzM.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $9ghG1.isHTMLElement)(node) && (0, $d5v3T.default)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $gBzyr.default)(node));
}

});
parcelRegister("gBzyr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c16bae6800ecc025$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");

var $4NPk2 = parcelRequire("4NPk2");

var $9ghG1 = parcelRequire("9ghG1");
function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $1DgzM.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $9ghG1.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4NPk2.default)(element) // fallback
    );
}

});



parcelRegister("5jKxG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3df2d470c30a409e$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");

var $1DgzM = parcelRequire("1DgzM");

var $3lU8c = parcelRequire("3lU8c");

var $9ghG1 = parcelRequire("9ghG1");

var $3pGhD = parcelRequire("3pGhD");

var $gBzyr = parcelRequire("gBzyr");

var $cTNvd = parcelRequire("cTNvd");
function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $9ghG1.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3lU8c.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $cTNvd.default)());
    var isIE = /Trident/i.test((0, $cTNvd.default)());
    if (isIE && (0, $9ghG1.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3lU8c.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $gBzyr.default)(element);
    if ((0, $9ghG1.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $9ghG1.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $1DgzM.default)(currentNode)) < 0){
        var css = (0, $3lU8c.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $3s2ws.default)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3pGhD.default)(offsetParent) && (0, $3lU8c.default)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1DgzM.default)(offsetParent) === 'html' || (0, $1DgzM.default)(offsetParent) === 'body' && (0, $3lU8c.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}

});
parcelRegister("3pGhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27c48183f07ddbe8$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");
function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $1DgzM.default)(element)) >= 0;
}

});


parcelRegister("5XeBn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $455dca0e08f2a815$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");
function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $cEoCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cEoCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $935c50c8659545b7$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $935c50c8659545b7$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $935c50c8659545b7$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $935c50c8659545b7$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $935c50c8659545b7$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $935c50c8659545b7$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $935c50c8659545b7$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $935c50c8659545b7$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $935c50c8659545b7$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $935c50c8659545b7$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $935c50c8659545b7$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $935c50c8659545b7$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $935c50c8659545b7$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $935c50c8659545b7$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $935c50c8659545b7$export$d087d3878fdf71d5; });
var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];

});


parcelRegister("9n6Ia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d2b77c34ff005f5$export$2e2bcd8739ae039; });
function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("b7Gje", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81912adbd60ec5c0$export$2e2bcd8739ae039; });
function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("lsNQz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa02e10eb4995658$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");
var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3s2ws.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};

});

parcelRegister("ksntq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee48a1861d343976$export$2e2bcd8739ae039; });

var $6OVAc = parcelRequire("6OVAc");
function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $6OVAc.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};

});
parcelRegister("6OVAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f7414566eeea71a$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $8Opre = parcelRequire("8Opre");

var $3m9cx = parcelRequire("3m9cx");

var $cEoCh = parcelRequire("cEoCh");
function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8MGgd.default)(placement) : null;
    var variation = placement ? (0, $8Opre.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cEoCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cEoCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cEoCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cEoCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $3m9cx.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cEoCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cEoCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("8MGgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6653967f933aaf29$export$2e2bcd8739ae039; });

function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("8Opre", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66a6b9b7896d6ec4$export$2e2bcd8739ae039; });
function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("3m9cx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $271a905a3adf884c$export$2e2bcd8739ae039; });
function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("xcXwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063d2297888fea12$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $5jKxG = parcelRequire("5jKxG");

var $3s2ws = parcelRequire("3s2ws");

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $8MGgd = parcelRequire("8MGgd");

var $8Opre = parcelRequire("8Opre");

var $c79oh = parcelRequire("c79oh");
var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $c79oh.round)(x * dpr) / dpr || 0,
        y: (0, $c79oh.round)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cEoCh.left);
    var sideY = (0, $cEoCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5jKxG.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $3s2ws.default)(popper)) {
            offsetParent = (0, $4NPk2.default)(popper);
            if ((0, $3lU8c.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cEoCh.top) || (placement === (0, $cEoCh.left) || placement === (0, $cEoCh.right)) && variation === (0, $cEoCh.end)) {
            sideY = (0, $cEoCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cEoCh.left) || (placement === (0, $cEoCh.top) || placement === (0, $cEoCh.bottom)) && variation === (0, $cEoCh.end)) {
            sideX = (0, $cEoCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3s2ws.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8MGgd.default)(state.placement),
        variation: (0, $8Opre.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};

});

parcelRegister("4dG9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $312913fa2edc14b2$export$2e2bcd8739ae039; });

var $1DgzM = parcelRequire("1DgzM");

var $9ghG1 = parcelRequire("9ghG1");
// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $9ghG1.isHTMLElement)(element) || !(0, $1DgzM.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $9ghG1.isHTMLElement)(element) || !(0, $1DgzM.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("c8CJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d644778f0e020f0$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $cEoCh = parcelRequire("cEoCh");
function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8MGgd.default)(placement);
    var invertDistance = [
        (0, $cEoCh.left),
        (0, $cEoCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cEoCh.left),
        (0, $cEoCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cEoCh.placements).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};

});

parcelRegister("iMl36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dabd09962ff7b702$export$2e2bcd8739ae039; });

var $ivINy = parcelRequire("ivINy");

var $8MGgd = parcelRequire("8MGgd");

var $7Bece = parcelRequire("7Bece");

var $9Ddln = parcelRequire("9Ddln");

var $gnuPI = parcelRequire("gnuPI");

var $cEoCh = parcelRequire("cEoCh");

var $8Opre = parcelRequire("8Opre");
function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8MGgd.default)(placement) === (0, $cEoCh.auto)) return [];
    var oppositePlacement = (0, $ivINy.default)(placement);
    return [
        (0, $7Bece.default)(placement),
        oppositePlacement,
        (0, $7Bece.default)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8MGgd.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ivINy.default)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8MGgd.default)(placement) === (0, $cEoCh.auto) ? (0, $gnuPI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8MGgd.default)(placement);
        var isStartVariation = (0, $8Opre.default)(placement) === (0, $cEoCh.start);
        var isVertical = [
            (0, $cEoCh.top),
            (0, $cEoCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9Ddln.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cEoCh.right) : (0, $cEoCh.left) : isStartVariation ? (0, $cEoCh.bottom) : (0, $cEoCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ivINy.default)(mainVariationSide);
        var altVariationSide = (0, $ivINy.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("ivINy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d79ddf39683d3f91$export$2e2bcd8739ae039; });
var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}

});

parcelRegister("7Bece", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5887002dcefa0743$export$2e2bcd8739ae039; });
var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}

});

parcelRegister("9Ddln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70321b611e132ecc$export$2e2bcd8739ae039; });

var $cHqSr = parcelRequire("cHqSr");

var $4NPk2 = parcelRequire("4NPk2");

var $2mYUo = parcelRequire("2mYUo");

var $6OVAc = parcelRequire("6OVAc");

var $2tr8P = parcelRequire("2tr8P");

var $cEoCh = parcelRequire("cEoCh");

var $9ghG1 = parcelRequire("9ghG1");

var $VHjvt = parcelRequire("VHjvt");

var $jxLne = parcelRequire("jxLne");
function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cEoCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cEoCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cEoCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $VHjvt.default)(typeof padding !== 'number' ? padding : (0, $jxLne.default)(padding, (0, $cEoCh.basePlacements)));
    var altContext = elementContext === (0, $cEoCh.popper) ? (0, $cEoCh.reference) : (0, $cEoCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $cHqSr.default)((0, $9ghG1.isElement)(element) ? element : element.contextElement || (0, $4NPk2.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2mYUo.default)(state.elements.reference);
    var popperOffsets = (0, $6OVAc.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2tr8P.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cEoCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cEoCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cEoCh.right),
                (0, $cEoCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cEoCh.top),
                (0, $cEoCh.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("cHqSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ee5964b4e9d426$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $aMU0E = parcelRequire("aMU0E");

var $eHRAH = parcelRequire("eHRAH");

var $3yaXD = parcelRequire("3yaXD");

var $5jKxG = parcelRequire("5jKxG");

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $9ghG1 = parcelRequire("9ghG1");

var $2mYUo = parcelRequire("2mYUo");

var $gBzyr = parcelRequire("gBzyr");

var $1yHmV = parcelRequire("1yHmV");

var $1DgzM = parcelRequire("1DgzM");

var $2tr8P = parcelRequire("2tr8P");

var $c79oh = parcelRequire("c79oh");
function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2mYUo.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cEoCh.viewport) ? (0, $2tr8P.default)((0, $aMU0E.default)(element, strategy)) : (0, $9ghG1.isElement)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2tr8P.default)((0, $eHRAH.default)((0, $4NPk2.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $3yaXD.default)((0, $gBzyr.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3lU8c.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $9ghG1.isHTMLElement)(element) ? (0, $5jKxG.default)(element) : element;
    if (!(0, $9ghG1.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $9ghG1.isElement)(clippingParent) && (0, $1yHmV.default)(clippingParent, clipperElement) && (0, $1DgzM.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $c79oh.max)(rect.top, accRect.top);
        accRect.right = (0, $c79oh.min)(rect.right, accRect.right);
        accRect.bottom = (0, $c79oh.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $c79oh.max)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("aMU0E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7da9d5689cacb0a6$export$2e2bcd8739ae039; });

var $3s2ws = parcelRequire("3s2ws");

var $4NPk2 = parcelRequire("4NPk2");

var $k1Xeb = parcelRequire("k1Xeb");

var $fvb08 = parcelRequire("fvb08");
function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3s2ws.default)(element);
    var html = (0, $4NPk2.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fvb08.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $k1Xeb.default)(element),
        y: y
    };
}

});

parcelRegister("eHRAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab4ea6dd03061fae$export$2e2bcd8739ae039; });

var $4NPk2 = parcelRequire("4NPk2");

var $3lU8c = parcelRequire("3lU8c");

var $k1Xeb = parcelRequire("k1Xeb");

var $VtlZ3 = parcelRequire("VtlZ3");

var $c79oh = parcelRequire("c79oh");
function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4NPk2.default)(element);
    var winScroll = (0, $VtlZ3.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $c79oh.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $c79oh.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $k1Xeb.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3lU8c.default)(body || html).direction === 'rtl') x += (0, $c79oh.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("1yHmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $122a9b90bb37fc73$export$2e2bcd8739ae039; });

var $9ghG1 = parcelRequire("9ghG1");
function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $9ghG1.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("2tr8P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd357ee33805adc$export$2e2bcd8739ae039; });
function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("VHjvt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ad6ec2b432662d8$export$2e2bcd8739ae039; });

var $83sLw = parcelRequire("83sLw");
function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $83sLw.default)(), paddingObject);
}

});
parcelRegister("83sLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dd4eac14cb3a9cb$export$2e2bcd8739ae039; });
function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("jxLne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3a5d8ce75f76756$export$2e2bcd8739ae039; });
function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("gnuPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bec6b628c79c2a3d$export$2e2bcd8739ae039; });

var $8Opre = parcelRequire("8Opre");

var $cEoCh = parcelRequire("cEoCh");

var $9Ddln = parcelRequire("9Ddln");

var $8MGgd = parcelRequire("8MGgd");
function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cEoCh.placements) : _options$allowedAutoP;
    var variation = (0, $8Opre.default)(placement);
    var placements = variation ? flipVariations ? (0, $cEoCh.variationPlacements) : (0, $cEoCh.variationPlacements).filter(function(placement) {
        return (0, $8Opre.default)(placement) === variation;
    }) : (0, $cEoCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9Ddln.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8MGgd.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("6blW5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4804c92787f86449$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $8MGgd = parcelRequire("8MGgd");

var $3m9cx = parcelRequire("3m9cx");

var $jVRdk = parcelRequire("jVRdk");

var $6Q9NZ = parcelRequire("6Q9NZ");

var $eQTzt = parcelRequire("eQTzt");

var $5jKxG = parcelRequire("5jKxG");

var $9Ddln = parcelRequire("9Ddln");

var $8Opre = parcelRequire("8Opre");

var $83sLw = parcelRequire("83sLw");

var $c79oh = parcelRequire("c79oh");
function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9Ddln.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8MGgd.default)(state.placement);
    var variation = (0, $8Opre.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $3m9cx.default)(basePlacement);
    var altAxis = (0, $jVRdk.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cEoCh.top) : (0, $cEoCh.left);
        var altSide = mainAxis === 'y' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cEoCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cEoCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $eQTzt.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $83sLw.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $6Q9NZ.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5jKxG.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $6Q9NZ.within)(tether ? (0, $c79oh.min)(min, tetherMin) : min, offset, tether ? (0, $c79oh.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cEoCh.top) : (0, $cEoCh.left);
        var _altSide = mainAxis === 'x' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cEoCh.top),
            (0, $cEoCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $6Q9NZ.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $6Q9NZ.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("jVRdk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82c9e5baaa8e9af$export$2e2bcd8739ae039; });
function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("6Q9NZ", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $4faf3481d1df2f95$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $4faf3481d1df2f95$export$86c8af6d3ef0b4a; });

var $c79oh = parcelRequire("c79oh");
function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $c79oh.max)(min, (0, $c79oh.min)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("2P8UZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20e743289f291887$export$2e2bcd8739ae039; });

var $8MGgd = parcelRequire("8MGgd");

var $eQTzt = parcelRequire("eQTzt");

var $1yHmV = parcelRequire("1yHmV");

var $5jKxG = parcelRequire("5jKxG");

var $3m9cx = parcelRequire("3m9cx");

var $6Q9NZ = parcelRequire("6Q9NZ");

var $VHjvt = parcelRequire("VHjvt");

var $jxLne = parcelRequire("jxLne");

var $cEoCh = parcelRequire("cEoCh");
var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $VHjvt.default)(typeof padding !== 'number' ? padding : (0, $jxLne.default)(padding, (0, $cEoCh.basePlacements)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8MGgd.default)(state.placement);
    var axis = (0, $3m9cx.default)(basePlacement);
    var isVertical = [
        (0, $cEoCh.left),
        (0, $cEoCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $eQTzt.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cEoCh.top) : (0, $cEoCh.left);
    var maxProp = axis === 'y' ? (0, $cEoCh.bottom) : (0, $cEoCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5jKxG.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $6Q9NZ.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $1yHmV.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("aKE1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d3d400f3b7c97f3$export$2e2bcd8739ae039; });

var $cEoCh = parcelRequire("cEoCh");

var $9Ddln = parcelRequire("9Ddln");
function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cEoCh.top),
        (0, $cEoCh.right),
        (0, $cEoCh.bottom),
        (0, $cEoCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9Ddln.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9Ddln.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};

});


parcelRegister("g6MkC", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $bba2b2857408f717$var$hasElementType = typeof Element !== 'undefined';
var $bba2b2857408f717$var$hasMap = typeof Map === 'function';
var $bba2b2857408f717$var$hasSet = typeof Set === 'function';
var $bba2b2857408f717$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $bba2b2857408f717$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$bba2b2857408f717$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($bba2b2857408f717$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$bba2b2857408f717$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($bba2b2857408f717$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($bba2b2857408f717$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($bba2b2857408f717$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$bba2b2857408f717$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $bba2b2857408f717$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("QeZ0i", function(module, exports) {

$parcel$export(module.exports, "fromEntries", function () { return $09d07abddf506fbd$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $09d07abddf506fbd$export$700979bc83e7db82; });

var $exYeM = parcelRequire("exYeM");
var $09d07abddf506fbd$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $09d07abddf506fbd$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $09d07abddf506fbd$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $09d07abddf506fbd$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $09d07abddf506fbd$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $09d07abddf506fbd$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $exYeM.useLayoutEffect : $exYeM.useEffect;

});




parcelRegister("iOYiC", function(module, exports) {

$parcel$export(module.exports, "AccountConnected", function () { return $117167df5b32372d$export$88ae9c2acfee7576; });
/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $5fNnZ = parcelRequire("5fNnZ");

var $idTJH = parcelRequire("idTJH");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $gYV1Q = parcelRequire("gYV1Q");

var $9x73v = parcelRequire("9x73v");

var $kaLCO = parcelRequire("kaLCO");

var $appXD = parcelRequire("appXD");

var $gkOpi = parcelRequire("gkOpi");

var $9ddGv = parcelRequire("9ddGv");

var $exi8o = parcelRequire("exi8o");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");

var $lFNyc = parcelRequire("lFNyc");

var $2SjoC = parcelRequire("2SjoC");

var $bICKq = parcelRequire("bICKq");

var $iz2wS = parcelRequire("iz2wS");

var $lQ3eP = parcelRequire("lQ3eP");

var $8APqM = parcelRequire("8APqM");

var $avpuJ = parcelRequire("avpuJ");

var $8Wmxp = parcelRequire("8Wmxp");

var $7YXQd = parcelRequire("7YXQd");

var $ikd3J = parcelRequire("ikd3J");
const $117167df5b32372d$export$88ae9c2acfee7576 = ({ user: user })=>{
    const { masteriesQuery: masteriesQuery } = (0, $2Yib7.useHistory)();
    const { refreshUser: refreshUser } = (0, $dCazK.useUser)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const staticData = (0, $fcoXO.useStaticData)();
    const summonerMatch = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).platformRiotId);
    const summonerGameMatch = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).platformRiotIdGame);
    const [menuIsVisible, setMenuIsVisible] = (0, $exYeM.useState)(false);
    const toggleMenu = (0, $exYeM.useCallback)(()=>setMenuIsVisible((v)=>!v), []);
    const hideMenu = (0, $exYeM.useCallback)(()=>setMenuIsVisible(false), []);
    const [isLoading, setIsLoading] = (0, $exYeM.useState)(false);
    const disconnect = (0, $exYeM.useCallback)((e)=>{
        e.stopPropagation();
        setIsLoading(true);
        return (0, $kj6DU.pipe)((0, $exi8o.apiUserLogoutPost), (0, $9ddGv.Future).chain(()=>refreshUser), (0, $5fNnZ).chainFirstIOK(()=>()=>setIsLoading(false)), (0, $lQ3eP.futureRunUnsafe));
    }, [
        refreshUser
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8APqM.ClickOutside), {
        onClickOutside: hideMenu,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "relative flex items-center gap-4 self-stretch py-2",
            children: [
                (0, $kj6DU.pipe)(user.linkedRiotAccount, (0, $9ddGv.Maybe).fold(()=>null, ({ platform: platform, puuid: puuid, riotId: riotId, profileIconId: profileIconId })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $7YXQd.HighlightLink), {
                        to: (summonerGameMatch !== undefined ? (0, $iz2wS.appRoutes).sPlatformPuuidGame : (0, $iz2wS.appRoutes).sPlatformPuuid)(platform, puuid, summonerMatch !== undefined ? (0, $2SjoC.MasteriesQuery).toPartial({
                            ...masteriesQuery,
                            search: (0, $9ddGv.Maybe).none
                        }) : {}),
                        parser: $117167df5b32372d$var$anyPlatformSummonerExact(platform, riotId),
                        tooltip: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex items-baseline gap-1.5",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex items-baseline gap-px",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "font-medium text-goldenrod",
                                            children: (0, $kaLCO.GameName).unwrap(riotId.gameName)
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            className: "text-grey-500",
                                            children: [
                                                "#",
                                                (0, $gkOpi.TagLine).unwrap(riotId.tagLine)
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "\u2014"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: platform
                                })
                            ]
                        }),
                        className: "py-1.5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                            src: staticData.assets.summonerIcon(profileIconId),
                            alt: t.summonerIconAlt((0, $appXD.RiotId).stringify(riotId)),
                            className: "w-7.5 shadow-even shadow-black"
                        })
                    }))),
                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    type: "button",
                    onClick: toggleMenu,
                    className: "flex items-center gap-3 py-2",
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        children: user.userName
                    })
                }),
                menuIsVisible ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ikd3J.Menu), {
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                        className: "flex flex-col gap-0.5",
                        children: [
                            (0, $gYV1Q.Permissions).canViewAdmin(user.role) ? /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                className: "flex justify-center pb-1",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                                    to: (0, $bICKq.adminRoutes).index,
                                    className: "hover:underline",
                                    children: "ADMIN"
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                    type: "button",
                                    onClick: disconnect,
                                    disabled: isLoading,
                                    className: "flex items-center gap-2 bg-goldenrod px-4 py-1 text-black hover:bg-goldenrod/75 disabled:bg-grey-disabled",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            children: t.layout.logout
                                        }),
                                        isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                                            className: "h-4"
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
function $117167df5b32372d$var$anyPlatformSummonerExact(platform, riotId) {
    return new (0, $idTJH.Parser)((r)=>(0, $kj6DU.pipe)((0, $iz2wS.appParsers).anyPlatformRiotId.run(r), (0, $9ddGv.Maybe).filter(([a])=>(0, $9x73v.PlatformWithRiotId).Eq.equals(a, {
                platform: platform,
                riotId: riotId
            }))));
}

});
parcelRegister("gYV1Q", function(module, exports) {

$parcel$export(module.exports, "Permissions", function () { return $afc681adbed0df97$export$2d41982586bbb6be; });
const $afc681adbed0df97$var$isAdmin = (role)=>role === 'admin';
const $afc681adbed0df97$export$2d41982586bbb6be = {
    canViewDocErrors: $afc681adbed0df97$var$isAdmin,
    canViewAdmin: $afc681adbed0df97$var$isAdmin,
    canUpdateAdmin: $afc681adbed0df97$var$isAdmin
};

});

parcelRegister("9x73v", function(module, exports) {

$parcel$export(module.exports, "PlatformWithRiotId", function () { return $19f7059258388838$export$49fdbe4951252161; });

var $9RyKW = parcelRequire("9RyKW");

var $appXD = parcelRequire("appXD");

var $5Dwzl = parcelRequire("5Dwzl");
const $19f7059258388838$var$Eq = (0, $9RyKW).struct({
    platform: (0, $5Dwzl.Platform).Eq,
    riotId: (0, $appXD.RiotId).Eq
});
const $19f7059258388838$export$49fdbe4951252161 = {
    Eq: $19f7059258388838$var$Eq
};

});

parcelRegister("8APqM", function(module, exports) {

$parcel$export(module.exports, "ClickOutside", function () { return $b72135470287c81a$export$c16e4f034c84cb3f; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $exYeM = parcelRequire("exYeM");
const $b72135470287c81a$export$c16e4f034c84cb3f = ({ onClickOutside: onClickOutside, children: children })=>{
    const refs = (0, $exYeM.Children).map(children, ()=>/*#__PURE__*/ (0, $exYeM.createRef)());
    const handleClick = (0, $exYeM.useCallback)((e)=>{
        const isOutside = refs.every((ref)=>ref.current !== null && !ref.current.contains(e.target));
        if (isOutside) onClickOutside(e);
    }, [
        onClickOutside,
        refs
    ]);
    (0, $exYeM.useEffect)(()=>{
        document.addEventListener('click', handleClick);
        return ()=>document.removeEventListener('click', handleClick);
    }, [
        handleClick
    ]);
    return (0, $exYeM.Children).map(children, (elt, idx)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        /*#__PURE__*/ (0, $exYeM.cloneElement)(elt, {
            ref: refs[idx]
        }));
};

});

parcelRegister("7YXQd", function(module, exports) {

$parcel$export(module.exports, "HighlightLink", function () { return $a3b34248fcd0a49e$export$4b17acbdf2e2629c; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $lFNyc = parcelRequire("lFNyc");

var $5MBh5 = parcelRequire("5MBh5");

var $avpuJ = parcelRequire("avpuJ");

var $1sXco = parcelRequire("1sXco");
function $a3b34248fcd0a49e$export$4b17acbdf2e2629c({ parser: parser, tooltip: tooltip, className: className, ...props }) {
    const ref = (0, $exYeM.useRef)(null);
    const matches = (0, $lFNyc.usePathMatch)(parser) !== undefined;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                ref: ref,
                ...props,
                disabled: matches,
                className: (0, $5MBh5.cx)('flex border-y border-t-transparent font-medium', matches ? 'border-b-goldenrod-bis' : 'border-b-transparent', className)
            }),
            tooltip !== undefined ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                children: tooltip
            }) : null
        ]
    });
}

});

parcelRegister("ikd3J", function(module, exports) {

$parcel$export(module.exports, "Menu", function () { return $9e8ff76965732b3c$export$d9b273488cd8ce6f; });

var $aSiaI = parcelRequire("aSiaI");

var $5MBh5 = parcelRequire("5MBh5");
const $9e8ff76965732b3c$export$d9b273488cd8ce6f = ({ className: className, children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $5MBh5.cx)('absolute right-0 top-full z-10 flex flex-col gap-3 border border-goldenrod bg-zinc-900 px-5 py-4', className),
        children: children
    });

});


parcelRegister("leRp4", function(module, exports) {

$parcel$export(module.exports, "AccountDisconnected", function () { return $671e380a20f9b874$export$e60d2459e69ce6b9; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $hZroh = parcelRequire("hZroh");

var $iz2wS = parcelRequire("iz2wS");

var $8APqM = parcelRequire("8APqM");

var $avpuJ = parcelRequire("avpuJ");

var $ikd3J = parcelRequire("ikd3J");
const $671e380a20f9b874$export$e60d2459e69ce6b9 = ()=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const [loginIsVisible, setLoginIsVisible] = (0, $exYeM.useState)(false);
    const toggleLogin = (0, $exYeM.useCallback)(()=>setLoginIsVisible((v)=>!v), []);
    const hideLogin = (0, $exYeM.useCallback)(()=>setLoginIsVisible(false), []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8APqM.ClickOutside), {
        onClickOutside: hideLogin,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "relative flex items-center self-stretch py-2",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    type: "button",
                    onClick: toggleLogin,
                    className: "border border-goldenrod bg-black px-4 py-1 hover:bg-goldenrod/75 hover:text-black",
                    children: t.layout.account
                }),
                loginIsVisible ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $ikd3J.Menu), {
                    className: "items-center",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                            to: (0, $iz2wS.appRoutes).login,
                            className: "bg-goldenrod px-4 py-1 text-black enabled:hover:bg-goldenrod/75",
                            children: t.layout.login
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                                to: (0, $iz2wS.appRoutes).register,
                                className: "underline",
                                children: t.layout.register
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
};

});

parcelRegister("21lR3", function(module, exports) {

$parcel$export(module.exports, "Languages", function () { return $4df8676549c01193$export$3db4614a73ea75e3; });

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aPuMp = parcelRequire("aPuMp");

var $hZroh = parcelRequire("hZroh");

var $k6Hlt = parcelRequire("k6Hlt");

var $dR62Q = parcelRequire("dR62Q");

var $aMofi = parcelRequire("aMofi");

var $5MBh5 = parcelRequire("5MBh5");

var $8APqM = parcelRequire("8APqM");
const $4df8676549c01193$export$3db4614a73ea75e3 = ()=>{
    const [languagesIsVisible, setLanguagesIsVisible] = (0, $exYeM.useState)(false);
    const toggleLanguages = (0, $exYeM.useCallback)(()=>setLanguagesIsVisible((v)=>!v), []);
    const hideLanguages = (0, $exYeM.useCallback)(()=>setLanguagesIsVisible(false), []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8APqM.ClickOutside), {
        onClickOutside: hideLanguages,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "relative flex items-center self-stretch py-2",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    type: "button",
                    onClick: toggleLanguages,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.LanguageOutline), {
                        className: "h-5"
                    })
                }),
                languagesIsVisible ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "absolute right-[calc(1px_-_0.75rem)] top-full z-10 flex flex-col border border-goldenrod bg-zinc-900",
                    children: (0, $aPuMp.Lang).values.map((l)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4df8676549c01193$var$LangButton, {
                            l: l
                        }, l))
                }) : null
            ]
        })
    });
};
const $4df8676549c01193$var$LangButton = ({ l: l })=>{
    const { lang: lang, setLang: setLang } = (0, $hZroh.useTranslation)();
    const handleClick = (0, $exYeM.useCallback)(()=>setLang(l), [
        l,
        setLang
    ]);
    const isSelected = (0, $aPuMp.Lang).Eq.equals(l, lang);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
        type: "button",
        disabled: isSelected,
        onClick: handleClick,
        className: (0, $5MBh5.cx)('group flex items-center justify-between gap-3.5 py-1.5 pl-4 pr-2', {
            'bg-zinc-700': isSelected
        }),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: (0, $5MBh5.cx)('border-y border-y-transparent leading-4', {
                    'group-hover:border-b-goldenrod': !isSelected
                }),
                children: (0, $aMofi.TranslationUtils).labels.lang[l]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "flex",
                children: $4df8676549c01193$var$langEmoji[l]
            })
        ]
    });
};
const $4df8676549c01193$var$langEmoji = {
    en_GB: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $k6Hlt.EmojiFlagGb), {
        className: "!h-6"
    }),
    fr_FR: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $k6Hlt.EmojiFlagFr), {
        className: "!h-6"
    })
};

});
parcelRegister("k6Hlt", function(module, exports) {

$parcel$export(module.exports, "EmojiFlagFr", function () { return $8cc6589893784830$export$c5993bc0065ea587; });
$parcel$export(module.exports, "EmojiFlagGb", function () { return $8cc6589893784830$export$b1b9b3b5c509404; });
$parcel$export(module.exports, "EmojiUpsideDown", function () { return $8cc6589893784830$export$c88907166fcd10ab; });

var $aSiaI = parcelRequire("aSiaI");

var $5MBh5 = parcelRequire("5MBh5");
const $8cc6589893784830$var$baseClassName = 'h-[1em] inline';
const $8cc6589893784830$export$f690ff38f558e05d = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72 72",
        className: (0, $5MBh5.cx)($8cc6589893784830$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "#f1b31c"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "#d22f27",
                d: "M23,33v7a2.0059,2.0059,0,0,1-2,2H17a2.0059,2.0059,0,0,1-2-2V33"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "9",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "46",
                width: "62",
                height: "9",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "19",
                y: "33",
                width: "4",
                height: "4",
                fill: "#f1b31c"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                cx: "19",
                cy: "37",
                r: "1.5",
                fill: "#6a462f"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("line", {
                x1: "27",
                x2: "27",
                y1: "33",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("line", {
                x1: "11",
                x2: "11",
                y1: "33",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M15,30a8.5678,8.5678,0,0,1,4-1"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M23,30a8.5678,8.5678,0,0,0-4-1"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("line", {
                x1: "15",
                x2: "23",
                y1: "33",
                y2: "33",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M23,33v7a2.0059,2.0059,0,0,1-2,2H17a2.0059,2.0059,0,0,1-2-2V33"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("line", {
                x1: "10",
                x2: "12",
                y1: "42",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("line", {
                x1: "26",
                x2: "28",
                y1: "42",
                y2: "42",
                fill: "none",
                stroke: "#6a462f",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
const $8cc6589893784830$export$c5993bc0065ea587 = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72 72",
        className: (0, $5MBh5.cx)($8cc6589893784830$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "21",
                height: "38",
                fill: "#1e50a0"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "46",
                y: "17",
                width: "21",
                height: "38",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
const $8cc6589893784830$export$b1b9b3b5c509404 = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 72 72",
        className: (0, $5MBh5.cx)($8cc6589893784830$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "#1e50a0"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#fff",
                points: "40 28.856 40 32 50.181 32 67 21.691 67 17 59.346 17 40 28.856"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#d22f27",
                points: "67 17 67 17 63.173 17 40 31.203 40 32 43.482 32 67 17.586 67 17"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#fff",
                points: "59.347 55 67 55 67 55 67 50.308 50.182 40 40 40 40 43.143 59.347 55"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#d22f27",
                points: "67 55 67 52.653 46.355 40 41.568 40 66.042 55 67 55 67 55"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#fff",
                points: "32 43.144 32 40 21.819 40 5 50.309 5 55 12.654 55 32 43.144"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#d22f27",
                points: "5 55 5 55 8.827 55 32 40.797 32 40 28.518 40 5 54.414 5 55"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#fff",
                points: "12.653 17 5 17 5 17 5 21.692 21.818 32 32 32 32 28.857 12.653 17"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                fill: "#d22f27",
                points: "5 17 5 19.347 25.646 32 30.432 32 5.958 17 5 17 5 17"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "31",
                width: "62",
                height: "10",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "31",
                y: "17",
                width: "10",
                height: "38",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "33",
                width: "62",
                height: "6",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "33",
                y: "17",
                width: "6",
                height: "38",
                fill: "#d22f27"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                x: "5",
                y: "17",
                width: "62",
                height: "38",
                fill: "none",
                stroke: "#000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            })
        ]
    });
const $8cc6589893784830$export$c88907166fcd10ab = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "12 12 48 48",
        className: (0, $5MBh5.cx)($8cc6589893784830$var$baseClassName, className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                cx: "36",
                cy: "36",
                r: "23",
                fill: "#FCEA2B"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
                cx: "36",
                cy: "36",
                r: "23",
                fill: "none",
                stroke: "#000000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "none",
                stroke: "#000000",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2",
                d: "M26.1851,27.0707 c2.8995-1.6362,6.2482-2.5699,9.8149-2.5699s6.9153,0.9336,9.8149,2.5699"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M42,41c0-1.6568,1.3448-3,3-3c1.6553,0,3,1.3433,3,3c0,1.6552-1.3447,3-3,3C43.3448,44,42,42.6552,42,41"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M24,41c0-1.6568,1.3447-3,3-3s3,1.3433,3,3c0,1.6552-1.3447,3-3,3S24,42.6552,24,41"
            })
        ]
    });

});

parcelRegister("aMofi", function(module, exports) {

$parcel$export(module.exports, "TranslationUtils", function () { return $5ad0a0563afc18ab$export$804272ad78c9493; });

var $kj6DU = parcelRequire("kj6DU");

var $cl9Ur = parcelRequire("cl9Ur");

var $csF9Q = parcelRequire("csF9Q");

var $dglOy = parcelRequire("dglOy");

var $9ddGv = parcelRequire("9ddGv");
const { round: $5ad0a0563afc18ab$var$round } = (0, $dglOy.NumberUtils);
const $5ad0a0563afc18ab$var$langLabel = {
    en_GB: 'English',
    fr_FR: "Fran\xe7ais"
};
const $5ad0a0563afc18ab$var$challenge = (onNone, onSome)=>(challengeId)=>(0, $kj6DU.pipe)((0, $csF9Q.ChallengesView).idEntries, (0, $9ddGv.List).findFirst(([, id])=>(0, $cl9Ur.ChallengeId).Eq.equals(id, challengeId)), (0, $9ddGv.Maybe).fold(()=>onNone(challengeId), (0, $kj6DU.flow)((0, $9ddGv.Tuple).fst, onSome)));
const $5ad0a0563afc18ab$var$numberUnit = (t)=>(pts)=>{
        if (1000000 <= pts) return t.numberM($5ad0a0563afc18ab$var$round(pts / 1000000, 1));
        if (1000 <= pts) return t.numberK($5ad0a0563afc18ab$var$round(pts / 1000, 1));
        return t.number(pts);
    };
const $5ad0a0563afc18ab$export$804272ad78c9493 = {
    labels: {
        lang: $5ad0a0563afc18ab$var$langLabel
    },
    challenge: $5ad0a0563afc18ab$var$challenge,
    numberUnit: $5ad0a0563afc18ab$var$numberUnit
};

});
parcelRegister("cl9Ur", function(module, exports) {

$parcel$export(module.exports, "ChallengeId", function () { return $b5c7b27d6298bfc9$export$ed95df8e12a8d6d6; });

var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $b5c7b27d6298bfc9$var$wrap, unwrap: $b5c7b27d6298bfc9$var$unwrap } = (0, $hp7yq.iso)();
const $b5c7b27d6298bfc9$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $b5c7b27d6298bfc9$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($b5c7b27d6298bfc9$var$unwrap));
const $b5c7b27d6298bfc9$export$ed95df8e12a8d6d6 = (0, $9ddGv.immutableAssign)($b5c7b27d6298bfc9$var$wrap, {
    codec: $b5c7b27d6298bfc9$var$codec,
    Eq: $b5c7b27d6298bfc9$var$Eq
});

});

parcelRegister("csF9Q", function(module, exports) {

$parcel$export(module.exports, "ChallengesView", function () { return $d0134d320b016d60$export$f937a8a51add31a1; });

var $7uCHH = parcelRequire("7uCHH");

var $k6yCu = parcelRequire("k6yCu");

var $9ddGv = parcelRequire("9ddGv");

var $cl9Ur = parcelRequire("cl9Ur");

var $8G5pR = parcelRequire("8G5pR");
const $d0134d320b016d60$var$maybeChallengeCodec = (0, $9ddGv.Maybe).codec((0, $8G5pR.ChallengeView).codec);
const $d0134d320b016d60$var$properties = {
    bandle: $d0134d320b016d60$var$maybeChallengeCodec,
    bilgewater: $d0134d320b016d60$var$maybeChallengeCodec,
    demacia: $d0134d320b016d60$var$maybeChallengeCodec,
    freljord: $d0134d320b016d60$var$maybeChallengeCodec,
    ionia: $d0134d320b016d60$var$maybeChallengeCodec,
    ixtal: $d0134d320b016d60$var$maybeChallengeCodec,
    noxus: $d0134d320b016d60$var$maybeChallengeCodec,
    piltover: $d0134d320b016d60$var$maybeChallengeCodec,
    shadowIsles: $d0134d320b016d60$var$maybeChallengeCodec,
    shurima: $d0134d320b016d60$var$maybeChallengeCodec,
    targon: $d0134d320b016d60$var$maybeChallengeCodec,
    void: $d0134d320b016d60$var$maybeChallengeCodec,
    zaun: $d0134d320b016d60$var$maybeChallengeCodec
};
const $d0134d320b016d60$var$codec = $7uCHH.struct($d0134d320b016d60$var$properties);
const $d0134d320b016d60$var$id = {
    bandle: (0, $cl9Ur.ChallengeId)(303501),
    bilgewater: (0, $cl9Ur.ChallengeId)(303502),
    demacia: (0, $cl9Ur.ChallengeId)(303503),
    freljord: (0, $cl9Ur.ChallengeId)(303504),
    ionia: (0, $cl9Ur.ChallengeId)(303505),
    ixtal: (0, $cl9Ur.ChallengeId)(303506),
    noxus: (0, $cl9Ur.ChallengeId)(303507),
    piltover: (0, $cl9Ur.ChallengeId)(303508),
    shadowIsles: (0, $cl9Ur.ChallengeId)(303509),
    shurima: (0, $cl9Ur.ChallengeId)(303510),
    targon: (0, $cl9Ur.ChallengeId)(303511),
    void: (0, $cl9Ur.ChallengeId)(303512),
    zaun: (0, $cl9Ur.ChallengeId)(303513)
};
const $d0134d320b016d60$var$idEntries = (0, $k6yCu.DictUtils).entries($d0134d320b016d60$var$id);
const $d0134d320b016d60$export$f937a8a51add31a1 = {
    id: $d0134d320b016d60$var$id,
    idEntries: $d0134d320b016d60$var$idEntries,
    codec: $d0134d320b016d60$var$codec
};

});
parcelRegister("8G5pR", function(module, exports) {

$parcel$export(module.exports, "ChallengeView", function () { return $d43ab7dbc0ae4175$export$c2c09bafe967ecd8; });

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $l8OHp = parcelRequire("l8OHp");
const $d43ab7dbc0ae4175$var$codec = $7uCHH.struct({
    level: (0, $9ddGv.Maybe).codec((0, $l8OHp.LeagueTier).codec),
    value: $7uCHH.number
});
const $d43ab7dbc0ae4175$export$c2c09bafe967ecd8 = {
    codec: $d43ab7dbc0ae4175$var$codec
};

});
parcelRegister("l8OHp", function(module, exports) {

$parcel$export(module.exports, "LeagueTier", function () { return $3d686004b5a9e801$export$9f1ee514706af278; });

var $3a4Bg = parcelRequire("3a4Bg");

var $9ddGv = parcelRequire("9ddGv");
const $3d686004b5a9e801$export$a31d2d1626cc9f40 = (0, $3a4Bg.createEnum)('IRON', 'BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'EMERALD', 'DIAMOND');
const $3d686004b5a9e801$export$668775a00367f28 = (0, $3a4Bg.createEnum)('MASTER', 'GRANDMASTER', 'CHALLENGER');
const $3d686004b5a9e801$var$e = (0, $3a4Bg.createEnum)(...$3d686004b5a9e801$export$a31d2d1626cc9f40.values, ...$3d686004b5a9e801$export$668775a00367f28.values);
const $3d686004b5a9e801$var$isApexTier = (tier)=>(0, $9ddGv.List).elem($3d686004b5a9e801$var$e.Eq)(tier, $3d686004b5a9e801$export$668775a00367f28.values);
const $3d686004b5a9e801$var$isRegularTier = (tier)=>(0, $9ddGv.List).elem($3d686004b5a9e801$var$e.Eq)(tier, $3d686004b5a9e801$export$a31d2d1626cc9f40.values);
const $3d686004b5a9e801$export$9f1ee514706af278 = {
    ...$3d686004b5a9e801$var$e,
    isApexTier: $3d686004b5a9e801$var$isApexTier,
    isRegularTier: $3d686004b5a9e801$var$isRegularTier
};

});



parcelRegister("dglOy", function(module, exports) {

$parcel$export(module.exports, "NumberUtils", function () { return $c93537a5c754a753$export$231f628ed3e191f0; });

var $gpfu2 = parcelRequire("gpfu2");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");
const $c93537a5c754a753$var$average = (ns)=>ns.length === 0 ? 0 : (0, $kj6DU.pipe)(ns, (0, $gpfu2).concatAll((0, $cF6yJ).MonoidSum)) / ns.length;
const $c93537a5c754a753$var$round = (n, digits = 0)=>{
    const e = 10 ** digits;
    return e === 0 ? 0 : Math.round(n * e) / e;
};
/**
 * https://github.com/lodash/lodash/blob/master/clamp.js
 *
 * Clamps `n` within the inclusive `lower` and `upper` bounds.
 *
 * @param n The number to clamp.
 * @param lower The lower bound.
 * @param upper The upper bound.
 * @returns Returns the clamped number.
 * @example
 *
 * clamp(-10, -5, 5)
 * // => -5
 *
 * clamp(10, -5, 5)
 * // => 5
 */ const $c93537a5c754a753$var$clamp = (n, lower, upper)=>{
    // eslint-disable-next-line functional/no-let
    let res = n;
    /* eslint-disable functional/no-expression-statements */ res = res <= upper ? res : upper;
    res = res >= lower ? res : lower;
    /* eslint-enable functional/no-expression-statements */ return res;
};
const $c93537a5c754a753$export$231f628ed3e191f0 = {
    round: $c93537a5c754a753$var$round,
    average: $c93537a5c754a753$var$average,
    clamp: $c93537a5c754a753$var$clamp
};

});



parcelRegister("fAUNn", function(module, exports) {

$parcel$export(module.exports, "SearchSummoner", function () { return $e290eadfba7a1998$export$ab1d845dde9a5149; });
/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $5Dwzl = parcelRequire("5Dwzl");

var $7pd72 = parcelRequire("7pd72");

var $9ddGv = parcelRequire("9ddGv");

var $2Yib7 = parcelRequire("2Yib7");

var $dCazK = parcelRequire("dCazK");

var $lFNyc = parcelRequire("lFNyc");

var $dR62Q = parcelRequire("dR62Q");

var $2SjoC = parcelRequire("2SjoC");

var $4MhX7 = parcelRequire("4MhX7");

var $iz2wS = parcelRequire("iz2wS");

var $5MBh5 = parcelRequire("5MBh5");

var $8APqM = parcelRequire("8APqM");

var $1J3k6 = parcelRequire("1J3k6");

var $bhFhT = parcelRequire("bhFhT");

var $h9A4m = parcelRequire("h9A4m");
const $e290eadfba7a1998$var$platformOptions = (0, $kj6DU.pipe)((0, $5Dwzl.Platform).values, (0, $9ddGv.List).map((0, $1J3k6.SelectOption)));
const $e290eadfba7a1998$export$ab1d845dde9a5149 = ()=>{
    const { navigate: navigate, masteriesQuery: masteriesQuery } = (0, $2Yib7.useHistory)();
    const { maybeUser: maybeUser, recentSearches: recentSearches } = (0, $dCazK.useUser)();
    const [isOpen, setIsOpen] = (0, $exYeM.useState)(false);
    const close = (0, $exYeM.useCallback)(()=>setIsOpen(false), []);
    const [platform, setPlatform] = (0, $exYeM.useState)((0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).anyPlatform)?.platform ?? (0, $5Dwzl.Platform).defaultPlatform);
    const summonerMatch = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).anyPlatformRiotId);
    const [summoner, setSummoner] = (0, $exYeM.useState)(summonerMatch !== undefined ? (0, $9ddGv.Either).right(summonerMatch.riotId) : (0, $9ddGv.Either).left(''));
    (0, $exYeM.useEffect)(()=>{
        if (summonerMatch !== undefined) setSummoner((0, $9ddGv.Either).right(summonerMatch.riotId));
    }, [
        summonerMatch
    ]);
    const handleFocus = (0, $exYeM.useCallback)((e)=>{
        e.target.select();
        setIsOpen(true);
    }, []);
    const gameMatch = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).platformRiotIdGame);
    const handleSubmit = (0, $exYeM.useCallback)((e)=>{
        e.preventDefault();
        if ((0, $9ddGv.Either).isRight(summoner)) navigate(gameMatch !== undefined ? (0, $iz2wS.appRoutes).platformRiotIdGame(platform, summoner.right) : (0, $iz2wS.appRoutes).platformRiotId(platform, summoner.right, (0, $2SjoC.MasteriesQuery).toPartial({
            ...masteriesQuery,
            search: (0, $9ddGv.Maybe).none
        })));
    }, [
        masteriesQuery,
        gameMatch,
        navigate,
        platform,
        summoner
    ]);
    const searches = (0, $9ddGv.List).compact([
        (0, $kj6DU.pipe)(maybeUser, (0, $9ddGv.Maybe).chain((u)=>u.linkedRiotAccount), (0, $9ddGv.Maybe).map((s)=>// eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $h9A4m.SummonerSearch), {
                type: "self",
                summoner: (0, $4MhX7.PartialSummonerShort).fromSummonerShort(s)
            }))),
        (0, $kj6DU.pipe)(maybeUser, (0, $9ddGv.Maybe).chain((u)=>(0, $9ddGv.NonEmptyArray).fromReadonlyArray(u.favoriteSearches)), (0, $9ddGv.Maybe).map((favoriteSearches)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                children: favoriteSearches.map((s)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $h9A4m.SummonerSearch), {
                        type: "favorite",
                        summoner: (0, $4MhX7.PartialSummonerShort).fromSummonerShort(s)
                    }, (0, $7pd72.Puuid).unwrap(s.puuid)))
            }))),
        (0, $kj6DU.pipe)(recentSearches, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((recentSearches_)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                children: recentSearches_.map((s)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $h9A4m.SummonerSearch), {
                        type: "recent",
                        summoner: s
                    }, (0, $7pd72.Puuid).unwrap(s.puuid)))
            })))
    ]);
    const showSearches = isOpen && (0, $9ddGv.List).isNonEmpty(searches);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "flex h-8 font-medium",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1J3k6.Select), {
                options: $e290eadfba7a1998$var$platformOptions,
                value: platform,
                onChange: setPlatform
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex gap-1 border border-goldenrod pr-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $8APqM.ClickOutside), {
                        onClickOutside: close,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bhFhT.SearchSummonerInput), {
                                summoner: summoner,
                                setSummoner: setSummoner,
                                handleFocus: handleFocus
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                className: (0, $5MBh5.cx)('absolute top-full z-40 max-h-[calc(100vh_-_5rem)] min-w-84 items-center gap-y-3 overflow-auto border border-goldenrod bg-zinc-900 py-2', (0, $9ddGv.Maybe).isSome(maybeUser) ? 'grid-cols-[auto_auto_auto]' : 'grid-cols-[auto_1fr] pr-3', showSearches ? 'grid' : 'hidden'),
                                children: $e290eadfba7a1998$var$concatWithHr(searches)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "submit",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.SearchOutline), {
                            className: "h-6 text-goldenrod"
                        })
                    })
                ]
            })
        ]
    });
};
function $e290eadfba7a1998$var$concatWithHr(es) {
    return (0, $kj6DU.pipe)(es, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).fold(()=>null, (0, $9ddGv.NonEmptyArray).concatAll({
        concat: (x, y)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    x,
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-[calc(100%_-_1rem)] justify-self-end border-t border-goldenrod"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "border-t border-goldenrod"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "w-[calc(100%_-_1rem)] border-t border-goldenrod"
                    }),
                    y
                ]
            })
    })));
}

});
parcelRegister("1J3k6", function(module, exports) {

$parcel$export(module.exports, "SelectOption", function () { return $ae9479a7b604c323$export$11a8a1ea41bf55d8; });
$parcel$export(module.exports, "Select", function () { return $ae9479a7b604c323$export$ef9b1a59e592288f; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $5wXMS = parcelRequire("5wXMS");

var $dR62Q = parcelRequire("dR62Q");

var $5MBh5 = parcelRequire("5MBh5");
function $ae9479a7b604c323$export$11a8a1ea41bf55d8(value, label = value) {
    return {
        value: value,
        label: label
    };
}
const $ae9479a7b604c323$var$ChevronForwardFilled = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.ChevronForwardFilled), {
        className: className
    });
function $ae9479a7b604c323$export$ef9b1a59e592288f({ options: options, value: value, onChange: onChange, className: className }) {
    const ref = (0, $exYeM.useRef)(null);
    const menuIsOpenRef = (0, $exYeM.useRef)(false);
    const handleChange = (0, $exYeM.useCallback)((newValue)=>{
        if (newValue !== null) onChange(newValue.value);
    }, [
        onChange
    ]);
    const onMenuOpen = (0, $exYeM.useCallback)(()=>{
        // eslint-disable-next-line functional/immutable-data
        menuIsOpenRef.current = true;
    }, []);
    const onMenuClose = (0, $exYeM.useCallback)(()=>{
        // eslint-disable-next-line functional/immutable-data
        menuIsOpenRef.current = false;
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5wXMS.default), {
        ref: ref,
        options: options,
        value: $ae9479a7b604c323$export$11a8a1ea41bf55d8(value),
        onChange: handleChange,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        isSearchable: false,
        components: {
            IndicatorSeparator: null,
            DropdownIndicator: $ae9479a7b604c323$var$ChevronForwardFilled
        },
        className: className,
        styles: {
            control: (base)=>({
                    ...base,
                    minHeight: undefined,
                    backgroundColor: undefined,
                    borderRadius: undefined,
                    borderWidth: undefined,
                    borderColor: undefined,
                    '&:hover': undefined
                }),
            valueContainer: (base)=>({
                    ...base,
                    padding: undefined
                }),
            singleValue: (base)=>({
                    ...base,
                    marginRight: undefined,
                    marginLeft: undefined,
                    color: undefined
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    '& > svg': {
                        width: 16,
                        height: 16,
                        transform: menuIsOpenRef.current ? 'rotate(270deg)' : 'rotate(90deg)',
                        transition: 'transform 0.3s'
                    }
                }),
            menu: (base)=>({
                    ...base,
                    marginTop: undefined,
                    marginBottom: undefined,
                    backgroundColor: undefined,
                    borderRadius: undefined
                }),
            menuList: (base)=>({
                    ...base,
                    paddingTop: undefined,
                    paddingBottom: undefined
                }),
            option: (base)=>({
                    ...base,
                    padding: undefined,
                    backgroundColor: undefined,
                    color: undefined,
                    cursor: undefined
                })
        },
        classNames: {
            container: ()=>$ae9479a7b604c323$var$containerClassName,
            control: ()=>$ae9479a7b604c323$var$controlClassName,
            singleValue: ()=>$ae9479a7b604c323$var$singleValueClassName,
            menu: ()=>$ae9479a7b604c323$var$menuClassName,
            option: (p)=>(0, $5MBh5.cx)($ae9479a7b604c323$var$optionClassName, [
                    $ae9479a7b604c323$var$optionIsFocusedClassName,
                    p.isFocused
                ], p.isSelected ? $ae9479a7b604c323$var$optionIsSelectedClassName : $ae9479a7b604c323$var$optionNotSelectedClassName) ?? ''
        }
    });
}
const $ae9479a7b604c323$var$containerClassName = 'z-10';
const $ae9479a7b604c323$var$controlClassName = 'h-full pl-1.5 pr-1 gap-1 border-y border-l border-goldenrod';
const $ae9479a7b604c323$var$singleValueClassName = 'min-w-8';
const $ae9479a7b604c323$var$menuClassName = 'bg-zinc-700 rounded-b-md';
const $ae9479a7b604c323$var$optionClassName = 'py-0.75 px-1.5';
const $ae9479a7b604c323$var$optionIsFocusedClassName = 'bg-black';
const $ae9479a7b604c323$var$optionIsSelectedClassName = 'bg-goldenrod-bis';
const $ae9479a7b604c323$var$optionNotSelectedClassName = 'cursor-pointer hover:bg-black';

});
parcelRegister("5wXMS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $406e516f8efaaf1d$export$2e2bcd8739ae039; });

var $4yr9A = parcelRequire("4yr9A");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $7KM8b = parcelRequire("7KM8b");

var $dJ7Y7 = parcelRequire("dJ7Y7");

var $kJJU8 = parcelRequire("kJJU8");

parcelRequire("8RfaJ");
parcelRequire("c2tl2");
parcelRequire("k2o2K");
parcelRequire("clMMr");
parcelRequire("drNVG");
parcelRequire("kLJEy");
parcelRequire("iNe3q");
parcelRequire("54H9R");

parcelRequire("5OoXb");
parcelRequire("7DH2y");
parcelRequire("c0F5b");
parcelRequire("d2lNW");

parcelRequire("rA44O");
var $406e516f8efaaf1d$var$StateManagedSelect = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $4yr9A.u)(props);
    return /*#__PURE__*/ $exYeM.createElement((0, $7KM8b.S), (0, $aJx1R.default)({
        ref: ref
    }, baseSelectProps));
});
var $406e516f8efaaf1d$export$2e2bcd8739ae039 = $406e516f8efaaf1d$var$StateManagedSelect;
var $406e516f8efaaf1d$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $exYeM.useMemo)(function() {
        return (0, $kJJU8.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $dJ7Y7.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("4yr9A", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $350f668bd7c94a32$export$3b14a55fb2447963; });

var $7CFkN = parcelRequire("7CFkN");

var $e3xqi = parcelRequire("e3xqi");

var $4nNod = parcelRequire("4nNod");

var $exYeM = parcelRequire("exYeM");
var $350f668bd7c94a32$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $350f668bd7c94a32$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $4nNod.default)(_ref, $350f668bd7c94a32$var$_excluded);
    var _useState = (0, $exYeM.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $e3xqi.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $exYeM.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $e3xqi.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $exYeM.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $e3xqi.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $exYeM.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $exYeM.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $exYeM.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $exYeM.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $7CFkN.default)((0, $7CFkN.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("7CFkN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58cc252a946b2efc$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");
function $58cc252a946b2efc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58cc252a946b2efc$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58cc252a946b2efc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lB7P9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58cc252a946b2efc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("lB7P9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb931f60d8d226d8$export$2e2bcd8739ae039; });

var $d9KNw = parcelRequire("d9KNw");
function $fb931f60d8d226d8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d9KNw.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("d9KNw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99406aaafdabc25e$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $g7Qem = parcelRequire("g7Qem");
function $99406aaafdabc25e$export$2e2bcd8739ae039(t) {
    var i = (0, $g7Qem.default)(t, "string");
    return "symbol" == (0, $ana82.default)(i) ? i : i + "";
}

});
parcelRegister("ana82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78d3e8b7d5e47526$export$2e2bcd8739ae039; });
function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}

});

parcelRegister("g7Qem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbd5d0b4a89d436f$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");
function $bbd5d0b4a89d436f$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ana82.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ana82.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("e3xqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3bb459d6a973ea1$export$2e2bcd8739ae039; });

var $bCmUc = parcelRequire("bCmUc");

var $oKd0e = parcelRequire("oKd0e");

var $45CPT = parcelRequire("45CPT");

var $12fni = parcelRequire("12fni");
function $a3bb459d6a973ea1$export$2e2bcd8739ae039(r, e) {
    return (0, $bCmUc.default)(r) || (0, $oKd0e.default)(r, e) || (0, $45CPT.default)(r, e) || (0, $12fni.default)();
}

});
parcelRegister("bCmUc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $875502dcf1b945d9$export$2e2bcd8739ae039; });
function $875502dcf1b945d9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("oKd0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04a616184d319d1c$export$2e2bcd8739ae039; });
function $04a616184d319d1c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("45CPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa5c1109958a2fc$export$2e2bcd8739ae039; });

var $5z2Zn = parcelRequire("5z2Zn");
function $2fa5c1109958a2fc$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5z2Zn.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5z2Zn.default)(r, a) : void 0;
    }
}

});
parcelRegister("5z2Zn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40d28a29bc3d0243$export$2e2bcd8739ae039; });
function $40d28a29bc3d0243$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("12fni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c11e77327771c10$export$2e2bcd8739ae039; });
function $0c11e77327771c10$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4nNod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $330f9f25da865537$export$2e2bcd8739ae039; });

var $3L80X = parcelRequire("3L80X");
function $330f9f25da865537$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3L80X.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3L80X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039; });
function $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("7KM8b", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $5a522a184a74c0c3$export$25ce5a424b770e84; });

var $aJx1R = parcelRequire("aJx1R");

var $7CFkN = parcelRequire("7CFkN");

var $kd56n = parcelRequire("kd56n");

var $6kKbN = parcelRequire("6kKbN");

var $8EMLg = parcelRequire("8EMLg");

var $1ZRiV = parcelRequire("1ZRiV");

var $hSuqf = parcelRequire("hSuqf");

var $exYeM = parcelRequire("exYeM");

var $2Jjmp = parcelRequire("2Jjmp");

var $4N3Qt = parcelRequire("4N3Qt");

var $jMw7l = parcelRequire("jMw7l");

var $4nNod = parcelRequire("4nNod");
function $5a522a184a74c0c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $5a522a184a74c0c3$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $5a522a184a74c0c3$var$A11yText = function A11yText(props) {
    return (0, $4N3Qt.jsx)("span", (0, $aJx1R.default)({
        css: $5a522a184a74c0c3$var$_ref
    }, props));
};
var $5a522a184a74c0c3$var$A11yText$1 = $5a522a184a74c0c3$var$A11yText;
var $5a522a184a74c0c3$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $5a522a184a74c0c3$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $exYeM.useMemo)(function() {
        return (0, $7CFkN.default)((0, $7CFkN.default)({}, $5a522a184a74c0c3$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $exYeM.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $7CFkN.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $exYeM.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $exYeM.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $exYeM.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $4N3Qt.jsx)((0, $exYeM.Fragment), null, (0, $4N3Qt.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $4N3Qt.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $4N3Qt.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $4N3Qt.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $4N3Qt.jsx)((0, $exYeM.Fragment), null, (0, $4N3Qt.jsx)($5a522a184a74c0c3$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $4N3Qt.jsx)($5a522a184a74c0c3$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $5a522a184a74c0c3$var$LiveRegion$1 = $5a522a184a74c0c3$var$LiveRegion;
var $5a522a184a74c0c3$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $5a522a184a74c0c3$var$anyDiacritic = new RegExp('[' + $5a522a184a74c0c3$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $5a522a184a74c0c3$var$diacriticToBase = {};
for(var $5a522a184a74c0c3$var$i = 0; $5a522a184a74c0c3$var$i < $5a522a184a74c0c3$var$diacritics.length; $5a522a184a74c0c3$var$i++){
    var $5a522a184a74c0c3$var$diacritic = $5a522a184a74c0c3$var$diacritics[$5a522a184a74c0c3$var$i];
    for(var $5a522a184a74c0c3$var$j = 0; $5a522a184a74c0c3$var$j < $5a522a184a74c0c3$var$diacritic.letters.length; $5a522a184a74c0c3$var$j++)$5a522a184a74c0c3$var$diacriticToBase[$5a522a184a74c0c3$var$diacritic.letters[$5a522a184a74c0c3$var$j]] = $5a522a184a74c0c3$var$diacritic.base;
}
var $5a522a184a74c0c3$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($5a522a184a74c0c3$var$anyDiacritic, function(match) {
        return $5a522a184a74c0c3$var$diacriticToBase[match];
    });
};
var $5a522a184a74c0c3$var$memoizedStripDiacriticsForInput = (0, $jMw7l.default)($5a522a184a74c0c3$var$stripDiacritics);
var $5a522a184a74c0c3$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $5a522a184a74c0c3$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $5a522a184a74c0c3$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $7CFkN.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $5a522a184a74c0c3$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $5a522a184a74c0c3$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $5a522a184a74c0c3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $5a522a184a74c0c3$var$memoizedStripDiacriticsForInput(input);
            candidate = $5a522a184a74c0c3$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $5a522a184a74c0c3$var$_excluded = [
    "innerRef"
];
function $5a522a184a74c0c3$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $4nNod.default)(_ref, $5a522a184a74c0c3$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $2Jjmp.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $4N3Qt.jsx)("input", (0, $aJx1R.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $4N3Qt.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $5a522a184a74c0c3$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $5a522a184a74c0c3$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $exYeM.useRef)(false);
    var isTop = (0, $exYeM.useRef)(false);
    var touchStart = (0, $exYeM.useRef)(0);
    var scrollTarget = (0, $exYeM.useRef)(null);
    var handleEventDelta = (0, $exYeM.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $5a522a184a74c0c3$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $exYeM.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $exYeM.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $exYeM.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $exYeM.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $2Jjmp.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $exYeM.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $exYeM.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $5a522a184a74c0c3$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $5a522a184a74c0c3$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $5a522a184a74c0c3$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $5a522a184a74c0c3$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $5a522a184a74c0c3$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $5a522a184a74c0c3$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $5a522a184a74c0c3$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $5a522a184a74c0c3$var$activeScrollLocks = 0;
var $5a522a184a74c0c3$var$listenerOptions = {
    capture: false,
    passive: false
};
function $5a522a184a74c0c3$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $exYeM.useRef)({});
    var scrollTarget = (0, $exYeM.useRef)(null);
    var addScrollLock = (0, $exYeM.useCallback)(function(touchScrollTarget) {
        if (!$5a522a184a74c0c3$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $5a522a184a74c0c3$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $5a522a184a74c0c3$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($5a522a184a74c0c3$var$LOCK_STYLES).forEach(function(key) {
                var val = $5a522a184a74c0c3$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $5a522a184a74c0c3$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $5a522a184a74c0c3$var$preventTouchMove, $5a522a184a74c0c3$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $5a522a184a74c0c3$var$preventInertiaScroll, $5a522a184a74c0c3$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $5a522a184a74c0c3$var$allowTouchMove, $5a522a184a74c0c3$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $5a522a184a74c0c3$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $exYeM.useCallback)(function(touchScrollTarget) {
        if (!$5a522a184a74c0c3$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $5a522a184a74c0c3$var$activeScrollLocks = Math.max($5a522a184a74c0c3$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $5a522a184a74c0c3$var$activeScrollLocks < 1) $5a522a184a74c0c3$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $5a522a184a74c0c3$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $5a522a184a74c0c3$var$preventTouchMove, $5a522a184a74c0c3$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $5a522a184a74c0c3$var$preventInertiaScroll, $5a522a184a74c0c3$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $5a522a184a74c0c3$var$allowTouchMove, $5a522a184a74c0c3$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $exYeM.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $5a522a184a74c0c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5a522a184a74c0c3$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $5a522a184a74c0c3$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $5a522a184a74c0c3$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $5a522a184a74c0c3$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $5a522a184a74c0c3$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $4N3Qt.jsx)((0, $exYeM.Fragment), null, lockEnabled && (0, $4N3Qt.jsx)("div", {
        onClick: $5a522a184a74c0c3$var$blurSelectInput,
        css: $5a522a184a74c0c3$var$_ref2$1
    }), children(targetRef));
}
function $5a522a184a74c0c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5a522a184a74c0c3$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $5a522a184a74c0c3$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $4N3Qt.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $5a522a184a74c0c3$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $5a522a184a74c0c3$var$RequiredInput$1 = $5a522a184a74c0c3$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $5a522a184a74c0c3$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $5a522a184a74c0c3$var$isIPhone() {
    return $5a522a184a74c0c3$var$testPlatform(/^iPhone/i);
}
function $5a522a184a74c0c3$var$isMac() {
    return $5a522a184a74c0c3$var$testPlatform(/^Mac/i);
}
function $5a522a184a74c0c3$var$isIPad() {
    return $5a522a184a74c0c3$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $5a522a184a74c0c3$var$isMac() && navigator.maxTouchPoints > 1;
}
function $5a522a184a74c0c3$var$isIOS() {
    return $5a522a184a74c0c3$var$isIPhone() || $5a522a184a74c0c3$var$isIPad();
}
function $5a522a184a74c0c3$var$isAppleDevice() {
    return $5a522a184a74c0c3$var$isMac() || $5a522a184a74c0c3$var$isIOS();
}
var $5a522a184a74c0c3$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $5a522a184a74c0c3$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $5a522a184a74c0c3$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $5a522a184a74c0c3$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $5a522a184a74c0c3$var$defaultStyles = {
    clearIndicator: (0, $2Jjmp.a),
    container: (0, $2Jjmp.b),
    control: (0, $2Jjmp.d),
    dropdownIndicator: (0, $2Jjmp.e),
    group: (0, $2Jjmp.g),
    groupHeading: (0, $2Jjmp.f),
    indicatorsContainer: (0, $2Jjmp.i),
    indicatorSeparator: (0, $2Jjmp.h),
    input: (0, $2Jjmp.j),
    loadingIndicator: (0, $2Jjmp.l),
    loadingMessage: (0, $2Jjmp.k),
    menu: (0, $2Jjmp.m),
    menuList: (0, $2Jjmp.n),
    menuPortal: (0, $2Jjmp.o),
    multiValue: (0, $2Jjmp.p),
    multiValueLabel: (0, $2Jjmp.q),
    multiValueRemove: (0, $2Jjmp.t),
    noOptionsMessage: (0, $2Jjmp.u),
    option: (0, $2Jjmp.v),
    placeholder: (0, $2Jjmp.w),
    singleValue: (0, $2Jjmp.x),
    valueContainer: (0, $2Jjmp.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $5a522a184a74c0c3$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $7CFkN.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $5a522a184a74c0c3$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $5a522a184a74c0c3$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $5a522a184a74c0c3$var$baseUnit = 4;
// The minimum height of the control
var $5a522a184a74c0c3$var$controlHeight = 38;
// The amount of space between the control and menu */
var $5a522a184a74c0c3$var$menuGutter = $5a522a184a74c0c3$var$baseUnit * 2;
var $5a522a184a74c0c3$var$spacing = {
    baseUnit: $5a522a184a74c0c3$var$baseUnit,
    controlHeight: $5a522a184a74c0c3$var$controlHeight,
    menuGutter: $5a522a184a74c0c3$var$menuGutter
};
var $5a522a184a74c0c3$export$4368d992c4eafac0 = {
    borderRadius: $5a522a184a74c0c3$var$borderRadius,
    colors: $5a522a184a74c0c3$var$colors,
    spacing: $5a522a184a74c0c3$var$spacing
};
var $5a522a184a74c0c3$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $2Jjmp.z)(),
    captureMenuScroll: !(0, $2Jjmp.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $5a522a184a74c0c3$export$db3b6bfb95261072(),
    formatGroupLabel: $5a522a184a74c0c3$var$formatGroupLabel,
    getOptionLabel: $5a522a184a74c0c3$export$8b22cf2602fb60ce,
    getOptionValue: $5a522a184a74c0c3$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $5a522a184a74c0c3$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $2Jjmp.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $5a522a184a74c0c3$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $5a522a184a74c0c3$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $5a522a184a74c0c3$var$_isOptionSelected(props, option, selectValue);
    var label = $5a522a184a74c0c3$var$getOptionLabel(props, option);
    var value = $5a522a184a74c0c3$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $5a522a184a74c0c3$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $5a522a184a74c0c3$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $5a522a184a74c0c3$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $5a522a184a74c0c3$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $5a522a184a74c0c3$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $2Jjmp.K));
}
function $5a522a184a74c0c3$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $hSuqf.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $5a522a184a74c0c3$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $hSuqf.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $5a522a184a74c0c3$var$buildFocusableOptions(props, selectValue) {
    return $5a522a184a74c0c3$var$buildFocusableOptionsFromCategorizedOptions($5a522a184a74c0c3$var$buildCategorizedOptions(props, selectValue));
}
function $5a522a184a74c0c3$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$5a522a184a74c0c3$var$shouldHideSelectedOptions(props) || !isSelected) && $5a522a184a74c0c3$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $5a522a184a74c0c3$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $5a522a184a74c0c3$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $5a522a184a74c0c3$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $5a522a184a74c0c3$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $5a522a184a74c0c3$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $5a522a184a74c0c3$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $5a522a184a74c0c3$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $5a522a184a74c0c3$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $5a522a184a74c0c3$var$getOptionValue(props, i) === candidate;
    });
}
function $5a522a184a74c0c3$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $5a522a184a74c0c3$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $5a522a184a74c0c3$var$instanceId = 1;
var $5a522a184a74c0c3$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $8EMLg.default)(Select, _Component);
    var _super = (0, $1ZRiV.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $kd56n.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $5a522a184a74c0c3$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $2Jjmp.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $2Jjmp.B)([].concat((0, $hSuqf.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $2Jjmp.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $2Jjmp.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $2Jjmp.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $2Jjmp.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $2Jjmp.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $5a522a184a74c0c3$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $5a522a184a74c0c3$var$buildFocusableOptionsWithIds($5a522a184a74c0c3$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $2Jjmp.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $5a522a184a74c0c3$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $5a522a184a74c0c3$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $5a522a184a74c0c3$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $2Jjmp.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $5a522a184a74c0c3$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $5a522a184a74c0c3$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $7CFkN.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $2Jjmp.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $5a522a184a74c0c3$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$5a522a184a74c0c3$var$instanceId);
        _this.state.selectValue = (0, $2Jjmp.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $5a522a184a74c0c3$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $6kKbN.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $2Jjmp.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $2Jjmp.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $5a522a184a74c0c3$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($5a522a184a74c0c3$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $7CFkN.default)((0, $7CFkN.default)({}, $5a522a184a74c0c3$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $5a522a184a74c0c3$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $5a522a184a74c0c3$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $5a522a184a74c0c3$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $7CFkN.default)((0, $7CFkN.default)((0, $7CFkN.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $exYeM.createElement($5a522a184a74c0c3$var$DummyInput, (0, $aJx1R.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $2Jjmp.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $exYeM.createElement(Input, (0, $aJx1R.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $exYeM.createElement(Placeholder, (0, $aJx1R.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $exYeM.createElement(MultiValue, (0, $aJx1R.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $exYeM.createElement(SingleValue, (0, $aJx1R.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $exYeM.createElement(ClearIndicator, (0, $aJx1R.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $exYeM.createElement(LoadingIndicator, (0, $aJx1R.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $exYeM.createElement(IndicatorSeparator, (0, $aJx1R.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $exYeM.createElement(DropdownIndicator, (0, $aJx1R.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $exYeM.createElement(Option, (0, $aJx1R.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $exYeM.createElement(Group, (0, $aJx1R.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $exYeM.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $exYeM.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $exYeM.createElement((0, $2Jjmp.M), (0, $aJx1R.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $exYeM.createElement(Menu, (0, $aJx1R.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $exYeM.createElement($5a522a184a74c0c3$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $exYeM.createElement(MenuList, (0, $aJx1R.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $exYeM.createElement(MenuPortal, (0, $aJx1R.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $exYeM.createElement($5a522a184a74c0c3$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $exYeM.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $exYeM.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $exYeM.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $exYeM.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $exYeM.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $exYeM.createElement($5a522a184a74c0c3$var$LiveRegion$1, (0, $aJx1R.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $exYeM.createElement(SelectContainer, (0, $aJx1R.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $exYeM.createElement(Control, (0, $aJx1R.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $exYeM.createElement(ValueContainer, (0, $aJx1R.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $exYeM.createElement(IndicatorsContainer, (0, $aJx1R.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $2Jjmp.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $5a522a184a74c0c3$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $5a522a184a74c0c3$var$buildFocusableOptionsWithIds($5a522a184a74c0c3$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $5a522a184a74c0c3$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $5a522a184a74c0c3$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $5a522a184a74c0c3$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $2Jjmp.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $7CFkN.default)((0, $7CFkN.default)((0, $7CFkN.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $exYeM.Component));
$5a522a184a74c0c3$export$25ce5a424b770e84.defaultProps = $5a522a184a74c0c3$export$407448d2b89b1813;

});
parcelRegister("kd56n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb68faaebde2ec0f$export$2e2bcd8739ae039; });
function $eb68faaebde2ec0f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6kKbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49c8709106076573$export$2e2bcd8739ae039; });

var $d9KNw = parcelRequire("d9KNw");
function $49c8709106076573$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $d9KNw.default)(o.key), o);
    }
}
function $49c8709106076573$export$2e2bcd8739ae039(e, r, t) {
    return r && $49c8709106076573$var$_defineProperties(e.prototype, r), t && $49c8709106076573$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("8EMLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d7e21dc5e0f704$export$2e2bcd8739ae039; });

var $5NwIB = parcelRequire("5NwIB");
function $64d7e21dc5e0f704$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $5NwIB.default)(t, e);
}

});
parcelRegister("5NwIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438ae88f4b206ba2$export$2e2bcd8739ae039; });
function $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e) {
    return $438ae88f4b206ba2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1ZRiV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1744d611733dc217$export$2e2bcd8739ae039; });

var $1wiRZ = parcelRequire("1wiRZ");

var $fVf3e = parcelRequire("fVf3e");

var $trDLD = parcelRequire("trDLD");
function $1744d611733dc217$export$2e2bcd8739ae039(t) {
    var r = (0, $fVf3e.default)();
    return function() {
        var e, o = (0, $1wiRZ.default)(t);
        if (r) {
            var s = (0, $1wiRZ.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $trDLD.default)(this, e);
    };
}

});
parcelRegister("1wiRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b76ac3717bcb79$export$2e2bcd8739ae039; });
function $11b76ac3717bcb79$export$2e2bcd8739ae039(t) {
    return $11b76ac3717bcb79$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $11b76ac3717bcb79$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fVf3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b977dabd4d3277fe$export$2e2bcd8739ae039; });
function $b977dabd4d3277fe$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b977dabd4d3277fe$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("trDLD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0588265b6dbabb0b$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $bYAPj = parcelRequire("bYAPj");
function $0588265b6dbabb0b$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $ana82.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bYAPj.default)(t);
}

});
parcelRegister("bYAPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b81dd4f51678982$export$2e2bcd8739ae039; });
function $8b81dd4f51678982$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("hSuqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d03f1413c8055345$export$2e2bcd8739ae039; });

var $uv40s = parcelRequire("uv40s");

var $bdw2e = parcelRequire("bdw2e");

var $45CPT = parcelRequire("45CPT");

var $5XUS7 = parcelRequire("5XUS7");
function $d03f1413c8055345$export$2e2bcd8739ae039(r) {
    return (0, $uv40s.default)(r) || (0, $bdw2e.default)(r) || (0, $45CPT.default)(r) || (0, $5XUS7.default)();
}

});
parcelRegister("uv40s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05bae60b5059fa29$export$2e2bcd8739ae039; });

var $5z2Zn = parcelRequire("5z2Zn");
function $05bae60b5059fa29$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5z2Zn.default)(r);
}

});

parcelRegister("bdw2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82a9c213e7b5e835$export$2e2bcd8739ae039; });
function $82a9c213e7b5e835$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("5XUS7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457e940208e3f1f6$export$2e2bcd8739ae039; });
function $457e940208e3f1f6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2Jjmp", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $1fcecd50114018fb$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $1fcecd50114018fb$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $1fcecd50114018fb$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $1fcecd50114018fb$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $1fcecd50114018fb$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $1fcecd50114018fb$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $1fcecd50114018fb$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $1fcecd50114018fb$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $1fcecd50114018fb$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $1fcecd50114018fb$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $1fcecd50114018fb$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $1fcecd50114018fb$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $1fcecd50114018fb$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $1fcecd50114018fb$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $1fcecd50114018fb$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $1fcecd50114018fb$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $1fcecd50114018fb$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $1fcecd50114018fb$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $1fcecd50114018fb$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $1fcecd50114018fb$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $1fcecd50114018fb$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $1fcecd50114018fb$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $1fcecd50114018fb$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $1fcecd50114018fb$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $1fcecd50114018fb$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $1fcecd50114018fb$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $1fcecd50114018fb$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $1fcecd50114018fb$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $1fcecd50114018fb$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $1fcecd50114018fb$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $1fcecd50114018fb$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $1fcecd50114018fb$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $1fcecd50114018fb$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $1fcecd50114018fb$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $1fcecd50114018fb$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $1fcecd50114018fb$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "F", function () { return $1fcecd50114018fb$export$d66501df72047452; });

var $7CFkN = parcelRequire("7CFkN");

var $aJx1R = parcelRequire("aJx1R");

var $4N3Qt = parcelRequire("4N3Qt");

var $e3xqi = parcelRequire("e3xqi");

var $4nNod = parcelRequire("4nNod");

var $ana82 = parcelRequire("ana82");

var $dFnsN = parcelRequire("dFnsN");

var $lB7P9 = parcelRequire("lB7P9");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $9Q6OH = parcelRequire("9Q6OH");

var $rA44O = parcelRequire("rA44O");
var $1fcecd50114018fb$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $1fcecd50114018fb$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $1fcecd50114018fb$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $1fcecd50114018fb$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($1fcecd50114018fb$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $1fcecd50114018fb$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($1fcecd50114018fb$var$isArray(value)) return value.filter(Boolean);
    if ((0, $ana82.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $1fcecd50114018fb$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $4nNod.default)(props, $1fcecd50114018fb$var$_excluded$4);
    return (0, $7CFkN.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $1fcecd50114018fb$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $1fcecd50114018fb$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $1fcecd50114018fb$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $1fcecd50114018fb$var$normalizedHeight(el) {
    if ($1fcecd50114018fb$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $1fcecd50114018fb$var$getScrollTop(el) {
    if ($1fcecd50114018fb$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1fcecd50114018fb$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1fcecd50114018fb$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $1fcecd50114018fb$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $1fcecd50114018fb$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1fcecd50114018fb$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $1fcecd50114018fb$export$b4171a6734a65d42;
    var start = $1fcecd50114018fb$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $1fcecd50114018fb$var$easeOutCubic(currentTime, start, change, duration);
        $1fcecd50114018fb$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $1fcecd50114018fb$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $1fcecd50114018fb$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $1fcecd50114018fb$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $1fcecd50114018fb$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $1fcecd50114018fb$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $1fcecd50114018fb$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $1fcecd50114018fb$var$passiveOptionAccessed = false;
var $1fcecd50114018fb$var$options = {
    get passive () {
        return $1fcecd50114018fb$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $1fcecd50114018fb$var$w = typeof window !== 'undefined' ? window : {};
if ($1fcecd50114018fb$var$w.addEventListener && $1fcecd50114018fb$var$w.removeEventListener) {
    $1fcecd50114018fb$var$w.addEventListener('p', $1fcecd50114018fb$export$b4171a6734a65d42, $1fcecd50114018fb$var$options);
    $1fcecd50114018fb$var$w.removeEventListener('p', $1fcecd50114018fb$export$b4171a6734a65d42, false);
}
var $1fcecd50114018fb$export$2408f22a0fab9ae5 = $1fcecd50114018fb$var$passiveOptionAccessed;
function $1fcecd50114018fb$export$3466f893ebf79586(item) {
    return item != null;
}
function $1fcecd50114018fb$var$isArray(arg) {
    return Array.isArray(arg);
}
function $1fcecd50114018fb$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $1fcecd50114018fb$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $1fcecd50114018fb$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $1fcecd50114018fb$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $e3xqi.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $e3xqi.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $1fcecd50114018fb$var$_excluded$3 = [
    "children",
    "innerProps"
], $1fcecd50114018fb$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $1fcecd50114018fb$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $1fcecd50114018fb$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $1fcecd50114018fb$var$normalizedHeight(scrollParent);
    var scrollTop = $1fcecd50114018fb$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1fcecd50114018fb$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $1fcecd50114018fb$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $1fcecd50114018fb$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1fcecd50114018fb$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $1fcecd50114018fb$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $1fcecd50114018fb$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $1fcecd50114018fb$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $1fcecd50114018fb$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $7CFkN.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $lB7P9.default)(_objectSpread2, $1fcecd50114018fb$var$alignToControl(placement), '100%'), (0, $lB7P9.default)(_objectSpread2, "position", 'absolute'), (0, $lB7P9.default)(_objectSpread2, "width", '100%'), (0, $lB7P9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $1fcecd50114018fb$var$PortalPlacementContext = /*#__PURE__*/ (0, $exYeM.createContext)(null);
// NOTE: internal only
var $1fcecd50114018fb$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $exYeM.useContext)($1fcecd50114018fb$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $exYeM.useRef)(null);
    var _useState = (0, $exYeM.useState)(maxMenuHeight), _useState2 = (0, $e3xqi.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $exYeM.useState)(null), _useState4 = (0, $e3xqi.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $rA44O.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $1fcecd50114018fb$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $7CFkN.default)((0, $7CFkN.default)({}, props), {}, {
            placement: placement || $1fcecd50114018fb$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $1fcecd50114018fb$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $1fcecd50114018fb$var$Menu$1 = $1fcecd50114018fb$var$Menu;
// ==============================
// Menu List
// ==============================
var $1fcecd50114018fb$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $7CFkN.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $1fcecd50114018fb$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $1fcecd50114018fb$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $7CFkN.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $1fcecd50114018fb$export$3b14a55fb2447963 = $1fcecd50114018fb$var$noticeCSS;
var $1fcecd50114018fb$export$342063e11d6c3cad = $1fcecd50114018fb$var$noticeCSS;
var $1fcecd50114018fb$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $4nNod.default)(_ref6, $1fcecd50114018fb$var$_excluded$3);
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps((0, $7CFkN.default)((0, $7CFkN.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $1fcecd50114018fb$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $4nNod.default)(_ref7, $1fcecd50114018fb$var$_excluded2$1);
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps((0, $7CFkN.default)((0, $7CFkN.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $1fcecd50114018fb$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $1fcecd50114018fb$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $exYeM.useRef)(null);
    var cleanupRef = (0, $exYeM.useRef)(null);
    var _useState5 = (0, $exYeM.useState)($1fcecd50114018fb$var$coercePlacement(menuPlacement)), _useState6 = (0, $e3xqi.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $exYeM.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $exYeM.useState)(null), _useState8 = (0, $e3xqi.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $exYeM.useCallback)(function() {
        if (!controlElement) return;
        var rect = $1fcecd50114018fb$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $rA44O.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $exYeM.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $9Q6OH.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $rA44O.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $exYeM.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({
        ref: setMenuPortalElement
    }, $1fcecd50114018fb$var$getStyleProps((0, $7CFkN.default)((0, $7CFkN.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $4N3Qt.jsx)($1fcecd50114018fb$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $d2lNW.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $1fcecd50114018fb$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $1fcecd50114018fb$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $1fcecd50114018fb$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $7CFkN.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $1fcecd50114018fb$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $1fcecd50114018fb$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $1fcecd50114018fb$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $1fcecd50114018fb$var$_templateObject;
var $1fcecd50114018fb$var$_excluded$2 = [
    "size"
], $1fcecd50114018fb$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $1fcecd50114018fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $1fcecd50114018fb$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $1fcecd50114018fb$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $4nNod.default)(_ref, $1fcecd50114018fb$var$_excluded$2);
    return (0, $4N3Qt.jsx)("svg", (0, $aJx1R.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $1fcecd50114018fb$var$_ref2
    }, props));
};
var $1fcecd50114018fb$var$CrossIcon = function CrossIcon(props) {
    return (0, $4N3Qt.jsx)($1fcecd50114018fb$var$Svg, (0, $aJx1R.default)({
        size: 20
    }, props), (0, $4N3Qt.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $1fcecd50114018fb$var$DownChevron = function DownChevron(props) {
    return (0, $4N3Qt.jsx)($1fcecd50114018fb$var$Svg, (0, $aJx1R.default)({
        size: 20
    }, props), (0, $4N3Qt.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $1fcecd50114018fb$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $7CFkN.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $1fcecd50114018fb$export$f1e1789686576879 = $1fcecd50114018fb$var$baseCSS;
var $1fcecd50114018fb$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $4N3Qt.jsx)($1fcecd50114018fb$var$DownChevron, null));
};
var $1fcecd50114018fb$export$407448d2b89b1813 = $1fcecd50114018fb$var$baseCSS;
var $1fcecd50114018fb$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $4N3Qt.jsx)($1fcecd50114018fb$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $1fcecd50114018fb$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $7CFkN.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $1fcecd50114018fb$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("span", (0, $aJx1R.default)({}, innerProps, $1fcecd50114018fb$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $1fcecd50114018fb$var$loadingDotAnimations = (0, $4N3Qt.keyframes)($1fcecd50114018fb$var$_templateObject || ($1fcecd50114018fb$var$_templateObject = (0, $dFnsN.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $1fcecd50114018fb$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $7CFkN.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $1fcecd50114018fb$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $4N3Qt.jsx)("span", {
        css: /*#__PURE__*/ (0, $4N3Qt.css)({
            animation: "".concat($1fcecd50114018fb$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $1fcecd50114018fb$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $4nNod.default)(_ref7, $1fcecd50114018fb$var$_excluded2);
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps((0, $7CFkN.default)((0, $7CFkN.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $4N3Qt.jsx)($1fcecd50114018fb$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $4N3Qt.jsx)($1fcecd50114018fb$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $4N3Qt.jsx)($1fcecd50114018fb$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $1fcecd50114018fb$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $7CFkN.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $1fcecd50114018fb$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({
        ref: innerRef
    }, $1fcecd50114018fb$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $1fcecd50114018fb$var$Control$1 = $1fcecd50114018fb$var$Control;
var $1fcecd50114018fb$var$_excluded$1 = [
    "data"
];
var $1fcecd50114018fb$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $1fcecd50114018fb$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $4N3Qt.jsx)(Heading, (0, $aJx1R.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $4N3Qt.jsx)("div", null, children));
};
var $1fcecd50114018fb$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $7CFkN.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $1fcecd50114018fb$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $1fcecd50114018fb$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $4nNod.default)(_cleanCommonProps, $1fcecd50114018fb$var$_excluded$1);
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $1fcecd50114018fb$var$Group$1 = $1fcecd50114018fb$var$Group;
var $1fcecd50114018fb$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $1fcecd50114018fb$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7CFkN.default)((0, $7CFkN.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $1fcecd50114018fb$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $1fcecd50114018fb$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $1fcecd50114018fb$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $7CFkN.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $1fcecd50114018fb$var$spacingStyle)
};
var $1fcecd50114018fb$var$inputStyle = function inputStyle(isHidden) {
    return (0, $7CFkN.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $1fcecd50114018fb$var$spacingStyle);
};
var $1fcecd50114018fb$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $1fcecd50114018fb$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $4nNod.default)(_cleanCommonProps, $1fcecd50114018fb$var$_excluded);
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $4N3Qt.jsx)("input", (0, $aJx1R.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $1fcecd50114018fb$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $1fcecd50114018fb$var$Input$1 = $1fcecd50114018fb$var$Input;
var $1fcecd50114018fb$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $7CFkN.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $1fcecd50114018fb$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $7CFkN.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $1fcecd50114018fb$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $7CFkN.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $1fcecd50114018fb$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $4N3Qt.jsx)("div", innerProps, children);
};
var $1fcecd50114018fb$var$MultiValueContainer = $1fcecd50114018fb$var$MultiValueGeneric;
var $1fcecd50114018fb$var$MultiValueLabel = $1fcecd50114018fb$var$MultiValueGeneric;
function $1fcecd50114018fb$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({
        role: "button"
    }, innerProps), children || (0, $4N3Qt.jsx)($1fcecd50114018fb$var$CrossIcon, {
        size: 14
    }));
}
var $1fcecd50114018fb$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $4N3Qt.jsx)(Container, {
        data: data,
        innerProps: (0, $7CFkN.default)((0, $7CFkN.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $4N3Qt.jsx)(Label, {
        data: data,
        innerProps: (0, $7CFkN.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $4N3Qt.jsx)(Remove, {
        data: data,
        innerProps: (0, $7CFkN.default)((0, $7CFkN.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $1fcecd50114018fb$var$MultiValue$1 = $1fcecd50114018fb$var$MultiValue;
var $1fcecd50114018fb$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7CFkN.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $1fcecd50114018fb$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $1fcecd50114018fb$var$Option$1 = $1fcecd50114018fb$var$Option;
var $1fcecd50114018fb$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7CFkN.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $1fcecd50114018fb$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $1fcecd50114018fb$var$Placeholder$1 = $1fcecd50114018fb$var$Placeholder;
var $1fcecd50114018fb$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $7CFkN.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $1fcecd50114018fb$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $4N3Qt.jsx)("div", (0, $aJx1R.default)({}, $1fcecd50114018fb$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $1fcecd50114018fb$var$SingleValue$1 = $1fcecd50114018fb$var$SingleValue;
var $1fcecd50114018fb$export$db3b6bfb95261072 = {
    ClearIndicator: $1fcecd50114018fb$var$ClearIndicator,
    Control: $1fcecd50114018fb$var$Control$1,
    DropdownIndicator: $1fcecd50114018fb$var$DropdownIndicator,
    DownChevron: $1fcecd50114018fb$var$DownChevron,
    CrossIcon: $1fcecd50114018fb$var$CrossIcon,
    Group: $1fcecd50114018fb$var$Group$1,
    GroupHeading: $1fcecd50114018fb$var$GroupHeading,
    IndicatorsContainer: $1fcecd50114018fb$var$IndicatorsContainer,
    IndicatorSeparator: $1fcecd50114018fb$var$IndicatorSeparator,
    Input: $1fcecd50114018fb$var$Input$1,
    LoadingIndicator: $1fcecd50114018fb$var$LoadingIndicator,
    Menu: $1fcecd50114018fb$var$Menu$1,
    MenuList: $1fcecd50114018fb$var$MenuList,
    MenuPortal: $1fcecd50114018fb$var$MenuPortal,
    LoadingMessage: $1fcecd50114018fb$var$LoadingMessage,
    NoOptionsMessage: $1fcecd50114018fb$var$NoOptionsMessage,
    MultiValue: $1fcecd50114018fb$var$MultiValue$1,
    MultiValueContainer: $1fcecd50114018fb$var$MultiValueContainer,
    MultiValueLabel: $1fcecd50114018fb$var$MultiValueLabel,
    MultiValueRemove: $1fcecd50114018fb$var$MultiValueRemove,
    Option: $1fcecd50114018fb$var$Option$1,
    Placeholder: $1fcecd50114018fb$var$Placeholder$1,
    SelectContainer: $1fcecd50114018fb$var$SelectContainer,
    SingleValue: $1fcecd50114018fb$var$SingleValue$1,
    ValueContainer: $1fcecd50114018fb$var$ValueContainer
};
var $1fcecd50114018fb$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $7CFkN.default)((0, $7CFkN.default)({}, $1fcecd50114018fb$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("4N3Qt", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $37ceb8a84e04816c$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $37ceb8a84e04816c$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $37ceb8a84e04816c$export$c8a8987d4410bf2d; });

var $dJ7Y7 = parcelRequire("dJ7Y7");

var $exYeM = parcelRequire("exYeM");

var $T7vh0 = parcelRequire("T7vh0");

var $hC5sW = parcelRequire("hC5sW");

var $6ol0g = parcelRequire("6ol0g");
parcelRequire("kJJU8");
parcelRequire("efvJ0");
parcelRequire("3u9AZ");

parcelRequire("5n5FB");
var $37ceb8a84e04816c$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $dJ7Y7.h).call(props, 'css')) return $exYeM.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $dJ7Y7.E);
    createElementArgArray[1] = (0, $dJ7Y7.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $exYeM.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($37ceb8a84e04816c$export$c8a8987d4410bf2d || ($37ceb8a84e04816c$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $37ceb8a84e04816c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $dJ7Y7.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6ol0g.serializeStyles)([
        styles
    ], undefined, $exYeM.useContext((0, $dJ7Y7.T)));
    if (!(0, $dJ7Y7.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $exYeM.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $exYeM.useRef();
    (0, $hC5sW.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $hC5sW.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $T7vh0.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $37ceb8a84e04816c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6ol0g.serializeStyles)(args);
}
function $37ceb8a84e04816c$export$d25ddfdf17c3ad3e() {
    var insertable = $37ceb8a84e04816c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $37ceb8a84e04816c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $37ceb8a84e04816c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $T7vh0.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $37ceb8a84e04816c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $hC5sW.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $T7vh0.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $dJ7Y7.i) && res !== undefined) rules += res;
        }
        if (!(0, $dJ7Y7.i)) return rules;
    });
    if (!(0, $dJ7Y7.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $exYeM.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $37ceb8a84e04816c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $dJ7Y7.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $dJ7Y7.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6ol0g.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $T7vh0.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $dJ7Y7.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $37ceb8a84e04816c$var$merge(cache.registered, css, $37ceb8a84e04816c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $exYeM.useContext((0, $dJ7Y7.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($37ceb8a84e04816c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("dJ7Y7", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $9fe5a8be6979abad$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $9fe5a8be6979abad$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $9fe5a8be6979abad$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $9fe5a8be6979abad$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $9fe5a8be6979abad$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $9fe5a8be6979abad$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $9fe5a8be6979abad$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $9fe5a8be6979abad$export$a9c23c6ac3fc3eca; });

var $exYeM = parcelRequire("exYeM");

var $kJJU8 = parcelRequire("kJJU8");

var $aJx1R = parcelRequire("aJx1R");

var $3u9AZ = parcelRequire("3u9AZ");

var $l2e9o = parcelRequire("l2e9o");

var $T7vh0 = parcelRequire("T7vh0");

var $6ol0g = parcelRequire("6ol0g");

var $hC5sW = parcelRequire("hC5sW");
var $9fe5a8be6979abad$export$407448d2b89b1813 = false;
var $9fe5a8be6979abad$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $9fe5a8be6979abad$var$EmotionCacheContext = /* #__PURE__ */ $exYeM.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $kJJU8.default)({
    key: 'css'
}) : null);
var $9fe5a8be6979abad$export$e7094788287c5e9b = $9fe5a8be6979abad$var$EmotionCacheContext.Provider;
var $9fe5a8be6979abad$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $exYeM.useContext)($9fe5a8be6979abad$var$EmotionCacheContext);
};
var $9fe5a8be6979abad$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $exYeM.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $exYeM.useContext)($9fe5a8be6979abad$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$9fe5a8be6979abad$export$23f2a1d2818174ef) $9fe5a8be6979abad$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $exYeM.useContext)($9fe5a8be6979abad$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $kJJU8.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $exYeM.createElement($9fe5a8be6979abad$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $9fe5a8be6979abad$export$971d5caa766a69d7 = /* #__PURE__ */ $exYeM.createContext({});
var $9fe5a8be6979abad$export$3b14a55fb2447963 = function useTheme() {
    return $exYeM.useContext($9fe5a8be6979abad$export$971d5caa766a69d7);
};
var $9fe5a8be6979abad$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $aJx1R.default)({}, outerTheme, theme);
};
var $9fe5a8be6979abad$var$createCacheWithTheme = /* #__PURE__ */ (0, $3u9AZ.default)(function(outerTheme) {
    return (0, $3u9AZ.default)(function(theme) {
        return $9fe5a8be6979abad$var$getTheme(outerTheme, theme);
    });
});
var $9fe5a8be6979abad$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $exYeM.useContext($9fe5a8be6979abad$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $9fe5a8be6979abad$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $exYeM.createElement($9fe5a8be6979abad$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $9fe5a8be6979abad$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $exYeM.forwardRef(function render(props, ref) {
        var theme = $exYeM.useContext($9fe5a8be6979abad$export$971d5caa766a69d7);
        return /*#__PURE__*/ $exYeM.createElement(Component, (0, $aJx1R.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $l2e9o.default)(WithTheme, Component);
}
var $9fe5a8be6979abad$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $9fe5a8be6979abad$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $9fe5a8be6979abad$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($9fe5a8be6979abad$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$9fe5a8be6979abad$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $9fe5a8be6979abad$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $T7vh0.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $hC5sW.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $T7vh0.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9fe5a8be6979abad$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $exYeM.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9fe5a8be6979abad$var$Emotion = /* #__PURE__ */ $9fe5a8be6979abad$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$9fe5a8be6979abad$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $T7vh0.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6ol0g.serializeStyles)(registeredStyles, undefined, $exYeM.useContext($9fe5a8be6979abad$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($9fe5a8be6979abad$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $9fe5a8be6979abad$var$typePropName && !$9fe5a8be6979abad$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($9fe5a8be6979abad$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $exYeM.createElement(WrappedComponent, newProps));
});
var $9fe5a8be6979abad$export$a9c23c6ac3fc3eca = $9fe5a8be6979abad$var$Emotion;

});
parcelRegister("kJJU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f18b9e40e13a8f6b$export$2e2bcd8739ae039; });

var $6wIDc = parcelRequire("6wIDc");

var $lsm0P = parcelRequire("lsm0P");

var $3u9AZ = parcelRequire("3u9AZ");

var $3xeCd = parcelRequire("3xeCd");
var $f18b9e40e13a8f6b$var$isBrowser = typeof document !== 'undefined';
var $f18b9e40e13a8f6b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $lsm0P.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $lsm0P.token)(character)) break;
        (0, $lsm0P.next)();
    }
    return (0, $lsm0P.slice)(begin, (0, $lsm0P.position));
};
var $f18b9e40e13a8f6b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $lsm0P.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $lsm0P.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $f18b9e40e13a8f6b$var$identifierWithPointTracking((0, $lsm0P.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $lsm0P.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $lsm0P.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $lsm0P.from)(character);
    }
    while (character = (0, $lsm0P.next)());
    return parsed;
};
var $f18b9e40e13a8f6b$var$getRules = function getRules(value, points) {
    return (0, $lsm0P.dealloc)($f18b9e40e13a8f6b$var$toRules((0, $lsm0P.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $f18b9e40e13a8f6b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $f18b9e40e13a8f6b$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$f18b9e40e13a8f6b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $f18b9e40e13a8f6b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $f18b9e40e13a8f6b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $f18b9e40e13a8f6b$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $f18b9e40e13a8f6b$var$prefix(value, length) {
    switch((0, $lsm0P.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lsm0P.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lsm0P.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MOZ) + value + (0, $lsm0P.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + value + value;
        // order
        case 6165:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.replace)(value, /(\w+).+(:[^]+)/, (0, $lsm0P.WEBKIT) + 'box-$1$2' + (0, $lsm0P.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + 'flex-item-' + (0, $lsm0P.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + 'flex-line-pack' + (0, $lsm0P.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $lsm0P.WEBKIT) + 'box-' + (0, $lsm0P.replace)(value, '-grow', '') + (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $lsm0P.WEBKIT) + (0, $lsm0P.replace)(value, /([^-])(transform)/g, '$1' + (0, $lsm0P.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $lsm0P.replace)((0, $lsm0P.replace)((0, $lsm0P.replace)(value, /(zoom-|grab)/, (0, $lsm0P.WEBKIT) + '$1'), /(image-set)/, (0, $lsm0P.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $lsm0P.replace)(value, /(image-set\([^]*)/, (0, $lsm0P.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $lsm0P.replace)((0, $lsm0P.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lsm0P.WEBKIT) + 'box-pack:$3' + (0, $lsm0P.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $lsm0P.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $lsm0P.replace)(value, /(.+)-inline(.+)/, (0, $lsm0P.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $lsm0P.strlen)(value) - 1 - length > 6) switch((0, $lsm0P.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $lsm0P.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $lsm0P.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $lsm0P.WEBKIT) + '$2-$3' + '$1' + (0, $lsm0P.MOZ) + ((0, $lsm0P.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $lsm0P.indexof)(value, 'stretch') ? $f18b9e40e13a8f6b$var$prefix((0, $lsm0P.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $lsm0P.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $lsm0P.charat)(value, (0, $lsm0P.strlen)(value) - 3 - (~(0, $lsm0P.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $lsm0P.replace)(value, ':', ':' + (0, $lsm0P.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $lsm0P.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $lsm0P.WEBKIT) + ((0, $lsm0P.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $lsm0P.WEBKIT) + '$2$3' + '$1' + (0, $lsm0P.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $lsm0P.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + value + value;
    }
    return value;
}
var $f18b9e40e13a8f6b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $lsm0P.DECLARATION:
                element["return"] = $f18b9e40e13a8f6b$var$prefix(element.value, element.length);
                break;
            case 0, $lsm0P.KEYFRAMES:
                return (0, $lsm0P.serialize)([
                    (0, $lsm0P.copy)(element, {
                        value: (0, $lsm0P.replace)(element.value, '@', '@' + (0, $lsm0P.WEBKIT))
                    })
                ], callback);
            case 0, $lsm0P.RULESET:
                if (element.length) return (0, $lsm0P.combine)(element.props, function(value) {
                    switch((0, $lsm0P.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $lsm0P.serialize)([
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(read-\w+)/, ':' + (0, $lsm0P.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $lsm0P.serialize)([
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(plac\w+)/, ':' + (0, $lsm0P.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(plac\w+)/, ':' + (0, $lsm0P.MOZ) + '$1')
                                    ]
                                }),
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(plac\w+)/, (0, $lsm0P.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $f18b9e40e13a8f6b$var$getServerStylisCache = $f18b9e40e13a8f6b$var$isBrowser ? undefined : (0, $3u9AZ.default)(function() {
    return (0, $3xeCd.default)(function() {
        return {};
    });
});
var $f18b9e40e13a8f6b$var$defaultStylisPlugins = [
    $f18b9e40e13a8f6b$var$prefixer
];
var $f18b9e40e13a8f6b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($f18b9e40e13a8f6b$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $f18b9e40e13a8f6b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($f18b9e40e13a8f6b$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $f18b9e40e13a8f6b$var$compat,
        $f18b9e40e13a8f6b$var$removeLabel
    ];
    if (!$f18b9e40e13a8f6b$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $lsm0P.stringify),
            (0, $lsm0P.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $lsm0P.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $lsm0P.serialize)((0, $lsm0P.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $lsm0P.stringify)
        ];
        var _serializer = (0, $lsm0P.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $lsm0P.serialize)((0, $lsm0P.compile)(styles), _serializer);
        };
        var serverStylisCache = $f18b9e40e13a8f6b$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $6wIDc.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("6wIDc", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $4c085a0d7bb16e67$export$9d753cd7ae895cce; });
var $4c085a0d7bb16e67$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $4c085a0d7bb16e67$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $4c085a0d7bb16e67$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $4c085a0d7bb16e67$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$4c085a0d7bb16e67$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($4c085a0d7bb16e67$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $4c085a0d7bb16e67$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("lsm0P", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $98c7a0c432789d27$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $98c7a0c432789d27$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $98c7a0c432789d27$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $98c7a0c432789d27$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $98c7a0c432789d27$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $98c7a0c432789d27$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $98c7a0c432789d27$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $98c7a0c432789d27$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $98c7a0c432789d27$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $98c7a0c432789d27$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $98c7a0c432789d27$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $98c7a0c432789d27$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $98c7a0c432789d27$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $98c7a0c432789d27$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $98c7a0c432789d27$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $98c7a0c432789d27$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $98c7a0c432789d27$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $98c7a0c432789d27$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $98c7a0c432789d27$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $98c7a0c432789d27$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $98c7a0c432789d27$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $98c7a0c432789d27$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $98c7a0c432789d27$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $98c7a0c432789d27$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $98c7a0c432789d27$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $98c7a0c432789d27$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $98c7a0c432789d27$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $98c7a0c432789d27$export$38bcb760f1d4871c; });
var $98c7a0c432789d27$export$71ad59f2e432cfe8 = "-ms-";
var $98c7a0c432789d27$export$2c0f367103c8d01c = "-moz-";
var $98c7a0c432789d27$export$39dfd62a25e0fe93 = "-webkit-";
var $98c7a0c432789d27$export$a29989082612d0d9 = "comm";
var $98c7a0c432789d27$export$aa3a2e812ca8570d = "rule";
var $98c7a0c432789d27$export$527d108ccf083c2b = "decl";
var $98c7a0c432789d27$export$d3d35020fa5b54f0 = "@page";
var $98c7a0c432789d27$export$500415a86c544f73 = "@media";
var $98c7a0c432789d27$export$a763edbf796b780a = "@import";
var $98c7a0c432789d27$export$2790aeb8b4e5c826 = "@charset";
var $98c7a0c432789d27$export$1cc683e23b84b133 = "@viewport";
var $98c7a0c432789d27$export$9447a5efea57e862 = "@supports";
var $98c7a0c432789d27$export$ef011b4e114b1fba = "@document";
var $98c7a0c432789d27$export$6aad947bda0f3f46 = "@namespace";
var $98c7a0c432789d27$export$b44a8529a35fcb60 = "@keyframes";
var $98c7a0c432789d27$export$2c16de31893252e6 = "@font-face";
var $98c7a0c432789d27$export$3d846dd52e150c6f = "@counter-style";
var $98c7a0c432789d27$export$22314bfbb57653fe = "@font-feature-values";
var $98c7a0c432789d27$export$d773506282b3cfe6 = "@layer";
var $98c7a0c432789d27$export$2335f513bbd82c6d = Math.abs;
var $98c7a0c432789d27$export$6788812c4e6611e6 = String.fromCharCode;
var $98c7a0c432789d27$export$e6e34fd1f2686227 = Object.assign;
function $98c7a0c432789d27$export$d6af199866bfb566(e, r) {
    return $98c7a0c432789d27$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 0)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 1)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 2)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 3) : 0;
}
function $98c7a0c432789d27$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $98c7a0c432789d27$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $98c7a0c432789d27$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $98c7a0c432789d27$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $98c7a0c432789d27$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $98c7a0c432789d27$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $98c7a0c432789d27$export$36776f635604f274(e) {
    return e.length;
}
function $98c7a0c432789d27$export$f9084667e487ed46(e) {
    return e.length;
}
function $98c7a0c432789d27$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $98c7a0c432789d27$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $98c7a0c432789d27$export$53f1d5ea8de3d7c = 1;
var $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1;
var $98c7a0c432789d27$export$f24224f1c91d8156 = 0;
var $98c7a0c432789d27$export$5880b8b5730aff45 = 0;
var $98c7a0c432789d27$export$c0306caf338ac095 = 0;
var $98c7a0c432789d27$export$30a86d91af8ff6e6 = "";
function $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $98c7a0c432789d27$export$53f1d5ea8de3d7c,
        column: $98c7a0c432789d27$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $98c7a0c432789d27$export$784d13d8ee351f07(e, r) {
    return $98c7a0c432789d27$export$e6e34fd1f2686227($98c7a0c432789d27$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $98c7a0c432789d27$export$eba6f6f03b0a92e7() {
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$232faf9add678146() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 > 0 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, --$98c7a0c432789d27$export$5880b8b5730aff45) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3--, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c--;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$48cfd1e771a65c4f() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 < $98c7a0c432789d27$export$f24224f1c91d8156 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45++) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3++, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c++;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$4d3fb11e950abb9e() {
    return $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$e88cb2efb12ae807() {
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$58adb3bec8346d0f(e, r) {
    return $98c7a0c432789d27$export$2f35ab04d2335697($98c7a0c432789d27$export$30a86d91af8ff6e6, e, r);
}
function $98c7a0c432789d27$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $98c7a0c432789d27$export$2de70f21292aac9e(e) {
    return $98c7a0c432789d27$export$53f1d5ea8de3d7c = $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$f24224f1c91d8156 = $98c7a0c432789d27$export$36776f635604f274($98c7a0c432789d27$export$30a86d91af8ff6e6 = e), $98c7a0c432789d27$export$5880b8b5730aff45 = 0, [];
}
function $98c7a0c432789d27$export$45918ac1574455b1(e) {
    return $98c7a0c432789d27$export$30a86d91af8ff6e6 = "", e;
}
function $98c7a0c432789d27$export$410ac95b9ec204b8(e) {
    return $98c7a0c432789d27$export$87c2784dc9fc4ab($98c7a0c432789d27$export$58adb3bec8346d0f($98c7a0c432789d27$export$5880b8b5730aff45 - 1, $98c7a0c432789d27$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $98c7a0c432789d27$export$660b2ee2d4fb4eff(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$5f8c09e3ae6f64e1($98c7a0c432789d27$export$2de70f21292aac9e(e)));
}
function $98c7a0c432789d27$export$7af1228ff777d175(e) {
    while($98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$4d3fb11e950abb9e())if ($98c7a0c432789d27$export$c0306caf338ac095 < 33) $98c7a0c432789d27$export$48cfd1e771a65c4f();
    else break;
    return $98c7a0c432789d27$export$9e1725a4cfeada27(e) > 2 || $98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $98c7a0c432789d27$export$5f8c09e3ae6f64e1(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095)){
        case 0:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$c0306caf338ac095), e);
            break;
        default:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$c0306caf338ac095), e);
    }
    return e;
}
function $98c7a0c432789d27$export$955ba06d119e085e(e, r) {
    while(--r && $98c7a0c432789d27$export$48cfd1e771a65c4f())if ($98c7a0c432789d27$export$c0306caf338ac095 < 48 || $98c7a0c432789d27$export$c0306caf338ac095 > 102 || $98c7a0c432789d27$export$c0306caf338ac095 > 57 && $98c7a0c432789d27$export$c0306caf338ac095 < 65 || $98c7a0c432789d27$export$c0306caf338ac095 > 70 && $98c7a0c432789d27$export$c0306caf338ac095 < 97) break;
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$e88cb2efb12ae807() + (r < 6 && $98c7a0c432789d27$export$4d3fb11e950abb9e() == 32 && $98c7a0c432789d27$export$48cfd1e771a65c4f() == 32));
}
function $98c7a0c432789d27$export$c889f2fcc19dbf12(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$c0306caf338ac095){
        case e:
            return $98c7a0c432789d27$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $98c7a0c432789d27$export$c889f2fcc19dbf12($98c7a0c432789d27$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $98c7a0c432789d27$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $98c7a0c432789d27$export$48cfd1e771a65c4f();
            break;
    }
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$4254d4e2b3745c4c(e, r) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 57) break;
    else if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 84 && $98c7a0c432789d27$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $98c7a0c432789d27$export$58adb3bec8346d0f(r, $98c7a0c432789d27$export$5880b8b5730aff45 - 1) + "*" + $98c7a0c432789d27$export$6788812c4e6611e6(e === 47 ? e : $98c7a0c432789d27$export$48cfd1e771a65c4f());
}
function $98c7a0c432789d27$export$c2ab62c7bf24634(e) {
    while(!$98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$4d3fb11e950abb9e()))$98c7a0c432789d27$export$48cfd1e771a65c4f();
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$ef7acd7185315e22(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $98c7a0c432789d27$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $98c7a0c432789d27$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $98c7a0c432789d27$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $98c7a0c432789d27$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($98c7a0c432789d27$export$f8e21b1e77979a08(j += $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $98c7a0c432789d27$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $98c7a0c432789d27$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $98c7a0c432789d27$export$955ba06d119e085e($98c7a0c432789d27$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($98c7a0c432789d27$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$4a34f930e789283c($98c7a0c432789d27$export$4254d4e2b3745c4c($98c7a0c432789d27$export$48cfd1e771a65c4f(), $98c7a0c432789d27$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $98c7a0c432789d27$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $98c7a0c432789d27$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $98c7a0c432789d27$export$36776f635604f274(j) - l) $98c7a0c432789d27$export$10d8903dec122b9d(p > 32 ? $98c7a0c432789d27$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $98c7a0c432789d27$export$f8483753829ec8f3($98c7a0c432789d27$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $98c7a0c432789d27$export$10d8903dec122b9d(y = $98c7a0c432789d27$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $98c7a0c432789d27$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $98c7a0c432789d27$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $98c7a0c432789d27$export$98e6a39c04603d36(e, y, y, n && $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $98c7a0c432789d27$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $98c7a0c432789d27$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $98c7a0c432789d27$export$232faf9add678146() == 125) continue;
            }
            switch(j += $98c7a0c432789d27$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($98c7a0c432789d27$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($98c7a0c432789d27$export$4d3fb11e950abb9e() === 45) j += $98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$48cfd1e771a65c4f());
                    v = $98c7a0c432789d27$export$4d3fb11e950abb9e(), o = l = $98c7a0c432789d27$export$36776f635604f274(g = j += $98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $98c7a0c432789d27$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $98c7a0c432789d27$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $98c7a0c432789d27$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $98c7a0c432789d27$export$2f35ab04d2335697(e, v + 1, v = $98c7a0c432789d27$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $98c7a0c432789d27$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $98c7a0c432789d27$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, s === 0 ? $98c7a0c432789d27$export$aa3a2e812ca8570d : i, f, o, l);
}
function $98c7a0c432789d27$export$4a34f930e789283c(e, r, a) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$a29989082612d0d9, $98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$eba6f6f03b0a92e7()), $98c7a0c432789d27$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $98c7a0c432789d27$export$f8483753829ec8f3(e, r, a, n) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$527d108ccf083c2b, $98c7a0c432789d27$export$2f35ab04d2335697(e, 0, n), $98c7a0c432789d27$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $98c7a0c432789d27$export$82e9f45cca5ba907(n, c, s) {
    switch($98c7a0c432789d27$export$d6af199866bfb566(n, c)){
        case 5103:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $98c7a0c432789d27$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$2c0f367103c8d01c + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-$1$2" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-item-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-line-pack" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-grow", "") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-pack:$3" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-column-align" + $98c7a0c432789d27$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$98c7a0c432789d27$export$f8e21b1e77979a08(s, "span") ? $98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) : +$98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) - +$98c7a0c432789d27$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($98c7a0c432789d27$export$36776f635604f274(n) - 1 - c > 6) switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $98c7a0c432789d27$export$2c0f367103c8d01c + ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n, "stretch") ? $98c7a0c432789d27$export$82e9f45cca5ba907($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 6) === 121) return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, $98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + ($98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $98c7a0c432789d27$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $98c7a0c432789d27$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $98c7a0c432789d27$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $98c7a0c432789d27$export$a763edbf796b780a:
        case $98c7a0c432789d27$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $98c7a0c432789d27$export$a29989082612d0d9:
            return "";
        case $98c7a0c432789d27$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $98c7a0c432789d27$export$36776f635604f274(a = $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $98c7a0c432789d27$export$5a7767152ae0305f(e) {
    var r = $98c7a0c432789d27$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $98c7a0c432789d27$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $98c7a0c432789d27$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $98c7a0c432789d27$export$527d108ccf083c2b:
                n.return = $98c7a0c432789d27$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $98c7a0c432789d27$export$b44a8529a35fcb60:
                return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                    $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                        value: $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $98c7a0c432789d27$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $98c7a0c432789d27$export$aa3a2e812ca8570d:
                if (n.length) return $98c7a0c432789d27$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($98c7a0c432789d27$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $98c7a0c432789d27$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $98c7a0c432789d27$export$76a88f7de6507443(e) {
    switch(e.type){
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $98c7a0c432789d27$export$1be1fc439b849fdf($98c7a0c432789d27$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($98c7a0c432789d27$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $98c7a0c432789d27$export$2f35ab04d2335697(r, 1, $98c7a0c432789d27$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $98c7a0c432789d27$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $98c7a0c432789d27$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $98c7a0c432789d27$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("3u9AZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $289b9de9542c5514$export$2e2bcd8739ae039; });
var $289b9de9542c5514$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("3xeCd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292fca7ef59d5404$export$2e2bcd8739ae039; });
function $292fca7ef59d5404$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("l2e9o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f504c2d9ae5173bf$export$2e2bcd8739ae039; });

var $5n5FB = parcelRequire("5n5FB");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f504c2d9ae5173bf$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5n5FB)))(targetComponent, sourceComponent);
};

});
parcelRegister("5n5FB", function(module, exports) {
'use strict';

var $bSFE1 = parcelRequire("bSFE1");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3e937fab5d08b2fc$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3e937fab5d08b2fc$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3e937fab5d08b2fc$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$TYPE_STATICS = {};
$3e937fab5d08b2fc$var$TYPE_STATICS[$bSFE1.ForwardRef] = $3e937fab5d08b2fc$var$FORWARD_REF_STATICS;
$3e937fab5d08b2fc$var$TYPE_STATICS[$bSFE1.Memo] = $3e937fab5d08b2fc$var$MEMO_STATICS;
function $3e937fab5d08b2fc$var$getStatics(component) {
    // React v16.11 and below
    if ($bSFE1.isMemo(component)) return $3e937fab5d08b2fc$var$MEMO_STATICS;
     // React v16.12 and above
    return $3e937fab5d08b2fc$var$TYPE_STATICS[component['$$typeof']] || $3e937fab5d08b2fc$var$REACT_STATICS;
}
var $3e937fab5d08b2fc$var$defineProperty = Object.defineProperty;
var $3e937fab5d08b2fc$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3e937fab5d08b2fc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3e937fab5d08b2fc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3e937fab5d08b2fc$var$getPrototypeOf = Object.getPrototypeOf;
var $3e937fab5d08b2fc$var$objectPrototype = Object.prototype;
function $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($3e937fab5d08b2fc$var$objectPrototype) {
            var inheritedComponent = $3e937fab5d08b2fc$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3e937fab5d08b2fc$var$objectPrototype) $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3e937fab5d08b2fc$var$getOwnPropertyNames(sourceComponent);
        if ($3e937fab5d08b2fc$var$getOwnPropertySymbols) keys = keys.concat($3e937fab5d08b2fc$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3e937fab5d08b2fc$var$getStatics(targetComponent);
        var sourceStatics = $3e937fab5d08b2fc$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3e937fab5d08b2fc$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3e937fab5d08b2fc$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3e937fab5d08b2fc$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3e937fab5d08b2fc$var$hoistNonReactStatics;

});
parcelRegister("bSFE1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("beWdq"));

});
parcelRegister("beWdq", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $82ee28eaccf33045$export$2b8d127b894957b9; }, function (v) { return $82ee28eaccf33045$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $82ee28eaccf33045$export$cea3a54a6425200c; }, function (v) { return $82ee28eaccf33045$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $82ee28eaccf33045$export$a7c73072b1a182ae; }, function (v) { return $82ee28eaccf33045$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $82ee28eaccf33045$export$9f27bc3417b4524d; }, function (v) { return $82ee28eaccf33045$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $82ee28eaccf33045$export$db77ccec0bb4ccac; }, function (v) { return $82ee28eaccf33045$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $82ee28eaccf33045$export$8392c0c9d3dcbd35; }, function (v) { return $82ee28eaccf33045$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $82ee28eaccf33045$export$ffb0004e005737fa; }, function (v) { return $82ee28eaccf33045$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $82ee28eaccf33045$export$b624eff549462981; }, function (v) { return $82ee28eaccf33045$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $82ee28eaccf33045$export$7897aa7841a5380c; }, function (v) { return $82ee28eaccf33045$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $82ee28eaccf33045$export$602eac185826482c; }, function (v) { return $82ee28eaccf33045$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $82ee28eaccf33045$export$e2c29f18771995cb; }, function (v) { return $82ee28eaccf33045$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $82ee28eaccf33045$export$5f8d39834fd61797; }, function (v) { return $82ee28eaccf33045$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $82ee28eaccf33045$export$74bf444e3cd11ea5; }, function (v) { return $82ee28eaccf33045$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $82ee28eaccf33045$export$92387174baf9b227; }, function (v) { return $82ee28eaccf33045$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $82ee28eaccf33045$export$ec112efeb987d9c6; }, function (v) { return $82ee28eaccf33045$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $82ee28eaccf33045$export$b706b080d889d2c9; }, function (v) { return $82ee28eaccf33045$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $82ee28eaccf33045$export$5be5a87408f70ddc; }, function (v) { return $82ee28eaccf33045$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $82ee28eaccf33045$export$45a5e7f76e0caa8d; }, function (v) { return $82ee28eaccf33045$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $82ee28eaccf33045$export$455c2e768291efa6; }, function (v) { return $82ee28eaccf33045$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $82ee28eaccf33045$export$9522e17588c12572; }, function (v) { return $82ee28eaccf33045$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $82ee28eaccf33045$export$2110ac352bb060b9; }, function (v) { return $82ee28eaccf33045$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $82ee28eaccf33045$export$56885ab8b9c456ab; }, function (v) { return $82ee28eaccf33045$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $82ee28eaccf33045$export$d927fcb6adf8f9de; }, function (v) { return $82ee28eaccf33045$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $82ee28eaccf33045$export$b82d16f27459e05a; }, function (v) { return $82ee28eaccf33045$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $82ee28eaccf33045$export$522c17b4f5e123e8; }, function (v) { return $82ee28eaccf33045$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $82ee28eaccf33045$export$1aabd8a0274ecfd6; }, function (v) { return $82ee28eaccf33045$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $82ee28eaccf33045$export$9b621391a187a31a; }, function (v) { return $82ee28eaccf33045$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $82ee28eaccf33045$export$f5bbd400c2f4426f; }, function (v) { return $82ee28eaccf33045$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82ee28eaccf33045$export$2b8d127b894957b9;
var $82ee28eaccf33045$export$cea3a54a6425200c;
var $82ee28eaccf33045$export$a7c73072b1a182ae;
var $82ee28eaccf33045$export$9f27bc3417b4524d;
var $82ee28eaccf33045$export$db77ccec0bb4ccac;
var $82ee28eaccf33045$export$8392c0c9d3dcbd35;
var $82ee28eaccf33045$export$ffb0004e005737fa;
var $82ee28eaccf33045$export$b624eff549462981;
var $82ee28eaccf33045$export$7897aa7841a5380c;
var $82ee28eaccf33045$export$602eac185826482c;
var $82ee28eaccf33045$export$e2c29f18771995cb;
var $82ee28eaccf33045$export$5f8d39834fd61797;
var $82ee28eaccf33045$export$74bf444e3cd11ea5;
var $82ee28eaccf33045$export$92387174baf9b227;
var $82ee28eaccf33045$export$ec112efeb987d9c6;
var $82ee28eaccf33045$export$b706b080d889d2c9;
var $82ee28eaccf33045$export$5be5a87408f70ddc;
var $82ee28eaccf33045$export$45a5e7f76e0caa8d;
var $82ee28eaccf33045$export$455c2e768291efa6;
var $82ee28eaccf33045$export$9522e17588c12572;
var $82ee28eaccf33045$export$2110ac352bb060b9;
var $82ee28eaccf33045$export$56885ab8b9c456ab;
var $82ee28eaccf33045$export$d927fcb6adf8f9de;
var $82ee28eaccf33045$export$b82d16f27459e05a;
var $82ee28eaccf33045$export$522c17b4f5e123e8;
var $82ee28eaccf33045$export$1aabd8a0274ecfd6;
var $82ee28eaccf33045$export$9b621391a187a31a;
var $82ee28eaccf33045$export$f5bbd400c2f4426f;
'use strict';
var $82ee28eaccf33045$var$b = "function" === typeof Symbol && Symbol.for, $82ee28eaccf33045$var$c = $82ee28eaccf33045$var$b ? Symbol.for("react.element") : 60103, $82ee28eaccf33045$var$d = $82ee28eaccf33045$var$b ? Symbol.for("react.portal") : 60106, $82ee28eaccf33045$var$e = $82ee28eaccf33045$var$b ? Symbol.for("react.fragment") : 60107, $82ee28eaccf33045$var$f = $82ee28eaccf33045$var$b ? Symbol.for("react.strict_mode") : 60108, $82ee28eaccf33045$var$g = $82ee28eaccf33045$var$b ? Symbol.for("react.profiler") : 60114, $82ee28eaccf33045$var$h = $82ee28eaccf33045$var$b ? Symbol.for("react.provider") : 60109, $82ee28eaccf33045$var$k = $82ee28eaccf33045$var$b ? Symbol.for("react.context") : 60110, $82ee28eaccf33045$var$l = $82ee28eaccf33045$var$b ? Symbol.for("react.async_mode") : 60111, $82ee28eaccf33045$var$m = $82ee28eaccf33045$var$b ? Symbol.for("react.concurrent_mode") : 60111, $82ee28eaccf33045$var$n = $82ee28eaccf33045$var$b ? Symbol.for("react.forward_ref") : 60112, $82ee28eaccf33045$var$p = $82ee28eaccf33045$var$b ? Symbol.for("react.suspense") : 60113, $82ee28eaccf33045$var$q = $82ee28eaccf33045$var$b ? Symbol.for("react.suspense_list") : 60120, $82ee28eaccf33045$var$r = $82ee28eaccf33045$var$b ? Symbol.for("react.memo") : 60115, $82ee28eaccf33045$var$t = $82ee28eaccf33045$var$b ? Symbol.for("react.lazy") : 60116, $82ee28eaccf33045$var$v = $82ee28eaccf33045$var$b ? Symbol.for("react.block") : 60121, $82ee28eaccf33045$var$w = $82ee28eaccf33045$var$b ? Symbol.for("react.fundamental") : 60117, $82ee28eaccf33045$var$x = $82ee28eaccf33045$var$b ? Symbol.for("react.responder") : 60118, $82ee28eaccf33045$var$y = $82ee28eaccf33045$var$b ? Symbol.for("react.scope") : 60119;
function $82ee28eaccf33045$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $82ee28eaccf33045$var$c:
                switch(a = a.type, a){
                    case $82ee28eaccf33045$var$l:
                    case $82ee28eaccf33045$var$m:
                    case $82ee28eaccf33045$var$e:
                    case $82ee28eaccf33045$var$g:
                    case $82ee28eaccf33045$var$f:
                    case $82ee28eaccf33045$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82ee28eaccf33045$var$k:
                            case $82ee28eaccf33045$var$n:
                            case $82ee28eaccf33045$var$t:
                            case $82ee28eaccf33045$var$r:
                            case $82ee28eaccf33045$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $82ee28eaccf33045$var$d:
                return u;
        }
    }
}
function $82ee28eaccf33045$var$A(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$m;
}
$82ee28eaccf33045$export$2b8d127b894957b9 = $82ee28eaccf33045$var$l;
$82ee28eaccf33045$export$cea3a54a6425200c = $82ee28eaccf33045$var$m;
$82ee28eaccf33045$export$a7c73072b1a182ae = $82ee28eaccf33045$var$k;
$82ee28eaccf33045$export$9f27bc3417b4524d = $82ee28eaccf33045$var$h;
$82ee28eaccf33045$export$db77ccec0bb4ccac = $82ee28eaccf33045$var$c;
$82ee28eaccf33045$export$8392c0c9d3dcbd35 = $82ee28eaccf33045$var$n;
$82ee28eaccf33045$export$ffb0004e005737fa = $82ee28eaccf33045$var$e;
$82ee28eaccf33045$export$b624eff549462981 = $82ee28eaccf33045$var$t;
$82ee28eaccf33045$export$7897aa7841a5380c = $82ee28eaccf33045$var$r;
$82ee28eaccf33045$export$602eac185826482c = $82ee28eaccf33045$var$d;
$82ee28eaccf33045$export$e2c29f18771995cb = $82ee28eaccf33045$var$g;
$82ee28eaccf33045$export$5f8d39834fd61797 = $82ee28eaccf33045$var$f;
$82ee28eaccf33045$export$74bf444e3cd11ea5 = $82ee28eaccf33045$var$p;
$82ee28eaccf33045$export$92387174baf9b227 = function(a) {
    return $82ee28eaccf33045$var$A(a) || $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$l;
};
$82ee28eaccf33045$export$ec112efeb987d9c6 = $82ee28eaccf33045$var$A;
$82ee28eaccf33045$export$b706b080d889d2c9 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$k;
};
$82ee28eaccf33045$export$5be5a87408f70ddc = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$h;
};
$82ee28eaccf33045$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82ee28eaccf33045$var$c;
};
$82ee28eaccf33045$export$455c2e768291efa6 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$n;
};
$82ee28eaccf33045$export$9522e17588c12572 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$e;
};
$82ee28eaccf33045$export$2110ac352bb060b9 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$t;
};
$82ee28eaccf33045$export$56885ab8b9c456ab = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$r;
};
$82ee28eaccf33045$export$d927fcb6adf8f9de = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$d;
};
$82ee28eaccf33045$export$b82d16f27459e05a = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$g;
};
$82ee28eaccf33045$export$522c17b4f5e123e8 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$f;
};
$82ee28eaccf33045$export$1aabd8a0274ecfd6 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$p;
};
$82ee28eaccf33045$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82ee28eaccf33045$var$e || a === $82ee28eaccf33045$var$m || a === $82ee28eaccf33045$var$g || a === $82ee28eaccf33045$var$f || a === $82ee28eaccf33045$var$p || a === $82ee28eaccf33045$var$q || "object" === typeof a && null !== a && (a.$$typeof === $82ee28eaccf33045$var$t || a.$$typeof === $82ee28eaccf33045$var$r || a.$$typeof === $82ee28eaccf33045$var$h || a.$$typeof === $82ee28eaccf33045$var$k || a.$$typeof === $82ee28eaccf33045$var$n || a.$$typeof === $82ee28eaccf33045$var$w || a.$$typeof === $82ee28eaccf33045$var$x || a.$$typeof === $82ee28eaccf33045$var$y || a.$$typeof === $82ee28eaccf33045$var$v);
};
$82ee28eaccf33045$export$f5bbd400c2f4426f = $82ee28eaccf33045$var$z;

});




parcelRegister("T7vh0", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $0a5af5308930f98f$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $0a5af5308930f98f$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $0a5af5308930f98f$export$6f077d94b33a01aa; });
var $0a5af5308930f98f$var$isBrowser = typeof document !== 'undefined';
function $0a5af5308930f98f$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $0a5af5308930f98f$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $0a5af5308930f98f$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $0a5af5308930f98f$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $0a5af5308930f98f$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$0a5af5308930f98f$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$0a5af5308930f98f$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("6ol0g", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $4a7546cd746450aa$export$6321afa313b251b5; });

var $lQ91k = parcelRequire("lQ91k");

var $iHmjH = parcelRequire("iHmjH");

var $3xeCd = parcelRequire("3xeCd");
var $4a7546cd746450aa$var$isDevelopment = false;
var $4a7546cd746450aa$var$hyphenateRegex = /[A-Z]|^ms/g;
var $4a7546cd746450aa$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $4a7546cd746450aa$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $4a7546cd746450aa$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $4a7546cd746450aa$var$processStyleName = /* #__PURE__ */ (0, $3xeCd.default)(function(styleName) {
    return $4a7546cd746450aa$var$isCustomProperty(styleName) ? styleName : styleName.replace($4a7546cd746450aa$var$hyphenateRegex, '-$&').toLowerCase();
});
var $4a7546cd746450aa$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($4a7546cd746450aa$var$animationRegex, function(match, p1, p2) {
                $4a7546cd746450aa$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $4a7546cd746450aa$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iHmjH.default)[key] !== 1 && !$4a7546cd746450aa$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $4a7546cd746450aa$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $4a7546cd746450aa$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $4a7546cd746450aa$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $4a7546cd746450aa$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $4a7546cd746450aa$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $4a7546cd746450aa$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $4a7546cd746450aa$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $4a7546cd746450aa$var$cursor;
                var result = interpolation(mergedProps);
                $4a7546cd746450aa$var$cursor = previousCursor;
                return $4a7546cd746450aa$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $4a7546cd746450aa$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $4a7546cd746450aa$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($4a7546cd746450aa$var$isProcessableValue(asString)) string += $4a7546cd746450aa$var$processStyleName(key) + ":" + $4a7546cd746450aa$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $4a7546cd746450aa$var$isDevelopment) throw new Error($4a7546cd746450aa$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($4a7546cd746450aa$var$isProcessableValue(value[_i])) string += $4a7546cd746450aa$var$processStyleName(key) + ":" + $4a7546cd746450aa$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $4a7546cd746450aa$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $4a7546cd746450aa$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $4a7546cd746450aa$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $4a7546cd746450aa$var$cursor;
function $4a7546cd746450aa$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $4a7546cd746450aa$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $4a7546cd746450aa$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $4a7546cd746450aa$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $4a7546cd746450aa$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $4a7546cd746450aa$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $lQ91k.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $4a7546cd746450aa$var$cursor
    };
}

});
parcelRegister("lQ91k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe6573913f214e4d$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fe6573913f214e4d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("iHmjH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9cd8dcf50c5790f$export$2e2bcd8739ae039; });
var $d9cd8dcf50c5790f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("hC5sW", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $cd2a39ab07ab93b6$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $cd2a39ab07ab93b6$export$811a713a7276cb9d; });

var $exYeM = parcelRequire("exYeM");
var $cd2a39ab07ab93b6$var$isBrowser = typeof document !== 'undefined';
var $cd2a39ab07ab93b6$var$syncFallback = function syncFallback(create) {
    return create();
};
var $cd2a39ab07ab93b6$var$useInsertionEffect = $exYeM.useInsertionEffect ? $exYeM.useInsertionEffect : false;
var $cd2a39ab07ab93b6$export$db21c7ffa21794e7 = !$cd2a39ab07ab93b6$var$isBrowser ? $cd2a39ab07ab93b6$var$syncFallback : $cd2a39ab07ab93b6$var$useInsertionEffect || $cd2a39ab07ab93b6$var$syncFallback;
var $cd2a39ab07ab93b6$export$811a713a7276cb9d = $cd2a39ab07ab93b6$var$useInsertionEffect || $exYeM.useLayoutEffect;

});


parcelRegister("efvJ0", function(module, exports) {
function $a5fb134ebbf9434b$var$_extends() {
    return module.exports = $a5fb134ebbf9434b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a5fb134ebbf9434b$var$_extends.apply(null, arguments);
}
module.exports = $a5fb134ebbf9434b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dFnsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f314e0a22bcbbd4$export$2e2bcd8739ae039; });
function $9f314e0a22bcbbd4$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("9Q6OH", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $729e420fd9c85e8f$export$deee3a793edee05f; });

var $3vWD9 = parcelRequire("3vWD9");
var $cCxCV = parcelRequire("cCxCV");

var $cCxCV = parcelRequire("cCxCV");

var $5UDEU = parcelRequire("5UDEU");
function $729e420fd9c85e8f$var$getCssDimensions(element) {
    const css = (0, $5UDEU.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $5UDEU.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cCxCV.round)(width) !== offsetWidth || (0, $cCxCV.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $729e420fd9c85e8f$var$unwrapElement(element) {
    return !(0, $5UDEU.isElement)(element) ? element.contextElement : element;
}
function $729e420fd9c85e8f$var$getScale(element) {
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    if (!(0, $5UDEU.isHTMLElement)(domElement)) return (0, $cCxCV.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $729e420fd9c85e8f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cCxCV.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cCxCV.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $729e420fd9c85e8f$var$noOffsets = /*#__PURE__*/ (0, $cCxCV.createCoords)(0);
function $729e420fd9c85e8f$var$getVisualOffsets(element) {
    const win = (0, $5UDEU.getWindow)(element);
    if (!(0, $5UDEU.isWebKit)() || !win.visualViewport) return $729e420fd9c85e8f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $729e420fd9c85e8f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $5UDEU.getWindow)(element)) return false;
    return isFixed;
}
function $729e420fd9c85e8f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    let scale = (0, $cCxCV.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $5UDEU.isElement)(offsetParent)) scale = $729e420fd9c85e8f$var$getScale(offsetParent);
        } else scale = $729e420fd9c85e8f$var$getScale(element);
    }
    const visualOffsets = $729e420fd9c85e8f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $729e420fd9c85e8f$var$getVisualOffsets(domElement) : (0, $cCxCV.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $5UDEU.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $5UDEU.isElement)(offsetParent) ? (0, $5UDEU.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $5UDEU.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $729e420fd9c85e8f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $5UDEU.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $5UDEU.getWindow)(currentIFrame);
            currentIFrame = (0, $5UDEU.getFrameElement)(currentWin);
        }
    }
    return (0, $cCxCV.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $729e420fd9c85e8f$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $5UDEU.getNodeScroll)(element).scrollLeft;
    if (!rect) return $729e420fd9c85e8f$var$getBoundingClientRect((0, $5UDEU.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $729e420fd9c85e8f$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $729e420fd9c85e8f$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $5UDEU.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $5UDEU.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cCxCV.createCoords)(1);
    const offsets = (0, $cCxCV.createCoords)(0);
    const isOffsetParentAnElement = (0, $5UDEU.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5UDEU.getNodeName)(offsetParent) !== 'body' || (0, $5UDEU.isOverflowElement)(documentElement)) scroll = (0, $5UDEU.getNodeScroll)(offsetParent);
        if ((0, $5UDEU.isHTMLElement)(offsetParent)) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent);
            scale = $729e420fd9c85e8f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $729e420fd9c85e8f$var$getHTMLOffset(documentElement, scroll, true) : (0, $cCxCV.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $729e420fd9c85e8f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $729e420fd9c85e8f$var$getDocumentRect(element) {
    const html = (0, $5UDEU.getDocumentElement)(element);
    const scroll = (0, $5UDEU.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cCxCV.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cCxCV.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $729e420fd9c85e8f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $5UDEU.getComputedStyle)(body).direction === 'rtl') x += (0, $cCxCV.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getViewportRect(element, strategy) {
    const win = (0, $5UDEU.getWindow)(element);
    const html = (0, $5UDEU.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $5UDEU.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $729e420fd9c85e8f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $5UDEU.isHTMLElement)(element) ? $729e420fd9c85e8f$var$getScale(element) : (0, $cCxCV.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $729e420fd9c85e8f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $729e420fd9c85e8f$var$getDocumentRect((0, $5UDEU.getDocumentElement)(element));
    else if ((0, $5UDEU.isElement)(clippingAncestor)) rect = $729e420fd9c85e8f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $729e420fd9c85e8f$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cCxCV.rectToClientRect)(rect);
}
function $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $5UDEU.getParentNode)(element);
    if (parentNode === stopNode || !(0, $5UDEU.isElement)(parentNode) || (0, $5UDEU.isLastTraversableNode)(parentNode)) return false;
    return (0, $5UDEU.getComputedStyle)(parentNode).position === 'fixed' || $729e420fd9c85e8f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $729e420fd9c85e8f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $5UDEU.getOverflowAncestors)(element, [], false).filter((el)=>(0, $5UDEU.isElement)(el) && (0, $5UDEU.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $5UDEU.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $5UDEU.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $5UDEU.isElement)(currentNode) && !(0, $5UDEU.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $5UDEU.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $5UDEU.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $5UDEU.isOverflowElement)(currentNode) && !currentNodeIsContaining && $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $5UDEU.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $729e420fd9c85e8f$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $5UDEU.isTopLayer)(element) ? [] : $729e420fd9c85e8f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cCxCV.max)(rect.top, accRect.top);
        accRect.right = (0, $cCxCV.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cCxCV.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cCxCV.max)(rect.left, accRect.left);
        return accRect;
    }, $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $729e420fd9c85e8f$var$getDimensions(element) {
    const { width: width, height: height } = $729e420fd9c85e8f$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $5UDEU.isHTMLElement)(offsetParent);
    const documentElement = (0, $5UDEU.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cCxCV.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5UDEU.getNodeName)(offsetParent) !== 'body' || (0, $5UDEU.isOverflowElement)(documentElement)) scroll = (0, $5UDEU.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $729e420fd9c85e8f$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $729e420fd9c85e8f$var$getHTMLOffset(documentElement, scroll) : (0, $cCxCV.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $729e420fd9c85e8f$var$isStaticPositioned(element) {
    return (0, $5UDEU.getComputedStyle)(element).position === 'static';
}
function $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $5UDEU.isHTMLElement)(element) || (0, $5UDEU.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $5UDEU.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $729e420fd9c85e8f$var$getOffsetParent(element, polyfill) {
    const win = (0, $5UDEU.getWindow)(element);
    if ((0, $5UDEU.isTopLayer)(element)) return win;
    if (!(0, $5UDEU.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $5UDEU.getParentNode)(element);
        while(svgOffsetParent && !(0, $5UDEU.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $5UDEU.isElement)(svgOffsetParent) && !$729e420fd9c85e8f$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $5UDEU.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $5UDEU.isTableElement)(offsetParent) && $729e420fd9c85e8f$var$isStaticPositioned(offsetParent))offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $5UDEU.isLastTraversableNode)(offsetParent) && $729e420fd9c85e8f$var$isStaticPositioned(offsetParent) && !(0, $5UDEU.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $5UDEU.getContainingBlock)(element) || win;
}
const $729e420fd9c85e8f$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $729e420fd9c85e8f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $729e420fd9c85e8f$var$isRTL(element) {
    return (0, $5UDEU.getComputedStyle)(element).direction === 'rtl';
}
const $729e420fd9c85e8f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $5UDEU.getDocumentElement,
    getClippingRect: $729e420fd9c85e8f$var$getClippingRect,
    getOffsetParent: $729e420fd9c85e8f$var$getOffsetParent,
    getElementRects: $729e420fd9c85e8f$var$getElementRects,
    getClientRects: $729e420fd9c85e8f$var$getClientRects,
    getDimensions: $729e420fd9c85e8f$var$getDimensions,
    getScale: $729e420fd9c85e8f$var$getScale,
    isElement: $5UDEU.isElement,
    isRTL: $729e420fd9c85e8f$var$isRTL
};
function $729e420fd9c85e8f$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $729e420fd9c85e8f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $5UDEU.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cCxCV.floor)(top);
        const insetRight = (0, $cCxCV.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cCxCV.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cCxCV.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cCxCV.max)(0, (0, $cCxCV.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$729e420fd9c85e8f$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $729e420fd9c85e8f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $729e420fd9c85e8f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $5UDEU.getOverflowAncestors)(referenceEl) : [],
        ...(0, $5UDEU.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $729e420fd9c85e8f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $729e420fd9c85e8f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $729e420fd9c85e8f$var$getBoundingClientRect(reference);
        if (prevRefRect && !$729e420fd9c85e8f$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $729e420fd9c85e8f$export$37b6bde19b108ecc = (0, $3vWD9.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $729e420fd9c85e8f$export$cc800923e997bb8 = (0, $3vWD9.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $729e420fd9c85e8f$export$91fb6ecbd551914 = (0, $3vWD9.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $729e420fd9c85e8f$export$fba63a578e423eb = (0, $3vWD9.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $729e420fd9c85e8f$export$8a83211c878a3f1f = (0, $3vWD9.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $729e420fd9c85e8f$export$346677f925de839c = (0, $3vWD9.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $729e420fd9c85e8f$export$fe8985bb6374093c = (0, $3vWD9.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $729e420fd9c85e8f$export$f2120bbfa5450bd2 = (0, $3vWD9.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $729e420fd9c85e8f$export$18c8ad048e32c7d5 = (0, $3vWD9.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $729e420fd9c85e8f$export$7bf07e38f3dc4b69 = (0, $3vWD9.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $729e420fd9c85e8f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $729e420fd9c85e8f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $3vWD9.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("3vWD9", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $28f1bf2594995773$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $28f1bf2594995773$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $28f1bf2594995773$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $28f1bf2594995773$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $28f1bf2594995773$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $28f1bf2594995773$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $28f1bf2594995773$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $28f1bf2594995773$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $28f1bf2594995773$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $28f1bf2594995773$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $28f1bf2594995773$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("cCxCV")).rectToClientRect; });

var $cCxCV = parcelRequire("cCxCV");
function $28f1bf2594995773$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cCxCV.getSideAxis)(placement);
    const alignmentAxis = (0, $cCxCV.getAlignmentAxis)(placement);
    const alignLength = (0, $cCxCV.getAxisLength)(alignmentAxis);
    const side = (0, $cCxCV.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cCxCV.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $28f1bf2594995773$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $28f1bf2594995773$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cCxCV.evaluate)(options, state);
    const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cCxCV.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cCxCV.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28f1bf2594995773$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cCxCV.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cCxCV.getAlignmentAxis)(placement);
            const length = (0, $cCxCV.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cCxCV.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cCxCV.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cCxCV.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cCxCV.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $28f1bf2594995773$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cCxCV.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cCxCV.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cCxCV.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cCxCV.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cCxCV.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28f1bf2594995773$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cCxCV.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cCxCV.placements) ? $28f1bf2594995773$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cCxCV.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cCxCV.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cCxCV.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cCxCV.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28f1bf2594995773$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cCxCV.getSide)(placement);
            const initialSideAxis = (0, $cCxCV.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cCxCV.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cCxCV.getOppositePlacement)(initialPlacement)
            ] : (0, $cCxCV.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cCxCV.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cCxCV.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cCxCV.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $28f1bf2594995773$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $28f1bf2594995773$var$isAnySideFullyClipped(overflow) {
    return (0, $cCxCV.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28f1bf2594995773$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $28f1bf2594995773$var$getBoundingRect(rects) {
    const minX = (0, $cCxCV.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cCxCV.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cCxCV.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cCxCV.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $28f1bf2594995773$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cCxCV.rectToClientRect)($28f1bf2594995773$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28f1bf2594995773$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cCxCV.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $28f1bf2594995773$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cCxCV.rectToClientRect)($28f1bf2594995773$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cCxCV.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cCxCV.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cCxCV.getSide)(placement) === 'left';
                    const maxRight = (0, $cCxCV.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cCxCV.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $28f1bf2594995773$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cCxCV.getSide)(placement);
    const alignment = (0, $cCxCV.getAlignment)(placement);
    const isVertical = (0, $cCxCV.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cCxCV.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28f1bf2594995773$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $28f1bf2594995773$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28f1bf2594995773$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cCxCV.getSideAxis)((0, $cCxCV.getSide)(placement));
            const mainAxis = (0, $cCxCV.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cCxCV.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cCxCV.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28f1bf2594995773$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cCxCV.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cCxCV.getSideAxis)(placement);
            const mainAxis = (0, $cCxCV.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cCxCV.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cCxCV.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28f1bf2594995773$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cCxCV.getSide)(placement);
            const alignment = (0, $cCxCV.getAlignment)(placement);
            const isYAxis = (0, $cCxCV.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cCxCV.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cCxCV.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cCxCV.max)(overflow.left, 0);
                const xMax = (0, $cCxCV.max)(overflow.right, 0);
                const yMin = (0, $cCxCV.max)(overflow.top, 0);
                const yMax = (0, $cCxCV.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cCxCV.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cCxCV.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cCxCV", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $93031e4206e8e991$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $93031e4206e8e991$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $93031e4206e8e991$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $93031e4206e8e991$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $93031e4206e8e991$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $93031e4206e8e991$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $93031e4206e8e991$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $93031e4206e8e991$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $93031e4206e8e991$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $93031e4206e8e991$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $93031e4206e8e991$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $93031e4206e8e991$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $93031e4206e8e991$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $93031e4206e8e991$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $93031e4206e8e991$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $93031e4206e8e991$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $93031e4206e8e991$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $93031e4206e8e991$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $93031e4206e8e991$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $93031e4206e8e991$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $93031e4206e8e991$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $93031e4206e8e991$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $93031e4206e8e991$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $93031e4206e8e991$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $93031e4206e8e991$export$803cd8101b6c182b = /*#__PURE__*/ $93031e4206e8e991$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[0], side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[1]), []);
const $93031e4206e8e991$export$96ec731ed4dcb222 = Math.min;
const $93031e4206e8e991$export$8960430cfd85939f = Math.max;
const $93031e4206e8e991$export$2077e0241d6afd3c = Math.round;
const $93031e4206e8e991$export$a3fe094919f356fd = Math.floor;
const $93031e4206e8e991$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $93031e4206e8e991$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $93031e4206e8e991$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $93031e4206e8e991$export$7d15b64cf5a3a4c4(start, value, end) {
    return $93031e4206e8e991$export$8960430cfd85939f(start, $93031e4206e8e991$export$96ec731ed4dcb222(value, end));
}
function $93031e4206e8e991$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $93031e4206e8e991$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $93031e4206e8e991$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $93031e4206e8e991$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $93031e4206e8e991$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $93031e4206e8e991$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($93031e4206e8e991$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $93031e4206e8e991$export$2b57e0052a6d6d4c(placement) {
    return $93031e4206e8e991$export$8a000a963141ac32($93031e4206e8e991$export$f28e8f882010718a(placement));
}
function $93031e4206e8e991$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    const alignmentAxis = $93031e4206e8e991$export$2b57e0052a6d6d4c(placement);
    const length = $93031e4206e8e991$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $93031e4206e8e991$export$496432a3699e50b1(placement) {
    const oppositePlacement = $93031e4206e8e991$export$9c5e28bad23365fa(placement);
    return [
        $93031e4206e8e991$export$2b182c584985588b(placement),
        oppositePlacement,
        $93031e4206e8e991$export$2b182c584985588b(oppositePlacement)
    ];
}
function $93031e4206e8e991$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$93031e4206e8e991$var$oppositeAlignmentMap[alignment]);
}
function $93031e4206e8e991$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $93031e4206e8e991$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    let list = $93031e4206e8e991$var$getSideList($93031e4206e8e991$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($93031e4206e8e991$export$2b182c584985588b));
    }
    return list;
}
function $93031e4206e8e991$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$93031e4206e8e991$var$oppositeSideMap[side]);
}
function $93031e4206e8e991$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $93031e4206e8e991$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $93031e4206e8e991$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $93031e4206e8e991$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("5UDEU", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $44e0f21d4eb6a5a0$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $44e0f21d4eb6a5a0$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $44e0f21d4eb6a5a0$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $44e0f21d4eb6a5a0$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $44e0f21d4eb6a5a0$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $44e0f21d4eb6a5a0$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $44e0f21d4eb6a5a0$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $44e0f21d4eb6a5a0$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $44e0f21d4eb6a5a0$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $44e0f21d4eb6a5a0$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $44e0f21d4eb6a5a0$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $44e0f21d4eb6a5a0$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $44e0f21d4eb6a5a0$export$7bf1f8740e3e34af; });
function $44e0f21d4eb6a5a0$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $44e0f21d4eb6a5a0$export$651544f548703224(node) {
    if ($44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $44e0f21d4eb6a5a0$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(value) {
    if (!$44e0f21d4eb6a5a0$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).Node;
}
function $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(value) {
    if (!$44e0f21d4eb6a5a0$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).Element;
}
function $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(value) {
    if (!$44e0f21d4eb6a5a0$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).HTMLElement;
}
function $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(value) {
    if (!$44e0f21d4eb6a5a0$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $44e0f21d4eb6a5a0$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $44e0f21d4eb6a5a0$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $44e0f21d4eb6a5a0$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($44e0f21d4eb6a5a0$export$651544f548703224(element));
}
function $44e0f21d4eb6a5a0$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $44e0f21d4eb6a5a0$export$78551043582a6a98();
    const css = $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(elementOrCss) ? $44e0f21d4eb6a5a0$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $44e0f21d4eb6a5a0$export$940d8225183e1404(element) {
    let currentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(element);
    while($44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(currentNode) && !$44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(currentNode)){
        if ($44e0f21d4eb6a5a0$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($44e0f21d4eb6a5a0$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $44e0f21d4eb6a5a0$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($44e0f21d4eb6a5a0$export$651544f548703224(node));
}
function $44e0f21d4eb6a5a0$export$3735103072e4a80(element) {
    return $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $44e0f21d4eb6a5a0$export$dc8fc79fa2800137(element) {
    if ($44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(node) {
    if ($44e0f21d4eb6a5a0$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $44e0f21d4eb6a5a0$export$e495491855dc5418(node);
    return $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(node) {
    const parentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(node);
    if ($44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(parentNode) && $44e0f21d4eb6a5a0$export$989e911fa9af580a(parentNode)) return parentNode;
    return $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(parentNode);
}
function $44e0f21d4eb6a5a0$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $44e0f21d4eb6a5a0$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $44e0f21d4eb6a5a0$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $44e0f21d4eb6a5a0$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $44e0f21d4eb6a5a0$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $44e0f21d4eb6a5a0$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("rA44O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $052e7f707e915d45$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
var $052e7f707e915d45$export$2e2bcd8739ae039 = (0, $exYeM.useLayoutEffect);

});


parcelRegister("jMw7l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e66b69e563b626e6$export$2e2bcd8739ae039; });
var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("8RfaJ", function(module, exports) {

var $c0F5b = parcelRequire("c0F5b");
function $672f0ace77efd731$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $672f0ace77efd731$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $672f0ace77efd731$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0F5b(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $672f0ace77efd731$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $672f0ace77efd731$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c0F5b", function(module, exports) {

var $sa3Cx = parcelRequire("sa3Cx");
function $8be55a4870f778e6$var$_defineProperty(e, r, t) {
    return (r = $sa3Cx(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $8be55a4870f778e6$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("sa3Cx", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $054a6ad4520a649f$var$_typeof = $5OoXb.default;

var $1wGoe = parcelRequire("1wGoe");
function $054a6ad4520a649f$var$toPropertyKey(t) {
    var i = $1wGoe(t, "string");
    return "symbol" == $054a6ad4520a649f$var$_typeof(i) ? i : i + "";
}
module.exports = $054a6ad4520a649f$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5OoXb", function(module, exports) {
function $43b4fa80efde8fb9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $43b4fa80efde8fb9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $43b4fa80efde8fb9$var$_typeof(o);
}
module.exports = $43b4fa80efde8fb9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1wGoe", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $11c9a95bb7de7697$var$_typeof = $5OoXb.default;
function $11c9a95bb7de7697$var$toPrimitive(t, r) {
    if ("object" != $11c9a95bb7de7697$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $11c9a95bb7de7697$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $11c9a95bb7de7697$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("c2tl2", function(module, exports) {

var $ao67S = parcelRequire("ao67S");

var $dnqwG = parcelRequire("dnqwG");

var $5uoV6 = parcelRequire("5uoV6");

var $3Jt3i = parcelRequire("3Jt3i");
function $8c3c6debc93055b5$var$_slicedToArray(r, e) {
    return $ao67S(r) || $dnqwG(r, e) || $5uoV6(r, e) || $3Jt3i();
}
module.exports = $8c3c6debc93055b5$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ao67S", function(module, exports) {
function $7900e5cd0773b86a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $7900e5cd0773b86a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dnqwG", function(module, exports) {
function $9bd1ffe0afdc524d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $9bd1ffe0afdc524d$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5uoV6", function(module, exports) {

var $8SL2m = parcelRequire("8SL2m");
function $3ff315b4f3abd60e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8SL2m(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8SL2m(r, a) : void 0;
    }
}
module.exports = $3ff315b4f3abd60e$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8SL2m", function(module, exports) {
function $6777da765d68ea35$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $6777da765d68ea35$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3Jt3i", function(module, exports) {
function $2b7c1c357a57c878$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $2b7c1c357a57c878$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("k2o2K", function(module, exports) {

var $gqEFx = parcelRequire("gqEFx");
function $03c3b856d5e3fa53$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $gqEFx(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $03c3b856d5e3fa53$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gqEFx", function(module, exports) {
function $bf5e9f09faf23ac5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $bf5e9f09faf23ac5$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("clMMr", function(module, exports) {
function $8fdd48f05e7c9e18$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $8fdd48f05e7c9e18$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("drNVG", function(module, exports) {

var $sa3Cx = parcelRequire("sa3Cx");
function $9ca486e3f798cd16$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $sa3Cx(o.key), o);
    }
}
function $9ca486e3f798cd16$var$_createClass(e, r, t) {
    return r && $9ca486e3f798cd16$var$_defineProperties(e.prototype, r), t && $9ca486e3f798cd16$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $9ca486e3f798cd16$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kLJEy", function(module, exports) {

var $2yX5r = parcelRequire("2yX5r");
function $f1eb9c2a56c06cb0$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $2yX5r(t, e);
}
module.exports = $f1eb9c2a56c06cb0$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2yX5r", function(module, exports) {
function $1ddc972472ee1694$var$_setPrototypeOf(t, e) {
    return module.exports = $1ddc972472ee1694$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1ddc972472ee1694$var$_setPrototypeOf(t, e);
}
module.exports = $1ddc972472ee1694$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iNe3q", function(module, exports) {

var $7vAxn = parcelRequire("7vAxn");

var $54ZqT = parcelRequire("54ZqT");

var $i3X6a = parcelRequire("i3X6a");
function $dae7b47c7bad0924$var$_createSuper(t) {
    var r = $54ZqT();
    return function() {
        var e, o = $7vAxn(t);
        if (r) {
            var s = $7vAxn(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $i3X6a(this, e);
    };
}
module.exports = $dae7b47c7bad0924$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7vAxn", function(module, exports) {
function $5777c5340528614f$var$_getPrototypeOf(t) {
    return module.exports = $5777c5340528614f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $5777c5340528614f$var$_getPrototypeOf(t);
}
module.exports = $5777c5340528614f$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("54ZqT", function(module, exports) {
function $3b2cfabc86d8a177$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $3b2cfabc86d8a177$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $3b2cfabc86d8a177$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i3X6a", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $d2665983ba6f0935$var$_typeof = $5OoXb.default;

var $9Lt1F = parcelRequire("9Lt1F");
function $d2665983ba6f0935$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $d2665983ba6f0935$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $9Lt1F(t);
}
module.exports = $d2665983ba6f0935$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9Lt1F", function(module, exports) {
function $71bf04cd41e006f0$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $71bf04cd41e006f0$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("54H9R", function(module, exports) {

var $aLubH = parcelRequire("aLubH");

var $kEVCS = parcelRequire("kEVCS");

var $5uoV6 = parcelRequire("5uoV6");

var $4GnAn = parcelRequire("4GnAn");
function $3b1ecdc246dbac7d$var$_toConsumableArray(r) {
    return $aLubH(r) || $kEVCS(r) || $5uoV6(r) || $4GnAn();
}
module.exports = $3b1ecdc246dbac7d$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aLubH", function(module, exports) {

var $8SL2m = parcelRequire("8SL2m");
function $7d65b5cc312324dd$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $8SL2m(r);
}
module.exports = $7d65b5cc312324dd$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kEVCS", function(module, exports) {
function $f0a43e6e79719248$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $f0a43e6e79719248$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4GnAn", function(module, exports) {
function $368d614adef128d5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $368d614adef128d5$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7DH2y", function(module, exports) {
function $58fd8fca77047e4b$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $58fd8fca77047e4b$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bhFhT", function(module, exports) {

$parcel$export(module.exports, "SearchSummonerInput", function () { return $ddfe775ba7c99ce2$export$601b49857336bd70; });

var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $kaLCO = parcelRequire("kaLCO");

var $appXD = parcelRequire("appXD");

var $gkOpi = parcelRequire("gkOpi");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");
const $ddfe775ba7c99ce2$export$601b49857336bd70 = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ summoner: summoner, setSummoner: setSummoner, handleFocus: handleFocus }, ref)=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const handleChange = (0, $exYeM.useCallback)((e)=>setSummoner((0, $kj6DU.pipe)((0, $appXD.RiotId).fromStringDecoder.decode(e.target.value), (0, $9ddGv.Either).mapLeft(()=>e.target.value))), [
        setSummoner
    ]);
    const summonerRaw = (0, $kj6DU.pipe)(summoner, (0, $9ddGv.Either).fold((0, $kj6DU.identity), (0, $appXD.RiotId).stringify));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        ref: ref,
        className: "grid min-w-50 items-center area-1",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "w-full px-2 area-1",
                children: (0, $kj6DU.pipe)(summoner, (0, $9ddGv.Either).fold((name)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        children: name
                    }), ({ gameName: gameName, tagLine: tagLine })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "text-goldenrod",
                                children: (0, $kaLCO.GameName).unwrap(gameName)
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: "text-grey-500",
                                children: [
                                    "#",
                                    (0, $gkOpi.TagLine).unwrap(tagLine)
                                ]
                            })
                        ]
                    })))
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                type: "text",
                value: summonerRaw,
                onChange: handleChange,
                onFocus: handleFocus,
                placeholder: t.layout.searchSummoner,
                className: (0, $5MBh5.cx)('w-0 min-w-full bg-transparent px-2 text-wheat/0 caret-wheat area-1', {
                    'font-normal': summonerRaw === ''
                })
            })
        ]
    });
});

});

parcelRegister("h9A4m", function(module, exports) {

$parcel$export(module.exports, "SummonerSearch", function () { return $a20a32bf778055c4$export$69be8bc94117727d; });
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $5fNnZ = parcelRequire("5fNnZ");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $kaLCO = parcelRequire("kaLCO");

var $appXD = parcelRequire("appXD");

var $hFHAv = parcelRequire("hFHAv");

var $gkOpi = parcelRequire("gkOpi");

var $9ddGv = parcelRequire("9ddGv");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");

var $lFNyc = parcelRequire("lFNyc");

var $dR62Q = parcelRequire("dR62Q");

var $2SjoC = parcelRequire("2SjoC");

var $iz2wS = parcelRequire("iz2wS");

var $5MBh5 = parcelRequire("5MBh5");

var $lQ3eP = parcelRequire("lQ3eP");

var $avpuJ = parcelRequire("avpuJ");

var $8Wmxp = parcelRequire("8Wmxp");
const $a20a32bf778055c4$export$69be8bc94117727d = ({ type: type, summoner: summoner })=>{
    const { navigate: navigate, masteriesQuery: masteriesQuery } = (0, $2Yib7.useHistory)();
    const { maybeUser: maybeUser, addFavoriteSearch: addFavoriteSearch, removeFavoriteSearch: removeFavoriteSearch, removeRecentSearch: removeRecentSearch } = (0, $dCazK.useUser)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const staticData = (0, $fcoXO.useStaticData)();
    const summonerMatch = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).platformRiotId);
    const summonerGameMatch = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).platformRiotIdGame);
    // with current masteriesQuery
    const puuidRoute = (0, $exYeM.useCallback)((platform, puuid)=>(summonerGameMatch !== undefined ? (0, $iz2wS.appRoutes).sPlatformPuuidGame : (0, $iz2wS.appRoutes).sPlatformPuuid)(platform, puuid, summonerMatch !== undefined ? (0, $2SjoC.MasteriesQuery).toPartial({
            ...masteriesQuery,
            search: (0, $9ddGv.Maybe).none
        }) : {}), [
        masteriesQuery,
        summonerGameMatch,
        summonerMatch
    ]);
    const removeRecent = (0, $exYeM.useCallback)((e)=>{
        e.stopPropagation();
        removeRecentSearch(summoner.puuid);
    }, [
        removeRecentSearch,
        summoner
    ]);
    const [favoriteIsLoading, setFavoriteIsLoading] = (0, $exYeM.useState)(false);
    const addFavorite = (0, $exYeM.useCallback)((e)=>{
        e.stopPropagation();
        if ((0, $9ddGv.Maybe).isNone(summoner.riotId)) return navigateToSummoner();
        setFavoriteIsLoading(true);
        return (0, $kj6DU.pipe)(addFavoriteSearch({
            ...summoner,
            riotId: summoner.riotId.value
        }), // on not found
        (0, $9ddGv.Future).map((0, $9ddGv.Maybe).getOrElseW(()=>navigateToSummoner())), (0, $5fNnZ).chainFirstIOK(()=>()=>setFavoriteIsLoading(false)), (0, $lQ3eP.futureRunUnsafe));
        function navigateToSummoner() {
            return navigate(puuidRoute(summoner.platform, summoner.puuid));
        }
    }, [
        addFavoriteSearch,
        navigate,
        puuidRoute,
        summoner
    ]);
    const removeFavorite = (0, $exYeM.useCallback)((e)=>{
        e.stopPropagation();
        setFavoriteIsLoading(true);
        return (0, $kj6DU.pipe)(removeFavoriteSearch(summoner.puuid), (0, $5fNnZ).chainFirstIOK(()=>()=>setFavoriteIsLoading(false)), (0, $lQ3eP.futureRunUnsafe));
    }, [
        removeFavoriteSearch,
        summoner
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
        className: "contents",
        children: [
            $a20a32bf778055c4$var$renderRecent(type, removeRecent),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $avpuJ.Link), {
                to: puuidRoute(summoner.platform, summoner.puuid),
                className: "group flex items-center leading-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: staticData.assets.summonerIcon(summoner.profileIconId),
                        alt: t.summonerIconAlt((0, $kj6DU.pipe)(summoner.riotId, (0, $9ddGv.Maybe).map((0, $appXD.RiotId).stringify), (0, $9ddGv.Maybe).alt(()=>(0, $kj6DU.pipe)(summoner.name, (0, $9ddGv.Maybe).map((0, $hFHAv.SummonerName).unwrap))), (0, $9ddGv.Maybe).getOrElse(()=>`<Summoner ${summoner.puuid}>`))),
                        className: "w-12"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "ml-2 flex grow items-baseline gap-0.5",
                        children: (0, $kj6DU.pipe)(summoner.riotId, (0, $9ddGv.Maybe).map((riotId)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: (0, $5MBh5.cx)($a20a32bf778055c4$var$linkClassName, 'text-goldenrod'),
                                        children: (0, $kaLCO.GameName).unwrap(riotId.gameName)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "font-normal text-grey-500",
                                        children: [
                                            "#",
                                            (0, $gkOpi.TagLine).unwrap(riotId.tagLine)
                                        ]
                                    })
                                ]
                            })), (0, $9ddGv.Maybe).alt(()=>(0, $kj6DU.pipe)(summoner.name, (0, $9ddGv.Maybe).map((name)=>// eslint-disable-next-line react/jsx-key
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: $a20a32bf778055c4$var$linkClassName,
                                    children: (0, $hFHAv.SummonerName).unwrap(name)
                                })))), (0, $9ddGv.Maybe).toNullable)
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: (0, $5MBh5.cx)($a20a32bf778055c4$var$linkClassName, 'ml-4 font-normal'),
                        children: summoner.platform
                    })
                ]
            }),
            (0, $9ddGv.Maybe).isSome(maybeUser) ? $a20a32bf778055c4$var$renderFavorite(type, favoriteIsLoading, addFavorite, removeFavorite) : null
        ]
    });
};
const $a20a32bf778055c4$var$linkClassName = 'border-y border-y-transparent group-hover:border-b-current';
function $a20a32bf778055c4$var$renderRecent(type, removeRecent) {
    switch(type){
        case 'self':
            return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "w-3"
            });
        case 'favorite':
            return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "w-3"
            });
        case 'recent':
            return /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                type: "button",
                onClick: removeRecent,
                className: "group p-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.TimeOutline), {
                        className: "h-4 text-goldenrod group-hover:hidden"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CloseFilled), {
                        className: "hidden h-4 text-red group-hover:flex"
                    })
                ]
            });
    }
}
function $a20a32bf778055c4$var$renderFavorite(type, isLoading, addFavorite, removeFavorite) {
    switch(type){
        case 'self':
            return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "px-3",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.PersonFilled), {
                    className: "h-4"
                })
            });
        case 'favorite':
            return /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                type: "button",
                onClick: removeFavorite,
                disabled: isLoading,
                className: "px-3 pb-3 pt-2 text-goldenrod enabled:hover:text-red",
                children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                    className: "h-5"
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.StarFilled), {
                    className: "h-5"
                })
            });
        case 'recent':
            return /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                type: "button",
                onClick: addFavorite,
                disabled: isLoading,
                className: "px-3 pb-3 pt-2 text-goldenrod enabled:hover:text-wheat",
                children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                    className: "h-5"
                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.StarOutline), {
                    className: "h-5"
                })
            });
    }
}

});



parcelRegister("eFmB1", function(module, exports) {

$parcel$export(module.exports, "getRouterComponent", function () { return $1d3011fc487c0547$export$19e2bdbb5ff92a3d; });
$parcel$export(module.exports, "e", function () { return $1d3011fc487c0547$export$f1e1789686576879; });
/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $idTJH = parcelRequire("idTJH");
var $2MDjk = parcelRequire("2MDjk");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $2Yib7 = parcelRequire("2Yib7");

var $hZroh = parcelRequire("hZroh");

var $5Aeax = parcelRequire("5Aeax");
function $1d3011fc487c0547$export$19e2bdbb5ff92a3d(parser) {
    return function RouterComponent() {
        const { t: t } = (0, $hZroh.useTranslation)('router');
        const { location: location } = (0, $2Yib7.useHistory)();
        const [node, title] = (0, $exYeM.useMemo)(()=>{
            const [node_, subTitle] = (0, $idTJH.parse)(parser, (0, $2MDjk.Route).parse(location.pathname), $1d3011fc487c0547$export$f1e1789686576879(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $5Aeax.NotFound), {}), (t_)=>t_.notFound));
            const title_ = (0, $kj6DU.pipe)([
                (0, $kj6DU.pipe)(subTitle, (0, $9ddGv.Maybe).map((s)=>s(t))),
                (0, $9ddGv.Maybe).some(t.theQuest)
            ], (0, $9ddGv.List).compact, (0, $9ddGv.List).mkString(' | '));
            return [
                node_,
                title_
            ];
        }, [
            location.pathname,
            t
        ]);
        (0, $exYeM.useEffect)(()=>{
            // eslint-disable-next-line functional/immutable-data
            document.title = title;
        }, [
            title
        ]);
        return node;
    };
}
function $1d3011fc487c0547$export$f1e1789686576879(element, title) {
    return (0, $9ddGv.Tuple).of(element, (0, $9ddGv.Maybe).fromNullable(title));
}

});
parcelRegister("5Aeax", function(module, exports) {

$parcel$export(module.exports, "NotFound", function () { return $df621614ec84d8fd$export$271f9f08425019c7; });

var $aSiaI = parcelRequire("aSiaI");

var $avpuJ = parcelRequire("avpuJ");

var $hZroh = parcelRequire("hZroh");

var $iz2wS = parcelRequire("iz2wS");
const $df621614ec84d8fd$export$271f9f08425019c7 = ()=>{
    const { t: t } = (0, $hZroh.useTranslation)('notFound');
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col items-center gap-4 p-6",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "text-xl",
                children: t.thisPageDoesntExist
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                to: (0, $iz2wS.appRoutes).index,
                className: "font-medium underline",
                children: t.home
            })
        ]
    });
};

});


parcelRegister("hn8KH", function(module, exports) {


module.exports = (parcelRequire("4WKyX"))((parcelRequire("iE7OH")).resolve("FCVDl")).then(()=>parcelRequire('3n8lN'));

});

var $3e56e77ed09bb63e$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL('fLaAm'), JSON.parse("[\"fLaAm\",\"index.132483b3.js\",\"7dwKU\",\"enGB.0720bf4a.js\",\"3Z31E\",\"frFR.395a3d22.js\",\"75YUb\",\"bandle.c006a2a6.webp\",\"2iknp\",\"bilgewater.58d00087.webp\",\"9EoIJ\",\"demacia.e4daa11c.webp\",\"3SrkJ\",\"freljord.744001bf.webp\",\"1JTp9\",\"ionia.6aea9ace.webp\",\"eNJzs\",\"ixtal.86197ae2.webp\",\"aVZTp\",\"noxus.954ce344.webp\",\"528Es\",\"piltover.011e21bc.webp\",\"3HBia\",\"shadowIsles.25801c44.webp\",\"cxtgc\",\"shurima.3cd980ed.webp\",\"ky2Fm\",\"targon.23d59733.webp\",\"cDrgD\",\"void.43168c65.webp\",\"Ppw0f\",\"zaun.e8da4a2f.webp\",\"d3fwM\",\"mastery-0.8fed1ae0.png\",\"d2R0C\",\"mastery-1.21920b27.png\",\"6115H\",\"mastery-2.a4fc1478.png\",\"5JaO4\",\"mastery-3.1cbe45a6.png\",\"hYbIF\",\"mastery-4.0c0f346b.png\",\"2ZO3m\",\"mastery-5.cfc9ee95.png\",\"9J3aY\",\"mastery-6.2b6317f1.png\",\"i1zP2\",\"mastery-7.d4edf5f3.png\",\"l6e4A\",\"mastery-8.ac344fe0.png\",\"1JBRN\",\"mastery-9.8f1c8b65.png\",\"6SEth\",\"mastery-10.de3bd6c9.png\",\"fplGW\",\"damage_amp.cb2ff0cf.webp\",\"75SFI\",\"armor_penetration.66104771.webp\",\"aZzAg\",\"heal_power.c8b3d796.webp\",\"sJpHc\",\"shield_power.437195fc.webp\",\"iQ9Qt\",\"ability_haste.8fbe6db0.webp\",\"iDFFm\",\"energy_regen.f768e637.webp\",\"1s4QZ\",\"attack_speed.81e8ef98.webp\",\"iEMcf\",\"movement_speed.bdd9f2d2.webp\",\"984mh\",\"tenacity.d3b34d47.webp\",\"2BFAO\",\"champion.3213ca9c.webp\",\"14tvf\",\"globetrotter.8936141a.png\",\"f0axb\",\"runeterra.83ef5934.png\",\"fvAMp\",\"spatula.4655b2c1.png\",\"gJ04c\",\"dpm-lol.d7c4d9eb.png\",\"a1Mmy\",\"league-of-graphs.143b9e5d.png\",\"1nVeb\",\"op-gg.3c7751c0.png\",\"0RUdW\",\"porofessor.06889782.png\",\"e6oJx\",\"year-in-lol.1d22245c.png\",\"jGV6X\",\"yuumi-home.2e417a16.png\",\"FCVDl\",\"AdminRouterComponent.f2553a75.js\",\"fsFbm\",\"index.2b9fc7f8.css\"]"));


var $aSiaI = parcelRequire("aSiaI");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
'use strict';

var $d2lNW = parcelRequire("d2lNW");
var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $d2lNW.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $d2lNW.hydrateRoot;



var $aSiaI = parcelRequire("aSiaI");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $bN7FL = parcelRequire("bN7FL");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");

var $aSiaI = parcelRequire("aSiaI");

var $9fMqj = parcelRequire("9fMqj");
var $idTJH = parcelRequire("idTJH");

var $exYeM = parcelRequire("exYeM");

var $appXD = parcelRequire("appXD");

var $hrnY6 = parcelRequire("hrnY6");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $8Wmxp = parcelRequire("8Wmxp");
const $a661241677b7896c$export$ac1a3f0c836eba03 = ({ children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $exYeM.Suspense), {
        fallback: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                className: "mt-4 h-6"
            })
        }),
        children: children
    });



var $5N26n = parcelRequire("5N26n");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $OFl2v = parcelRequire("OFl2v");var $793be4c33bc284e1$exports = {};

$parcel$export($793be4c33bc284e1$exports, "random", function () { return $793be4c33bc284e1$export$4385e60b38654f68; });
$parcel$export($793be4c33bc284e1$exports, "randomInt", function () { return $793be4c33bc284e1$export$3c5f89dae98e900b; });
$parcel$export($793be4c33bc284e1$exports, "randomRange", function () { return $793be4c33bc284e1$export$5c61011b8a176cb5; });
$parcel$export($793be4c33bc284e1$exports, "randomBool", function () { return $793be4c33bc284e1$export$b3b584c8d6ffe165; });
$parcel$export($793be4c33bc284e1$exports, "randomElem", function () { return $793be4c33bc284e1$export$3626835d6c2414ab; });
/**
 * @since 2.0.0
 */ 
var $kj6DU = parcelRequire("kj6DU");

var $OFl2v = parcelRequire("OFl2v");
var $793be4c33bc284e1$export$4385e60b38654f68 = function() {
    return Math.random();
};
function $793be4c33bc284e1$export$3c5f89dae98e900b(low, high) {
    return (0, $kj6DU.pipe)($793be4c33bc284e1$export$4385e60b38654f68, (0, $OFl2v.map)(function(n) {
        return Math.floor((high - low + 1) * n + low);
    }));
}
function $793be4c33bc284e1$export$5c61011b8a176cb5(min, max) {
    return (0, $kj6DU.pipe)($793be4c33bc284e1$export$4385e60b38654f68, (0, $OFl2v.map)(function(n) {
        return (max - min) * n + min;
    }));
}
var $793be4c33bc284e1$export$b3b584c8d6ffe165 = /*#__PURE__*/ (0, $kj6DU.pipe)($793be4c33bc284e1$export$4385e60b38654f68, (0, $OFl2v.map)(function(n) {
    return n < 0.5;
}));
var $793be4c33bc284e1$export$3626835d6c2414ab = function(as) {
    return (0, $kj6DU.pipe)($793be4c33bc284e1$export$3c5f89dae98e900b(0, as.length - 1), (0, $OFl2v.map)(function(i) {
        return as[i];
    }));
};



var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $632HS = parcelRequire("632HS");

var $f96Tp = parcelRequire("f96Tp");

var $javAY = parcelRequire("javAY");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $hZroh = parcelRequire("hZroh");

var $dR62Q = parcelRequire("dR62Q");

var $5MBh5 = parcelRequire("5MBh5");

var $1sXco = parcelRequire("1sXco");
const $c0ec2c134c6dc113$export$13c8a39fad75a36b = ({ category: category, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('mapChanges');
    const hoverRef = (0, $exYeM.useRef)(null);
    const placementRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $5MBh5.cx)('col-span-full flex pb-1', className),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
            ref: hoverRef,
            className: "flex items-center gap-2 font-semibold",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    children: t.category.label[category]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    ref: placementRef,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.InformationCircleOutline), {
                        className: "h-4"
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                    hoverRef: hoverRef,
                    placementRef: placementRef,
                    className: "max-w-xl !whitespace-normal break-normal py-2",
                    children: t.category.description[category]
                })
            ]
        })
    });
};


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $OFl2v = parcelRequire("OFl2v");
var $lSBre = parcelRequire("lSBre");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $dR62Q = parcelRequire("dR62Q");

var $5MBh5 = parcelRequire("5MBh5");

var $1sXco = parcelRequire("1sXco");
const $859fbc684bacb002$export$bb60b672622fdba0 = ({ searchCount: searchCount, randomChampion: randomChampion, initialSearch: initialSearch, onChange: onChange, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const searchRef = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        const onKeyup = (e)=>{
            if ((e.key.toLowerCase() === 'f' && (e.ctrlKey || e.metaKey) || e.key === '/' || e.key === 'F3') && searchRef.current !== null) {
                e.preventDefault();
                searchRef.current.select();
            }
        };
        document.addEventListener('keydown', onKeyup, true);
        return ()=>document.removeEventListener('keydown', onKeyup, true);
    }, []);
    const [search, setSearch] = (0, $exYeM.useState)((0, $kj6DU.pipe)(initialSearch, (0, $9ddGv.Maybe).getOrElse(()=>'')));
    const emptySearch = (0, $exYeM.useCallback)(()=>{
        setSearch('');
        searchRef.current?.focus();
    }, []);
    const handleKeyDown = (0, $exYeM.useCallback)((e)=>{
        if (e.key === 'Escape') {
            setSearch('');
            searchRef.current?.blur();
        }
    }, []);
    const updateSearch = (0, $exYeM.useMemo)(()=>(0, $kj6DU.flow)((0, $gSyeU).trim, (0, $9ddGv.Maybe).fromPredicate((0, $lSBre).not((0, $gSyeU).isEmpty)), onChange), [
        onChange
    ]);
    (0, $exYeM.useEffect)(()=>{
        updateSearch(search);
    }, [
        updateSearch,
        search
    ]);
    const handleSearchChange = (0, $exYeM.useCallback)((e)=>setSearch(e.target.value), []);
    const onFocus = (0, $exYeM.useCallback)((e)=>e.target.select(), []);
    const handleRandomClick = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(randomChampion, (0, $9ddGv.Maybe).map((0, $OFl2v).map(setSearch)), (0, $9ddGv.Maybe).toUndefined), [
        randomChampion
    ]);
    const randomButtonRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: (0, $5MBh5.cx)('flex flex-wrap items-center gap-3', className),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative flex flex-col items-center text-xs",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid items-center",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                ref: searchRef,
                                type: "text",
                                value: search,
                                onChange: handleSearchChange,
                                onKeyDown: handleKeyDown,
                                onFocus: onFocus,
                                placeholder: t.searchChamion,
                                className: (0, $5MBh5.cx)('w-32.5 justify-self-start rounded-sm border border-grey-disabled bg-transparent py-0.5 pl-2 area-1', search === '' ? 'pr-2' : 'pr-7')
                            }),
                            search !== '' ? /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                type: "button",
                                onClick: emptySearch,
                                className: "mr-1 justify-self-end area-1",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CloseFilled), {
                                    className: "h-5 text-wheat"
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: (0, $5MBh5.cx)('absolute top-full pt-0.5 text-zinc-400', {
                            hidden: (0, $9ddGv.Maybe).isNone(initialSearch)
                        }),
                        children: t.nResults(searchCount)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                ref: randomButtonRef,
                type: "button",
                onClick: handleRandomClick,
                disabled: (0, $9ddGv.Maybe).isNone(randomChampion),
                className: "group -mx-0.5 overflow-hidden p-0.5 disabled:opacity-30",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.DiceFilled), {
                    className: "h-7 transition-transform duration-300 group-enabled:group-hover:animate-dice"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: randomButtonRef,
                placement: "top",
                children: t.randomChampion
            })
        ]
    });
};



var $lMH1q = parcelRequire("lMH1q");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $gpfu2 = parcelRequire("gpfu2");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7znXl = parcelRequire("7znXl");

var $k6yCu = parcelRequire("k6yCu");

var $3a4Bg = parcelRequire("3a4Bg");

var $9ddGv = parcelRequire("9ddGv");
const $33db2523ab42fb92$var$e = (0, $3a4Bg.createEnum)('buffed', 'nerfed', 'other', 'balanced');
const $33db2523ab42fb92$var$fromData = (data)=>(0, $kj6DU.pipe)(data.stats, (0, $9ddGv.Maybe).map((stats)=>{
        const normalized = $33db2523ab42fb92$var$normalizeStats(stats);
        return normalized < 0 ? 'nerfed' : 0 < normalized ? 'buffed' : 'other';
    }), (0, $9ddGv.Maybe).getOrElse(()=>(0, $kj6DU.pipe)(data.skills, (0, $9ddGv.Maybe).fold(()=>'balanced', ()=>'other'))));
const $33db2523ab42fb92$var$normalizeStats = (stats)=>(0, $kj6DU.pipe)(stats, (0, $k6yCu.DictUtils).partial.entries, (0, $9ddGv.List).map(([key, val])=>{
        if (val === undefined || val === 0) return 0;
        return (((0, $7znXl.WikiStatsBalance).isModifierStat(key) ? val - 1 : val) < 0 ? -1 : 1) * ((0, $7znXl.WikiStatsBalance).isMalusStat(key) ? -1 : 1);
    }), (0, $gpfu2).concatAll((0, $cF6yJ).MonoidSum));
const $33db2523ab42fb92$export$dc50577efab52c43 = {
    values: $33db2523ab42fb92$var$e.values,
    fromData: $33db2523ab42fb92$var$fromData,
    Eq: $33db2523ab42fb92$var$e.Eq
};



var $4IdVv = parcelRequire("4IdVv");

var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $aSiaI = parcelRequire("aSiaI");

var $5MBh5 = parcelRequire("5MBh5");
const $a85e2b07dac54e12$var$masteryBgColorClassName = {
    10: 'text-[#fdf2fc]',
    9: 'text-[#d2651b]',
    8: 'text-[#8d12c9]',
    7: 'text-[#0369a1]',
    6: 'text-[#329055]',
    5: 'text-[#94a3b8]',
    4: 'text-[#71717a]',
    3: 'text-[#71717a]',
    2: 'text-[#71717a]',
    1: 'text-[#71717a]'
};
const $a85e2b07dac54e12$export$641527e078380b15 = /*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "size-0",
    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("defs", {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("linearGradient", {
                id: $a85e2b07dac54e12$export$b06b879d73ad6baf(10),
                x1: "1",
                y1: "0",
                x2: "0",
                y2: "0",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                        offset: "30%",
                        stopColor: "#f3eafb"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                        offset: "55%",
                        stopColor: "#fffad8"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                        offset: "80%",
                        stopColor: "#c8fdfc"
                    })
                ]
            }),
            $a85e2b07dac54e12$var$gradient(9, '#d2651b', '#8e3d25'),
            $a85e2b07dac54e12$var$gradient(8, '#8d12c9', '#560292'),
            $a85e2b07dac54e12$var$gradient(7, '#0369a1', '#324bd0'),
            $a85e2b07dac54e12$var$gradient(6, '#329055', '#266846'),
            $a85e2b07dac54e12$var$gradient(5, '#94a3b8', '#475569'),
            $a85e2b07dac54e12$var$gradient(4, '#71717a', '#52525b'),
            $a85e2b07dac54e12$var$gradient(3, '#71717a', '#52525b'),
            $a85e2b07dac54e12$var$gradient(2, '#71717a', '#52525b'),
            $a85e2b07dac54e12$var$gradient(1, '#71717a', '#52525b')
        ]
    })
});
function $a85e2b07dac54e12$var$gradient(level, from, to) {
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("linearGradient", {
        id: $a85e2b07dac54e12$export$b06b879d73ad6baf(level),
        x1: "1",
        y1: "0",
        x2: "0",
        y2: "0",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                offset: "0%",
                stopColor: from
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                offset: "100%",
                stopColor: to
            })
        ]
    });
}
// Update in sync with `masterySquareBorderGradientDefs` above.
// Define some `text-...` for `<ChampionTooltip />` better contrast (default: black)
const $a85e2b07dac54e12$var$masteryHistogramGradientClassName = {
    10: 'from-[#f3eafb] via-[#fffad8] to-[#c8fdfc] text-black',
    9: 'from-[#d2651b] to-[#8e3d25] text-shadow',
    8: 'from-[#8d12c9] to-[#560292] text-shadow',
    7: 'from-[#0369a1] to-[#324bd0] text-shadow',
    6: 'from-[#329055] to-[#266846] text-shadow',
    5: 'from-[#94a3b8] to-[#475569] text-shadow',
    4: 'from-[#71717a] to-[#52525b] text-shadow',
    3: 'from-[#71717a] to-[#52525b] text-shadow',
    2: 'from-[#71717a] to-[#52525b] text-shadow',
    1: 'from-[#71717a] to-[#52525b] text-shadow'
};
// Need iife for Tailwind extension to work ✨
const $a85e2b07dac54e12$var$masteryTextColorClassName = (()=>{
    const className = {
        10: 'text-[#f3eafb]',
        9: 'text-[#f6a738]',
        8: 'text-[#e752fb]',
        7: 'text-[#3b82f6]',
        6: 'text-[#22c55e]',
        5: 'text-[#cbd5e1]'
    };
    return className;
})();
const $a85e2b07dac54e12$var$masteryTextColorDefaultClassName = 'text-[#d4d4d4]';
const $a85e2b07dac54e12$var$masteryRulerColorClassName = (()=>{
    const className = {
        10: 'border-grey-500',
        8: 'border-grey-500',
        7: 'border-grey-500'
    };
    return className;
})();
const $a85e2b07dac54e12$var$masteryRulerColorDefaultClassName = 'border-grey-400';
function $a85e2b07dac54e12$export$910cc3307d8b09db(championLevel) {
    const level = $a85e2b07dac54e12$var$clampChampionLevel(championLevel);
    if (level === 0) return undefined;
    return $a85e2b07dac54e12$var$masteryBgColorClassName[level];
}
function $a85e2b07dac54e12$export$b06b879d73ad6baf(championLevel) {
    return `linear-${$a85e2b07dac54e12$var$clampChampionLevel(championLevel)}`;
}
function $a85e2b07dac54e12$export$ba5db2e5993f4709(championLevel) {
    const level = $a85e2b07dac54e12$var$clampChampionLevel(championLevel);
    if (level === 0) return undefined;
    const commonClassName = 'bg-gradient-to-br from-30% to-80%';
    return (0, $5MBh5.cx)(commonClassName, $a85e2b07dac54e12$var$masteryHistogramGradientClassName[level]);
}
function $a85e2b07dac54e12$export$5d6f9a79aaea5f31(championLevel) {
    return $a85e2b07dac54e12$var$masteryTextColorClassName[$a85e2b07dac54e12$var$clampChampionLevel(championLevel)] ?? $a85e2b07dac54e12$var$masteryTextColorDefaultClassName;
}
function $a85e2b07dac54e12$export$9842f088a6739769(championLevel) {
    return $a85e2b07dac54e12$var$masteryRulerColorClassName[$a85e2b07dac54e12$var$clampChampionLevel(championLevel)] ?? $a85e2b07dac54e12$var$masteryRulerColorDefaultClassName;
}
/**
 * @param championLevel Should be >= 0
 */ function $a85e2b07dac54e12$var$clampChampionLevel(championLevel) {
    return Math.min(championLevel, 10);
}



var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $5mLQo = parcelRequire("5mLQo");

var $7CMrG = parcelRequire("7CMrG");
const $eb9efc27dddf1fe3$export$1d957f0f68a69614 = ({ faction: faction, className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $7CMrG.MaskedImage), {
        src: (0, $5mLQo.Assets).factions[faction],
        className: className
    });



var $aSiaI = parcelRequire("aSiaI");

var $aSiaI = parcelRequire("aSiaI");
const $35021e4c10651d5f$export$f7842826a842b266 = {
    top: ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    opacity: "0.5",
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M21,14H14v7h7V14Zm5-3V26L11.014,26l-4,4H30V7.016Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                    fill: "currentColor",
                    points: "4 4 4.003 28.045 9 23 9 9 23 9 28.045 4.003 4 4"
                })
            ]
        }),
    jun: ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M25,3c-2.128,3.3-5.147,6.851-6.966,11.469A42.373,42.373,0,0,1,20,20a27.7,27.7,0,0,1,1-3C21,12.023,22.856,8.277,25,3ZM13,20c-1.488-4.487-4.76-6.966-9-9,3.868,3.136,4.422,7.52,5,12l3.743,3.312C14.215,27.917,16.527,30.451,17,31c4.555-9.445-3.366-20.8-8-28C11.67,9.573,13.717,13.342,13,20Zm8,5a15.271,15.271,0,0,1,0,2l4-4c0.578-4.48,1.132-8.864,5-12C24.712,13.537,22.134,18.854,21,25Z"
            })
        }),
    mid: ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    opacity: "0.5",
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M30,12.968l-4.008,4L26,26H17l-4,4H30ZM16.979,8L21,4H4V20.977L8,17,8,8h8.981Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                    fill: "currentColor",
                    points: "25 4 4 25 4 30 9 30 30 9 30 4 25 4"
                })
            ]
        }),
    bot: ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                    opacity: "0.5",
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M13,20h7V13H13v7ZM4,4V26.984l3.955-4L8,8,22.986,8l4-4H4Z"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("polygon", {
                    fill: "currentColor",
                    points: "29.997 5.955 25 11 25 25 11 25 5.955 29.997 30 30 29.997 5.955"
                })
            ]
        }),
    sup: ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 34 34",
            className: className,
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M26,13c3.535,0,8-4,8-4H23l-3,3,2,7,5-2-3-4h2ZM22,5L20.827,3H13.062L12,5l5,6Zm-5,9-1-1L13,28l4,3,4-3L18,13ZM11,9H0s4.465,4,8,4h2L7,17l5,2,2-7Z"
            })
        })
};


const $62c858348d1b2db2$export$12e8b9f23d53a496 = ({ position: position, className: className })=>{
    const Position = (0, $35021e4c10651d5f$export$f7842826a842b266)[position];
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Position, {
        className: className
    });
};


const $f6e5e62ee0cda291$export$c5545b89bafb388 = ({ masteries: masteries, name: name, shardsCount: shardsCount, positions: positions, factions: factions })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const percentsElement = /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        className: "relative flex items-center py-0.5 pl-1.5 font-semibold shadow-black text-shadow",
        children: masteries !== undefined ? t.common.percents(Math.round(masteries.percents)) : t.masteries.unknownPercents
    });
    const tokenShards = (0, $kj6DU.pipe)([
        masteries !== undefined && 0 < masteries.markRequiredForNextLevel ? (0, $9ddGv.Maybe).some(/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
            children: t.masteries.nMarksOfMastery(masteries.tokensEarned, masteries.markRequiredForNextLevel)
        }, "tokens")) : (0, $9ddGv.Maybe).none,
        (0, $kj6DU.pipe)(shardsCount, (0, $9ddGv.Maybe).map((shards)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: t.masteries.nShards(shards)
            }, "shards")))
    ], (0, $9ddGv.List).compact, (0, $9ddGv.NonEmptyArray).fromReadonlyArray);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "relative flex overflow-hidden border-b border-tooltip",
                children: [
                    percentsElement,
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "absolute left-0",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "absolute -right-2 -top-4 size-[200%] rotate-12 bg-goldenrod-bis shadow-inner shadow-black"
                            }),
                            percentsElement
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: (0, $5MBh5.cx)('grow py-0.5 pl-4 pr-2 text-center font-bold shadow-black', (0, $a85e2b07dac54e12$export$ba5db2e5993f4709)(masteries?.championLevel ?? 0)),
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                className: "border-b border-tooltip px-2 py-1 text-center",
                children: masteries !== undefined ? t.masteries.points(masteries.championPoints, masteries.championPoints + masteries.championPointsUntilNextLevel, 'font-semibold') : t.masteries.unknownPoints('font-semibold')
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex grow flex-col items-center justify-center gap-1 px-2 py-1",
                children: [
                    (0, $kj6DU.pipe)(tokenShards, (0, $9ddGv.Maybe).fold(()=>null, (nea)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                            className: "flex items-center gap-2",
                            children: nea
                        }))),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($f6e5e62ee0cda291$export$135d860430810669, {
                        positions: positions,
                        factions: factions
                    })
                ]
            })
        ]
    });
};
const $f6e5e62ee0cda291$export$135d860430810669 = ({ positions: positions, factions: factions })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
        className: "flex w-full max-w-41 flex-wrap items-center justify-center gap-x-3 gap-y-0.5",
        children: [
            (0, $9ddGv.List).isNonEmpty(positions) ? (0, $kj6DU.pipe)(positions, (0, $9ddGv.NonEmptyArray).map((position)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                    className: "flex items-center gap-0.5",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $62c858348d1b2db2$export$12e8b9f23d53a496), {
                            position: position,
                            className: "size-6 shrink-0 p-0.5 text-wheat-bis"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            children: t.labels.position[position]
                        })
                    ]
                }, position))) : null,
            (0, $9ddGv.List).isNonEmpty(factions) ? (0, $kj6DU.pipe)(factions, (0, $9ddGv.NonEmptyArray).map((faction)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                    className: "flex items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $eb9efc27dddf1fe3$export$1d957f0f68a69614), {
                            faction: faction,
                            className: "size-5 text-wheat-bis"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            children: t.labels.faction[faction]
                        })
                    ]
                }, faction))) : null
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");
const $612718ebc5bdc341$export$6028b0e8199948bf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function({ championKey: championKey, championName: championName, as: as = 'div', className: className, children: children, ...props }, ref) {
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { assets: assets } = (0, $fcoXO.useStaticData)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: /*#__PURE__*/ (0, $exYeM.createElement)(as, {
            ...props,
            ref: ref,
            className: (0, $5MBh5.cx)('overflow-hidden', className)
        }, /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: assets.champion.square(championKey),
            alt: t.championIconAlt(championName),
            className: "m-[-6%] w-[112%] max-w-none"
        }), children)
    });
});



var $aSiaI = parcelRequire("aSiaI");

var $dR62Q = parcelRequire("dR62Q");
const $c77ac8d2b466640f$export$24a214d9165f464d = ({ href: href })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
        className: "mt-24 flex items-center gap-2 self-center text-sm",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.OpenInNew), {
                className: "invisible size-3.5"
            }),
            " ",
            /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noreferrer",
                className: "peer border-b border-b-wheat/50 transition-all duration-100 hover:border-b-goldenrod",
                children: href
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.OpenInNew), {
                className: "invisible size-3.5 opacity-0 transition-all duration-100 peer-hover:visible peer-hover:opacity-100"
            })
        ]
    });



var $1sXco = parcelRequire("1sXco");

var $aSiaI = parcelRequire("aSiaI");

var $aRVRH = parcelRequire("aRVRH");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $1sXco = parcelRequire("1sXco");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $kMW27 = parcelRequire("kMW27");

var $hZroh = parcelRequire("hZroh");

var $kj6DU = parcelRequire("kj6DU");

var $7znXl = parcelRequire("7znXl");

var $cdTKd = parcelRequire("cdTKd");

var $9ddGv = parcelRequire("9ddGv");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $ebb708240c48dd63$var$MapChangeStat(name, value) {
    return {
        type: 'stat',
        name: name,
        value: value
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $ebb708240c48dd63$var$MapChangeSkill(skill, changes) {
    return {
        type: 'skill',
        skill: skill,
        changes: changes
    };
}
function $ebb708240c48dd63$export$90c20a432e29f511(data) {
    const maybes = (0, $kj6DU.pipe)([
        (0, $kj6DU.pipe)(data.stats, (0, $9ddGv.Maybe).chain((stats)=>(0, $kj6DU.pipe)((0, $7znXl.WikiStatsBalance).keys, (0, $9ddGv.List).filterMap((key)=>(0, $kj6DU.pipe)((0, $9ddGv.Dict).lookup(key, stats), (0, $9ddGv.Maybe).map((value)=>$ebb708240c48dd63$var$MapChangeStat(key, value)))), (0, $9ddGv.NonEmptyArray).fromReadonlyArray))),
        (0, $kj6DU.pipe)(data.skills, (0, $9ddGv.Maybe).chain((skills)=>(0, $kj6DU.pipe)((0, $cdTKd.Skill).values, (0, $9ddGv.List).filterMap((skill)=>(0, $kj6DU.pipe)((0, $9ddGv.Dict).lookup(skill, skills), (0, $9ddGv.Maybe).map((changes)=>$ebb708240c48dd63$var$MapChangeSkill(skill, changes)))), (0, $9ddGv.NonEmptyArray).fromReadonlyArray)))
    ]);
    return (0, $kj6DU.pipe)(maybes, (0, $9ddGv.List).compact, (0, $9ddGv.List).chain((0, $kj6DU.identity)));
}
const $ebb708240c48dd63$export$35cd56382745d8d0 = ({ limit: limitSize, ...sizes })=>(data)=>$ebb708240c48dd63$var$splitWhileSmallerThanRec(sizes, limitSize, data, []);
function $ebb708240c48dd63$var$splitWhileSmallerThanRec(sizes, limitSize, data, acc) {
    if (limitSize < 0) return {
        left: acc,
        right: data
    };
    const [head, ...tail] = data;
    if (head === undefined) return {
        left: acc,
        right: tail
    };
    return $ebb708240c48dd63$var$splitWhileSmallerThanRec(sizes, limitSize - sizes[head.type], tail, (0, $kj6DU.pipe)(acc, (0, $9ddGv.List).append(head)));
}



var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $7znXl = parcelRequire("7znXl");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $5mLQo = parcelRequire("5mLQo");

var $5MBh5 = parcelRequire("5MBh5");
const $0ae63a68c5eaf6c7$export$728851338d8b3809 = ({ name: name, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('mapChanges');
    return /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
        src: (0, $5mLQo.Assets).stats[name],
        alt: t.statIconAlt(name),
        className: (0, $5MBh5.cx)('shrink-0 bg-contain brightness-75 sepia', className)
    });
};
const $0ae63a68c5eaf6c7$export$2cc79ca546e3ab80 = ({ name: name, value: value })=>{
    const isMalusStat = (0, $7znXl.WikiStatsBalance).isMalusStat(name);
    const maybeUnit = (0, $7znXl.WikiStatsBalance).isPercentsStat(name) ? (0, $9ddGv.Maybe).some('%') : (0, $9ddGv.Maybe).none;
    const n = (0, $7znXl.WikiStatsBalance).isModifierStat(name) ? (value * 1000 - 1000) / 10 : value;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
        className: (0, $5MBh5.cx)('flex shrink-0 font-lib-mono', (isMalusStat ? 0 < n : n < 0) ? 'text-red' : 'text-green'),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                children: [
                    n < 0 ? null : '+',
                    n
                ]
            }),
            (0, $kj6DU.pipe)(maybeUnit, (0, $9ddGv.Maybe).fold(()=>null, (u)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    children: u
                })))
        ]
    });
};


const $4f36ad52d98450a3$export$8c094cd568b6439e = ({ data: data })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const changes = (0, $exYeM.useMemo)(()=>(0, $ebb708240c48dd63$export$90c20a432e29f511)(data), [
        data
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
        className: "grid max-w-sm grid-cols-[auto_1fr] items-center gap-y-2 py-1",
        children: changes.map((c)=>{
            switch(c.type){
                case 'stat':
                    return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                        className: "contents",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-center gap-2 pr-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0ae63a68c5eaf6c7$export$728851338d8b3809), {
                                        name: c.name,
                                        className: "size-4"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "grow",
                                        children: t.common.labels.wikiStatsBalance[c.name]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0ae63a68c5eaf6c7$export$2cc79ca546e3ab80), {
                                name: c.name,
                                value: c.value
                            })
                        ]
                    }, c.name);
                case 'skill':
                    return /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                        className: "col-span-2",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                            className: "flex flex-col gap-1",
                            children: Array.from(c.changes.abilities.entries()).map(([ability, { icon: icon, description: description }])=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: icon
                                                    },
                                                    className: "wiki large mr-1"
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: (0, $kMW27.Ability).unwrap(c.changes.name)
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: t.mapChanges.skill(c.skill)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            },
                                            className: "wiki"
                                        })
                                    ]
                                }, (0, $kMW27.Ability).unwrap(ability)))
                        })
                    }, c.skill);
            }
        })
    });
};




var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");

const $981bed87d249c540$export$9e4948ce114eaafb = {
    stat: 3,
    skill: 5
};
const $981bed87d249c540$export$4c157fb38ec75dc = ({ name: name, value: value, reverse: reverse = false })=>{
    const elems = (0, $kj6DU.pipe)([
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0ae63a68c5eaf6c7$export$728851338d8b3809), {
            name: name,
            className: "size-2.5"
        }, "icon"),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0ae63a68c5eaf6c7$export$2cc79ca546e3ab80), {
            name: name,
            value: value
        }, "value")
    ], reverse ? (0, $9ddGv.List).reverse : (0, $kj6DU.identity));
    return /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
        className: $981bed87d249c540$var$gridClassName(reverse),
        children: elems
    });
};
const $981bed87d249c540$export$8eae7b5b63fcf71d = ({ skill: skill, changes: changes, reverse: reverse = false })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const elems = (0, $kj6DU.pipe)([
        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: changes.icon
            },
            className: "wiki compact"
        }, "html"),
        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
            children: t.labels.skill[skill]
        }, "name")
    ], reverse ? (0, $9ddGv.List).reverse : (0, $kj6DU.identity));
    return /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
        className: $981bed87d249c540$var$gridClassName(reverse),
        children: elems
    });
};
function $981bed87d249c540$var$gridClassName(reverse) {
    return (0, $5MBh5.cx)('grid items-center gap-1', reverse ? 'grid-cols-[1fr_max-content] justify-items-end' : 'grid-cols-[max-content_1fr]');
}


const $8dfaba1de5ccacc8$export$8feb69f2a1cfb779 = 'grid grid-cols-[auto_1fr] grid-rows-[auto_1fr] rounded-lg bg-aram-stats text-2xs';
const $8dfaba1de5ccacc8$export$60aa91691c7ccf90 = ({ tooltiPlacementRef: tooltiPlacementRef, wrapAfterSize: wrapAfterSize, data: data })=>{
    const initialRef = (0, $exYeM.useRef)(null);
    const moreRef = (0, $exYeM.useRef)(null);
    const { initial: initial, more: more } = (0, $exYeM.useMemo)(()=>$8dfaba1de5ccacc8$var$partitionStatsWrap(wrapAfterSize, data), [
        data,
        wrapAfterSize
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                ref: initialRef,
                className: "row-span-2 grid place-items-center",
                children: (0, $9ddGv.List).isNonEmpty(initial) && /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                    className: "p-0.5",
                    children: initial
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                ref: moreRef,
                className: "grid items-end justify-items-center",
                children: (0, $9ddGv.List).isNonEmpty(more) && /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                    className: "p-0.5",
                    children: more
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: [
                    initialRef,
                    moreRef
                ],
                placementRef: tooltiPlacementRef,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4f36ad52d98450a3$export$8c094cd568b6439e), {
                    data: data
                })
            })
        ]
    });
};
/**
 * Puts elements in `initial` until `wrapAfterSize` is reached.
 * Then puts remaining even elements in `more`, and appends odd elements to `initial`.
 *
 * @param wrapAfterSize should be `imageSize - 2 x paddingYSize`
 */ function $8dfaba1de5ccacc8$var$partitionStatsWrap(wrapAfterSize, data) {
    const { left: initial, right: more } = (0, $kj6DU.pipe)((0, $ebb708240c48dd63$export$90c20a432e29f511)(data), (0, $ebb708240c48dd63$export$35cd56382745d8d0)({
        ...(0, $981bed87d249c540$export$9e4948ce114eaafb),
        limit: wrapAfterSize
    }), $8dfaba1de5ccacc8$var$evenOddRights, (0, $aRVRH).bimap($8dfaba1de5ccacc8$var$toElements, $8dfaba1de5ccacc8$var$toElements));
    return {
        initial: initial,
        more: more
    };
}
const $8dfaba1de5ccacc8$var$toElements = (0, $9ddGv.List).map((change)=>{
    switch(change.type){
        case 'stat':
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $981bed87d249c540$export$4c157fb38ec75dc), {
                name: change.name,
                value: change.value
            }, change.name);
        case 'skill':
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $981bed87d249c540$export$8eae7b5b63fcf71d), {
                skill: change.skill,
                changes: change.changes
            }, change.skill);
    }
});
function $8dfaba1de5ccacc8$var$evenOddRights({ left: left, right: right }) {
    const { left: odds, right: evens } = (0, $kj6DU.pipe)(right, (0, $9ddGv.List).partitionWithIndex((i)=>i % 2 === 0));
    return {
        left: (0, $kj6DU.pipe)(left, (0, $9ddGv.List).concat(odds)),
        right: evens
    };
}



const { cleanChampionName: $ad291ea4f23077af$var$cleanChampionName } = (0, $hrnY6.StringUtils);
const $ad291ea4f23077af$export$7cf138d016f88fdb = (wikiLink, getData)=>()=>{
        const { genericQuery: genericQuery, updateGenericQuery: updateGenericQuery } = (0, $2Yib7.useHistory)();
        const { t: t } = (0, $hZroh.useTranslation)('common');
        const { champions: champions } = (0, $fcoXO.useStaticData)();
        const { filteredAndSortedChampions: filteredAndSortedChampions, searchCount: searchCount } = (0, $exYeM.useMemo)(()=>{
            const sortedChampions = (0, $kj6DU.pipe)(champions, (0, $9ddGv.List).map((c)=>({
                    ...c,
                    isHidden: !(0, $kj6DU.pipe)(genericQuery.search, (0, $9ddGv.Maybe).every((search)=>$ad291ea4f23077af$var$cleanChampionName(c.name).includes($ad291ea4f23077af$var$cleanChampionName(search)))),
                    category: (0, $33db2523ab42fb92$export$dc50577efab52c43).fromData(getData(c))
                })), (0, $9ddGv.List).sort((0, $f96Tp.StaticDataChampion).Ord.byName));
            const grouped = (0, $kj6DU.pipe)(sortedChampions, (0, $9ddGv.List).groupBy((a)=>a.isHidden ? 'hidden' : a.category));
            return {
                filteredAndSortedChampions: (0, $kj6DU.pipe)((0, $33db2523ab42fb92$export$dc50577efab52c43).values, (0, $9ddGv.List).reduce((0, $9ddGv.List).empty(), (acc, category)=>(0, $kj6DU.pipe)(acc, (0, $9ddGv.List).concat(grouped[category] ?? []))), (0, $9ddGv.List).concat(grouped.hidden ?? [])),
                searchCount: (0, $kj6DU.pipe)(sortedChampions, (0, $9ddGv.List).filter((c)=>!c.isHidden), (0, $9ddGv.List).size)
            };
        }, [
            champions,
            genericQuery.search
        ]);
        const onSearchChange = (0, $exYeM.useMemo)(()=>(0, $kj6DU.flow)((0, $4IdVv.GenericQuery).Lens.search.set, updateGenericQuery), [
            updateGenericQuery
        ]);
        const randomChampion = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(filteredAndSortedChampions, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $kj6DU.flow)((0, $793be4c33bc284e1$exports).randomElem, (0, $OFl2v).map((m)=>{
                updateGenericQuery((0, $4IdVv.GenericQuery).Lens.search.set((0, $9ddGv.Maybe).some(m.name)));
                return m.name;
            })))), [
            filteredAndSortedChampions,
            updateGenericQuery
        ]);
        return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex size-full flex-col overflow-y-auto px-2 pb-24 pt-3",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $859fbc684bacb002$export$bb60b672622fdba0), {
                        searchCount: searchCount,
                        randomChampion: randomChampion,
                        initialSearch: genericQuery.search,
                        onChange: onSearchChange,
                        className: "self-center"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "grid w-full grid-cols-[repeat(auto-fit,1px)] items-start gap-x-3.75 gap-y-1",
                        children: (0, $kj6DU.pipe)(filteredAndSortedChampions, (0, $javAY.ListUtils).mapWithPrevious((maybePrev, c)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                                children: [
                                    !c.isHidden && !(0, $kj6DU.pipe)(maybePrev, (0, $9ddGv.Maybe).exists((prev)=>(0, $33db2523ab42fb92$export$dc50577efab52c43).Eq.equals(prev.category, c.category))) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c0ec2c134c6dc113$export$13c8a39fad75a36b), {
                                        category: c.category,
                                        className: "pt-4"
                                    }) : null,
                                    /*#__PURE__*/ (0, $aSiaI.jsx)($ad291ea4f23077af$var$Champion, {
                                        getData: getData,
                                        champion: c
                                    })
                                ]
                            }, (0, $632HS.ChampionKey).unwrap(c.key))))
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "mt-6 self-center",
                        children: t.nChampionsFraction(searchCount, champions.length)
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c77ac8d2b466640f$export$24a214d9165f464d), {
                        href: wikiLink
                    })
                ]
            })
        });
    };
const $ad291ea4f23077af$var$Champion = ({ getData: getData, champion: champion })=>{
    const containerRef = (0, $exYeM.useRef)(null);
    const championRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        ref: containerRef,
        className: (0, $5MBh5.cx)((0, $8dfaba1de5ccacc8$export$8feb69f2a1cfb779), (0, $33db2523ab42fb92$export$dc50577efab52c43).fromData(getData(champion)) !== 'balanced' ? 'col-span-7' : 'col-span-4', [
            'hidden',
            champion.isHidden
        ]),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $612718ebc5bdc341$export$6028b0e8199948bf), {
                ref: championRef,
                championKey: champion.key,
                championName: champion.name,
                className: "size-12 rounded-lg shadow-even shadow-black"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: championRef,
                placement: "top",
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "self-center px-2 font-bold shadow-black text-shadow",
                        children: champion.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f6e5e62ee0cda291$export$135d860430810669), {
                        positions: champion.positions,
                        factions: champion.factions
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8dfaba1de5ccacc8$export$60aa91691c7ccf90), {
                tooltiPlacementRef: containerRef,
                wrapAfterSize: 11,
                data: getData(champion)
            })
        ]
    });
};


const $2676db7586563391$export$97895786af974272 = (0, $ad291ea4f23077af$export$7cf138d016f88fdb)('https://wiki.leagueoflegends.com/en-us/ARAM#Mode-Specific_Changes', (c)=>c.aram);



var $aSiaI = parcelRequire("aSiaI");

var $j7Bi0 = parcelRequire("j7Bi0");

var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $jVoNn = parcelRequire("jVoNn");

var $cn7Rc = parcelRequire("cn7Rc");

var $hPJN4 = parcelRequire("hPJN4");

var $7uCHH = parcelRequire("7uCHH");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $xJ0AO = parcelRequire("xJ0AO");
const { unwrap: $3f87dd84dbdb0cf9$var$unwrap } = (0, $hp7yq.iso)();
const $3f87dd84dbdb0cf9$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $3f87dd84dbdb0cf9$export$fb03e79d05d8f11e = {
    unwrap: $3f87dd84dbdb0cf9$var$unwrap,
    codec: $3f87dd84dbdb0cf9$var$codec
};


const $ccd287cd71369ee1$var$codec = $7uCHH.struct({
    code: (0, $3f87dd84dbdb0cf9$export$fb03e79d05d8f11e).codec
});
const $ccd287cd71369ee1$export$c138c21223413590 = {
    codec: $ccd287cd71369ee1$var$codec
};




var $9ddGv = parcelRequire("9ddGv");

var $kJ6py = parcelRequire("kJ6py");

var $avpuJ = parcelRequire("avpuJ");

var $5N26n = parcelRequire("5N26n");

var $2Yib7 = parcelRequire("2Yib7");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");

var $iz2wS = parcelRequire("iz2wS");

var $lQ3eP = parcelRequire("lQ3eP");

var $fviO3 = parcelRequire("fviO3");

var $5Aeax = parcelRequire("5Aeax");
const $cf7fc2f3f1aabf0f$var$apiCallDelay = (0, $hPJN4.MsDuration).milliseconds(100);
const $cf7fc2f3f1aabf0f$var$apiRoute = (0, $cn7Rc.apiRoutes).user.login.discord.post;
const $cf7fc2f3f1aabf0f$var$codeDecoder = $5zWxO.struct({
    code: (0, $3f87dd84dbdb0cf9$export$fb03e79d05d8f11e).codec
});
const $cf7fc2f3f1aabf0f$export$288f4777bbf2f735 = ()=>{
    const { query: query } = (0, $2Yib7.useHistory)();
    return (0, $kj6DU.pipe)($cf7fc2f3f1aabf0f$var$codeDecoder.decode(query), (0, $9ddGv.Either).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $5Aeax.NotFound), {}), ({ code: code })=>/*#__PURE__*/ (0, $aSiaI.jsx)($cf7fc2f3f1aabf0f$var$DiscordRedirectValidated, {
            code: code
        })));
};
const $cf7fc2f3f1aabf0f$var$DiscordRedirectValidated = ({ code: code })=>{
    const { refreshUser: refreshUser } = (0, $dCazK.useUser)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { data: data, error: error } = (0, $jVoNn.default)([
        ...$cf7fc2f3f1aabf0f$var$apiRoute,
        code
    ], ([url, method, code_])=>(0, $kj6DU.pipe)((0, $j7Bi0).sequenceT((0, $9ddGv.Future).ApplyPar)((0, $kj6DU.pipe)((0, $fviO3.http)([
            url,
            method
        ], {
            json: [
                (0, $ccd287cd71369ee1$export$c138c21223413590).codec,
                {
                    code: code_
                }
            ]
        }), (0, $9ddGv.Future).chain(()=>refreshUser)), (0, $kj6DU.pipe)((0, $9ddGv.Future).notUsed, (0, $9ddGv.Future).delay($cf7fc2f3f1aabf0f$var$apiCallDelay))), (0, $lQ3eP.futureRunUnsafe)), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
                data: data,
                error: error,
                children: ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $5N26n.Navigate), {
                        to: (0, $iz2wS.appRoutes).index,
                        replace: true
                    })
            }),
            error !== undefined ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                    to: (0, $iz2wS.appRoutes).index,
                    className: "mt-4 underline",
                    children: t.layout.home
                })
            }) : null
        ]
    });
};


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $OFl2v = parcelRequire("OFl2v");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $exYeM = parcelRequire("exYeM");

var $ffzmL = parcelRequire("ffzmL");

var $632HS = parcelRequire("632HS");

var $f96Tp = parcelRequire("f96Tp");

var $javAY = parcelRequire("javAY");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $csF9Q = parcelRequire("csF9Q");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $52dbH = parcelRequire("52dbH");

var $k6yCu = parcelRequire("k6yCu");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");

var $1sXco = parcelRequire("1sXco");
const $497c996a4da16cff$var$imgSrc = (id, tier)=>(0, $52dbH.DDragonUtils).ddragon(`/cdn/img/challenges-images/${id}-${tier}.png`);
const $497c996a4da16cff$export$a50dcf13e7b62e9d = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ id: id, tier: tier, className: className }, ref)=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const src = $497c996a4da16cff$var$imgSrc(id, (0, $kj6DU.pipe)(tier, (0, $9ddGv.Maybe).getOrElse(()=>'BRONZE')));
    const alt = t.challenge.iconAlt(id);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
        ref: ref,
        src: src,
        alt: alt,
        className: (0, $5MBh5.cx)([
            'grayscale',
            (0, $9ddGv.Maybe).isNone(tier)
        ], className)
    });
});
const $497c996a4da16cff$export$199960b3365d3c01 = ({ id: id, tier: tier, value: maybeValue, thresholds: thresholds, iconClassName: iconClassName })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const hoverRef = (0, $exYeM.useRef)(null);
    const placementRef = (0, $exYeM.useRef)(null);
    const src = $497c996a4da16cff$var$imgSrc(id, (0, $kj6DU.pipe)(tier, (0, $9ddGv.Maybe).getOrElse(()=>'BRONZE')));
    const alt = t.challenge.iconAlt(id);
    const value = (0, $kj6DU.pipe)(maybeValue, (0, $9ddGv.Maybe).getOrElse(()=>0));
    const values = (0, $k6yCu.DictUtils).partial.values(thresholds);
    const total = (0, $kj6DU.pipe)(values, (0, $9ddGv.List).filter((n)=>value < n), (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $9ddGv.NonEmptyArray).min((0, $cF6yJ).Ord)), (0, $9ddGv.Maybe).alt(()=>(0, $kj6DU.pipe)(values, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $9ddGv.NonEmptyArray).max((0, $cF6yJ).Ord)))), (0, $9ddGv.Maybe).getOrElse(()=>0));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                ref: hoverRef,
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        ref: placementRef,
                        src: src,
                        alt: alt,
                        className: (0, $5MBh5.cx)([
                            'grayscale',
                            (0, $9ddGv.Maybe).isNone(tier)
                        ], iconClassName)
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "font-semibold",
                        children: t.fraction(value, total)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: hoverRef,
                placementRef: placementRef,
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "pl-1 pt-1",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                    src: src,
                                    alt: alt,
                                    className: (0, $5MBh5.cx)('size-20', [
                                        'grayscale',
                                        (0, $9ddGv.Maybe).isNone(tier)
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex flex-col self-center",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex items-baseline gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                children: t.challenge.challenge
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                                className: "font-bold",
                                                children: t.labels.challenge(id)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "pt-1",
                                        children: t.labels.challengeShort(id)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        className: "flex gap-2 pt-2",
                                        children: [
                                            (0, $kj6DU.pipe)(tier, (0, $9ddGv.Maybe).fold(()=>null, (t_)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: t.labels.leagueTier[t_]
                                                }))),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                children: t.fraction(value, total)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-wrap gap-2 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: t.challenge.thresholds
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                className: "flex flex-wrap gap-1.5 italic",
                                children: (0, $kj6DU.pipe)(thresholds, (0, $k6yCu.DictUtils).partial.entries, (entries)=>entries.map(([key, val], i)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                            children: t.challenge.valueTier(val ?? 0, key, {
                                                withComma: i !== entries.length - 1
                                            })
                                        }, key)))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $8Wmxp = parcelRequire("8Wmxp");

var $cwvCy = parcelRequire("cwvCy");

var $1sXco = parcelRequire("1sXco");
const $afadb44a095e5a9d$export$2978b4beac7a3c02 = ({ challenges: challenges, faction: faction, count: { count: count, total: total }, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $5MBh5.cx)('col-span-full flex', className),
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "flex items-baseline gap-4",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        faction !== 'none' ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $eb9efc27dddf1fe3$export$1d957f0f68a69614), {
                            faction: faction,
                            className: "size-7"
                        }) : null,
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: "font-semibold",
                            children: t.labels.factionOrNone[faction]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            ref: ref,
                            className: "text-sm",
                            children: t.fraction(count, total, {
                                withParenthesis: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                    hoverRef: ref,
                    children: t.nChampionsFraction(count, total)
                }),
                faction !== 'none' ? (0, $kj6DU.pipe)(challenges, (0, $9ddGv.Maybe).fold(()=>null, ({ data: data, error: error })=>error !== undefined ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cwvCy.Pre), {
                        children: "error"
                    }) : data === undefined ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                        className: "h-4"
                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $497c996a4da16cff$export$199960b3365d3c01), {
                        id: (0, $csF9Q.ChallengesView).id[faction],
                        tier: (0, $kj6DU.pipe)(data[faction], (0, $9ddGv.Maybe).chain((c)=>c.level)),
                        value: (0, $kj6DU.pipe)(data[faction], (0, $9ddGv.Maybe).map((c)=>c.value)),
                        thresholds: $afadb44a095e5a9d$var$thresholds,
                        iconClassName: "h-7"
                    }))) : null
            ]
        })
    });
};
const $afadb44a095e5a9d$var$thresholds = {
    GOLD: 1,
    PLATINUM: 3,
    DIAMOND: 6,
    MASTER: 10
};







var $lMH1q = parcelRequire("lMH1q");

var $1sXco = parcelRequire("1sXco");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");
const $67cf1f07a2ea57b8$var$empty = {
    count: 0,
    total: 0
};
const $67cf1f07a2ea57b8$export$1b9130a9fda2eb88 = {
    empty: $67cf1f07a2ea57b8$var$empty
};



var $4IdVv = parcelRequire("4IdVv");

var $hOuM2 = parcelRequire("hOuM2");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");

var $hrnY6 = parcelRequire("hrnY6");
const { cleanUTF8ToASCII: $a34009e2fd6e6d61$var$cleanUTF8ToASCII } = (0, $hrnY6.StringUtils);
const $a34009e2fd6e6d61$export$6a3aa170c29c42fa = {
    Ord: {
        byLabel: (t)=>(0, $kj6DU.pipe)((0, $gSyeU).Ord, (0, $hOuM2).contramap((f)=>$a34009e2fd6e6d61$var$cleanUTF8ToASCII(t.labels.faction[f])))
    }
};



var $5MBh5 = parcelRequire("5MBh5");
const { cleanChampionName: $974a65b4ee53a896$var$cleanChampionName } = (0, $hrnY6.StringUtils);
const $974a65b4ee53a896$var$EnrichedStaticDataChampion = {
    Lens: {
        faction: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('faction'))
    }
};
const $974a65b4ee53a896$export$c454e4c3445e22b1 = ()=>{
    const { genericQuery: genericQuery, updateGenericQuery: updateGenericQuery } = (0, $2Yib7.useHistory)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { champions: champions } = (0, $fcoXO.useStaticData)();
    const { filteredAndSortedChampions: filteredAndSortedChampions, factionsCount: factionsCount, searchCount: searchCount } = (0, $exYeM.useMemo)(()=>{
        const sortedChampions = (0, $kj6DU.pipe)(champions, (0, $9ddGv.List).map((c)=>({
                ...c,
                isHidden: !(0, $kj6DU.pipe)(genericQuery.search, (0, $9ddGv.Maybe).every((search)=>$974a65b4ee53a896$var$cleanChampionName(c.name).includes($974a65b4ee53a896$var$cleanChampionName(search)))),
                faction: (0, $f96Tp.StaticDataChampion).getFaction(c.factions)
            })), (0, $9ddGv.List).sort((0, $f96Tp.StaticDataChampion).Ord.byName));
        const grouped = (0, $kj6DU.pipe)(sortedChampions, (0, $javAY.ListUtils).multipleGroupBy((c)=>{
            if (c.isHidden) return [
                'hidden'
            ];
            if ((0, $9ddGv.List).isNonEmpty(c.factions)) return c.factions;
            return [
                'none'
            ];
        }), (0, $9ddGv.PartialDict).mapWithIndex((faction, champions_)=>(0, $kj6DU.pipe)(champions_, (0, $9ddGv.NonEmptyArray).map((c)=>faction === 'hidden' ? c : (0, $kj6DU.pipe)(c, $974a65b4ee53a896$var$EnrichedStaticDataChampion.Lens.faction.set(faction))))));
        const factionsCount_ = (0, $kj6DU.pipe)(sortedChampions, (0, $javAY.ListUtils).multipleGroupBy((c)=>(0, $9ddGv.List).isNonEmpty(c.factions) ? c.factions : [
                'none'
            ]), (0, $9ddGv.PartialDict).map((nea)=>({
                count: nea.filter((c)=>!c.isHidden).length,
                total: nea.length
            })));
        return {
            filteredAndSortedChampions: (0, $kj6DU.pipe)((0, $ffzmL.ChampionFactionOrNone).valuesSortBy([
                (0, $a34009e2fd6e6d61$export$6a3aa170c29c42fa).Ord.byLabel(t)
            ]), (0, $9ddGv.List).reduce((0, $9ddGv.List).empty(), (acc, faction)=>(0, $kj6DU.pipe)(acc, (0, $9ddGv.List).concat(grouped[faction] ?? []))), (0, $9ddGv.List).concat(grouped.hidden ?? [])),
            factionsCount: factionsCount_,
            searchCount: (0, $kj6DU.pipe)(sortedChampions, (0, $9ddGv.List).filter((c)=>!c.isHidden), (0, $9ddGv.List).size)
        };
    }, [
        champions,
        genericQuery.search,
        t
    ]);
    const onSearchChange = (0, $exYeM.useMemo)(()=>(0, $kj6DU.flow)((0, $4IdVv.GenericQuery).Lens.search.set, updateGenericQuery), [
        updateGenericQuery
    ]);
    const randomChampion = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(filteredAndSortedChampions, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $kj6DU.flow)((0, $793be4c33bc284e1$exports).randomElem, (0, $OFl2v).map((m)=>{
            updateGenericQuery((0, $4IdVv.GenericQuery).Lens.search.set((0, $9ddGv.Maybe).some(m.name)));
            return m.name;
        })))), [
        filteredAndSortedChampions,
        updateGenericQuery
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "flex size-full flex-col overflow-y-auto px-2 pb-24 pt-3",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $859fbc684bacb002$export$bb60b672622fdba0), {
                    searchCount: searchCount,
                    randomChampion: randomChampion,
                    initialSearch: genericQuery.search,
                    onChange: onSearchChange,
                    className: "self-center"
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "grid w-full grid-cols-[repeat(auto-fit,3rem)] items-start gap-2",
                    children: (0, $kj6DU.pipe)(filteredAndSortedChampions, (0, $javAY.ListUtils).mapWithPrevious((maybePrev, c)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                            children: [
                                !c.isHidden && !(0, $kj6DU.pipe)(maybePrev, (0, $9ddGv.Maybe).exists((prev)=>(0, $ffzmL.ChampionFactionOrNone).Eq.equals(prev.faction, c.faction))) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $afadb44a095e5a9d$export$2978b4beac7a3c02), {
                                    challenges: (0, $9ddGv.Maybe).none,
                                    count: factionsCount[c.faction] ?? (0, $67cf1f07a2ea57b8$export$1b9130a9fda2eb88).empty,
                                    faction: c.faction,
                                    className: "pt-3"
                                }) : null,
                                /*#__PURE__*/ (0, $aSiaI.jsx)($974a65b4ee53a896$var$Champion, {
                                    champion: c
                                })
                            ]
                        }, `${c.faction}${(0, $632HS.ChampionKey).unwrap(c.key)}`)))
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "mt-6 self-center",
                    children: t.nChampionsFraction(searchCount, champions.length)
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c77ac8d2b466640f$export$24a214d9165f464d), {
                    href: "https://wiki.leagueoflegends.com/en-us/Challenges#Faction_Challenges"
                })
            ]
        })
    });
};
const $974a65b4ee53a896$var$Champion = ({ champion: champion })=>{
    const hoverRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $612718ebc5bdc341$export$6028b0e8199948bf), {
                ref: hoverRef,
                championKey: champion.key,
                championName: champion.name,
                className: (0, $5MBh5.cx)('size-12 rounded-xl shadow-even shadow-black', [
                    'hidden',
                    champion.isHidden
                ])
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: hoverRef,
                placement: "top",
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                        className: "self-center px-2 font-bold shadow-black text-shadow",
                        children: champion.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f6e5e62ee0cda291$export$135d860430810669), {
                        positions: champion.positions,
                        factions: []
                    })
                ]
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $lMH1q = parcelRequire("lMH1q");

var $hZroh = parcelRequire("hZroh");
const $4d43a77e6747d7f7$export$b94310965bed44e6 = ()=>{
    const { t: t } = (0, $hZroh.useTranslation)('home');
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "grid h-full grid-rows-[1fr_auto] justify-center gap-3 p-3",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
                    className: "place-self-center font-lib-mono text-2xl",
                    children: t.theQuest
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                    className: "text-2xs",
                    children: t.isntEndorsed
                })
            ]
        })
    });
};


/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $5fNnZ = parcelRequire("5fNnZ");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $exYeM = parcelRequire("exYeM");

var $kf3m0 = parcelRequire("kf3m0");

var $9ddGv = parcelRequire("9ddGv");

var $exi8o = parcelRequire("exi8o");

var $kJ6py = parcelRequire("kJ6py");

var $avpuJ = parcelRequire("avpuJ");

var $8Wmxp = parcelRequire("8Wmxp");

var $5N26n = parcelRequire("5N26n");

var $lMH1q = parcelRequire("lMH1q");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");

var $aSiaI = parcelRequire("aSiaI");
const $b33a6caddb54ab23$export$42e8453a5b2d580 = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 508.67 96.36",
        className: className,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M170.85,20.2h27.3q9.87,0,16.7,3.08a22.5,22.5,0,0,1,10.21,8.58,23.34,23.34,0,0,1,3.4,12.56A23.24,23.24,0,0,1,224.93,57a23.94,23.94,0,0,1-10.79,8.92q-7.24,3.3-17.95,3.29H170.85Zm25.06,36.54q6.65,0,10.22-3.32a11.8,11.8,0,0,0,3.57-9.07,11.5,11.5,0,0,0-3.18-8.5q-3.2-3.18-9.63-3.19h-8.54V56.74Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M269.34,69.13a37,37,0,0,1-10.22-4.27V53.24a27.77,27.77,0,0,0,9.2,4.38,39.31,39.31,0,0,0,11.17,1.71,8.71,8.71,0,0,0,3.82-.66c.86-.44,1.29-1,1.29-1.58a2.37,2.37,0,0,0-.7-1.75,6.15,6.15,0,0,0-2.73-1.19l-8.4-1.89q-7.22-1.68-10.25-4.65a10.39,10.39,0,0,1-3-7.81,10.37,10.37,0,0,1,2.66-7.07,17.13,17.13,0,0,1,7.56-4.65,36,36,0,0,1,11.48-1.65A43.27,43.27,0,0,1,292,27.69a30.25,30.25,0,0,1,8.12,3.22v11a30,30,0,0,0-7.6-3.11,34,34,0,0,0-8.85-1.16q-6.58,0-6.58,2.24a1.69,1.69,0,0,0,1,1.58,16.14,16.14,0,0,0,3.74,1.08l7,1.26Q295.65,45,299,48t3.36,8.78a11.61,11.61,0,0,1-5.57,10.12Q291.26,70.61,281,70.6A46.41,46.41,0,0,1,269.34,69.13Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M318.9,67.66a21,21,0,0,1-9.07-8,21.59,21.59,0,0,1-3-11.34,20.62,20.62,0,0,1,3.15-11.27,21.16,21.16,0,0,1,9.24-7.8,34.25,34.25,0,0,1,14.56-2.84q10.5,0,17.43,4.41V43.65a21.84,21.84,0,0,0-5.7-2.73,22.65,22.65,0,0,0-7-1.05q-6.51,0-10.19,2.38a7.15,7.15,0,0,0-.1,12.43q3.57,2.41,10.36,2.41a23.91,23.91,0,0,0,6.9-1,25.71,25.71,0,0,0,5.84-2.49V66a34,34,0,0,1-17.85,4.62A32.93,32.93,0,0,1,318.9,67.66Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M368.64,67.66a21.77,21.77,0,0,1-9.25-8,21.14,21.14,0,0,1-3.18-11.41A20.27,20.27,0,0,1,359.39,37a21.42,21.42,0,0,1,9.21-7.74,38.17,38.17,0,0,1,28.7,0,21.25,21.25,0,0,1,9.17,7.7,20.41,20.41,0,0,1,3.15,11.27,21.29,21.29,0,0,1-3.15,11.41,21.51,21.51,0,0,1-9.2,8,36.32,36.32,0,0,1-28.63,0Zm21.27-12.42a9.12,9.12,0,0,0,2.56-6.76,8.87,8.87,0,0,0-2.56-6.68,9.53,9.53,0,0,0-7-2.49,9.67,9.67,0,0,0-7,2.49,8.9,8.9,0,0,0-2.55,6.68,9.15,9.15,0,0,0,2.55,6.76,9.53,9.53,0,0,0,7,2.55A9.4,9.4,0,0,0,389.91,55.24Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M451.69,29V44.14a12.47,12.47,0,0,0-6.93-1.75c-3.73,0-6.61,1.14-8.61,3.4s-3,5.77-3,10.53V69.2H416V28.25h16.8v13q1.4-7.14,4.52-10.53a10.38,10.38,0,0,1,8-3.4A11.71,11.71,0,0,1,451.69,29Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M508.67,18.8V69.2H491.52V60a16.23,16.23,0,0,1-6.62,7.88A20.81,20.81,0,0,1,474,70.6a18.11,18.11,0,0,1-10.15-2.83A18.6,18.6,0,0,1,457.11,60a25.75,25.75,0,0,1-2.34-11.17,24.87,24.87,0,0,1,2.48-11.55,19.43,19.43,0,0,1,7.21-8,19.85,19.85,0,0,1,10.61-2.87q12.24,0,16.45,10.64V18.8ZM489,55a8.83,8.83,0,0,0,2.63-6.62A8.42,8.42,0,0,0,489,42a11,11,0,0,0-13.89,0,8.55,8.55,0,0,0-2.59,6.47A8.67,8.67,0,0,0,475.14,55,9.42,9.42,0,0,0,482,57.51,9.56,9.56,0,0,0,489,55Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ellipse", {
                cx: "242.92",
                cy: "24.93",
                rx: "8.55",
                ry: "7.68",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
                d: "M234.36,37.9a22.08,22.08,0,0,0,17.11,0V69.42H234.36Z",
                fill: "currentColor"
            })
        ]
    });



var $3sLwn = parcelRequire("3sLwn");

var $iz2wS = parcelRequire("iz2wS");

var $kj6DU = parcelRequire("kj6DU");

var $2art4 = parcelRequire("2art4");

var $9ddGv = parcelRequire("9ddGv");

var $abFKR = parcelRequire("abFKR");
const $f5e967de4468d378$export$f8ebcce652de4cda = `https://discord.com/api/oauth2/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($2art4))).stringify({
    client_id: (0, $abFKR.config).discordClient.id,
    redirect_uri: (0, $abFKR.config).discordClient.redirectUri,
    response_type: 'code',
    scope: (0, $kj6DU.pipe)([
        'identify',
        'connections'
    ], (0, $9ddGv.List).mkString(' ')),
    prompt: 'none'
})}`;



var $lQ3eP = parcelRequire("lQ3eP");
const $767ba6d83a3bcbb3$var$emptyState = {
    userName: '',
    password: ''
};
const $767ba6d83a3bcbb3$export$68936a7c4bae5452 = (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('userName'));
const $767ba6d83a3bcbb3$export$2ef0475305ef813d = (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('password'));
const $767ba6d83a3bcbb3$export$21a94553ffa41578 = ()=>{
    const { user: user, refreshUser: refreshUser } = (0, $dCazK.useUser)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const [isLoading, setIsLoading] = (0, $exYeM.useState)(false);
    const [error, setError] = (0, $exYeM.useState)((0, $9ddGv.Maybe).none);
    const [state, setState] = (0, $exYeM.useState)($767ba6d83a3bcbb3$var$emptyState);
    const updateUserName = (0, $exYeM.useCallback)((e)=>{
        setState($767ba6d83a3bcbb3$export$68936a7c4bae5452.set(e.target.value));
        setError((0, $9ddGv.Maybe).none);
    }, []);
    const updatePassword = (0, $exYeM.useCallback)((e)=>{
        setState($767ba6d83a3bcbb3$export$2ef0475305ef813d.set(e.target.value));
        setError((0, $9ddGv.Maybe).none);
    }, []);
    const validated = (0, $exYeM.useMemo)(()=>(0, $kf3m0.LoginPasswordPayload).codec.decode(state), [
        state
    ]);
    const handleSubmit = (0, $exYeM.useCallback)((e)=>{
        e.preventDefault();
        (0, $kj6DU.pipe)(validated, (0, $9ddGv.Either).map((valid)=>{
            setIsLoading(true);
            return (0, $kj6DU.pipe)(valid, (0, $exi8o.apiUserLoginPasswordPost), (0, $9ddGv.Future).chain(()=>refreshUser), (0, $9ddGv.Future).orElseW(()=>(0, $9ddGv.Future).successful(setError((0, $9ddGv.Maybe).some('error')))), (0, $5fNnZ).chainFirstIOK(()=>()=>setIsLoading(false)), (0, $lQ3eP.futureRunUnsafe));
        }));
    }, [
        refreshUser,
        validated
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
        ...(0, $3sLwn.AsyncState).toSWR(user),
        children: (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex flex-col items-center gap-12 px-4 py-20",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                            href: (0, $f5e967de4468d378$export$f8ebcce652de4cda),
                            className: "flex items-center rounded-md bg-discord-blurple px-6 text-white",
                            children: t.form.loginWithDiscord(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $b33a6caddb54ab23$export$42e8453a5b2d580), {
                                className: "my-3 ml-3 h-6"
                            }))
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                            children: t.form.or
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "flex flex-col items-center gap-8 border border-goldenrod bg-zinc-900 px-12 py-8",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                    className: "text-lg font-bold",
                                    children: t.layout.login
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "grid grid-cols-[auto_auto] gap-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: t.form.userName
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "text",
                                                    value: state.userName,
                                                    onChange: updateUserName,
                                                    className: "border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "col-start-1 mt-2",
                                                    children: t.form.password
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "password",
                                                    value: state.password,
                                                    onChange: updatePassword,
                                                    className: "mt-2 border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col items-center gap-2 self-center",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "submit",
                                            disabled: isLoading || (0, $9ddGv.Either).isLeft(validated),
                                            className: "flex items-center gap-2 bg-goldenrod px-4 py-1 text-black enabled:hover:bg-goldenrod/75 disabled:bg-grey-disabled",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: t.form.login
                                                }),
                                                isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                                                    className: "h-4"
                                                }) : null
                                            ]
                                        }),
                                        (0, $kj6DU.pipe)(error, (0, $9ddGv.Maybe).fold(()=>null, (e)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "text-red",
                                                children: e
                                            })))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex w-full max-w-xl flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: t.form.noAccount
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                                    to: (0, $iz2wS.appRoutes).register,
                                    className: "font-medium underline",
                                    children: t.form.register
                                })
                            ]
                        })
                    ]
                })
            }), ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $5N26n.Navigate), {
                to: (0, $iz2wS.appRoutes).index,
                replace: true
            }))
    });
};


/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $5fNnZ = parcelRequire("5fNnZ");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $exYeM = parcelRequire("exYeM");

var $98dC6 = parcelRequire("98dC6");

var $kf3m0 = parcelRequire("kf3m0");

var $9ddGv = parcelRequire("9ddGv");

var $98dC6 = parcelRequire("98dC6");

var $9ddGv = parcelRequire("9ddGv");
const $177732b0b4bcc470$export$4d2a7159fda5dc93 = (password)=>{
    const passwordStr = (0, $98dC6.ClearPassword).unwrap(password);
    if (passwordStr.length < 8) return (0, $9ddGv.Either).left("Le mot de passe doit contenir au moins 8 caract\xe8res");
    if (!$177732b0b4bcc470$var$containsUpperLowerDigit(passwordStr)) return (0, $9ddGv.Either).left('Le mot de passe doit contenir au moins une minuscule, une majuscule et un chiffre');
    return (0, $9ddGv.Either).right(password);
};
const $177732b0b4bcc470$var$containsUpperLowerDigit = (str)=>{
    const chars = str.split('');
    return $177732b0b4bcc470$var$containsLower(chars) && $177732b0b4bcc470$var$containsUpper(chars) && $177732b0b4bcc470$var$containsDigit(str);
};
const $177732b0b4bcc470$var$containsLower = (0, $9ddGv.List).exists((c)=>c.toLowerCase() === c);
const $177732b0b4bcc470$var$containsUpper = (0, $9ddGv.List).exists((c)=>c.toUpperCase() === c);
const $177732b0b4bcc470$var$digitsRegex = /[0-9]/;
const $177732b0b4bcc470$var$containsDigit = (str)=>$177732b0b4bcc470$var$digitsRegex.test(str);



var $exi8o = parcelRequire("exi8o");

var $kJ6py = parcelRequire("kJ6py");

var $avpuJ = parcelRequire("avpuJ");

var $8Wmxp = parcelRequire("8Wmxp");

var $5N26n = parcelRequire("5N26n");

var $lMH1q = parcelRequire("lMH1q");

var $exJMo = parcelRequire("exJMo");

var $2Yib7 = parcelRequire("2Yib7");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");


var $dR62Q = parcelRequire("dR62Q");

var $3sLwn = parcelRequire("3sLwn");

var $iz2wS = parcelRequire("iz2wS");

var $5MBh5 = parcelRequire("5MBh5");


var $lQ3eP = parcelRequire("lQ3eP");
const $2b9576acf8cbab7f$var$lesQuaisAbattoirs = {
    inviteLink: 'https://discord.gg/M4jnkHd',
    name: 'Les Quais-Abattoirs',
    image: 'https://cdn.discordapp.com/icons/707621148652994642/a_8b2674e8d2831749f540f330df66a63e.gif?size=240'
};
const $2b9576acf8cbab7f$var$emptyState = {
    userName: '',
    password: '',
    confirmPassword: ''
};
const $2b9576acf8cbab7f$var$userNameLens = (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('userName'));
const $2b9576acf8cbab7f$var$passwordLens = (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('password'));
const $2b9576acf8cbab7f$var$confirmPasswordLens = (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('confirmPassword'));
const $2b9576acf8cbab7f$export$157c131647dc68e = ()=>{
    const { navigate: navigate } = (0, $2Yib7.useHistory)();
    const { user: user } = (0, $dCazK.useUser)();
    const { t: t } = (0, $hZroh.useTranslation)();
    const [isLoading, setIsLoading] = (0, $exYeM.useState)(false);
    const [error, setError] = (0, $exYeM.useState)((0, $9ddGv.Maybe).none);
    const [state, setState] = (0, $exYeM.useState)($2b9576acf8cbab7f$var$emptyState);
    const updateUserName = (0, $exYeM.useCallback)((e)=>{
        setState($2b9576acf8cbab7f$var$userNameLens.set(e.target.value));
        setError((0, $9ddGv.Maybe).none);
    }, []);
    const updatePassword = (0, $exYeM.useCallback)((e)=>{
        setState($2b9576acf8cbab7f$var$passwordLens.set(e.target.value));
        setError((0, $9ddGv.Maybe).none);
    }, []);
    const updateConfirmPassword = (0, $exYeM.useCallback)((e)=>{
        setState($2b9576acf8cbab7f$var$confirmPasswordLens.set(e.target.value));
        setError((0, $9ddGv.Maybe).none);
    }, []);
    const validated = (0, $exYeM.useMemo)(()=>(0, $kf3m0.LoginPasswordPayload).codec.decode(state), [
        state
    ]);
    const handleSubmit = (0, $exYeM.useCallback)((e)=>{
        e.preventDefault();
        (0, $kj6DU.pipe)(validated, (0, $9ddGv.Either).map((payload)=>{
            (0, $kj6DU.pipe)($2b9576acf8cbab7f$var$validateOnSubmit(t.common)(payload.password, state.confirmPassword), (0, $9ddGv.Either).foldW((0, $kj6DU.flow)((0, $9ddGv.Maybe).some, setError), ()=>{
                setIsLoading(true);
                return (0, $kj6DU.pipe)((0, $exi8o.apiUserRegisterPost)(payload), (0, $9ddGv.Future).map(()=>navigate((0, $iz2wS.appRoutes).login)), (0, $9ddGv.Future).orElse(()=>(0, $9ddGv.Future).successful(setError((0, $9ddGv.Maybe).some('error')))), (0, $5fNnZ).chainFirstIOK(()=>()=>setIsLoading(false)), (0, $lQ3eP.futureRunUnsafe));
            }));
        }));
    }, [
        navigate,
        state.confirmPassword,
        t,
        validated
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
        ...(0, $3sLwn.AsyncState).toSWR(user),
        children: (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    className: "flex flex-col items-center gap-12 px-4 py-20",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("table", {
                            className: "grid grid-cols-[auto_1fr_1fr]",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("thead", {
                                    className: "contents",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                        className: "contents",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("th", {}),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Th, {
                                                children: t.register.withoutAccount
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Th, {
                                                children: t.register.withAccount
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("tbody", {
                                    className: "contents",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "border-l border-t border-goldenrod pl-10 pt-12",
                                                    children: t.register.accessSummonerDetails
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-t border-goldenrod pt-12",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-r border-t border-goldenrod pt-12",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "border-l border-goldenrod pl-10",
                                                    children: t.register.accessRecentSearches((0, $exJMo.constants).recentSearchesMaxCount)
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-r border-goldenrod",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "border-l border-goldenrod pl-10",
                                                    children: t.register.addSummonerToFavorites
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$EmptyTd, {}),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-r border-goldenrod",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "border-l border-goldenrod pl-10",
                                                    children: t.register.customiseChampionPositions
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$EmptyTd, {}),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-r border-goldenrod",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("tr", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsxs)($2b9576acf8cbab7f$var$Td, {
                                                    className: "flex-col gap-3 border-b border-l border-goldenrod pb-12 pl-10",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "self-start",
                                                            children: t.register.discordHallOfFameRanking
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                            className: "flex items-center self-start rounded bg-discord-darkgrey px-6 py-5 text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                                                    src: $2b9576acf8cbab7f$var$lesQuaisAbattoirs.image,
                                                                    alt: t.register.discordServerIconAlt($2b9576acf8cbab7f$var$lesQuaisAbattoirs.name),
                                                                    className: "w-12 rounded-xl"
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                                    className: "ml-4 flex flex-col",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                            className: "font-bold",
                                                                            children: $2b9576acf8cbab7f$var$lesQuaisAbattoirs.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                            className: "text-sm text-zinc-400",
                                                                            children: t.register.discordServer
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                                                    href: $2b9576acf8cbab7f$var$lesQuaisAbattoirs.inviteLink,
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    className: "ml-8 rounded bg-discord-darkgreen px-3 py-2 text-sm font-medium",
                                                                    children: t.register.join
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-b border-goldenrod pb-12",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
                                                    className: "justify-center border-b border-r border-goldenrod pb-12",
                                                    children: $2b9576acf8cbab7f$var$greenCheck
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {
                            className: "w-full max-w-xl border-t border-goldenrod"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                            href: (0, $f5e967de4468d378$export$f8ebcce652de4cda),
                            className: "flex items-center rounded-md bg-discord-blurple px-6 text-white",
                            children: t.common.form.loginWithDiscord(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $b33a6caddb54ab23$export$42e8453a5b2d580), {
                                className: "my-3 ml-3 h-6"
                            }))
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)("p", {
                            children: t.common.form.or
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "flex flex-col items-center gap-8 border border-goldenrod bg-zinc-900 px-12 py-8",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                    className: "text-lg font-bold",
                                    children: t.common.layout.register
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "grid grid-cols-[auto_auto] gap-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: t.common.form.userName
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "text",
                                                    value: state.userName,
                                                    onChange: updateUserName,
                                                    className: "border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "col-start-1 mt-2",
                                                    children: t.common.form.password
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "password",
                                                    value: state.password,
                                                    onChange: updatePassword,
                                                    className: "mt-2 border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
                                            className: "contents",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    className: "col-start-1 mt-2",
                                                    children: t.common.form.confirmPassword
                                                }),
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                                                    type: "password",
                                                    value: state.confirmPassword,
                                                    onChange: updateConfirmPassword,
                                                    className: "mt-2 border border-goldenrod bg-transparent"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex flex-col items-center gap-2 self-center",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                                            type: "submit",
                                            disabled: isLoading || (0, $9ddGv.Either).isLeft(validated),
                                            className: "flex items-center gap-2 bg-goldenrod px-4 py-1 text-black enabled:hover:bg-goldenrod/75 disabled:bg-grey-disabled",
                                            children: [
                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                    children: t.common.form.register
                                                }),
                                                isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                                                    className: "h-4"
                                                }) : null
                                            ]
                                        }),
                                        (0, $kj6DU.pipe)(error, (0, $9ddGv.Maybe).fold(()=>null, (e)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "text-red",
                                                children: e
                                            })))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "flex w-full max-w-xl flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: t.common.form.alreadyAnAccount
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $avpuJ.Link), {
                                    to: (0, $iz2wS.appRoutes).login,
                                    className: "font-medium underline",
                                    children: t.common.form.login
                                })
                            ]
                        })
                    ]
                })
            }), ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $5N26n.Navigate), {
                to: (0, $iz2wS.appRoutes).index,
                replace: true
            }))
    });
};
const $2b9576acf8cbab7f$var$Th = ({ children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)("th", {
        className: "flex items-center justify-center px-2 pb-3 font-medium",
        children: children
    });
const $2b9576acf8cbab7f$var$Td = ({ className: className, children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)("td", {
        className: (0, $5MBh5.cx)('flex items-center bg-zinc-900 px-2 py-5', className),
        children: children
    });
const $2b9576acf8cbab7f$var$EmptyTd = ({ className: className })=>/*#__PURE__*/ (0, $aSiaI.jsx)($2b9576acf8cbab7f$var$Td, {
        className: (0, $5MBh5.cx)('justify-center text-sm', className),
        children: "\u2014"
    });
const $2b9576acf8cbab7f$var$greenCheck = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CheckMarkSharp), {
    className: "h-6 text-green"
});
const $2b9576acf8cbab7f$var$validateOnSubmit = (t)=>(password, confirmPassword)=>(0, $98dC6.ClearPassword).unwrap(password) !== confirmPassword ? (0, $9ddGv.Either).left(t.form.passwordsShouldBeIdentical) : (0, $kj6DU.pipe)((0, $177732b0b4bcc470$export$4d2a7159fda5dc93)(password), (0, $9ddGv.Either).map((0, $9ddGv.toNotUsed)));


/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $cn7Rc = parcelRequire("cn7Rc");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $hPJN4 = parcelRequire("hPJN4");

var $7uCHH = parcelRequire("7uCHH");

var $632HS = parcelRequire("632HS");
const $3725f8579c0c2481$var$codec = $7uCHH.struct({
    championId: (0, $632HS.ChampionKey).codec,
    championLevel: $7uCHH.number,
    championPoints: $7uCHH.number,
    championPointsSinceLastLevel: $7uCHH.number,
    championPointsUntilNextLevel: $7uCHH.number,
    tokensEarned: $7uCHH.number,
    markRequiredForNextLevel: $7uCHH.number
});
const $3725f8579c0c2481$export$c891b48931e98110 = {
    codec: $3725f8579c0c2481$var$codec
};



var $9RyKW = parcelRequire("9RyKW");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $632HS = parcelRequire("632HS");
const $422ee4e31ec4eecd$var$codec = $7uCHH.struct({
    champion: (0, $632HS.ChampionKey).codec,
    count: $7uCHH.number
});
const $422ee4e31ec4eecd$var$byChampionEq = (0, $kj6DU.pipe)((0, $632HS.ChampionKey).Eq, (0, $9RyKW).contramap((s)=>s.champion));
const $422ee4e31ec4eecd$export$c8017683694e0c17 = {
    codec: $422ee4e31ec4eecd$var$codec,
    Eq: {
        byChampion: $422ee4e31ec4eecd$var$byChampionEq
    }
};



var $7uCHH = parcelRequire("7uCHH");

var $k6yCu = parcelRequire("k6yCu");

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $3a4Bg = parcelRequire("3a4Bg");
const $5f1b0f127434cc95$var$e = (0, $3a4Bg.createEnum)('W', 'L', 'N');
const $5f1b0f127434cc95$export$4584bab0cdf7c506 = $5f1b0f127434cc95$var$e;



var $3a4Bg = parcelRequire("3a4Bg");
const $1a06604f3d4260d5$export$254129c6bcc47359 = (0, $3a4Bg.createEnum)('I', 'II', 'III', 'IV');



var $l8OHp = parcelRequire("l8OHp");
const $de408bd4ef972717$var$codec = $7uCHH.struct({
    currentSplit: (0, $9ddGv.Maybe).codec($7uCHH.struct({
        tier: (0, $l8OHp.LeagueTier).codec,
        rank: (0, $1a06604f3d4260d5$export$254129c6bcc47359).codec,
        leaguePoints: $7uCHH.number,
        wins: $7uCHH.number,
        losses: $7uCHH.number,
        miniSeriesProgress: (0, $9ddGv.Maybe).codec((0, $9ddGv.NonEmptyArray).codec((0, $5f1b0f127434cc95$export$4584bab0cdf7c506).codec))
    })),
    // poro
    previousSplit: (0, $9ddGv.Maybe).codec($7uCHH.struct({
        tier: (0, $l8OHp.LeagueTier).codec,
        rank: (0, $1a06604f3d4260d5$export$254129c6bcc47359).codec
    }))
});
const $de408bd4ef972717$export$d2c14bcabfcb358c = {
    codec: $de408bd4ef972717$var$codec
};


const $1893979b11fc029b$var$properties = {
    soloDuo: (0, $de408bd4ef972717$export$d2c14bcabfcb358c).codec,
    flex: (0, $de408bd4ef972717$export$d2c14bcabfcb358c).codec
};
const $1893979b11fc029b$var$codec = $7uCHH.struct($1893979b11fc029b$var$properties);
const $1893979b11fc029b$var$keys = (0, $k6yCu.DictUtils).keys($1893979b11fc029b$var$properties);
const $1893979b11fc029b$export$34d6dd1c63e72828 = {
    codec: $1893979b11fc029b$var$codec,
    keys: $1893979b11fc029b$var$keys
};



var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $appXD = parcelRequire("appXD");

var $hFHAv = parcelRequire("hFHAv");

var $7pd72 = parcelRequire("7pd72");
const $843d038a4018d874$var$codec = $7uCHH.struct({
    puuid: (0, $7pd72.Puuid).codec,
    riotId: (0, $appXD.RiotId).fromStringCodec,
    name: (0, $9ddGv.Maybe).codec((0, $hFHAv.SummonerName).codec),
    profileIconId: $7uCHH.number,
    summonerLevel: $7uCHH.number
});
const $843d038a4018d874$export$270856858defe778 = {
    codec: $843d038a4018d874$var$codec
};


const $e6b38fa586ac4361$var$codec = $7uCHH.struct({
    summoner: (0, $843d038a4018d874$export$270856858defe778).codec,
    leagues: (0, $1893979b11fc029b$export$34d6dd1c63e72828).codec,
    masteries: $7uCHH.struct({
        champions: (0, $9ddGv.List).codec((0, $3725f8579c0c2481$export$c891b48931e98110).codec),
        insertedAt: (0, $xJ0AO.DayJsFromISOString).codec,
        cacheDuration: (0, $hPJN4.MsDuration).codec
    }),
    championShards: (0, $9ddGv.Maybe).codec((0, $9ddGv.List).codec((0, $422ee4e31ec4eecd$export$c8017683694e0c17).codec))
});
const $e6b38fa586ac4361$var$Lens = {
    championShards: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('championShards'), (0, $4QCFr).some)
};
const $e6b38fa586ac4361$export$295b25f3552f2c84 = {
    codec: $e6b38fa586ac4361$var$codec,
    Lens: $e6b38fa586ac4361$var$Lens
};



var $9ddGv = parcelRequire("9ddGv");

var $kJ6py = parcelRequire("kJ6py");

var $5N26n = parcelRequire("5N26n");

var $lMH1q = parcelRequire("lMH1q");

var $2Yib7 = parcelRequire("2Yib7");

var $hZroh = parcelRequire("hZroh");

var $cmF7r = parcelRequire("cmF7r");

var $2SjoC = parcelRequire("2SjoC");

var $iz2wS = parcelRequire("iz2wS");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $kj6DU = parcelRequire("kj6DU");

var $5zWxO = parcelRequire("5zWxO");

var $exYeM = parcelRequire("exYeM");

var $jVoNn = parcelRequire("jVoNn");
var $7h4Dl = parcelRequire("7h4Dl");

var $cn7Rc = parcelRequire("cn7Rc");

var $hPJN4 = parcelRequire("hPJN4");

var $i92em = parcelRequire("i92em");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");
var $kyy1y = parcelRequire("kyy1y");

var $9ddGv = parcelRequire("9ddGv");

var $hhoaA = parcelRequire("hhoaA");

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $9ddGv = parcelRequire("9ddGv");

var $appXD = parcelRequire("appXD");

var $632HS = parcelRequire("632HS");

var $lfkrA = parcelRequire("lfkrA");

var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $79273afeecdb2db1$var$wrap, unwrap: $79273afeecdb2db1$var$unwrap } = (0, $hp7yq.iso)();
const $79273afeecdb2db1$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $79273afeecdb2db1$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($79273afeecdb2db1$var$unwrap));
const $79273afeecdb2db1$export$96c66196b0b4f739 = (0, $9ddGv.immutableAssign)($79273afeecdb2db1$var$wrap, {
    unwrap: $79273afeecdb2db1$var$unwrap,
    codec: $79273afeecdb2db1$var$codec,
    Eq: $79273afeecdb2db1$var$Eq
});



var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $961cbdbae1c3c6dd$var$wrap, unwrap: $961cbdbae1c3c6dd$var$unwrap } = (0, $hp7yq.iso)();
const $961cbdbae1c3c6dd$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $961cbdbae1c3c6dd$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($961cbdbae1c3c6dd$var$unwrap));
const $961cbdbae1c3c6dd$export$597b42c1d60925a3 = (0, $9ddGv.immutableAssign)($961cbdbae1c3c6dd$var$wrap, {
    codec: $961cbdbae1c3c6dd$var$codec,
    Eq: $961cbdbae1c3c6dd$var$Eq
});


const $a9673f0304825303$var$codec = $7uCHH.struct({
    perkIds: (0, $9ddGv.List).codec((0, $79273afeecdb2db1$export$96c66196b0b4f739).codec),
    perkStyle: (0, $961cbdbae1c3c6dd$export$597b42c1d60925a3).codec,
    perkSubStyle: (0, $961cbdbae1c3c6dd$export$597b42c1d60925a3).codec
});
const $a9673f0304825303$export$97e21419a10fd553 = {
    codec: $a9673f0304825303$var$codec
};




var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $5zWxO = parcelRequire("5zWxO");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $110f7e5c1a405981$var$wrap, unwrap: $110f7e5c1a405981$var$unwrap } = (0, $hp7yq.iso)();
const $110f7e5c1a405981$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $110f7e5c1a405981$var$fromStringCodec = $7uCHH.make((0, $kj6DU.pipe)((0, $xJ0AO.NumberFromString).decoder, $5zWxO.map($110f7e5c1a405981$var$wrap)), {
    encode: String
});
const $110f7e5c1a405981$var$isSmite = (spell)=>$110f7e5c1a405981$var$unwrap(spell) === 11;
const $110f7e5c1a405981$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($110f7e5c1a405981$var$unwrap));
const $110f7e5c1a405981$export$733cfc729a9b57a7 = (0, $9ddGv.immutableAssign)($110f7e5c1a405981$var$wrap, {
    unwrap: $110f7e5c1a405981$var$unwrap,
    codec: $110f7e5c1a405981$var$codec,
    fromStringCodec: $110f7e5c1a405981$var$fromStringCodec,
    isSmite: $110f7e5c1a405981$var$isSmite,
    Eq: $110f7e5c1a405981$var$Eq
});



var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $7uCHH = parcelRequire("7uCHH");
const $b7a0406f7f20009e$var$codec = $7uCHH.struct({
    championLevel: $7uCHH.number,
    championPoints: $7uCHH.number,
    championPointsSinceLastLevel: $7uCHH.number,
    championPointsUntilNextLevel: $7uCHH.number,
    tokensEarned: $7uCHH.number,
    markRequiredForNextLevel: $7uCHH.number
});
const $b7a0406f7f20009e$export$790a5df3f4508560 = {
    codec: $b7a0406f7f20009e$var$codec
};


const $8912fa8f5cb1ab15$var$codec = $7uCHH.struct({
    questPercents: $7uCHH.number,
    totalMasteryLevel: $7uCHH.number,
    totalMasteryPoints: $7uCHH.number,
    otpIndex: $7uCHH.number,
    champion: (0, $9ddGv.Maybe).codec((0, $b7a0406f7f20009e$export$790a5df3f4508560).codec)
});
const $8912fa8f5cb1ab15$export$250ea29fceec4561 = {
    codec: $8912fa8f5cb1ab15$var$codec
};



var $7uCHH = parcelRequire("7uCHH");

var $3a4Bg = parcelRequire("3a4Bg");
const $f547bc8dbe38f2f3$export$6330c36b36a471b6 = (0, $3a4Bg.createEnum)(-1, 0, 1, 2);


const $686ffe4b4802fc3b$var$codec = $7uCHH.struct({
    niceness: (0, $f547bc8dbe38f2f3$export$6330c36b36a471b6).codec,
    label: $7uCHH.string,
    tooltip: $7uCHH.string
});
const $686ffe4b4802fc3b$export$b2fed4ed588653e8 = {
    codec: $686ffe4b4802fc3b$var$codec
};


const $11932b1fd95b0eeb$var$codec = $7uCHH.struct({
    riotId: (0, $9ddGv.Maybe).codec((0, $appXD.RiotId).fromStringCodec),
    profileIconId: $7uCHH.number,
    leagues: (0, $9ddGv.Maybe).codec((0, $1893979b11fc029b$export$34d6dd1c63e72828).codec),
    championId: (0, $632HS.ChampionKey).codec,
    masteries: (0, $9ddGv.Maybe).codec((0, $8912fa8f5cb1ab15$export$250ea29fceec4561).codec),
    shardsCount: (0, $9ddGv.Maybe).codec($7uCHH.number),
    spell1Id: (0, $110f7e5c1a405981$export$733cfc729a9b57a7).codec,
    spell2Id: (0, $110f7e5c1a405981$export$733cfc729a9b57a7).codec,
    perks: (0, $9ddGv.Maybe).codec((0, $a9673f0304825303$export$97e21419a10fd553).codec),
    // poro
    premadeId: (0, $9ddGv.Maybe).codec($7uCHH.number),
    summonerLevel: (0, $9ddGv.Maybe).codec($7uCHH.number),
    championRankedStats: (0, $9ddGv.Maybe).codec($7uCHH.struct({
        wins: $7uCHH.number,
        losses: $7uCHH.number,
        kills: $7uCHH.number,
        deaths: $7uCHH.number,
        assists: $7uCHH.number
    })),
    role: (0, $9ddGv.Maybe).codec((0, $lfkrA.ChampionPosition).codec),
    mainRoles: (0, $9ddGv.List).codec((0, $lfkrA.ChampionPosition).codec),
    tags: (0, $9ddGv.List).codec((0, $686ffe4b4802fc3b$export$b2fed4ed588653e8).codec)
});
const $11932b1fd95b0eeb$var$Lens = {
    shardsCount: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('shardsCount'))
};
const $11932b1fd95b0eeb$export$31eb4e888063c573 = {
    codec: $11932b1fd95b0eeb$var$codec,
    Lens: $11932b1fd95b0eeb$var$Lens
};



var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $632HS = parcelRequire("632HS");
const $32a228ec9ede1dc6$var$codec = $7uCHH.struct({
    pickTurn: $7uCHH.number,
    championId: (0, $9ddGv.Maybe).codec((0, $632HS.ChampionKey).codec)
});
const $32a228ec9ede1dc6$var$empty = {
    pickTurn: -1,
    championId: (0, $9ddGv.Maybe).none
};
const $32a228ec9ede1dc6$export$2ebb7b938507b895 = {
    codec: $32a228ec9ede1dc6$var$codec,
    empty: $32a228ec9ede1dc6$var$empty
};


const $93fc9cbc4116e450$var$bannedChampionsProperties = {
    100: (0, $9ddGv.NonEmptyArray).codec((0, $32a228ec9ede1dc6$export$2ebb7b938507b895).codec),
    200: (0, $9ddGv.NonEmptyArray).codec((0, $32a228ec9ede1dc6$export$2ebb7b938507b895).codec)
};
const $93fc9cbc4116e450$var$participantsProperties = {
    100: (0, $9ddGv.NonEmptyArray).codec((0, $11932b1fd95b0eeb$export$31eb4e888063c573).codec),
    200: (0, $9ddGv.NonEmptyArray).codec((0, $11932b1fd95b0eeb$export$31eb4e888063c573).codec)
};
const $93fc9cbc4116e450$var$codec = $7uCHH.struct({
    gameStartTime: (0, $9ddGv.Maybe).codec((0, $xJ0AO.DayJsFromISOString).codec),
    /** MapId */ mapId: $7uCHH.number,
    /** GameMode */ gameMode: $7uCHH.string,
    /** GameQueue */ gameQueueConfigId: $7uCHH.number,
    isDraft: $7uCHH.boolean,
    bannedChampions: $7uCHH.readonly($7uCHH.partial($93fc9cbc4116e450$var$bannedChampionsProperties)),
    participants: $7uCHH.readonly($7uCHH.partial($93fc9cbc4116e450$var$participantsProperties)),
    isPoroOK: $7uCHH.boolean
});
const $93fc9cbc4116e450$export$d949d84c708ca152 = {
    codec: $93fc9cbc4116e450$var$codec
};


const $e6281be3d74c9d26$var$codec = $7uCHH.struct({
    summoner: (0, $hhoaA.SummonerShort).codec,
    game: (0, $9ddGv.Maybe).codec((0, $93fc9cbc4116e450$export$d949d84c708ca152).codec)
});
const $e6281be3d74c9d26$var$Lens = {
    game: {
        participants: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('game'), (0, $4QCFr).some, (0, $kyy1y).prop('participants'))
    }
};
const $e6281be3d74c9d26$export$8609024c4106d527 = {
    codec: $e6281be3d74c9d26$var$codec,
    Lens: $e6281be3d74c9d26$var$Lens
};



var $9ddGv = parcelRequire("9ddGv");

var $2Yib7 = parcelRequire("2Yib7");

var $lQ3eP = parcelRequire("lQ3eP");

var $fviO3 = parcelRequire("fviO3");
const $290caf74bcd3a18a$var$timeout = (0, $hPJN4.MsDuration).minute(1);
function $290caf74bcd3a18a$export$1432bee435d2d13b(lang, platform, riotId) {
    const { mutate: mutate } = (0, $7h4Dl.useSWRConfig)();
    const { historyStateRef: historyStateRef, modifyHistoryStateRef: modifyHistoryStateRef } = (0, $2Yib7.useHistory)();
    const key = (0, $cn7Rc.apiRoutes).summoner.byRiotId(platform)(riotId).activeGame(lang).get;
    const res = (0, $jVoNn.default)(key, ([url, method])=>(0, $kj6DU.pipe)(historyStateRef.current.game, (0, $9ddGv.Maybe).fold(()=>(0, $fviO3.http)([
                url,
                method
            ], {
                timeout: $290caf74bcd3a18a$var$timeout
            }, $290caf74bcd3a18a$export$9e6b371f9e8e5333), (0, $kj6DU.flow)((0, $9ddGv.Future).successful, (0, $9ddGv.Future).chainFirstIOK(()=>()=>modifyHistoryStateRef((0, $2Yib7.HistoryState).Lens.game.set((0, $9ddGv.Maybe).none))), (0, $9ddGv.Future).map((game)=>(0, $i92em.ValidatedSoft)(game)))), (0, $lQ3eP.futureRunUnsafe)), {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    $290caf74bcd3a18a$export$d2fa983f8fa4372a(res.data?.errors);
    return {
        ...res,
        data: res.data?.value,
        mutate: (0, $exYeM.useCallback)((data, opts)=>mutate(key, data, opts), // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...key,
            mutate
        ])
    };
}
const $290caf74bcd3a18a$export$9e6b371f9e8e5333 = (0, $9ddGv.Tuple).of((0, $i92em.ValidatedSoft).decoder((0, $e6281be3d74c9d26$export$8609024c4106d527).codec, $5zWxO.string), 'ValidatedSoft<SummonerActiveGameView, string>');
function $290caf74bcd3a18a$export$d2fa983f8fa4372a(errors) {
    (0, $exYeM.useEffect)(()=>{
        if (errors !== undefined && (0, $9ddGv.List).isNonEmpty(errors)) console.error((0, $9ddGv.List).mkString('Game errors:\n- ', '\n- ', '\n')(errors));
    }, [
        errors
    ]);
}


const $f8bfad20417c4ba9$export$689d97825c9414dc = ({ platform: platform, puuid: puuid })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
            ...(0, $cmF7r.useSWRHttp)((0, $cn7Rc.apiRoutes).summoner.byPuuid(platform)(puuid).masteries.get, {}, [
                (0, $e6b38fa586ac4361$export$295b25f3552f2c84).codec,
                'SummonerMasteriesView'
            ]),
            children: (masteries)=>/*#__PURE__*/ (0, $aSiaI.jsx)($f8bfad20417c4ba9$var$SummonerByProfileLoaded, {
                    platform: platform,
                    masteries: masteries
                })
        })
    });
const $f8bfad20417c4ba9$export$af8896da5ab9f805 = ({ platform: platform, puuid: puuid })=>{
    const { lang: lang } = (0, $hZroh.useTranslation)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
            ...(0, $cmF7r.useSWRHttp)((0, $cn7Rc.apiRoutes).summoner.byPuuid(platform)(puuid).activeGame(lang).get, {}, (0, $290caf74bcd3a18a$export$9e6b371f9e8e5333)),
            children: (data)=>/*#__PURE__*/ (0, $aSiaI.jsx)($f8bfad20417c4ba9$var$SummonerByGameLoaded, {
                    platform: platform,
                    data: data
                })
        })
    });
};
const $f8bfad20417c4ba9$var$SummonerByProfileLoaded = ({ platform: platform, masteries: masteries })=>{
    const { modifyHistoryStateRef: modifyHistoryStateRef, masteriesQuery: masteriesQuery } = (0, $2Yib7.useHistory)();
    (0, $exYeM.useEffect)(()=>{
        modifyHistoryStateRef((0, $2Yib7.HistoryState).Lens.masteries.set((0, $9ddGv.Maybe).some(masteries)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5N26n.Navigate), {
        to: (0, $iz2wS.appRoutes).platformRiotId(platform, masteries.summoner.riotId, (0, $2SjoC.MasteriesQuery).toPartial(masteriesQuery)),
        replace: true
    });
};
const $f8bfad20417c4ba9$var$SummonerByGameLoaded = ({ platform: platform, data: data })=>{
    const game = data.value;
    (0, $290caf74bcd3a18a$export$d2fa983f8fa4372a)(data.errors);
    const { modifyHistoryStateRef: modifyHistoryStateRef } = (0, $2Yib7.useHistory)();
    (0, $exYeM.useEffect)(()=>{
        modifyHistoryStateRef((0, $2Yib7.HistoryState).Lens.game.set((0, $9ddGv.Maybe).some(game)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5N26n.Navigate), {
        to: (0, $iz2wS.appRoutes).platformRiotIdGame(platform, game.summoner.riotId),
        replace: true
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $cn7Rc = parcelRequire("cn7Rc");

var $9RyKW = parcelRequire("9RyKW");
var $cF6yJ = parcelRequire("cF6yJ");

var $kj6DU = parcelRequire("kj6DU");

var $7uCHH = parcelRequire("7uCHH");

var $hp7yq = parcelRequire("hp7yq");

var $9ddGv = parcelRequire("9ddGv");

var $xJ0AO = parcelRequire("xJ0AO");
const { wrap: $75ec77282a60aec4$var$wrap, unwrap: $75ec77282a60aec4$var$unwrap } = (0, $hp7yq.iso)();
const $75ec77282a60aec4$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.number);
const $75ec77282a60aec4$var$Eq = (0, $kj6DU.pipe)((0, $cF6yJ).Eq, (0, $9RyKW).contramap($75ec77282a60aec4$var$unwrap));
const $75ec77282a60aec4$export$43ac25706d3b5d4a = (0, $9ddGv.immutableAssign)($75ec77282a60aec4$var$wrap, {
    unwrap: $75ec77282a60aec4$var$unwrap,
    codec: $75ec77282a60aec4$var$codec,
    Eq: $75ec77282a60aec4$var$Eq
});



var $lfkrA = parcelRequire("lfkrA");


var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");

var $iNmEk = parcelRequire("iNmEk");

var $7uCHH = parcelRequire("7uCHH");

const $607322c69bcf11a7$var$codec = $7uCHH.struct({
    id: (0, $75ec77282a60aec4$export$43ac25706d3b5d4a).codec,
    name: $7uCHH.string,
    description: $7uCHH.string,
    plaintext: $7uCHH.string,
    image: $7uCHH.string
});
const $607322c69bcf11a7$export$5d8566322c77991f = {
    codec: $607322c69bcf11a7$var$codec
};



var $7uCHH = parcelRequire("7uCHH");

const $b1fd4a769a4676e2$var$codec = $7uCHH.struct({
    id: (0, $79273afeecdb2db1$export$96c66196b0b4f739).codec,
    name: $7uCHH.string,
    longDesc: $7uCHH.string,
    iconPath: $7uCHH.string
});
const $b1fd4a769a4676e2$export$49b18f1aa22c1e57 = {
    codec: $b1fd4a769a4676e2$var$codec
};



var $7uCHH = parcelRequire("7uCHH");

var $9ddGv = parcelRequire("9ddGv");


const $6b24919122062b79$var$codec = $7uCHH.struct({
    id: (0, $961cbdbae1c3c6dd$export$597b42c1d60925a3).codec,
    icon: $7uCHH.string,
    name: $7uCHH.string,
    slots: (0, $9ddGv.List).codec($7uCHH.struct({
        runes: (0, $9ddGv.List).codec((0, $79273afeecdb2db1$export$96c66196b0b4f739).codec)
    }))
});
const $6b24919122062b79$export$4ef9a04ed09bb111 = {
    codec: $6b24919122062b79$var$codec
};



var $7uCHH = parcelRequire("7uCHH");

var $7uCHH = parcelRequire("7uCHH");

var $xJ0AO = parcelRequire("xJ0AO");
const $4e0b5a41937ea67e$var$codec = (0, $xJ0AO.fromNewtype)($7uCHH.string);
const $4e0b5a41937ea67e$export$18b673513e92ca23 = {
    codec: $4e0b5a41937ea67e$var$codec
};



const $3de55118d74c08d3$var$codec = $7uCHH.struct({
    id: (0, $4e0b5a41937ea67e$export$18b673513e92ca23).codec,
    key: (0, $110f7e5c1a405981$export$733cfc729a9b57a7).codec,
    name: $7uCHH.string,
    description: $7uCHH.string,
    cooldown: $7uCHH.number
});
const $3de55118d74c08d3$export$67dfffeeeae52312 = {
    codec: $3de55118d74c08d3$var$codec
};


const $d235b3ad729c7838$var$codec = $7uCHH.struct({
    version: (0, $iNmEk.DDragonVersion).codec,
    summonerSpells: (0, $9ddGv.List).codec((0, $3de55118d74c08d3$export$67dfffeeeae52312).codec),
    runeStyles: (0, $9ddGv.List).codec((0, $6b24919122062b79$export$4ef9a04ed09bb111).codec),
    runes: (0, $9ddGv.List).codec((0, $b1fd4a769a4676e2$export$49b18f1aa22c1e57).codec),
    items: (0, $9ddGv.List).codec((0, $607322c69bcf11a7$export$5d8566322c77991f).codec)
});
const $d235b3ad729c7838$export$94540228b78a751e = {
    codec: $d235b3ad729c7838$var$codec
};




var $javAY = parcelRequire("javAY");

var $9ddGv = parcelRequire("9ddGv");

var $kJ6py = parcelRequire("kJ6py");

/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");



var $9ddGv = parcelRequire("9ddGv");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $52dbH = parcelRequire("52dbH");

var $hZroh = parcelRequire("hZroh");

var $1sXco = parcelRequire("1sXco");
const $34b3a579085a2719$var$base = (0, $52dbH.DDragonUtils).ddragon('/cdn/img/');
const $34b3a579085a2719$export$dd4e3679fae405b5 = ({ icon: icon, name: name, description: description, tooltipShouldHide: tooltipShouldHide, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                ref: ref,
                src: `${$34b3a579085a2719$var$base}${icon}`,
                alt: t.runeIconAlt(name),
                className: className
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                shouldHide: tooltipShouldHide,
                className: "flex max-w-xs flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "font-bold",
                        children: name
                    }),
                    description !== undefined && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: description
                        },
                        className: "whitespace-normal"
                    })
                ]
            })
        ]
    });
};



var $1sXco = parcelRequire("1sXco");
const $4c07dd73d95864fa$export$e3b0796a61ebb801 = {
    id: (0, $79273afeecdb2db1$export$96c66196b0b4f739)(8347),
    haste: 18
};
const $4c07dd73d95864fa$var$ionianBootsOfLucidity = {
    id: (0, $75ec77282a60aec4$export$43ac25706d3b5d4a)(3158),
    haste: 10
};
const $4c07dd73d95864fa$var$crimsonLucidity = {
    id: (0, $75ec77282a60aec4$export$43ac25706d3b5d4a)(3171),
    haste: 20
};
const $4c07dd73d95864fa$export$14b1c0db81189f0d = ({ runeById: runeById, itemById: itemById, totalHaste: totalHaste, onToggle: onToggle, cosmicInsightDefaultChecked: cosmicInsightDefaultChecked = false, cosmicInsightDisabled: cosmicInsightDisabled = false, canBuyCrimsonLucidity: canBuyCrimsonLucidity, size: size = 'large', className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const isSmall = size === 'small';
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                ref: ref,
                className: (0, $5MBh5.cx)('flex gap-2', className),
                children: [
                    (0, $kj6DU.pipe)(runeById($4c07dd73d95864fa$export$e3b0796a61ebb801.id), (0, $9ddGv.Maybe).fold(()=>null, (rune)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$RuneBonusCheckbox, {
                            defaultChecked: cosmicInsightDefaultChecked,
                            haste: $4c07dd73d95864fa$export$e3b0796a61ebb801.haste,
                            rune: rune,
                            onToggle: onToggle,
                            disabled: cosmicInsightDisabled,
                            isSmall: isSmall
                        }))),
                    (0, $kj6DU.pipe)(itemById($4c07dd73d95864fa$var$ionianBootsOfLucidity.id), (0, $9ddGv.Maybe).fold(()=>null, (baseItem)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$BootsBonusRadio, {
                            baseHaste: $4c07dd73d95864fa$var$ionianBootsOfLucidity.haste,
                            baseItem: baseItem,
                            upgradedHaste: $4c07dd73d95864fa$var$crimsonLucidity.haste,
                            upgradedItem: (0, $kj6DU.pipe)(itemById($4c07dd73d95864fa$var$crimsonLucidity.id), (0, $9ddGv.Maybe).filter(()=>canBuyCrimsonLucidity)),
                            onToggle: onToggle,
                            isSmall: isSmall
                        })))
                ]
            }),
            totalHaste !== undefined && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                placement: "top",
                children: t.totalHaste(totalHaste)
            })
        ]
    });
};
const $4c07dd73d95864fa$var$RuneBonusCheckbox = ({ defaultChecked: defaultChecked, haste: haste, rune: rune, onToggle: onToggle, disabled: disabled, isSmall: isSmall })=>{
    const [checked, setChecked] = (0, $exYeM.useState)(false);
    const onChange = (0, $exYeM.useCallback)(()=>{
        if (checked) {
            onToggle(-haste);
            setChecked(false);
        } else {
            onToggle(haste);
            setChecked(true);
        }
    }, [
        checked,
        haste,
        onToggle
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (defaultChecked) onChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // only on mount
    ;
    const id = (0, $exYeM.useId)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                type: "checkbox",
                id: id,
                checked: checked,
                onChange: onChange,
                disabled: disabled,
                className: "peer sr-only"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$Label, {
                htmlFor: id,
                isSmall: isSmall,
                crossedOut: !checked,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $34b3a579085a2719$export$dd4e3679fae405b5), {
                    icon: rune.iconPath,
                    name: rune.name,
                    description: rune.longDesc,
                    className: "w-full"
                })
            })
        ]
    });
};
const $4c07dd73d95864fa$var$radioStateValues = [
    'none',
    'base',
    'upgraded'
];
const $4c07dd73d95864fa$var$BootsBonusRadio = ({ baseHaste: baseHaste, baseItem: baseItem, upgradedHaste: upgradedHaste, upgradedItem: upgradedItem, onToggle: onToggle, isSmall: isSmall })=>{
    const [value, setValue] = (0, $exYeM.useState)('none');
    const onClick = (0, $exYeM.useCallback)(()=>{
        switch(value){
            case 'none':
                onToggle(baseHaste);
                return setValue('base');
            case 'base':
                if ((0, $9ddGv.Maybe).isSome(upgradedItem)) {
                    onToggle(-baseHaste + upgradedHaste);
                    return setValue('upgraded');
                }
                onToggle(-baseHaste);
                return setValue('none');
            case 'upgraded':
                onToggle(-upgradedHaste);
                return setValue('none');
            default:
                (0, $9ddGv.assertUnreachable)(value);
        }
    }, [
        baseHaste,
        onToggle,
        upgradedHaste,
        upgradedItem,
        value
    ]);
    const id = (0, $exYeM.useId)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
        className: "flex",
        children: [
            $4c07dd73d95864fa$var$radioStateValues.map((val)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$Radio, {
                    name: "hastBoots",
                    id: `${id}-${val}`,
                    value: val,
                    setValue: setValue,
                    isChecked: val === value
                }, val)),
            /*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$Label, {
                htmlFor: `${id}-${value}`,
                isSmall: isSmall,
                crossedOut: value === 'none',
                onClick: onClick,
                children: (0, $kj6DU.pipe)(upgradedItem, (0, $9ddGv.Maybe).filter(()=>value === 'upgraded'), (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$Item, {
                        item: baseItem
                    }), (upgraded)=>/*#__PURE__*/ (0, $aSiaI.jsx)($4c07dd73d95864fa$var$Item, {
                        item: upgraded
                    })))
            })
        ]
    });
};
function $4c07dd73d95864fa$var$Radio({ name: name, id: id, value: value, setValue: setValue, isChecked: isChecked }) {
    const onChange = (0, $exYeM.useCallback)(()=>setValue(value), [
        setValue,
        value
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
        type: "radio",
        name: name,
        id: id,
        value: value,
        checked: isChecked,
        onChange: onChange,
        className: "peer sr-only" // peer enabled cursor pointer below
    });
}
const $4c07dd73d95864fa$var$Item = ({ item: item })=>{
    const { assets: assets } = (0, $fcoXO.useStaticData)();
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                ref: ref,
                src: assets.item(item.id),
                alt: item.name,
                className: "w-full"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                className: "flex max-w-xs flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "font-bold",
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "whitespace-break-spaces",
                        children: item.plaintext
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        },
                        className: "whitespace-normal"
                    })
                ]
            })
        ]
    });
};
const $4c07dd73d95864fa$var$Label = ({ htmlFor: htmlFor, isSmall: isSmall, crossedOut: crossedOut, onClick: onClick, children: children })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("label", {
        htmlFor: htmlFor,
        // prevent drag and drop in parents
        onPointerDown: $4c07dd73d95864fa$var$stopPropagation,
        onClick: onClick,
        className: (0, $5MBh5.cx)('relative flex overflow-hidden bg-black peer-enabled:cursor-pointer', isSmall ? 'w-7' : 'w-10'),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: crossedOut ? 'opacity-60' : undefined,
                children: children
            }),
            crossedOut && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "absolute top-[calc(100%_-_0.125rem)] w-20 origin-left -rotate-45 border-t-4 border-red-ban shadow-even shadow-black"
            })
        ]
    });
function $4c07dd73d95864fa$var$stopPropagation(e) {
    e.stopPropagation();
}


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $7wIl1 = parcelRequire("7wIl1");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");

var $1sXco = parcelRequire("1sXco");
const $613f1c447f9abb4e$export$10199abf042bcb34 = ({ spell: spell, haste: haste = 0, tooltipShouldHide: tooltipShouldHide, className: className, timerClassName: timerClassName })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { assets: assets } = (0, $fcoXO.useStaticData)();
    // https://wiki.leagueoflegends.com/en-us/Haste#Formula
    const cooldown = spell.cooldown * (100 / (100 + haste));
    const ref = (0, $exYeM.useRef)(null);
    const intervalId = (0, $exYeM.useRef)();
    function clearInterval() {
        window.clearInterval(intervalId.current);
    }
    // clearInterval on unmount
    (0, $exYeM.useEffect)(()=>clearInterval, []);
    const [remainingSeconds, setRemainingSeconds] = (0, $exYeM.useState)();
    const onClick = (0, $exYeM.useCallback)(()=>{
        if (intervalId.current !== undefined) window.clearInterval(intervalId.current);
        if (remainingSeconds === undefined) {
            // eslint-disable-next-line functional/immutable-data
            intervalId.current = window.setInterval(()=>{
                setRemainingSeconds((n)=>{
                    if (n === undefined) return n;
                    const newN = n - 1;
                    if (newN <= 0) {
                        clearInterval();
                        return undefined;
                    }
                    return newN;
                });
            }, 1000);
            setRemainingSeconds(cooldown);
        } else setRemainingSeconds(undefined);
    }, [
        remainingSeconds,
        cooldown
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                ref: ref,
                type: "button",
                onClick: onClick,
                // prevent drag and drop in parents
                onPointerDown: $613f1c447f9abb4e$var$stopPropagation,
                className: (0, $5MBh5.cx)('relative grid place-items-center', className),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: assets.summonerSpell(spell.id),
                        alt: t.spellIconAlt(spell.name),
                        className: "size-full area-1"
                    }),
                    remainingSeconds !== undefined && /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: (0, $5MBh5.cx)('grid size-full place-items-center bg-black/50 font-lib-mono text-white shadow-black area-1 text-shadow', timerClassName),
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            className: "-mx-96 area-1",
                            children: (0, $7wIl1.DayJs).Duration.formatSeconds(remainingSeconds)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                shouldHide: tooltipShouldHide,
                className: "grid max-w-xs grid-cols-[auto_auto] gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "font-bold",
                        children: spell.name
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "justify-self-end",
                        children: t.cooldownSeconds(cooldown, 'text-goldenrod')
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "col-span-2 whitespace-normal",
                        children: spell.description
                    })
                ]
            })
        ]
    });
};
function $613f1c447f9abb4e$var$stopPropagation(e) {
    e.stopPropagation();
}



var $lMH1q = parcelRequire("lMH1q");

var $hZroh = parcelRequire("hZroh");

var $cmF7r = parcelRequire("cmF7r");
const $57b1d54e96073335$var$cleanse = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(1);
const $57b1d54e96073335$var$exhaust = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(3);
const $57b1d54e96073335$var$flash = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(4);
const $57b1d54e96073335$var$ghost = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(6);
const $57b1d54e96073335$var$heal = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(7);
const $57b1d54e96073335$var$smite = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(11);
const $57b1d54e96073335$var$teleport = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(12);
const $57b1d54e96073335$var$ignite = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(14);
const $57b1d54e96073335$var$barrier = (0, $110f7e5c1a405981$export$733cfc729a9b57a7)(21);
const $57b1d54e96073335$var$normalSpells = new Set([
    $57b1d54e96073335$var$flash,
    $57b1d54e96073335$var$teleport,
    $57b1d54e96073335$var$ignite,
    $57b1d54e96073335$var$barrier,
    $57b1d54e96073335$var$heal,
    $57b1d54e96073335$var$ghost,
    $57b1d54e96073335$var$exhaust,
    $57b1d54e96073335$var$cleanse
]);
const $57b1d54e96073335$var$junSpells = new Set([
    ...$57b1d54e96073335$var$normalSpells,
    $57b1d54e96073335$var$smite
]);
const $57b1d54e96073335$export$8bb2c1fb2b1765a9 = ()=>{
    const { lang: lang } = (0, $hZroh.useTranslation)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
            ...(0, $cmF7r.useSWRHttp)((0, $cn7Rc.apiRoutes).staticData(lang).additional.get, {}, [
                (0, $d235b3ad729c7838$export$94540228b78a751e).codec,
                'AdditionalStaticData'
            ]),
            children: (additionalStaticData)=>/*#__PURE__*/ (0, $aSiaI.jsx)($57b1d54e96073335$var$Loaded, {
                    additionalStaticData: additionalStaticData
                })
        })
    });
};
const $57b1d54e96073335$var$Loaded = ({ additionalStaticData: additionalStaticData })=>{
    const summonerSpellByKey = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.summonerSpells, (0, $javAY.ListUtils).findFirstBy((0, $110f7e5c1a405981$export$733cfc729a9b57a7).Eq)((s)=>s.key)), [
        additionalStaticData.summonerSpells
    ]);
    const runeById = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.runes, (0, $javAY.ListUtils).findFirstBy((0, $79273afeecdb2db1$export$96c66196b0b4f739).Eq)((r)=>r.id)), [
        additionalStaticData.runes
    ]);
    const itemById = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.items, (0, $javAY.ListUtils).findFirstBy((0, $75ec77282a60aec4$export$43ac25706d3b5d4a).Eq)((i)=>i.id)), [
        additionalStaticData.items
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "grid min-h-full place-items-center",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
            className: "flex flex-col gap-5",
            children: (0, $lfkrA.ChampionPosition).values.map((position)=>/*#__PURE__*/ (0, $aSiaI.jsx)($57b1d54e96073335$var$Position, {
                    runeById: runeById,
                    itemById: itemById,
                    position: position,
                    spells: position === 'jun' ? $57b1d54e96073335$var$junSpells : $57b1d54e96073335$var$normalSpells,
                    summonerSpellByKey: summonerSpellByKey
                }, position))
        })
    });
};
const $57b1d54e96073335$var$Position = ({ runeById: runeById, itemById: itemById, position: position, spells: spells, summonerSpellByKey: summonerSpellByKey })=>{
    const [totalHaste, setTotalHaste] = (0, $exYeM.useState)(0);
    const onToggleHaste = (0, $exYeM.useCallback)((addHaste)=>setTotalHaste((h)=>h + addHaste), []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
        className: "flex items-center gap-5",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4c07dd73d95864fa$export$14b1c0db81189f0d), {
                runeById: runeById,
                itemById: itemById,
                totalHaste: totalHaste,
                onToggle: onToggleHaste,
                canBuyCrimsonLucidity: position === 'mid'
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $62c858348d1b2db2$export$12e8b9f23d53a496), {
                position: position,
                className: "size-12"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                className: "flex gap-3",
                children: (0, $kj6DU.pipe)(Array.from(spells), (0, $9ddGv.List).filterMap((0, $kj6DU.flow)(summonerSpellByKey, (0, $9ddGv.Maybe).map((spell)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $613f1c447f9abb4e$export$10199abf042bcb34), {
                            spell: spell,
                            haste: totalHaste,
                            className: "w-16 overflow-hidden rounded-lg",
                            timerClassName: "text-2xl bg-black/60"
                        })
                    }, (0, $110f7e5c1a405981$export$733cfc729a9b57a7).unwrap(spell.key))))))
            })
        ]
    });
};



const $bc596a9ae38c2493$export$8f34c1ae61107b83 = (0, $ad291ea4f23077af$export$7cf138d016f88fdb)('http://wiki.leagueoflegends.com/en-us/Ultra_Rapid_Fire#Mode-Specific_Changes', (c)=>c.urf);


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");
parcelRequire("lr3g3");
var $dGJql = parcelRequire("dGJql");
function $9c93f61d2741ec13$var$clamp(v, min, max) {
    return Math.max(min, Math.min(v, max));
}
const $9c93f61d2741ec13$export$e7c866399fa523f5 = {
    toVector (v, fallback) {
        if (v === undefined) v = fallback;
        return Array.isArray(v) ? v : [
            v,
            v
        ];
    },
    add (v1, v2) {
        return [
            v1[0] + v2[0],
            v1[1] + v2[1]
        ];
    },
    sub (v1, v2) {
        return [
            v1[0] - v2[0],
            v1[1] - v2[1]
        ];
    },
    addTo (v1, v2) {
        v1[0] += v2[0];
        v1[1] += v2[1];
    },
    subTo (v1, v2) {
        v1[0] -= v2[0];
        v1[1] -= v2[1];
    }
};
function $9c93f61d2741ec13$var$rubberband(distance, dimension, constant) {
    if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, constant * 5);
    return distance * dimension * constant / (dimension + constant * distance);
}
function $9c93f61d2741ec13$export$43caf9889c228507(position, min, max, constant = 0.15) {
    if (constant === 0) return $9c93f61d2741ec13$var$clamp(position, min, max);
    if (position < min) return -$9c93f61d2741ec13$var$rubberband(min - position, max - min, constant) + min;
    if (position > max) return +$9c93f61d2741ec13$var$rubberband(position - max, max - min, constant) + max;
    return position;
}
function $9c93f61d2741ec13$export$db3b6bfb95261072(bounds, [Vx, Vy], [Rx, Ry]) {
    const [[X0, X1], [Y0, Y1]] = bounds;
    return [
        $9c93f61d2741ec13$export$43caf9889c228507(Vx, X0, X1, Rx),
        $9c93f61d2741ec13$export$43caf9889c228507(Vy, Y0, Y1, Ry)
    ];
}


function $632c0fd227832521$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $632c0fd227832521$var$_toPropertyKey(arg) {
    var key = $632c0fd227832521$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $632c0fd227832521$export$407448d2b89b1813(obj, key, value) {
    key = $632c0fd227832521$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $632c0fd227832521$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $632c0fd227832521$export$71511d61b312f219(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $632c0fd227832521$var$ownKeys(Object(t), !0).forEach(function(r) {
            $632c0fd227832521$export$407448d2b89b1813(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $632c0fd227832521$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $632c0fd227832521$var$EVENT_TYPE_MAP = {
    pointer: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    mouse: {
        start: 'down',
        change: 'move',
        end: 'up'
    },
    touch: {
        start: 'start',
        change: 'move',
        end: 'end'
    },
    gesture: {
        start: 'start',
        change: 'change',
        end: 'end'
    }
};
function $632c0fd227832521$var$capitalize(string) {
    if (!string) return '';
    return string[0].toUpperCase() + string.slice(1);
}
const $632c0fd227832521$var$actionsWithoutCaptureSupported = [
    'enter',
    'leave'
];
function $632c0fd227832521$var$hasCapture(capture = false, actionKey) {
    return capture && !$632c0fd227832521$var$actionsWithoutCaptureSupported.includes(actionKey);
}
function $632c0fd227832521$export$4368d992c4eafac0(device, action = '', capture = false) {
    const deviceProps = $632c0fd227832521$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return 'on' + $632c0fd227832521$var$capitalize(device) + $632c0fd227832521$var$capitalize(actionKey) + ($632c0fd227832521$var$hasCapture(capture, actionKey) ? 'Capture' : '');
}
const $632c0fd227832521$var$pointerCaptureEvents = [
    'gotpointercapture',
    'lostpointercapture'
];
function $632c0fd227832521$export$ffb5f4729a158638(prop) {
    let eventKey = prop.substring(2).toLowerCase();
    const passive = !!~eventKey.indexOf('passive');
    if (passive) eventKey = eventKey.replace('passive', '');
    const captureKey = $632c0fd227832521$var$pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
    const capture = !!~eventKey.indexOf(captureKey);
    if (capture) eventKey = eventKey.replace('capture', '');
    return {
        device: eventKey,
        capture: capture,
        passive: passive
    };
}
function $632c0fd227832521$export$625550452a3fa3ec(device, action = '') {
    const deviceProps = $632c0fd227832521$var$EVENT_TYPE_MAP[device];
    const actionKey = deviceProps ? deviceProps[action] || action : action;
    return device + actionKey;
}
function $632c0fd227832521$export$23f2a1d2818174ef(event) {
    return 'touches' in event;
}
function $632c0fd227832521$var$getPointerType(event) {
    if ($632c0fd227832521$export$23f2a1d2818174ef(event)) return 'touch';
    if ('pointerType' in event) return event.pointerType;
    return 'mouse';
}
function $632c0fd227832521$var$getCurrentTargetTouchList(event) {
    return Array.from(event.touches).filter((e)=>{
        var _event$currentTarget, _event$currentTarget$;
        return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
    });
}
function $632c0fd227832521$var$getTouchList(event) {
    return event.type === 'touchend' || event.type === 'touchcancel' ? event.changedTouches : event.targetTouches;
}
function $632c0fd227832521$var$getValueEvent(event) {
    return $632c0fd227832521$export$23f2a1d2818174ef(event) ? $632c0fd227832521$var$getTouchList(event)[0] : event;
}
function $632c0fd227832521$var$distanceAngle(P1, P2) {
    try {
        const dx = P2.clientX - P1.clientX;
        const dy = P2.clientY - P1.clientY;
        const cx = (P2.clientX + P1.clientX) / 2;
        const cy = (P2.clientY + P1.clientY) / 2;
        const distance = Math.hypot(dx, dy);
        const angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
        const origin = [
            cx,
            cy
        ];
        return {
            angle: angle,
            distance: distance,
            origin: origin
        };
    } catch (_unused) {}
    return null;
}
function $632c0fd227832521$export$8b22cf2602fb60ce(event) {
    return $632c0fd227832521$var$getCurrentTargetTouchList(event).map((touch)=>touch.identifier);
}
function $632c0fd227832521$var$touchDistanceAngle(event, ids) {
    const [P1, P2] = Array.from(event.touches).filter((touch)=>ids.includes(touch.identifier));
    return $632c0fd227832521$var$distanceAngle(P1, P2);
}
function $632c0fd227832521$var$pointerId(event) {
    const valueEvent = $632c0fd227832521$var$getValueEvent(event);
    return $632c0fd227832521$export$23f2a1d2818174ef(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function $632c0fd227832521$var$pointerValues(event) {
    const valueEvent = $632c0fd227832521$var$getValueEvent(event);
    return [
        valueEvent.clientX,
        valueEvent.clientY
    ];
}
const $632c0fd227832521$var$LINE_HEIGHT = 40;
const $632c0fd227832521$var$PAGE_HEIGHT = 800;
function $632c0fd227832521$var$wheelValues(event) {
    let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
    if (deltaMode === 1) {
        deltaX *= $632c0fd227832521$var$LINE_HEIGHT;
        deltaY *= $632c0fd227832521$var$LINE_HEIGHT;
    } else if (deltaMode === 2) {
        deltaX *= $632c0fd227832521$var$PAGE_HEIGHT;
        deltaY *= $632c0fd227832521$var$PAGE_HEIGHT;
    }
    return [
        deltaX,
        deltaY
    ];
}
function $632c0fd227832521$var$scrollValues(event) {
    var _ref, _ref2;
    const { scrollX: scrollX, scrollY: scrollY, scrollLeft: scrollLeft, scrollTop: scrollTop } = event.currentTarget;
    return [
        (_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0,
        (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0
    ];
}
function $632c0fd227832521$var$getEventDetails(event) {
    const payload = {};
    if ('buttons' in event) payload.buttons = event.buttons;
    if ('shiftKey' in event) {
        const { shiftKey: shiftKey, altKey: altKey, metaKey: metaKey, ctrlKey: ctrlKey } = event;
        Object.assign(payload, {
            shiftKey: shiftKey,
            altKey: altKey,
            metaKey: metaKey,
            ctrlKey: ctrlKey
        });
    }
    return payload;
}
function $632c0fd227832521$var$call(v, ...args) {
    if (typeof v === 'function') return v(...args);
    else return v;
}
function $632c0fd227832521$var$noop() {}
function $632c0fd227832521$export$db3b6bfb95261072(...fns) {
    if (fns.length === 0) return $632c0fd227832521$var$noop;
    if (fns.length === 1) return fns[0];
    return function() {
        let result;
        for (const fn of fns)result = fn.apply(this, arguments) || result;
        return result;
    };
}
function $632c0fd227832521$var$assignDefault(value, fallback) {
    return Object.assign({}, fallback, value || {});
}
const $632c0fd227832521$var$BEFORE_LAST_KINEMATICS_DELAY = 32;
class $632c0fd227832521$var$Engine {
    constructor(ctrl, args, key){
        this.ctrl = ctrl;
        this.args = args;
        this.key = key;
        if (!this.state) {
            this.state = {};
            this.computeValues([
                0,
                0
            ]);
            this.computeInitial();
            if (this.init) this.init();
            this.reset();
        }
    }
    get state() {
        return this.ctrl.state[this.key];
    }
    set state(state) {
        this.ctrl.state[this.key] = state;
    }
    get shared() {
        return this.ctrl.state.shared;
    }
    get eventStore() {
        return this.ctrl.gestureEventStores[this.key];
    }
    get timeoutStore() {
        return this.ctrl.gestureTimeoutStores[this.key];
    }
    get config() {
        return this.ctrl.config[this.key];
    }
    get sharedConfig() {
        return this.ctrl.config.shared;
    }
    get handler() {
        return this.ctrl.handlers[this.key];
    }
    reset() {
        const { state: state, shared: shared, ingKey: ingKey, args: args } = this;
        shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
        state._step = [
            false,
            false
        ];
        state.intentional = false;
        state._movement = [
            0,
            0
        ];
        state._distance = [
            0,
            0
        ];
        state._direction = [
            0,
            0
        ];
        state._delta = [
            0,
            0
        ];
        state._bounds = [
            [
                -Infinity,
                Infinity
            ],
            [
                -Infinity,
                Infinity
            ]
        ];
        state.args = args;
        state.axis = undefined;
        state.memo = undefined;
        state.elapsedTime = state.timeDelta = 0;
        state.direction = [
            0,
            0
        ];
        state.distance = [
            0,
            0
        ];
        state.overflow = [
            0,
            0
        ];
        state._movementBound = [
            false,
            false
        ];
        state.velocity = [
            0,
            0
        ];
        state.movement = [
            0,
            0
        ];
        state.delta = [
            0,
            0
        ];
        state.timeStamp = 0;
    }
    start(event) {
        const state = this.state;
        const config = this.config;
        if (!state._active) {
            this.reset();
            this.computeInitial();
            state._active = true;
            state.target = event.target;
            state.currentTarget = event.currentTarget;
            state.lastOffset = config.from ? $632c0fd227832521$var$call(config.from, state) : state.offset;
            state.offset = state.lastOffset;
            state.startTime = state.timeStamp = event.timeStamp;
        }
    }
    computeValues(values) {
        const state = this.state;
        state._values = values;
        state.values = this.config.transform(values);
    }
    computeInitial() {
        const state = this.state;
        state._initial = state._values;
        state.initial = state.values;
    }
    compute(event) {
        const { state: state, config: config, shared: shared } = this;
        state.args = this.args;
        let dt = 0;
        if (event) {
            state.event = event;
            if (config.preventDefault && event.cancelable) state.event.preventDefault();
            state.type = event.type;
            shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
            shared.locked = !!document.pointerLockElement;
            Object.assign(shared, $632c0fd227832521$var$getEventDetails(event));
            shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
            dt = event.timeStamp - state.timeStamp;
            state.timeStamp = event.timeStamp;
            state.elapsedTime = state.timeStamp - state.startTime;
        }
        if (state._active) {
            const _absoluteDelta = state._delta.map(Math.abs);
            (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._distance, _absoluteDelta);
        }
        if (this.axisIntent) this.axisIntent(event);
        const [_m0, _m1] = state._movement;
        const [t0, t1] = config.threshold;
        const { _step: _step, values: values } = state;
        if (config.hasCustomTransform) {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
        } else {
            if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
            if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
        }
        state.intentional = _step[0] !== false || _step[1] !== false;
        if (!state.intentional) return;
        const movement = [
            0,
            0
        ];
        if (config.hasCustomTransform) {
            const [v0, v1] = values;
            movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
        } else {
            movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
            movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
        }
        if (this.restrictToAxis && !state._blocked) this.restrictToAxis(movement);
        const previousOffset = state.offset;
        const gestureIsActive = state._active && !state._blocked || state.active;
        if (gestureIsActive) {
            state.first = state._active && !state.active;
            state.last = !state._active && state.active;
            state.active = shared[this.ingKey] = state._active;
            if (event) {
                if (state.first) {
                    if ('bounds' in config) state._bounds = $632c0fd227832521$var$call(config.bounds, state);
                    if (this.setup) this.setup();
                }
                state.movement = movement;
                this.computeOffset();
            }
        }
        const [ox, oy] = state.offset;
        const [[x0, x1], [y0, y1]] = state._bounds;
        state.overflow = [
            ox < x0 ? -1 : ox > x1 ? 1 : 0,
            oy < y0 ? -1 : oy > y1 ? 1 : 0
        ];
        state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
        state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
        const rubberband = state._active ? config.rubberband || [
            0,
            0
        ] : [
            0,
            0
        ];
        state.offset = (0, $9c93f61d2741ec13$export$db3b6bfb95261072)(state._bounds, state.offset, rubberband);
        state.delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(state.offset, previousOffset);
        this.computeMovement();
        if (gestureIsActive && (!state.last || dt > $632c0fd227832521$var$BEFORE_LAST_KINEMATICS_DELAY)) {
            state.delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(state.offset, previousOffset);
            const absoluteDelta = state.delta.map(Math.abs);
            (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);
            if (!state.first && dt > 0) {
                state.velocity = [
                    absoluteDelta[0] / dt,
                    absoluteDelta[1] / dt
                ];
                state.timeDelta = dt;
            }
        }
    }
    emit() {
        const state = this.state;
        const shared = this.shared;
        const config = this.config;
        if (!state._active) this.clean();
        if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
        const memo = this.handler($632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, shared), state), {}, {
            [this.aliasKey]: state.values
        }));
        if (memo !== undefined) state.memo = memo;
    }
    clean() {
        this.eventStore.clean();
        this.timeoutStore.clean();
    }
}
function $632c0fd227832521$var$selectAxis([dx, dy], threshold) {
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);
    if (absDx > absDy && absDx > threshold) return 'x';
    if (absDy > absDx && absDy > threshold) return 'y';
    return undefined;
}
class $632c0fd227832521$var$CoordinatesEngine extends $632c0fd227832521$var$Engine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "aliasKey", 'xy');
    }
    reset() {
        super.reset();
        this.state.axis = undefined;
    }
    init() {
        this.state.offset = [
            0,
            0
        ];
        this.state.lastOffset = [
            0,
            0
        ];
    }
    computeOffset() {
        this.state.offset = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).add(this.state.lastOffset, this.state.movement);
    }
    computeMovement() {
        this.state.movement = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(this.state.offset, this.state.lastOffset);
    }
    axisIntent(event) {
        const state = this.state;
        const config = this.config;
        if (!state.axis && event) {
            const threshold = typeof config.axisThreshold === 'object' ? config.axisThreshold[$632c0fd227832521$var$getPointerType(event)] : config.axisThreshold;
            state.axis = $632c0fd227832521$var$selectAxis(state._movement, threshold);
        }
        state._blocked = (config.lockDirection || !!config.axis) && !state.axis || !!config.axis && config.axis !== state.axis;
    }
    restrictToAxis(v) {
        if (this.config.axis || this.config.lockDirection) switch(this.state.axis){
            case 'x':
                v[1] = 0;
                break;
            case 'y':
                v[0] = 0;
                break;
        }
    }
}
const $632c0fd227832521$var$identity = (v)=>v;
const $632c0fd227832521$var$DEFAULT_RUBBERBAND = 0.15;
const $632c0fd227832521$var$commonConfigResolver = {
    enabled (value = true) {
        return value;
    },
    eventOptions (value, _k, config) {
        return $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, config.shared.eventOptions), value);
    },
    preventDefault (value = false) {
        return value;
    },
    triggerAllEvents (value = false) {
        return value;
    },
    rubberband (value = 0) {
        switch(value){
            case true:
                return [
                    $632c0fd227832521$var$DEFAULT_RUBBERBAND,
                    $632c0fd227832521$var$DEFAULT_RUBBERBAND
                ];
            case false:
                return [
                    0,
                    0
                ];
            default:
                return (0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(value);
        }
    },
    from (value) {
        if (typeof value === 'function') return value;
        if (value != null) return (0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(value);
    },
    transform (value, _k, config) {
        const transform = value || config.shared.transform;
        this.hasCustomTransform = !!transform;
        var v;
        return transform || $632c0fd227832521$var$identity;
    },
    threshold (value) {
        return (0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(value, 0);
    }
};
var $632c0fd227832521$var$value, $632c0fd227832521$var$value1, $632c0fd227832521$var$value2;
const $632c0fd227832521$var$DEFAULT_AXIS_THRESHOLD = 0;
const $632c0fd227832521$var$coordinatesConfigResolver = $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, $632c0fd227832521$var$commonConfigResolver), {}, {
    axis (_v, _k, { axis: axis }) {
        this.lockDirection = axis === 'lock';
        if (!this.lockDirection) return axis;
    },
    axisThreshold (value = $632c0fd227832521$var$DEFAULT_AXIS_THRESHOLD) {
        return value;
    },
    bounds (value = {}) {
        if (typeof value === 'function') return (state)=>$632c0fd227832521$var$coordinatesConfigResolver.bounds(value(state));
        if ('current' in value) return ()=>value.current;
        if (typeof HTMLElement === 'function' && value instanceof HTMLElement) return value;
        const { left: left = -Infinity, right: right = Infinity, top: top = -Infinity, bottom: bottom = Infinity } = value;
        return [
            [
                left,
                right
            ],
            [
                top,
                bottom
            ]
        ];
    }
});
const $632c0fd227832521$var$KEYS_DELTA_MAP = {
    ArrowRight: (displacement, factor = 1)=>[
            displacement * factor,
            0
        ],
    ArrowLeft: (displacement, factor = 1)=>[
            -1 * displacement * factor,
            0
        ],
    ArrowUp: (displacement, factor = 1)=>[
            0,
            -1 * displacement * factor
        ],
    ArrowDown: (displacement, factor = 1)=>[
            0,
            displacement * factor
        ]
};
class $632c0fd227832521$var$DragEngine extends $632c0fd227832521$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "ingKey", 'dragging');
    }
    reset() {
        super.reset();
        const state = this.state;
        state._pointerId = undefined;
        state._pointerActive = false;
        state._keyboardActive = false;
        state._preventScroll = false;
        state._delayed = false;
        state.swipe = [
            0,
            0
        ];
        state.tap = false;
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
    }
    setup() {
        const state = this.state;
        if (state._bounds instanceof HTMLElement) {
            const boundRect = state._bounds.getBoundingClientRect();
            const targetRect = state.currentTarget.getBoundingClientRect();
            const _bounds = {
                left: boundRect.left - targetRect.left + state.offset[0],
                right: boundRect.right - targetRect.right + state.offset[0],
                top: boundRect.top - targetRect.top + state.offset[1],
                bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
            };
            state._bounds = $632c0fd227832521$var$coordinatesConfigResolver.bounds(_bounds);
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        state.canceled = true;
        state._active = false;
        setTimeout(()=>{
            this.compute();
            this.emit();
        }, 0);
    }
    setActive() {
        this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
    clean() {
        this.pointerClean();
        this.state._pointerActive = false;
        this.state._keyboardActive = false;
        super.clean();
    }
    pointerDown(event) {
        const config = this.config;
        const state = this.state;
        if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
        const ctrlIds = this.ctrl.setEventIds(event);
        if (config.pointerCapture) event.target.setPointerCapture(event.pointerId);
        if (ctrlIds && ctrlIds.size > 1 && state._pointerActive) return;
        this.start(event);
        this.setupPointer(event);
        state._pointerId = $632c0fd227832521$var$pointerId(event);
        state._pointerActive = true;
        this.computeValues($632c0fd227832521$var$pointerValues(event));
        this.computeInitial();
        if (config.preventScrollAxis && $632c0fd227832521$var$getPointerType(event) !== 'mouse') {
            state._active = false;
            this.setupScrollPrevention(event);
        } else if (config.delay > 0) {
            this.setupDelayTrigger(event);
            if (config.triggerAllEvents) {
                this.compute(event);
                this.emit();
            }
        } else this.startPointerDrag(event);
    }
    startPointerDrag(event) {
        const state = this.state;
        state._active = true;
        state._preventScroll = true;
        state._delayed = false;
        this.compute(event);
        this.emit();
    }
    pointerMove(event) {
        const state = this.state;
        const config = this.config;
        if (!state._pointerActive) return;
        const id = $632c0fd227832521$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        const _values = $632c0fd227832521$var$pointerValues(event);
        if (document.pointerLockElement === event.target) state._delta = [
            event.movementX,
            event.movementY
        ];
        else {
            state._delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(_values, state._values);
            this.computeValues(_values);
        }
        (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.compute(event);
        if (state._delayed && state.intentional) {
            this.timeoutStore.remove('dragDelay');
            state.active = false;
            this.startPointerDrag(event);
            return;
        }
        if (config.preventScrollAxis && !state._preventScroll) {
            if (state.axis) {
                if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
                    state._active = false;
                    this.clean();
                    return;
                } else {
                    this.timeoutStore.remove('startPointerDrag');
                    this.startPointerDrag(event);
                    return;
                }
            } else return;
        }
        this.emit();
    }
    pointerUp(event) {
        this.ctrl.setEventIds(event);
        try {
            if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        const state = this.state;
        const config = this.config;
        if (!state._active || !state._pointerActive) return;
        const id = $632c0fd227832521$var$pointerId(event);
        if (state._pointerId !== undefined && id !== state._pointerId) return;
        this.state._pointerActive = false;
        this.setActive();
        this.compute(event);
        const [dx, dy] = state._distance;
        state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;
        if (state.tap && config.filterTaps) state._force = true;
        else {
            const [_dx, _dy] = state._delta;
            const [_mx, _my] = state._movement;
            const [svx, svy] = config.swipe.velocity;
            const [sx, sy] = config.swipe.distance;
            const sdt = config.swipe.duration;
            if (state.elapsedTime < sdt) {
                const _vx = Math.abs(_dx / state.timeDelta);
                const _vy = Math.abs(_dy / state.timeDelta);
                if (_vx > svx && Math.abs(_mx) > sx) state.swipe[0] = Math.sign(_dx);
                if (_vy > svy && Math.abs(_my) > sy) state.swipe[1] = Math.sign(_dy);
            }
        }
        this.emit();
    }
    pointerClick(event) {
        if (!this.state.tap && event.detail > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    setupPointer(event) {
        const config = this.config;
        const device = config.device;
        var _unused2;
        if (config.pointerLock) event.currentTarget.requestPointerLock();
        if (!config.pointerCapture) {
            this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
            this.eventStore.add(this.sharedConfig.window, device, 'cancel', this.pointerUp.bind(this));
        }
    }
    pointerClean() {
        if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) document.exitPointerLock();
    }
    preventScroll(event) {
        if (this.state._preventScroll && event.cancelable) event.preventDefault();
    }
    setupScrollPrevention(event) {
        this.state._preventScroll = false;
        $632c0fd227832521$var$persistEvent(event);
        const remove = this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
            passive: false
        });
        this.eventStore.add(this.sharedConfig.window, 'touch', 'end', remove);
        this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', remove);
        this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
    }
    setupDelayTrigger(event) {
        this.state._delayed = true;
        this.timeoutStore.add('dragDelay', ()=>{
            this.state._step = [
                0,
                0
            ];
            this.startPointerDrag(event);
        }, this.config.delay);
    }
    keyDown(event) {
        const deltaFn = $632c0fd227832521$var$KEYS_DELTA_MAP[event.key];
        if (deltaFn) {
            const state = this.state;
            const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
            this.start(event);
            state._delta = deltaFn(this.config.keyboardDisplacement, factor);
            state._keyboardActive = true;
            (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._movement, state._delta);
            this.compute(event);
            this.emit();
        }
    }
    keyUp(event) {
        if (!(event.key in $632c0fd227832521$var$KEYS_DELTA_MAP)) return;
        this.state._keyboardActive = false;
        this.setActive();
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        bindFunction(device, 'start', this.pointerDown.bind(this));
        if (this.config.pointerCapture) {
            bindFunction(device, 'change', this.pointerMove.bind(this));
            bindFunction(device, 'end', this.pointerUp.bind(this));
            bindFunction(device, 'cancel', this.pointerUp.bind(this));
            bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
        }
        if (this.config.keys) {
            bindFunction('key', 'down', this.keyDown.bind(this));
            bindFunction('key', 'up', this.keyUp.bind(this));
        }
        if (this.config.filterTaps) bindFunction('click', '', this.pointerClick.bind(this), {
            capture: true,
            passive: false
        });
    }
}
function $632c0fd227832521$var$persistEvent(event) {
    'persist' in event && typeof event.persist === 'function' && event.persist();
}
const $632c0fd227832521$var$isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;
function $632c0fd227832521$var$supportsTouchEvents() {
    return $632c0fd227832521$var$isBrowser && 'ontouchstart' in window;
}
function $632c0fd227832521$var$isTouchScreen() {
    return $632c0fd227832521$var$supportsTouchEvents() || $632c0fd227832521$var$isBrowser && window.navigator.maxTouchPoints > 1;
}
function $632c0fd227832521$var$supportsPointerEvents() {
    return $632c0fd227832521$var$isBrowser && 'onpointerdown' in window;
}
function $632c0fd227832521$var$supportsPointerLock() {
    return $632c0fd227832521$var$isBrowser && 'exitPointerLock' in window.document;
}
function $632c0fd227832521$var$supportsGestureEvents() {
    try {
        return 'constructor' in GestureEvent;
    } catch (e) {
        return false;
    }
}
const $632c0fd227832521$export$25ce5a424b770e84 = {
    isBrowser: $632c0fd227832521$var$isBrowser,
    gesture: $632c0fd227832521$var$supportsGestureEvents(),
    touch: $632c0fd227832521$var$supportsTouchEvents(),
    touchscreen: $632c0fd227832521$var$isTouchScreen(),
    pointer: $632c0fd227832521$var$supportsPointerEvents(),
    pointerLock: $632c0fd227832521$var$supportsPointerLock()
};
const $632c0fd227832521$var$DEFAULT_PREVENT_SCROLL_DELAY = 250;
const $632c0fd227832521$var$DEFAULT_DRAG_DELAY = 180;
const $632c0fd227832521$var$DEFAULT_SWIPE_VELOCITY = 0.5;
const $632c0fd227832521$var$DEFAULT_SWIPE_DISTANCE = 50;
const $632c0fd227832521$var$DEFAULT_SWIPE_DURATION = 250;
const $632c0fd227832521$var$DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const $632c0fd227832521$var$DEFAULT_DRAG_AXIS_THRESHOLD = {
    mouse: 0,
    touch: 0,
    pen: 8
};
const $632c0fd227832521$var$dragConfigResolver = $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, $632c0fd227832521$var$coordinatesConfigResolver), {}, {
    device (_v, _k, { pointer: { touch: touch = false, lock: lock = false, mouse: mouse = false } = {} }) {
        this.pointerLock = lock && $632c0fd227832521$export$25ce5a424b770e84.pointerLock;
        if ($632c0fd227832521$export$25ce5a424b770e84.touch && touch) return 'touch';
        if (this.pointerLock) return 'mouse';
        if ($632c0fd227832521$export$25ce5a424b770e84.pointer && !mouse) return 'pointer';
        if ($632c0fd227832521$export$25ce5a424b770e84.touch) return 'touch';
        return 'mouse';
    },
    preventScrollAxis (value, _k, { preventScroll: preventScroll }) {
        this.preventScrollDelay = typeof preventScroll === 'number' ? preventScroll : preventScroll || preventScroll === undefined && value ? $632c0fd227832521$var$DEFAULT_PREVENT_SCROLL_DELAY : undefined;
        if (!$632c0fd227832521$export$25ce5a424b770e84.touchscreen || preventScroll === false) return undefined;
        return value ? value : preventScroll !== undefined ? 'y' : undefined;
    },
    pointerCapture (_v, _k, { pointer: { capture: capture = true, buttons: buttons = 1, keys: keys = true } = {} }) {
        this.pointerButtons = buttons;
        this.keys = keys;
        return !this.pointerLock && this.device === 'pointer' && capture;
    },
    threshold (value, _k, { filterTaps: filterTaps = false, tapsThreshold: tapsThreshold = 3, axis: axis }) {
        const threshold = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
        this.filterTaps = filterTaps;
        this.tapsThreshold = tapsThreshold;
        return threshold;
    },
    swipe ({ velocity: velocity = $632c0fd227832521$var$DEFAULT_SWIPE_VELOCITY, distance: distance = $632c0fd227832521$var$DEFAULT_SWIPE_DISTANCE, duration: duration = $632c0fd227832521$var$DEFAULT_SWIPE_DURATION } = {}) {
        return {
            velocity: this.transform((0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(velocity)),
            distance: this.transform((0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(distance)),
            duration: duration
        };
    },
    delay (value = 0) {
        switch(value){
            case true:
                return $632c0fd227832521$var$DEFAULT_DRAG_DELAY;
            case false:
                return 0;
            default:
                return value;
        }
    },
    axisThreshold (value) {
        if (!value) return $632c0fd227832521$var$DEFAULT_DRAG_AXIS_THRESHOLD;
        return $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, $632c0fd227832521$var$DEFAULT_DRAG_AXIS_THRESHOLD), value);
    },
    keyboardDisplacement (value = $632c0fd227832521$var$DEFAULT_KEYBOARD_DISPLACEMENT) {
        return value;
    }
});
var $632c0fd227832521$var$value3, $632c0fd227832521$var$value4, $632c0fd227832521$var$value5, $632c0fd227832521$var$value6, $632c0fd227832521$var$value7;
function $632c0fd227832521$var$clampStateInternalMovementToBounds(state) {
    const [ox, oy] = state.overflow;
    const [dx, dy] = state._delta;
    const [dirx, diry] = state._direction;
    if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) state._movement[0] = state._movementBound[0];
    if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) state._movement[1] = state._movementBound[1];
}
const $632c0fd227832521$var$SCALE_ANGLE_RATIO_INTENT_DEG = 30;
const $632c0fd227832521$var$PINCH_WHEEL_RATIO = 100;
class $632c0fd227832521$var$PinchEngine extends $632c0fd227832521$var$Engine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "ingKey", 'pinching');
        $632c0fd227832521$export$407448d2b89b1813(this, "aliasKey", 'da');
    }
    init() {
        this.state.offset = [
            1,
            0
        ];
        this.state.lastOffset = [
            1,
            0
        ];
        this.state._pointerEvents = new Map();
    }
    reset() {
        super.reset();
        const state = this.state;
        state._touchIds = [];
        state.canceled = false;
        state.cancel = this.cancel.bind(this);
        state.turns = 0;
    }
    computeOffset() {
        const { type: type, movement: movement, lastOffset: lastOffset } = this.state;
        if (type === 'wheel') this.state.offset = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).add(movement, lastOffset);
        else this.state.offset = [
            (1 + movement[0]) * lastOffset[0],
            movement[1] + lastOffset[1]
        ];
    }
    computeMovement() {
        const { offset: offset, lastOffset: lastOffset } = this.state;
        this.state.movement = [
            offset[0] / lastOffset[0],
            offset[1] - lastOffset[1]
        ];
    }
    axisIntent() {
        const state = this.state;
        const [_m0, _m1] = state._movement;
        if (!state.axis) {
            const axisMovementDifference = Math.abs(_m0) * $632c0fd227832521$var$SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(_m1);
            if (axisMovementDifference < 0) state.axis = 'angle';
            else if (axisMovementDifference > 0) state.axis = 'scale';
        }
    }
    restrictToAxis(v) {
        if (this.config.lockDirection) {
            if (this.state.axis === 'scale') v[1] = 0;
            else if (this.state.axis === 'angle') v[0] = 0;
        }
    }
    cancel() {
        const state = this.state;
        if (state.canceled) return;
        setTimeout(()=>{
            state.canceled = true;
            state._active = false;
            this.compute();
            this.emit();
        }, 0);
    }
    touchStart(event) {
        this.ctrl.setEventIds(event);
        const state = this.state;
        const ctrlTouchIds = this.ctrl.touchIds;
        if (state._active) {
            if (state._touchIds.every((id)=>ctrlTouchIds.has(id))) return;
        }
        if (ctrlTouchIds.size < 2) return;
        this.start(event);
        state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
        const payload = $632c0fd227832521$var$touchDistanceAngle(event, state._touchIds);
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pointerStart(event) {
        if (event.buttons != null && event.buttons % 2 !== 1) return;
        this.ctrl.setEventIds(event);
        event.target.setPointerCapture(event.pointerId);
        const state = this.state;
        const _pointerEvents = state._pointerEvents;
        const ctrlPointerIds = this.ctrl.pointerIds;
        if (state._active) {
            if (Array.from(_pointerEvents.keys()).every((id)=>ctrlPointerIds.has(id))) return;
        }
        if (_pointerEvents.size < 2) _pointerEvents.set(event.pointerId, event);
        if (state._pointerEvents.size < 2) return;
        this.start(event);
        const payload = $632c0fd227832521$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchStart(event, payload);
    }
    pinchStart(event, payload) {
        const state = this.state;
        state.origin = payload.origin;
        this.computeValues([
            payload.distance,
            payload.angle
        ]);
        this.computeInitial();
        this.compute(event);
        this.emit();
    }
    touchMove(event) {
        if (!this.state._active) return;
        const payload = $632c0fd227832521$var$touchDistanceAngle(event, this.state._touchIds);
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pointerMove(event) {
        const _pointerEvents = this.state._pointerEvents;
        if (_pointerEvents.has(event.pointerId)) _pointerEvents.set(event.pointerId, event);
        if (!this.state._active) return;
        const payload = $632c0fd227832521$var$distanceAngle(...Array.from(_pointerEvents.values()));
        if (!payload) return;
        this.pinchMove(event, payload);
    }
    pinchMove(event, payload) {
        const state = this.state;
        const prev_a = state._values[1];
        const delta_a = payload.angle - prev_a;
        let delta_turns = 0;
        if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
        this.computeValues([
            payload.distance,
            payload.angle - 360 * delta_turns
        ]);
        state.origin = payload.origin;
        state.turns = delta_turns;
        state._movement = [
            state._values[0] / state._initial[0] - 1,
            state._values[1] - state._initial[1]
        ];
        this.compute(event);
        this.emit();
    }
    touchEnd(event) {
        this.ctrl.setEventIds(event);
        if (!this.state._active) return;
        if (this.state._touchIds.some((id)=>!this.ctrl.touchIds.has(id))) {
            this.state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    pointerEnd(event) {
        const state = this.state;
        this.ctrl.setEventIds(event);
        try {
            event.target.releasePointerCapture(event.pointerId);
        } catch (_unused) {}
        if (state._pointerEvents.has(event.pointerId)) state._pointerEvents.delete(event.pointerId);
        if (!state._active) return;
        if (state._pointerEvents.size < 2) {
            state._active = false;
            this.compute(event);
            this.emit();
        }
    }
    gestureStart(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        if (state._active) return;
        this.start(event);
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    gestureMove(event) {
        if (event.cancelable) event.preventDefault();
        if (!this.state._active) return;
        const state = this.state;
        this.computeValues([
            event.scale,
            event.rotation
        ]);
        state.origin = [
            event.clientX,
            event.clientY
        ];
        const _previousMovement = state._movement;
        state._movement = [
            event.scale - 1,
            event.rotation
        ];
        state._delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(state._movement, _previousMovement);
        this.compute(event);
        this.emit();
    }
    gestureEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    wheel(event) {
        const modifierKey = this.config.modifierKey;
        if (modifierKey && (Array.isArray(modifierKey) ? !modifierKey.find((k)=>event[k]) : !event[modifierKey])) return;
        if (!this.state._active) this.wheelStart(event);
        else this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelStart(event) {
        this.start(event);
        this.wheelChange(event);
    }
    wheelChange(event) {
        const isR3f = 'uv' in event;
        if (!isR3f) {
            if (event.cancelable) event.preventDefault();
        }
        const state = this.state;
        state._delta = [
            -$632c0fd227832521$var$wheelValues(event)[1] / $632c0fd227832521$var$PINCH_WHEEL_RATIO * state.offset[0],
            0
        ];
        (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $632c0fd227832521$var$clampStateInternalMovementToBounds(state);
        this.state.origin = [
            event.clientX,
            event.clientY
        ];
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        const device = this.config.device;
        if (!!device) {
            bindFunction(device, 'start', this[device + 'Start'].bind(this));
            bindFunction(device, 'change', this[device + 'Move'].bind(this));
            bindFunction(device, 'end', this[device + 'End'].bind(this));
            bindFunction(device, 'cancel', this[device + 'End'].bind(this));
            bindFunction('lostPointerCapture', '', this[device + 'End'].bind(this));
        }
        if (this.config.pinchOnWheel) bindFunction('wheel', '', this.wheel.bind(this), {
            passive: false
        });
    }
}
const $632c0fd227832521$var$pinchConfigResolver = $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, $632c0fd227832521$var$commonConfigResolver), {}, {
    device (_v, _k, { shared: shared, pointer: { touch: touch = false } = {} }) {
        const sharedConfig = shared;
        if (sharedConfig.target && !$632c0fd227832521$export$25ce5a424b770e84.touch && $632c0fd227832521$export$25ce5a424b770e84.gesture) return 'gesture';
        if ($632c0fd227832521$export$25ce5a424b770e84.touch && touch) return 'touch';
        if ($632c0fd227832521$export$25ce5a424b770e84.touchscreen) {
            if ($632c0fd227832521$export$25ce5a424b770e84.pointer) return 'pointer';
            if ($632c0fd227832521$export$25ce5a424b770e84.touch) return 'touch';
        }
    },
    bounds (_v, _k, { scaleBounds: scaleBounds = {}, angleBounds: angleBounds = {} }) {
        const _scaleBounds = (state)=>{
            const D = $632c0fd227832521$var$assignDefault($632c0fd227832521$var$call(scaleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                D.min,
                D.max
            ];
        };
        const _angleBounds = (state)=>{
            const A = $632c0fd227832521$var$assignDefault($632c0fd227832521$var$call(angleBounds, state), {
                min: -Infinity,
                max: Infinity
            });
            return [
                A.min,
                A.max
            ];
        };
        if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [
            _scaleBounds(),
            _angleBounds()
        ];
        return (state)=>[
                _scaleBounds(state),
                _angleBounds(state)
            ];
    },
    threshold (value, _k, config) {
        this.lockDirection = config.axis === 'lock';
        const threshold = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).toVector(value, this.lockDirection ? [
            0.1,
            3
        ] : 0);
        return threshold;
    },
    modifierKey (value) {
        if (value === undefined) return 'ctrlKey';
        return value;
    },
    pinchOnWheel (value = true) {
        return value;
    }
});
class $632c0fd227832521$var$MoveEngine extends $632c0fd227832521$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "ingKey", 'moving');
    }
    move(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        if (!this.state._active) this.moveStart(event);
        else this.moveChange(event);
        this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
    }
    moveStart(event) {
        this.start(event);
        this.computeValues($632c0fd227832521$var$pointerValues(event));
        this.compute(event);
        this.computeInitial();
        this.emit();
    }
    moveChange(event) {
        if (!this.state._active) return;
        const values = $632c0fd227832521$var$pointerValues(event);
        const state = this.state;
        state._delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(values, state._values);
        (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    moveEnd(event) {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute(event);
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'change', this.move.bind(this));
        bindFunction('pointer', 'leave', this.moveEnd.bind(this));
    }
}
const $632c0fd227832521$var$moveConfigResolver = $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, $632c0fd227832521$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
class $632c0fd227832521$var$ScrollEngine extends $632c0fd227832521$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "ingKey", 'scrolling');
    }
    scroll(event) {
        if (!this.state._active) this.start(event);
        this.scrollChange(event);
        this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
    }
    scrollChange(event) {
        if (event.cancelable) event.preventDefault();
        const state = this.state;
        const values = $632c0fd227832521$var$scrollValues(event);
        state._delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(values, state._values);
        (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        this.computeValues(values);
        this.compute(event);
        this.emit();
    }
    scrollEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('scroll', '', this.scroll.bind(this));
    }
}
const $632c0fd227832521$var$scrollConfigResolver = $632c0fd227832521$var$coordinatesConfigResolver;
class $632c0fd227832521$var$WheelEngine extends $632c0fd227832521$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "ingKey", 'wheeling');
    }
    wheel(event) {
        if (!this.state._active) this.start(event);
        this.wheelChange(event);
        this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
    wheelChange(event) {
        const state = this.state;
        state._delta = $632c0fd227832521$var$wheelValues(event);
        (0, $9c93f61d2741ec13$export$e7c866399fa523f5).addTo(state._movement, state._delta);
        $632c0fd227832521$var$clampStateInternalMovementToBounds(state);
        this.compute(event);
        this.emit();
    }
    wheelEnd() {
        if (!this.state._active) return;
        this.state._active = false;
        this.compute();
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('wheel', '', this.wheel.bind(this));
    }
}
const $632c0fd227832521$var$wheelConfigResolver = $632c0fd227832521$var$coordinatesConfigResolver;
class $632c0fd227832521$var$HoverEngine extends $632c0fd227832521$var$CoordinatesEngine {
    constructor(...args){
        super(...args);
        $632c0fd227832521$export$407448d2b89b1813(this, "ingKey", 'hovering');
    }
    enter(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        this.start(event);
        this.computeValues($632c0fd227832521$var$pointerValues(event));
        this.compute(event);
        this.emit();
    }
    leave(event) {
        if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
        const state = this.state;
        if (!state._active) return;
        state._active = false;
        const values = $632c0fd227832521$var$pointerValues(event);
        state._movement = state._delta = (0, $9c93f61d2741ec13$export$e7c866399fa523f5).sub(values, state._values);
        this.computeValues(values);
        this.compute(event);
        state.delta = state.movement;
        this.emit();
    }
    bind(bindFunction) {
        bindFunction('pointer', 'enter', this.enter.bind(this));
        bindFunction('pointer', 'leave', this.leave.bind(this));
    }
}
const $632c0fd227832521$var$hoverConfigResolver = $632c0fd227832521$export$71511d61b312f219($632c0fd227832521$export$71511d61b312f219({}, $632c0fd227832521$var$coordinatesConfigResolver), {}, {
    mouseOnly: (value = true)=>value
});
const $632c0fd227832521$export$a9c23c6ac3fc3eca = new Map();
const $632c0fd227832521$export$e7094788287c5e9b = new Map();
function $632c0fd227832521$export$43caf9889c228507(action) {
    $632c0fd227832521$export$a9c23c6ac3fc3eca.set(action.key, action.engine);
    $632c0fd227832521$export$e7094788287c5e9b.set(action.key, action.resolver);
}
const $632c0fd227832521$export$f1e1789686576879 = {
    key: 'drag',
    engine: $632c0fd227832521$var$DragEngine,
    resolver: $632c0fd227832521$var$dragConfigResolver
};
const $632c0fd227832521$export$dda1d9f60106f0e9 = {
    key: 'hover',
    engine: $632c0fd227832521$var$HoverEngine,
    resolver: $632c0fd227832521$var$hoverConfigResolver
};
const $632c0fd227832521$export$953cecd6e717a553 = {
    key: 'move',
    engine: $632c0fd227832521$var$MoveEngine,
    resolver: $632c0fd227832521$var$moveConfigResolver
};
const $632c0fd227832521$export$2d1720544b23b823 = {
    key: 'pinch',
    engine: $632c0fd227832521$var$PinchEngine,
    resolver: $632c0fd227832521$var$pinchConfigResolver
};
const $632c0fd227832521$export$2408f22a0fab9ae5 = {
    key: 'scroll',
    engine: $632c0fd227832521$var$ScrollEngine,
    resolver: $632c0fd227832521$var$scrollConfigResolver
};
const $632c0fd227832521$export$efccba1c4a2ef57b = {
    key: 'wheel',
    engine: $632c0fd227832521$var$WheelEngine,
    resolver: $632c0fd227832521$var$wheelConfigResolver
};






var $exYeM = parcelRequire("exYeM");


function $bf3726678f7ef395$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bf3726678f7ef395$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bf3726678f7ef395$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
const $bf3726678f7ef395$var$sharedConfigResolver = {
    target (value) {
        if (value) return ()=>'current' in value ? value.current : value;
        return undefined;
    },
    enabled (value = true) {
        return value;
    },
    window (value = (0, $632c0fd227832521$export$25ce5a424b770e84).isBrowser ? window : undefined) {
        return value;
    },
    eventOptions ({ passive: passive = true, capture: capture = false } = {}) {
        return {
            passive: passive,
            capture: capture
        };
    },
    transform (value) {
        return value;
    }
};
const $bf3726678f7ef395$var$_excluded = [
    "target",
    "eventOptions",
    "window",
    "enabled",
    "transform"
];
function $bf3726678f7ef395$var$resolveWith(config = {}, resolvers) {
    const result = {};
    for (const [key, resolver] of Object.entries(resolvers))switch(typeof resolver){
        case 'function':
            result[key] = resolver.call(result, config[key], key, config);
            break;
        case 'object':
            result[key] = $bf3726678f7ef395$var$resolveWith(config[key], resolver);
            break;
        case 'boolean':
            if (resolver) result[key] = config[key];
            break;
    }
    return result;
}
function $bf3726678f7ef395$var$parse(newConfig, gestureKey, _config = {}) {
    const _ref = newConfig, { target: target, eventOptions: eventOptions, window: window1, enabled: enabled, transform: transform } = _ref, rest = $bf3726678f7ef395$var$_objectWithoutProperties(_ref, $bf3726678f7ef395$var$_excluded);
    _config.shared = $bf3726678f7ef395$var$resolveWith({
        target: target,
        eventOptions: eventOptions,
        window: window1,
        enabled: enabled,
        transform: transform
    }, $bf3726678f7ef395$var$sharedConfigResolver);
    if (gestureKey) {
        const resolver = (0, $632c0fd227832521$export$e7094788287c5e9b).get(gestureKey);
        _config[gestureKey] = $bf3726678f7ef395$var$resolveWith((0, $632c0fd227832521$export$71511d61b312f219)({
            shared: _config.shared
        }, rest), resolver);
    } else for(const key in rest){
        const resolver = (0, $632c0fd227832521$export$e7094788287c5e9b).get(key);
        if (resolver) _config[key] = $bf3726678f7ef395$var$resolveWith((0, $632c0fd227832521$export$71511d61b312f219)({
            shared: _config.shared
        }, rest[key]), resolver);
    }
    return _config;
}
class $bf3726678f7ef395$var$EventStore {
    constructor(ctrl, gestureKey){
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "_listeners", new Set());
        this._ctrl = ctrl;
        this._gestureKey = gestureKey;
    }
    add(element, device, action, handler, options) {
        const listeners = this._listeners;
        const type = (0, $632c0fd227832521$export$625550452a3fa3ec)(device, action);
        const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
        const eventOptions = (0, $632c0fd227832521$export$71511d61b312f219)((0, $632c0fd227832521$export$71511d61b312f219)({}, _options), options);
        element.addEventListener(type, handler, eventOptions);
        const remove = ()=>{
            element.removeEventListener(type, handler, eventOptions);
            listeners.delete(remove);
        };
        listeners.add(remove);
        return remove;
    }
    clean() {
        this._listeners.forEach((remove)=>remove());
        this._listeners.clear();
    }
}
class $bf3726678f7ef395$var$TimeoutStore {
    constructor(){
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "_timeouts", new Map());
    }
    add(key, callback, ms = 140, ...args) {
        this.remove(key);
        this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
    }
    remove(key) {
        const timeout = this._timeouts.get(key);
        if (timeout) window.clearTimeout(timeout);
    }
    clean() {
        this._timeouts.forEach((timeout)=>void window.clearTimeout(timeout));
        this._timeouts.clear();
    }
}
class $bf3726678f7ef395$export$bd0bf19f25da8474 {
    constructor(handlers){
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "gestures", new Set());
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "_targetEventStore", new $bf3726678f7ef395$var$EventStore(this));
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "gestureEventStores", {});
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "gestureTimeoutStores", {});
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "handlers", {});
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "config", {});
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "pointerIds", new Set());
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "touchIds", new Set());
        (0, $632c0fd227832521$export$407448d2b89b1813)(this, "state", {
            shared: {
                shiftKey: false,
                metaKey: false,
                ctrlKey: false,
                altKey: false
            }
        });
        $bf3726678f7ef395$var$resolveGestures(this, handlers);
    }
    setEventIds(event) {
        if ((0, $632c0fd227832521$export$23f2a1d2818174ef)(event)) {
            this.touchIds = new Set((0, $632c0fd227832521$export$8b22cf2602fb60ce)(event));
            return this.touchIds;
        } else if ('pointerId' in event) {
            if (event.type === 'pointerup' || event.type === 'pointercancel') this.pointerIds.delete(event.pointerId);
            else if (event.type === 'pointerdown') this.pointerIds.add(event.pointerId);
            return this.pointerIds;
        }
    }
    applyHandlers(handlers, nativeHandlers) {
        this.handlers = handlers;
        this.nativeHandlers = nativeHandlers;
    }
    applyConfig(config, gestureKey) {
        this.config = $bf3726678f7ef395$var$parse(config, gestureKey, this.config);
    }
    clean() {
        this._targetEventStore.clean();
        for (const key of this.gestures){
            this.gestureEventStores[key].clean();
            this.gestureTimeoutStores[key].clean();
        }
    }
    effect() {
        if (this.config.shared.target) this.bind();
        return ()=>this._targetEventStore.clean();
    }
    bind(...args) {
        const sharedConfig = this.config.shared;
        const props = {};
        let target;
        if (sharedConfig.target) {
            target = sharedConfig.target();
            if (!target) return;
        }
        if (sharedConfig.enabled) {
            for (const gestureKey of this.gestures){
                const gestureConfig = this.config[gestureKey];
                const bindFunction = $bf3726678f7ef395$var$bindToProps(props, gestureConfig.eventOptions, !!target);
                if (gestureConfig.enabled) {
                    const Engine = (0, $632c0fd227832521$export$a9c23c6ac3fc3eca).get(gestureKey);
                    new Engine(this, args, gestureKey).bind(bindFunction);
                }
            }
            const nativeBindFunction = $bf3726678f7ef395$var$bindToProps(props, sharedConfig.eventOptions, !!target);
            for(const eventKey in this.nativeHandlers)nativeBindFunction(eventKey, '', (event)=>this.nativeHandlers[eventKey]((0, $632c0fd227832521$export$71511d61b312f219)((0, $632c0fd227832521$export$71511d61b312f219)({}, this.state.shared), {}, {
                    event: event,
                    args: args
                })), undefined, true);
        }
        for(const handlerProp in props)props[handlerProp] = (0, $632c0fd227832521$export$db3b6bfb95261072)(...props[handlerProp]);
        if (!target) return props;
        for(const handlerProp in props){
            const { device: device, capture: capture, passive: passive } = (0, $632c0fd227832521$export$ffb5f4729a158638)(handlerProp);
            this._targetEventStore.add(target, device, '', props[handlerProp], {
                capture: capture,
                passive: passive
            });
        }
    }
}
function $bf3726678f7ef395$var$setupGesture(ctrl, gestureKey) {
    ctrl.gestures.add(gestureKey);
    ctrl.gestureEventStores[gestureKey] = new $bf3726678f7ef395$var$EventStore(ctrl, gestureKey);
    ctrl.gestureTimeoutStores[gestureKey] = new $bf3726678f7ef395$var$TimeoutStore();
}
function $bf3726678f7ef395$var$resolveGestures(ctrl, internalHandlers) {
    if (internalHandlers.drag) $bf3726678f7ef395$var$setupGesture(ctrl, 'drag');
    if (internalHandlers.wheel) $bf3726678f7ef395$var$setupGesture(ctrl, 'wheel');
    if (internalHandlers.scroll) $bf3726678f7ef395$var$setupGesture(ctrl, 'scroll');
    if (internalHandlers.move) $bf3726678f7ef395$var$setupGesture(ctrl, 'move');
    if (internalHandlers.pinch) $bf3726678f7ef395$var$setupGesture(ctrl, 'pinch');
    if (internalHandlers.hover) $bf3726678f7ef395$var$setupGesture(ctrl, 'hover');
}
const $bf3726678f7ef395$var$bindToProps = (props, eventOptions, withPassiveOption)=>(device, action, handler, options = {}, isNative = false)=>{
        var _options$capture, _options$passive;
        const capture = (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
        const passive = (_options$passive = options.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
        let handlerProp = isNative ? device : (0, $632c0fd227832521$export$4368d992c4eafac0)(device, action, capture);
        if (withPassiveOption && passive) handlerProp += 'Passive';
        props[handlerProp] = props[handlerProp] || [];
        props[handlerProp].push(handler);
    };
const $bf3726678f7ef395$var$RE_NOT_NATIVE = /^on(Drag|Wheel|Scroll|Move|Pinch|Hover)/;
function $bf3726678f7ef395$var$sortHandlers(_handlers) {
    const native = {};
    const handlers = {};
    const actions = new Set();
    for(let key in _handlers)if ($bf3726678f7ef395$var$RE_NOT_NATIVE.test(key)) {
        actions.add(RegExp.lastMatch);
        handlers[key] = _handlers[key];
    } else native[key] = _handlers[key];
    return [
        handlers,
        native,
        actions
    ];
}
function $bf3726678f7ef395$var$registerGesture(actions, handlers, handlerKey, key, internalHandlers, config) {
    if (!actions.has(handlerKey)) return;
    if (!(0, $632c0fd227832521$export$a9c23c6ac3fc3eca).has(key)) return;
    const startKey = handlerKey + 'Start';
    const endKey = handlerKey + 'End';
    const fn = (state)=>{
        let memo = undefined;
        if (state.first && startKey in handlers) handlers[startKey](state);
        if (handlerKey in handlers) memo = handlers[handlerKey](state);
        if (state.last && endKey in handlers) handlers[endKey](state);
        return memo;
    };
    internalHandlers[key] = fn;
    config[key] = config[key] || {};
}
function $bf3726678f7ef395$export$c14d3c7045c4485d(mergedHandlers, mergedConfig) {
    const [handlers, nativeHandlers, actions] = $bf3726678f7ef395$var$sortHandlers(mergedHandlers);
    const internalHandlers = {};
    $bf3726678f7ef395$var$registerGesture(actions, handlers, 'onDrag', 'drag', internalHandlers, mergedConfig);
    $bf3726678f7ef395$var$registerGesture(actions, handlers, 'onWheel', 'wheel', internalHandlers, mergedConfig);
    $bf3726678f7ef395$var$registerGesture(actions, handlers, 'onScroll', 'scroll', internalHandlers, mergedConfig);
    $bf3726678f7ef395$var$registerGesture(actions, handlers, 'onPinch', 'pinch', internalHandlers, mergedConfig);
    $bf3726678f7ef395$var$registerGesture(actions, handlers, 'onMove', 'move', internalHandlers, mergedConfig);
    $bf3726678f7ef395$var$registerGesture(actions, handlers, 'onHover', 'hover', internalHandlers, mergedConfig);
    return {
        handlers: internalHandlers,
        config: mergedConfig,
        nativeHandlers: nativeHandlers
    };
}







function $1c8da9e350a78c26$var$useRecognizers(handlers, config = {}, gestureKey, nativeHandlers) {
    const ctrl = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>new (0, $bf3726678f7ef395$export$bd0bf19f25da8474)(handlers), []);
    ctrl.applyHandlers(handlers, nativeHandlers);
    ctrl.applyConfig(config, gestureKey);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(ctrl.effect.bind(ctrl));
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        return ctrl.clean.bind(ctrl);
    }, []);
    if (config.target === undefined) return ctrl.bind.bind(ctrl);
    return undefined;
}
function $1c8da9e350a78c26$export$7941f8aafa4b6021(handler, config) {
    (0, $632c0fd227832521$export$43caf9889c228507)((0, $632c0fd227832521$export$f1e1789686576879));
    return $1c8da9e350a78c26$var$useRecognizers({
        drag: handler
    }, config || {}, 'drag');
}
function $1c8da9e350a78c26$export$ccc26886ea7dba8f(handler, config) {
    (0, $632c0fd227832521$export$43caf9889c228507)((0, $632c0fd227832521$export$2d1720544b23b823));
    return $1c8da9e350a78c26$var$useRecognizers({
        pinch: handler
    }, config || {}, 'pinch');
}
function $1c8da9e350a78c26$export$43260e1b277d5f62(handler, config) {
    (0, $632c0fd227832521$export$43caf9889c228507)((0, $632c0fd227832521$export$efccba1c4a2ef57b));
    return $1c8da9e350a78c26$var$useRecognizers({
        wheel: handler
    }, config || {}, 'wheel');
}
function $1c8da9e350a78c26$export$d928051c8cd740b(handler, config) {
    (0, $632c0fd227832521$export$43caf9889c228507)((0, $632c0fd227832521$export$2408f22a0fab9ae5));
    return $1c8da9e350a78c26$var$useRecognizers({
        scroll: handler
    }, config || {}, 'scroll');
}
function $1c8da9e350a78c26$export$36da96379f79f245(handler, config) {
    (0, $632c0fd227832521$export$43caf9889c228507)((0, $632c0fd227832521$export$953cecd6e717a553));
    return $1c8da9e350a78c26$var$useRecognizers({
        move: handler
    }, config || {}, 'move');
}
function $1c8da9e350a78c26$export$ae780daf29e6d456(handler, config) {
    (0, $632c0fd227832521$export$43caf9889c228507)((0, $632c0fd227832521$export$dda1d9f60106f0e9));
    return $1c8da9e350a78c26$var$useRecognizers({
        hover: handler
    }, config || {}, 'hover');
}
function $1c8da9e350a78c26$export$ee99e1f7df2b9180(actions) {
    actions.forEach((0, $632c0fd227832521$export$43caf9889c228507));
    return function useGesture(_handlers, _config) {
        const { handlers: handlers, nativeHandlers: nativeHandlers, config: config } = (0, $bf3726678f7ef395$export$c14d3c7045c4485d)(_handlers, _config || {});
        return $1c8da9e350a78c26$var$useRecognizers(handlers, config, undefined, nativeHandlers);
    };
}
function $1c8da9e350a78c26$export$ece84446a783717(handlers, config) {
    const hook = $1c8da9e350a78c26$export$ee99e1f7df2b9180([
        (0, $632c0fd227832521$export$f1e1789686576879),
        (0, $632c0fd227832521$export$2d1720544b23b823),
        (0, $632c0fd227832521$export$2408f22a0fab9ae5),
        (0, $632c0fd227832521$export$efccba1c4a2ef57b),
        (0, $632c0fd227832521$export$953cecd6e717a553),
        (0, $632c0fd227832521$export$dda1d9f60106f0e9)
    ]);
    return hook(handlers, config || {});
}



var $kj6DU = parcelRequire("kj6DU");

var $kyy1y = parcelRequire("kyy1y");

var $exYeM = parcelRequire("exYeM");

var $cn7Rc = parcelRequire("cn7Rc");

var $cF6yJ = parcelRequire("cF6yJ");
var $hOuM2 = parcelRequire("hOuM2");

var $kj6DU = parcelRequire("kj6DU");

var $9ddGv = parcelRequire("9ddGv");
/**
 * Mastery level 10 or more = 100%.
 *
 * It takes 75,600 points to reach level 10 (counts for half the percentage calculation).
 *
 * It takes 7 Marks of Mastery to reach level 10 (counts for the other half of the calculation).
 */ function $7c2fab9890607f52$var$championPercents({ championLevel: championLevel, championPoints: championPoints, championPointsUntilNextLevel: championPointsUntilNextLevel, tokensEarned: tokensEarned }) {
    if (10 <= championLevel) return 100;
    const pointsPercents = Math.min(// `championPointsUntilNextLevel` can be negative
    Math.min(championPoints + championPointsUntilNextLevel, championPoints) / 75600, 1) * 50;
    const tokensPercents = Math.min((Math.max(championLevel - 4, 0) + tokensEarned) / 7, 1) * 50;
    return pointsPercents + tokensPercents;
}
const $7c2fab9890607f52$var$byPointsOrd = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((c)=>c.championPoints), (0, $hOuM2).reverse);
function $7c2fab9890607f52$var$otpRatio(masteries, totalMasteryPoints) {
    return $7c2fab9890607f52$var$otpRatioRec(totalMasteryPoints / 2, (0, $kj6DU.pipe)(masteries, (0, $9ddGv.List).sort($7c2fab9890607f52$var$byPointsOrd)), 0, 0);
}
function $7c2fab9890607f52$var$otpRatioRec(threshold, masteries, pointsAcc, countAcc) {
    if (!(0, $9ddGv.List).isNonEmpty(masteries)) return countAcc;
    const [head, tail] = (0, $9ddGv.NonEmptyArray).unprepend(masteries);
    const newPointsAcc = pointsAcc + head.championPoints;
    const newCountAcc = countAcc + 1;
    if (threshold <= newPointsAcc) return newCountAcc;
    return $7c2fab9890607f52$var$otpRatioRec(threshold, tail, newPointsAcc, newCountAcc);
}
const $7c2fab9890607f52$var$poroLang = {
    en_GB: 'en',
    fr_FR: 'fr'
};
const $7c2fab9890607f52$export$6d7a29d4960e3d83 = {
    championPercents: $7c2fab9890607f52$var$championPercents,
    otpRatio: $7c2fab9890607f52$var$otpRatio,
    poroLang: $7c2fab9890607f52$var$poroLang
};



var $7wIl1 = parcelRequire("7wIl1");

var $hPJN4 = parcelRequire("hPJN4");


var $cF6yJ = parcelRequire("cF6yJ");

var $9ddGv = parcelRequire("9ddGv");
const $edc657eabde8d7fe$var$summonersRiftMaps = [
    1,
    2,
    11
];
// 3, // The Proving Grounds — Tutorial Map
// 4, // Twisted Treeline — Original Version
// 8, // The Crystal Scar — Dominion map
// 10, // Twisted Treeline — Last TT map
// 12, // Howling Abyss — ARAM map
// 14, // Butcher's Bridge — Alternate ARAM map
// 16, // Cosmic Ruins — Dark Star: Singularity map
// 18, // Valoran City Park — Star Guardian Invasion map
// 19, // Substructure 43 — PROJECT: Hunters map
// 20, // Crash Site — Odyssey: Extraction map
// 21, // Nexus Blitz — Nexus Blitz map
// 22, // Convergence — Teamfight Tactics map
// 30, // Rings of Wrath — Arena map
// 35, // The Bandlewood — Brawl map
function $edc657eabde8d7fe$var$isSummonersRift(map) {
    return (0, $9ddGv.List).elem((0, $cF6yJ).Eq)(map, $edc657eabde8d7fe$var$summonersRiftMaps);
}
const $edc657eabde8d7fe$export$44c1e36a0d7bb01f = {
    isSummonersRift: $edc657eabde8d7fe$var$isSummonersRift
};



var $5Dwzl = parcelRequire("5Dwzl");



var $3a4Bg = parcelRequire("3a4Bg");
const $5ff7d0cead9d8600$export$4718096832dec34e = (0, $3a4Bg.createEnum)(100, 200);







var $appXD = parcelRequire("appXD");

var $javAY = parcelRequire("javAY");

var $dglOy = parcelRequire("dglOy");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $kJ6py = parcelRequire("kJ6py");

var $cwvCy = parcelRequire("cwvCy");

var $lMH1q = parcelRequire("lMH1q");

var $1sXco = parcelRequire("1sXco");

var $abFKR = parcelRequire("abFKR");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");
/* eslint-disable functional/no-expression-statements */ 
var $exYeM = parcelRequire("exYeM");

var $appXD = parcelRequire("appXD");

var $2Yib7 = parcelRequire("2Yib7");

var $dCazK = parcelRequire("dCazK");

var $iz2wS = parcelRequire("iz2wS");

var $lFNyc = parcelRequire("lFNyc");
function $8e158bd0f9b43ba8$export$f96ad7bfa050ed2(summoner, correctUrlCase) {
    const { navigate: navigate } = (0, $2Yib7.useHistory)();
    const { addRecentSearch: addRecentSearch } = (0, $dCazK.useUser)();
    (0, $exYeM.useEffect)(()=>addRecentSearch(summoner), [
        addRecentSearch,
        summoner
    ]);
    const riotIdFromLocation = (0, $lFNyc.usePathMatch)((0, $iz2wS.appParsers).anyPlatformRiotId)?.riotId;
    // Correct Riot ID's case in url
    (0, $exYeM.useEffect)(()=>{
        if (riotIdFromLocation !== undefined && !(0, $appXD.RiotId).Eq.equals(riotIdFromLocation, summoner.riotId)) navigate(correctUrlCase, {
            replace: true
        });
    }, [
        navigate,
        riotIdFromLocation,
        summoner.riotId,
        correctUrlCase
    ]);
}


/* eslint-disable functional/no-expression-statements */ 
var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");
const $72dc780a792c7de1$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $exYeM.useRef)((0, $9ddGv.Maybe).none);
    (0, $exYeM.useEffect)(()=>{
        // eslint-disable-next-line functional/immutable-data
        ref.current = (0, $9ddGv.Maybe).some(value);
    }, [
        value
    ]);
    return ref.current;
};



var $cmF7r = parcelRequire("cmF7r");

var $5mLQo = parcelRequire("5mLQo");

var $dR62Q = parcelRequire("dR62Q");

var $iz2wS = parcelRequire("iz2wS");

var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");


var $csF9Q = parcelRequire("csF9Q");

var $ffzmL = parcelRequire("ffzmL");

var $javAY = parcelRequire("javAY");

var $9ddGv = parcelRequire("9ddGv");



var $1sXco = parcelRequire("1sXco");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $5mLQo = parcelRequire("5mLQo");

var $5MBh5 = parcelRequire("5MBh5");
const $007d2d12dc557e1c$export$e355dba6ae7236d1 = ({ isDraft: isDraft, bannedChampions: bannedChampions, participants: participants })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { championByKey: championByKey } = (0, $fcoXO.useStaticData)();
    const factions = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(participants, (0, $9ddGv.PartialDict).map((0, $kj6DU.flow)((0, $9ddGv.NonEmptyArray).map((p)=>(0, $kj6DU.pipe)(championByKey(p.championId), (0, $9ddGv.Maybe).fold(()=>[], (c)=>c.factions))), (0, $javAY.ListUtils).commonElems((0, $ffzmL.ChampionFaction).Eq)))), [
        championByKey,
        participants
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex flex-wrap gap-16 px-3 text-sm text-goldenrod",
        children: (0, $5ff7d0cead9d8600$export$4718096832dec34e).values.map((teamId, i)=>{
            const teamBans = bannedChampions[teamId];
            const reverse = i % 2 === 1;
            return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('flex grow basis-0 items-center gap-8', [
                    'flex-row-reverse',
                    reverse
                ]),
                children: [
                    isDraft ? /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                        className: "flex flex-wrap gap-1",
                        children: teamBans !== undefined ? (0, $kj6DU.pipe)(teamBans, (0, $9ddGv.NonEmptyArray).map((bannedChampion)=>/*#__PURE__*/ (0, $aSiaI.jsx)($007d2d12dc557e1c$var$Ban, {
                                bannedChampion: bannedChampion
                            }, bannedChampion.pickTurn))) : null
                    }) : null,
                    /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                        className: (0, $5MBh5.cx)('flex gap-4', [
                            'justify-end',
                            !reverse
                        ]),
                        children: (factions[teamId] ?? []).map((faction)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                className: (0, $5MBh5.cx)('flex items-center gap-1.5', [
                                    'flex-row-reverse',
                                    reverse
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $497c996a4da16cff$export$a50dcf13e7b62e9d), {
                                        id: (0, $csF9Q.ChallengesView).id[faction],
                                        tier: (0, $9ddGv.Maybe).some('GOLD'),
                                        className: "h-9"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "font-semibold",
                                        children: t.labels.faction[faction]
                                    })
                                ]
                            }, faction))
                    }, teamId)
                ]
            }, teamId);
        })
    });
};
const $007d2d12dc557e1c$var$Ban = ({ bannedChampion: bannedChampion })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const { championByKey: championByKey } = (0, $fcoXO.useStaticData)();
    const ref = (0, $exYeM.useRef)(null);
    const [children, tooltip] = (0, $kj6DU.pipe)(bannedChampion.championId, (0, $9ddGv.Maybe).fold(()=>(0, $9ddGv.Tuple).of(/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
            ref: ref,
            className: "relative flex size-10 items-center justify-center overflow-hidden bg-black",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                src: (0, $5mLQo.Assets).champion,
                alt: t.common.emptyChampionIconAlt,
                className: "size-6 opacity-50"
            })
        }), t.activeGame.empty), (championId)=>{
        const bannedChampionName = (0, $kj6DU.pipe)(championByKey(championId), (0, $9ddGv.Maybe).fold(()=>t.common.championKey(championId), (c)=>c.name));
        return (0, $9ddGv.Tuple).of(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $612718ebc5bdc341$export$6028b0e8199948bf), {
            ref: ref,
            championKey: championId,
            championName: bannedChampionName,
            as: "li",
            className: "relative size-10",
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "absolute top-[calc(100%_-_0.125rem)] w-20 origin-left -rotate-45 border-t-4 border-red-ban shadow-even shadow-black"
            })
        }), bannedChampionName);
    }));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                className: "flex flex-col items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "font-medium",
                        children: tooltip
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "text-xs",
                        children: t.activeGame.bannedAtTurn(bannedChampion.pickTurn)
                    })
                ]
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $lr3g3 = parcelRequire("lr3g3");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");





var $dglOy = parcelRequire("dglOy");

var $9ddGv = parcelRequire("9ddGv");
/* eslint-disable functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $dglOy = parcelRequire("dglOy");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $dR62Q = parcelRequire("dR62Q");


var $5MBh5 = parcelRequire("5MBh5");



var $8Wmxp = parcelRequire("8Wmxp");

var $1sXco = parcelRequire("1sXco");
const { round: $897a2720cadf5613$var$round } = (0, $dglOy.NumberUtils);
const $897a2720cadf5613$export$f46140fe718f016b = ({ championId: championId, masteries: masteries, name: name, shardsCount: shardsCount, positions: positions, factions: factions, setChampionShards: setChampionShards, isHistogram: isHistogram = false, tooltipHoverRef: overrideHoverRef, tooltipPlacementRef: tooltipPlacementRef, tooltipPlacement: tooltipPlacement = 'bottom', tooltipShouldHide: tooltipShouldHide, centerLevel: centerLevel = true, centerShards: centerShards = false, noShadow: noShadow = false })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const setShardsCount = (0, $exYeM.useMemo)(()=>setChampionShards !== null ? setChampionShards.run(championId) : null, [
        championId,
        setChampionShards
    ]);
    const filteredShardsCount = (0, $kj6DU.pipe)(shardsCount, (0, $9ddGv.Maybe).filter((n)=>0 < n));
    const hoverRef_ = (0, $exYeM.useRef)(null);
    const hoverRef = overrideHoverRef ?? hoverRef_;
    const tokens = (0, $kj6DU.pipe)((0, $9ddGv.Maybe).fromNullable(masteries), (0, $9ddGv.Maybe).chain((m)=>(0, $kj6DU.pipe)($897a2720cadf5613$var$repeatElements(Math.min(m.tokensEarned, m.markRequiredForNextLevel), (i)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.SparkSolid), {
                className: (0, $5MBh5.cx)('-mt-px h-2.5', (0, $a85e2b07dac54e12$export$5d6f9a79aaea5f31)(m.championLevel), {
                    'rotate-45': m.tokensEarned > m.markRequiredForNextLevel
                })
            }, i)), (0, $9ddGv.List).concat($897a2720cadf5613$var$repeatElements(Math.max(m.markRequiredForNextLevel - m.tokensEarned, 0), (i)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "m-0.5 mt-px size-1.5 rounded-1/2 border border-grey-500"
            }, m.tokensEarned + i))), (0, $9ddGv.NonEmptyArray).fromReadonlyArray)));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                ref: hoverRef_,
                className: "grid size-16",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: (0, $5MBh5.cx)('size-full overflow-hidden rounded-bl-xl bg-black area-1', isHistogram ? 'rounded-br-xl' : 'rounded-tr-xl', [
                            'shadow-even shadow-black',
                            !noShadow
                        ]),
                        children: masteries !== undefined && 0 < masteries.championLevel ? /*#__PURE__*/ (0, $aSiaI.jsx)($897a2720cadf5613$var$LevelSVG, {
                            championLevel: masteries.championLevel,
                            ...isHistogram ? {
                                // always full for histogram
                                championPointsUntilNextLevel: 0,
                                championPointsSinceLastLevel: 1,
                                stroke: 'currentColor'
                            } : {
                                championPointsUntilNextLevel: masteries.championPointsUntilNextLevel,
                                championPointsSinceLastLevel: masteries.championPointsSinceLastLevel,
                                stroke: `url(#${(0, $a85e2b07dac54e12$export$b06b879d73ad6baf)(masteries.championLevel)})`
                            }
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $612718ebc5bdc341$export$6028b0e8199948bf), {
                        championKey: championId,
                        championName: name,
                        className: (0, $5MBh5.cx)('size-13.5 self-center justify-self-center rounded-bl-lg bg-black text-2xs text-transparent area-1', isHistogram ? 'rounded-br-lg' : 'rounded-tr-lg')
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-start place-self-start area-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: (0, $5MBh5.cx)('flex overflow-hidden bg-black pb-0.75 pr-1.25 text-sm font-bold leading-2.5', (0, $9ddGv.Maybe).isNone(tokens) ? 'rounded-br-lg' : 'rounded-br', [
                                    'pl-0.5 pt-0.5',
                                    centerLevel
                                ], (0, $a85e2b07dac54e12$export$5d6f9a79aaea5f31)(masteries?.championLevel ?? 0)),
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: masteries !== undefined ? t.number(masteries.championLevel) : '?'
                                })
                            }),
                            (0, $kj6DU.pipe)(tokens, (0, $9ddGv.Maybe).fold(()=>null, (elements)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "-ml-0.5 flex gap-0.5 rounded-br bg-black pb-0.5 pr-0.5",
                                    children: elements
                                })))
                        ]
                    }),
                    (0, $kj6DU.pipe)(filteredShardsCount, (0, $9ddGv.Maybe).fold(()=>null, (shards)=>/*#__PURE__*/ (0, $aSiaI.jsx)($897a2720cadf5613$var$Shards, {
                            shardsCount: shards,
                            isLoading: setChampionShards?.isLoading === true,
                            setShardsCount: setShardsCount,
                            centerShards: centerShards
                        })))
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: hoverRef,
                placementRef: tooltipPlacementRef,
                placement: tooltipPlacement,
                shouldHide: tooltipShouldHide,
                className: "!p-0",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f6e5e62ee0cda291$export$c5545b89bafb388), {
                    masteries: masteries,
                    name: name,
                    shardsCount: filteredShardsCount,
                    positions: positions,
                    factions: factions
                })
            })
        ]
    });
};
const $897a2720cadf5613$var$totalLength = 100.5;
const $897a2720cadf5613$var$LevelSVG = ({ championLevel: championLevel, championPointsSinceLastLevel: championPointsSinceLastLevel, championPointsUntilNextLevel: championPointsUntilNextLevel, stroke: stroke })=>/*#__PURE__*/ (0, $aSiaI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        className: (0, $5MBh5.cx)('size-full', (0, $a85e2b07dac54e12$export$910cc3307d8b09db)(championLevel)),
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
            cx: "16",
            cy: "16",
            r: "16",
            stroke: stroke,
            strokeWidth: "16",
            strokeDasharray: $897a2720cadf5613$var$totalLength,
            strokeDashoffset: $897a2720cadf5613$var$totalLength - 0.96 * $897a2720cadf5613$var$levelPercents({
                championPointsSinceLastLevel: championPointsSinceLastLevel,
                championPointsUntilNextLevel: championPointsUntilNextLevel
            }),
            className: "origin-center rotate-[-128.5deg]"
        })
    });
function $897a2720cadf5613$var$levelPercents({ championPointsSinceLastLevel: championPointsSinceLastLevel, championPointsUntilNextLevel: championPointsUntilNextLevel }) {
    // championPointsSinceLastLevel can be negative because of new system
    // see server/services/MasteriesService#fixPointsSinceLastLevel
    if (championPointsSinceLastLevel < 0) return 0;
    const levelRange = championPointsSinceLastLevel + championPointsUntilNextLevel;
    if (levelRange === 0) return 0;
    return Math.min($897a2720cadf5613$var$round(100 * championPointsSinceLastLevel / levelRange), 100);
}
function $897a2720cadf5613$var$repeatElements(n, getA) {
    return (0, $kj6DU.pipe)(Array.from({
        length: Math.max(n, 0)
    }), (0, $9ddGv.List).mapWithIndex(getA));
}
const $897a2720cadf5613$var$Shards = ({ shardsCount: shardsCount, isLoading: isLoading, setShardsCount: setShardsCount, centerShards: centerShards = false })=>{
    const { t: t } = (0, $hZroh.useTranslation)('masteries');
    const addButtonRef = (0, $exYeM.useRef)(null);
    const removeButtonRef = (0, $exYeM.useRef)(null);
    const addShardCount = (0, $exYeM.useCallback)(()=>setShardsCount?.(shardsCount + 1), [
        setShardsCount,
        shardsCount
    ]);
    const removeShardCount = (0, $exYeM.useCallback)(()=>setShardsCount?.(shardsCount - 1), [
        setShardsCount,
        shardsCount
    ]);
    const canRemoveShard = 1 <= shardsCount;
    const canAddShard = shardsCount < 9;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "group relative flex h-2.5 flex-row-reverse items-end place-self-end area-1",
        children: [
            setShardsCount !== null ? /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('absolute -right-px z-10 hidden flex-col justify-center overflow-hidden bg-black p-px group-hover:flex', [
                    'gap-4',
                    canAddShard === canRemoveShard
                ], canAddShard ? '-top-4 rounded-t-5' : '-bottom-4 rounded-tl-5', [
                    'rounded-b-5',
                    canRemoveShard
                ]),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: (0, $5MBh5.cx)('flex', [
                            'mb-3',
                            !canRemoveShard
                        ], [
                            'hidden',
                            !canAddShard
                        ]),
                        children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                            className: "w-3 text-goldenrod-bis"
                        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                    ref: addButtonRef,
                                    type: "button",
                                    onClick: addShardCount,
                                    className: "w-3 rounded-t bg-goldenrod text-black",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.AddOutline), {
                                        className: "w-full"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                    hoverRef: addButtonRef,
                                    placement: "right",
                                    className: "z-10 !text-xs",
                                    children: t.addShard
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: (0, $5MBh5.cx)('flex', [
                            'mt-3.75',
                            !canAddShard
                        ], [
                            'hidden',
                            !canRemoveShard
                        ]),
                        children: isLoading ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                            className: "w-3 text-goldenrod-bis"
                        }) : /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                                    ref: removeButtonRef,
                                    type: "button",
                                    onClick: removeShardCount,
                                    className: "w-3 rounded-b bg-goldenrod text-black",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.RemoveOutline), {
                                        className: "w-full"
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                    hoverRef: removeButtonRef,
                                    placement: "right",
                                    className: "z-10 !text-xs",
                                    children: t.removeShard
                                })
                            ]
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: (0, $5MBh5.cx)('relative z-10 flex items-center justify-center overflow-hidden rounded-tl-lg bg-black pt-1 font-semibold', centerShards ? 'w-4 pl-1' : (0, $5MBh5.cx)('pl-1.5 group-hover:w-4 group-hover:pl-1', [
                    'group-hover:pt-0.5',
                    canAddShard
                ])),
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "text-15",
                    children: shardsCount
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "relative z-10 -mr-0.75 rounded-tl bg-black pl-px pt-px",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.SparklesSharp), {
                    className: "size-2.5 rotate-180"
                })
            })
        ]
    });
};




var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $l8OHp = parcelRequire("l8OHp");

var $9ddGv = parcelRequire("9ddGv");

var $hZroh = parcelRequire("hZroh");

var $dR62Q = parcelRequire("dR62Q");

var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $l8OHp = parcelRequire("l8OHp");

var $hZroh = parcelRequire("hZroh");

var $5MBh5 = parcelRequire("5MBh5");
const $d6053fec8850de9e$export$de0c91b9dbecc60d = (tier)=>`https://raw.communitydragon.org/latest/plugins/rcp-fe-lol-static-assets/global/default/images/ranked-mini-crests/${tier.toLowerCase()}.svg`;
const $d6053fec8850de9e$export$d840247cdba25bd3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ tier: tier, rank: rank, className: className, style: style, ...props }, ref)=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        ref: ref,
        className: (0, $5MBh5.cx)('flex items-center overflow-hidden', className),
        style: style,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
            src: $d6053fec8850de9e$export$de0c91b9dbecc60d(tier),
            alt: tier === 'unranked' ? t.league.unrankedIconAlt : t.league.tierRankAlt(tier, (0, $l8OHp.LeagueTier).isRegularTier(tier) ? rank : undefined),
            className: (0, $5MBh5.cx)('mr-[-100%] max-w-none', $d6053fec8850de9e$var$imgClassName[tier]),
            ...props
        })
    });
});
const $d6053fec8850de9e$var$imgClassName = {
    unranked: 'w-[37%] ml-[31.5%]',
    IRON: 'w-[86%] mt-[9%] ml-[4.5%]',
    BRONZE: 'w-[90%] mt-[9%] ml-[5%]',
    SILVER: 'w-[90%] mt-[9%] ml-[5%]',
    GOLD: 'w-[92%] mt-[14.5%] ml-[6.5%]',
    PLATINUM: 'w-[106%] mt-[19%] ml-[-3%]',
    EMERALD: 'w-[106%] mt-[19%] ml-[-3%]',
    DIAMOND: 'w-[106%] mt-[19%] ml-[-3%]',
    MASTER: 'w-[106%] ml-[-6%]',
    GRANDMASTER: 'w-[106%] ml-[-6%]',
    CHALLENGER: 'w-[106%] ml-[-6%]'
};



var $1sXco = parcelRequire("1sXco");
const $0be8ba81f8425294$export$9fc0e0d0ecb98c84 = ({ variant: variant = 'base', queue: queue, league: league, reverse: reverse = false, tooltipShouldHide: tooltipShouldHide, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const currentSplitRef = (0, $exYeM.useRef)(null);
    const currentSplitIconRef = (0, $exYeM.useRef)(null);
    const previousSplitRef = (0, $exYeM.useRef)(null);
    const { tier: tier, rank: rank, description: description, subDescription: subDescription, currentSplitTooltip: currentSplitTooltip } = (0, $kj6DU.pipe)(league.currentSplit, (0, $9ddGv.Maybe).fold(()=>({
            tier: 'unranked',
            rank: 'I',
            description: t.league.unranked,
            subDescription: undefined
        }), ({ leaguePoints: leaguePoints, wins: wins, losses: losses, miniSeriesProgress: miniSeriesProgress, ...s })=>{
        const tierRank = t.league.tierRank(s.tier, (0, $l8OHp.LeagueTier).isRegularTier(s.tier) ? s.rank : undefined);
        const games = wins + losses;
        return {
            tier: s.tier,
            rank: s.rank,
            description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        children: tierRank
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        children: t.league.leaguePoints(leaguePoints)
                    })
                ]
            }),
            subDescription: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "font-semibold",
                        children: t.percents(games === 0 ? 0 : Math.round(100 * wins / games))
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "text-grey-400",
                        children: t.number(games, {
                            withParenthesis: true
                        })
                    })
                ]
            }),
            currentSplitTooltip: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    (0, $kj6DU.pipe)(miniSeriesProgress, (0, $9ddGv.Maybe).fold(()=>null, (progress)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "col-span-2 mb-1 flex items-center gap-1 justify-self-center",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "mr-1",
                                    children: t.league.serie
                                }),
                                progress.map((p, i)=>// eslint-disable-next-line react/no-array-index-key
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: $0be8ba81f8425294$var$renderProgress(p)
                                    }, i))
                            ]
                        }))),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($0be8ba81f8425294$var$WinLoss, {
                        value: wins,
                        label: t.league.wins,
                        valueClassName: "text-green"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($0be8ba81f8425294$var$WinLoss, {
                        value: losses,
                        label: t.league.losses,
                        valueClassName: "text-red mb-0.5"
                    })
                ]
            })
        };
    }));
    const isSomeCurrentSplit = (0, $9ddGv.Maybe).isSome(league.currentSplit);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                ref: currentSplitRef,
                className: (0, $5MBh5.cx)('-mb-1 grid grid-cols-[auto_auto] items-center', [
                    'gap-3',
                    variant === 'base'
                ], [
                    'gap-2',
                    variant === 'small'
                ], className),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6053fec8850de9e$export$d840247cdba25bd3), {
                        ref: currentSplitIconRef,
                        tier: tier,
                        rank: rank,
                        className: (0, $5MBh5.cx)({
                            'size-16': variant === 'base',
                            'size-9': variant === 'small',
                            'col-start-2': reverse
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: (0, $5MBh5.cx)('flex text-sm', [
                            'col-start-1 row-start-1',
                            reverse
                        ], isSomeCurrentSplit ? (0, $5MBh5.cx)('flex-col', reverse ? 'items-end' : 'items-start') : (0, $5MBh5.cx)('items-center gap-2', [
                            'flex-row-reverse',
                            reverse
                        ]), [
                            'leading-4',
                            variant === 'small'
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: (0, $5MBh5.cx)('flex gap-1.5 whitespace-nowrap', {
                                    'font-semibold': isSomeCurrentSplit,
                                    'text-grey-400': variant === 'small'
                                }),
                                children: description
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                className: (0, $5MBh5.cx)('flex gap-3', [
                                    'flex-row-reverse',
                                    reverse
                                ]),
                                children: [
                                    subDescription,
                                    (0, $kj6DU.pipe)(league.previousSplit, (0, $9ddGv.Maybe).fold(()=>null, (s)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                            ref: previousSplitRef,
                                            className: "flex items-center text-grey-400",
                                            children: [
                                                "(",
                                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d6053fec8850de9e$export$d840247cdba25bd3), {
                                                    tier: s.tier,
                                                    rank: s.rank,
                                                    className: "mx-0.5 size-5"
                                                }),
                                                ")"
                                            ]
                                        })))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                hoverRef: currentSplitRef,
                placementRef: currentSplitIconRef,
                shouldHide: tooltipShouldHide,
                className: "grid grid-cols-[auto_auto] gap-x-1.5",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "col-span-2 justify-self-center font-semibold",
                        children: t.league.label[queue]
                    }),
                    currentSplitTooltip,
                    (0, $kj6DU.pipe)(league.previousSplit, (0, $9ddGv.Maybe).fold(()=>null, (s)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                            className: "col-span-2 flex items-center gap-1.5 whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: t.league.previousSplit
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "font-semibold",
                                    children: t.league.tierRank(s.tier, (0, $l8OHp.LeagueTier).isRegularTier(s.tier) ? s.rank : undefined)
                                })
                            ]
                        })))
                ]
            })
        ]
    });
};
const $0be8ba81f8425294$var$WinLoss = ({ value: value, label: label, valueClassName: valueClassName })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: (0, $5MBh5.cx)('justify-self-end font-semibold', valueClassName),
                children: value
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: label(value)
            })
        ]
    });
const $0be8ba81f8425294$var$renderProgress = (progress)=>{
    switch(progress){
        case 'W':
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CheckMarkSharp), {
                className: "h-4 text-green"
            });
        case 'L':
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CloseFilled), {
                className: "h-4 text-red"
            });
        case 'N':
            return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "\u2014"
            });
    }
};





var $1sXco = parcelRequire("1sXco");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $exYeM = parcelRequire("exYeM");
const $365838d4a22316ec$export$5ae0e7fb2375230f = (f)=>{
    const ref = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(()=>{
        const onResize = ()=>{
            if (ref.current !== null) f(ref.current);
        };
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, [
        f
    ]);
    return (0, $exYeM.useCallback)((e)=>{
        // eslint-disable-next-line functional/immutable-data
        ref.current = e;
        if (e !== null) f(e);
    }, [
        f
    ]);
};



var $5MBh5 = parcelRequire("5MBh5");

var $aSiaI = parcelRequire("aSiaI");

var $gpfu2 = parcelRequire("gpfu2");
var $cF6yJ = parcelRequire("cF6yJ");
var $aRVRH = parcelRequire("aRVRH");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");



var $5MBh5 = parcelRequire("5MBh5");
const $cb54dcc6a5bed971$export$aa446a51db8c710 = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ data: data, reverse: reverse }, ref)=>{
    const { initial: initial, more: more } = (0, $exYeM.useMemo)(()=>$cb54dcc6a5bed971$var$partitionStats2Cols(data, reverse), [
        data,
        reverse
    ]);
    const uls = (0, $kj6DU.pipe)([
        initial,
        more
    ], (0, $9ddGv.List).filterMapWithIndex((i, lis)=>(0, $9ddGv.List).isNonEmpty(lis) ? (0, $9ddGv.Maybe).some(/*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
            children: lis
        }, i)) : (0, $9ddGv.Maybe).none), reverse ? (0, $9ddGv.List).reverse : (0, $kj6DU.identity));
    if ((0, $9ddGv.List).isEmpty(uls)) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        ref: ref,
        className: (0, $5MBh5.cx)('grid items-center py-1 text-2xs', [
            'gap-1',
            uls.length > 1
        ]),
        style: {
            gridTemplateColumns: `repeat(${uls.length}, auto)`
        },
        children: uls
    });
});
const $cb54dcc6a5bed971$var$limitSize = 22.5 /* (padding) */ ;
function $cb54dcc6a5bed971$var$partitionStats2Cols(data, reverse) {
    const changes = (0, $ebb708240c48dd63$export$90c20a432e29f511)(data);
    const sizes_ = changes.map((change)=>(0, $981bed87d249c540$export$9e4948ce114eaafb)[change.type]);
    const totalSize = (0, $kj6DU.pipe)(sizes_, (0, $gpfu2).concatAll((0, $cF6yJ).MonoidSum));
    if (totalSize <= $cb54dcc6a5bed971$var$limitSize) return {
        initial: $cb54dcc6a5bed971$var$toElements(reverse)(changes),
        more: []
    };
    const { left: initial, right: more } = (0, $kj6DU.pipe)((0, $ebb708240c48dd63$export$35cd56382745d8d0)({
        ...(0, $981bed87d249c540$export$9e4948ce114eaafb),
        limit: totalSize / 2
    })(changes), (0, $aRVRH).bimap($cb54dcc6a5bed971$var$toElements(reverse), $cb54dcc6a5bed971$var$toElements(reverse)));
    return {
        initial: initial,
        more: more
    };
}
const $cb54dcc6a5bed971$var$toElements = (reverse)=>(0, $9ddGv.List).map((change)=>{
        switch(change.type){
            case 'stat':
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $981bed87d249c540$export$4c157fb38ec75dc), {
                    name: change.name,
                    value: change.value,
                    reverse: reverse
                }, change.name);
            case 'skill':
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $981bed87d249c540$export$8eae7b5b63fcf71d), {
                    skill: change.skill,
                    changes: change.changes,
                    reverse: reverse
                }, change.skill);
        }
    });



var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");


var $9ddGv = parcelRequire("9ddGv");


var $5MBh5 = parcelRequire("5MBh5");
const $ba4339275a9377aa$export$12dda5e6511ff2f1 = ({ runeStyleById: runeStyleById, runeById: runeById, perks: perks, reverse: reverse, tooltipShouldHide: tooltipShouldHide })=>{
    const { keyStone: keyStone, primaryPath: primaryPath, secondaryPath: secondaryPath, shards: shards } = (0, $exYeM.useMemo)(()=>{
        const findRunes = $ba4339275a9377aa$var$getFindRunes(runeStyleById, runeById, perks.perkIds);
        const primaryPath_ = findRunes(perks.perkStyle);
        const secondaryPath_ = findRunes(perks.perkSubStyle);
        const pathIds = (0, $kj6DU.pipe)(primaryPath_, (0, $9ddGv.List).concat(secondaryPath_), (0, $9ddGv.List).map((rune)=>rune.id));
        return {
            keyStone: (0, $9ddGv.List).head(primaryPath_),
            primaryPath: (0, $kj6DU.pipe)((0, $9ddGv.List).tail(primaryPath_), (0, $9ddGv.Maybe).getOrElseW(()=>[])),
            secondaryPath: secondaryPath_,
            shards: (0, $kj6DU.pipe)(perks.perkIds, (0, $9ddGv.List).difference((0, $79273afeecdb2db1$export$96c66196b0b4f739).Eq)(pathIds), (0, $9ddGv.List).filterMap(runeById))
        };
    }, [
        perks,
        runeById,
        runeStyleById
    ]);
    const nonEmpty = (0, $9ddGv.List).isNonEmpty(primaryPath) || (0, $9ddGv.List).isNonEmpty(secondaryPath) || (0, $9ddGv.List).isNonEmpty(shards);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: (0, $5MBh5.cx)('relative flex min-h-17 gap-1.5', reverse ? 'flex-row-reverse items-end' : 'items-start'),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('grid gap-2', [
                    reverse ? 'pr-1' : 'pl-1',
                    nonEmpty
                ]),
                style: reverse ? {
                    gridTemplateAreas: '"shards" "secondary" "primary"',
                    gridTemplateRows: '.75rem 1.25rem 1.25rem'
                } : {
                    gridTemplateAreas: '"primary" "secondary" "shards"',
                    gridTemplateRows: '1.25rem 1.25rem .75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($ba4339275a9377aa$var$RunePath, {
                        runes: primaryPath,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "gap-1 area-[primary]"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($ba4339275a9377aa$var$RunePath, {
                        runes: secondaryPath,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "gap-1 area-[secondary]"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($ba4339275a9377aa$var$RunePath, {
                        runes: shards,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "gap-1.5 area-[shards]",
                        liClassName: "!size-3 overflow-hidden",
                        runeClassName: "!w-[calc(100%_+_0.5rem)] -m-1 max-w-none"
                    })
                ]
            }),
            (0, $9ddGv.List).isEmpty(secondaryPath) && (0, $kj6DU.pipe)(runeStyleById(perks.perkSubStyle), (0, $9ddGv.Maybe).fold(()=>null, (rune)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: (0, $5MBh5.cx)('absolute size-5', reverse ? 'left-4 top-1' : 'bottom-1 right-4'),
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $34b3a579085a2719$export$dd4e3679fae405b5), {
                        icon: rune.icon,
                        name: rune.name,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "w-full"
                    })
                }))),
            (0, $kj6DU.pipe)(keyStone, (0, $9ddGv.Maybe).fold(()=>null, (r)=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: (0, $5MBh5.cx)('flex size-9', reverse ? '-mb-1.5' : '-mt-1.5'),
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $34b3a579085a2719$export$dd4e3679fae405b5), {
                        icon: r.iconPath,
                        name: r.name,
                        description: r.longDesc,
                        tooltipShouldHide: tooltipShouldHide,
                        className: "w-full"
                    })
                })))
        ]
    });
};
const $ba4339275a9377aa$var$getFindRunes = (runeStyleById, runeById, runeIds)=>(styleId)=>{
        const runesInStyle = (0, $kj6DU.pipe)(runeStyleById(styleId), (0, $9ddGv.Maybe).fold(()=>[], (style)=>(0, $kj6DU.pipe)(style.slots, (0, $9ddGv.List).chain((slot)=>slot.runes))));
        return (0, $kj6DU.pipe)(runeIds, (0, $9ddGv.List).filterMap((0, $kj6DU.flow)((0, $9ddGv.Maybe).fromPredicate((runeId)=>(0, $9ddGv.List).elem((0, $79273afeecdb2db1$export$96c66196b0b4f739).Eq)(runeId, runesInStyle)), (0, $9ddGv.Maybe).chain(runeById))));
    };
const $ba4339275a9377aa$var$RunePath = ({ runes: runes, reverse: reverse, tooltipShouldHide: tooltipShouldHide, className: className, liClassName: liClassName, runeClassName: runeClassName })=>/*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
        className: (0, $5MBh5.cx)('flex justify-end', [
            'flex-row-reverse',
            !reverse
        ], className),
        children: runes.map((r, i)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                className: (0, $5MBh5.cx)('w-5', liClassName),
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $34b3a579085a2719$export$dd4e3679fae405b5), {
                    icon: r.iconPath,
                    name: r.name,
                    description: r.longDesc,
                    tooltipShouldHide: tooltipShouldHide,
                    className: (0, $5MBh5.cx)('w-full', runeClassName)
                })
            }, i))
    });



var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $3Em0q = parcelRequire("3Em0q");

var $lfkrA = parcelRequire("lfkrA");

var $kaLCO = parcelRequire("kaLCO");

var $appXD = parcelRequire("appXD");

var $gkOpi = parcelRequire("gkOpi");

var $dglOy = parcelRequire("dglOy");

var $9ddGv = parcelRequire("9ddGv");


var $1sXco = parcelRequire("1sXco");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $dR62Q = parcelRequire("dR62Q");

var $iz2wS = parcelRequire("iz2wS");

var $aMofi = parcelRequire("aMofi");

var $5MBh5 = parcelRequire("5MBh5");
const { round: $9f6811c319faefdb$var$round } = (0, $dglOy.NumberUtils);
const $9f6811c319faefdb$var$allLevels = new Set((0, $3Em0q.ChampionLevel).values);
const $9f6811c319faefdb$export$4cacbff04efabb77 = ({ platform: platform, riotId: riotId, profileIconId: profileIconId, masteries: masteries, premadeId: premadeId, summonerLevel: summonerLevel, role: role, mainRoles: mainRoles, reverse: reverse, tooltipShouldHide: tooltipShouldHide, padding: padding })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const { assets: assets } = (0, $fcoXO.useStaticData)();
    const summonerLevelRef = (0, $exYeM.useRef)(null);
    const percentsRef = (0, $exYeM.useRef)(null);
    const totalMasteriesRef = (0, $exYeM.useRef)(null);
    const mainRolesRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex flex-col justify-center gap-1 pt-2",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('flex items-center gap-3', [
                    'flex-row-reverse',
                    reverse
                ]),
                children: [
                    (0, $kj6DU.pipe)(premadeId, (0, $9ddGv.Maybe).fold(()=>null, (id)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: (0, $5MBh5.cx)('flex items-center gap-1 text-xs font-semibold text-white', padding, {
                                'flex-row-reverse': !reverse
                            }),
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.PeopleSharp), {
                                    className: "h-3"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "mt-0.5",
                                    children: id
                                })
                            ]
                        }))),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: (0, $5MBh5.cx)('flex grow', reverse ? 'justify-start' : 'justify-end'),
                        children: (0, $kj6DU.pipe)(riotId, (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "leading-5 text-grey-500",
                                children: t.activeGame.streamerMode
                            }), (id)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("a", {
                                href: (0, $iz2wS.appRoutes).platformRiotId(platform, id, {
                                    view: 'histogram',
                                    level: $9f6811c319faefdb$var$allLevels
                                }),
                                target: "_blank",
                                rel: "noreferrer",
                                className: "flex items-baseline gap-0.5 whitespace-pre",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "text-lg font-semibold leading-6 text-goldenrod",
                                        children: (0, $kaLCO.GameName).unwrap(id.gameName)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "leading-5 text-grey-500",
                                        children: [
                                            "#",
                                            (0, $gkOpi.TagLine).unwrap(id.tagLine)
                                        ]
                                    })
                                ]
                            })))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('flex items-center gap-2', [
                    'flex-row-reverse',
                    !reverse
                ]),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: assets.summonerIcon(profileIconId),
                        alt: t.common.summonerIconAlt((0, $kj6DU.pipe)(riotId, (0, $9ddGv.Maybe).fold(()=>t.activeGame.streamerMode, (0, $appXD.RiotId).stringify))),
                        className: "w-12"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: (0, $5MBh5.cx)('flex flex-col text-sm leading-3', reverse ? 'items-start' : 'items-end'),
                        children: [
                            (0, $kj6DU.pipe)(summonerLevel, (0, $9ddGv.Maybe).fold(()=>null, (lvl)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            ref: summonerLevelRef,
                                            className: "text-grey-400",
                                            children: t.common.level(lvl, 'font-semibold')
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                            hoverRef: summonerLevelRef,
                                            children: t.common.summonerLevel
                                        })
                                    ]
                                }))),
                            (0, $kj6DU.pipe)(masteries, (0, $9ddGv.Maybe).fold(()=>null, (m)=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    className: "mt-1.25",
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                        className: "flex gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                ref: percentsRef,
                                                className: "whitespace-nowrap font-semibold",
                                                children: t.common.percents($9f6811c319faefdb$var$round(m.questPercents, 1))
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                                hoverRef: percentsRef,
                                                shouldHide: tooltipShouldHide,
                                                children: t.activeGame.theQuestProgression
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                ref: totalMasteriesRef,
                                                className: "whitespace-nowrap text-grey-400",
                                                children: t.activeGame.totals(m.totalMasteryLevel, (0, $aMofi.TranslationUtils).numberUnit(t.common)(m.totalMasteryPoints), 'font-semibold')
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                                                hoverRef: totalMasteriesRef,
                                                className: "flex flex-col items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        children: t.activeGame.masteryScoreAndPoints
                                                    }),
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        children: t.activeGame.otpIndex(m.otpIndex, 'font-semibold')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }))),
                            (0, $9ddGv.List).isNonEmpty(mainRoles) ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                        ref: mainRolesRef,
                                        className: "mt-0.75 flex items-start gap-1",
                                        children: mainRoles.map((r)=>{
                                            const isCurrent = (0, $kj6DU.pipe)(role, (0, $9ddGv.Maybe).elem((0, $lfkrA.ChampionPosition).Eq)(r));
                                            return /*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
                                                className: "relative flex flex-col items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $62c858348d1b2db2$export$12e8b9f23d53a496), {
                                                        position: r,
                                                        className: (0, $5MBh5.cx)('w-4', [
                                                            'text-cyan-200',
                                                            isCurrent
                                                        ])
                                                    }),
                                                    isCurrent ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                        className: "absolute -bottom-1 size-0.5 rounded-1/2 bg-cyan-200"
                                                    }) : null
                                                ]
                                            }, r);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                                        hoverRef: mainRolesRef,
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                children: [
                                                    t.activeGame.mainRoles,
                                                    ' ',
                                                    mainRoles.map((r, i)=>{
                                                        const isCurrent = (0, $kj6DU.pipe)(role, (0, $9ddGv.Maybe).elem((0, $lfkrA.ChampionPosition).Eq)(r));
                                                        return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                                    className: (0, $5MBh5.cx)('font-semibold', [
                                                                        'text-cyan-200',
                                                                        isCurrent
                                                                    ]),
                                                                    children: t.common.labels.position[r]
                                                                }),
                                                                i !== mainRoles.length - 1 ? ', ' : null
                                                            ]
                                                        }, r);
                                                    })
                                                ]
                                            }),
                                            (0, $kj6DU.pipe)(role, (0, $9ddGv.Maybe).fold(()=>null, (r)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    children: [
                                                        t.activeGame.currentRole,
                                                        ' ',
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "font-semibold text-cyan-200",
                                                            children: t.common.labels.position[r]
                                                        })
                                                    ]
                                                })))
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $1sXco = parcelRequire("1sXco");

var $5MBh5 = parcelRequire("5MBh5");
const $c7a8704e7dfd5b00$export$9ef0be9c867d1434 = ({ niceness: niceness, label: label, tooltip: tooltip })=>{
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                ref: ref,
                className: (0, $5MBh5.cx)('whitespace-nowrap rounded-b px-0.5 text-white shadow-even shadow-black saturate-[0.7]', $c7a8704e7dfd5b00$var$nicenessClassName[niceness]),
                children: label
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                className: "max-w-xs",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: tooltip
                    },
                    className: "whitespace-normal"
                })
            })
        ]
    });
};
const $c7a8704e7dfd5b00$var$nicenessClassName = {
    '-1': 'bg-poro-red',
    0: 'bg-poro-orange',
    1: 'bg-poro-green',
    2: 'bg-poro-blue'
};


const { round: $9119c22d5d39a2bb$var$round } = (0, $dglOy.NumberUtils);
const $9119c22d5d39a2bb$var$gridTotalCols = 9;
const $9119c22d5d39a2bb$var$bevelWidth = 32 // px
;
const $9119c22d5d39a2bb$var$inspirationPath = (0, $961cbdbae1c3c6dd$export$597b42c1d60925a3)(8300);
const $9119c22d5d39a2bb$export$2d6247fb34949a13 = {
    false: {
        gridTemplateColumns: `1fr repeat(7,auto) ${$9119c22d5d39a2bb$var$bevelWidth}px`
    },
    true: {
        gridTemplateColumns: `${$9119c22d5d39a2bb$var$bevelWidth}px repeat(7,auto) 1fr`
    }
};
const $9119c22d5d39a2bb$export$5cfb5b4baffb5bc9 = ({ summonerSpellByKey: summonerSpellByKey, runeStyleById: runeStyleById, runeById: runeById, itemById: itemById, platform: platform, gameMode: gameMode, participant: { riotId: riotId, profileIconId: profileIconId, leagues: leagues, championId: championId, masteries: masteries, shardsCount: shardsCount, spell1Id: spell1Id, spell2Id: spell2Id, perks: maybePerks, premadeId: premadeId, summonerLevel: summonerLevel, championRankedStats: championRankedStats, role: role, mainRoles: mainRoles, tags: tags }, shouldWrap: shouldWrap, highlight: highlight, reverse: reverse, index: index, isLast: isLast, isDragging: isDragging, springStyle: springStyle, gestureProps: gestureProps })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const { championByKey: championByKey } = (0, $fcoXO.useStaticData)();
    const championRef = (0, $exYeM.useRef)(null);
    const championWinRateRef = (0, $exYeM.useRef)(null);
    const mapChangesRef = (0, $exYeM.useRef)(null);
    const totalHasteRef = (0, $exYeM.useRef)(null);
    const spells = [
        spell1Id,
        spell2Id
    ].map((id)=>(0, $9ddGv.Tuple).of(id, summonerSpellByKey(id)));
    const [totalHaste, setTotalHaste] = (0, $exYeM.useState)($9119c22d5d39a2bb$var$foldGameMode(gameMode, {
        onAram: 70,
        onUrf: 300,
        default: 0
    }));
    const onToggleHaste = (0, $exYeM.useCallback)((addHaste)=>setTotalHaste((h)=>h + addHaste), []);
    const hasInspirationPath = (0, $kj6DU.pipe)(maybePerks, (0, $9ddGv.Maybe).exists((perks)=>(0, $961cbdbae1c3c6dd$export$597b42c1d60925a3).Eq.equals(perks.perkStyle, $9119c22d5d39a2bb$var$inspirationPath) || (0, $961cbdbae1c3c6dd$export$597b42c1d60925a3).Eq.equals(perks.perkSubStyle, $9119c22d5d39a2bb$var$inspirationPath)));
    /** `runeById`, but only if rune style exists for rune `id` */ const filteredRuneById = (0, $exYeM.useCallback)((id)=>{
        if ((0, $79273afeecdb2db1$export$96c66196b0b4f739).Eq.equals(id, (0, $4c07dd73d95864fa$export$e3b0796a61ebb801).id)) return hasInspirationPath ? runeById(id) : (0, $9ddGv.Maybe).none;
        return runeById(id);
    }, [
        hasInspirationPath,
        runeById
    ]);
    const hasCosmicInsight = (0, $kj6DU.pipe)(maybePerks, (0, $9ddGv.Maybe).exists((perks)=>(0, $9ddGv.List).elem((0, $79273afeecdb2db1$export$96c66196b0b4f739).Eq)((0, $4c07dd73d95864fa$export$e3b0796a61ebb801).id, perks.perkIds)));
    const champion = championByKey(championId);
    const tooltipShouldHide = isDragging;
    const squareProps = (0, $kj6DU.pipe)(champion, (0, $9ddGv.Maybe).map((c)=>({
            championId: championId,
            name: c.name,
            shardsCount: (0, $kj6DU.pipe)(shardsCount, (0, $9ddGv.Maybe).filter((n)=>n !== 0)),
            positions: c.positions,
            factions: c.factions,
            setChampionShards: null,
            masteries: (0, $kj6DU.pipe)(masteries, (0, $9ddGv.Maybe).chain((m)=>m.champion), (0, $9ddGv.Maybe).fold(()=>(0, $kj6DU.pipe)(riotId, (0, $9ddGv.Maybe).map(()=>({
                        tokensEarned: 0,
                        markRequiredForNextLevel: 0,
                        championLevel: 0,
                        championPoints: 0,
                        championPointsSinceLastLevel: 0,
                        championPointsUntilNextLevel: 0,
                        percents: 0
                    }))), (m)=>(0, $9ddGv.Maybe).some({
                    ...m,
                    percents: (0, $7c2fab9890607f52$export$6d7a29d4960e3d83).championPercents(m)
                })), (0, $9ddGv.Maybe).toUndefined),
            tooltipShouldHide: tooltipShouldHide,
            centerShards: true,
            noShadow: true
        })));
    const [bevelHeight, setBevelHeight] = (0, $exYeM.useState)(0);
    const onBevelMount = (0, $365838d4a22316ec$export$5ae0e7fb2375230f)((0, $exYeM.useCallback)((e)=>setBevelHeight(e.offsetHeight), []));
    const bevelRotate = (0, $exYeM.useMemo)(()=>Math.atan($9119c22d5d39a2bb$var$bevelWidth / bevelHeight), [
        bevelHeight
    ]);
    const padding = reverse ? 'pr-2.5' : 'pl-2.5';
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($9119c22d5d39a2bb$var$Li, {
        reverse: reverse,
        gridRowStart: 3 * index + 1,
        springStyle: springStyle,
        gestureProps: gestureProps,
        className: isDragging ? 'cursor-grabbing' : 'cursor-grab',
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                gridRowOffset: 1,
                gridColStart: 1,
                className: (0, $5MBh5.cx)('h-4 text-xs', reverse ? 'col-span-9' : 'col-span-8'),
                children: (0, $9ddGv.List).isNonEmpty(tags) ? /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                    className: (0, $5MBh5.cx)('flex items-center justify-end gap-1 px-2', {
                        'flex-row-reverse': reverse
                    }),
                    children: tags.map((tag, i)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c7a8704e7dfd5b00$export$9ef0be9c867d1434), {
                            ...tag
                        }, i))
                }) : null
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                gridColStart: 1,
                className: "col-span-8 bg-current shadow-even shadow-black"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                ref: onBevelMount,
                gridColStart: 8,
                dontResetColor: true,
                className: "col-span-2 overflow-hidden",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                    className: "relative",
                    style: {
                        height: bevelHeight
                    },
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: (0, $5MBh5.cx)('absolute size-125 bg-current shadow-even shadow-black', reverse ? 'bottom-0 origin-bottom-left' : 'right-0 origin-top-right'),
                        style: {
                            transform: `rotate(${bevelRotate}rad)`
                        }
                    })
                })
            }),
            highlight ? /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                gridColStart: 1,
                className: (0, $5MBh5.cx)('border-goldenrod-bis', reverse ? 'border-r-4' : 'border-l-4')
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                gridColStart: 2,
                className: padding,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9f6811c319faefdb$export$4cacbff04efabb77), {
                    platform: platform,
                    riotId: riotId,
                    profileIconId: profileIconId,
                    masteries: masteries,
                    premadeId: premadeId,
                    summonerLevel: summonerLevel,
                    role: role,
                    mainRoles: mainRoles,
                    reverse: reverse,
                    tooltipShouldHide: tooltipShouldHide,
                    padding: padding
                })
            }),
            (0, $kj6DU.pipe)(leagues, (0, $9ddGv.Maybe).fold(()=>null, ({ soloDuo: soloDuo, flex: flex })=>/*#__PURE__*/ (0, $aSiaI.jsxs)($9119c22d5d39a2bb$var$Cell, {
                    gridColStart: 3,
                    className: (0, $5MBh5.cx)('flex flex-col justify-center gap-3', reverse ? 'items-end' : 'items-start', padding),
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0be8ba81f8425294$export$9fc0e0d0ecb98c84), {
                            variant: "small",
                            queue: "soloDuo",
                            league: soloDuo,
                            reverse: reverse,
                            tooltipShouldHide: tooltipShouldHide,
                            className: "-mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0be8ba81f8425294$export$9fc0e0d0ecb98c84), {
                            variant: "small",
                            queue: "flex",
                            league: flex,
                            reverse: reverse,
                            tooltipShouldHide: tooltipShouldHide
                        })
                    ]
                }))),
            (0, $kj6DU.pipe)(championRankedStats, (0, $9ddGv.Maybe).fold(()=>null, ({ wins: wins, losses: losses, kills: kills, deaths: deaths, assists: assists })=>{
                const played = wins + losses;
                const percents = played === 0 ? 0 : Math.round(100 * wins / played);
                return /*#__PURE__*/ (0, $aSiaI.jsxs)($9119c22d5d39a2bb$var$Cell, {
                    gridColStart: 4,
                    className: (0, $5MBh5.cx)('flex flex-col justify-center text-sm', padding),
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            ref: championWinRateRef,
                            className: (0, $5MBh5.cx)('flex flex-col', reverse ? 'items-start' : 'items-end'),
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "whitespace-nowrap text-grey-400",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "font-semibold text-green",
                                            children: t.common.number(kills)
                                        }),
                                        " /",
                                        ' ',
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "font-semibold text-red",
                                            children: t.common.number(deaths)
                                        }),
                                        " /",
                                        ' ',
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "font-semibold text-goldenrod",
                                            children: t.common.number(assists)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                    className: "flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "font-semibold",
                                            children: t.common.percents(percents)
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                            className: "text-grey-400",
                                            children: t.common.number(played, {
                                                withParenthesis: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                            hoverRef: championWinRateRef,
                            className: "grid grid-cols-[auto_auto] gap-x-1.5 gap-y-1",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "justify-self-end font-semibold text-green",
                                    children: wins
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: t.common.league.wins(wins)
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    className: "justify-self-end font-semibold text-red",
                                    children: losses
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: t.common.league.losses(losses)
                                })
                            ]
                        })
                    ]
                });
            })),
            /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                gridColStart: 5,
                className: (0, $5MBh5.cx)('flex flex-col gap-px py-1 text-xs leading-3', padding),
                children: (0, $kj6DU.pipe)(squareProps, (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "invisible",
                                children: "h"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "size-16 bg-black text-2xs",
                                children: t.common.championKey(championId)
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "invisible",
                                children: "h"
                            })
                        ]
                    }), (props)=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                className: "invisible",
                                children: "h"
                            }),
                            props.masteries === undefined || props.masteries.championLevel < 5 ? // hide points
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $897a2720cadf5613$export$f46140fe718f016b), {
                                        ...props
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "invisible",
                                        children: "h"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                ref: championRef,
                                className: "flex flex-col items-center gap-px",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $897a2720cadf5613$export$f46140fe718f016b), {
                                        tooltipHoverRef: championRef,
                                        ...props
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "font-medium",
                                        children: t.common.numberK($9119c22d5d39a2bb$var$round(props.masteries.championPoints / 1000, 1))
                                    })
                                ]
                            })
                        ]
                    })))
            }),
            (0, $kj6DU.pipe)(champion, (0, $9ddGv.Maybe).chain((c)=>$9119c22d5d39a2bb$var$foldGameMode(gameMode, {
                    onAram: (0, $9ddGv.Maybe).some(c.aram),
                    onUrf: (0, $9ddGv.Maybe).some(c.urf),
                    default: (0, $9ddGv.Maybe).none
                })), (0, $9ddGv.Maybe).fold(()=>null, (data)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($9119c22d5d39a2bb$var$Cell, {
                    gridColStart: 6,
                    className: (0, $5MBh5.cx)('flex flex-col justify-center', padding),
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cb54dcc6a5bed971$export$aa446a51db8c710), {
                            ref: mapChangesRef,
                            reverse: reverse,
                            data: data
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                            hoverRef: mapChangesRef,
                            shouldHide: tooltipShouldHide,
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4f36ad52d98450a3$export$8c094cd568b6439e), {
                                data: data
                            })
                        })
                    ]
                }))),
            /*#__PURE__*/ (0, $aSiaI.jsxs)($9119c22d5d39a2bb$var$Cell, {
                type: (0, $lr3g3.animated).div,
                gridColStart: 7,
                className: (0, $5MBh5.cx)('flex flex-col justify-center', padding),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        ref: totalHasteRef,
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                className: "flex gap-2",
                                children: spells.map(([id, spell])=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                        className: "size-7",
                                        children: (0, $kj6DU.pipe)(spell, (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Empty, {
                                                className: "size-full",
                                                children: t.common.spellKey(id)
                                            }), (s)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $613f1c447f9abb4e$export$10199abf042bcb34), {
                                                spell: s,
                                                haste: totalHaste,
                                                tooltipShouldHide: tooltipShouldHide,
                                                className: "size-full"
                                            })))
                                    }, (0, $110f7e5c1a405981$export$733cfc729a9b57a7).unwrap(id)))
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4c07dd73d95864fa$export$14b1c0db81189f0d), {
                                runeById: filteredRuneById,
                                itemById: itemById,
                                onToggle: onToggleHaste,
                                cosmicInsightDefaultChecked: true,
                                cosmicInsightDisabled: hasCosmicInsight,
                                canBuyCrimsonLucidity: (0, $kj6DU.pipe)(role, (0, $9ddGv.Maybe).exists((r)=>r === 'mid')),
                                size: "small",
                                className: (0, $5MBh5.cx)('justify-center', reverse ? 'flex-row-reverse' : undefined)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                        hoverRef: totalHasteRef,
                        placement: "top",
                        children: t.common.totalHaste(totalHaste)
                    })
                ]
            }),
            (0, $kj6DU.pipe)(maybePerks, (0, $9ddGv.Maybe).fold(()=>null, (perks)=>/*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                    gridColStart: 8,
                    className: (0, $5MBh5.cx)('col-span-2 flex items-center py-1', reverse ? 'pl-4' : 'pr-4', padding),
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ba4339275a9377aa$export$12dda5e6511ff2f1), {
                        runeStyleById: runeStyleById,
                        runeById: runeById,
                        perks: perks,
                        reverse: reverse,
                        tooltipShouldHide: tooltipShouldHide
                    })
                }))),
            !isLast ? /*#__PURE__*/ (0, $aSiaI.jsx)($9119c22d5d39a2bb$var$Cell, {
                gridRowOffset: 2,
                gridColStart: 1,
                className: shouldWrap ? 'h-1' : 'h-4'
            }) : null
        ]
    });
};
const $9119c22d5d39a2bb$var$Li = ({ reverse: reverse, gridRowStart: gridRowStart, springStyle: springStyle, gestureProps: gestureProps, className: baseClassName, children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
        className: "contents",
        children: (0, $exYeM.Children).map(children, (element)=>{
            if (element === null) return null;
            const { gridRowOffset: gridRowOffset = 0, className: className, style: style, ...props_ } = element.props;
            const props = {
                ...gestureProps,
                ...props_,
                gridRowOffset: gridRowOffset,
                reverse: reverse,
                className: (0, $5MBh5.cx)(baseClassName, className, 'touch-pinch-zoom select-none'),
                style: {
                    ...style,
                    gridRowStart: gridRowStart + gridRowOffset,
                    ...springStyle
                }
            };
            return /*#__PURE__*/ (0, $exYeM.cloneElement)(element, props);
        })
    });
const $9119c22d5d39a2bb$var$Cell = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ type: type = (0, $lr3g3.animated).div, gridColStart: gridColStart, // eslint-disable-next-line @typescript-eslint/no-unused-vars
gridRowOffset: _, reverse: reverse = false, dontResetColor: dontResetColor, className: className, style: style, children: children, ...props_ }, ref)=>{
    const props = {
        ...props_,
        ref: ref,
        className: (0, $5MBh5.cx)([
            '[&>*]:text-wheat',
            dontResetColor !== true
        ], className),
        style: {
            ...style,
            gridColumnStart: reverse ? undefined : gridColStart,
            gridColumnEnd: reverse ? $9119c22d5d39a2bb$var$gridTotalCols - gridColStart + 2 : undefined
        }
    };
    return /*#__PURE__*/ (0, $exYeM.createElement)(type, props, children);
});
const $9119c22d5d39a2bb$var$Empty = ({ className: className, children: children })=>/*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $5MBh5.cx)('bg-black text-2xs', className),
        children: children
    });
function $9119c22d5d39a2bb$var$foldGameMode(gameMode, { onAram: onAram, onUrf: onUrf, default: default_ }) {
    switch(gameMode){
        case 'ARAM':
            return onAram;
        case 'URF':
            return onUrf;
        default:
            return default_;
    }
}



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $lfkrA = parcelRequire("lfkrA");


var $1sXco = parcelRequire("1sXco");

var $hZroh = parcelRequire("hZroh");
// participant line 1 + participant line 2
const $13ded1e86ffa4bde$var$participantHeightWithoutSpacer = 114;
const $13ded1e86ffa4bde$export$daea3ea1fa035f44 = $13ded1e86ffa4bde$var$participantHeightWithoutSpacer + 4;
const $13ded1e86ffa4bde$export$8ddcd5fd8c1e34a3 = $13ded1e86ffa4bde$var$participantHeightWithoutSpacer + 16;
const $13ded1e86ffa4bde$export$e903137a303a952a = ({ shouldWrap: shouldWrap, rowMultiple: rowMultiple = 1, iconClassName: iconClassName })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: (0, $lfkrA.ChampionPosition).values.map((position, i)=>{
            const isLast = i === (0, $lfkrA.ChampionPosition).values.length - 1;
            return /*#__PURE__*/ (0, $aSiaI.jsx)($13ded1e86ffa4bde$var$Span, {
                position: position,
                className: iconClassName,
                style: {
                    height: shouldWrap ? undefined : isLast ? $13ded1e86ffa4bde$var$participantHeightWithoutSpacer : $13ded1e86ffa4bde$export$8ddcd5fd8c1e34a3,
                    gridRowStart: rowMultiple * i + 1
                }
            }, position);
        })
    });
const $13ded1e86ffa4bde$var$Span = ({ position: position, className: className, style: style })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const ref = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                ref: ref,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $62c858348d1b2db2$export$12e8b9f23d53a496), {
                    position: position,
                    className: "size-5 text-grey-500"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: ref,
                children: t.labels.position[position]
            })
        ]
    });
};



/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $exYeM = parcelRequire("exYeM");
const $9433a2b05c5ec609$export$bede44fc2a176ab2 = ()=>{
    const [shouldWrap, setShouldWrap] = (0, $exYeM.useState)(false);
    const containerRef = (0, $exYeM.useRef)(null);
    const leftRef = (0, $exYeM.useRef)(null);
    const rightRef = (0, $exYeM.useRef)(null);
    const updateShouldWrap = (0, $exYeM.useCallback)(()=>{
        if (containerRef.current !== null && leftRef.current !== null && rightRef.current !== null) {
            const container = containerRef.current.getBoundingClientRect();
            const left = leftRef.current.getBoundingClientRect();
            const right = rightRef.current.getBoundingClientRect();
            setShouldWrap((shouldWrap_)=>{
                if (shouldWrap_ && left.right < right.left) return false;
                if (!shouldWrap_ && container.width < left.width + right.width) return true;
                return shouldWrap_;
            });
        }
    }, []);
    (0, $exYeM.useEffect)(()=>{
        window.addEventListener('resize', updateShouldWrap);
        return ()=>window.removeEventListener('resize', updateShouldWrap);
    }, [
        updateShouldWrap
    ]);
    return {
        shouldWrap: shouldWrap,
        onMountContainer: (0, $exYeM.useCallback)((e)=>{
            // eslint-disable-next-line functional/immutable-data
            containerRef.current = e;
            updateShouldWrap();
        }, [
            updateShouldWrap
        ]),
        onMountLeft: (0, $exYeM.useCallback)((e)=>{
            // eslint-disable-next-line functional/immutable-data
            leftRef.current = e;
            updateShouldWrap();
        }, [
            updateShouldWrap
        ]),
        onMountRight: (0, $exYeM.useCallback)((e)=>{
            // eslint-disable-next-line functional/immutable-data
            rightRef.current = e;
            updateShouldWrap();
        }, [
            updateShouldWrap
        ])
    };
};


const { swap: $c1c84d7e477757d6$var$swap } = (0, $javAY.ListUtils);
const { clamp: $c1c84d7e477757d6$var$clamp } = (0, $dglOy.NumberUtils);
const { pad10: $c1c84d7e477757d6$var$pad10 } = (0, $hrnY6.StringUtils);
const $c1c84d7e477757d6$var$refreshDelay = (0, $hPJN4.MsDuration).milliseconds(100);
const $c1c84d7e477757d6$var$reloadInterval = (0, $hPJN4.MsDuration).seconds(10);
const $c1c84d7e477757d6$var$timerInterval = (0, $hPJN4.MsDuration).second(1);
const $c1c84d7e477757d6$export$85034e8d4bf2420 = ({ platform: platform, riotId: riotId })=>{
    const { maybeUser: maybeUser } = (0, $dCazK.useUser)();
    const { lang: lang } = (0, $hZroh.useTranslation)();
    const { data: data, error: error, mutate: mutate } = (0, $290caf74bcd3a18a$export$1432bee435d2d13b)(lang, platform, riotId);
    // Remove shards on user disconnect
    const previousUser = (0, $72dc780a792c7de1$export$5cae361ad82dce8b)(maybeUser);
    (0, $exYeM.useEffect)(()=>{
        if (data !== undefined && (0, $9ddGv.Maybe).isNone(maybeUser) && (0, $9ddGv.Maybe).isSome((0, $9ddGv.Maybe).flatten(previousUser)) && (0, $9ddGv.Maybe).isSome(data.game)) mutate((0, $kj6DU.pipe)((0, $e6281be3d74c9d26$export$8609024c4106d527).Lens.game.participants, (0, $kyy1y).modify((0, $9ddGv.PartialDict).map((0, $9ddGv.NonEmptyArray).map((0, $11932b1fd95b0eeb$export$31eb4e888063c573).Lens.shardsCount.set((0, $9ddGv.Maybe).none)))))(data), {
            revalidate: false
        });
    }, [
        data,
        maybeUser,
        mutate,
        previousUser
    ]);
    const refreshGame = (0, $exYeM.useCallback)(()=>{
        mutate(undefined, {
            revalidate: false
        });
        setTimeout(()=>mutate(undefined, {
                revalidate: true
            }), (0, $hPJN4.MsDuration).unwrap($c1c84d7e477757d6$var$refreshDelay));
    }, [
        mutate
    ]);
    const reloadGame = (0, $exYeM.useCallback)(()=>{
        mutate();
    }, [
        mutate
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
            data: data,
            error: error,
            children: (summonerGame)=>/*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$Loaded, {
                    platform: platform,
                    summoner: summonerGame.summoner,
                    game: summonerGame.game,
                    refreshGame: refreshGame,
                    reloadGame: reloadGame
                })
        })
    });
};
const $c1c84d7e477757d6$var$Loaded = (props)=>{
    const { summoner: summoner, refreshGame: refreshGame } = props;
    const { t: t } = (0, $hZroh.useTranslation)('activeGame');
    (0, $8e158bd0f9b43ba8$export$f96ad7bfa050ed2)(summoner, (0, $iz2wS.appRoutes).platformRiotIdGame(props.platform, summoner.riotId));
    return (0, $kj6DU.pipe)(props.game, (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: "flex flex-col items-center gap-4",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cwvCy.Pre), {
                    className: "mt-4",
                    children: t.notInGame
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                    type: "button",
                    onClick: refreshGame,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.RefreshOutline), {
                        className: "w-6"
                    })
                })
            ]
        }), (game)=>/*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$WithoutAdditional, {
            ...props,
            game: game
        })));
};
const $c1c84d7e477757d6$var$WithoutAdditional = (props)=>{
    const { lang: lang } = (0, $hZroh.useTranslation)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
        ...(0, $cmF7r.useSWRHttp)((0, $cn7Rc.apiRoutes).staticData(lang).additional.get, {}, [
            (0, $d235b3ad729c7838$export$94540228b78a751e).codec,
            'AdditionalStaticData'
        ]),
        children: (additionalStaticData)=>/*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$ActiveGameComponent, {
                ...props,
                additionalStaticData: additionalStaticData
            })
    });
};
const $c1c84d7e477757d6$var$ActiveGameComponent = ({ additionalStaticData: additionalStaticData, platform: platform, summoner: summoner, game: { gameStartTime: gameStartTime, mapId: mapId, gameMode: gameMode, gameQueueConfigId: gameQueueConfigId, isDraft: isDraft, bannedChampions: bannedChampions, participants: participants, isPoroOK: isPoroOK }, refreshGame: refreshGame, reloadGame: reloadGame })=>{
    const { lang: lang, t: t } = (0, $hZroh.useTranslation)();
    const { shouldWrap: shouldWrap, onMountContainer: onMountContainer, onMountLeft: onMountLeft, onMountRight: onMountRight } = (0, $9433a2b05c5ec609$export$bede44fc2a176ab2)();
    const summonerSpellByKey = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.summonerSpells, (0, $javAY.ListUtils).findFirstBy((0, $110f7e5c1a405981$export$733cfc729a9b57a7).Eq)((s)=>s.key)), [
        additionalStaticData.summonerSpells
    ]);
    const runeStyleById = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.runeStyles, (0, $javAY.ListUtils).findFirstBy((0, $961cbdbae1c3c6dd$export$597b42c1d60925a3).Eq)((s)=>s.id)), [
        additionalStaticData.runeStyles
    ]);
    const runeById = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.runes, (0, $javAY.ListUtils).findFirstBy((0, $79273afeecdb2db1$export$96c66196b0b4f739).Eq)((s)=>s.id)), [
        additionalStaticData.runes
    ]);
    const itemById = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(additionalStaticData.items, (0, $javAY.ListUtils).findFirstBy((0, $75ec77282a60aec4$export$43ac25706d3b5d4a).Eq)((i)=>i.id)), [
        additionalStaticData.items
    ]);
    const shouldShowPositions = (0, $edc657eabde8d7fe$export$44c1e36a0d7bb01f).isSummonersRift(mapId);
    const gameQueue = (0, $kj6DU.pipe)(t.common.labels.gameQueue, (0, $9ddGv.Dict).lookup(`${gameQueueConfigId}`), (0, $9ddGv.Maybe).getOrElseW(()=>gameQueueConfigId));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "grid min-h-full grid-rows-[1fr_auto_auto_1fr] gap-4 py-3",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex items-center justify-center gap-4 px-3",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("button", {
                        type: "button",
                        onClick: refreshGame,
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.RefreshOutline), {
                            className: "w-6"
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                        className: "text-xl font-bold text-goldenrod",
                        children: gameQueue
                    }),
                    (0, $kj6DU.pipe)(gameStartTime, (0, $9ddGv.Maybe).fold(()=>/*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$Loading, {
                            reload: reloadGame
                        }), (startTime)=>/*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$Timer, {
                            startTime: startTime
                        }))),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex items-center gap-0.5",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: $c1c84d7e477757d6$var$poroLink(lang, platform, summoner.riotId),
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                    src: (0, $5mLQo.Assets).thirdParty.porofessor,
                                    alt: t.activeGame.poroIconAlt,
                                    className: "h-5"
                                })
                            }),
                            isPoroOK ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CheckMarkSharp), {
                                className: "w-3 text-green"
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CloseFilled), {
                                className: "w-3 text-red"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $007d2d12dc557e1c$export$e355dba6ae7236d1), {
                isDraft: isDraft,
                bannedChampions: bannedChampions,
                participants: participants
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                ref: onMountContainer,
                className: shouldWrap ? 'flex flex-col items-start gap-1' : 'grid grid-cols-2',
                children: [
                    (0, $5ff7d0cead9d8600$export$4718096832dec34e).values.map((teamId, i)=>{
                        const reverse = i % 2 === 1;
                        const participants_ = participants[teamId];
                        const mountRef = i === 0 ? onMountLeft : i === 1 ? onMountRight : undefined;
                        return /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                            className: (0, $5MBh5.cx)('grid', [
                                'self-end',
                                shouldWrap && reverse
                            ]),
                            style: {
                                ...shouldShowPositions && !shouldWrap ? {
                                    gridRowStart: Math.floor((i + 2) / 2),
                                    gridRowEnd: `span ${participants_?.length ?? 0}`
                                } : {},
                                gridColumnStart: reverse ? 2 : 1,
                                ...(0, $9119c22d5d39a2bb$export$2d6247fb34949a13)[`${reverse}`]
                            },
                            children: [
                                mountRef !== undefined ? /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                                    ref: mountRef,
                                    className: "col-span-full row-start-1"
                                }) : null,
                                shouldShowPositions && shouldWrap ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ded1e86ffa4bde$export$e903137a303a952a), {
                                    shouldWrap: shouldWrap,
                                    rowMultiple: 3,
                                    iconClassName: (0, $5MBh5.cx)('col-span-full col-start-1 pt-9.75', reverse ? 'justify-self-start -ml-2.5' : 'justify-self-end -mr-2.5')
                                }) : null,
                                participants_ === undefined ? null : /*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$Participants, {
                                    platform: platform,
                                    summoner: summoner,
                                    gameMode: gameMode,
                                    shouldWrap: shouldWrap,
                                    teamId: teamId,
                                    reverse: reverse,
                                    participants: participants_,
                                    summonerSpellByKey: summonerSpellByKey,
                                    runeStyleById: runeStyleById,
                                    runeById: runeById,
                                    itemById: itemById
                                })
                            ]
                        }, teamId);
                    }),
                    shouldShowPositions && !shouldWrap ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ded1e86ffa4bde$export$e903137a303a952a), {
                        shouldWrap: shouldWrap,
                        iconClassName: "col-span-2 justify-self-center col-start-1 pt-9.75"
                    }) : null
                ]
            })
        ]
    });
};
const $c1c84d7e477757d6$var$poroLink = (lang, platform, { gameName: gameName, tagLine: tagLine })=>`${(0, $abFKR.config).poroApiBaseUrl}/${(0, $7c2fab9890607f52$export$6d7a29d4960e3d83).poroLang[lang]}/live/${(0, $5Dwzl.Platform).encoderLower.encode(platform)}/${gameName}-${tagLine}/season`;
const $c1c84d7e477757d6$var$Participants = ({ platform: platform, summoner: summoner, gameMode: gameMode, shouldWrap: shouldWrap, teamId: teamId, reverse: reverse, participants: participants, summonerSpellByKey: summonerSpellByKey, runeStyleById: runeStyleById, runeById: runeById, itemById: itemById })=>{
    const [isDragging, setIsDragging] = (0, $exYeM.useState)(false);
    const order = (0, $exYeM.useRef)(participants.map((_, index)=>index)) // Store indicies as a local ref, this represents the item order
    ;
    const participantHeight = shouldWrap ? (0, $13ded1e86ffa4bde$export$daea3ea1fa035f44) : (0, $13ded1e86ffa4bde$export$8ddcd5fd8c1e34a3);
    const [springs, api] = (0, $dGJql.useSprings)(participants.length, $c1c84d7e477757d6$var$fn(participantHeight, teamId, order.current)) // Create springs, each corresponds to an item, controlling its transform, etc.
    ;
    const bind = (0, $1c8da9e350a78c26$export$7941f8aafa4b6021)(({ event: event, args: [activeIndex], active: active, movement: [, y] })=>{
        event.preventDefault();
        setIsDragging(active);
        const currentIndex = order.current.indexOf(activeIndex);
        const currentRow = $c1c84d7e477757d6$var$clamp(Math.round((currentIndex * participantHeight + y) / participantHeight), 0, participants.length - 1);
        if (active) api.start($c1c84d7e477757d6$var$fn(participantHeight, teamId, order.current, active, activeIndex, currentIndex, currentRow, y)) // Feed springs new style data, they'll animate the view without causing a single render
        ;
        else {
            const newOrder = $c1c84d7e477757d6$var$swap(order.current, currentIndex, currentRow);
            api.start($c1c84d7e477757d6$var$fn(participantHeight, teamId, newOrder, active, activeIndex, currentIndex, currentRow, y));
            // eslint-disable-next-line functional/immutable-data
            order.current = newOrder;
        }
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: springs.map((springStyle, j)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const participant = participants[j];
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $9119c22d5d39a2bb$export$5cfb5b4baffb5bc9), {
                summonerSpellByKey: summonerSpellByKey,
                runeStyleById: runeStyleById,
                runeById: runeById,
                itemById: itemById,
                platform: platform,
                gameMode: gameMode,
                participant: participant,
                shouldWrap: shouldWrap,
                highlight: (0, $kj6DU.pipe)(participant.riotId, (0, $9ddGv.Maybe).exists((id)=>(0, $appXD.RiotId).Eq.equals(id, summoner.riotId))),
                reverse: reverse,
                index: j,
                isLast: j === springs.length - 1,
                isDragging: isDragging,
                springStyle: springStyle,
                gestureProps: bind(j)
            }, (0, $kj6DU.pipe)(participant.riotId, (0, $9ddGv.Maybe).foldW(()=>j, (0, $appXD.RiotId).stringify)));
        })
    });
};
const $c1c84d7e477757d6$var$dragOffset = 20;
const $c1c84d7e477757d6$var$fn = (participantHeight, teamId, order, active = false, originalIndex = 0, currentIndex = 0, currentRow = 0, y = 0)=>(index)=>{
        if (active && index === originalIndex) return {
            x: teamId === 100 ? $c1c84d7e477757d6$var$dragOffset : -$c1c84d7e477757d6$var$dragOffset,
            y: (currentIndex - originalIndex) * participantHeight + y,
            color: $c1c84d7e477757d6$var$dragColor[teamId],
            zIndex: 2,
            immediate: (key)=>key === 'y' || key === 'zIndex'
        };
        const indexOf = order.indexOf(index);
        return {
            x: 0,
            y: (indexOf - index) * participantHeight,
            color: active && indexOf === currentRow ? $c1c84d7e477757d6$var$dragOverColor : $c1c84d7e477757d6$var$baseColor[teamId],
            zIndex: 1,
            immediate: false
        };
    };
const $c1c84d7e477757d6$var$baseColor = {
    100: '#061b3e',
    200: '#261622'
};
const $c1c84d7e477757d6$var$dragColor = {
    100: '#04285c',
    200: '#411a21'
};
const $c1c84d7e477757d6$var$dragOverColor = '#525252';
const $c1c84d7e477757d6$var$Loading = ({ reload: reload })=>{
    const { t: t } = (0, $hZroh.useTranslation)('activeGame');
    (0, $exYeM.useEffect)(()=>{
        const id = window.setInterval(reload, (0, $hPJN4.MsDuration).unwrap($c1c84d7e477757d6$var$reloadInterval));
        return ()=>window.clearInterval(id);
    }, [
        reload
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$GameInfo, {
        children: t.loading
    });
};
const $c1c84d7e477757d6$var$Timer = ({ startTime: startTime })=>{
    const { t: t } = (0, $hZroh.useTranslation)('activeGame');
    const [gameDuration, setGameDuration] = (0, $exYeM.useState)(()=>(0, $kj6DU.pipe)((0, $7wIl1.DayJs).now(), (0, $7wIl1.DayJs).diff(startTime)));
    (0, $exYeM.useEffect)(()=>{
        const id = window.setInterval(()=>setGameDuration((0, $hPJN4.MsDuration).add($c1c84d7e477757d6$var$timerInterval)), (0, $hPJN4.MsDuration).unwrap($c1c84d7e477757d6$var$timerInterval));
        return ()=>window.clearInterval(id);
    }, []);
    const timerRef = (0, $exYeM.useRef)(null);
    const date = (0, $7wIl1.DayJs).toDate(startTime);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($c1c84d7e477757d6$var$GameInfo, {
                ref: timerRef,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "font-lib-mono",
                    children: $c1c84d7e477757d6$var$prettyMs(gameDuration)
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: timerRef,
                children: t.gameStartedAt(date)
            })
        ]
    });
};
const $c1c84d7e477757d6$var$prettyMs = (ms)=>{
    const date = (0, $7wIl1.DayJs).of((0, $hPJN4.MsDuration).unwrap(ms));
    const zero = (0, $7wIl1.DayJs).of(0);
    const d = (0, $kj6DU.pipe)(date, (0, $7wIl1.DayJs).diff(zero, 'days'));
    const h = (0, $7wIl1.DayJs).hour.get(date);
    const m = (0, $7wIl1.DayJs).minute.get(date);
    const s = (0, $7wIl1.DayJs).second.get(date);
    return `${$c1c84d7e477757d6$var$pad10(d * 24 + h)}:${$c1c84d7e477757d6$var$pad10(m)}:${$c1c84d7e477757d6$var$pad10(s)}`;
};
const $c1c84d7e477757d6$var$GameInfo = /*#__PURE__*/ (0, $exYeM.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
        ref: ref,
        className: "flex text-grey-400",
        children: [
            "(",
            children,
            ")"
        ]
    }));


/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $gpfu2 = parcelRequire("gpfu2");
var $cF6yJ = parcelRequire("cF6yJ");
var $5fNnZ = parcelRequire("5fNnZ");

var $kj6DU = parcelRequire("kj6DU");
var $f4ea6fc35b8f94b3$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $f4ea6fc35b8f94b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $f4ea6fc35b8f94b3$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f4ea6fc35b8f94b3$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $f4ea6fc35b8f94b3$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f4ea6fc35b8f94b3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f4ea6fc35b8f94b3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f4ea6fc35b8f94b3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f4ea6fc35b8f94b3$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $f4ea6fc35b8f94b3$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $f4ea6fc35b8f94b3$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f4ea6fc35b8f94b3$var$root = $f4ea6fc35b8f94b3$var$freeGlobal || $f4ea6fc35b8f94b3$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $f4ea6fc35b8f94b3$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f4ea6fc35b8f94b3$var$objectToString = $f4ea6fc35b8f94b3$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f4ea6fc35b8f94b3$var$nativeMax = Math.max, $f4ea6fc35b8f94b3$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f4ea6fc35b8f94b3$var$now = function() {
    return $f4ea6fc35b8f94b3$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $f4ea6fc35b8f94b3$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($f4ea6fc35b8f94b3$var$FUNC_ERROR_TEXT);
    wait = $f4ea6fc35b8f94b3$var$toNumber(wait) || 0;
    if ($f4ea6fc35b8f94b3$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $f4ea6fc35b8f94b3$var$nativeMax($f4ea6fc35b8f94b3$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $f4ea6fc35b8f94b3$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f4ea6fc35b8f94b3$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f4ea6fc35b8f94b3$var$now());
    }
    function debounced() {
        var time = $f4ea6fc35b8f94b3$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f4ea6fc35b8f94b3$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f4ea6fc35b8f94b3$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f4ea6fc35b8f94b3$var$isSymbol(value) {
    return typeof value == 'symbol' || $f4ea6fc35b8f94b3$var$isObjectLike(value) && $f4ea6fc35b8f94b3$var$objectToString.call(value) == $f4ea6fc35b8f94b3$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f4ea6fc35b8f94b3$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($f4ea6fc35b8f94b3$var$isSymbol(value)) return $f4ea6fc35b8f94b3$var$NAN;
    if ($f4ea6fc35b8f94b3$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f4ea6fc35b8f94b3$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($f4ea6fc35b8f94b3$var$reTrim, '');
    var isBinary = $f4ea6fc35b8f94b3$var$reIsBinary.test(value);
    return isBinary || $f4ea6fc35b8f94b3$var$reIsOctal.test(value) ? $f4ea6fc35b8f94b3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f4ea6fc35b8f94b3$var$reIsBadHex.test(value) ? $f4ea6fc35b8f94b3$var$NAN : +value;
}
$f4ea6fc35b8f94b3$exports = $f4ea6fc35b8f94b3$var$debounce;



var $kyy1y = parcelRequire("kyy1y");

var $exYeM = parcelRequire("exYeM");


var $hPJN4 = parcelRequire("hPJN4");

var $632HS = parcelRequire("632HS");

var $3Em0q = parcelRequire("3Em0q");

var $f96Tp = parcelRequire("f96Tp");



var $javAY = parcelRequire("javAY");

var $dglOy = parcelRequire("dglOy");

var $hrnY6 = parcelRequire("hrnY6");

var $9ddGv = parcelRequire("9ddGv");

var $exi8o = parcelRequire("exi8o");

var $kJ6py = parcelRequire("kJ6py");

var $8Wmxp = parcelRequire("8Wmxp");

var $lMH1q = parcelRequire("lMH1q");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $bN7FL = parcelRequire("bN7FL");

var $hZroh = parcelRequire("hZroh");

var $dCazK = parcelRequire("dCazK");




var $2SjoC = parcelRequire("2SjoC");

var $iz2wS = parcelRequire("iz2wS");

var $5MBh5 = parcelRequire("5MBh5");

var $lQ3eP = parcelRequire("lQ3eP");
/* eslint-disable functional/no-expression-statements */ 
var $aSiaI = parcelRequire("aSiaI");

var $OFl2v = parcelRequire("OFl2v");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $ffzmL = parcelRequire("ffzmL");

var $632HS = parcelRequire("632HS");

var $javAY = parcelRequire("javAY");

var $dglOy = parcelRequire("dglOy");

var $9ddGv = parcelRequire("9ddGv");





var $1sXco = parcelRequire("1sXco");

var $2Yib7 = parcelRequire("2Yib7");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");



var $2SjoC = parcelRequire("2SjoC");

var $dpwSR = parcelRequire("dpwSR");


var $5MBh5 = parcelRequire("5MBh5");
/* eslint-disable functional/no-expression-statements,
                  functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $hOuM2 = parcelRequire("hOuM2");
var $goBZ5 = parcelRequire("goBZ5");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $exYeM = parcelRequire("exYeM");

var $ffzmL = parcelRequire("ffzmL");

var $3Em0q = parcelRequire("3Em0q");

var $lfkrA = parcelRequire("lfkrA");

var $9ddGv = parcelRequire("9ddGv");



var $7CMrG = parcelRequire("7CMrG");

var $aSiaI = parcelRequire("aSiaI");

var $hZroh = parcelRequire("hZroh");

var $5mLQo = parcelRequire("5mLQo");

var $5MBh5 = parcelRequire("5MBh5");
const $eb6612b0a3b45d74$export$9ea228593aea6cc2 = ({ level: level, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)('common');
    return /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
        src: (0, $5mLQo.Assets).masteries[level],
        alt: t.masteryIconAlt(level),
        className: (0, $5MBh5.cx)([
            'grayscale',
            level === 0
        ], className)
    });
};


/* eslint-disable functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $5MBh5 = parcelRequire("5MBh5");
function $fb5a90769c937148$export$e282af879c335b03({ name: name, value: value, setValue: setValue, children: children }) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: "flex flex-wrap",
        children: children.map(({ value: val, label: label })=>/*#__PURE__*/ (0, $aSiaI.jsx)($fb5a90769c937148$var$Radio, {
                name: name,
                value: val,
                setValue: setValue,
                label: label,
                isChecked: val === value
            }, val))
    });
}
function $fb5a90769c937148$var$Radio({ name: name, value: value, setValue: setValue, label: label, isChecked: isChecked }) {
    const onChange = (0, $exYeM.useCallback)(()=>setValue(value), [
        setValue,
        value
    ]);
    const id = (0, $exYeM.useId)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
        className: "group",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                type: "radio",
                name: name,
                id: id,
                checked: isChecked,
                onChange: onChange,
                className: "sr-only"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                htmlFor: id,
                className: (0, $5MBh5.cx)('flex border-l border-goldenrod-bis group-first:rounded-l-md group-first:border-l-0 group-last:rounded-r-md', isChecked ? 'bg-goldenrod-bis text-black' : 'cursor-pointer bg-zinc-700'),
                children: label
            })
        ]
    });
}
function $fb5a90769c937148$export$f87cf8075df92fdf(value, label) {
    return {
        value: value,
        label: label
    };
}




var $1sXco = parcelRequire("1sXco");

var $2Yib7 = parcelRequire("2Yib7");

var $hZroh = parcelRequire("hZroh");

var $5mLQo = parcelRequire("5mLQo");

var $khrbF = parcelRequire("khrbF");

var $dR62Q = parcelRequire("dR62Q");

var $2SjoC = parcelRequire("2SjoC");

var $5EDDu = parcelRequire("5EDDu");

var $1KINn = parcelRequire("1KINn");

var $5MBh5 = parcelRequire("5MBh5");
/* eslint-disable functional/no-return-void */ 
var $aSiaI = parcelRequire("aSiaI");

var $goBZ5 = parcelRequire("goBZ5");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $9ddGv = parcelRequire("9ddGv");

var $1sXco = parcelRequire("1sXco");

var $5MBh5 = parcelRequire("5MBh5");
function $7d2c800e47d41b90$export$2bc6b1ab4f9a3f({ eq: eq, values: values, checked: checked, toggleChecked: toggleChecked, isMenuVisible: isMenuVisible, onMouseEnter: onMouseEnter, tooltipPlacement: tooltipPlacement, iconClassName: iconClassName, className: className }) {
    const toggleChecked_ = (0, $exYeM.useCallback)((value)=>(e)=>toggleChecked((prev)=>{
                const isAllChecked = (0, $goBZ5).size(prev) === (0, $9ddGv.List).size(values);
                if (isAllChecked) return new Set([
                    value
                ]);
                const isChecked = (0, $goBZ5).elem(eq)(value, prev);
                if (isChecked && (0, $goBZ5).size(prev) === 1) return (0, $kj6DU.pipe)(values, (0, $9ddGv.List).map((v)=>v.value), (0, $goBZ5).fromReadonlyArray(eq));
                return (0, $kj6DU.pipe)(prev, (e.target.checked ? (0, $goBZ5).insert(eq) : (0, $goBZ5).remove(eq))(value));
            }), [
        eq,
        toggleChecked,
        values
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        onMouseEnter: onMouseEnter,
        className: (0, $5MBh5.cx)('flex flex-wrap', className),
        children: (0, $kj6DU.pipe)(values, (0, $9ddGv.List).map(({ key: key, value: value, icon: icon, label: label })=>/*#__PURE__*/ (0, $aSiaI.jsx)($7d2c800e47d41b90$var$LabelCheckbox, {
                eq: eq,
                isAllChecked: (0, $goBZ5).size(checked) === (0, $9ddGv.List).size(values),
                value: value,
                icon: icon,
                label: label,
                checked: checked,
                toggleChecked: toggleChecked_,
                isMenuVisible: isMenuVisible,
                tooltipPlacement: tooltipPlacement,
                iconClassName: iconClassName
            }, key)))
    });
}
function $7d2c800e47d41b90$var$LabelCheckbox({ eq: eq, isAllChecked: isAllChecked, value: value, icon: icon, label: label, checked: checked, toggleChecked: toggleChecked, isMenuVisible: isMenuVisible, tooltipPlacement: tooltipPlacement, iconClassName: iconClassName }) {
    const hoverRef = (0, $exYeM.useRef)(null);
    const isChecked = isAllChecked ? false : (0, $goBZ5).elem(eq)(value, checked);
    const id = (0, $exYeM.useId)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
        className: "group/checkbox",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("input", {
                type: "checkbox",
                id: id,
                checked: isChecked,
                onChange: toggleChecked(value),
                className: "sr-only"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("label", {
                ref: hoverRef,
                htmlFor: id,
                className: (0, $5MBh5.cx)('flex h-9 shrink-0 cursor-pointer items-center', isMenuVisible === true ? 'group-first/checkbox:rounded-tl-md group-last/checkbox:rounded-tr-md' : 'group-first/checkbox:rounded-l-md group-last/checkbox:rounded-r-md', isChecked ? 'bg-goldenrod-bis' : 'bg-zinc-700', iconClassName),
                children: icon(isChecked)
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: hoverRef,
                placement: tooltipPlacement,
                children: label
            })
        ]
    });
}


const $5e8f40a3a844d772$export$a81e88d11f746f25 = ({ searchCount: searchCount, randomChampion: randomChampion })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const { masteriesQuery: masteriesQuery, updateMasteriesQuery: updateMasteriesQuery } = (0, $2Yib7.useHistory)();
    const [levelsMenuIsVisible, setLevelsMenuIsVisible] = (0, $exYeM.useState)(false);
    const handleMasteriesMouseEnter = (0, $exYeM.useCallback)(()=>{
        if (!levelsMenuIsVisible) setLevelsMenuIsVisible(true);
    }, [
        levelsMenuIsVisible
    ]);
    const hideLevelsMenu = (0, $exYeM.useCallback)(()=>setLevelsMenuIsVisible(false), []);
    const toggleMasteryChecked = (0, $exYeM.useCallback)((f)=>{
        updateMasteriesQuery((0, $kj6DU.pipe)((0, $2SjoC.MasteriesQuery).Lens.level, (0, $4QCFr).modify(f)));
        hideLevelsMenu();
    }, [
        hideLevelsMenu,
        updateMasteriesQuery
    ]);
    const SelectLevelsButton = (0, $exYeM.useMemo)(()=>$5e8f40a3a844d772$var$getSelectLevelsButton(masteriesQuery.level, (0, $kj6DU.flow)((0, $2SjoC.MasteriesQuery).Lens.level.set, updateMasteriesQuery, hideLevelsMenu)), [
        hideLevelsMenu,
        masteriesQuery.level,
        updateMasteriesQuery
    ]);
    const toggleFactionChecked = (0, $exYeM.useCallback)((f)=>updateMasteriesQuery((0, $kj6DU.pipe)((0, $2SjoC.MasteriesQuery).Lens.faction, (0, $4QCFr).modify(f))), [
        updateMasteriesQuery
    ]);
    const togglePositionChecked = (0, $exYeM.useCallback)((f)=>updateMasteriesQuery((0, $kj6DU.pipe)((0, $2SjoC.MasteriesQuery).Lens.position, (0, $4QCFr).modify(f))), [
        updateMasteriesQuery
    ]);
    const setSort = (0, $kj6DU.flow)((0, $2SjoC.MasteriesQuery).Lens.sort.set, updateMasteriesQuery);
    const setOrder = (0, $kj6DU.flow)((0, $2SjoC.MasteriesQuery).Lens.order.set, updateMasteriesQuery);
    const setView = (0, $kj6DU.flow)((0, $2SjoC.MasteriesQuery).Lens.view.set, updateMasteriesQuery);
    const setQuerySearch = (0, $exYeM.useMemo)(()=>(0, $kj6DU.flow)((0, $2SjoC.MasteriesQuery).Lens.search.set, updateMasteriesQuery), [
        updateMasteriesQuery
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "flex w-full max-w-7xl flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $fb5a90769c937148$export$e282af879c335b03), {
                        name: "view",
                        value: masteriesQuery.view,
                        setValue: setView,
                        children: [
                            (0, $fb5a90769c937148$export$f87cf8075df92fdf)('compact', /*#__PURE__*/ (0, $aSiaI.jsxs)($5e8f40a3a844d772$var$IconLabel, {
                                tooltip: t.masteries.filters.view.compact,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.AppsSharp), {
                                        className: "w-4"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: t.masteries.filters.viewShort.compact
                                    })
                                ]
                            })),
                            (0, $fb5a90769c937148$export$f87cf8075df92fdf)('histogram', /*#__PURE__*/ (0, $aSiaI.jsxs)($5e8f40a3a844d772$var$IconLabel, {
                                tooltip: t.masteries.filters.view.histogram,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.StatsChartSharp), {
                                        className: "w-5 rotate-90 -scale-x-100"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: t.masteries.filters.viewShort.histogram
                                    })
                                ]
                            })),
                            (0, $fb5a90769c937148$export$f87cf8075df92fdf)('aram', /*#__PURE__*/ (0, $aSiaI.jsxs)($5e8f40a3a844d772$var$IconLabel, {
                                tooltip: t.masteries.filters.view.aram,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $khrbF.HowlingAbyssSimple), {
                                        className: "w-4.5"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: t.masteries.filters.viewShort.aram
                                    })
                                ]
                            })),
                            (0, $fb5a90769c937148$export$f87cf8075df92fdf)('urf', /*#__PURE__*/ (0, $aSiaI.jsxs)($5e8f40a3a844d772$var$IconLabel, {
                                tooltip: t.masteries.filters.view.urf,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7CMrG.MaskedImage), {
                                        src: (0, $5mLQo.Assets).spatula,
                                        className: "size-4.5"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: t.masteries.filters.viewShort.urf
                                    })
                                ]
                            })),
                            (0, $fb5a90769c937148$export$f87cf8075df92fdf)('factions', /*#__PURE__*/ (0, $aSiaI.jsxs)($5e8f40a3a844d772$var$IconLabel, {
                                tooltip: t.masteries.filters.view.factions,
                                className: "px-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7CMrG.MaskedImage), {
                                        src: (0, $5mLQo.Assets).runeterra,
                                        className: "size-4.5"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        children: t.masteries.filters.viewShort.factions
                                    })
                                ]
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fb5a90769c937148$export$e282af879c335b03), {
                                name: "sort",
                                value: masteriesQuery.sort,
                                setValue: setSort,
                                children: (0, $kj6DU.pipe)((0, $1KINn.MasteriesQuerySort).values, (0, $9ddGv.NonEmptyArray).map((value)=>(0, $fb5a90769c937148$export$f87cf8075df92fdf)(value, /*#__PURE__*/ (0, $aSiaI.jsx)($5e8f40a3a844d772$var$TextLabel, {
                                        tooltip: t.masteries.filters.sort[value],
                                        children: t.masteries.filters.sortShort[value]
                                    }))))
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fb5a90769c937148$export$e282af879c335b03), {
                                name: "order",
                                value: masteriesQuery.order,
                                setValue: setOrder,
                                children: (0, $kj6DU.pipe)((0, $5EDDu.MasteriesQueryOrder).values, (0, $9ddGv.NonEmptyArray).map((value)=>{
                                    const OrderIcon = $5e8f40a3a844d772$var$orderIcon[value];
                                    return (0, $fb5a90769c937148$export$f87cf8075df92fdf)(value, /*#__PURE__*/ (0, $aSiaI.jsx)($5e8f40a3a844d772$var$IconLabel, {
                                        tooltip: t.masteries.filters.order[value],
                                        className: "w-6",
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)(OrderIcon, {
                                            className: "w-5"
                                        })
                                    }));
                                }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        onMouseLeave: hideLevelsMenu,
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7d2c800e47d41b90$export$2bc6b1ab4f9a3f), {
                                eq: (0, $3Em0q.ChampionLevel).Eq,
                                values: (0, $kj6DU.pipe)((0, $3Em0q.ChampionLevel).values, (0, $9ddGv.List).reverse, (0, $9ddGv.List).map((level)=>({
                                        key: level,
                                        value: level,
                                        icon: (isChecked)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $eb6612b0a3b45d74$export$9ea228593aea6cc2), {
                                                level: level,
                                                className: (0, $5MBh5.cx)('h-full', [
                                                    'drop-shadow-[0_0_3px_black]',
                                                    isChecked
                                                ])
                                            }),
                                        label: t.masteries.filters.level(level)
                                    }))),
                                checked: masteriesQuery.level,
                                toggleChecked: toggleMasteryChecked,
                                isMenuVisible: levelsMenuIsVisible,
                                onMouseEnter: handleMasteriesMouseEnter,
                                tooltipPlacement: "top",
                                iconClassName: "px-0.5 pt-1.5 pb-1",
                                className: "relative z-30"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("ul", {
                                className: (0, $5MBh5.cx)('absolute z-20 flex w-full flex-col overflow-hidden rounded-b-md border-t border-black bg-zinc-700 shadow-even shadow-black', [
                                    'hidden',
                                    !levelsMenuIsVisible
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(SelectLevelsButton, {
                                        levels: (0, $3Em0q.ChampionLevel).values,
                                        children: t.masteries.filters.all
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(SelectLevelsButton, {
                                        levels: [
                                            0,
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9
                                        ],
                                        children: t.masteries.filters.nineAndLess
                                    }),
                                    (0, $kj6DU.pipe)((0, $3Em0q.ChampionLevel).values, (0, $9ddGv.List).reverse, (0, $9ddGv.List).map((level)=>/*#__PURE__*/ (0, $aSiaI.jsx)(SelectLevelsButton, {
                                            levels: [
                                                level
                                            ],
                                            children: level === 10 ? t.masteries.filters.tenAndMore : t.common.number(level)
                                        }, level)))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7d2c800e47d41b90$export$2bc6b1ab4f9a3f), {
                        eq: (0, $ffzmL.ChampionFactionOrNone).Eq,
                        values: (0, $kj6DU.pipe)((0, $ffzmL.ChampionFactionOrNone).values, (0, $9ddGv.List).map((faction)=>({
                                key: faction,
                                value: faction,
                                icon: (isChecked)=>faction === 'none' ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: (0, $5MBh5.cx)('flex w-6 justify-center', isChecked ? 'text-black' : 'text-wheat-bis'),
                                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.CircleOffOutline), {
                                            className: "w-4 -rotate-90"
                                        })
                                    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $eb9efc27dddf1fe3$export$1d957f0f68a69614), {
                                        faction: faction,
                                        className: (0, $5MBh5.cx)('size-6', isChecked ? 'text-black' : 'text-wheat-bis')
                                    }),
                                label: t.common.labels.factionOrNone[faction]
                            }))),
                        checked: masteriesQuery.faction,
                        toggleChecked: toggleFactionChecked,
                        tooltipPlacement: "top",
                        iconClassName: "px-1"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7d2c800e47d41b90$export$2bc6b1ab4f9a3f), {
                        eq: (0, $lfkrA.ChampionPosition).Eq,
                        values: (0, $kj6DU.pipe)((0, $lfkrA.ChampionPosition).values, (0, $9ddGv.List).map((position)=>({
                                key: position,
                                value: position,
                                icon: (isChecked)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $62c858348d1b2db2$export$12e8b9f23d53a496), {
                                        position: position,
                                        className: (0, $5MBh5.cx)('w-6', isChecked ? 'text-black' : 'text-wheat-bis')
                                    }),
                                label: t.common.labels.position[position]
                            }))),
                        checked: masteriesQuery.position,
                        toggleChecked: togglePositionChecked,
                        tooltipPlacement: "top",
                        iconClassName: "px-1.5"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $859fbc684bacb002$export$bb60b672622fdba0), {
                        searchCount: searchCount,
                        randomChampion: randomChampion,
                        initialSearch: masteriesQuery.search,
                        onChange: setQuerySearch
                    })
                ]
            })
        ]
    });
};
const $5e8f40a3a844d772$var$getSelectLevelsButton = (selectedLevels, setLevels)=>({ levels: levels, children: children })=>{
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const levelsSet = (0, $exYeM.useMemo)(()=>new Set(levels), levels);
        const handleClick = (0, $exYeM.useCallback)(()=>setLevels(levelsSet), [
            levelsSet
        ]);
        const isSelected = (0, $goBZ5).getEq((0, $3Em0q.ChampionLevel).Eq).equals(selectedLevels, levelsSet);
        return /*#__PURE__*/ (0, $aSiaI.jsx)("li", {
            className: "group contents",
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)("button", {
                type: "button",
                onClick: handleClick,
                disabled: isSelected,
                className: (0, $5MBh5.cx)('flex items-center justify-between gap-1 py-1.5 pl-4 pr-2 text-left text-sm font-medium', isSelected ? 'bg-goldenrod-bis text-black' : 'hover:bg-black'),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "flex gap-0.5",
                        children: (0, $kj6DU.pipe)(levelsSet, (0, $goBZ5).toReadonlyArray((0, $hOuM2).reverse((0, $3Em0q.ChampionLevel).Ord)), (0, $9ddGv.List).map((level)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $eb6612b0a3b45d74$export$9ea228593aea6cc2), {
                                level: level,
                                className: (0, $5MBh5.cx)('h-5', [
                                    'drop-shadow-[0_0_3px_black]',
                                    isSelected
                                ])
                            }, level)))
                    })
                ]
            })
        });
    };
const $5e8f40a3a844d772$var$TextLabel = ({ tooltip: tooltip, className: className, children: children })=>{
    const hoverRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                ref: hoverRef,
                className: (0, $5MBh5.cx)('flex h-6 w-10 items-center justify-center text-sm font-semibold', className),
                children: children
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: hoverRef,
                placement: "top",
                children: tooltip
            })
        ]
    });
};
const $5e8f40a3a844d772$var$IconLabel = ({ tooltip: tooltip, className: className, children: children })=>{
    const hoverRef = (0, $exYeM.useRef)(null);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                ref: hoverRef,
                className: (0, $5MBh5.cx)('flex h-6 items-center justify-center gap-1.5 text-sm font-medium', className),
                children: children
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                hoverRef: hoverRef,
                placement: "top",
                children: tooltip
            })
        ]
    });
};
const $5e8f40a3a844d772$var$orderIcon = {
    asc: (0, $dR62Q.CaretUpOutline),
    desc: (0, $dR62Q.CaretDownOutline)
};



var $cF6yJ = parcelRequire("cF6yJ");
var $hOuM2 = parcelRequire("hOuM2");
var $lSBre = parcelRequire("lSBre");
var $goBZ5 = parcelRequire("goBZ5");

var $kj6DU = parcelRequire("kj6DU");

var $ffzmL = parcelRequire("ffzmL");

var $3Em0q = parcelRequire("3Em0q");

var $lfkrA = parcelRequire("lfkrA");

var $f96Tp = parcelRequire("f96Tp");

var $javAY = parcelRequire("javAY");

var $9ddGv = parcelRequire("9ddGv");


var $dpwSR = parcelRequire("dpwSR");


var $cF6yJ = parcelRequire("cF6yJ");
var $hOuM2 = parcelRequire("hOuM2");
var $gSyeU = parcelRequire("gSyeU");

var $kj6DU = parcelRequire("kj6DU");
parcelRequire("7bKko");
var $4QCFr = parcelRequire("4QCFr");

var $hrnY6 = parcelRequire("hrnY6");
const $79c009d2d630440b$var$byLevel = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((c)=>c.championLevel));
const $79c009d2d630440b$var$byTokens = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((c)=>c.tokensEarned));
const $79c009d2d630440b$var$byPercents = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((c)=>c.percents));
const $79c009d2d630440b$var$byPoints = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((c)=>c.championPoints));
const $79c009d2d630440b$var$byName = (0, $kj6DU.pipe)((0, $gSyeU).Ord, (0, $hOuM2).contramap((c)=>(0, $hrnY6.StringUtils).cleanUTF8ToASCII(c.name)));
const $79c009d2d630440b$export$72b76efde5641ade = {
    Ord: {
        byLevel: $79c009d2d630440b$var$byLevel,
        byTokens: $79c009d2d630440b$var$byTokens,
        byPercents: $79c009d2d630440b$var$byPercents,
        byPoints: $79c009d2d630440b$var$byPoints,
        byName: $79c009d2d630440b$var$byName
    },
    Lens: {
        shardsCount: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('shardsCount'), (0, $4QCFr).some),
        glow: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('glow')),
        faction: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('faction')),
        isHidden: (0, $kj6DU.pipe)((0, $4QCFr).id(), (0, $4QCFr).prop('isHidden'))
    }
};


const $87b66cb0499ed7ea$var$hideInsteadOfGlowViews = new Set([
    'histogram',
    'aram',
    'urf',
    'factions'
]);
const $87b66cb0499ed7ea$export$4f133c75954dbf19 = (t, challenges, masteries, query)=>{
    const hideInsteadOfGlow = (0, $9ddGv.Maybe).isSome(query.search) && (0, $goBZ5).elem((0, $dpwSR.MasteriesQueryView).Eq)(query.view, $87b66cb0499ed7ea$var$hideInsteadOfGlowViews);
    const isHidden = $87b66cb0499ed7ea$var$getIsHidden({
        hideInsteadOfGlow: hideInsteadOfGlow
    });
    const filterPredicate = (0, $kj6DU.pipe)($87b66cb0499ed7ea$var$levelFilterPredicate(query.level), (0, $lSBre).and($87b66cb0499ed7ea$var$factionFilterPredicate(query.faction)), (0, $lSBre).and($87b66cb0499ed7ea$var$positionFilterPredicate(query.position)));
    const ords = $87b66cb0499ed7ea$var$getSortBy(query.sort, query.order);
    const filteredMasteries = (0, $kj6DU.pipe)(masteries, (0, $9ddGv.List).map((m)=>(0, $kj6DU.pipe)(m, filterPredicate(m) ? (0, $kj6DU.identity) : (0, $79c009d2d630440b$export$72b76efde5641ade).Lens.isHidden.set(true))));
    return {
        filteredAndSortedMasteries: (0, $kj6DU.pipe)(filteredMasteries, $87b66cb0499ed7ea$var$getSort(t, challenges, isHidden, query.view)(ords)),
        championsCount: (0, $kj6DU.pipe)(filteredMasteries, (0, $9ddGv.List).filter((c)=>!c.isHidden), (0, $9ddGv.List).size),
        factionsCount: (0, $kj6DU.pipe)(filteredMasteries, (0, $javAY.ListUtils).multipleGroupBy((c)=>(0, $9ddGv.List).isNonEmpty(c.factions) ? c.factions : [
                'none'
            ]), (0, $9ddGv.PartialDict).map((nea)=>({
                count: nea.filter((c)=>!c.isHidden).length,
                total: nea.length
            }))),
        searchCount: (0, $kj6DU.pipe)(filteredMasteries, (0, $9ddGv.List).filter((c)=>c.glow), (0, $9ddGv.List).size),
        maybeMaxPoints: (0, $kj6DU.pipe)(filteredMasteries, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $kj6DU.flow)((0, $9ddGv.NonEmptyArray).map((c)=>// `championPointsUntilNextLevel` can be negative
            Math.max(c.championPoints + c.championPointsUntilNextLevel, c.championPoints)), (0, $9ddGv.NonEmptyArray).max((0, $cF6yJ).Ord)))),
        hideInsteadOfGlow: hideInsteadOfGlow,
        isHidden: isHidden
    };
};
const $87b66cb0499ed7ea$var$getSort = (t, challenges, isHidden, view)=>{
    switch(view){
        case 'compact':
        case 'histogram':
            return (0, $9ddGv.List).sortBy;
        case 'aram':
            return $87b66cb0499ed7ea$var$sortMapChanges(isHidden, (c)=>c.aram.category);
        case 'urf':
            return $87b66cb0499ed7ea$var$sortMapChanges(isHidden, (c)=>c.urf.category);
        case 'factions':
            return $87b66cb0499ed7ea$var$sortFactions(t, challenges, isHidden);
    }
};
const $87b66cb0499ed7ea$var$sortMapChanges = (isHidden, getCategory)=>(ords)=>(as)=>{
            const grouped = (0, $kj6DU.pipe)(as, (0, $9ddGv.List).groupBy((c)=>isHidden(c) ? 'hidden' : getCategory(c)));
            return (0, $kj6DU.pipe)((0, $33db2523ab42fb92$export$dc50577efab52c43).values, (0, $9ddGv.List).reduce((0, $9ddGv.List).empty(), (acc, category)=>(0, $kj6DU.pipe)(acc, (0, $9ddGv.List).concat((0, $kj6DU.pipe)(grouped[category] ?? [], (0, $9ddGv.List).sortBy(ords))))), (0, $9ddGv.List).concat(grouped.hidden ?? []));
        };
const $87b66cb0499ed7ea$var$sortFactions = (t, challenges, isHidden)=>(ords)=>(as)=>{
            const grouped = (0, $kj6DU.pipe)(as, (0, $javAY.ListUtils).multipleGroupBy((c)=>{
                if (isHidden(c)) return [
                    'hidden'
                ];
                if ((0, $9ddGv.List).isNonEmpty(c.factions)) return c.factions;
                return [
                    'none'
                ];
            }), (0, $9ddGv.PartialDict).mapWithIndex((faction, champions)=>(0, $kj6DU.pipe)(champions, (0, $9ddGv.NonEmptyArray).map((c)=>(0, $kj6DU.pipe)(c, (0, $79c009d2d630440b$export$72b76efde5641ade).Lens.faction.set(faction === 'hidden' ? (0, $f96Tp.StaticDataChampion).getFaction(c.factions) : faction))))));
            return (0, $kj6DU.pipe)((0, $ffzmL.ChampionFactionOrNone).valuesSortBy($87b66cb0499ed7ea$var$factionSortBy(t, challenges)), (0, $9ddGv.List).reduce((0, $9ddGv.List).empty(), (acc, faction)=>(0, $kj6DU.pipe)(acc, (0, $9ddGv.List).concat((0, $kj6DU.pipe)(grouped[faction] ?? [], (0, $9ddGv.List).sortBy(ords))))), (0, $9ddGv.List).concat(grouped.hidden ?? []));
        };
const $87b66cb0499ed7ea$var$factionSortBy = (t, { data: challenges })=>{
    const byLabel = (0, $a34009e2fd6e6d61$export$6a3aa170c29c42fa).Ord.byLabel(t);
    if (challenges === undefined) return [
        byLabel
    ];
    const byChallengeValue = (0, $kj6DU.pipe)((0, $cF6yJ).Ord, (0, $hOuM2).contramap((f)=>(0, $kj6DU.pipe)(challenges[f], (0, $9ddGv.Maybe).fold(()=>0, (c)=>c.value))), (0, $hOuM2).reverse);
    return [
        byChallengeValue,
        byLabel
    ];
};
const $87b66cb0499ed7ea$var$getIsHidden = ({ hideInsteadOfGlow: hideInsteadOfGlow })=>(c)=>c.isHidden || hideInsteadOfGlow && !c.glow;
const $87b66cb0499ed7ea$var$getSortBy = (sort, order)=>{
    switch(sort){
        case 'level':
            return [
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byLevel),
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byTokens),
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byPoints),
                (0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byName
            ];
        case 'percents':
            return [
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byPercents),
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byPoints),
                (0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byName
            ];
        case 'points':
            return [
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byPoints),
                (0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byName
            ];
        case 'name':
            return [
                reverseIfDesc((0, $79c009d2d630440b$export$72b76efde5641ade).Ord.byName)
            ];
    }
    function reverseIfDesc(o) {
        switch(order){
            case 'asc':
                return o;
            case 'desc':
                return (0, $hOuM2).reverse(o);
        }
    }
};
const $87b66cb0499ed7ea$var$levelFilterPredicate = (levels)=>(c)=>// always keep if all levels are selected
        (0, $goBZ5).size(levels) === (0, $3Em0q.ChampionLevel).values.length || // convert to 10 if 10+
        (0, $goBZ5).elem((0, $3Em0q.ChampionLevel).Eq)((0, $3Em0q.ChampionLevel).fromNumber(c.championLevel), levels);
const $87b66cb0499ed7ea$var$factionFilterPredicate = (factions)=>(c)=>(0, $goBZ5).size(factions) === (0, $ffzmL.ChampionFactionOrNone).values.length || ((0, $9ddGv.List).isNonEmpty(c.factions) ? (0, $kj6DU.pipe)(c.factions, (0, $9ddGv.List).some((faction)=>(0, $goBZ5).elem((0, $ffzmL.ChampionFactionOrNone).Eq)(faction, factions))) : (0, $goBZ5).elem((0, $ffzmL.ChampionFactionOrNone).Eq)('none', factions));
const $87b66cb0499ed7ea$var$positionFilterPredicate = (positions)=>(c)=>(0, $goBZ5).size(positions) === (0, $lfkrA.ChampionPosition).values.length || (0, $kj6DU.pipe)(c.positions, (0, $9ddGv.List).some((position)=>(0, $goBZ5).elem((0, $lfkrA.ChampionPosition).Eq)(position, positions)));


const { round: $ef687db929be9f78$var$round } = (0, $dglOy.NumberUtils);
const $ef687db929be9f78$export$f62f504f0a1af108 = ({ challenges: challenges, masteries: masteries, setChampionShards: setChampionShards })=>{
    const { masteriesQuery: masteriesQuery, updateMasteriesQuery: updateMasteriesQuery } = (0, $2Yib7.useHistory)();
    const { t: t } = (0, $hZroh.useTranslation)('common');
    const { champions: champions } = (0, $fcoXO.useStaticData)();
    const { filteredAndSortedMasteries: filteredAndSortedMasteries, championsCount: championsCount, factionsCount: factionsCount, searchCount: searchCount, maybeMaxPoints: maybeMaxPoints, hideInsteadOfGlow: hideInsteadOfGlow, isHidden: isHidden } = (0, $exYeM.useMemo)(()=>(0, $87b66cb0499ed7ea$export$4f133c75954dbf19)(t, challenges, masteries, masteriesQuery), [
        challenges,
        masteries,
        masteriesQuery,
        t
    ]);
    const randomChampion = (0, $exYeM.useMemo)(()=>(0, $kj6DU.pipe)(filteredAndSortedMasteries, (0, $9ddGv.List).filter((m)=>!m.isHidden), (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $kj6DU.flow)((0, $793be4c33bc284e1$exports).randomElem, (0, $OFl2v).map((m)=>{
            updateMasteriesQuery((0, $2SjoC.MasteriesQuery).Lens.search.set((0, $9ddGv.Maybe).some(m.name)));
            return m.name;
        })))), [
        filteredAndSortedMasteries,
        updateMasteriesQuery
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5e8f40a3a844d772$export$a81e88d11f746f25), {
                searchCount: searchCount,
                randomChampion: randomChampion
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: (0, $5MBh5.cx)('w-full', $ef687db929be9f78$var$viewContainerClassName[masteriesQuery.view]),
                children: (0, $kj6DU.pipe)(filteredAndSortedMasteries, (0, $javAY.ListUtils).mapWithPrevious((maybePrev, champion)=>/*#__PURE__*/ (0, $aSiaI.jsx)($ef687db929be9f78$var$Champion, {
                        challenges: challenges,
                        factionsCount: factionsCount,
                        maybeMaxPoints: maybeMaxPoints,
                        isGlowing: !hideInsteadOfGlow && champion.glow,
                        isHidden: isHidden(champion),
                        maybePrev: maybePrev,
                        champion: champion,
                        setChampionShards: setChampionShards
                    }, `${champion.faction}${(0, $632HS.ChampionKey).unwrap(champion.championId)}`)))
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "self-center text-sm",
                children: t.nChampionsFraction(championsCount, champions.length)
            })
        ]
    });
};
const $ef687db929be9f78$var$mapChangesClassName = 'grid grid-cols-[repeat(auto-fit,0.625rem)] items-start gap-x-4 gap-y-1';
const $ef687db929be9f78$var$viewContainerClassName = {
    compact: 'grid max-w-416 grid-cols-[repeat(auto-fit,4rem)] items-start gap-4',
    histogram: 'grid max-w-7xl grid-cols-[auto_1fr] gap-y-2',
    aram: $ef687db929be9f78$var$mapChangesClassName,
    urf: $ef687db929be9f78$var$mapChangesClassName,
    factions: 'grid max-w-416 grid-cols-[repeat(auto-fit,4rem)] items-start gap-4'
};
const $ef687db929be9f78$var$Champion = ({ challenges: challenges, factionsCount: factionsCount, maybeMaxPoints: maybeMaxPoints, isGlowing: isGlowing, isHidden: isHidden, maybePrev: maybePrev, champion: champion, setChampionShards: setChampionShards })=>{
    const { masteriesQuery: { view: view } } = (0, $2Yib7.useHistory)();
    const containerRef = (0, $exYeM.useRef)(null);
    const isHistogram = view === 'histogram';
    const isFactions = view === 'factions';
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $dpwSR.MasteriesQueryView).isBalance(view) && !isHidden && !(0, $kj6DU.pipe)(maybePrev, (0, $9ddGv.Maybe).exists((prev)=>(0, $33db2523ab42fb92$export$dc50577efab52c43).Eq.equals(prev[view].category, champion[view].category))) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c0ec2c134c6dc113$export$13c8a39fad75a36b), {
                category: champion[view].category,
                className: (0, $5MBh5.cx)([
                    'pt-4',
                    (0, $9ddGv.Maybe).isSome(maybePrev)
                ])
            }) : null,
            isFactions && !isHidden && !(0, $kj6DU.pipe)(maybePrev, (0, $9ddGv.Maybe).exists((prev)=>(0, $ffzmL.ChampionFactionOrNone).Eq.equals(prev.faction, champion.faction))) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $afadb44a095e5a9d$export$2978b4beac7a3c02), {
                challenges: (0, $9ddGv.Maybe).some(challenges),
                faction: champion.faction,
                count: factionsCount[champion.faction] ?? (0, $67cf1f07a2ea57b8$export$1b9130a9fda2eb88).empty,
                className: (0, $5MBh5.cx)([
                    'pt-2',
                    (0, $9ddGv.Maybe).isSome(maybePrev)
                ])
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                ref: containerRef,
                className: (0, $5MBh5.cx)('relative', $ef687db929be9f78$var$colSpanClassName(view, champion), {
                    hidden: isHidden
                }),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($ef687db929be9f78$var$Glow, {
                        isGlowing: isGlowing
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: (0, $8dfaba1de5ccacc8$export$8feb69f2a1cfb779),
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $897a2720cadf5613$export$f46140fe718f016b), {
                                championId: champion.championId,
                                masteries: {
                                    tokensEarned: champion.tokensEarned,
                                    markRequiredForNextLevel: champion.markRequiredForNextLevel,
                                    championLevel: champion.championLevel,
                                    championPoints: champion.championPoints,
                                    championPointsSinceLastLevel: champion.championPointsSinceLastLevel,
                                    championPointsUntilNextLevel: champion.championPointsUntilNextLevel,
                                    percents: champion.percents
                                },
                                name: champion.name,
                                shardsCount: champion.shardsCount,
                                positions: champion.positions,
                                factions: champion.factions,
                                setChampionShards: setChampionShards,
                                isHistogram: isHistogram,
                                tooltipPlacementRef: containerRef,
                                tooltipPlacement: "top",
                                centerLevel: false
                            }),
                            (0, $dpwSR.MasteriesQueryView).isBalance(view) ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8dfaba1de5ccacc8$export$60aa91691c7ccf90), {
                                tooltiPlacementRef: containerRef,
                                wrapAfterSize: 15,
                                data: champion[view].data
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($ef687db929be9f78$var$ChampionMasteryHistogram, {
                maybeMaxPoints: maybeMaxPoints,
                champion: champion,
                className: (0, $5MBh5.cx)([
                    'hidden',
                    !isHistogram || isHidden
                ])
            })
        ]
    });
};
const $ef687db929be9f78$var$balancedClassName = 'col-span-3';
const $ef687db929be9f78$var$unbalancedClassName = 'col-span-5';
function $ef687db929be9f78$var$colSpanClassName(view, champion) {
    if ((0, $dpwSR.MasteriesQueryView).isBalance(view)) return champion[view].category === 'balanced' ? $ef687db929be9f78$var$balancedClassName : $ef687db929be9f78$var$unbalancedClassName;
    return undefined;
}
const $ef687db929be9f78$var$Glow = ({ isGlowing: isGlowing })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: isGlowing ? 'absolute -left-1.75 -top-1.75 grid size-19.5 place-items-center overflow-hidden rounded-1/2' : 'hidden',
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "col-start-1 row-start-1 size-full animate-my-spin-reverse rounded-1/2 border-2 border-dashed border-white"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "col-start-1 row-start-1 size-[calc(100%_-_.25rem)] animate-my-spin rounded-1/2 border-2 border-dashed border-goldenrod"
            })
        ]
    });
const $ef687db929be9f78$var$ChampionMasteryHistogram = ({ maybeMaxPoints: maybeMaxPoints, champion: { championLevel: championLevel, championPoints: championPoints, championPointsSinceLastLevel: championPointsSinceLastLevel, championPointsUntilNextLevel: championPointsUntilNextLevel }, className: className })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const hoverRef1 = (0, $exYeM.useRef)(null);
    const hoverRef2 = (0, $exYeM.useRef)(null);
    const hoverRef3 = (0, $exYeM.useRef)(null);
    const placementRef = (0, $exYeM.useRef)(null);
    const pointsUntilAndSince = (0, $kj6DU.pipe)([
        2 <= championLevel ? (0, $9ddGv.Maybe).some(t.masteries.pointsSinceLastLevel(championPointsSinceLastLevel, championLevel)) : (0, $9ddGv.Maybe).none,
        (0, $9ddGv.Maybe).some(t.masteries.pointsUntilNextLevel(championPointsUntilNextLevel, championLevel + 1))
    ], (0, $9ddGv.List).compact, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $9ddGv.List).mkString(" \u2014 ")));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('flex flex-col', className),
                children: [
                    (0, $kj6DU.pipe)(maybeMaxPoints, (0, $9ddGv.Maybe).fold(()=>null, (maxPoints)=>{
                        function p(n) {
                            return `${$ef687db929be9f78$var$round(100 * n / maxPoints, 2)}%`;
                        }
                        return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                            className: "relative h-7",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    ref: hoverRef2,
                                    className: (0, $5MBh5.cx)('absolute left-0 top-0 h-full', (0, $a85e2b07dac54e12$export$ba5db2e5993f4709)(championLevel)),
                                    style: {
                                        width: p(championPoints)
                                    }
                                }),
                                0 < championPointsUntilNextLevel ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    ref: hoverRef1,
                                    className: "absolute top-0 h-full bg-histogram-grey/50",
                                    style: {
                                        width: p(championPointsUntilNextLevel),
                                        left: p(championPoints)
                                    }
                                }) : null,
                                2 <= championLevel ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                    ref: hoverRef3,
                                    className: (0, $5MBh5.cx)('absolute top-0 h-full border-l', championPointsUntilNextLevel <= 0 ? 'border-x' : 'border-l', (0, $a85e2b07dac54e12$export$9842f088a6739769)(championLevel)),
                                    style: {
                                        width: p(championPointsSinceLastLevel + championPointsUntilNextLevel),
                                        left: p(championPoints - championPointsSinceLastLevel)
                                    }
                                }) : null
                            ]
                        });
                    })),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                            ref: placementRef,
                            className: (0, $5MBh5.cx)('pl-1.5 pt-1 font-semibold', (0, $a85e2b07dac54e12$export$5d6f9a79aaea5f31)(championLevel)),
                            children: t.common.number(championPoints)
                        })
                    })
                ]
            }),
            (0, $kj6DU.pipe)(pointsUntilAndSince, (0, $9ddGv.Maybe).fold(()=>null, (tooltip)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                    hoverRef: [
                        placementRef,
                        hoverRef1,
                        hoverRef2,
                        hoverRef3
                    ],
                    placement: "bottom-start",
                    children: tooltip
                })))
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $kj6DU = parcelRequire("kj6DU");

var $exYeM = parcelRequire("exYeM");

var $7wIl1 = parcelRequire("7wIl1");

var $hPJN4 = parcelRequire("hPJN4");

var $3Em0q = parcelRequire("3Em0q");


var $kaLCO = parcelRequire("kaLCO");

var $appXD = parcelRequire("appXD");

var $hFHAv = parcelRequire("hFHAv");

var $gkOpi = parcelRequire("gkOpi");

var $dglOy = parcelRequire("dglOy");

var $9ddGv = parcelRequire("9ddGv");



var $1sXco = parcelRequire("1sXco");

var $fcoXO = parcelRequire("fcoXO");

var $hZroh = parcelRequire("hZroh");

var $5mLQo = parcelRequire("5mLQo");

var $dR62Q = parcelRequire("dR62Q");

var $aMofi = parcelRequire("aMofi");


var $5MBh5 = parcelRequire("5MBh5");
const { round: $bcd0eb38a694b645$var$round } = (0, $dglOy.NumberUtils);
const $bcd0eb38a694b645$export$7eec06b052b876ef = ({ platform: platform, summoner: { riotId: riotId, name: maybeName, profileIconId: profileIconId, summonerLevel: summonerLevel, questPercents: questPercents, totalMasteryLevel: totalMasteryLevel, totalMasteryPoints: totalMasteryPoints, otpIndex: otpIndex, masteriesCount: masteriesCount }, leagues: leagues, masteries: masteries })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const staticData = (0, $fcoXO.useStaticData)();
    const nameRef = (0, $exYeM.useRef)(null);
    const levelRef = (0, $exYeM.useRef)(null);
    const masteriesRef = (0, $exYeM.useRef)(null);
    const infoRef = (0, $exYeM.useRef)(null);
    const MasteryImgWithCount = (0, $exYeM.useMemo)(()=>$bcd0eb38a694b645$var$getMasteryImgWithCount(t.common, masteriesCount), [
        masteriesCount,
        t
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
        className: "relative flex w-full max-w-7xl flex-wrap items-center justify-between gap-6",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-wrap gap-4",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                        src: staticData.assets.summonerIcon(profileIconId),
                        alt: t.common.summonerIconAlt((0, $appXD.RiotId).stringify(riotId)),
                        className: "size-24 rounded border border-goldenrod-bis"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-rows-[1fr_auto]",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex flex-wrap items-baseline gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                        ref: nameRef,
                                        className: "flex items-baseline gap-0.5 whitespace-pre",
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "text-xl font-bold text-goldenrod",
                                                children: (0, $kaLCO.GameName).unwrap(riotId.gameName)
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                                                className: "text-lg text-grey-500",
                                                children: [
                                                    "#",
                                                    (0, $gkOpi.TagLine).unwrap(riotId.tagLine)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                                        hoverRef: nameRef,
                                        className: "flex flex-col items-center",
                                        children: [
                                            (0, $kj6DU.pipe)(maybeName, (0, $9ddGv.Maybe).fold(()=>null, (name)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                                    className: "flex items-baseline gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            children: t.common.oldSummonerName
                                                        }),
                                                        /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                            className: "whitespace-pre text-lg font-bold text-goldenrod",
                                                            children: (0, $hFHAv.SummonerName).unwrap(name)
                                                        })
                                                    ]
                                                }))),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "text-grey-500",
                                                children: t.summoner.masteriesCache.lastUpdate((0, $7wIl1.DayJs).unwrap(masteries.insertedAt).toDate())
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                                className: "text-grey-500",
                                                children: t.summoner.masteriesCache.duration($bcd0eb38a694b645$var$prettyMs(masteries.cacheDuration))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "text-grey-400",
                                        children: "\u2014"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        ref: levelRef,
                                        children: t.common.level(summonerLevel, 'font-semibold')
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                        hoverRef: levelRef,
                                        placement: "right",
                                        children: t.common.summonerLevel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                                className: "flex flex-wrap gap-6",
                                children: (0, $1893979b11fc029b$export$34d6dd1c63e72828).keys.map((queue)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $0be8ba81f8425294$export$9fc0e0d0ecb98c84), {
                                        queue: queue,
                                        league: leagues[queue]
                                    }, queue))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: "flex flex-col items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        ref: masteriesRef,
                        className: "flex items-end gap-3 pb-1",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                level: 10,
                                imgClassName: "!w-20"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                level: 9,
                                imgClassName: "!w-20 -mt-0.5",
                                className: "-mb-1"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                level: 8,
                                imgClassName: "!w-20 -mt-0.5",
                                className: "-mb-1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $1sXco.Tooltip), {
                        hoverRef: masteriesRef,
                        className: "flex flex-col items-center gap-2 px-5 pb-4 pt-3",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "flex items-end justify-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 7
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 6
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 5,
                                        imgClassName: "-mt-1",
                                        className: "-mx-0.5"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 4,
                                        imgClassName: "-mt-1",
                                        className: "-mx-1"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 3,
                                        imgClassName: "-mt-1.5",
                                        className: "-mx-1.5"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 2,
                                        imgClassName: "-mt-1.5",
                                        className: "-mx-2"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 1,
                                        imgClassName: "-mt-2",
                                        className: "-mx-2.5"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)(MasteryImgWithCount, {
                                        level: 0,
                                        imgClassName: "-mt-2",
                                        className: "-mx-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                                className: "grid grid-cols-[auto_auto] gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "justify-self-end",
                                        children: t.summoner.masteryScore
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "font-semibold",
                                        children: t.common.number(totalMasteryLevel)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "mt-1 justify-self-end",
                                        children: t.summoner.masteryPoints
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "mt-1 font-semibold",
                                        children: (0, $aMofi.TranslationUtils).numberUnit(t.common)(totalMasteryPoints)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "mt-1 justify-self-end",
                                        children: t.summoner.otpIndex
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "mt-1 font-semibold",
                                        children: t.common.number(otpIndex)
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                        className: "col-span-2 whitespace-pre-wrap text-center text-xs italic opacity-70",
                                        children: t.summoner.otpIndexExplanation
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)("span", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: t.summoner.percentsProgression($bcd0eb38a694b645$var$round(questPercents, 2), 'font-semibold')
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                ref: infoRef,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.InformationCircleOutline), {
                                    className: "h-6"
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1sXco.Tooltip), {
                                hoverRef: infoRef,
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)("ul", {
                                    className: "list-disc pl-3 leading-6",
                                    children: t.summoner.masteriesExplanation
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "grid justify-items-end gap-1.5 self-start",
                children: Object.entries($bcd0eb38a694b645$var$otherThirdPartySites).map(([key, [icon, href]])=>/*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                        className: "grid grid-cols-[auto,auto] items-center gap-1 self-center text-sm",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("a", {
                                href: href(platform, riotId),
                                target: "_blank",
                                rel: "noreferrer",
                                className: "peer border-b border-b-wheat/50 leading-none transition-all duration-100 hover:border-b-goldenrod",
                                children: key
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("img", {
                                src: icon,
                                className: "size-3.5 transition-[visibility,opacity] duration-100 area-[1/2] peer-hover:invisible peer-hover:opacity-0"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dR62Q.OpenInNew), {
                                className: "invisible size-3.5 opacity-0 transition-[visibility,opacity] duration-100 area-[1/2] peer-hover:visible peer-hover:opacity-100"
                            })
                        ]
                    }, key))
            })
        ]
    });
};
// TODO: platform
const $bcd0eb38a694b645$var$otherThirdPartySites = {
    'op.gg': [
        (0, $5mLQo.Assets).thirdParty.opGg,
        (platform, riotId)=>`https://op.gg/lol/summoners/${$bcd0eb38a694b645$var$pr(platform, riotId)}`
    ],
    LeagueOfGraphs: [
        (0, $5mLQo.Assets).thirdParty.leagueOfGraphs,
        (platform, riotId)=>`https://www.leagueofgraphs.com/summoner/${$bcd0eb38a694b645$var$pr(platform, riotId)}`
    ],
    'DPM.LOL': [
        (0, $5mLQo.Assets).thirdParty.dpmLol,
        (_, riotId)=>`https://dpm.lol/${$bcd0eb38a694b645$var$r(riotId)}`
    ],
    'YearIn.LoL': [
        (0, $5mLQo.Assets).thirdParty.yearInLol,
        (_, riotId)=>`https://yearin.lol/profile/${$bcd0eb38a694b645$var$r(riotId)}`
    ]
};
function $bcd0eb38a694b645$var$pr(platform, riotId) {
    return `${platform.toLowerCase()}/${$bcd0eb38a694b645$var$r(riotId)}`;
}
function $bcd0eb38a694b645$var$r(riotId) {
    return `${riotId.gameName}-${riotId.tagLine}`;
}
const $bcd0eb38a694b645$var$getMasteryImgWithCount = (t, masteriesCount)=>({ level: level, imgClassName: imgClassName, className: className })=>{
        const count = masteriesCount[(0, $3Em0q.ChampionLevel).stringify(level)];
        return /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
            className: (0, $5MBh5.cx)('flex flex-col items-center', className),
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: (0, $5MBh5.cx)('text-sm font-semibold', (0, $a85e2b07dac54e12$export$5d6f9a79aaea5f31)(level)),
                    children: t.number(count ?? -1)
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $eb6612b0a3b45d74$export$9ea228593aea6cc2), {
                    level: level,
                    className: (0, $5MBh5.cx)('w-13.5', imgClassName)
                })
            ]
        });
    };
function $bcd0eb38a694b645$var$prettyMs(ms) {
    const date = (0, $7wIl1.DayJs).of((0, $hPJN4.MsDuration).unwrap(ms));
    const zero = (0, $7wIl1.DayJs).of(0);
    const m = (0, $kj6DU.pipe)(date, (0, $7wIl1.DayJs).diff(zero, 'minutes'));
    const s = (0, $7wIl1.DayJs).second.get(date) / 60;
    return m + s;
}



var $jVoNn = parcelRequire("jVoNn");

var $cn7Rc = parcelRequire("cn7Rc");

var $csF9Q = parcelRequire("csF9Q");

var $abFKR = parcelRequire("abFKR");

var $2Yib7 = parcelRequire("2Yib7");

var $lQ3eP = parcelRequire("lQ3eP");

var $fviO3 = parcelRequire("fviO3");
const $a8227cbe19cdf329$export$af1539e67ee344d = (platform, puuid)=>{
    const { masteriesQuery: masteriesQuery } = (0, $2Yib7.useHistory)();
    return (0, $jVoNn.default)([
        ...(0, $cn7Rc.apiRoutes).summoner.byPuuid(platform)(puuid).challenges.get,
        $a8227cbe19cdf329$var$getShouldFetchChallenges(masteriesQuery.view)
    ], ([url, method, shouldFetchChallenges])=>shouldFetchChallenges ? (0, $lQ3eP.futureRunUnsafe)((0, $fviO3.http)([
            url,
            method
        ], {}, [
            (0, $csF9Q.ChallengesView).codec,
            'ChallengesView'
        ])) : Promise.reject(Error('Challenges should not be used for this view')), {
        revalidateIfStale: !(0, $abFKR.config).isDev,
        revalidateOnFocus: !(0, $abFKR.config).isDev,
        revalidateOnReconnect: !(0, $abFKR.config).isDev
    });
};
const $a8227cbe19cdf329$var$getShouldFetchChallenges = (view)=>view === 'factions';



var $kj6DU = parcelRequire("kj6DU");

var $jVoNn = parcelRequire("jVoNn");

var $cn7Rc = parcelRequire("cn7Rc");


var $9ddGv = parcelRequire("9ddGv");

var $abFKR = parcelRequire("abFKR");

var $2Yib7 = parcelRequire("2Yib7");

var $lQ3eP = parcelRequire("lQ3eP");

var $fviO3 = parcelRequire("fviO3");
const $2df0ffb96202b3f1$export$6952cc2a2c7ff335 = (platform, riotId)=>{
    const { historyStateRef: historyStateRef, modifyHistoryStateRef: modifyHistoryStateRef } = (0, $2Yib7.useHistory)();
    return (0, $jVoNn.default)((0, $cn7Rc.apiRoutes).summoner.byRiotId(platform)(riotId).masteries.get, ([url, method])=>(0, $kj6DU.pipe)(historyStateRef.current.masteries, (0, $9ddGv.Maybe).fold(()=>(0, $fviO3.http)([
                url,
                method
            ], {}, [
                (0, $e6b38fa586ac4361$export$295b25f3552f2c84).codec,
                'SummonerMasteriesView'
            ]), (0, $kj6DU.flow)((0, $9ddGv.Future).successful, (0, $9ddGv.Future).chainFirstIOK(()=>()=>modifyHistoryStateRef((0, $2Yib7.HistoryState).Lens.masteries.set((0, $9ddGv.Maybe).none))))), (0, $lQ3eP.futureRunUnsafe)), {
        revalidateIfStale: !(0, $abFKR.config).isDev,
        revalidateOnFocus: !(0, $abFKR.config).isDev,
        revalidateOnReconnect: !(0, $abFKR.config).isDev
    });
};


const { cleanChampionName: $63c28e058f0e5ff0$var$cleanChampionName } = (0, $hrnY6.StringUtils);
const $63c28e058f0e5ff0$var$shardsDebounceWait = (0, $hPJN4.MsDuration).second(1);
const $63c28e058f0e5ff0$export$f5c7402fca0d82db = ({ platform: platform, riotId: riotId })=>{
    const { t: t } = (0, $hZroh.useTranslation)();
    const { showToaster: showToaster } = (0, $bN7FL.useToaster)();
    const { maybeUser: maybeUser } = (0, $dCazK.useUser)();
    const { data: data, error: error, mutate: mutate } = (0, $2df0ffb96202b3f1$export$6952cc2a2c7ff335)(platform, riotId);
    // Remove shards on user disconnect
    const previousUser = (0, $72dc780a792c7de1$export$5cae361ad82dce8b)(maybeUser);
    (0, $exYeM.useEffect)(()=>{
        if (data !== undefined && (0, $9ddGv.Maybe).isNone(maybeUser) && (0, $9ddGv.Maybe).isSome((0, $9ddGv.Maybe).flatten(previousUser))) mutate({
            ...data,
            championShards: (0, $9ddGv.Maybe).none
        }, {
            revalidate: false
        });
    }, [
        data,
        maybeUser,
        mutate,
        previousUser
    ]);
    const [shardsIsLoading, setShardsIsLoading] = (0, $exYeM.useState)(false);
    const debouncedSetChampionsShardsBulk = (0, $exYeM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($f4ea6fc35b8f94b3$exports)))((platform_, puuid, updates, optimisticMutation, oldData, newData)=>{
            setShardsIsLoading(true);
            return (0, $kj6DU.pipe)((0, $exi8o.apiUserSelfSummonerChampionsShardsCountPost)(platform_, puuid, updates), (0, $9ddGv.Future).map(()=>{
                if (!optimisticMutation) mutate(newData, {
                    revalidate: false
                });
                showToaster('success', t.masteries.updateShardsSucces);
                return 0, $9ddGv.NotUsed;
            }), (0, $9ddGv.Future).orElse((e)=>{
                if (optimisticMutation) mutate(oldData, {
                    revalidate: false
                });
                console.error(e);
                showToaster('error', t.masteries.updateShardsError);
                return (0, $9ddGv.Future).notUsed;
            }), (0, $5fNnZ).chainFirstIOK(()=>()=>setShardsIsLoading(false)), (0, $lQ3eP.futureRunUnsafe));
        }, (0, $hPJN4.MsDuration).unwrap($63c28e058f0e5ff0$var$shardsDebounceWait)), [
        mutate,
        showToaster,
        t
    ]);
    const setChampionsShardsBulk = (0, $exYeM.useCallback)((updates, { optimisticMutation: optimisticMutation })=>{
        if (data === undefined || (0, $9ddGv.Maybe).isNone(data.championShards)) return;
        const newData = (0, $kj6DU.pipe)((0, $e6b38fa586ac4361$export$295b25f3552f2c84).Lens.championShards, (0, $kyy1y).modify((championsShards)=>(0, $kj6DU.pipe)(updates, (0, $9ddGv.NonEmptyArray).reduce(championsShards, (acc, { championId: championId, shardsCount: shardsCount })=>(0, $kj6DU.pipe)(acc, (0, $javAY.ListUtils).updateOrAppend((0, $422ee4e31ec4eecd$export$c8017683694e0c17).Eq.byChampion)({
                    champion: championId,
                    count: shardsCount
                }))))))(data);
        if (optimisticMutation) mutate(newData, {
            revalidate: false
        });
        debouncedSetChampionsShardsBulk(platform, data.summoner.puuid, updates, optimisticMutation, data, newData);
    }, [
        data,
        debouncedSetChampionsShardsBulk,
        mutate,
        platform
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $lMH1q.MainLayout), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $kJ6py.AsyncRenderer), {
            data: data,
            error: error,
            children: ({ summoner: summoner, leagues: leagues, masteries: masteries, championShards: championShards })=>/*#__PURE__*/ (0, $aSiaI.jsx)($63c28e058f0e5ff0$var$SummonerViewComponent, {
                    platform: platform,
                    summoner: summoner,
                    leagues: leagues,
                    masteries: masteries,
                    championShards: championShards,
                    shardsIsLoading: shardsIsLoading,
                    setChampionsShardsBulk: setChampionsShardsBulk
                })
        })
    });
};
const $63c28e058f0e5ff0$var$SummonerViewComponent = ({ platform: platform, summoner: summoner, leagues: leagues, masteries: masteries, championShards: championShards, shardsIsLoading: shardsIsLoading, setChampionsShardsBulk: setChampionsShardsBulk })=>{
    const { masteriesQuery: masteriesQuery } = (0, $2Yib7.useHistory)();
    const { champions: champions } = (0, $fcoXO.useStaticData)();
    const challenges = (0, $a8227cbe19cdf329$export$af1539e67ee344d)(platform, summoner.puuid);
    (0, $8e158bd0f9b43ba8$export$f96ad7bfa050ed2)((0, $exYeM.useMemo)(()=>({
            platform: platform,
            ...summoner
        }), [
        platform,
        summoner
    ]), (0, $iz2wS.appRoutes).platformRiotId(platform, summoner.riotId, (0, $2SjoC.MasteriesQuery).toPartial(masteriesQuery)));
    const { enrichedSummoner: enrichedSummoner, enrichedMasteries: enrichedMasteries } = (0, $exYeM.useMemo)(()=>$63c28e058f0e5ff0$var$enrichAll(masteries.champions, championShards, masteriesQuery.search, champions), [
        championShards,
        champions,
        masteries.champions,
        masteriesQuery.search
    ]);
    const [uiIsBlocked, setUiIsBlocked] = (0, $exYeM.useState)(true);
    (0, $exYeM.useEffect)(()=>{
        setUiIsBlocked(false);
    }, []);
    const setChampionShards = (0, $exYeM.useMemo)(()=>({
            isLoading: shardsIsLoading,
            run: (championKey)=>(shardsCount)=>setChampionsShardsBulk([
                        {
                            championId: championKey,
                            shardsCount: shardsCount
                        }
                    ], {
                        optimisticMutation: true
                    })
        }), [
        setChampionsShardsBulk,
        shardsIsLoading
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            uiIsBlocked ? /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8Wmxp.Loading), {
                    className: "mt-4 h-6 self-center"
                })
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                className: (0, $5MBh5.cx)('flex h-full flex-col items-center gap-6 overflow-y-auto overflow-x-hidden px-2 pb-24 pt-3', [
                    'hidden',
                    uiIsBlocked
                ]),
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bcd0eb38a694b645$export$7eec06b052b876ef), {
                        platform: platform,
                        summoner: {
                            ...summoner,
                            ...enrichedSummoner
                        },
                        leagues: leagues,
                        masteries: masteries
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ef687db929be9f78$export$f62f504f0a1af108), {
                        challenges: challenges,
                        masteries: enrichedMasteries,
                        setChampionShards: setChampionShards
                    })
                ]
            })
        ]
    });
};
const $63c28e058f0e5ff0$var$enrichAll = (masteries, championShards, maybeSearch, staticDataChampions)=>{
    const enrichedMasteries_ = (0, $kj6DU.pipe)(staticDataChampions, (0, $9ddGv.List).map(({ key: key, name: name, positions: positions, factions: factions, aram: aram, urf: urf })=>{
        const shardsCount = (0, $kj6DU.pipe)(championShards, (0, $9ddGv.Maybe).map((0, $kj6DU.flow)((0, $9ddGv.List).findFirst((s)=>(0, $632HS.ChampionKey).Eq.equals(s.champion, key)), (0, $9ddGv.Maybe).fold(()=>0, (s)=>s.count))));
        const glow = (0, $kj6DU.pipe)(maybeSearch, (0, $9ddGv.Maybe).exists((search)=>$63c28e058f0e5ff0$var$cleanChampionName(name).includes($63c28e058f0e5ff0$var$cleanChampionName(search))));
        const aramCategory = (0, $33db2523ab42fb92$export$dc50577efab52c43).fromData(aram);
        const urfCategory = (0, $33db2523ab42fb92$export$dc50577efab52c43).fromData(urf);
        const faction = (0, $f96Tp.StaticDataChampion).getFaction(factions);
        const isHidden = false;
        return (0, $kj6DU.pipe)((0, $kj6DU.pipe)(masteries, (0, $javAY.ListUtils).findFirstBy((0, $632HS.ChampionKey).Eq)((c)=>c.championId))(key), (0, $9ddGv.Maybe).fold(()=>({
                championId: key,
                championLevel: 0,
                championPoints: 0,
                championPointsSinceLastLevel: 0,
                championPointsUntilNextLevel: 0,
                tokensEarned: 0,
                markRequiredForNextLevel: 0,
                name: name,
                percents: 0,
                shardsCount: shardsCount,
                glow: glow,
                positions: positions,
                factions: factions,
                aram: {
                    category: aramCategory,
                    data: aram
                },
                urf: {
                    category: urfCategory,
                    data: urf
                },
                faction: faction,
                isHidden: isHidden
            }), (champion)=>({
                ...champion,
                name: name,
                percents: (0, $7c2fab9890607f52$export$6d7a29d4960e3d83).championPercents(champion),
                shardsCount: shardsCount,
                glow: glow,
                positions: positions,
                factions: factions,
                aram: {
                    category: aramCategory,
                    data: aram
                },
                urf: {
                    category: urfCategory,
                    data: urf
                },
                faction: faction,
                isHidden: isHidden
            })));
    }));
    const totalMasteryPoints = (0, $kj6DU.pipe)(enrichedMasteries_, (0, $9ddGv.List).map((c)=>c.championPoints), (0, $gpfu2).concatAll((0, $cF6yJ).MonoidSum));
    const grouped = (0, $kj6DU.pipe)(enrichedMasteries_, (0, $9ddGv.NonEmptyArray).fromReadonlyArray, (0, $9ddGv.Maybe).map((0, $9ddGv.List).groupBy((c)=>(0, $kj6DU.pipe)((0, $3Em0q.ChampionLevel).fromNumber(c.championLevel), (0, $3Em0q.ChampionLevel).stringify))), (0, $9ddGv.Maybe).getOrElse(()=>({})));
    return {
        enrichedSummoner: {
            questPercents: (0, $kj6DU.pipe)(enrichedMasteries_, (0, $9ddGv.List).map((c)=>c.percents), (0, $dglOy.NumberUtils).average),
            totalMasteryLevel: (0, $kj6DU.pipe)(enrichedMasteries_, (0, $9ddGv.List).map((c)=>c.championLevel), (0, $gpfu2).concatAll((0, $cF6yJ).MonoidSum)),
            totalMasteryPoints: totalMasteryPoints,
            otpIndex: (0, $7c2fab9890607f52$export$6d7a29d4960e3d83).otpRatio(enrichedMasteries_, totalMasteryPoints),
            masteriesCount: (0, $kj6DU.pipe)((0, $3Em0q.ChampionLevel).values, (0, $9ddGv.List).reduce((0, $9ddGv.Dict).empty(), (acc, championLevel)=>{
                const lvl = (0, $3Em0q.ChampionLevel).stringify(championLevel);
                const value = grouped[lvl]?.length ?? 0;
                return {
                    ...acc,
                    [lvl]: value
                };
            }))
        },
        enrichedMasteries: enrichedMasteries_
    };
};



var $iz2wS = parcelRequire("iz2wS");

var $eFmB1 = parcelRequire("eFmB1");

const $358211fa17534202$var$AdminRouterComponent = /*#__PURE__*/ (0, $exYeM.lazy)(()=>(parcelRequire("hn8KH")));
const $358211fa17534202$export$326dfe05f118f497 = (0, $eFmB1.getRouterComponent)((0, $idTJH.zero)().alt((0, $iz2wS.appParsers).index.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $4d43a77e6747d7f7$export$b94310965bed44e6), {})))).alt($358211fa17534202$var$withPlatformLower((0, $iz2wS.appMatches).sPlatformPuuid, ({ platform: platform, puuid: puuid })=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f8bfad20417c4ba9$export$689d97825c9414dc), {
        platform: platform,
        puuid: puuid
    })))).alt($358211fa17534202$var$withPlatformLower((0, $iz2wS.appMatches).sPlatformPuuidGame, ({ platform: platform, puuid: puuid })=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f8bfad20417c4ba9$export$af8896da5ab9f805), {
        platform: platform,
        puuid: puuid
    })))).alt($358211fa17534202$var$withPlatformLower((0, $iz2wS.appMatches).platformRiotId, ({ platform: platform, riotId: riotId })=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $63c28e058f0e5ff0$export$f5c7402fca0d82db), {
        platform: platform,
        riotId: riotId
    }), ()=>(0, $appXD.RiotId).stringify(riotId)))).alt($358211fa17534202$var$withPlatformLower((0, $iz2wS.appMatches).platformRiotIdGame, ({ platform: platform, riotId: riotId })=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $c1c84d7e477757d6$export$85034e8d4bf2420), {
        platform: platform,
        riotId: riotId
    }), (t)=>`${(0, $appXD.RiotId).stringify(riotId)} \u{2014} ${t.game}`))).alt((0, $iz2wS.appParsers).aram.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2676db7586563391$export$97895786af974272), {}), (t)=>t.aram))).alt((0, $iz2wS.appParsers).urf.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $bc596a9ae38c2493$export$8f34c1ae61107b83), {}), (t)=>t.urf))).alt((0, $iz2wS.appParsers).factions.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $974a65b4ee53a896$export$c454e4c3445e22b1), {}), (t)=>t.factions))).alt((0, $iz2wS.appParsers).timers.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $57b1d54e96073335$export$8bb2c1fb2b1765a9), {}), (t)=>t.timers))).alt((0, $iz2wS.appParsers).login.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $767ba6d83a3bcbb3$export$21a94553ffa41578), {}), (t)=>t.login))).alt((0, $iz2wS.appParsers).register.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2b9576acf8cbab7f$export$157c131647dc68e), {}), (t)=>t.register))).alt((0, $iz2wS.appParsers).discordRedirect.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $cf7fc2f3f1aabf0f$export$288f4777bbf2f735), {})))).alt((0, $iz2wS.appParsers).anyAdmin.map(()=>(0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $a661241677b7896c$export$ac1a3f0c836eba03), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($358211fa17534202$var$AdminRouterComponent, {})
    })))));
// Redirect if upper case
function $358211fa17534202$var$withPlatformLower(match, f) {
    return match.parser.map((a)=>{
        const upperCase = (0, $hrnY6.StringUtils).toUpperCase(a.platform);
        const isUppercase = upperCase === a.platform;
        return isUppercase ? (0, $eFmB1.e)(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $5N26n.Navigate), {
            to: (0, $9fMqj.format)(match.formatter, {
                ...a,
                platform: a.platform.toLowerCase()
            }),
            replace: true
        })) : f({
            ...a,
            platform: upperCase
        });
    });
}



const $7ae2a9ebf78f2c1f$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $hZroh.TranslationContextProvider), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bN7FL.ToasterContextProvider), {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2Yib7.HistoryContextProvider), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dCazK.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $fcoXO.StaticDataContextProvider), {
                        children: [
                            (0, $a85e2b07dac54e12$export$641527e078380b15),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $358211fa17534202$export$326dfe05f118f497), {})
                        ]
                    })
                })
            })
        })
    });


const $b68919c8a0c03dc3$var$rootEltId = 'root';
const $b68919c8a0c03dc3$var$rootElt = document.getElementById($b68919c8a0c03dc3$var$rootEltId);
if ($b68919c8a0c03dc3$var$rootElt === null) // eslint-disable-next-line functional/no-throw-statements
throw Error(`root element not found: #${$b68919c8a0c03dc3$var$rootEltId}`);
const $b68919c8a0c03dc3$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($b68919c8a0c03dc3$var$rootElt);
// eslint-disable-next-line functional/no-expression-statements
$b68919c8a0c03dc3$var$root.render(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $7ae2a9ebf78f2c1f$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.132483b3.js.map
